webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(8);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 1 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.12
 * (c) 2014-2020 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.12';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anything as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4), __webpack_require__(18).setImmediate))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(28),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(27),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(0);
var normalizeHeaderName = __webpack_require__(35);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(12);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(12);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);
var settle = __webpack_require__(36);
var buildURL = __webpack_require__(9);
var buildFullPath = __webpack_require__(38);
var parseHeaders = __webpack_require__(41);
var isURLSameOrigin = __webpack_require__(42);
var createError = __webpack_require__(13);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(43);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(37);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_touch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_resource__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_analytics__);
/*jshint esversion: 6 */
/* The Vue build version to load with the `import` command
(runtime-only or standalone) has been set in webpack.base.conf with an alias. */

var path = __webpack_require__(17);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a.config.swipe = {
  direction: 'horizontal',
  threshold: 10,
  velocity: 0.3,
  pointers: 1
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a, { name: 'v-touch' });

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_analytics___default.a, {
  id: ['UA-137347938-1', 'UA-64435914-1'],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  autoTracking: {
    pageviewTemplate: function pageviewTemplate(route) {
      return {
        page: path.join(window.location.pathname, route.path),
        title: document.title,
        location: window.location.href
      };
    }
  },
  debug: {
    enabled: false
  }
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  data: {},
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
}).$mount('#app');

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(19);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(2)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(21)
  __webpack_require__(22)
  __webpack_require__(23)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(46),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    pageNum: {
      type: Number,
      default: 0
    },
    ttlPages: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      pageNumber: this.pageNum,
      totalPages: this.ttlPages,
      info: false,
      buyBar: true,
      buyMenu: false,
      socialMenu: false,
      otherBooks: false,
      focused: false,
      dialogBuy: false,
      dialogShare: false,
      notifications: false,
      sound: true,
      widgets: false,
      show: false,
      iSize: 50,
      selectBook: "Books",
      home: this.$route.path,
      drawer: false,
      drawerRight: false,
      items: [],
      books: [],
      booksChanged: '',
      socials: [{
        title: "LinkedIn",
        img: "static/img/linkedin-logo.svg",
        url: "https://www.linkedin.com/shareArticle?mini=true&url=https://textcafe.co/books/EV0WRT/%3F1704425409997&title=Die%20polnischen%20Bauern%20I%20-%20Herbst%2C%20Classics%20To%20Go&summary=Wladyslaw%20Stanislaw%20Reymont%20war%20ein%20polnischer%20Schriftsteller%2C%20der%20am%207.%20Mai%201867%20in%20Kobiele%20Wielkie%2C%20Polen%2C%20geboren%20wurde%20und%20am%205.%20Dezember%201925%20in%20Warschau%20verstarb.%20Er%20gilt%20als%20einer%20der%20bedeutendsten%20Vertreter%20der%20polnischen%20Literatur%20des%2020.%20Jahrhun&source=LinkedIn",
        icon: "ion-social-linkedin"
      }, {
        title: "Facebook",
        img: "static/img/facebook-logo.svg",
        url: "https://www.facebook.com/sharer/sharer.php?u=https://textcafe.co/books/EV0WRT/%3F1704425409997",
        icon: "ion-social-facebook"
      }, {
        title: "Twitter",
        img: "static/img/twitter-logo-silhouette.svg",
        url: "https://twitter.com/intent/tweet?text=Wladyslaw%20Stanislaw%20Reymont%20war%20ein%20polnischer%20Schriftsteller%2C%20der%20am%207.%20Mai%201867%20in%20Kobiele%20Wielkie%2C%20Polen%2C%20geboren%20wurde%20und%20am%205.%20Dezember%2019%0Dhttps://textcafe.co/books/EV0WRT/%3F1704425409997&amp;via=textcafecom",
        icon: "ion-social-twitter"
      }, {
        title: "Tumblr",
        img: "static/img/tumblr-letter-logo.svg",
        url: "https://www.tumblr.com/widgets/share/tool?canonicalUrl=https://textcafe.co/books/EV0WRT/%3F1704425409997&posttype=link&caption=Wladyslaw%20Stanislaw%20Reymont%20war%20ein%20polnischer%20Schriftsteller%2C%20der%20am%207.%20Mai%201867%20in%20Kobiele%20Wielkie%2C%20Polen%2C%20geboren%20wurde%20und%20am%205.%20Dezember%201925%20in%20Warschau%20verstarb.%20Er%20gilt%20als%20einer%20der%20bedeutendsten%20Vertreter%20der%20polnischen%20Literatur%20des%2020.%20Jahrhun",
        icon: "ion-social-tumblr"
      }, {
        title: "Pinterest",
        img: "static/img/pinterest-logo.svg",
        url: "http://www.pinterest.com/pin/create/button/?url=https://textcafe.co/books/EV0WRT/%3F1704425409997&description=Wladyslaw%20Stanislaw%20Reymont%20war%20ein%20polnischer%20Schriftsteller%2C%20der%20am%207.%20Mai%201867%20in%20Kobiele%20Wielkie%2C%20Polen%2C%20geboren%20wurde%20und%20am%205.%20Dezember%201925%20in%20Warschau%20verstarb.%20Er%20gilt%20als%20einer%20der%20bedeutendsten%20Vertreter%20der%20polnischen%20Literatur%20des%2020.%20Jahrhun&media=https://textcafe.co/books/EV0WRT/tc-custom/9783988264619.jpg",
        icon: "ion-social-pinterest"
      }],
      buys: [{
        title: 'Amazon US',
        img: 'https://textcafe.co/domain-icons/Amazon.com_A_Smile.svg',
        url: 'https://www.amazon.com/s?k=9783988264619&i=stripbooks&linkCode=qs&tag=mobilebookcom-20',
        alt: 'None'
      }],
      right: null,
      left: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('https://www.textcafe.com/widget/get-samples.json?related=9783988264619').then(function (response) {
      return _this.books = response.data.map(function (item) {
        return {
          title: item.title,
          img: item.coverImagePath,
          url: item.socialUrl,
          alt: "This image is the cover for the book " + item.title
        };
      });
    }).catch(function (error) {
      return (
        // handle error
        console.log(error)
      );
    });
  },

  created: function created() {
    var _this2 = this;

    this.$router.options.routes.forEach(function (route) {
      _this2.items.push({
        path: route.path,
        name: route.name,
        component: route.component,
        //image: "static/img/ilG6Mf.jpg"
        image: '/books/EV0WRT/tc-custom/9783988264619.jpg?1704425409997',
        alt: 'Die polnischen Bauern I - Herbst, Classics To Go'
      });
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("pageNum", function (newValue) {
      _this2.pageNum = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("ttlPages", function (newValue) {
      _this2.ttlPages = newValue;
    });
  },
  watch: {
    $route: function $route(to, from) {
      if (to.path === "/") {
        this.home = this.$route.path;
      } else {
        this.home = null;
      }
    },

    iSize: function iSize(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("iSizeChanged", newValue);
    },
    books: function books(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("booksChanged", Date.now());
    }
  },
  methods: {
    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    },
    onBlur: function onBlur() {
      if (this.show === true) {
        this.show = false;
        this.$emit("blur");
      }
    },
    onFocus: function onFocus() {
      if (this.show === false) {
        this.show = true;
        this.$el.querySelector(".book-page").$emit("focus");
      }
    },
    buyClick: function buyClick(url) {
      //const url = '/foo/bar'
      // this.$ga.query('send', 'event', 'outbound', 'click', url, {
      //     transport: 'beacon',
      //     hitCallback () {
      //        //document.location = url
      //     }
      // })
      this.$ga.event({
        eventCategory: 'purchase',
        eventAction: 'click',
        eventLabel: url
        // eventValue: 123
      });
    },
    shareClick: function shareClick(network) {
      this.$ga.event({
        eventCategory: 'share',
        eventAction: 'click',
        eventLabel: network
        // eventValue: 123
      });
    }
  },
  components: {
    settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default.a,
    reader: __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default.a
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var SLIDE_TIME = document.documentElement.clientWidth > 480 ? 500 : 300;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "reader",
  props: {
    value1: {
      type: Number,
      default: 22
    },
    selected: {
      type: String
    },
    ex8: {
      type: String,
      default: "Auto"
    },
    value2: {
      type: Number
    },
    value3: {
      type: Number,
      default: 100
    }
  },
  data: function data() {
    return {
      pageNum: 0,
      pageNumber: 1,
      ttlPages: 0,
      totalPages: 0,
      home: false,
      div: 0,
      prevX: null,
      xDownEnd: null,
      fontSize: this.value1,
      fontFamily: this.selected,
      columns: this.ex8,
      widthSize: this.value2,
      brightness: this.value3,
      currentColor: "#f3f3f3",
      cols: "2 220px",
      position: { scrollTop: 0, scrollLeft: 0 },
      offset: null,
      height: 0,
      isOver: false,
      routeNames: ["home", "Text/titlepage", "Text/Section0001", "Text/Section0002", "Text/Section0003", "last"],
      routeTransition: "slide-left",
      rest: true,
      selectedView: "Book1",
      progress: 0,
      hiddenEl: false,
      brandReaderUrl: "",
      brandLogoUrl: "",
      currentUrl: "https://textcafe.co/books/EV0WRT/",
      waiting: false
    };
  },

  created: function created() {
    var _this = this;

    document.addEventListener("mousewheel", this.onScroll, false);
    window.addEventListener('resize', this.resize);
    this.resize();
    this.getTtlPages();

    if (document.documentElement.offsetWidth >= 768) {
      this.hiddenEl = true;
    } else {
      this.hiddenEl = false;
    }

    this.$router.options.routes.forEach(function (route) {
      _this.routeNames.push(route.name);
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontSizeChanged", function (newValue) {
      _this.fontSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontFamilyChanged", function (newValue) {
      _this.fontFamily = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("columnsCountChanged", function (newValue) {
      _this.columns = newValue;
      if (_this.columns === "Single") {
        _this.cols = "1 auto";
      } else if (_this.columns === "Auto") {
        _this.cols = "2 220px";
      }
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("widthChanged", function (newValue) {
      _this.widthSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("brightnessChanged", function (newValue) {
      _this.brightness = newValue;
    });
  },

  destroyed: function destroyed() {
    document.removeEventListener("mousewheel", this.onScroll, false);
    document.removeEventListener("resize", this.resize, false);
  },
  updated: function updated() {
    this.getTtlPages();
    this.resize();
    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };
  },
  mounted: function mounted() {
    this.resize();

    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };

    this.getTtlPages();

    var bgColor = document.getElementsByClassName("book-content")[0].style.backgroundColor,
        hexDigits = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f");
    function rgb2hex(rgb) {
      rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
      return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
    }
    function hex(x) {
      return isNaN(x) ? "00" : hexDigits[(x - x % 16) / 16] + hexDigits[x % 16];
    }
    this.currentColor = rgb2hex(bgColor);
  },

  watch: {
    $route: function $route(to, from, next) {
      var toDepth = this.routeNames.indexOf(to.name);
      var fromDepth = this.routeNames.indexOf(from.name);
      this.routeTransition = toDepth < fromDepth ? "slide-right" : "slide-left";

      this.progress = 0;
      this.pageNumber = 1;
    },

    pageNum: function pageNum(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("pageNum", newValue);
    },
    ttlPages: function ttlPages(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("ttlPages", newValue);
    }
  },
  methods: {
    resize: function resize() {
      this.height = document.documentElement.clientHeight;
    },
    linkTo: function linkTo(refName) {
      var element = document.getElementById(refName);
      var elementOffset = Math.ceil(element.offsetLeft);
      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);
      var onStart = Math.ceil(page.scrollLeft);
      var destinationOffset = Math.floor(elementOffset / (page.offsetWidth + gap));
      var target = destinationOffset * (page.offsetWidth + gap) - onStart;
      if (destinationOffset + 1 !== this.pageNumber) {
        this.scrollIt(target, 300, "easeOutQuad", false);
        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pctScrolled = Math.floor(destinationOffset * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
        this.pageNumber = destinationOffset + 1;
      }
    },
    getTtlPages: function getTtlPages() {
      this.$nextTick(function () {
        var page = this.$el.querySelector(".book-page");

        var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));
        this.ttlPages = ttlPages;
        this.totalPages = this.ttlPages + 1;
      });
    },
    tapped: function tapped() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    tappedIn: function tappedIn() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    scrollIt: function scrollIt(destination) {
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;

      var _this2 = this;

      var easing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "easeInOutQuart";
      var callback = arguments[3];

      var easings = {
        linear: function linear(t) {
          return t;
        },
        easeInQuad: function easeInQuad(t) {
          return t * t;
        },
        easeOutQuad: function easeOutQuad(t) {
          return t * (2 - t);
        },
        easeInOutQuad: function easeInOutQuad(t) {
          return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        },
        easeInCubic: function easeInCubic(t) {
          return t * t * t;
        },
        easeOutCubic: function easeOutCubic(t) {
          return --t * t * t + 1;
        },
        easeInOutCubic: function easeInOutCubic(t) {
          return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
        },
        easeInQuart: function easeInQuart(t) {
          return t * t * t * t;
        },
        easeOutQuart: function easeOutQuart(t) {
          return 1 - --t * t * t * t;
        },
        easeInOutQuart: function easeInOutQuart(t) {
          return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
        },
        easeInQuint: function easeInQuint(t) {
          return t * t * t * t * t;
        },
        easeOutQuint: function easeOutQuint(t) {
          return 1 + --t * t * t * t * t;
        },
        easeInOutQuint: function easeInOutQuint(t) {
          return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
        }
      };

      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap;

      var start = Math.ceil(page.scrollLeft);

      var startTime = "now" in window.performance ? performance.now() : new Date().getTime();

      var documentWidth = Math.max(page.scrollWidth || page.offsetWidth || page.clientWidth);

      var windowWidth = window.innerWidth || window.clientWidth;

      var destinationOffsetToScroll = start + destination;

      function scroll() {
        var now = "now" in window.performance ? performance.now() : new Date().getTime();
        var time = Math.min(1, (now - startTime) / duration);
        var timeFunction = easings[easing](time);
        page.scroll(Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start), 0);
        if (timeFunction === 1 || start === destinationOffsetToScroll) {
          if (callback) {
            callback();
          }
          return;
        }
        requestAnimationFrame(scroll);
      }
      scroll();
      setTimeout(function () {
        _this2.waiting = false;
      }, 250);
    },


    next: function next(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";
      var book = this.$el.querySelector(".book-content");
      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;
      var windowWidth = window.innerWidth || window.clientWidth;
      var trackLength = scrollArea - (page.offsetWidth + gap);

      // var pageNum = Math.floor(page.scrollLeft / (page.offsetWidth + gap));
      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.floor(scrollLeft / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      pageNum += 1;

      this.pageNumber += 1;

      if (page.scrollWidth - (scrollLeft + page.offsetWidth) !== 0 && pctScrolled !== 100) {
        var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = nextPage - scrollLeft;

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index + 1] });

        this.pageNumber = 1;
        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    prev: function prev(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";

      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;

      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
      var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      this.pageNumber -= 1;

      var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

      if (scrollLeft !== 0 && pageNum !== 0) {
        var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
        var pageNumber = Math.floor(scrollLeft / (page.offsetWidth + gap));

        pageNum -= 1;
        var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = -1 * (scrollLeft - prevPage);

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index - 1] });

        this.pageNumber = 1;

        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    over: function over() {
      this.isOver = true;
    },
    out: function out() {
      this.isOver = false;
    },
    onScroll: function onScroll(e, position) {
      this.position = position;
      if (this.isOver === true) {
        var page = this.$el.querySelector(".book-page"),
            gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
            deltaX = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail)),
            end = page.scrollWidth - (page.scrollLeft + page.offsetWidth),
            offset = page.offsetWidth + gap;

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pageNum = Math.round(page.scrollLeft / (page.offsetWidth + gap));

        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;

        if (deltaX === 1) {
          if (page.scrollLeft !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum -= 1;

            this.pageNumber -= 1;
            var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = -1 * (page.scrollLeft - prevPage);

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        } else if (deltaX === -1) {
          if (page.scrollWidth - (page.scrollLeft + page.offsetWidth) !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum += 1;

            this.pageNumber += 1;
            var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = nextPage - page.scrollLeft;

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        }
      } else {
        return;
      }
    },
    fadeIn: function fadeIn() {
      var page = this.$el.querySelector(".book-page");
      page.style.opacity = 0;
      var last = +new Date();
      var tick = function tick() {
        page.style.opacity = +page.style.opacity + (new Date() - last) / 400;
        last = +new Date();
        if (+page.style.opacity < 1) {
          window.requestAnimationFrame && requestAnimationFrame(tick) || setTimeout(tick, 16);
        }
      };
      tick();
    },

    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    }
  },
  computed: {
    isMobile: function isMobile() {
      var check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  },
  components: {
    Settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings___default.a
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "settings",
  data: function data() {
    return {
      events: [],
      value1: 22,
      value2: 70,
      value3: 100,
      ex8: "Auto",
      selected: "Old-Cabin",
      fonts: ["Old-Cabin", "Raleway-Bitter", "Ubuntu-Abel", "Droid-Abril", "Garamond-Clicker", "Alice-Playfair", "Judson-Quando"],
      classes: ["white", "black", "sepia"]
    };
  },

  watch: {
    value1: function value1(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontSizeChanged", newValue);
    },
    selected: function selected(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontFamilyChanged", newValue);
    },
    ex8: function ex8(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("columnsCountChanged", newValue);
    },
    value2: function value2(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("widthChanged", newValue);
    },
    value3: function value3(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("brightnessChanged", newValue);
    }
  },
  methods: {
    reloadBook: function reloadBook() {
      window.location.reload(true);
    },
    changeClassWhite: function changeClassWhite() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      console.log(document.getElementsByTagName("footer")[0]);
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("white");
        el2.classList.add("white");
        el3.classList.add("white");
        el4.classList.add("white");
      } else {
        el.className += " white";
        el2.className += " white";
        el3.className += " white";
        el4.className += " white";
      }
    },
    changeClassBlack: function changeClassBlack() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("black");
        el2.classList.add("black");
        el3.classList.add("black");
        el4.classList.add("black");
      } else {
        el.className += " black";
        el2.className += " black";
        el3.className += " black";
        el4.className += " black";
      }
    },
    changeClassSepia: function changeClassSepia() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.add("sepia");
        el2.classList.add("sepia");
        el3.classList.add("sepia");
        el4.classList.add("sepia");
      } else {
        el.className += " sepia";
        el2.className += " sepia";
        el3.className += " sepia";
        el4.className += " sepia";
      }
    }
  }
});

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_c('ul', {
    staticClass: "settings-list"
  }, [_c('li', [_c('span', [_vm._v("Reload book: ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "reloadBookBtn",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reloadBook()
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-loop-strong")])], 1)], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.fonts,
      "overflow": "",
      "single-line": "",
      "return-objectauto": "",
      "append-icon": "ion-ios-arrow-down",
      "hide-details": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = true
      }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font size:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value1 + 'px' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 17,
      "max": 27,
      "step": 1
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "columns-setting"
  }, [_c('span', [_vm._v("Page columns:")]), _c('br'), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Auto",
      "value": "Auto",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Single",
      "value": "Single",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "width-setting"
  }, [_c('span', [_vm._v("Page width:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value2 + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 50,
      "max": 90
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Brightness:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s((_vm.value3 - 100) + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "step": 1,
      "min": 0,
      "max": 200
    },
    model: {
      value: (_vm.value3),
      callback: function($$v) {
        _vm.value3 = $$v
      },
      expression: "value3"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Color mode:")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "colors"
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "id": "white",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassWhite()
      }
    }
  }, [_vm._v("\n          White\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "black",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassBlack()
      }
    }
  }, [_vm._v("\n          Black\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "sepia",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassSepia()
      }
    }
  }, [_vm._v("\n          Sepia\n        ")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap",
    style: ({
      'filter': 'brightness(' + _vm.brightness + '%)',
      'height': _vm.height - 49 + 'px'
    })
  }, [_c('v-progress-linear', {
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  }), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowleft']),
      expression: "['arrowleft']"
    }],
    staticClass: "nav-btn left",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.prev($event)
      },
      "shortkey": _vm.prev
    }
  }, [_c('v-icon', {
    style: ({
      'left': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowright']),
      expression: "['arrowright']"
    }],
    staticClass: "nav-btn right",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.next($event)
      },
      "shortkey": _vm.next
    }
  }, [_c('v-icon', {
    style: ({
      'right': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "book-content",
    style: ({
      'width': _vm.widthSize + '%',
      'background-color': _vm.currentColor,
      'height': _vm.height - 78 + 'px'
    }),
    on: {
      "mouseenter": _vm.over,
      "mouseleave": _vm.out
    }
  }, [(_vm.isMobile) ? _c('v-touch', {
    staticClass: "touch-swipe",
    class: {
      active: _vm.hiddenEl
    },
    on: {
      "swipeleft": _vm.next,
      "swiperight": _vm.prev,
      "tap": _vm.tapped
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    key: _vm.div,
    staticClass: "book-page",
    class: _vm.fontFamily,
    style: ({
      'font-size': _vm.fontSize + 'px',
      'columns': _vm.cols
    }),
    attrs: {
      "enable-resize-watcher": ""
    },
    on: {
      "tap": _vm.tappedIn,
      "swipe": _vm.tappedIn,
      "click": _vm.tappedIn
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.routeTransition,
      "mode": "out-in"
    }
  }, [_c('router-view', {
    key: _vm.$route.name,
    staticClass: "view"
  })], 1)], 1)], 1), _vm._v(" "), _c('footer', {
    class: _vm.fontFamily,
    style: ({
      'font-size': (_vm.fontSize - 5) + 'px'
    })
  }, [(_vm.brandReaderUrl) ? _c('div', [_c('v-btn', {
    staticClass: "HC-footer-button",
    attrs: {
      "flat": "",
      "ripple": false,
      "tag": "a",
      "href": _vm.brandReaderUrl,
      "target": "_blank"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = false, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('i', [_c('img', {
    attrs: {
      "src": _vm.brandLogoUrl
    }
  })])])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "foots"
  }, [_c('span', [_c('em', [_vm._v(_vm._s(this.$route.name))])]), _vm._v(" - page "), _c('span', [_c('em', [_vm._v(_vm._s(this.pageNumber))])]), _vm._v(" "), (this.totalPages > 1) ? _c('span', [_c('em', [_vm._v(_vm._s("/ " + this.totalPages))])]) : _vm._e()]), _vm._v(" "), _c('v-spacer')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(30);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);
var bind = __webpack_require__(8);
var Axios = __webpack_require__(31);
var mergeConfig = __webpack_require__(14);
var defaults = __webpack_require__(11);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(15);
axios.CancelToken = __webpack_require__(44);
axios.isCancel = __webpack_require__(10);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(45);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);
var buildURL = __webpack_require__(9);
var InterceptorManager = __webpack_require__(32);
var dispatchRequest = __webpack_require__(33);
var mergeConfig = __webpack_require__(14);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);
var transformData = __webpack_require__(34);
var isCancel = __webpack_require__(10);
var defaults = __webpack_require__(11);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(13);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(39);
var combineURLs = __webpack_require__(40);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(15);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "toolbar": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info
      }
    },
    model: {
      value: (_vm.info),
      callback: function($$v) {
        _vm.info = $$v
      },
      expression: "info"
    }
  }, [_c('v-card', {
    staticClass: "infoDialog"
  }, [_c('div', {
    staticClass: "menuIns"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-navicon")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-browsers-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Contents")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Navigate to book chapters")])]), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip2"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Related Books")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Other books you might like")])]), _vm._v(" "), _c('div', {
    staticClass: "socMenu"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-linkedin")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-facebook")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-twitter")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-tumblr")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-pinterest")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuMob"
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Share Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Share book to your social network")])]), _vm._v(" "), _c('div', {
    staticClass: "resize-settings"
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "resize-settings-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Settings button")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Change colors and fonts")])]), _vm._v(" "), _c('div', {
    staticClass: "left-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('div', {
    staticClass: "left-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Left/Previous")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to previous page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe right.")])]), _vm._v(" "), _c('div', {
    staticClass: "right-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "right-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Right/Next")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to next page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe left.")])]), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-mob"
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Buy Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Click to stores where you can buy this book")])]), _vm._v(" "), _c('div', {
    staticClass: "headline"
  }, [_vm._v("Instructions")]), _vm._v(" "), _c('v-btn', {
    staticClass: "closeDialog",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "menu",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.name,
      attrs: {
        "href": item.path,
        "to": item.path,
        "exact": "",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "height": "55px",
        "alt": item.alt,
        "src": item.image
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(item.name))])], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "otherBooks",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks
      }
    },
    model: {
      value: (_vm.otherBooks),
      callback: function($$v) {
        _vm.otherBooks = $$v
      },
      expression: "otherBooks"
    }
  }, [_c('v-list', [_c('h6', [_vm._v("Other books you might like:")]), _vm._v(" "), _vm._l((_vm.books), function(book) {
    return _c('v-list-tile', {
      key: book.title,
      attrs: {
        "href": book.url,
        "target": "_blank",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": book.alt,
        "src": book.img
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(book.title))])], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "settings-drawer",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "right": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.drawerRight),
      callback: function($$v) {
        _vm.drawerRight = $$v
      },
      expression: "drawerRight"
    }
  }, [_c('v-list', [_c('settings')], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "mini-bar",
    attrs: {
      "mini-variant": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.buyBar),
      callback: function($$v) {
        _vm.buyBar = $$v
      },
      expression: "buyBar"
    }
  }, [_c('v-list', {
    attrs: {
      "ripple": false
    }
  }, [_vm._v("Shop:\n      "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })])
  })], 2)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "main-menu",
    attrs: {
      "fixed": "",
      "persistent": ""
    }
  }, [_c('v-btn', {
    staticClass: "main-menu-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-navicon")])], 1), _vm._v(" "), (_vm.books.length > 0) ? _c('v-btn', {
    key: _vm.booksChanged,
    staticClass: "otherBooks-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.drawer = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-browsers-outline")])], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "desktop-social-btn",
    staticStyle: {
      "margin-left": "5%"
    }
  }, _vm._l((_vm.socials), function(social) {
    return _c('v-btn', {
      key: social.title,
      attrs: {
        "flat": "",
        "href": social.url,
        "target": "_blank",
        "ripple": false
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1)
  }), 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-buy-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu, _vm.info = false, _vm.drawer = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "buy-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu
      }
    },
    model: {
      value: (_vm.buyMenu),
      callback: function($$v) {
        _vm.buyMenu = $$v
      },
      expression: "buyMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Purchase this book: ")]), _vm._v(" "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })]), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(buy.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-social-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu, _vm.info = false, _vm.buyMenu = false, _vm.drawer = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "social-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "persistent": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu
      }
    },
    model: {
      value: (_vm.socialMenu),
      callback: function($$v) {
        _vm.socialMenu = $$v
      },
      expression: "socialMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Share this book: ")]), _vm._v(" "), _vm._l((_vm.socials), function(social) {
    return _c('v-list-tile', {
      key: social.title,
      attrs: {
        "href": social.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(social.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "info-btn",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info, _vm.drawer = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-information-outline")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "settings-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = !_vm.drawerRight, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawer = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('reader')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Reader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Text_titlepage__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Text_titlepage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Text_titlepage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Text_Section0001__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Text_Section0001___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Text_Section0001__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Text_Section0002__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Text_Section0002___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Text_Section0002__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Text_Section0003__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Text_Section0003___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Text_Section0003__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_last__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_last__);
/*jshint esversion: 6 */











__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    "path": "/",
    "name": "home",
    "component": __WEBPACK_IMPORTED_MODULE_3__components_home___default.a
  }, {
    "path": "/Text/titlepage",
    "name": "Text/titlepage",
    "component": __WEBPACK_IMPORTED_MODULE_4__components_Text_titlepage___default.a
  }, {
    "path": "/Text/Section0001",
    "name": "Text/Section0001",
    "component": __WEBPACK_IMPORTED_MODULE_5__components_Text_Section0001___default.a
  }, {
    "path": "/Text/Section0002",
    "name": "Text/Section0002",
    "component": __WEBPACK_IMPORTED_MODULE_6__components_Text_Section0002___default.a
  }, {
    "path": "/Text/Section0003",
    "name": "Text/Section0003",
    "component": __WEBPACK_IMPORTED_MODULE_7__components_Text_Section0003___default.a
  }, {
    "path": "/last",
    "name": "last",
    "component": __WEBPACK_IMPORTED_MODULE_8__components_last___default.a
  }]
}));

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v2.8.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '2.8.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(51),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Navigation from '@/components/Navigation'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {};
  },

  components: {
    // 'navigation': Navigation
  }
});

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/EV0WRT/tc-custom/9783988264619.jpg?1704425409997",
      "alt": "This image is the cover for the book Die polnischen Bauern I - Herbst, Classics To Go"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Die polnischen Bauern I - Herbst, Classics To Go\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Wladyslaw Stanislaw Reymont war ein polnischer Schriftsteller, der am 7. Mai 1867 in Kobiele Wielkie, Polen, geboren wurde und am 5. Dezember 1925 in Warschau verstarb. Er gilt als einer der bedeutendsten Vertreter der polnischen Literatur des 20. Jahrhunderts. Reymonts bekanntestes Werk ist der Roman \"Die Bauern\" (im Original \"Chłopi\"), der in den Jahren 1904-1909 veröffentlicht wurde und ihm 1924 den Nobelpreis für Literatur einbrachte. Der Roman beschreibt das Leben der Bauern in einer polnischen Dorfgemeinschaft und schildert ihre harte Arbeit, ihre Traditionen und ihren Kampf ums Überleben. \"Die Bauern\" ist in vier Teile unterteilt, die jeweils verschiedene Jahreszeiten repräsentieren. Der erste Teil, \"Frühling\", beschreibt die Zeit des Erwachens und des Wachstums. Die Bauern bereiten die Felder vor und säen ihre Saat. Der zweite Teil, \"Sommer\", zeigt das volle Leben auf dem Land, mit der Arbeit auf den Feldern und den Feierlichkeiten des Dorfes. Der dritte Teil, \"Herbst\", stellt den Rückgang und das Altern dar, während die Bauern ihre Ernte einfahren und sich auf den Winter vorbereiten. Der letzte Teil, \"Winter\", zeigt die harten Bedingungen des Winters und die Schwierigkeiten, die die Bauern bewältigen müssen. Reymonts Schreibstil zeichnet sich durch seine detaillierte und realistische Darstellung des ländlichen Lebens aus. Er zeigt die Konflikte, die zwischen den Bauern entstehen, aber auch ihre Zusammengehörigkeit und ihre traditionellen Werte. Durch seine detaillierten Beschreibungen der Natur und der Jahreszeiten schafft Reymont eine lebendige und atmosphärische Welt. \"Die Bauern\" ist ein bedeutendes Werk der polnischen Literatur und hat Reymonts Ruf als einer der wichtigsten Schriftsteller Polens gefestigt. Das Buch thematisiert nicht nur das Leben der Bauern, sondern stellt auch soziale und politische Fragen, die zu dieser Zeit in Polen relevant waren. Reymonts Werk bleibt bis heute ein bedeutender Beitrag zur polnischen Literaturgeschichte.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Wladyslaw Stanislaw Reymont\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Władysław Stanisław Reymont war ein polnischer Schriftsteller und Träger des Nobelpreises für Literatur. Er wurde am 7. Mai 1867 in Kobiele Wielkie, Polen, geboren und verstarb am 5. Dezember 1925 in Warschau. Reymont gilt als einer der bedeutendsten polnischen Autoren des 20. Jahrhunderts. Reymont wurde in eine bäuerliche Familie geboren und wuchs in einfachen Verhältnissen auf. Als junger Mann arbeitete er zunächst als Schmied und später als Eisenbahntechniker. Während dieser Zeit entwickelte er seine schriftstellerischen Fähigkeiten und begann Geschichten zu schreiben. Sein literarischer Durchbruch erfolgte im Jahr 1897 mit seinem Roman \"Die Bauern\" (Chłopi), einer epischen Erzählung über das Leben der Bauern in Polen. Der Roman wurde international bekannt und von der Kritik hochgelobt. Er gilt als eines der bedeutendsten Werke der polnischen Literatur und wurde als eindringliche Darstellung des bäuerlichen Lebens und der sozialen Realität in Polen angesehen. Reymont schrieb auch andere Romane, darunter \"Die Köhler\" (Komornicy) aus dem Jahr 1906 und \"Die Räuber\" (Ziemia obiecana) aus dem Jahr 1899. Diese Werke behandeln ähnliche soziale Themen und porträtieren verschiedene Schichten der polnischen Gesellschaft. Im Jahr 1924 wurde Władysław Stanisław Reymont mit dem Nobelpreis für Literatur ausgezeichnet. Die Schwedische Akademie würdigte ihn für seine eindrucksvolle Darstellung des polnischen Volkes und für seine Fähigkeit, das Leben in all seinen Facetten und Nuancen darzustellen. Reymont verstarb am 5. Dezember 1925 in Warschau. Sein literarisches Erbe und seine Bedeutung für die polnische Literatur sind von großer Bedeutung. Seine Werke werden noch heute gelesen und geschätzt und haben einen wichtigen Beitrag zur Entwicklung der polnischen Literatur geleistet.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    OTB ebook\n   ")])])])
}]}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(54),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('img', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "alt": "cover",
      "src": "Images/cover.jpeg"
    }
  })])])])
}]}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(57),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_vm._v("Die polnischen")]), _vm._v(" "), _c('h2', {
    staticClass: "sigil_not_in_toc"
  }, [_vm._v("Bauern I – Herbst")]), _vm._v(" "), _c('h3', {
    staticClass: "sigil_not_in_toc"
  }, [_vm._v("Wladyslaw Stanislaw Reymont")])])])
}]}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(60),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "calibre5"
  }, [_vm._v("Zur Einführung")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Der Bauer fängt heute an, eine immer größere Rolle im\nöffentlichen Leben Polens zu spielen, die im Gegensatz zu der\nverhältnismäßig viel unbedeutenderen, der ländlichen bäuerlichen\nBevölkerung bei den stark industrialisierten westeuropäischen\nVölkern auch noch die Tendenz hat zu einer maßgebenden Macht wie im\npolitischen, so auch im geistigen Leben zu erstarken. Der Bauer ist\ngegenwärtig in Polen nicht nur Mode, er muß auch als eine\naufwachsende neue Möglichkeit, als wieder zum erstenmal nach vielen\nJahrhunderten urbar gewordenes Land betrachtet und eingeschätzt\nwerden. Das gegenwärtige polnische öffentliche Leben, die moderne\npolnische Wissenschaft, Technik, Kunst und Literatur haben eine\nganze Reihe hervorragender Männer aufzuweisen, die unmittelbar aus\ndem Bauernvolke hervorgegangen sind. Es mögen hier beispielsweise\neinige Namen von Bedeutung auf dem Gebiete der polnischen Dichtung\nfolgen, die alle mit dem Bauerntum unmittelbar zusammenhängen; ich\nnenne Jan Kasprowicz, Stanislaw Przybyszewski, Wladislaw Stanislaw\nReymont, den Verfasser des vorliegenden großen Bauernepos, Ladislaw\nOrkan, Josef Jedlicz, A. Gwidz, ohne die Allerjüngsten, noch\nRingenden, zu berücksichtigen, unter denen auch eine Anzahl von\nDichtern zu finden ist, die zugleich schreiben und ihr Bauernland\nbeackern/ eine Verschmelzung zweier verschiedenartiger\nBetätigungen, die uns im Westen Europas als ein geträumtes Idyll\noder eine Schäferpose anmuten könnte, und dennoch keines von beiden\nist. In dieses Kapitel gehören auch die seinerzeit so\nsensationellen Bauernheiraten dreier namhafter polnischer Künstler:\ndes Malers Wladimir Tetmajer und der beiden Dichter Lucian Rydel\nund Stanislaw Wyspianski, die sich, eine uralte polnische Tradition\nauffrischend, Bauerntöchter, barfüßige, frische Mädchen in "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page5",
      "title": "JohannN/lac"
    }
  }), _vm._v(" leuchtenden, samtenen\nBauernmiedern und buntgestreiften Beiderwandröcken zu Frauen\ngenommen haben. Tetmajer und Rydel zogen aufs Land und sind somit\ndurch ihre Heirat in ein besonders intimes Verhältnis zum\nBauernstand getreten, dessen Interessen Tetmajer heute mit anderen\nMännern aus dem Volke im österreichischen Reichstag vertritt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Ein besonderes Denkmal dieser Verbindungen ist das in Polen\nberühmt gewordene Märchendrama »Hochzeit«, das der früh verstorbene\nDichter, Maler, Architekt und Plastiker Stanislaw Wyspianski, eine\npolyphone Renaissancenatur und eines der bedeutendsten und\nstärksten Talente, die das moderne Polen aufzuweisen hat, verfaßte.\nIn dieser rhythmisch und gedanklich bestrickenden szenischen\nDichtung finden wir das ganze seelische Verhältnis des modernen\nPolentums zum Bauernstand mit einer Tiefe und Macht begriffen,\nerfüllt und gestaltet, daß man das Werk als wichtigsten Beitrag zur\nVertiefung dieser Frage bezeichnen kann.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Der Bauer hat natürlich auch viel früher schon eine gewisse\nRolle in der polnischen Literatur gespielt; schon ganz am Anfang\ndes 19. Jahrhunderts finden wir ihn in der allerdings noch recht\nsentimentalen, auf Rousseausche Naturschwärmerei zurückzuführenden\nDichtung Brodzinskis »Wieslaw«, die von den Zeitgenossen mit\nBegeisterung aufgenommen wurde. Die Romantiker bringen neben dem\nVolkslied eine Menge Volksmotive in die Dichtung und knüpfen aufs\nneue das lange zerrissen gewesene Band zwischen hoch und niedrig,\ndoch ist ihre idealisierte Darstellung des Volkes noch weit davon\nentfernt, eine Gestaltung des Lebens zu sein. Um überhaupt die ganz\neigene Stellung des Bauern im polnischen Volksorganismus zu\nbegreifen, wird es unerläßlich sein, einen Blick in historische\nZusammenhänge zu tun.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Geschichte des polnischen Bauerntums bis zum Fall "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page6",
      "title": "JohannN/lac"
    }
  }), _vm._v(" Polens umfaßt 5\nEntwicklungsstufen/eine Einteilung, die auch mehrere\nGeschichtschreiber angenommen haben. Die erste umspannt den\nZeitraum von den frühesten Zeiten bis zur Einführung des\nChristentums und zur Belehnung der katholischen Geistlichkeit mit\nGütern, reicht also ungefähr bis zur Mitte des 10. Jahrhunderts.\nSie ist vor allem dadurch interessant, daß sie besonders wichtige\nAufschlüsse über das Wesen des polnischen Volkes gibt und in enger\nBeziehung zu späteren nationalen Reformen sowie zum politischen\nProgramm des heutigen Bauerntums steht. Die ersten maßgebenden\nSchilderungen der polnischen Dorfgemeinden finden wir bei Herodot,\nJulius Cäsar und einigen polnischen Chronisten. Die Schilderungen,\ndie Julius Cäsar von den Einrichtungen der Sueven macht, lassen\nsich unverändert auf die Slawen übertragen. Er berichtet über eine\nEinteilung des Landes in 100 Kreise, die von Freien und Unfreien\nbewohnt waren. Die ersten waren die eigentlichen Bürger (\n"), _c('span', {
    staticClass: "teletype"
  }, [_vm._v("ingenui")]), _vm._v("), deren einem Teil das\nHandwerk des Krieges außerhalb der Landesgrenzen oblag, während der\nandere seinen Acker bestellte, um im folgenden Jahre die\nheimkehrenden Krieger abzulösen. Der Ackerbau wurde mit Hilfe der\nUnfreien ( "), _c('span', {
    staticClass: "teletype"
  }, [_vm._v("servi")]), _vm._v("), die aus\nKriegsgefangenen vervollständigt wurden, betrieben.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die soziale Einrichtung der betreffenden Gemeinden trägt einen\nausgesprochenen demokratisch-kommunistischen Charakter. Der Boden\nist nicht Besitz von einzelnen, sondern gehört den Gemeinden, die\nsich selbständig regieren und dem Einzelnen das Land zur\nBearbeitung auf eine gewisse Zeit austeilen, um, nachdem die\nErgiebigkeit des Bodens nachgelassen hat, weiterzuziehen. Diese\nEinrichtung, die übrigens in Mitteleuropa eine Zeitlang überall\nbestand, ist ein Gegensatz der in skandinavischen Ländern\nentstandenen aristokratischen Höfe. Während bei den kommunistischen\nGemeinden ein Zuwachs an Mitgliedern eine Steigerung der Macht der\nGemeinde bedeutete, da sie um "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page7",
      "title": "JohannN/lac"
    }
  }), _vm._v(" so mehr herrenloses Land an sich reißen und\nurbar machen konnte, war für den Ackerbau im Norden, dem nicht\nsoviel fruchtbares Land zur Verfügung stand, jeder hinzukommende\nFremdling ein Feind und Schmäler seiner Einkünfte. Man schloß sich\nlieber an den stärkeren Nachbar an, bei dem man Aussicht hatte,\neine kräftige Unterstützung seiner persönlichen Interessen und\nRechte im Falle der Not zu erwarten. Es entstehen hier also von\nvornherein Vasallen- und Freundschaftsbündnisse, die sich\nunmittelbar auf eine persönliche Wertung, also auf ein\nindividualistisch aristokratisches Prinzip gründen. Auf\nausschließlich äußerliche Bedingungen, wie Bodenbeschaffenheit,\nKlima u. dgl., lassen sich diese Gegensätze zwischen Dorfgemeinde\nund Hof jedoch nicht zurückführen. Wie sehr hier das allmächtige\nBlut und die Instinkte der Rasse als gestaltende Mächte eingreifen,\nbeweist die Geschichte zur Genüge. Ich möchte nur zunächst auf die\neigentümliche Erscheinung hinweisen, daß die kommunistische\nDorfgemeinde, die ja übrigens in den ersten Jahrhunderten unserer\nZeitrechnung nicht nur bei den Slawen, sondern in ähnlichem Maße\nbei den Teutonen, Sueven, Sachsen, Dalmatiern u. v. a. zu finden\nist, doch vornehmlich bei den Slawen, und das selbst gewissermaßen\nbis auf den heutigen Tag Geltung behält, während die germanischen\nVölker sehr bald zu einer aristokratischen politischen Einrichtung\ngelangen. Die Grundlage dazu finden wir in der »Lex Salica« mit\nihrem fest umrissenen Erbrecht.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Höfe erscheinen bei den Polen erst nach der Einwanderung der\n»Lechen«, die, wie in der russischen Ebene die herbeigerufenen\n»Russen«, das aristokratische Prinzip in die kommunistische\nslawische Gemeinde hineintragen, ohne sie jedoch von Grund aus\numgestalten zu können. Mit den Lechen, die im 6. Jahrhundert nach\nChristi Geburt in Polen einzudringen begannen/man kann sie mit\nziemlicher Sicherheit als die normannischen Eroberer\nbezeichnen/erscheint "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page8",
      "title": "JohannN/lac"
    }
  }), _vm._v(" auch unter den Polen zum erstenmal der Begriff\ndes Edelmanns /Schlachziz/während bis dahin das Land nur von\nHüfnern ( "), _c('span', {
    staticClass: "teletype"
  }, [_vm._v("Cmetones")]), _vm._v(", wie die Chronik\nsie nennt, den polnischen Namen: Kmieti, Kmeten latinisierend) und\nBauern bewohnt wurde. Die Kmeten waren jene ackerbauenden Krieger (\n"), _c('span', {
    staticClass: "teletype"
  }, [_vm._v("ingenui")]), _vm._v(") und die Bauern jene\n"), _c('span', {
    staticClass: "teletype"
  }, [_vm._v("servi")]), _vm._v(", von denen bei Julius Cäsar die\nRede ist. Auch die ersten vorgeschichtlichen Fürsten, von denen die\nSage dunkel raunt, Krakus, der Gründer von Krakau, und Popiel, der\nFürst von Gnesen, sind Lechen. Wichtig und bezeichnend allerdings\nist, daß zum Gründer der ersten polnischen Königsdynastie kein\nLech, sondern der Kmet Piast wird, von dem der polnische Chronist\nGallus sagt, daß er beim Lechen Popiel, der in Gnesen regierte,\n"), _c('span', {
    staticClass: "teletype"
  }, [_vm._v("»arator«")]), _vm._v(" "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/#foot1",
      "id": "text1"
    }
  }, [_c('sup', {
    staticClass: "calibre6"
  }, [_vm._v("F1")])]), _vm._v(" war und aus bäuerlichem Stande kam.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die polnische Dorfgemeinde wird nun allmählich aus einer\nkommunistischen eine aristokratisch-republikanische. Der neben dem\nDorf bestehende Herrenhof sammelt um sich die Wohnstätten der\nGutsknechte und erlaubt auch für entsprechende Gegenleistungen\nPersonen des Bauernstandes, sich auf seinem Grund und Boden\nanzusiedeln. Allerdings befindet sich nur der Acker in festen\nHänden, während alles Brachland, Triften, Weideplätze und der Wald\ngemeinsamer Besitz bleiben.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Wir werden in der vorliegenden Reymontschen Schilderung des\nheutigen Bauernlebens genau den bis in diese Uranfänge reichenden\nFäden begegnen können, sie bilden eines der wichtigsten Motive im\nsozialen Gemälde des polnischen Dorfes, das er entwirft.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Das Christentum bringt den Slawen die neuen Begriffe einer\nmonarchisch-aristokratischen Rangordnung. Gerade der Gegensatz\ndavon, was Nietzsche als den Aufstand der Herdeninstinkte\nschildert, tritt unter seinem Einfluß in polnischen Ländern ein.\nSoweit hat sich das Christentum schon "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page9",
      "title": "Wunibald/lac"
    }
  }), _vm._v(" unter römischem und germanischem Einfluß\ngewandelt. Man wird, glaube ich, überhaupt erst auf dieser\nGrundlage die treue Anhänglichkeit der Polen für das päpstliche Rom\nbegreifen. Sie ist ein aristokratischer Zug und paßt zu den\npolitischen Anschauungen des immer mehr ausschlaggebenden\nAdelsstandes, der polnischen »Schlachta«. Von Wichtigkeit ist der\nEinfluß der römisch-katholischen Geistlichkeit auf die Lage des\npolnischen Bauernstandes. Wir finden auf den Gütern der höheren\nGeistlichkeit, sowie auf denen des Königs (diese Würde ist ein\nwestlicher, mit dem Christentum bei den Slawen eingeführter\nBegriff) und einzelner höherer Würdenträger freie Landleute und\nUnfreie, die Abgaben zahlen. Wer keinen Grundbesitz hatte, konnte\nLand gegen Abgaben erhalten/eine Sitte, die sich immer mehr\neinzubürgern beginnt, seitdem sich die Kmeten (Hüfner) fast\nausschließlich dem Kriegshandwerk und der Verwaltung der Ämter\nwidmen. Die Abgaben Zahlenden waren entweder nur durch ihre\nfreiwillig zu vereinbarenden Zahlungen, die in Geld oder\nErzeugnissen des Ackerbaus bestanden, dem Besitzer verbunden, oder\nsie waren unfreie Bauern und waren verpflichtet, zu tun, was man\nihnen befahl. Die Abgaben zahlende Landbevölkerung war somit frei\nund hatte das Recht, sich aus ihrem Wohnsitz jederzeit nach\nErfüllung ihrer Verpflichtungen zu entfernen. Daß die Lage dieses\nBevölkerungsteiles in Polen günstig gewesen sein muß, beweist die\nbeginnende starke Einwanderung der Deutschen, deren Einfluß auf das\nWerden des polnischen Staates sich auch anderweitig und vor allem\ndurch kirchliche Angelegenheiten/die polnische Kirche war eine\nZeitlang von dem Erzbistum in Magdeburg abhängig/ bemerkbar macht.\n"), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/#foot2",
      "id": "text2"
    }
  }, [_c('sup', {
    staticClass: "calibre6"
  }, [_vm._v("F2")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Auf diese Weise trägt das Christentum eine neue, auf "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page10",
      "title": "Johnboy2001/divisi"
    }
  }), _vm._v("\nmonarchischem Prinzip gegründete politische Ordnung nach Polen\nhinein, in der die Macht der Geistlichkeit und der Herren zu einem\nwichtigen gesellschaftlichen und volkswirtschaftlichen Faktor wird.\nDaß diese neuen Ordnungen zunächst einen Volksaufstand\nhervorgerufen hatte, beweist, wie fremd sie eigentlich den\nEinrichtungen des Landes waren.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die dritte Epoche ist dadurch wichtig und interessant, daß sie\nzeigt, in welcher Weise das polnische Volk mit den ihm\naufgepfropften fremden politischen Formen fertig geworden ist,\nindem es sie seinem Charakter entsprechend ummodelte. Ich möchte\nhier im voraus schon betonen, daß die heutigen Begriffe und\nReformpläne, der auf die Kraft des Bauerntums bauenden\nallpolnischen politischen Elemente gerade an diese Epoche des\npolitischen Lebens und ihre Ideale anknüpfen. Wie zugänglich der\npolnische Bauer für diese Tradition auch heute noch ist, beweist\nder Reymontsche Roman recht unzweideutig. Besonders die Propaganda\ndes alten Bettlers Rochus ist dafür bezeichnend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die unter dem bedeutendsten Herrscher aus der Piastendynastie\nKasimir dem Großen herausgegebene Gesetzsammlung von Wislica und\ndie späteren Verordnungen der Könige der Jagellonischen Dynastie\ngeben den übernommenen aristokratisch-monarchischen Einrichtungen\neinen immer stärker hervortretenden demokratisch-republikanischen\nZug. Um diese Zeit entstehen neben der ursprünglichen, sich selbst\nregierenden Dorfgemeinde mit gemeinsamen Triften und Wäldern noch\nzwei andre: die aus Adel und Landleuten bestehende Dorfgemeinde mit\npolnischer Gerichtsbarkeit und die aus Adel und Landleuten\nbestehende Gemeinde, in der das Magdeburgische Recht galt. Uns\ninteressiert hier vor allem diese zweite Gemeinde, da sie ein\nbesonderes Licht auf den unter deutscher Bevölkerung zu jener Zeit\nbeginnenden Drang nach Osten wirft, der gewissermaßen ein\nGegenstück zu dem, wenn auch aus "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page11",
      "title": "lac/woldemar"
    }
  }), _vm._v(" ganz anderen Gründen erwachten, aber in\nseinen rassegeschichtlichen Folgen nicht minder schwerwiegenden\nDrang nach Westen unter den Massen des slawischen Proletariats\ngenannt werden könnte. Auch diese Frage ist noch heute aktuell, und\nauch sie kommt im Reymontschen Roman zur Geltung.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die erwähnte, dem Magdeburgischen Recht unterstehende\nDorfgemeinde hat sich in Polen unter folgenden Bedingungen\ngebildet. Das Auftauchen der Tatarenhorden im Osten Europas und die\nEntvölkerung des Landes durch die blutigen Kämpfe mit ihnen\nerwecken im polnischen Reich das Bedürfnis nach frischen\nArbeitskräften. Die Einwanderung der Deutschen wird begünstigt und\ndie Geistlichkeit ist es, die zuerst die Erlaubnis erwirkt (die\nZisterzienser in Lubeni 1175), deutsche Kolonisten auf ihren Gütern\nanzusiedeln. Diese deutschen, damals gern gesehenen Kolonisten\nhaben auf die Einrichtungen der polnischen Dorfgemeinde insofern\neingewirkt, daß sie einen neuen Typus, den des adelig-bäuerlichen\nDorfes schufen. Auch das Entstehen gewisser Dorfbeamten: des\nSchulzen und Schultheißen, ist auf deutschen Einfluß\nzurückzuführen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("In diesem Zustand findet die Gesetzsammlung von Wislica die\npolnischen Dorfgemeinden. Die Hauptaufgabe, die Kasimir der Große,\nder Bauernkönig, wie ihn das polnische Volk auch heute noch nennt,\nin seiner Gesetzgebung verfolgte, war möglichst weitgehende Rechte\nfür den Bauernstand, als den Nährstand des Landes, zu sichern,\ndarum verschließt er auch in seinen Bestimmungen den Kmeten nicht\ndie Wege zu höheren Ämtern und versucht, sie möglichst dem\nAdelsstand gleichzustellen. Auch die Entrichtung der Vergütungen\nfür Nutznießung des Bodens beruht gänzlich auf freiwilliger\nAbmachung/ein Zustand, der ziemlich weit von dem der\nLeibeigenschaft bezeichnet werden kann und den noch die durchaus\nnicht streng zu nennenden Bestimmungen über die Auswanderung zu\n"), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page12",
      "title": "JohannN/woldemar"
    }
  }), _vm._v(" einem\nZustand ziemlicher Bewegungsfreiheit stempeln. Wichtig ist außerdem\nnoch die Erhebung der Schulzen und Schultheißen in den Ritterstand\ndritten Grades und die Unterwerfung aller Untertanen, ob sie Bürger\noder Bauern, Juden oder Edelleute sind, unter ein und dasselbe\nRecht. Darin zeigt sich die Gesetzsammlung von Wislica als ein\nunzweideutiger Ausdruck echt slawischer demokratischer Gesinnung.\nDer soziale Aufbau des polnischen Volkes ist diesen\nGesetzbestimmungen gemäß ein demokratisch betonter und weist\ndurchaus keine Kluft zwischen oben und unten auf. Heiraten zwischen\nAdeligen und Bauerntöchtern, und umgekehrt, sind um diese Zeit\nkeine Seltenheit, besonders sind es die Schulzen und Schultheißen,\ndie eine Zeitlang (bis 1496) eine dem Adel fast an Ansehen\ngleichkommende Stellung einnahmen und zu höheren Ämtern zugelassen\nwurden.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Mit dem Eindringen der Adelsbegriffe von Westen, und vorzüglich\nist es das nahe deutsche Beispiel, das immer wieder verlockend\nwirkt, versucht der polnische Adel besondere Rechte für sich zu\nerwirken, was ihm allmählich auch gelingt. Die Einzelheiten dieser\nWandlung des noch unter den Jagellonen demokratisch-republikanisch\nbetonten polnischen Staates zu einer der Willkür der Magnaten\npreisgegebenen Adelsrepublik zu schildern, würde zu weit führen;\nfür unsere Untersuchung ist nur wichtig, daß der polnische\nBauernstand während dieses Zeitraums in völlige Leibeigenschaft\n(nach den Reichstagsbestimmungen vom Jahre 1520) gerät. Von nun an\nbeginnt eine rein adelige polnische Geschichte, ein vom\ndemokratisch-kommunistischen Unterton des slawischen\nRassecharakters losgelöstes Intermezzo, das mit dem schrillen\nMißton eines völligen Zusammenbruchs abreißt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Der polnische Bauer war jahrhundertelang national totes Land,\nzum erstenmal tritt er wieder hell ins Licht der Geschichte nach\ndem Fall Polens, als der Leiter des polnischen "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page13",
      "title": "JohannN/woldemar"
    }
  }), _vm._v(" Aufstandes v. J. 1830, der\nGeneral Kosciuszko die Bauern unter seine Fahnen berief. Man hatte\nallerdings schon vor Polens Fall Anstrengungen gemacht, den\nBauernstand wieder aus dem Zustand seiner Rechtlosigkeit zu heben,\ndie ersten Versuche datieren selbst ins Jahr 1733 zurück, doch\nwirklich durchgreifende Reformen sind nicht erfolgt, und selbst der\ngroßzügige Entschluß des letzten polnischen Reichstags wurde durch\nden Eigennutz der Großen im Reiche zuschanden gemacht. Der\npolnische Bauer, der bereits in den napoleonischen Legionen zu\nfinden ist und in der großen Armee des wider Rußland ziehenden\nKorsen gegen Moskau marschiert, wird eigentlich erst im Aufstand v.\nJ. 1830 sichtbar. Das Bild der polnischen Sensenmänner erscheint\nauf der Bildfläche des nationalen Bewußtseins, sie tragen das rote\nBanner mit einer goldgestickten Garbe darauf / ein\nzusammenfassendes Sinnbild des polnischen Bauernvolkes: das\ndemokratische Rot und das erdgebundene Ährengold, auf dem stolz und\nselbstbewußt, als ob sie eine ganze lange Vergangenheit wegwischen\nwollten, die Worte leuchten: »Sie nähren und wehren.« Allerdings\nhaben die polnischen Bauern das Vaterland nicht retten können, denn\nerstens hatte sich nur ein kleiner Bruchteil, die Elite des\nBauerntums unter den Fahnen Kosciuszkos versammelt und zweitens\nauch einzig solche, die der auf seine kleinlich-egoistischen\nInteressen im allgemeinen bedachte Adel ins Feld ziehen ließ. Nach\ndiesem Aufflammen, das nicht ohne Heroismus ist, muß der Bauer\nwieder in seine alten unerträglichen sozialen Verhältnisse zurück,\ner ist nach wie vor rechtlos, auf Gnade und Ungnade der Knute\nseines Herrn ausgeliefert, und die Last der Fronarbeit drückt\nungemindert auf seine tief gebeugten Schultern. Daß unter solchen\nUmständen von einem politischen Erwachen des Bauern nicht die Rede\nsein kann, liegt auf der Hand. Ja, während allmählich das polnische\nDorf literaturfähig wird (als erster tut es der vielseitige,\naußerordentlich fruchtbare Schriftsteller J. J. Kraszewski "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page14",
      "title": "JohannN/woldemar"
    }
  }), _vm._v(" ) und man für\nländliche Motive zu schwärmen beginnt, indem man sich zum Volke\n»niederbeugt«, lernt der Bauer am eigenen Leibe nichts als die\nganze Last seiner Rechtlosigkeit kennen. Allerdings war der einmal\ngefaßte Gedanke der Befreiung des Volkes aus der Leibeigenschaft,\nals dessen Ausdruck der letzte polnische Reichstag und sein\nManifest vom 3. Mai zu betrachten sind, ununterbrochen im Laufe der\ndarauf folgenden über 60 Jahre an der Arbeit gewesen, doch hat er\neine positive gesetzgebende Tat nicht vollbracht. So wurde es für\nlange Jahre zum Verhängnis für die innere polnische Einheit, daß\ndie eigentlichen Befreier des polnischen Bauernvolkes aus der\nLeibeigenschaft nicht die polnischen regierenden Stände, sondern\nerst die fremden Regierungen wurden, die das geteilte Polen\npolitisch zu verwalten begonnen hatten. Außerdem wurden durch die\nverschiedenen Maßnahmen einer jeden der drei Regierungen bei der\nBefreiung des polnischen Bauers aus der Leibeigenschaft ganz\nverschiedene ökonomische Verhältnisse für das polnische Bauernvolk\neines jeden Teiles geschaffen, so daß man von nun an von den\npolnischen Bauern in Deutsch-Polen, Österreichisch-Polen und\nRussisch-Polen, als von drei sich verschieden entwickelnden\nvolkswirtschaftlichen Gruppen reden muß.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Das Mißtrauen und die feindselige Stimmung des polnischen Dorfes\ngegenüber der polnischen Intelligenz und besonders gegenüber dem\npolnischen Adel kommt auch noch hier und da im Reymontschen\nBauernroman, besonders in dem vierten Teil seines Werkes zutage, wo\ndie politischen und sozialen Zusammenhänge des Dorfes am\nsichtbarsten hervortreten. Bezeichnend dafür sind die Worte, die\nReymont einem alten Bauer auf einer Gemeindeversammlung in den Mund\nlegt:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Lacht nur zu, aber ich kann es euch sagen, wie es um jene\nZeiten herum aussah, als die Herren ihren Aufstand "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page15",
      "title": "JohannN/woldemar"
    }
  }), _vm._v(" gemacht haben; ich weiß\nnoch gut, wie sie uns vorgeschwindelt und geschworen haben, daß sie\nuns, wenn Polen wieder zurechtkäme, die Freiheit und Wald und Land\nund was nicht noch alles geben würden! Vorgeredet und versprochen\nhaben sie es uns, und was wir gekriegt haben, das hat uns ein\nanderer gegeben, und bestrafen mußte er sie noch, weil sie in\nkeiner Sache dem Volk eine Erleichterung schaffen wollten. Aber\nmich lockt keiner auf Spreu, ich weiß gut, was dieses, ihr Polen,\nbedeuten soll: das ist nur eine Peitsche für unseren Buckel und\nKnechtschaft und Leibeigenschaft!« ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Diese feindliche Voreingenommenheit, die man noch um die 80er\nund selbst noch 90er Jahre des neunzehnten Jahrhunderts im\npolnischen Dorf allgemein finden konnte, hat allmählich eine\nWandlung erfahren. Nach der Zeit des herablassenden Interesses für\ndas Dorf kam die Zeit des Mitgefühls mit dem sozialen Elend; man\ndichtete und besang den »Bruder im rauhen Bauernkittel« und fand\nauch hin und wieder echte, tiefe Töne. Vor allem sind es einzelne\nFrauen, wie die Dichterin Maria Konopnicka, Polens Selma Lagerlöf,\nund Elisa Orzeszkowa, auch Henryk Sienkiewicz schreibt um diese\nZeit seine Dorfnovellen. Doch es überwiegt noch immer eine\noberflächliche Sentimentalität, die einen besonders großen Zuspruch\nder Menge findet.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Erst die um 1887 gegründete Wochenschrift »Glos« (Die Stimme),\ndie um sich alle wirklich schöpferischen demokratischen Kräfte des\nmodernen Polens sammelt, leitet einen neuen Kurs in den Beziehungen\nder polnischen Intelligenz zum Volke ein. Die Erkenntnis dämmert\nauf, daß man das Volk nicht anders als durch das Volk selbst für\ndie polnische Sache gewinnen konnte. Es beginnt die Zeit der\nschweren, oft mit den größten Gefahren und Entbehrungen verbundenen\nArbeit im Volke. Der Bettler-Apostel Rochus im Reymontschen Roman\nist ein Beispiel dafür. Geheimverbindungen, die selbst mitten unter\ndie lernende Schuljugend "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page16",
      "title": "Ruktz/woldemar"
    }
  }), _vm._v(" reichen, spannen ein vielmaschiges Netz über\ndas ganze Land aus. An der Spitze aller Bestrebungen steht /\nVolksaufklärung! Schritt für Schritt versucht man vorzudringen,\nungeachtet der vielen Opfer, die besonders in Russisch-Polen diese\nArbeit fordert, da die russische Regierung alle Bemühungen dieser\nArt aufs schärfste bestraft. Nächtliche Haussuchungen,\nVerhaftungen, Deportation auf sog. administrativem Wege, d. h. ohne\nGericht, jahrelanges Schmachten in Gefängnissen und die Schrecken\ndes sibirischen Exils sind an der Tagesordnung. Jetzt setzt auch\neine ganz neue Phase in den Beziehungen zum Dorf ein. Man entdeckt\nabermals den polnischen Bauer, aber jetzt nicht mehr als einen\nGegenstand des Interesses oder des Mitleids, sondern als eine\nQuelle der Kraft. Unter den Werken, die das zuerst tun, ist das des\nMalers Stanislaw Witkiewicz über die galizischen Tatragebirgler das\ngrundlegende. Die Tatralandschaft und der Tatrastil / der erste in\nPolen zum Ansehen gelangte Bauernstil / werden hochaktuell. Die\nTatralandschaft fand ihren Epiker in Kasimir Tetmajer, dem Bruder\ndes Malers Wladimir.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Linie von dieser neuen Entdeckung des polnischen Bauers bis\nzu den politischen Idealen der Neuzeit, die den Bauer in den\nMittelpunkt jeglicher polnischer Probleme und Hoffnung stellen und\nbesonders in der Partei der polnischen National-Demokratie mit\nihren allpolnischen Bestrebungen einen politisch greifbaren\nAusdruck finden, ist klar genug sichtbar. Er ist, wenn man die\nRichtung näher charakterisieren soll, ein Anknüpfen an altpolnische\nbäuerliche, dem Grundcharakter nach demokratische Überlieferungen,\nein Überspringen des ganzen adeligen Intermezzos und ein\nBeiseiteschieben des bürgerlichen Mittelstandes, der in Polen\nsowieso niemals eine Rolle zu spielen vermocht hatte / kurzum, eine\nvollständige Änderung des Kurses. Der polnische Bauer mit seinen\nZukunftsmöglichkeiten ist der leitende Stern der realen und idealen\nPolitik. "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page17",
      "title": "Ruktz/lac"
    }
  }), _vm._v(" Mit\nanderen Worten kommt dieses einem Versuch gleich, ein paar\nJahrhunderte polnischer Geschichte auszustreichen und die\nBankerotterklärung der adeligen Anschauungen in Polen ein für\nallemal zu statuieren.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Es ist kein Wunder, daß bei dieser um sich greifenden Stimmung\nder Bauer in der neuesten polnischen Literatur eine ganz\nexzeptionelle Rolle zu spielen beginnt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Unter den vielen modernen polnischen Dichtungen, die der\nSchilderung bäuerlicher Motive gewidmet sind, verdienen vor allem\ndrei hervorgehoben zu werden: »Die Hochzeit«, das schon vorhin\nerwähnte Märchendrama Stanislaw Wyspianskis, »Herr Balcer in\nBrasilien«, das Epos von der polnischen Auswanderung nach Amerika\nvon Maria Konopnicka und die »Bauern«, das große realistische\nGemälde des polnischen Dorflebens von W. S. Reymont. Die feinen,\nunter einer wundersam gesponnenen Symbolik verborgenen Fäden der in\neinen nationalen Tanzrhythmus vorübergleitenden kaleidoskopartigen\nWyspianskischen Hochzeitsdichtung, die Gegenwärtiges und\nZukünftiges zu verbinden trachten, sind allerdings nicht leicht für\neinen Ausländer herauszuspüren. Ist es aber einem darum zu tun,\neine Ahnung polnischer Entwickelungsmöglichkeiten zu gewinnen, so\nsind gerade die Werke Wyspianskis neben denen von Stefan Zeromski\ndie geeignetsten dazu. Maria Konopnickas Auswanderungsepos, das\nwohl die vollendetste polnische epische Dichtung seit der Zeit der\ngroßen Romantiker ist und in seinem Aufbau, seiner\nSchilderungskunst, seiner Sprache unter die Meisterwerke der\nPolnischen Literatur gezählt werden muß, ist in seiner Analyse der\nBauernpsyche viel zu sehr von sentimentalen Nebengefühlen\nbeeinflußt, um als das Buch des polnischen Bauerntums gelten zu\nkönnen; den Anspruch darauf darf einzig das große vierbändige\nProsaepos von Reymont erheben. In diesem Werk, in dem sich ein ganz\nseltsam temperamentvoller Naturalismus und eine vortreffliche\nKenntnis "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page18",
      "title": "Ruktz/lac"
    }
  }), _vm._v(" des\npolnischen Bauernlebens vereinen, ist ein bis in alle Einzelheiten\nwahres Gemälde des polnischen Dorflebens gegeben worden.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Reymonts Werk erschien gerade an der Schwelle außerordentlich\nwichtiger, für die Entwickelung des östlichen Slawentums\nentscheidender politischer Ereignisse – vor Rußlands Niederlage im\nJapanischen Krieg und vor dem Beginn der großen revolutionären\nBewegung im russischen Reich. Es fixiert polnische Dorfzustände mit\neiner Klarheit, in der sie augenblicklich nicht gesehen werden\nkönnen, es gibt uns einen Schlüssel zu den verworrenen Vorgängen,\ndie sich heute auf politischem und sozialem Gebiet in Polen\nabspielen; und was vor allem wichtig ist, es führt uns den\npolnischen Bauer, auf den heute das polnische Volk dermaßen erhöhte\npolitische Hoffnungen setzt, im unverfälschten und durch keinerlei\ndoktrinäre oder ideologische Gesichtspunkte »verschönten«\nRohzustand vor. Das ist die aufschlußgebende Bedeutung der\nReymontschen Dichtung.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Dabei ist natürlich nicht zu vergessen, daß es wirklich eine\nDichtung ist, die uns diese Einblicke in ein interessantes Neuland\nverschafft. W. S. Reymont ist der berufene Epiker des polnischen\nDorfes. Er ist trotz seines fremdländisch klingenden Namens ein\nKind der fremden, kulturfernen Welt des polnischen Dorfes, in der\ner seinen Lebenslauf mitten unter Gänsejungen und Viehhütern,\nselbst die Herde seines Vaters, eines dem Bauernstande entwachsenen\nDorforganisten, hütend, seinen Lebenslauf beginnt, um allmählich\nauf der sozialen Stufenleiter zur Stellung eines beliebten und\nbekannten Dichters emporzusteigen, der schon seit Jahren einen\nbeträchtlichen Teil seiner Zeit in Paris, im Zentrum der modernen\nKultur, zu verleben pflegt. Reymont kennt das Dorf aus\nunmittelbarer Nähe, bis in jede Einzelheit, bis in die geheimsten\nWinkel und Falten der polnischen Bauernseele, bis zu den\nEigentümlichkeiten der polnischen Bauernsprache, er kennt es mit\nder tiefen, instinktsicheren "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page19",
      "title": "Ruktz/gary"
    }
  }), _vm._v(" Kenntnis eines Menschen, den die vertrautesten\nErinnerungen der Kindheit mit dem Milieu verbinden, der aus der\nFülle schöpft, und was besonders zu betonen ist, sich trotz der\nbunten Lebensschicksale, die ihn allmählich dem polnischen Dorf\nentführt haben, die ihn von der Tonbank eines städtischen Ladens\nzum Wanderkarren eines fliegenden Provinztheaters, von dem\nlärmenden Tagwerk eines Bahnarbeiters bis in die Stille einer\nKlosterzell trieben, dennoch nie diesem Dorf entfremdet hat.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Reymont ist nicht nur der Schilderer des polnischen Dorfes, er\nist das zum sprachlichen Ausdruck gewordene bäuerlich-ländliche\nElement, er ist das unmittelbarste rhythmische und seelische\nBekenntnis des polnischen Bauerntums. Das ist die Stärke und auch\nzuweilen die Schwäche seines Werkes. Seine »Bauern« halten somit im\nweitesten Sinne das, was der Titel verspricht/sie sind das Epos des\npolnischen Dorfes. Das polnische Dorf, wie es in Russisch-Polen\nvornehmlich zu finden ist (seine deutschen und österreichischen\nGegenstücke sind nur unmerkliche Abweichungen von diesem Typus),\nist trotz der Anekdote, die auch der dramatischen Spannung nicht\nentbehrt, der eigentliche Romanheld. Das Dorf ist es, das den Kampf\num den gemeinsamen Waldbesitz mit dem Gutshof führt, dessen\neinzelne Phasen den Hintergrund für die beiden Teile des Romans\nbilden, das Dorf, das sich sein eigenes Recht in einem prachtvoll\ngezeichneten, höchst dramatischen und zugleich humoristischen Kampf\nim Walde verschafft und dafür die tragikomische Strafe einer\ngemeinsamen Haft erleidet, das Dorf, das gegen Antek, den Sohn des\nersten Dorfpotentaten, des alten Matheus Boryna, vorgeht, als\ndieser eigenwillig die Schranken der gemeinsamen Sitte zu\ndurchbrechen droht, das Dorf/das gegen die russische Regierung und\ngegen die deutschen Kolonisten Stellung nimmt, das das aus\nkommunistisch-demokratischen Lebensanschauungen erwachsene Prinzip\nder gemeinsamen Abwehr und der gemeinsamen "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page20",
      "title": "Ruktz/gary"
    }
  }), _vm._v(" Hilfe in der Not in eine Reihe von\nTaten umsetzt, deren sozialpolitische Bedeutung nicht zu verkennen\nist und das eine grausame Lynchjustiz an einer Dorfhelena ausführt,\num die sich das Begehren des leicht erregbaren Blutes, das auch den\npolnischen Bauer kennzeichnet, wie um die zweite Achse der Handlung\ndreht.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Gegenüber dieser Macht der Gemeinde schrumpft die einzelne\nPersönlichkeit zu einem fast nichtssagenden Schnörkel zusammen. Es\ngibt natürlich Anführer, und die demokratisch-kommunistische\nDorfgemeinde bedarf ihrer noch mehr, als eine freie Verbindung von\nselbständigen Bündlern, ein solcher Anführer ist bei Reymont der\nalte Matheus Boryna, der reichste und angesehenste Bauer im Dorf.\nDoch ist ihre Macht und ihr Einfluß im Dorf dermaßen durch den\nZusammenhang mit der Gemeinde bedingt, daß sie eigentlich mehr als\nderen höchste Vertreter und Interpreten, nicht aber als einzeln für\nsich dastehende Persönlichkeiten zur Geltung kommen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Der zweite Ring, der die Einzelpersönlichkeiten mit eiserner\nGewalt umschließt und ihnen noch stärker den demokratischen Stempel\neiner streng aufeinander angewiesenen Gemeinschaft aufdrückt, ist\ndie völlige Naturgebundenheit, in der sich die polnischen Bauern\nbefinden. Die echt slawische rückhaltslose Hingabe des Polen an die\nNatur, seine Naturversunkenheit, die nicht einmal einen Versuch von\nAuflehnung zeigt, die das Gefühl vertrauender Kindesliebe über den\nStandpunkt der Empörung wider die Naturgewalten, den Kampf gegen\nsie und ihre Überwindung stellt, trägt noch mehr dazu bei, die\nEinzelpersönlichkeit im Dorfleben der Gemeinde verschwinden zu\nlassen. Das Individuelle versinkt fast spurlos im Naturgeschehen,\nwie ein einzelner Wanderer in der Unendlichkeit der slawischen\nEbene, in der selbst Dörfer und Gehöfte belanglos erscheinen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("ES ist Reymont in seinen »Bauern« gelungen, einen "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page21",
      "title": "Ruktz/gary"
    }
  }), _vm._v(" außerordentlich\neindringlichen Ausdruck dieser Naturgebundenheit des polnischen\nBauers zu geben, nicht nur durch den Aufbau seines vierteiligen\nRomans im Rahmen der Aufeinanderfolge der vier Jahreszeiten\n(Herbst/Winter, Frühling/Sommer), sondern auch durch die Gliederung\ndieses Jahresringes. Die Handlung beginnt mit der Zeit der ersten\nAussaat, mit der nach der Ernte einsetzenden Vorbereitung künftiger\nErntemöglichkeiten, um über die Hemmungen des Winters hinaus, sich\nzum Höhepunkt der Sommererntezeit zu steigern. So wird die\nJahreszeit mit allen ihren Forderungen und mit ihrem Geschehen zum\nGrundmotiv der Handlung selbst. Wie eine allmächtige,\nallbestimmende Gewalt steht die Natur hinter allen Vorgängen. Die\nvortreffliche Zusammenschweißung beider ist eine besondere Stärke\nder Reymontschen Dichtung.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Wir sehen den Herbst in seiner bunten Pracht der Reife\naufglühen; wie stille Bilder reihen sich die einzelnen Geschehnisse\naneinander. Kartoffelernte, Kohlschneiden, ein Septembersonntag im\nDorf mit Kirchenandacht und einem Tanzvergnügen, Herbstmarkt, eine\ntypische Abendzusammenkunft mit Kohlschälen, Allerseelen mit seinen\neigentümlichen Bräuchen, eine Bauernverlobung und Hochzeit ... In\ndiesen Rahmen ist eine Anekdote hineingespannt: die Geschichte\neiner Nebenbuhlerschaft zwischen Vater und Sohn wegen einer\nDorfschönen. Mit einer prunkvollen Hochzeit, die alle Farben des\npolnischen Dorfes in sich zu einer koloristisch und rhythmisch\naußerordentlich reichen Schilderung vereinigt, schließt das bunte\nHerbstbild. Wie ein Vorbote des schon nahen Winters mischt sich\nzuletzt noch eine elegische Todesweise in die Festfreude des Dorfes\nhinein, ganz wundersam mit seinen Kontrasten das hohe Fest des\nLebens durchwebend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Der Winter bringt dramatische Töne. Das polnische Dorf in Eis\nund Schnee wird sichtbar. Der Schankwirt, die jüdischen Händler und\nder Müller halten ihre Erntezeit, "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page22",
      "title": "Ruktz/gary"
    }
  }), _vm._v(" und aus dem todähnlichen Schlaf der Abwehr,\nin dem das Dorf nach außenhin ganz befangen zu sein scheint, reckt\nsich immer drohender, je näher es nach dem Vorfrühling zu geht, die\nbange Sorge der Vorerntenot. Die ungesicherten, traurigen\nVerhältnisse des polnischen Dorfproletariats treten in ihrer ganzen\nKraßheit vor unsere Augen. Sie kommen anschaulich in den\nSchicksalen des reichen Hofbauernsohns Antek Boryna zur Geltung,\nden der alte Vater von Haus und Hof gejagt hat und der nun mit Frau\nund Kind in einer ärmlichen Kate alle Schrecknisse einer auf Gnade\nund Ungnade den unerbittlichen Naturgewalten ausgelieferten\nExistenz am eigenen Leibe erleben muß. Eine der prachtvollsten\nSchilderungen dieser Art sind die Erlebnisse einer schwangeren,\nverratenen Frau im Hochwald während eines Schneesturms beim\nReisigsammeln. Den scharfen Akzenten, die das Naturbild zeigt,\nentspricht das sich verdüsternde Bild der Leidenschaften. Es werden\nden Leser allerdings die verträumten Bilder der Weihnachtszeit, mit\nall ihrer innigen Feierlichkeit mit ihren alten Sitten und\nBräuchen, die Spinnabende mit ihrer Lust am Fabulieren, ihrem\nMummenschanz, Rätselspielen usw. wie traute Ruhepausen hier und da\nfesthalten; aber der Gang der Handlung ist doch ein unerbittlich\nernster, zu einer Katastrophe hindrängender. Die Feindschaft\nzwischen Vater und Sohn wächst nach der Hochzeit des alten Borynas,\ndie einen vorläufigen Sieg des Vaters bedeutet, während sich die\nLiebesfäden zwischen Sohn und Stiefmutter immer enger zu einem\nverhängnisvollen Ehebruch knüpfen. Der mißlungenen Rache des\nVaters, der den Sohn mit der Frau "), _c('span', {
    staticClass: "teletype"
  }, [_vm._v("in\nflagranti")]), _vm._v(" in einem Heuschober überrascht, welchen er darauf\nin Brand setzt, folgt der Waldkampf des ganzen Dorfes gegen den\nGutshof, währenddessen sich dem Sohn eine Gelegenheit zur blutigen\nVergeltung bietet, die er jedoch im letzten Augenblick nicht\nausführt. Wie ein die Welt reinfegender Märzsturm schließt der\nhochdramatische Waldkampf das strenge Winterbild ab. "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page23",
      "title": "Ruktz/gary"
    }
  }), _vm._v(" Das allmähliche Werden des\nFrühlings, die drängende Triebkraft der erwachenden Fruchtbarkeit\nwirken besonders eindrucksvoll durch die Hemmungen, in denen sich\ndas Dorf nach dem verhängnisvollen Waldkampf befindet. Es kehren\nschon die Bettler wie Wandervögel von ihren Winterstreifzügen in\ndas heimatliche Dorf zurück, wo man jetzt jeglichen Zuwachs an\nArbeitskräften mit Freuden begrüßt, aber sie finden totenhafte\nRuhe. Die Erde ist erwacht, alles sprießt und wächst, der Acker\nwartet auf den aufwühlenden Pflug und auf den befruchtenden Samen,\naber die Menschen sitzen im Gefängnis. Es ist Reymont durch diese\nKontraste gelungen, eine ganz eigenartige Frühlingsstimmung zu\nerzeugen, die der wirklichen Lage im polnischen Dorf viel näher\nkommt, als alle dithyrambischen Frühlingshymnen der früheren\nSchilderer des polnischen Bauerntums. Das Frühlingserwachen auf dem\npolnischen Dorf ist ein schwerer, krisenhafter Vorgang. Die bittere\nNot steht an der Pforte zu neuen Erfüllungen. Das Wort\n»Vorerntezeit« ist im Polnischen gleichbedeutend mit dem Begriff\nschwerer Entbehrungen. Die schwierigen ökonomischen Verhältnisse\nerlauben einem recht ansehnlichen Bruchteil der Landleute nicht,\nvon dem Ertrag der Ernte ein ganzes Jahr zu leben, und da dabei die\nGelegenheitsverdienste gering und sehr unsicher sind, so stellt\nsich in der Frühlingszeit meist schon eine recht empfindliche Not\nein, die in einzelnen Teilen des russischen Reiches selbst die Form\nvon chronischen Hungersnöten annimmt. Dagegen sind die Hilfsmittel\ndes einzelnen und selbst der Regierung machtlos. Darum ist auch das\nAufkommen des kommunistisch-demokratischen Prinzips der gemeinsamen\nSelbsthilfe, das von nun an in der Handlung des Reymontschen Romans\neine entschieden führende Rolle übernimmt, außerordentlich typisch\nfür slawisches Empfinden und slawische Entwickelungsmöglichkeiten.\nEs ist das alte unter den Piasten in Polen zum politischen Ausdruck\ngekommene Prinzip des demokratischen Bauernstaates, auf "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page24",
      "title": "Ruktz/gary"
    }
  }), _vm._v(" das sich auch die\nHoffnung der modernen polnischen Politiker stützen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Handlung nimmt nun ganz beträchtlich an Breite zu, sie wird\nwie ein Strom, der seine Schnellen überwunden hat und sich nun, zu\neiner gewaltigen Wassermenge angewachsen, seiner Mündung\nentgegenwälzt. Darin ist der Roman für slawisches Empfinden\naußerordentlich bezeichnend, obgleich er für westeuropäische und\nvor allem für germanische Begriffe einen empfindlichen Mangel an\nStraffheit aufweist. Er zerfließt fast zur Formlosigkeit, und doch\nist gerade dieses Zerfließen ein notwendiger Ausfluß slawischer\nWesensart.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Um der Entwicklung der Handlung das rechte Verständnis\nentgegenzubringen, wird es zunächst von Wichtigkeit sein, zwei\nSchwerpunkte zu beachten: Die Natur und die Macht der Dorfgemeinde.\nZwischen beiden schlängelt sich die immer stärker symbolisch\nanmutende Romananekdote.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Das Aufblühen der guten Jahreszeit umfängt allmählich wie mit\neinem Zauber die ganze Gefühlsatmosphäre des Dorfes. Ein schwerer,\nberauschender Erdgeruch durchzieht das Buch, legt sich betäubend\nund verführerisch auf die Sinne, verdichtet sich zu Visionen, die\nan altslawische Naturgottheiten erinnern und zuweilen selbst etwas\nvon der naturinnigen Lieblichkeit Gauginscher Erlebnisse haben.\nBezeichnend dafür ist besonders der Grundton der Schilderung einer\nMaiandacht auf einem Dorfkirchhof. Dieses immer mächtiger\nanwachsende Naturmotiv findet seine symbolisch-menschliche\nErgänzung in der Schilderung des Todes des alten, im Waldkampfe\nschwer verletzten Boryna, der in einer mondhellen Mainacht, am\nVorabend der angesagten Rückkehr seines Sohnes aus dem\nUntersuchungsgefängnis, bloß im Hemd und barfuß mit säend-segnender\nGebärde über sein Ackerland schreitet, oder in dem ersten Gang des\nwiedergekehrten Antek Boryna, der mit seinem kleinen Söhnchen auf\ndem Arm durch die ernteverheißenden Felder "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page25",
      "title": "Ruktz/gary"
    }
  }), _vm._v(" geht, von denen er wie ein Erbe\nendloser, erdgebundener Geschlechter und als Vorfahr neuer\nendloser, erdgebundener Generationen Besitz ergreift.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Auch das kommunistisch-demokratische Element der polnischen\nDorfgemeinde nimmt im Entwicklungsgang der Handlung einen immer\nwichtigeren Platz ein. Die Einzelschicksale werden im Vergleich zu\ndieser immer klarer hervortretenden Gesamtpersönlichkeit in den\nHintergrund gedrängt. Auch das ist durchaus slawisch empfunden. Von\ndiesem Gesichtspunkt aus zeigt der Roman ein ganz besonderes\neinheitliches Gefüge, das ihm sonst fehlen würde, wenn man\nlediglich die Entwicklung der Einzelschicksale betrachten wollte.\nAußer der ganzen im übrigen verständlichen, wenn auch\nungewöhnlichen Wendung bleibt in der Entwickelung des Reymontschen\nRomans noch die ziemlich breit ausgesponnene Jagna-Episode zu\nerklären, die recht kräftig in den Schluß hineinklingt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Vielen wird die Gestalt dieses vielumworbenen Dorfmädchens, der\nblondhaarigen und blauäugigen Dorfhelena, die den Sohn liebt, den\nVater heiratet, mit diesem Sohn dann zur Ehebrecherin wird, mit dem\nDorfschulzen eine skandalöse Liebschaft hat, von einem früheren\nLiebhaber, noch ehe sie Witwe geworden, wieder umschwärmt wird und\nsich selbst in den Organistensohn Jascho, einen angehenden\nPriester, verliebt, den sie mit ihrer sinnlosen Leidenschaft\nverfolgt, um schließlich vom ganzen Dorf gelyncht zu werden, als\neine rätselhafte, unverständliche und vielleicht selbst\nunglaubwürdige Gestalt vorkommen. Der Dichter selbst\ncharakterisiert sie einmal im ersten Teil seines Bauernepos mit\nfolgenden Worten (s. S. 153):")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»... Denn wie die heilige Erde war Jagnas Seele/ ganz wie diese\nErde; sie lag in Tiefen, die niemand erkennen konnte, in der\nWirrnis schlaftrunkener Träume/ riesig und unbewußt, mächtig, aber\nohne Willen, ohne Wollen, ohne Wünsche, totenstarr und dennoch\nunsterblich, "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page26",
      "title": "Ruktz/gary"
    }
  }), _vm._v("\nund wie diese Erde nahm sie jeder Wind, umhüllte sie, schaukelte\nsie und trug sie dahin, wo er wollte ... sie war wie die Erde, die\ndie warme Sonne zur Frühjahrszeit weckt, mit Leben befruchtet, mit\ndem Feuerschauer des Verlangens, der Liebe erschüttert/und sie\ngebiert, weil sie muß; sie lebt, singt, herrscht, schafft und\nvernichtet, weil sie muß; sie ist, weil sie muß ... denn wie die\nheilige Erde war Jagnas Seele/ganz wie diese Erde! ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Diese Schilderung ist jedoch nur ein flüchtiger Hinweis, wo wir\nden Schlüssel zu Jagnas seltsamer Menschlichkeit zu suchen haben.\nErklärlich wird sie nur, wenn man das sinnliche Moment und seine\nBedeutung für die slawische Psyche begriffen hat. Es gibt\nallerdings eine ganze Stufenleiter slawischer Sinnlichkeit von der\ntschechischen prallen Lebensfreude bis zur tiefsinnigen russischen\nLeidenschaftlichkeit, zwischen denen die polnische Heißblütigkeit\nin der Mitte steht. Man darf nicht vergessen, daß die\nHauptgestalten des Reymontschen Romans, wie das die »Revue des deux\nMondes« in einem umfassenden Aufsatz über Reymont treffend bemerkt,\n»eine unverkennbare symbolische Bedeutung haben, die sie doch nicht\nhindert, in unseren Augen die Merkmale einer greifbaren\nmenschlichen Wahrhaftigkeit zu bewahren«. Eine solche symbolische\n»tiefere« Bedeutung ist auch der Gestalt der Jagna beizulegen, die\nneben dem alten Boryna, seinem Sohn Antek und dessen Frau Anna zu\nden in diesem Sinne deutbaren Hauptgestalten des Romans gezählt\nwerden muß. Damit aber berühren wir das spezifisch\nSlawisch-Polnische im Reymontschen Bauernroman.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Auf das demokratisch-kommunistische Gefühl als eine besondere\nslawische sozialpolitisch formende Kraft habe ich bereits\nhingewiesen, es ist der individualistisch-aristokratischen\nLebensanschauung des Germanen diametral entgegengesetzt, so wie die\nkommunistische Dorfgemeinde der Urslawen der Gegenpol der\nurgermanischen norwegischen "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page27",
      "title": "Ruktz/gary"
    }
  }), _vm._v(" Höfe ist. Dem Slawen fehlt das Problematische des\nGermanen. Seine Naturversunkenheit ist ekstatisch ohne Widerspruch,\ner identifiziert sich mit der Natur, ohne den Zwiespalt zu fühlen,\nder als Faustischer Zug durch alles Germanische geht. Dadurch hat\ner sich eine gewisse taufrische Naturinnigkeit bewahrt, die auch\nheute noch als eine Stärke von den geschichtlich älteren Nationen\nEuropas empfunden wird, im Grunde aber seine Schwäche ist, denn nur\naus dem Zwiespalt mit der Natur entsteht die Naturüberwindung, nur\nüber die Abgründe des Problematischen kann man zur siegreichen\nSelbstverewigung des monumentalen Stils gelangen. Der völlige\nMangel monumentaler Gestaltungsfähigkeit zeichnet den Slawen aus,\nund wie sehr er ein Gegner des individualistischen\nSich-selbst-formens, Sich-selbst-wiederfindens im Weltgeschehen\nist, dafür liefert einer der größten und echtesten Interpreten der\nslawischen Seele, Fedor Dostojewski, mit seinem fanatischen Haß des\nindividualistischen Prinzips einen recht beredten Ausdruck. Wir\nbrauchen solchen Werken nur die alten isländischen Sagas\nentgegenzustellen, in denen sich das germanische Empfinden in\nseiner reinsten Gestalt, denn noch frei vom Einfluß des\nChristentums, monumental auszusprechen vermocht hat, um zu sehen,\ndaß es sich hier um prinzipielle und nicht durch geschichtliche\nVermengungen erst gewordene Unterschiede handelt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Würde der christlichen Idee der Menschenverbrüderung eine\nsozialpolitische Verwirklichung im europäischen Völkerleben\nbeschieden sein, dann könnte allerdings die\nkommunistisch-demokratische Gesellschaftsordnung, an der die Slawen\nseit jeher festzuhalten versucht haben, eine weltgeschichtliche\nBedeutung gewinnen, auch die Gedanken der modernen Propheten des\nDemokratismus (ich möchte hier besonders auf die Wendung hinweisen,\ndie der Sozialismus im heutigen England genommen hat/Näheres\ndarüber ist in dem vortrefflichen Werk des Schweben Gustaf F.\nSteffen "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page28",
      "title": "Ruktz/gary"
    }
  }), _vm._v(" »Die\nDemokratie in England« zu finden) haben merkwürdigerweise gewisse\nBerührungspunkte mit diesen kommunistisch-demokratischen Begriffen\ndes Slawentums. Da wir aber das Wertvollste, das wir bis jetzt an\nKulturerrungenschaften besitzen, unverkennbar nicht dem\nempfangenden und interpretierenden, sondern dem gestaltenden und\neigenwillig prägenden aristokratisch-individualistischen Prinzip zu\nverdanken haben, so ist die slawische »Seele« als ein Element zu\nbetrachten, daß nicht ohne folgenschwere Einwirkungen dem\nKulturbesitz beigemengt werden kann.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Was dem Slawen an Gestaltungsfähigkeit abgeht, das ersetzt er\ndurch die Stärke des Empfindens. Diese Stärke des Empfindens finden\nwir auch im hohen Maße in Reymonts »Bauern«. Die Musik der Sprache,\ndie Farbe, der Rhythmus sind oft von einem beträchtlichen Schwung,\nseine Vergleiche schillern und funkeln wie im grellsten\nSonnenlicht, seine Schilderungen brechen oft in ekstatischer\nSeligkeit wie sprudelnde Lyrismen hervor, selbst sein\nNaturalismus/denn Reymont trachtet die Seele und das Leben des\npolnischen Dorfes von außenher mit einer bis ins Kleinste gehenden\nWahrheitstreue zu beschreiben/ist ganz ungewöhnlich temperamentvoll\nund bildet für die Ausdrucksmöglichkeiten naturalistischer\nDarstellungskunst zuweilen eine ganz neue Bereicherung. Beispiele\nfür Reymonts ekstatisch-naturalistische Art zu schreiben, ließen\nsich leicht häufen, es möge hier nur eine besonders\ncharakteristische Schilderung polnischer Nationaltänze folgen, wie\nsie auf Borynas Hochzeit getanzt wurden (s. Bd. 1, Herbst, S.\n285):")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und sie tanzten!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("... Die zappelnden, schäkernden Krakowiaks mit der abgerissenen,\nklirrenden Melodie, die wie mit Ziernäglein beschlagene Gürtel mit\ntanzfrohen Liedlein ausgeputzt war; die Krakowiaks voll Lachen und\nMutwillen, voll fröhlichen Sangs und üppiger starker, kecker Jugend\nund zugleich voll "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page29",
      "title": "Ruktz/gary"
    }
  }), _vm._v(" lustiger Possen, voll Haschen und voll Greifen\nund voll Glut des jungen liebeshungrigen Blutes. Hei!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("... Mazurkas, langgedehnt wie Feldraine, breitgestreckt wie die\nMathiasbirnbäume, rauschend, und wie unabsehbare Ebenen so breit,\nvoll Schwergewicht und schlank aufstrebend, sehnsüchtig und\nverwegen, gleitend und dräuend gepackt, würdevoll und\ndraufgängerisch und steifnackig dazu, wie jene Mannsleute, die zu\neinem Haufen zusammengeschart, wie ein Wald aufragend, sich in den\nTanz werfen mit Juchzern und solcher Macht, als ob es zu hundert\ngegen Tausende angehen sollte/und wenn man dabei die ganze Welt\nzerreißen, verprügeln, zerstampfen, zu Splittern zertrampeln, auf\nden Absätzen auseinandertragen müßte und selbst zugrunde gehen, um\ndann noch nach dem Tode zu tanzen, mit den Hacken aufzutrampeln und\nforsch auf mazurische Art aufzujuchzen: »Da-dana!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("... Und mächtige Obereks tanzten sie, ruckweise Springetänze,\nschwindelnde, tolle, rasende, herausfordernde und wehmütige,\nsengende und versonnene, mit Klageliedern durchwobene, im Siedetakt\ndes feurigen Blutes pulsende, und doch voll Güte und Liebe,\nplötzlich wie eine Hagelwolke niedersausende, und voll herzlicher\nStimmen, voll himmelblauer Blicke, voll lenzverheißender Lüfte,\nvoll düfteschwangeren Zweigerauschens, das aus blütenschweren\nObstgärten kommt/Tänze, die wie jene sangerfüllten Frühlingsfelder\nsind, Tänze, wo auch die Tränen noch durch Lachen fließen, und das\nHerz Freudelieder singt, und die Seele sich sehnsüchtig losreißt,\nden fernen Weiten, den entlegenen Wäldern entgegen und in die große\nWelt hinausfliegt, ahnender Träume voll, vor sich hinsingend: »Oj,\nDa-dana!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Solche Schilderungen haben ihren besonderen stark anregenden\nReiz, doch sind sie zu eigenwillig, zu selbstherrlich, um sich\neinem großen Ganzen unterzuordnen, sie zersprengen den Rahmen der\nForm, und in großen Zusammenhängen "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page30",
      "title": "lac/gary"
    }
  }), _vm._v(" bilden sich aus ihnen aneinandergereihte\nBilder, aber nicht ein einheitlicher, emporstrebender, einen\neinzigen Willen monumental ausdrückender Bau/das ist der breite\nslawische Strom, der ungebändigt, elementar sich durch eine weite\nEbene ergießt!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Diese Intensität des Empfindens setzt eine starke sinnliche\nErregbarkeit voraus. Sie ist ein Kennzeichen aller Slawen. Bei den\nPolen ist sie das »heiße polnische Blut«, dessen explosive\nEigenschaften allgemein bekannt sind. Der Pole ist immer geladen,\nin seiner Seele brennt ein unstillbares Flackerfeuer, das immer\nwieder zu Ausbrüchen drängt, seine Bewegungen sind rasch, er braust\nleicht auf und gerät schnell in den Zustand sinnloser Wut, oder\nseliger Verzückung. Man findet bei Reymont Worte wie: kochen,\nsieden, aufflammen, brodeln, aufeinander zuspringen, fliegen (für\nlaufen), ausbrechen, als die gewöhnlichen Charakteristika für\nEmpfinden und Bewegung/Ausdrücke, die in der wörtlichen Übersetzung\nins Deutsche als Übertriebenheiten wirken würden und dennoch im\nOriginal durchaus echt sind. Wer sich überzeugen will, daß diese\nEigenschaft im Stil der meisten polnischen Dichter und\nSchriftsteller als charakteristisches Merkmal zu finden ist, der\nprüfe aufmerksam ihre Werke; besonders leicht kann man diese\nEigentümlichkeit bei Stanislaw Przybyszewski und vor allem an\nseinen, auch in deutscher Sprache erschienenen Romanen\nbeobachten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Vortrefflich hat die erwähnte Charaktereigenschaft des Polen\neiner der seinsinnigsten polnischen Maler der Neuzeit, Jacek\nMalczewski in einem Bild, das »Vor dem Sturm« benannt ist,\nversinnbildlicht. Malczewski ist ein Künstler, der in seltsam\nkühnen Bildern eine wundersam tiefe Symbolik zu geben weiß. Ein\npolnischer Bauernjunge sitzt mit gesenktem, struppigem Kopf auf\neiner Blumenwiese, die ganze Haltung hat etwas Lässig-Träges,\nHingebendes, aber der Ausdruck der eigentümlich stieren Augen und\ndes sinnlich geschwellten "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page31",
      "title": "lac/lesdochmal"
    }
  }), _vm._v(" Mundes ist gespannt. Er horcht auf das\nlockende Flüstern einer neben ihm einschmeichelnd hingekauerten\nPhantasiegestalt, eines Weibes mit einem unförmlich raubtierhaften\nTigerleib, riesigen Hintertatzen und spitzen Bussardflügeln, die\naus den Schultern herauswachsen; eine ihrer Krallenhände hat sie an\nseine Hand geschmiegt und sieht auf ihre sichere Beute mit\nsiegestrunkenem Lachen herab. Im Hintergrund, über ärmlichen, im\nkahlen Feld dastehenden Katen, hängt schwarz eine brauende\nGewitterwolke ... Die Stimmung »Vor dem Gewitter« ist der normale\nZustand des polnischen Temperaments, das jeden Augenblick imstande\nist, auszubrechen und in einem wilden Elan durchzugehen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Nun erst wird es uns möglich, Jagnas Gestalt aus Reymonts Roman\nrichtig zu verstehen. Jagna ist, wenn man die symbolischen Züge\nzusammenfaßt, die ihrer durchaus echt und wahr dargestellten\nMenschlichkeit entnommen werden könnten, die naturgebundene,\nexplosive, polnische Leidenschaftlichkeit. Sinnliche Erregbarkeit\nund Naturversunkenheit schließen sich hier zu einem festen Ring\nzusammen und bilden ein eigentümliches Gleichgewicht. Darum wirkt\nihre Erscheinung trotz ihrer vielfachen Liebesabenteuer doch nicht\nlüstern, und ihre Bestrafung hat etwas von einem Martyrium. Man hat\ndas Gefühl, als leuchte über ihrem Haupt der blasse Lichtschein\neiner fernen Ankunftsmöglichkeit, obgleich ihr Fuß über Schmutz und\nStaub einer verdüsterten Gegenwart den verhängnisvollen Weg der\nVerlorenen schreitet. Die tüchtige, energische, treue Anna, Antek\nBorynas Frau, hat im Vergleich mit ihr etwas Engherziges, Ärmliches\nund Graues.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Das Explosive des polnischen »heißen Blutes«, das sich im\npolnischen Edelmann, etwas aus seiner Naturgebundenheit gelockert,\nzu einem aristokratisch-revolutionären Element ausgebildet hat, ist\nim polnischen Bauer noch naturgebunden geblieben und harrt als eine\nunbekannte Möglichkeit "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page32",
      "title": "lac/DaoH"
    }
  }), _vm._v(" /auf den Tag seiner Erlösung. Das Bild des\npolnischen Dorfes, dieses für den nichtpolnischen Leser\nliterarischen Neulands, aus dem man jene Zukunft zum Teil\nherauslesen könnte, hat Reymont mit einer bis in alle Einzelheiten\ngehenden Deutlichkeit geschildert. Das ganze Bauernleben mit all\nseinen Äußerungen von der Wiege bis zum Grabe, zu jeder Jahreszeit,\nin jeglicher Lage und zu jeglicher Stunde des Tages wird uns\noffenbar. Man kann, ohne zu übertreiben, behaupten, daß es kaum ein\nWerk gibt, das ein wichtigeres Dokument zur Kenntnis des polnischen\nBauerntums genannt werden dürfte. Dieses poetische Dokument\nerscheint in einem wichtigen Augenblick, und zwar in einer Zeit\ntiefgehender Umgestaltungen im polnischen Bauernleben, am Vorabend\ndes Eintrittes des Bauern in nationalpolnische Geschichte. Das\nErwachen des sozialpolitischen Bewußtseins im polnischen Bauerntum\nist nämlich eine seit dem Beginn der russischen Revolution deutlich\nhervortretende Erscheinung, die auch bereits ihren politischen\nAusdruck in der allpolnischen National-Demokratie gefunden hat.\nDurch diese Wandlungen ist allerdings die Physiognomie des\npolnischen Dorfes weniger deutlich erkennbar geworden und läßt sich\nheute überhaupt nicht so feststellen, wie das Reymont gerade noch\nim letzten Augenblick vor der beginnenden Verwandlung tun konnte.\nAllerdings finden wir auch bei Reymont schon neben dem alten\nAusdruck des polnischen Dorflebens, das noch die Väter\nrepräsentieren, auch das Gären der neuen Zeit in den Söhnen. Die\nerste Hälfte des Romans zeigt dementsprechend einen recht\nmerklichen Unterschied im Vergleich mit der zweiten. Gestalten, wie\nder alte Dorfpatriarch Matheus Boryna, der derb-witzige Küster\nAmbrosius, der unterwürfig-schlaue alte Bylica, der treue Knecht\nJakob Socha, die genügsame Bettlerin Agathe, die giftige Gusche und\ndie scheinheilige, habsüchtige Dominikbäuerin, Jagnas Mutter,\ntreten allmählich immer mehr in den Hintergrund, und mit ihnen\n"), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page33",
      "title": "Ruktz/lac"
    }
  }), _vm._v(" versinkt die\nZeit der rein vegetativen jahrhundertealten Epoche im polnischen\nBauernleben, um einem neuen Zeitalter Platz zu machen, dessen\nVertreter in Antek Boryna, Mathias Täubich, Jagnas Bruder Schymek\nund Gschela, dem Bruder des Dorfschulzen, zu finden sind. Zwischen\nbeiden Welten steht Rochus, der an Tolstoische Gestalten erinnernde\nApostel-Bettler, der das nette Bewußtsein mit der Drangabe seiner\nganzen menschlichen Existenz predigt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wegen mir braucht ihr keine Angst zu haben,« sagt er, als er\nvor den ihm nachstellenden Gendarmen fliehen muß, »ein winziges\nStäubchen bin ich nur, ein Halm vom reichen Feld; nimmt man mich\nund bringt mich ins Verderben, so schadet es nichts, denn es\nbleiben noch viele solche und jeder ist bereit, auf gleiche Weise\nsein Leben der Sache zu opfern ... Und kommt die Zeit, dann werden\nTausende von ihnen auftauchen; sie werden aus den Städten und aus\nden Bauernhütten kommen und aus den Herrenhöfen auch, in einer\nendlosen Reihe werden sie kommen und werden ihre Köpfe hingeben und\nihr Blut fließen lassen und werden einer nach dem anderen fallen,\nsich wie Steine häufend, bis aus ihnen die heilige, ersehnte Kirche\naufgebaut wird ... Und ich sage es euch, daß sie erbaut wird und\nbis in alle Ewigkeiten stehenbleibt, und keine böse Macht wird sie\nüberwinden können, denn sie wird aus Blutopfern und Liebe entstehen\n...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Was die Jungen von den Alten schon bei Reymont vorzüglich\nunterscheidet, ist ein aggressiver Zug ihres Wesens, der sich nach\nallen Richtungen hin bemerkbar macht. Die Alten sind in ihrer\nErdgebundenheit gleich Mensch gewordenen Ackerbaufunktionen, die\nsich nur elementar betätigen, ohne über den engen Kreis ihres\nTagwerks hinauszugehen, sie handeln und empfinden kommunistisch aus\nInstinkt, während die Jüngeren schon die Macht der sozialen\nZusammenhänge ahnen und bewußt an rasseeigentümliche Anfänge\nanknüpfen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page34",
      "title": "lac/DaoH"
    }
  }), _vm._v(" Über das\nUreigene der polnischen Volkspsyche bieten die vielfachen alten\nSitten und Bräuche, die von Reymont eingehend geschildert werden,\nreichen Aufschluß. Vorchristliche Überlieferungen lassen sich\nallerdings schwerlich in reinem Zustande finden, sie sind in einer\nMenge von Bräuchen enthalten, die die Kirche ihren Zwecken\ndienstbar gemacht hat und die darum, trotz ihres heidnischen\nUrsprungs, wie z. B. gewisse Ostergebräuche, das Fest der\nKräuter-Muttergottes, die festlichen Umzüge mit Kirchenfahnen durch\ndie Felder und das Eingraben von geweihten Evangelien und Kränzlein\nan den Feldgrenzen, der Kult der Toten am Allerseelentag u. v. a.\ndoch eine stark katholische Färbung erhalten haben. Mehr noch tritt\ndie besondere Eigenart der Volkspsyche dort hervor, wo das Volk die\nRanken einer selbständigen, naiven Dichtung um ein ihm geläufiges\nThema schlingt. Dafür liefern die Legenden und Geschichten, die\nRochus bei verschiedenen Gelegenheiten zum besten gibt, einen\ninteressanten Beweis (ein Meisterstück dieser Art ist die Legende\nvom Herrn Jesus und Burek seinem Hündchen, die Rochus wahrend einer\nAbendversammlung beim Kohlschälen erzählt). Auch die\ncharakteristischen Redensarten, Sprichwörter, Sinnsprüche,\nLiedlein, Festgesänge, Bauernregeln und Rätselspiele, von denen das\nReymontsche Epos eine sehr reiche Auswahl bringt, bieten eine\naußerordentlich ergiebige Ausbeute.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Als ein besonders klarer Spiegel der polnischen Volksseele muß\nin Reymonts Roman die von köstlichen Ursprünglichkeiten reich\ndurchsetzte Sprache betrachtet werden. Der Dichter hat aus der\nBauernsprache heraus ein nicht nur in Dialogen, sondern auch in der\ngesamten Ausdrucksweise zur Geltung kommendes und einzigartiges\nAusdrucksmittel neu geschaffen, das selbst im Satzbau zur Geltung\nkommt, der der etwas schwerfälligen Gedankenarbeit und dem\nlebhaften Gefühlsrhythmus des polnischen Bauernvolkes entspricht.\nSo sind die oft endlosen, von Leidenschaft fast erstickten "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page35",
      "title": "lac/DaoH"
    }
  }), _vm._v(" Perioden, die sich in\nÜberbietungen nicht genug tun können, und dann wiederum gewisse,\nsich schwer dahinschleppende Rhythmen entstanden, in denen man\nglaubt, das schlafbefangene Tasten erdgebundener Gedankengänge zu\nhören. Also auch hier die starke, zu Explosionen hinneigende\nGefühlsspannung und die tief verankerte Naturversunkenheit. Soweit\ndiese Eigentümlichkeiten übertragbar waren, sind sie in der\nvorliegenden Verdeutschung wiedergegeben worden.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "spaced"
  }, [_vm._v("Jean Paul d'Ardeschah")]), _vm._v(" "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page36",
      "title": "lac/DaoH"
    }
  })]), _vm._v(" "), _c('ol', {
    staticClass: "calibre7"
  }, [_c('li', {
    staticClass: "calibre8"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/#text1",
      "id": "foot1"
    }
  }, [_c('span', {
    staticClass: "pcalibre5 pcalibre4 footnote"
  }, [_vm._v("Pflüger.")])])]), _vm._v(" "), _c('li', {
    staticClass: "calibre8"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/#text2",
      "id": "foot2"
    }
  }, [_c('span', {
    staticClass: "pcalibre5 pcalibre4 footnote"
  }, [_vm._v("Im Jahre 1000 wurden die ersten drei\npolnischen Bistümer in Kolberg, Breslau und Krakau unter der\nerzbischöflichen Oberhoheit des Erzbischofs von Gnesen von\nMagdeburg losgetrennt.")])])])])])])
}]}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(63),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "calibre1"
  }, [_vm._v("Erster Teil. Der Herbst")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page37",
      "title": "lac/DaoH"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page38",
      "title": "Ruktz/lac"
    }
  }), _vm._v(" Gelobt sei Jesus Christus!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»In Ewigkeit Amen! beste Agathe, und wohin wandert ihr denn,\nwas?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»In die Welt, zu den Menschen, euer Liebden, in die weite Welt!\n...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie zog mit dem Stecken einen Bogen von Osten nach Westen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Der Priester schaute unbewußt in jene Ferne und senkte rasch die\nAugen, denn über dem Westen hing die blendende Sonne; dann fragte\ner stiller, wie ängstlich fast ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Haben die Klembs euch fortgetrieben, was? Oder habt ihr euch\nnur gezankt? ... Vielleicht ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie antwortete nicht gleich, reckte sich etwas und ließ die\nalten verbleichten Augen schwer über die herbstlichen, leeren\nFelder und die Dächer des Dorfes schweifen, das in Obstgärten\ngetaucht ruhte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»I nee, nee ... rausgejagt ... nee, wie sollten sie denn. Sind\ndoch ganz gute Leute, Verwandte. War auch kein Zank nicht da./Man\nmerkt nur selber so, daß es Zeit ist, in die Welt fort./Vom fremden\nWagen muß der Mensch 'runter wenn es Zeit ist, selbst ins\nWasser.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Man mußte ... sie hatten schon keine Arbeit mehr für mich ... es\ngeht nach dem Winter, wie kann man denn da/umsonst sollen sie das\nEssen geben und die Ecke fürs Schlafen? ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und weil sie doch auch gerade das Kalb, den kleinen Bullen,\nentwöhnt haben ... und bei den kalten Nächten müssen auch die\nGänschen 'rein/da hab' ich Platz gemacht, was soll man denn anders,\nis doch schade ums schöne Vieh, sind auch Gottesgeschöpfe ... Die\nLeute sind gut, nehmen mich doch für den Sommer ins Haus und gönnen\nmir meine Ecke und mein Essen/so daß der Mensch wie eine Hofbäuerin\nherumparadiert ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und für den Winter/viel brauch' ich ja nicht/da muß man schon\nbitten gehen. Auf dem Bettel geben einem die "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page39",
      "title": "Monne3/lac"
    }
  }), _vm._v(" guten Leute schon was, und bis zum\nFrühjahr werde ich mich mit unseres Herrn Jesu Hilfe durchwürgen.\n'n paar Groschen spart man sich auch noch über/das ist dann für\nmeine Leute, auf die Vorerntezeit ... von wegen der\nVerwandtschaft.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und das süße Jesuskind wird die Armut schon nicht\nverlassen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Nein, das wird er nicht,« rief der Priester mit Wärme und\ndrückte ihr ein blankes Fünfzehnkopekenstück in die Faust.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hochwürden, unser lieber Hochwürden!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie beugte sich, daß ihr zittriger Kopf seine Knie berührte, und\ndie Tränen kollerten wie Erbsen über ihr greises, wie Herbstäcker\nzerfurchtes Gesicht.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Geht nur mit Gott/geht nur,« murmelte er bekümmert und richtete\nsie auf.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie sammelte mit zitternden Händen die Bettelsäcke, den Stecken\nmit der Igelspitze, bekreuzigte sich und ging über den breiten\nausgefahrenen Weg in der Richtung des Waldes davon; doch immer\nwieder blickte sie sich um nach dem Dorf, nach den Feldern, auf\ndenen man Kartoffeln grub, nach dem Rauch der Hirtenfeuer, der\ndicht über den Stoppelfeldern hinkroch, und immer wieder blickte\nsie traurig zurück bis sie zuletzt hinter den Büschen am Wege\nverschwand.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Der Priester kehrte auf seinen alten Platz zwischen die Räder\nder Pflugkarre zurück, langte nach einer Prise und schlug das\nBrevier auf, doch seine Augen glitten von den roten Lettern ab und\nliefen über die weiten, von herbstlicher Versonnenheit umfangenen\nLande, schweiften über den blassen Himmel und machten dann bei\neinem Knecht halt, der über einen Pflug gebeugt ging.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Walek ... die Furche ist schief ... täh ...« schrie er und\nlupfte leicht vom Sitz. Schritt für Schritt folgte er nun mit den\nAugen dem runden Schimmelpaar, das den knirschenden Pflug zog.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Dann fing er wieder unbewußt an, die roten Lettern des "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page40",
      "title": "Monne3/lac"
    }
  }), _vm._v(" Breviers zu\ndurchlaufen und die Lippen murmelnd zu bewegen. Doch die Augen\nwaren immer wieder hinter den Schimmeln her und beobachteten die\nKrähen, die mit behutsam vorgestreckten Schnäbeln in der\nAckerfurche hüpften und bei jedem Peitschenhieb und jeder Wendung\ndes Pfluges schwer aufflatterten, um gleich wieder auf den Acker\nzurückzufallen und die Schnäbel an den harten trockenen Schollen zu\nwetzen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»He, Walek! lang' er ihr mal eine über die Pantalons, die Rechte\nzieht nicht!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Er schmunzelte heimlich, da die Rechte nach dem Peitschenhieb\nihre Pflicht tat. Als die Pferde wieder an den Weg herangekommen\nwaren, erhob er sich eilig und klopfte ihnen wohlwollend den\nNacken, so daß sie die Nüstern nach ihm reckten und\nfreundschaftlich sein Gesicht beschnupperten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Heeet aa!« rief Walek mit singender Stimme, er zog die silbrig\nblinkende Pflugschar aus der Erde, hob sie etwas hoch, riß die\nPferdeleine an, so daß die Gäule einen kurzen Bogen machten, stieß\nden blanken Sieck in das Stoppelfeld und schwang die Peitsche; die\nPferde ruckten an, daß die Ortscheite quarrten. Und er pflügte\nweiter, das weite Gelände hinab, das im geraden Winkel vom Weg\nabfiel und als ein langer Zug leinwandgrauer Schollen sich zum tief\ngelagerten Dorf hin reckte, welches wie versunken lag in rötlichen\nund goldenen Obstgärten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Luft war still, warm und etwas schläfernd.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Obgleich es schon gegen Ende September war, wärmte die Sonne\nnicht schlecht; sie schwebte über den Wäldern auf der Hälfte des\nWeges zwischen Süden und Westen, doch legten sich schon nächtlich\nkühle Schatten um die Knicks, um die Steinhaufen, um die harten\ntrockenen Ackerkrumen und unter die Birnbäume auf den Feldern.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Über den verlassenen Fluren lag Stille und eine berauschende\nSüße war in der von Sonnendunst gedämpften Luft; im hohen, blassen\nblauen Himmel lagen hier und da "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page41",
      "title": "Monne3/lac"
    }
  }), _vm._v(" gewaltige weiße Wolken verstreut, wie\nSchneewälle, die von Winden aufgeballt und zerfetzt waren.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und unter diesen Wolken, soweit das Auge reichen konnte, ruhte\ngraues Ackerland/eine riesige Schale mit eingekerbtem Rand\nbläulicher Wälder, durch die gleich silbernen, in der Sonne\naufflirrenden Gespinsten der Fluß mit seinen Windungen zwischen\nErlen und Uferweiden hervorblitzte. Er staute sich mitten im Dorf\nzu einem großen länglichen Weiher und lief nach Norden durch eine\nSchlucht zwischen den Hügeln; im Talkessel rund um den Weiher\nlagerte sich das im Sonnenschein schillernde Dorf in der Pracht\nseiner herbstlich bunten Baumwipfel, gleich einer rotgelben\nzusammengerollten Raupe auf einem grauen Lattichblatt. Lange Gewebe\netwas wirrer Ackerhufen, Plantücher grauer Felder mit Schnüren von\nRainen voll Steinhaufen und Schlehdornbüschen streckten sich vom\nDorf bis zu den Wäldern. Hin und wieder nur ergossen sich Rinnsale\nvon Gold in das silbrige Grau/Lupinenfelder breiteten ihre gelben\nFlächen voll duftender Blumen, ausgedörrte Strombetten entblößten\nihre weißlichen Sandgründe und müde lagen die sandigen Wege.\nMächtige Pappeln stiegen in Reihen an ihren Rändern langsam die\nHügel empor den fernen Wäldern zu.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Der Priester erwachte aus seiner Versunkenheit, denn ein langes,\nklagendes Brüllen ertönte dicht bei ihm. Schreiend flogen die\nKrähen auf und flügelten schräg zum Kartoffelland hinüber und ein\nschwarzer Schatten huschte ihnen tief unten nach, über Äcker und\nBrachen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Der Priester schützte seine Augen mit der Hand und schaute\nsonnenwärts/ein Mädchen, das eine große, rotbraune Kuh am Seil\nführte, ging auf dem Weg vorüber, der vom Walde kam; sie bot Gott\nzum Gruß, drehte zum Priester hin und wollte ihm die Hand küssen,\naber die Kuh riß sie heftig weg und fing wieder an zu brüllen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Geht sie zum Verkauf, was?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page42",
      "title": "Monne3/lac"
    }
  }), _vm._v(" »Nii ...\nzum Müller seinen Bullen ... halt' still, Pestige ... verrücktes\nVieh!« schrie sie nach Atem ringend und versuchte sich\nentgegenzustemmen, aber die Kuh riß sie mit, bis sie beide\ndahinstoben, was die Lenden hielten und in einer Staubwolke\nverschwanden.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Danach schleppte sich schwer über den Sandweg der Lumpenjude; ab\nund zu kuschelte er sich hin und ächzte schwer, denn die Karre war\nvollgeladen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Was gibt's Neues, Mäusche?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Was soll's geben? ... Wem's gut geht, bei dem gibt's gut ... De\nKartoffeln sind, Gott Dank, geraten, der Roggen gibt was her, Kohl\nwird auch da sein. Wer Roggen hat, wer Kohl hat, wer de Kartoffeln\nhat/bei dem gibt's gut!« Er küßte den Ärmel des Priesterrocks,\nlegte sich in die Gurten der Karre und schob bedächtig weiter, denn\nder Weg führte schon über ein leichtes Gefäll hinab.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Dann kam mittwegs, im aufgewirbelten Staub, den er mit seinen\nFüßen aufstieben machte, ein blinder Bettler daher, geführt von\neiner dicken, an einem Bindfaden vertäuten Töle.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Dann wieder rannte von der Waldseite her ein Junge mit einer\nFlasche, der beim Anblick des Priesters am Wegrand in einem großen\nBogen um diesen herum querfeldein zur Schenke lief.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Ein Bauer aus dem Nachbardorf fuhr zur Mühle und eine Jüdin\ntrieb eine Herde gekaufter Gänse vorüber.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Jeder bot Gott zum Gruß, wechselte ein paar Worte und ging\nseines Wegs, begleitet vom wohlwollenden Wort und Blick des\nPriesters, der, da die Sonne schon tief stand, sich erhob und\nseinem Knecht zurief:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Bis zu den Birken pflügen, Walek, und dann nach Haus, ... sonst\nstrapazieren wir die Pferde zu viel.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Gemächlich ging er über die Feldraine, sprach halblaut das\nGebet, und umfaßte mit einem klaren Blick voll Liebe das Land\n...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page43",
      "title": "Teledahner/lac"
    }
  }), _vm._v(" ...\nReihen roter Frauenröcke leuchteten über dem Kartoffelacker auf ...\ndas Kollern der eingeschütteten Kartoffeln gegen die Wagenbretter\nwurde hörbar ... stellenweise pflügte man noch für die Wintersaat\n... Herden buntscheckiger Kühe weideten auf dem Brachland ... und\nlange aschfarbene Saatenfelder begannen sich rostrot mit dem\nsprießenden Getreide zu färben ... Auf den dürren verschossenen\nWiesen aber schimmerten Gänse, wie weiße Schneeflecken. Irgendwo\nmuhte eine Kuh ... Es brannten Feldfeuer und lange blaue\nRauchsträhnen zogen über die Erde hin ... Hin und wieder wurde\nWagengeroll hörbar, oder ein Pflug knirschte gegen Steine an. Dann\nwiederum umfing auf einen Augenblick Stille das Land, daß man das\nhohle Gurgeln des Stromes und das Rollen der Mühle hörte, die sich\nhinter dem Dorf im Dickicht der herbstlichen Bäume versteckte ...\nEin Liedchen flog auf, wie ein Ruf von irgendwo, flatterte tief\nüber die Rillen und Furchen und sank ohne Widerhall im\nHerbstdämmer, auf spinnwebgebundene Stoppeln, an öden Wegen, wo die\nEbereschen die blutigen schweren Köpfe neigten. Man eggte einen\nAckerstreifen und ein Schweif hundertjährigen mürben Staubes hob\nsich hinter den Eggen auf, zog sich in die Länge hügelan, und\nsenkte sich. Unter ihm kam, wie aus einer Wolke, ein barfüßiger\nBauer hervor, mit bloßem Kopf und einem quer über den Leib\ngebundenen Schurz. Er ging langsam, schöpfte Korn aus dem Leintuch\nund säete mit eintöniger, andachtsvoller, segenspendender Gebärde.\nBis an den Feldrand kam er, füllte nach aus einem Sack, kehrte um\nund schritt hügelan ... zuerst tauchte sein zerzauster Kopf auf,\ndann seine Schultern und schließlich ward er ganz sichtbar auf dem\nSonnenhintergrund mit seiner segnenden Bewegung des Säemanns; mit\ndem immer gleichen heiligen Wurf schleuderte er das Korn, das\nwirbelnd, wie goldener Staubregen, in die Erde fiel.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Der Priester ging immer langsamer, zuweilen blieb er "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page44",
      "title": "Wunibald/DaoH"
    }
  }), _vm._v(" stehen, um Atem\nzu schöpfen, dann blickte er sich nach seinen Schimmeln um, und sah\nden Jungen zu, die mit Steinen nach einem gewaltigen Birnbaum\nwarfen, bis sie allesamt zu ihm hingelaufen kamen, die Hände hinter\ndem Rücken versteckend, um seinen Rockärmel zu küssen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Er strich ihnen über die Köpfe und ermahnte: »Brecht nur nicht\ndie Äste ab, sonst gibt's nächstes Jahr keine Birnen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wir werfen nicht wegen den Birnen, aber da is 'n Krähennest,«\nließ sich ein Dreisterer vernehmen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Gütig lächelnd nickte er und blieb gleich wieder bei den\nKartoffeln ausnehmenden Leuten stehen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Der Herr segne die Arbeit!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Vergelt's Gott, wir danken schön!« antworteten sie zugleich,\nindem sie sich emporreckten und sich alle in Bewegung setzten, um\ndie Hände des lieben Hochwürden zu küssen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Der liebe Gott hat dieses Jahr schöne Kartoffeln wachsen\nlassen, was?« sprach er und streckte den Männern die geöffnete\nTabaksdose hin; sie nahmen gewissenhaft und ehrerbietig in kleinen\nPrisen, ohne zu wagen, in seiner Gegenwart zu schnupfen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Stimmt, groß wie Katzenköpfe sind sie und viele unter dem\nBusch.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Na, dann werden die Schweine teuer werden, denn jeder wird\nmästen wollen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Sind auch so teuer genug; im Sommer sind sie an der Seuche\nwegkrepiert und auch nach Preußen kauft man viel.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ist schon wahr. Wem gehören die Kartoffeln hier?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Boryna seine.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Den Bauern seh' ich nicht, da hab' ich ihn halt nicht aus dem\nHaufen erkannt.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Vater und Meiner sind in den Wald gefahren.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ach, das seid ihr, Anna, na, wie macht es sich?« wandte er sich\nzu der jungen schmucken Frau im Kopftuch, die, da ihre Hand mit\nErde beschmutzt war, mit der Schürze nach seiner langte, um sie\nauch zu küssen. "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page45",
      "title": "Wunibald/lac"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wie geht es denn euerm Jungen, den ich zur Erntezeit getauft\nhabe?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gott Lob und Dank, er wächst auf, Hochwürden, er fängt schon\nan, herumzukrabbeln.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Nu, dann ... Grüß Gott!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Schönen Dank.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Er wandte sich nach rechts dem Friedhof zu, der noch diesseits\ndes Dorfes am Pappelweg lag.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie sahen noch lange schweigend seiner leicht gebeugt\ndahinschreitenden geschmeidigen Gestalt nach, und ihre Jungen\nlösten sich erst, als er hinter die niedrige steinerne\nKirchhofsmauer einbog, zwischen Grabhügeln der Kapelle\nzuschreitend, die inmitten blaßgelber Birken und roter Ahorne\nstand.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Einen Besseren gibt's wohl nicht in der ganzen Welt,« fing eine\nder Weiber an.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Is wahr, nach der Stadt wollten sie ihn schon haben. Wenn Vater\nund der Schulzen nicht um ihn bis zum Bischof gewesen wären, hatten\nmer'n auch nicht mehr ... Hackt man zu, Leute, bis Feierabend ist\nnicht mehr lange und Kartoffeln noch genug,« sagte Anna, indem sie\nihren Korb auf einen hellen Kartoffelhaufen leerte, der aus der\nzerwühlten Erde voll trockener Kartoffelstrünke aufragte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie griffen flink und schweigend zu, so daß man nur das Picken\nder Hacken auf der Erdkruste und zuweilen das Aufschlagen des\nEisens gegen einen Kiesel hörte. Ab und zu reckte einer oder der\nandere den gebückten, schmerzenden Rücken, atmete tief auf und sah\nstumpf dem Saemann im Nachbarfeld zu, grub dann weiter und las die\ngelben Kartoffeln vom grauen Boden auf, die er in den nebenan\nstehenden Korb warf.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Es war vielleicht ein Dutz Leute, meist alte Weiber und/ Kätner.\nHinter ihnen, an zwei gekreuzten Holzgestellen hingen in geknoteten\nweißen Leinentüchern ein paar kleine Kinder, die ab und zu\ngreinten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page46",
      "title": "joe_ebc/lac"
    }
  }), _vm._v(" »Die Alte\nis nu doch in die Welt gegangen,« leitete die Gusche ein.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wer denn?« fragte Anna, sich erhebend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Die alte Agathe doch ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Auf den Bettel ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Jawoll, auf den Bettel! Hale, wohl nicht zum Spaß. Hat den\nVerwandten die Arbeit gemacht, sich den Sommer über geschunden/nu\nkann sie die frische Luft besehen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Zum Frühjahr kommt sie schon heim, dann bringt sie ihnen in den\nHungersäckelchen Zucker und chinesischen Tee, auch'n paar Groschen\nhat sie dann noch über/gleich werden sie sie dann lieben, lassen\nsie im eignen Bett unter den Daunen schlafen, für die Arbeit ist\nsie dann zu gut, sie braucht Ruhe ... Base und Tante sagen sie ihr\ndann, bis sie ihr den letzten Notgroschen abgetrieben haben ... Im\nHerbst aber da gibt's keinen Platz mehr, nich im Flur und nich im\nSchweinstall. Verdammtes Aaszeug, Hundeverwandtschaft!« spie sie\nhervor und eine solche Wut überkam sie, daß ihr Gesicht blau\nanlief.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich mein' schon, dem Armen weht der Wind immer in die Augen,«\npflichtete einer der Kätner bei, ein alter, ausgemergelter Bauer\nmit einem schiefen Mund.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hackt man zu, Leute, hackt man zu,« trieb Anna wieder an, mit\nder Wendung, die das Gespräch nahm, nicht zufrieden.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Gusche, die nicht lange aushalten konnte ohne herumzuschwatzen,\nsagte, nach einem unweit stehenden Burschen hinüberblickend:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Die beiden Patschesjungen, das sind schon reichlich alte\nBurschen, die Zotteln fangen schon an, ihnen zu sprießen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und immer noch Junggesellen,« meinte eine andere.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und so viele Mädchen werden alt, oder müssen in den Dienst\n...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Is wahr, und haben doch 'ne ganze halbe Huf' und die kleine\nWiese hinter der Mühle dazu.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page47",
      "title": "halei/gary"
    }
  }), _vm._v(" »Jawohl,\naber wird sie sie heiraten lassen, die Alte ... läßt sie sie mal\nlocker? ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Wer würde da die Kühe melken oder die Wäsche spülen, wer würde\ndie Wirtschaft besorgen und auf die Schweinchen passen ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Mutter muß um ihre Jagna hantieren/die spielt doch schon das\nreine gnädige Fräulein, 'ne richtige Gutstochter, immer nur putzen\ntut sie sich und waschen und sich im Spiegel angaffen, oder die\nZöpfe flechten.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und paßt nur auf, wen sie sich unters Federbett holt, ob er\nauch stark genug ist!« fügte Gusche mit einem bösen Lächeln\nbei.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Jusek Bandcha schickte schon mit Schnaps zu ihr/sie wollte ihn\nnicht.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Guck einer/die verdammte Marjell!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und die Alsch sitzt den halben Tag in der Kirche, betet aus dem\nGebetbuch und tut von Dorf zu Dorf auf Ablaß gehen, wo es nur\nKirchweih gibt.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Is schon so, aber 'ne Hexe is sie auch; und Wawschjons Kühen,\nwer hat ihnen die Milch genommen, was? Und als sie Johannes sein'\nJungen beim Pflaumenstehlen erwischt hat, hat sie ihm ein solches\nWort gesagt, daß ihm der Weichselzopf gewachsen ist und alle\nGlieder sind ihm krumm geworden, du lieber Gott!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und da soll Gottes Segen über dem Volk sein, wenn solche im\nDorf sitzen ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und damals, als ich noch Väterchens Kühe hütete, da mein' ich,\nhat man solche zum Dorf rausgejagt,« gab Gusche bei.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Den zweien passiert schon kein Unrecht nicht, die haben schon\nwelche, die es mit ihnen halten ...,« und die Stimme zum Flüsterton\ndämpfend, indem sie nach Anna schielte, die vornbei in der ersten\nFurche hackte, tuschelte sie ihren Nachbarinnen zu:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Der erste dazu, wäre wohl der Anna ihrer, sagt man ... der ist\nhinter der Jagna her, wie 'n Hund in seiner Zeit ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page48",
      "title": "halei/gary"
    }
  }), _vm._v("\n»Jeses/Jeses ... was ihr nicht sagt ... wäre doch die reine Sünd'\nund Schand' ...« tuschelten sie beieinander, ohne die Köpfe dabei\nzu erheben und emsig weitergrabend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ist er denn der einzige ... wie einer Hündin laufen sie ihr\nnach.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Schön ist sie, das muß ihr der Neid lassen: und fein rund wie\neine Färse, und die schöne weiße Fratze ... die Augen sind akk'rat\nwie Flachsblumen ... und solche Kraft hat sie, daß manch' ein Kerl\nnicht gegen ankann ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie schwiegen eine lange Weile, denn sie mußten die Kartoffeln\nauf einen Haufen schütten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Darauf redeten sie hin und wieder nur ein paar Worte mehr und\nschwiegen ganz, als eine von ihnen gewahr wurde, daß vom Dorf her\nBorynas Fine über das Stoppelfeld gelaufen kam.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie war es tatsächlich und kam schon von weitem schreiend\natemlos angerannt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Anna, kommt schnell nach Haus, der Kuh ist was.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Jesus Maria/welche denn? ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Die Bunte! ... die Bunte! ... ich kann kaum atmen ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Mein Gott, ich hab' mich ganz verfahren, ich dachte meine,«\nrief Anna erleichtert.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Eben erst hat Witek sie eingetrieben; der Heger hat sie aus dem\nWald gejagt. Ganz verbiestert war sie, sie ist ja so dick ... beim\nKuhstall ist sie gleich umgefallen, nicht mal trinken will sie,\nfressen auch nicht, sie wälzt sich hin und her und brüllt immerzu,\ndaß Gott erbarm'!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Is' Vater nicht da?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Näh, Vaterchen ist noch nicht zurückgekommen. O Jesus, mein\nJesus, so eine Kuh, die auf einmal gut ein Liter Milch gegeben hat.\nKommt doch man schnell.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich flieg schon ..., in einem Nu.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie riß das Kind aus dem Leinentuch, stülpte ihm die\nQuastenmütze über, wickelte es in die Schürze und eilte rasch\n"), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page49",
      "title": "halei/gary"
    }
  }), _vm._v(" fort. Sie war\nso verstört durch diese Nachricht, daß sie nicht einmal den\nBeiderwandrock herunterzog, daran dachte sie ganz und gar nicht,\nund ihre bis an die Knie bloßen Beine schimmerten weiß gegen den\ndunklen Acker. Fine lief voraus.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Indessen schoben sich die kartoffelgrabenden Leute, jeder\nbreitbeinig über seiner Furche langsam vorwärts und hackten\nbedächtiger, denn niemand trieb sie und niemand drängte sie.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Sonne rollte schon dem Erdenrande zu, und wie erhitzt vom\nraschen Lauf, erglühte sie zu einer purpurnen Radscheibe und sank\nin die hohen schwarzen Wälder. Die Dämmerung stieg empor und kroch\nüber die Felder; sie schob sich durch die Furchen heran, hockte in\nden Gräben, staute sich im Dickicht an und ergoß sich leise über\ndie Erde, da dämpften sich die Farben und erloschen, nur die\nSchöpfe der Bäume, die Türme und Dächer der Kirche flammten noch\nglühend. Es zogen schon einige von den Feldern heim.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und Menschenstimmen, Wiehern, Gebrüll, Wagengeratter klangen\nimmer schärfer durch die stille dämmerumfangene Luft.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Mit erzenem Gezwitscher begann die Betglocke der Kirche das Ave\neinzuläuten; die Menschen blieben stehen und das Murmeln der Gebete\nsank, wie welke Blätter, in die Dämmerung.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Unter Gesang und frohen Zurufen wurde das Vieh von den Weiden\ngetrieben; es kam dichtgedrängt in Herden, von Staubwolken\neingehüllt, so daß nur hin und wieder gewaltige Köpfe und\nbreitgegabelte Hörner sichtbar waren.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Hier und da blökten ein paar Schafe, vom Weideland flatterten\nGänsescharen auf ins Abendrot und ihr durchdringender Schrei\nertönte aus der Luft.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wär' doch man schade um die Kuh; was die kalbte!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Na ja ... einen Armen hat es nicht getroffen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Immerhin schade, daß so 'n statiöses Vieh so elendiglich\numkommen muß.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page50",
      "title": "halei/gary"
    }
  }), _vm._v(" »Keine\nHausfrau hat Boryna, da sackt alles weg wie durch ein Sieb.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und Anna, ist denn die keine?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Für sich selbst ... wie zur Miete sitzen die bei dem Vater, und\ndaß die nur drauf lauern, was in ihre Tasche fällt, kannst du\ndenken, und das Väterliche, da kann der Hund für aufkommen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und Fine, so 'n Kiekindiewelt, was kann die dabei?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Na aber, könnte denn auch der Boryna nicht seinen Hof dem Antek\nabgeben, ah?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und selbst soll er zu ihnen auf den Altenteil, wie? ... Alt\nseid ihr, Laurenz, und noch immer dumm bis in die Klamotten,«\nbegann Gusche lebhaft. »Hoho, der alte Boryna, der stellt noch\nseinen Mann; der kann sich noch verheiraten. Dumm wäre er, wenn er\nwas seinen Kindern abschriebe.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Na ja ...a, kräftig is er schon, aber sechzig Jahre.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Brauchst keine Angst zu haben, Laurenz, jede Junge nimmt den,\nlaß ihn nur ein Wort sagen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Zwei Frauen hat er schon begraben.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Laß ihn auch die dritte mit Gottes Hilfe begraben, aber den\nKindern, solange er lebt ... kein Stückchen, keinen Fetzen, nicht\nmal so viel, wie einer unter dem Pantoffel hat. Aaspack, dem käm's,\nwie meine mir. Einen Altenteil würden sie ihm geben, auf Arbeit\nkönnte er dann gehen, verhungern oder den Bettelstock nehmen. Gib's\nnur her, was du hast, deinen Kindern, die werden's dir schon\nvergelten, das reicht dann für ein Stricklein, oder für 'n Stein um\nden Hals ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Nach Hause, Leute, 's wird schon dunkel.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Jaja, und die Sonne ist auch weg.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie sammelten rasch die Hacken und Körbe, nahmen ihre\nZweiertöpfe auf, die vom Mittagsessen noch da waren, und gingen im\nGänsemarsch miteinander redend den Feldrain entlang; nur die alte\nGusche schrie immer noch wütend "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page51",
      "title": "halei/gary"
    }
  }), _vm._v(" über ihre Kinder und fluchte zu guter Letzt auf\ndie ganze Welt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Neben ihnen im gleichen Schritt trieb ein Mädchen eine Sau mit\nihren Ferkeln und sang mit dünnem Stimmchen:")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Aj, geh nicht um den Wagen,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nAj, halt dich nicht ans Rad,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nAj, gib dem Mann kein Küßlein,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nAj, wenn er selbst gebeten hat.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Tä, Dumme, schreit, als ob man ihr die Haut abschälte.«")]), _vm._v(" "), _c('p', {
    staticClass: "pcalibre6 initial1"
  }, [_vm._v("Auf Borynas Hof, der von drei\nSeiten mit Wirtschaftsgebäuden umstellt war und den von der vierten\nein Obstgarten von der Dorfstraße trennte, hatte sich schon viel\nVolk angesammelt; ein paar Weiber beratschlagten und gestikulierten\nwegen einer gewaltigen rotweißen Kuh, die auf einem Misthaufen vor\ndem Kuhstall lag.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Ein alter, etwas lahmer Hund mit glatzigen Flanken umkreiste die\nBunte, beroch sie und bellte. Dann jagte er die Kinder, die\nneugierig am Zaun hingen, von der Einfahrt zwischen die Hecken\nzurück und versuchte sich an eine Sau heranzupirschen, die sich an\ndie Wand des Wohnhauses lang ausgestreckt hingelegt hatte und leise\nstöhnte, denn die jungen, weißen Ferkel sogen an ihr.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Gerade stürzte Anna atemlos heran, warf sich auf die Kuh und\nfing an, ihren Kopf und ihr Maul zu streicheln.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Bunte, arme Bunte!« rief sie weinerlich und brach in ein\nSchluchzen und Wehklagen aus.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Frauen aber beratschlagten immer wieder über neue\nRettungsversuche für die Kranke; einmal goß man ihr Salzlauge in\nden Hals, dann geschmolzenes Wachs von einer geweihten Kerze in\nMilch zerlassen; eine riet Molken mit grüner Seife/eine andere\nschrie, daß man sie zur Ader lassen "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page52",
      "title": "halei/gary"
    }
  }), _vm._v(" sollte/doch der Kuh wollte nichts helfen,\nsie streckte sich immer länger, hob nur von Zeit zu Zeit den Kopf\nhoch und brüllte gedehnt und schmerzlich, wie nach Rettung; ihre\nschönen, rosig umrandeten Augen begannen sich neblig zu trüben und\nder schwere gehörnte Kopf fiel zurück vor Ermattung. Sie streckte\ndie Zunge aus und leckte Annas Hände.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Vielleicht würde Ambrosius helfen?« schlug eine vor.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hast recht, der kennt sich auf Krankheit aus,« bestätigte\nman.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Lauf, Fine. Soeben haben sie das Ave ausgeläutet, da muß er\nnoch bei der Kirche sein. Herr, du meine Güte, wenn Vater kommt,\nwird das ein Fluchen werden. Wir haben aber doch keine Schuld,«\nklagte sie weinerlich.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Dann setzte sie sich auf die Schwelle des Kuhstalls, streckte\ndem plärrenden Jungen die weiße volle Brust hin und blickte mit\nschreckhafter Angst bald auf die röchelnde Kuh, bald aufhorchend\nauf den Weg zwischen den Hecken.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("In der Dauer von ein bis zwei Paternostern kam Fine mit Geschrei\nzurück/Ambrosius käme schon.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und wirklich kam er gleich hinterdrein, ein vielleicht\nhundertjähriger Alter, gerade wie eine Kerze, obgleich er einen\nStelzfuß hatte und am Stocke ging. Sein Gesicht war trocken und\nrunzlig wie eine Kartoffel im Frühjahr und von derselben grauen\nFarbe. Es war glatt ausrasiert und voller Hiebnarben. Sein Haar war\nmilchweiß und fiel in Strähnen auf Stirn und Nacken, denn er kam\nbloßköpfig daher.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Er trat geradewegs auf die Kuh zu und besah sie sich\neingehend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Oho, ich seh schon, daß ihr frisches Fleisch kriegt.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Helft ihr man, kuriert sie doch, die Kuh ist ja die dreihundert\nSilberlinge wert/und eben erst nach dem Kalben, helft doch.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Oh Jesus/Jesus!« rief Fine.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page53",
      "title": "Frank_9901/gary"
    }
  }), _vm._v("\nAmbrosius holte aus der Tasche ein Aderlaßmesser, wetzte es am\nStiefelschaft, hielt die Spitze gegen das Abendlicht und\ndurchschnitt der Bunten die Arterien unter dem Bauch / aber das\nBlut spritzte nicht, es trat nur langsam, schwarz und schaumig\nhervor.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie standen alle vorgebeugt ringsherum und sahen mit verhaltenem\nAtem zu.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Zu spät! Oho, das Viecherl läßt schon den letzten Atem von\nsich,« sagte Ambrosius mit Feierlichkeit. »Das ist gewiß die böse\nSeuche oder etwas anderes ... man sollte gleich, wie sie krank\nwurde ... aber diese Frauenzimmer, die haben nur den Verstand zum\nWeinen, das Aaszeug, wenn man helfen soll, dann blöken sie, wie die\nSchafe.« Er spuckte verächtlich aus, ging um die Kuh herum, sah ihr\nin die Augen, betrachtete die Junge, wischte die blutigen Hände an\nihrem weichen glänzenden Fell ab und schickte sich an,\nfortzugehen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Zu diesem Begräbnis werde ich euch nicht läuten; das Geläut\nmacht ihr schon selbst mit den Pötten.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Der Vater und Antek!« rief Fine und rannte auf den Weg hinaus\nihnen entgegen, denn ein dumpfes, schweres Rollen ließ sich von der\nanderen Seite des Weihers her vernehmen, wo in dem vom Abendlicht\nrotleuchtenden Staub ein länglicher, mit ein paar Pferden\nbespannter Wagen sichtbar wurde.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Vater, da ... die Bunte tut verrecken!« Boryna bog gerade mit\ndem Wagen um den Weiher; Antek schob hinten nach, denn sie hatten\neine lange Fichte aufgeladen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Red' nicht Unnützes,« brummte er, die Pferde antreibend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ambrosius hat sie zur Ader gelassen und gar nichts ...\ngeschmolzenes Wachs hat man ihr in die Gurgel gegossen, auch nichts\n... und Salz ... und alles nichts ... das ist gewiß die schlimme\nSeuche ... Witek sagte, der Heger hat sie aus dem Weidewald gejagt,\nund die Bunte hätte sich immer hingelegt und gestöhnt, bis er sie\nhergekriegt hat ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page54",
      "title": "Frank_9901/gary"
    }
  }), _vm._v(" »Die\nBunte, die beste Kuh, daß ihr die Kränke kriegt, Saupack,\nverdammtes, so wird hier aufgepaßt«; er warf dem Sohn die Zügel hin\nund lief mit der Peitsche in der Hand voraus.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Weiber traten auseinander, und Witek, der die ganze Zeitlang\nvor dem Wohnhaus an irgend etwas herumgebastelt hatte, sprang aus\nlauter Angst davon und verschwand im Garten, selbst Anna erhob sich\nund stand ratlos und verängstigt da.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Zuschanden haben sie mir das Tier gemacht,« ... rief der Bauer\nschließlich aus, nachdem er die Kuh besichtigt hatte! »Dreihundert\nSilberlinge rein in den Dreck geschmissen!/ Zum Fressen da sind die\nBiester da, die ganze Stube voll, aber Obacht geben, das gibt's\nnicht. So 'ne Kuh, so 'ne Kuh! Nicht aus dem Haus raus kann man,\ngleich kommt Verlust und Schaden draus ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Schon von Mittag an war ich doch beim Kartoffelausnehmen,«\nentschuldigte sich Anna leise.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wenn du doch einmal was sehen tätest!« schrie er wütend. »Aber\ngeht dich das an, was meins ist?« /")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»So 'ne Kuh, so 'n Prachtstück, 'ne zweite, wie die, könnte man\nauf dem Gutshof suchen!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Er fluchte immer erbitterter, ging um die Kuh herum, versuchte\nsie zu heben, zog sie am Schwanz, guckte ihr in die Zähne, aber das\nTier atmete röchelnd und immer mühevoller, selbst das Blut hörte\nauf zu fließen und gerann langsam zu schwarzen, krustigen\nSchlacken/sie lag augenscheinlich schon in den letzten Zügen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Nichts zu machen, man muß sie notschlachten, wenigstens das\n'rausschlagen!« sagte er schließlich, holte eine Sense aus der\nScheune, wetzte sie schnell an einem Schleifstein, der unter der\nDachtraufe des Kuhstalls stand, zog seinen Spencer aus, krämpte die\nHemdsärmel hoch und machte sich ans Schlachten ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Anna und Fine heulten los, denn die Bunte erhob mühevoll den\nKopf, als ob sie den nahen Tod fühlte, brüllte "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page55",
      "title": "Frank_9901/gary"
    }
  }), _vm._v(" dumpf auf und fiel mit\ndurchschnittener Gurgel zurück, nur noch mit den Beinen strampelnd\n...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Der Hund leckte das an der Luft gerinnende Blut und sprang\ndarauf nach den Kartoffelgruben, die Pferde anbellend, die mit dem\nWagen vor der Umzäunung stehengeblieben waren. Antek hatte sie dort\ngelassen und sah gleichgültig dem Schlachten zu.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Heul' nicht, dumme Trine! Was geht uns Vaters Kuh an, ist doch\nnicht unser Verlust!« sagte er giftig zu seiner Frau und ging an\ndas Ausspannen und Abschirren der Pferde, die Witek eifrig an den\nMähnen in den Stall zerrte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Viel Kartoffeln auf dem Feld?« fragte Boryna, die Hände am\nBrunnen waschend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Weiß Gott, nicht wenig, an die zwanzig Säcke wird's wohl\nmachen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Die müssen heut noch rein.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Dann fahr' sie selbst ein, ich fühl' schon meine eigenen Füße\nnicht mehr, meinen Rücken auch nicht ... und das Handpferd lahmt\nauf dem Vorderfuß.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Fine, ruf' mal den Jakob her vom Kartoffelfeld, mag er dafür\ndas Jungpferd vorspannen, es muß heute eingefahren werden. / Es\nkann Regen geben.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Es siedete in ihm vor Wut und Ärger, und immer wieder blieb er\nvor der Kuh stehen und fluchte gallig, dann machte er sich auf dem\nHof zu schaffen, guckte in den Kuhstall, in die Scheuer, in den\nSchuppen und wußte selbst nicht, was er suchte; der Verlust fraß an\nihm.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Witek! Witek!« brüllte er mit einem Male und schnallte den\nbreiten Riemen von den Hüften los, aber der Junge blieb\nverschwunden.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Leute verzogen sich, denn sie begriffen, daß ein solcher\nSchade, eine solche Verdrießlichkeit mit Prügeln enden mußte, um so\nmehr da Boryna meist schnell damit zur Hand war, aber der Alte\nfluchte heute nur und ging in die Stube.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page56",
      "title": "gary/Pirki"
    }
  }), _vm._v(" »Anna, das\nEssen her!« herrschte er die Schwiegertochter durchs offene Fenster\nan und ging auf seine Seite.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Das Haus war ein landläufiges Bauernhaus/in der Mitte durch eine\ngroße Diele getrennt; seine Giebelseite ging auf den Hof und die\nvierfenstrige Front schaute nach dem Obstgarten und auf die\nStraße.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die eine Seite, nach dem Garten zu, nahm Boryna mit Fine ein,\nauf der anderen saß Antek und seine Frau. Der Knecht und der\nHirtenjunge schliefen bei den Pferden.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("In der Stube war es schon dämmerig, denn durch die kleinen\nFensterchen, die von der Dachtraufe beschattet wurden und vor denen\ndie Bäume buschig wuchsen, kam wenig Licht herein, außerdem\ndunkelte es schon draußen; nur die Gläser auf den Heiligenbildern,\ndie auf der geweißten Wand eine schwarze Reihe bildeten,\nschimmerten noch. Die Stube war groß, aber von einer\nrußgeschwärzten Balkendecke niedergedrückt und so mit allerhand\nHausrat vollgestellt, daß man nur um den großen, an der Flurwand\nstehenden Herd herum mit seinem mächtigen Rauchfang darüber etwas\nfreien Platz hatte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Boryna zog die Stiefel aus und trat in die dunkle Buze hinein,\ndie Tür hinter sich schließend; von der kleinen Fensterscheibe\nschob er das Brett zurück, so daß das Abendlicht mit blutigem\nSchein den Raum erleuchtete.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Buze war voll Kram und Wirtschaftsgeräten, auf querlaufenden\nStangen hingen Schafspelze, rote gestreifte Beiderwandröcke, weiße\nHaartuchkittel, ganze Raspeln grauer Garne, zu Ballen\nzusammengerollte schmutzige Schaffließe und Säcke voll Daunen. Er\nholte einen weißen Haartuchkittel und einen roten geflochtenen\nHanfgürtel hervor und suchte darauf lange in den mit Getreide\ngefüllten Tonnen herum, dann wieder in einem Haufen alten Eisens\nund alter Riemen; als er jedoch Anna in der Vorderstube hantieren\nhörte, zog er das Brett über das kleine Fenster und scharrte noch\nlange im Korn. "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page57",
      "title": "gary/Pirki"
    }
  }), _vm._v("\nAuf der Bank vor dem Fenster dampfte schon das Essen; aus dem\ngewaltigen Tiegel voll Kohl verbreitete sich der Duft von\ngeröstetem Speck; auch nach Rühreiern roch es, wovon eine nicht\nkleine Schüssel daneben stand.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wo hat Witek die Kühe gehütet?« fragte er, eine mächtige\nSchnitte von einem Brotlaib schneidend, der so groß war, wie ein\nGetreidesieb.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Im Weidewald, im Gutsbezirk, der Heger hat sie verjagt.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Aasbiester, "), _c('span', {
    staticClass: "spaced"
  }, [_vm._v("die")]), _vm._v(" haben mir das Tier\nzuschanden gerichtet.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Selbstredend, so 'ne große Kuh, die hat sich verhitzt bei dem\nGetreibe, 'n Brand hat sie gekriegt.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das Lumpenpack. Der Weidewald gehört uns, das steht deutlich\nwie 'n Ochs im Grundbuch, und die tun nichts als 'rausjagen und\nmeinen, es sei ihrer.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Die anderen haben sie auch 'rausgejagt und Waleks Jungen hat er\nverprügelt und wie geprügelt ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ha! da muß man vors Gericht und zum Kommissar. Dreihundert\nSilberlinge ist sie wert, mindestens!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gewiß!« versicherte sie, froh, daß der Vater sich\nzufriedengegeben hatte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Sag' Antek, wenn sie die Kartoffeln eingefahren haben, sollen\nsie sich gleich an die Kuh heranmachen, man muß sie häuten und\nzerlegen. Wenn ich vom Schulzen heimkomme, will ich euch helfen. In\nder Banse am Balken soll man sie aufhängen/das wird sicherer sein\nvor den Hunden oder sonst welchem Viehzeug ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Er war bald mit dem Essen fertig und stand auf, um sich\nzurechtzumachen, aber er fühlte eine solche Trägheit in sich, ein\nsolches Ziehen in den Knochen, eine solche Schläfrigkeit, daß er,\nso wie er dastand, sich aufs Bett warf, um etwas zu schlafen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Anna ging auf ihre Seite zurück und wirtschaftete in der Stube,\nsich von Zeit zu Zeit hinauslehnend, um nach Antek "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page58",
      "title": "gary/Pirki"
    }
  }), _vm._v(" zu sehen, der auf der Veranda\nvor dem Haus sein Essen bekommen hatte. Er war von der Schüssel\nabgerückt, wie es Brauch ist, und schlürfte Löffel auf Löffel,\nindem er laut gegen die gerillte Schüssel kratzte und gelegentlich\nvor sich hin auf den Weiher starrte. Dort lag die Abendröte und es\nentstanden auf dem Wasser gold-purpurne Regenbogen und flammende\nKreise, durch die, gleich weißen Wölklein, die Gänse schnatternd\nhindurchschwammen, Schnüre blutroter Perlen aus den Schnäbeln\nvergießend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Im Dorf fing es an, sich zu regen und zu wimmeln; auf dem Wege\num den Weiher herum erhoben sich ständig Staubwolken, erklang\nWagengerassel und das Brüllen der Kühe, die bis an die Knie ins\nWasser stiegen, langsam tranken und die schweren Köpfe\naufrichteten, daß ihnen dünne Wasserrinnsale, gleich opalfarbenen\nPeitschenschnüren aus den breiten Mäulern herunterrannen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Irgendwo vom anderen Ende des Weihers knatterten die\nWaschschlegel der Wäscherinnen, und dumpf und eintönig klang von\neiner fernen Scheune herüber das Aufschlagen der Dreschflegel.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Antek, hack' mir etwas Holz, denn allein werde ich nicht\nfertig,« bat sie schüchtern und ängstlich; denn er machte sich\nnichts daraus, zu fluchen oder zuzuschlagen aus dem ersten besten\nAnlaß.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Nicht einmal antworten tat er, als hätte er nichts gehört, so\ndaß sie sich gar nicht mehr traute, noch etwas zu sagen und selbst\nhinging, von den Holzklötzen Holz abzuspalten; er aber schwieg\nverärgert, von der Tagesarbeit erschöpft und blickte jetzt nach dem\njenseitigen Ufer auf ein Haus, dessen weiße Wände und\nFensterscheiben leuchteten, denn es stand gegen das Abendlicht.\nBüschel roter Georginen sah er, die sich über die steinerne\nGartenmauer lehnten und grell auf dem Hintergründe der Wände\nbrannten, und vor dem Haus, einmal im Obstgarten, einmal zwischen\nden Hecken bewegte sich geschäftig eine hohe Gestalt "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page59",
      "title": "gary/Pirki"
    }
  }), _vm._v(" /das Gesicht konnte man nicht\nerkennen, denn jeden Augenblick verschwand sie im Hausflur oder\nunter den Bäumen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Der schläft wie 'n Gutsherr, und du arbeite man gefälligst, wie\n'n Knecht,« murrte er böse auf, denn das väterliche Schnarchen\ndrang bis auf die Veranda.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Er ging auf den Hof und besah sich nochmals die Kuh.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das ist recht, Vater seine Kuh ist es, aber auch unser\nVerlust,« sagte er zu seiner Frau, die, da Jakob die Kartoffeln vom\nFeld eingefahren hatte, das Holzspalten aufgab und sich dem Wagen\nnäherte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Die Kartoffelgruben sind noch nicht in Ordnung, da muß man auf\ndie Tenne abladen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Vater sagt doch, du sollst auf der Tenne die Kuh häuten und\nausweiden.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Die Kuh wird Platz haben und die Kartoffeln auch,« brummelte\nJakob, indem er die Scheunentür sperrangelweit aufstieß.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich bin kein Schinder, daß ich dazu da bin, der Kuh die Haut\nabzuziehen,« warf Antek ein.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie sprachen nichts weiter, man hörte nur das Kullern der\nKartoffeln, die auf die Tenne geschüttet wurden.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Sonne war erloschen, es wurde Abend, das letzte Rot\nleuchtete noch wie Lachen geronnenen Blutes und erstarrten Goldes.\nDer Weiher war wie mit Kupferstaub bestreut und die stillen\nGewässer zuckten unter rostigen Schuppen im schläfrigen\nGemurmel.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Das Dorf versank in Dunkelheit, in die tiefe, tote Stille eines\nHerbstabends. Die Bauernhäuser wurden kleiner, als ob sie sich zur\nErde duckten, als schmiegten sie sich gegen die schlaftrunken\ngeneigten Bäume und grauen Hecken.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Antek und Jakob waren mit dem Einfahren der Kartoffeln\nbeschäftigt, während Anna und Fine die Wirtschaft besorgten. Die\nGänse sollten noch zur Nacht eingetrieben werden und die Schweine\ngefüttert, die sich mit Gequieke auf die "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page60",
      "title": "gary/Pirki"
    }
  }), _vm._v(" Diele drängten und die gefräßigen\nRüssel in die Zuber steckten, worin der Drank für das Vieh war.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Kühe mußten auch gemolken werden, denn gerade hatte Witek\ndie letzten von der Weide heimgetrieben und legte jeder einen Arm\nvoll Heu in die Raufe, damit sie stillhielten beim Melken.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Fine setzte sich gerade zurecht, die erste vom Rande zu melken,\nals Witek unter der Krippe hervorkroch leise und ängstlich\nfragend:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Fine, is der Bauer bös? ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Du lieber Himmel, prügeln wird er dich, armer Kerl ... was hat\ner geflucht,« antwortete sie, den Kopf zum Licht wegdrehend und\ndabei mit der Hand das Gesicht schützend, weil die Kuh der Fliegen\nwegen mit dem Schweif gegen die Flanken klatschte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich ... kann ich denn was dafür ... Der Heger hat mich doch\nrausgetrieben und wollte noch mit dem Stock nach mir schlagen, aber\nich bin gelaufen ... und die Bunte hat sich doch gleich hingelegt\nund gebrüllt und gestöhnt, so daß ich sie gleich heimgetrieben habe\n...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Er schwieg; man hörte nur ein stilles, banges Schluchzen und\nSchneuzen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Witek ... Hab' dich doch nicht wie 'n Kalb, ist doch nicht das\nerstemal, daß Vater dich verwichst...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Nein, nicht zum erstenmal, aber ich hab' doch solche Angst ...\nvon wegen weil ich keine Ausdauer hab' ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Bist dumm, wird schon bald ein Knecht und hat Angst ... ich\nwerd's Väterchen schon stecken ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Willst du das, Fine?« rief er freudig aus, »das war doch der\nHeger, der hat mich mit den Kühen weggejagt/das war doch ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich werd's schon stecken, Witek, brauchst keine Angst zu haben!\n...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wenn es so ist ... dann hast du hier den Vogel!« flüsterte er\nfreudig erregt und zog unter der Jacke ein hölzernes "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page61",
      "title": "gary/Pirki"
    }
  }), _vm._v(" Wunderwerk hervor. »Guck nur,\nwie er sich von selbst bewegt.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Er stellte sein Geschenk auf die Schwelle des Kuhstalls, drehte\nes auf und der Vogel fing an zu wackeln, die langen Beine zu heben\nund zu marschieren ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Jesus, 'n Storch, der ist ja ganz wie lebendig!« schrie sie\nerstaunt, stellte die Melkgelte beiseite, hockte vor der Schwelle\nnieder und sah ganz glückselig und bewundernd zu.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Jesus! bist du ein Mechanikus! und bewegt er sich denn von\nselbst so, äh? ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Doch, von selbst, Fine, nur mit dem Hölzchen muß ich ihn\naufdrehen, dann spaziert er wie 'n Gutsherr nach dem Mittagessen/da\n...,« er drehte ihn um, und der Vogel streckte ernst und komisch\nseinen langen Hals, hob die Beine und spazierte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie lachten beide herzhaft und ergötzten sich an seinen\nBewegungen, zuweilen nur hob Fine die Augen und sah den Jungen voll\nStaunen und Bewunderung an.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Fine!« ertönte die Stimme Borynas vor dem Wohnhaus.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Was denn?« ... schrie sie zurück.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Komm mal her.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wir melken doch.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Paß hier auf, ich gehe zum Schulzen hinüber,« sagte er, den\nKopf in den dunklen Kuhstall steckend, »hast du nicht dieses\naufgelesene Landstraßenbalg gesehen, ha?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Witek?/ni, der is mit Antek auf'm Kartoffelfeld, denn Jakob\nsoll Häcksel schneiden ...,« sie antwortete schnell und etwas\nängstlich, denn Witek verkroch sich aus Angst hinter ihrem\nRücken.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Aas von Junge, nur in Stücke reißen, so eine Kuh zu ruinieren,«\nbrummte er, in die Stube zurückgehend, wo er den neuen weißen\nTuchrock anzog, der an allen Nähten entlang mit schwarzem\nLitzenmuster benäht war, suchte den hohen spitzen Filzhut mit der\nroten Kokarde hervor, wickelte "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page62",
      "title": "Monne3/gary"
    }
  }), _vm._v(" dazu den roten Gürtel um und entfernte sich über\nden Weg am Weiher in der Richtung der Mühle.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»So viel Arbeit noch ... Das Holz ist noch nicht eingefahren ...\ndie Saat nicht beendigt ... der Kohl draußen ... die Nadelstreu\nnicht zusammengeharkt ... für die Kartoffeln muß gepflügt werden\n... auch für'n Hafer müßte man ... und du fahr man zum Gericht ...\nHerr Gott, daß man die Arbeit nie fertigkriegt, immer nur wie'n\nOchs im Joch ... nicht ausschlafen, nicht ausruhen kann unsereiner\n...,« sinnierte er ... »Und dazu nun noch Gericht ... Aasschlampe,\nsieh einer an, ich mit der schlafen ... daß dir die Zunge verdorrt\n... Lumpentrine ... Metze ...,« er spuckte wütend aus, pfropfte die\nkleine Pfeife mit Knaster voll und rieb die feuchtgewordenen\nStreichhölzer lange gegen die Hose, bevor er sie in Brand setzen\nkonnte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("In Abständen paffend schleppte er sich langsam vorwärts; alle\nGlieder schmerzten ihm und der Verdruß wegen der Kuh machte ihn\nmißmutig und zog ihm durch alle Knochen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und den Arger kann man sich nicht einmal wegprügeln oder\nausklagen, nichts ... wie 'n einsamer Pflock ist man auf der Welt;\nalles muß man selbst bedenken, über alles mit seinem eigenen Kopf\ndeliberieren, hinter allem selbst her sein, wie ein Hofhund ...\nreden kann man mit niemand ein Wort und von nirgends 'n Rat und 'ne\nHilfe / nur Schaden und Verlust allenthalben ... und die ganze\nGesellschaft, wie Wölfe um ein Schaf herum ... die zerren nach\nallen Seiten und lauem nur, wenn sie einen in Stücke reißen\n...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Im Dorf war es schon dunkel, in den warmen Abend quollen durch\ndie angelehnten Türen und Fenster Flackerscheine der Herdfeuer, der\nDuft gekochter Kartoffeln und saurer Mehlsuppen mit Speckgrieben;\nhier und bei verzehrte man das Nachtmahl auf den Dielen oder selbst\nvor den Häusern, daß man von überall das Kratzen der Löffel und die\nStimmen der Menschen hörte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page63",
      "title": "rudi49/gary"
    }
  }), _vm._v(" Boryna\nging immer langsamer, die Erbitterung machte ihn schwerfällig, und\ndann fuhr ihm die Erinnerung an die im Frühjahr Verstorbene an die\nGurgel ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ho! ho! ... bei der/möge sie unberufen in Frieden ruhn/wär' das\nder Bunten nicht passiert ... das war 'ne Bäuerin! ... Gewiß, ein\nSchandmaul hatte sie und eine böse Zunge, ein gutes Wort hat sie\nniemandem gegönnt, mit den Weibern hat sie sich immerzu in den\nHaaren gelegen ... aber die Ehefrau war es immerhin doch und 'ne\ngute Hausfrau!« Hier seufzte er auf mit frommem Wunsch für ihr\nSeelenheil und eine noch größere Betrübnis legte sich auf ihn, denn\ner gedachte dessen, wie es einstmals gewesen war.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Kam er von der Arbeit nach Hause, abgearbeitet/dann hielt sie\nfettes Essen bereit, und oft und manch einmal steckte sie ihm\nhinter dem Rücken der Kinder noch sein gutes Stück Wurst zu ... Und\nwie gedieh da alles! ... Die Kälber und die schönen Gänse und die\nFerkel ... zu jedem Jahrmarkt hatte man was mit zur Stadt zu fahren\nund bar Geld war immer da, allein vom Jungvieh schon... Und was\nKohl mit Erbsen ist/so wie die kann das 'ne andere gar nicht\n...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und jetzt was? ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Antek zerrt was er kann, der Schmied lungert auch nur herum, was\ner in die Krallen kriegt, und Fine? Die dumme Dirn', hat doch nur\nStreu im Kopf. Is ja auch man erst an die Zehn, was 'n Wunder da\n... Anna kreucht herum wie 'ne Nachteule und ist immerlos krank und\nwas die tut, ist gerade so viel wert, wie das, was sich der Hund\nzusammenheult.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("So geht alles zugrunde ... die Bunte mußte geschlachtet werden\n... in der Erntezeit ist ein Mastschwein krepiert ... die Krähen\nsind zwischen die Gössel gekommen, kaum die Hälfte ist\nübriggeblieben! ... So viel vergeudet, so viel zuschanden gemacht!\n... Alles rinnt wie durch ein Sieb ... wie durch ein Sieb ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page64",
      "title": "lac/gary"
    }
  }), _vm._v(" »Aber ich\nduld' es nicht!« schrie er fast laut; »solange ich noch auf den\nKlumpen stehe, will ich keinen Morgen Land abschreiben! Das is mal\nsicher, auf den Altenteil geh ich zu euch nicht ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Soll mir erst mal der Gschela vom Militär heimkommen, dann kann\nAntek auf Anna ihren paar Morgen wirtschaften ... ich duld' es\nnicht ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gelobt sei Jesus Christus,« ertönte eine Stimme.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»In Ewigkeit,« ... antwortete er gewohnheitsmäßig und bog von\nder Straße in einen langen Heckenweg ein, in dessen Hintergrund das\nGewese des Schulzen lag.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("In den Fenstern war Licht und die Hunde schlugen an.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Er trat geradeswegs in die Giebelstube ein.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Der Schulze da?« fragte er eine dicke Frau, die vor einer Wiege\nniedergekniet war und einem Kind die Brust gab.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Der kommt gleich, ist nur 'raus, um die Kartoffeln einzufahren.\nSetzt euch so lange, Matheus, is schon nichts zu machen dazu,\ndieser wartet auch,« mit einer Bewegung des Kinns wies sie nach\neinem Bettler, der neben dem Herd saß; das war jener alte blinde\nBettler, der von einem Hund geführt wurde; das rötliche Licht der\nScheite umfloß grell sein gewaltiges ausrasiertes Gesicht, seinen\nnackten Schädel und seine weit aufgerissenen Augen, die mit einer\nweißen Haut überzogen waren und unbeweglich unter den greisen,\nbuschigen Augenbrauen saßen ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Woher kommt ihr mit Gottes Hilfe?« fragte Boryna, sich an die\nandere Seite des Feuers setzend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Aus der Welt, Bauer, woher denn sonst,« erwiderte er langsam\nmit seiner breiten, kläglichen Bettelstimme und spitzte fleißig die\nOhren, die Tabakdose hervorholend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Langt zu, Bauer.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Matheus nahm eine kräftige Prise und nieste dreimal\nhintereinander, so daß ihm die Tränen in die Augen kamen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page65",
      "title": "lac/gary"
    }
  }), _vm._v(" »Starkes\nZeug!« und er wischte mit dem Ärmel über die tränenden Augen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gut bekomm's. Petersburgischer, is gut auf die Augen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Kehrt morgen bei mir ein, eine Kuh hab' ich notgeschlachtet, da\nfindet sich für euch schon 'n Bissen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gott lohn's ... Boryna, scheint mir, was?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Freilich, daß ihr das aber erkannt habt? ... he, he.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Noch der Stimme nur, nach dem Reden.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Was gibt's denn so in der Welt? Ihr seid doch immerzu\nunterwegs.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Du lieber Gott, was es wohl geben kann. Einmal schlecht, einmal\ngut, einmal verschieden, rote immer in der Welt. Und alle pfeifen\naus dem letzten Loch und jammern, wenn es sein muß, dem Bettler was\nzu geben, oder auch einem anderen, aber für den Schnaps da haben\nsie was.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wahr habt ihr geredet, so ist es.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ho, ho! so viel Jahre schleppt sich einer über diese heilige\nErde, da kennt man sich aus.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und wo habt ihr denn diesen aufgelesenen Jungen hingetan, der\neuch im letzten Jahre führte?« fragte die Schulzin.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gegangen ist das Aas, fort, schön hat er mir die Bettelsäcke\numgekehrt ... Etwas Geld hatt' ich ja von guten Leuten, das war für\nMessen vor dem Altar der Tschenstochauer heiligen Jungfrau, das hat\nmir das Aas ausgenommen, und denn davon, über alle Berge! Still da,\nBurek! Den Schulzen hört er, mein' ich.« Er zerrte an der Schnur\nund der Hund horte auf zu knurren.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Er hatte gut geraten, denn der Schulze kam herein, warf die\nPeitsche in die Ecke und rief gleich an der Schwelle:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Frau, Essen, hab 'n Wolfshunger./Wie geht's mit euch, Matheus,\nund was wollt ihr, Alter? ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich komme von wegen meiner Gerichtssache, die für morgen\nangesetzt ist.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page66",
      "title": "lac/gary"
    }
  }), _vm._v(" »Und ich kann\nwarten, Herr Schulze. Befehlt ihr auf der Diele/schön, auch dort\nwird's gut sein, und laßt ihr mich am Feuer, da ich doch alt bin,\ndann bleib' ich, und gebt ihr mir 'ne kleine Schüssel Kartoffeln,\noder auch 'ne Brotrinde/dann will ich für euch ein Gebet sprechen\nund noch ein zweites dazu ... als hättet ihr mir bar Geld gegeben,\noder vielleicht 'n Groschen ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Bleibt man sitzen, Abendbrot kriegt ihr, und wenn ihr wollt,\nkönnt ihr übernachten ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und der Schulze setzte sich an die Schüssel voll gemuster\nKartoffeln, die reichlich mit Speckbrühe begossen waren. Neben ihm\nstand eine große Satte voll saurer Milch.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Setzt euch zu uns, Matheus, und nehmt, was da ist,« lud die\nSchulzin ein, indem sie einen dritten Löffel zurechtlegte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gott lohn's. Als ich vom Wald heimgekommen bin, da hab' ich\nschon ordentlich gefuttert ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Haltet euch nur an den Löffel, das wird euch nicht schaden,\njetzt sind die Abende schon lang ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ein langes Gebet und eine große Schüssel, dadurch ist noch\nniemand ins Grab gekommen,« warf der Bettler ein.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Boryna zierte sich, aber schließlich, da der Speckduft ihm stark\ngegen die Nüstern stieß, setzte er sich an die Bank und langte\nbedächtig und vorsichtig zu, wie es die gute Sitte wollte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Schulzin aber stand ein nach dem andern Male wieder auf,\nfüllte die Kartoffeln nach und goß neue Milch in die Satte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Der Hund des Bettlers fing an sich zu drehen und leise und\nbescheiden nach Essen zu winseln.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Still, Burek, die Bauern essen jetzt ... auch du kriegst was,\nhab' keine Angst ...,« beruhigte ihn der Bettler, die schmackhaften\nDüfte mit der Nase witternd, und wärmte sich die Hände am\nFeuer.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page67",
      "title": "lac/gary"
    }
  }), _vm._v(" »Da soll euch\ndie Eve verklagt haben,« schnitt der Schulze an, nachdem er sich\netwas gesättigt hatte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ja, das hat sie schon, wegen dem Lohn, den ich ihr nicht\nausgezahlt haben soll! Die hat ihn gekriegt, so wahr wie Gott ist,\nund noch darüber, aus gutem Herzen hab' ich dem Priester einen Sack\nHafer gegeben wegen der Taufe ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und die sagt aus, daß dieses Kind ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Im Namen Gottes und des Sohnes. Is sie toll geworden, oder\nwas?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ho, ho! alt seid ihr, aber noch 'n Meister!« Die Schulzen\nfingen an zu lachen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Leichter passiert's dem Alten, denn der kennt sich drauf und\nhat die Übung,« murmelte der Bettler.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Die lügt wie'n Hund, nicht angerührt hab ich sie. Das fehlte\nmir noch, diese Schlampe ... am Zaun wär' sie verreckt, und wie hat\nsie gewinselt, daß man sie nur fürs Essen und für die Ecke zum\nSchlafen da behielte, weil es doch zum Winter ging. Ich wollte\nnicht, aber die Selige meinte: laß sie man kommen, kann sich im\nHaus nützlich machen, was sollen wir Tagelöhner nehmen ... Die\neigene wird zur Hand sein ... Ich wollte nicht, im Winter gibt's\ndoch keine Arbeit, und da noch ein Maul mehr zum Fressen. Aber die\nSelige hat gemeint: zu sorgen brauchst du dich nicht, sie soll\nBeiderwand und Leinen weben können, ich krieg' sie 'ran, mög' sie\nman 'rumpuddeln, irgendwas wird sie schon herauspuddeln. Na und sie\nis geblieben, hat sich 'rausgefüttert und sich nach Zuwachs\numgesehen ... Und wer da Kumpeljonk is, davon haben sie schon\nmanches geredet ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Sie klagt gegen euch.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Kalt werd' ich das Aas noch machen, die Zigeunermetze!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Aber zum Gericht müßt ihr.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das will ich. Gott vergelt's, daß ihr es gesagt habt, denn ich\nwußte bis jetzt nur das wegen dem Lohn/aber "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page68",
      "title": "Frank_9901/gary"
    }
  }), _vm._v(" bezahlt hab' ich, da hab' ich\nZeugen für! Die vermaledeite Schnauze, die Bettelschickse. Großer\nGott, so viel Kummer, daß man schon gar nicht weiß, wie man das\ntragen soll / und dazu ist mir noch die Kuh umgekommen,\nnotschlachten hab' ich sie müssen, auf dem Feld bleibt die Arbeit\nliegen und man ist allein auf seine fünf Finger angewiesen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das Schaf unter den Wölfen ist der Witwer unter den Menschen,«\nfügte abermals der Bettler hinzu.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Von der Kuh hab' ich gehört, man sagte es mir schon auf dem\nFeld ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Da hat das Gut seine Finger dabei gehabt, ich hör', der Heger\nhat sie aus dem Weidewald verjagt. Die beste Kuh, dreihundert\nSilberlinge war sie wert, sie hat sich verhitzt, so'n schweres\nTier, und hat den Brand gekriegt, ich mußte sie schlachten ... Aber\ndas Gut soll mir nicht damit durchkommen ... klagen werd' ich.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Der Schulze jedoch fing an, ihm zuzureden und ihm die Sache\nauseinanderzusetzen und meinte, er möge damit warten, der Ärger sei\nein schlechter Berater; er hielt zum Gut, und um schließlich der\nUnterhaltung eine andere Wendung zu geben, blinzelte er seiner Frau\nzu und sagte:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ihr müßtet wieder heiraten, dann wär' da jemand, der nach der\nWirtschaft sieht.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Zieht ihr mich auf, oder was? ... Ich habe doch am\nKräutersonntag meine achtundfünfzig Jahr beendigt. Was euch nur\neinfällt, die andere ist noch nicht richtig kalt geworden.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ihr müßt 'ne Frau nehmen, die zu eurem Alter paßt, dann kommt\nalles wieder zurecht,« ergänzte die Schulzin und begann\nabzuräumen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ein gutes Eheweib krönt des Mannes Erdenleib,« warf der Bettler\nhinzu, die Schüssel betastend, die die Schulzin vor ihn hingestellt\nhatte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Boryna wehrte ab, aber er wurde nachdenklich darüber, "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page69",
      "title": "Frank_9901/gary"
    }
  }), _vm._v(" warum ihm der\nGedanke nicht auch schon gekommen war. Denn wie auch die Frau sein\nmag, die einer kriegt, es ist doch immerhin besser, mit ihr\nzusammen, als sich alleine abzuquälen...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Manche ist dumm und nicht rührig, manche wiederum 'ne böse, die\nnach des Bauers Zotteln langt und manche is 'n Schmutzfink und 'n\nRumtreiber, hat nur Schenke und Tanzmusik im Kopfe / und doch ist\nder Bauer besser mit ihr dran und hat auch seine Bequemlichkeit,«\nführte der Bettler essend weiter aus.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Da würden sie im Dorf was haben, um sich darüber aufzuhalten,«\nsagte Boryna.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Na ja / und werden euch die Leute die Kuh wieder gesund machen,\noder helfen, die Wirtschaft besorgen, oder euch bemitleiden,« legte\ndie Schulzin gefühlvoll los.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Oder euch das Federbett wärmen,« lachte der Schulze. »Und im\nDorf gibt es so viele Madchen, daß wenn man zwischen den Häusern\ngeht, die Glut schon durch die Wände schlägt ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Pfui doch, sieh' einer mal, diesen Liederjan ... Was der nicht\nalles möchte ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und dem Gregor seine Sophie, wie wär' denn die zum Beispiel,\nschlank, schön und 'ne gute Mitgift.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Was denn, Mitgift, braucht denn Matheus 'ne Mitgift / der erste\nBauer im Dorf!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wer hätte genug, daß er nicht mehr wollte?« protestierte der\nBettler.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Nee, dem Gregor seine ist nichts für ihn«, nahm der Schulze\nwieder auf, »die ist noch zu matt, is ja kaum trocken hinter den\nOhren.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und dem Andreas seine Kassja«, zählte die Schulzin weiter.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Vergeben. Gestern hat dem Rochus sein Adam mit Schnaps zu ihr\ngeschickt.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Dann ist noch dem Stach seine Veronika da.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page70",
      "title": "Monne3/gary"
    }
  }), _vm._v(" »Die\nBummelliese, dieser Rumtreiber und 'ne dicke Hüfte hat sie\ndazu.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und dem Tomek seine Witwe, wie wär's mit der ... is noch ganz\nreputierlich ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Drei Kinder, vier Morgen, zwei Kuhschwänze und den alten\nSchafspelz vom Seligen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und Ulischja, die vom Wojtek, die hinter der Kirche sitzen?\n...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ji ... das wär' was für'n Junggesellen ... gleich mit Zuwachs,\nder Junge wäre schon zum Hüten gut, aber Matheus braucht keinen, er\nhat schon seinen Hirten.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gewiß, es gibt noch genug von diesem Jungfernkraut, aber ich\nsuch' doch solche aus, die für Matheus passen sollen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Aber eine hast du vergessen, die für ihn grad die Rechte\nwäre.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wen denn?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Dem Dominik seine Jagna.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das is wahr, die hab' ich ganz vergessen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»'ne deftige Dirn', und gut gewachsen, über den Zaun kommt die\nnicht, ohne daß die Latten unten wegbrechen ... und schön noch\ndazu, ordentlich weiß ums Maul, schmuck wie 'ne Färse.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Jagna,« wiederholte Boryna, der schweigend der Aufzählung\ngefolgt war, »von der sagt man doch, daß sie auf die Jungen happig\nist.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hat sich was / war denn jemand dabei, der das weiß? Die\nKlatschmäuler reden nur, um zu reden; macht alles nur der Neid,«\nverteidigte die Schulzin mit Nachdruck.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich red' auch nicht von mir aus / es wird nur so erzahlt. /\nAber ich muß gehen;« er rückte den Gurt zurecht, steckte ein Stück\nKohle in die Pfeife und sog ein paarmal.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Um wieviel Uhr zu Gericht?« fragte er gelassen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Auf neun Uhr steht's in der Vorladung. Vor Tag müßt ihr\naufstehen, wenn's zu Fuß gehen soll.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page71",
      "title": "Monne3/gary"
    }
  }), _vm._v(" »Nee ...\nmit der Jungstute will ich langsam hinfahren. Gehabt euch wohl, und\nschönen Dank für das Essen und den nachbarlichen Rat.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gott auf'n Weg und überlegt es euch, was wir euch angeraten\nhaben ... Und sagt ihr ein Wort, geh' ich selbst mit dem Schnaps\nzur Mutter und noch vor Weihnachten feiern wir Hochzeit ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Boryna antwortete darauf nichts, drehte nur mit den Augen und\nentfernte sich.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wenn ein Alter 'ne Junge freit, freut sich der Teufel, denn er\nwird davon Profit haben,« sagte der Bettler gewichtig, indem er\nlaut über den Grund der Schüssel schabte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Boryna kehrte langsam heim und kaute nachdenklich durch, was sie\nihm geraten hatten. Er hatte sich wohlweislich nichts merken lassen\nbei den Schulzens, daß ihm dieser Gedanke recht gut mundete; wieso\nhätte er denn auch sollen, er war doch ein Großbauer und kein\nBursch mehr, der noch gelb um den Schnabel ist, der, wenn man ihm\nvom Heiraten redet, schon quiekt und von einem Fuß auf den anderen\nspringt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Nacht hielt schon die Erde umfaßt und die Sterne blinkten,\nwie silberner Tau, aus dunklen, stummen Tiefen. Das Dorf war still,\nnur die Hunde bellten hin und wieder, und hier und da glommen\nzwischen den Bäumen schwache Lichtlein ... Manchmal wehte ein\nfeuchter Windhauch von den Wiesen, so daß die Bäume anfingen leicht\nzu schaukeln und mit den Blättlein leise zu flüstern.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Boryna wählte nicht den Weg, auf dem er gekommen war, sondern\nwandte sich tiefer ins Tal, überschritt die Brücke, unter der das\nvom Fluß herkommende Wasser gurgelnd vorüberfloß, mit dumpfem\nGetöse sich zur Mühle hinwälzend, und schwenkte nach der anderen\nSeite des Weihers hinüber. Das Gewässer lag still und schimmerte\nschwärzlich, die Uferbäume warfen auf die spiegelnde Fläche "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page72",
      "title": "Monne3/gary"
    }
  }), _vm._v(" schwarze Schatten\nund faßten die Ränder, wie in eine Umrahmung ein, und in der Mitte\ndes Weihers, wo es heller war, spiegelten sich die Sterne, wie in\neinem Stahlspiegel, wider.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Matheus wußte nicht, warum er nicht geradenwegs nach Hause\ngegangen war, sondern den Umweg gemacht hatte, vielleicht um an\nJagnas Hause vorüberzugehen? vielleicht auch um sich etwas zu\nsammeln und zu meditieren.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Natürlich, schlecht wär' es schon nicht! natürlich! Und was man\nda über sie erzählt, das ist soviel wert ...« Er spuckte aus. »'n\ndeftiges Frauenzimmer!« Ein Frösteln lief ihm über den Rücken. Vom\nWeiher kam nämlich feuchte Kühle und bei dem Schulzen war es\nmächtig heiß gewesen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und ohne Eheweib muß man zugrunde gehen oder den Kindern die\nWirtschaft abschreiben,« überlegte er, »und groß ist das Biest und\nwie gemalt. / Und die beste Kuh ist krepiert, und wer kann wissen,\nwas morgen kommt? ... Vielleicht muß man doch 'ne Frau suchen. Aber\ndie alte Dominikbäuerin ist der reine bissige Köter / na was kann\ndas schaden, ihr Haus haben sie und ihren Grundbesitz, die kann\ndann auf dem ihrigen sitzenbleiben. Dreie sind sie und haben\nfünfzehn Morgen, dann kämen auf Jagna fünf zum Beispiel und die\nAuszahlung von wegen dem Haus und dem Infantar! / Fünf Morgen,\ngerade die Felder hinter meinem Kartoffelland, Roggen haben sie,\nglaub' ich, gesät dieses Jahr, ja ... Fünf Morgen zu den meinen,\ndas wären ... fünfunddreißig Morgen fast! Mächtig viel Land!\n...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Er rieb sich die Hände und schob seinen Gurt zurecht. / »Dann\nhat nur der Müller mehr ... der Dieb, durch Menschenunrecht,\nProzente und Betrügereien hat er es zusammengeschachert ... Und im\nnächsten Jahr würde ich gut durchmisten, den Acker durchnehmen und\nauf dem ganzen Stück Weizen säen; ein Pferd müßte man hinzukaufen\n"), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page73",
      "title": "Monne3/gary"
    }
  }), _vm._v(" und dann für\ndie Bunte irgendeinen rechten Ersatz ... Das ist wahr, 'ne Kuh\nwürde sie noch mitkriegen ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und so überlegte er, zählte und schwelgte in wirtschaftlichen\nPlänen, bis er zuweilen in tiefem Nachdenken stehenblieb. Und da er\nein kluger Kerl war, raffte er alle Gedanken zusammen und guckte\ntief in seinen Kopf hinein, um nicht irgend etwas zu übersehen oder\nzu vergessen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Schreien würde die Bagage, schreien!« dachte er, sich der\nKinder erinnernd, aber sofort überflutete ihn das Selbstbewußtsein\nund das Gefühl seiner Macht und verstärkte seinen dumpfen, noch\nwankenden Entschluß.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Der Grundbesitz ist mein, da soll sich jeder hüten, da\nbeizugehen. Und wollt ihr nicht, dann soll euch ...« er beendete\nnicht, denn er stand vor dem Hause der Jagna.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie hatten noch Licht, und ein breiter Lichtstreifen fiel durch\ndas offene Fenster auf einen Georginenbusch, auf einige niedrige\nPflaumenbäume und lief über den Zaun bis auf die Dorfstraße.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Boryna blieb im Schatten stehen und versenkte den Blick in die\nStube.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Ein Lämpchen glimmte über dem Rauchfang, aber auf dem Herd mußte\nnoch ein gehöriges Feuer brennen, denn man hörte das Knackern von\nTannenzweigen, und rötliches Licht erfüllte den großen, in den\nEcken dämmrigen Raum; die Alte saß vor dem Kamin hingekauert und\nlas irgend etwas vor, und ihr gegenüber saß Jagna mit dem Gesicht\nin der Richtung des Fensters und rupfte eine Gans; sie hatte nur\nnoch das Hemd an und die Ärmel waren bis an die Schultern\nhochgekrempt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Verdeubeltes Luder, verdeubelt!« dachte er. Sie hob zuweilen\nden Kopf, sah zur Mutter hinüber und seufzte tief auf; dann machte\nsie sich wieder ans Rupfen der ängstlich unter ihren Händen\ngackernden Gans, die mit "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page74",
      "title": "Monne3/gary"
    }
  }), _vm._v(" Geschrei und mit Flügelschlagen ihr zu entrinnen\nversuchte, so daß die Daunen, wie eine weiße Wolke, durch die Stube\nflogen. Sie beruhigte das Tier rasch und preßte es fest zwischen\nihre Knie, bis die Gans nur unterdrückt und schmerzlich gackelte.\nIrgendwo, vom Hof oder von der Diele, antworteten ihr die\nanderen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Statiöses Frauenzimmer,« kam es ihm. Er ging rasch davon, denn\nes war ihm zu Kopf geschlagen, so daß er sich kratzend über den\nSchädel fuhr, eine Rocköse zuknöpfte und den Gürtel strammer\nanzog./")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Schon hatte er das Tor seines Gehöfts hinter sich und ging an\nden Hecken entlang dem Hause zu, als er sich noch einmal nach ihrem\nHof umblickte, der gerade gegenüber, nur an der anderen Seite des\nWassers lag. Zur selben Zeit trat drüben jemand hinaus, denn durch\ndie geöffnete Tür sprühte ein Lichtstrahl, blitzte auf wie ein\nWetterleuchten und fiel bis auf den Weiher; darauf hörte man das\nfeste Stapfen von Schritten, das Plantschen eines Wassereimers, der\ngefüllt wurde, und schließlich erklang durch die Dunkelheit und\ndurch die Nebeldünste, die von den Wiesen aus sich anfingen über\nden Weiher zusammenzuziehen, ein gedämpftes Singen:")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Ich hinterm Wasser und du hinterm Wasser,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nWie soll ich nun den Kuß dir reichen."), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nIch geb' ihn auf einem Blättelein."), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nDa hast du ihn, Geliebter mein!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Er lauschte lange, obgleich die Stimme schon schwieg und die\nLichter erloschen waren.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Aus den Wäldern kam der Vollmond über den Himmel gerollt und\nversilberte die Schöpfe der Bäume, streute sein Licht durch die\nZweige über den Weiher und guckte in die Fenster der Hütten, die\nihm gegenüber lagen. Selbst die Hunde schwiegen. Eine\nunergründliche Stille umfaßte das ganze Dorf und die Kreatur.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page75",
      "title": "Monne3/gary"
    }
  }), _vm._v(" Boryna\numschritt den Hof, sah bei den Pferden ein, die schnaubten und ihr\nFutter fraßen, und steckte den Kopf in den Kuhstall, dessen Türen\nder Hitze wegen ausgesperrt standen. Die Kühe lagen wiederkauend da\nund taten ihrer Gewohnheit nach ab und zu schnaufen. / Er lehnte\nnoch die Scheunentür an.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Mit dem Hut betrat er die Stube und sprach halblaut das\nGebet.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Da jedoch schon alle schliefen, zog er leise die Stiefel aus und\nlegte sich gleich schlafen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Aber der Schlaf wollte nicht kommen; einmal brannte ihn das\nFederbett, daß er die Füße heraussteckte, dann wieder gingen ihm\nverschiedene Geschäfte durch den Kopf, verschiedene Sorgen und\nGedanken ... und dann fühlte er ein arges Drücken im Magen, so daß\ner herumstöhnte und vor sich hin brummte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das sag' ich immer, saure Milch bläht nur den Bauch auf, die\nsoll man nicht für die Nacht geben ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Danach fing er an, über die Jagna nachzudenken; und wie gut das\nwäre, denn sie wäre schön gewachsen und tüchtig, und das viele Feld\n... Seine Kinder kamen ihm in den Sinn, das Gerede über Jagna, bis\nsich alles in ihm verwirrte und er nicht mehr wußte, was er\nanfangen sollte; er richtete sich etwas hoch und wollte, wie er es\ngewohnt war, nach dem andern Bett herüberrufen und um Rat\nfragen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Marysch! Soll ich die Jagna heiraten, oder soll ich sie nicht\nheiraten, die Jagna? ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Aber zur rechten Zeit fiel es ihm ein, daß Marysch schon seit\ndem Frühjahre auf dem Friedhof lag und daß dort im Bett Fine\nschlief und schnarchte; daß er 'ne ganze Waise geworden ist und\nniemanden hat, den er um Rat fragen kann, darum seufzte er schwer\nauf, bekreuzigte sich und fing an Aves für die Selige zu beten, und\nfür alle Seelen, die im Fegefeuer sind.")]), _vm._v(" "), _c('p', {
    staticClass: "pcalibre6 initial1"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page76",
      "title": "DaoH/gary"
    }
  }), _vm._v(" Die Morgendämmerung hatte schon die Dächer\nkalkweißer Helle übertüncht und die Nacht mit ihren verblaßten\nSternen mit einem grauen Sacktuch zugeworfen, als es sich auf dem\nBorynahof zu regen begann.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Jakob kroch von seiner Pritsche herunter und guckte vor den\nStall. – Auf der Erde lag Frühreif und alles war noch in Grau\ngetaucht, aber schon fing im Osten das Morgenrot an aufzuglühen und\ndie Wipfel der bereiften Bäume rot zu färben. Er reckte sich\nbehaglich, gähnte noch ein paarmal und ging hinüber in den\nKuhstall, um Witek zuzuschreien, daß es Zeit sei aufzustehen, aber\nder Junge hob nur etwas seinen schlaftrunkenen Kopf und murmelte:\n»Gleich, Jakob, gleich!« und preßte sich fester an seine\nLagerstätte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Schlaf noch was; armer Kerl, schlaf nur!« Er deckte ihm den\nSchafspelz über und humpelte davon; man hatte ihm einst das Bein am\nKnie durchschossen, darum hinkte er stark und schleppte den einen\nFuß nach. Er wusch sich am Brunnen, glättete mit der Handfläche die\nspärlichen, zausigen Haare, die ihm in filzigen Zotteln um den Kopf\nhingen, und kniete auf der Schwelle des Stalles zum Morgengebet\nnieder.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Der Bauer schlief noch; in den Fenstern des Wohnhauses\nentzündete sich der blutige Schein des Morgens, und dichte weiße\nNebel zogen sich langsam von den Weihern zurück, schaukelten\nschwerfällig und rafften ihre zerrissenen Fetzen zusammen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Jakob bewegte den Rosenkranz zwischen den Fingern und betete\nlange, seine Blicke aber liefen durch den Hof, an den Fenstern des\nWohnhauses entlang, über den Obstgarten, dessen tiefster Teil noch\nim Dämmer lag, von Apfelbaum zu Apfelbaum, wo die Früchte groß wie\nFäuste hingen; dann warf er irgend etwas nach der Hundehütte, die\ndicht bei der Tür stand und traf den weißen Kopf "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page77",
      "title": "MEsswein/gary"
    }
  }), _vm._v(" Waupas, so daß der Hund\naufknurrte und sich zusammenrollte, um wieder weiterzuschlafen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Sieh einer, bis die Sonne 'raus ist, will er schlafen. Das\nBiest!« und er warf zum zweitenmal nach ihm. Der Hund kroch heraus,\nstreckte sich, gähnte, wedelte mit dem Schwanz und setzte sich hin,\num sich zu kratzen und mit den Zähnen im dichten Pelz Ordnung zu\nschaffen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»... Und dieses Gebet spreche ich dir und allen Heiligen zu\nEhren, Amen!« Er schlug sich lange gegen die Brust, und sich\nerhebend sagte er zu Waupa:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hela! olegantes Viech, sucht sich die Flöh' zusammen, wie'n\nFrauenzimmer vor der Hochzeit.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Da er aber ein fleißiger Mensch war, machte er sich gleich an\ndie Morgenarbeit, rollte den Wagen aus der Scheune hervor,\nschmierte ihn, tränkte die Pferde und füllte ihnen Heu nach. Sie\nfingen an zu schnaufen und mit den Hufen zu stampfen. Dann holte er\naus der Banse etwas Spreu, gut mit Hafer vermengt und schüttete ihn\nder Stute, die im Verschlag abgesondert stand, in die Krippe.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Friß, Alte, friß! 'n Fohlen wirst du haben, da brauchst du\nKraft, friß!« Er streichelte sie über die Nüstern, so daß die Stute\nihm den Kopf auf die Schulter legte und liebkosend mit ihrem Maul\nnach seinen Zotteln griff.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»... Bis Mittag fahren wir die Kartoffeln ein, und gegen Abend\nmuß man in den Wald Nadelstreu holen/brauchst nichts zu fürchten,\ndie Streu ist leicht und gejagt wirst du nicht ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und du Faulpelz, kriegst einen mit der Peitsche über, paß du\nauf, der Hafer sticht den Gauner,« redete er zum nebenan stehenden\nWallach, der den Kopf zwischen den Brettern des Verschlages\ndurchschob, um zur Krippe der Stute zu gelangen/er langte ihm einen\nkräftigen mit der Faust auf den Hintern, daß das Pferd zur Seite\nsprang und aufwieherte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»So ein Judenpferd! Fressen würdest du selbst reinen "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page78",
      "title": "JohannN/gary"
    }
  }), _vm._v(" Hafer, aber für\ndie Arbeit bist du nicht zu haben; ohne Peitsche geht das Luder\nnicht von der Stelle! ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Er umging ihn und sah nach der Jungstute, die ganz zuletzt an\nder Wand stand und schon von weitem ihm den kastanienbraunen Kopf\nmit einer weißen Blesse an der Stirn entgegenstreckte und ganz zart\nzu ihm herüberwieherte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Still man, Kleine! Freß dich satt, sollst den Bauer zur Stadt\nfahren!« Er drehte sich einen Büschel Heu zurecht und putzte ihr\ndie besudelte Flanke. »So 'ne große Stute, soll schon bald zum\nHengst kommen, und so'n Schwein! Gleich wie 'ne Sau muß sie sich\neinschmieren,« redete er vor sich hin und wandte sich nach den\nSchweineställen, die quiekenden Schweine herauszulassen. Hinter ihm\nkam Waupa und versuchte ihm in die Augen zu gucken.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Willst was zu essen? Hier hast ein Stück Brot, da!« Er holte\nein Stück Brot hervor und warf es ihm hin, der Hund fing es auf und\nflüchtete ins Hundehaus, denn die Schweine stürzten auf ihn zu, um\nihm den Bissen zu entreißen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hale, diese Schweine, ganz wie manch' Mensch, nur immer Fremdes\nan sich bringen und 'runterschlingen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Er trat in die Scheune und sah lange auf die am Balken hängende\nKuh.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wenn es auch nur ein dummes Tier ist, sein Ende hat's doch\ngefunden. Morgen werden wir Fleisch zu Mittag haben ... Das ist\nauch alles, was von dir übrigbleibt, daß der Mensch sich Sonntags\nsattessen kann ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Er seufzte auf im Gedanken an das gute Essen und schlurfte\ndavon, um Witek zu wecken ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gleich geht die Sonne auf ... Es ist Zeit, die Kühe auf die\nWeide zu treiben.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Witek murmelte etwas, wehrte sich, schmiegte sich an den\nSchafspelz, mußte aber schließlich doch aufstehen und kroch\nschwerfällig und schlaftrunken im Hof herum.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page79",
      "title": "JohannN/gary"
    }
  }), _vm._v(" Der Bauer\nhatte die Zeit verschlafen, denn die Sonne war schon aufgegangen,\nhatte den Reif gerötet und entzündete Feuerscheine in den Gewässern\nund Fensterscheiben, aber aus dem Wohnhaus kam niemand zum\nVorschein ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Witek saß auf der Schwelle des Kuhstalls, kratzte sich emsig und\ngähnte zwischendurch, und als die Spatzen von den Dächern zum\nBrunnen herunterflatterten und im Trog mit den Flügeln plätschernd\nzu baden begannen, setzte er eine Leiter an und stieg unter die\nTraufe, um nach den Schwalbennestern zu sehen, in denen es heute\neigentümlich still war.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Sind sie erfroren, oder was?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Er fing an, behutsam die erkalteten Vögelchen herauszuziehen und\nsie unters Hemd an seine Brust zu stecken.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Jakob, wißt ihr, die leben nicht, oh!« Er lief nach dem Knecht\nund zeigte ihm die steifen, abgestorbenen Schwalbenkörperchen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Aber Jakob nahm sie nur in die Hand, legte sie gegen das Ohr,\npustete ihnen in die Augen und sagte:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Die sind nur steif, war auch ein Morgenfrost, der sich sehen\nlassen kann, daß die dummen Dinger nicht eher in die warmen Länder\ngegangen sind / na, na ...« Er kehrte an seine Arbeit zurück.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Witek setzte sich inzwischen vors Wohnhaus an der Giebelseite\nnieder, weil die Sonne da schon schien und die geweißten Wände\nübergoß, auf denen die Fliegen anfingen herumzukriechen; er zog die\nVögel hervor, die, durch seinen Körper erwärmt, sich schon etwas\nbewegten, hauchte sie an, öffnete ihnen die Schnäbel und tränkte\nsie aus dem eigenen Munde / bis sie sich belebten, die Augen\nöffneten und ihm zu entschlüpfen versuchten; dann hielt er die\nRechte lauernd gegen die Wand, langte sich hin und wieder die eine\noder andere Fliege, fütterte einen Vogel und ließ ihn los.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page80",
      "title": "lesebaer/gary"
    }
  }), _vm._v(" »Fliegt\nhin zur Mutter, fliegt!« flüsterte er, die Schwalben beobachtend,\nwie sie sich auf den First des Kuhstalls setzten, sich mit den\nSchnäbeln putzten und wie zum Dank zwitscherten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und Waupa saß vor ihm und winselte possierlich; sobald ein Vogel\naufflog, warf er sich ihm nach, lief einige Schritte und kehrte auf\nseinen Beobachtungsposten zurück ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Da, kannst den Wind im Feld fangen,« murmelte Witek, und war so\nmit seiner Tätigkeit des Aufwärmens der Vögel beschäftigt, daß er\ngar nicht sah, daß Boryna um die Ecke des Hauses kam und vor ihm\nstehenblieb.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wirst du hier mit den Vögeln spielen, du Aas, was?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Der Junge sprang auf, um davonzustürzen, aber der Bauer griff\nihn fest ins Genick und knüpfte rasch mit der anderen Hand den\nbreiten, harten Ledergurt ab.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Nicht schlagen, nicht schlagen!« hatte er nur noch Zeit\naufzuschreien./")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»So'n Hirt bist du, was? So hütest du, was? Die beste Kuh hast\nzuschanden gemacht, was ... du Landstraßenbalg, du Warschauer\nMistgeburt, du!« und er schlug sinnlos, wohin er traf, daß der\nLederriemen sauste. Der Junge wand sich wie 'n Aal und heulte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Schlagt nicht! Mein Gott! Er macht mich tot! Bauer! ... O\nJesus, Hilfe! ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Selbst Anna sah hinaus, was geschehen war, und Jakob spuckte aus\nund verschwand in den Stall.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Boryna aber prügelte ihn windelweich, er gerbte ihm seinen\nVerlust so wütig aufs Fell, daß Witek schon ein blaues Gesicht\nhatte und das Blut ihm aus der Nase lief. Er schrie\ngottsjämmerlich, riß sich wie durch ein Wunder los, griff mit\nbeiden Händen hinten an die Hosen und rannte auf die Hecken zu.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Jesus, sie haben mich totgeschlagen, totgeschlagen haben sie\nmich!« brüllte er und lief dermaßen, daß ihm der Rest der Schwalben\nherausfiel und auf dem Weg liegenblieb.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page81",
      "title": "lesebaer/gary"
    }
  }), _vm._v(" Boryna\ndrohte ihm noch nach, umgürtete sich und kehrte ins Haus zurück,\nauf Anteks Seite eintretend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Die Sonne ist schon zwei Mann hoch, und du liegst noch herum!«\nfuhr er seinen Sohn an.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hab' mich gestern genug, wie ein Vieh, abgeschunden, da laß ich\nmir jetzt was zukommen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich fahr' aufs Gericht ... hol' du die Kartoffeln ein, und wenn\ndie Leute mit dem Ausnehmen fertig sind, dann sollen sie Streu\nharken, und du könntest die Pflöcke eintreiben, damit wir für den\nWinter die Wände mit Faschinen schützen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Belegt euch das Haus selbst mit Faschinen, uns weht es hier\nnicht.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Du hast es gesagt ... Dann werde ich meine Seite belegen und du\nkannst frieren, wenn du so 'n Lüderjan bist.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Er knallte die Tür zu und ging auf seine Seite.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Fine hatte schon Feuer gemacht und machte sich auf den Weg, die\nKühe zu melken.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gib rasch das Essen, denn ich fahre gleich ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich soll mich wohl zerreißen, zwei Arbeiten auf einmal kann\nkein Mensch tun,« meinte sie und ging.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Nicht einen ruhigen Augenblick hat man, man kann nur immer den\nLeuten die Zähne zeigen!« dachte er und zog sich um, er war\nverärgert und aufgebracht. »Wie soll man denn auch nicht, dieser\newige Krieg mit dem Sohn, nicht ein Wort kann man sagen, sonst\nspringt er einem mit den Krallen an die Augen, oder sagt was, daß\nman es bis in die Eingeweide fühlt. Auf niemanden kann man sich\nverlassen, nur schuften, immer wieder schuften!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Der Ärger stieg in ihm, so daß er leise vor sich hin fluchte und\nmit seinen Kleidungsstücken und Stiefeln um sich warf.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gehorchen sollten die, und tun es doch nicht! Warum denn das?«\nüberlegte er.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Mir deucht, ohne einen Knüttel geht's nicht mit ihnen, und das\nnicht ohne einen derben! Lange schon haben sie es "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page82",
      "title": "lesebaer/gary"
    }
  }), _vm._v(" verdient, gleich nach dem\nTode der Seligen, als sie anfingen, sich um das Land zu reißen,«\naber er hatte es sich immer noch überlegt, um nicht im Dorf das\nböse Beispiel zu geben. Er war doch nicht der erste beste Bauer,\nauf dreißig Morgen saß er, und von Geburt war er auch nicht\nirgendeiner, Boryna doch, das weiß man! Aber mit Güte kommt man bei\ndenen zu keinem Ende. Hier kam ihm sein Schwiegersohn, der Schmied,\nin Erinnerung, der alle im stillen aufhetzte und ihm auch selbst\nimmerfort in den Ohren lag, daß man ihm sechs Morgen und einen\nMorgen Wald abschreiben sollte; auf den Rest würde er schon warten\n...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wenn ich sterbe, meint er! Wart' du man, Luder, warte,« dachte\ner wütig. »Solange ich meine Knochen schleppe, wirst du nicht eine\nParzelle zu riechen bekommen. Seht mal diesen klugen Mussiö!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Kartoffeln brodelten schon stark auf dem Feuerherd, als Fine\nvom Melken zurückkam und sofort das Frühstück herrichtete.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Fine, und das Fleisch sollst du verkaufen. Morgen ist Sonntag,\nsie wissen schon Bescheid im Dorf, da werden sie schon gerannt\nkommen; nur niemand was borgen. Die Keule laß für uns; Ambrosius\nwollen wir bestellen, der kann sie pökeln ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Aber das kann doch auch der Schmied ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Jawohl, und teilen würde der, wie der Wolf mit dem Schaf.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Magda wird sich grämen, von wegen weil es unsere Kuh ist und\nsie selbst davon nichts zu sehen kriegt.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Dann schneide für Magda einen Teil heraus und trag' es ihr hin,\naber der Schmied soll nicht kommen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gut seid ihr, Väterchen, gut seid ihr.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Nana, Mädel, nana. Paß du hier auf und ich werd' dir schon 'ne\nSemmel mitbringen, oder sonst was Schönes.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Er aß sein tüchtiges Teil, umgürtete sich mit dem Gurt, "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page83",
      "title": "lesebaer/gary"
    }
  }), _vm._v(" glättete mit\nbespuckter Handfläche die spärlichen, widerspenstigen Haare, nahm\nseine Peitsche und sah sich im Zimmer um.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Daß ich nichts vergesse.« Er hatte Lust, in die Butze\nhineinzugucken, doch er hielt sich zurück, denn Fine äugte zu ihm\nherüber; so bekreuzigte er sich denn nur und machte sich auf den\nWeg.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und schon auf seinem Wagen aus Weidengeflecht rief er, die\nHanfzügel raffend, Fine zu.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wenn sie mit den Kartoffeln fertig sind, sollen sie gleich\nStreu harken gehen, die Quittung ist hinter dem Bild, 'ne Hainbuche\noder eine Fichte können sie auch noch fällen/die kann man\nbrauchen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Der Wagen ruckte an; er war schon zwischen den Hecken, als Witek\nan den Apfelbäumen vorübersauste.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das hab' ich noch vergessen ... prrr ... Witek! Prrr! Witek,\nbring' die Kühe auf die Wiese, paß' aber auf, sonst werde ich dich\nBiest so durchbläuen, daß du an mich denken sollst!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»He-He, ihr könnt mir was ... küssen ...!« schrie er ihm trotzig\nzurück, hinter der Scheune verschwindend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Willst du noch hier das Maul aufreißen, hüte dich, wenn ich\n'runter komm! ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Er wendete vom Heckenweg links ab auf die Straße, die zur Kirche\nführte, und gab der Jungstute einen Peitschenhieb, so daß sie\ngemächlich trabend auf dem ausgefahrenen steinigen Weg\ndahinzuckelte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Sonne war schon ein weniges über den Hütten hervorgekommen\nund schien immer wärmer, daß die bereiten Strohdächer anfingen zu\ntropfen und zu dünsten, nur im Schatten, an den Zäunen der\nObstgärten und in den Gräben lag noch der weiße Frost. Über den\nWeiher schleppten sich die letzten dünnen Nebel, und das Wasser\nfing an, unter seinen Nebelhäuten Glanz zu brauen und die Sonne\nblitzend zu spiegeln.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page84",
      "title": "lesebaer/gary"
    }
  }), _vm._v(" Im Dorfe\nbegann das alltägliche Treiben: der Morgen war hell und kühl, und\nda der Frühreif die Luft erfrischt hatte, rührte man sich munterer\nund lärmender; haufenweise zogen sie auf die Felder; die einen\ngingen zum Kartoffelausnehmen, Hacken und Körbe schleppend, sie\nkauten noch an ihrem Frühstück; andere zogen mit dem Pflug auf die\nStoppelfelder; etliche kamen, die Eggen auf ihrem Leiterwagen\nhatten und Säcke voll Saatkorn; und andere mit geschulterten Harken\nschlugen den Weg nach den Wäldern ein, um Nadelstreu fürs Vieh zu\nholen./Das Getöse und Geschrei von beiden Seiten des Weihers wurde\nimmer stärker, denn auf den Wegen drängte sich das Vieh, das auf\ndie Weide zog, Hundegebell und Zurufe drangen aus den niedrigen\nschweren Staubwolken, die sich von den taufeuchten Wegen\nerhoben.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Boryna wich den Herden behutsam aus, manchmal langte er einem\nLämmlein, das zu dumm war, vor seinem Pferd auszuweichen, eins\nübers Fell oder verscheuchte ein Kalb, bis er alle überholt hatte;\nneben der Kirche, die herbstgelbe Linden und Ahorne wie mit einem\ngewaltigen Wall umschlossen, bog er auf die breite Heerstraße ab,\ndie zu beiden Seiten von einer langen Reihe mächtiger Pappeln\neingesäumt war.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("In der Kirche wurde gerade die heilige Messe zelebriert, denn\ndie Betglocke hatte zur Konsekration geläutet, und die Orgel tönte\nmit leiser Stimme. Er nahm den Hut ab und seufzte fromm auf.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Der Weg, den dichte Schattenstreifen durchschnitten, die die\nStämme der Pappeln warfen, weil die Sonne von der Seite schien, war\nleer und mit gefallenem Laub so dicht bedeckt, daß die Löcher und\nSchneisen unter einer rostiggoldenen Decke lagen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wioh, Kleine, wioh!« Die Peitsche sauste durch die Luft, und\ndie Stute lief etwas munterer ein paar Klafter weit, aber dann ließ\nsie nach und schleppte sich langsam, "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page85",
      "title": "DaoH/gary"
    }
  }), _vm._v(" denn der Weg stieg, wenn auch unmerklich, zu\nden Hügeln hinauf, auf denen die schwarzen Wälder standen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Boryna, der durch die Stille, die ihn umgab, wie benebelt war,\nsah durch die Säulenreihe der Pappeln auf die im rosigen\nMorgenlicht gebadeten Felder, dann versuchte er über die\nGerichtssache mit der Eve nachzudenken und auch über die Bunte,\ndoch es überfiel ihn das Duseln so stark, daß er nicht gegen\nangehen konnte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die kleinen Vögel zirpten in den Zweigen und manchmal glitt der\nWind mit leichten Fingern über die Schöpfe der Bäume, so daß hier\nund dort sich ein Blatt, wie ein goldener Falter, vom Mutterzweig\nlöste und kreisend auf den Weg fiel oder auch auf die staubigen\nDisteln, die mit brandigen Blütenaugen trotzig in die Sonne\nstarrten/und die Pappeln Huben an, miteinander zu reden, flüsterten\nleise mit den Zweigen und schwiegen ganz, als ob sie Dorfbasen\nwären, die beim Emporheben des heiligen Sakraments die Augen\naufwärtsrichten, die Arme auseinanderbreiten und im Gebet\naufseufzen, um gleich darauf in den Staub zu sinken vor der\nverborgenen Majestät in jener goldenen Monstranz, die über der Erde\nhing, über der heiligen, heimatlichen ..")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Erst dicht am Wald wurde er ganz munter und hielt das Pferd\nan.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Der geht nicht schlecht auf,« meinte er, die graue Ackerfläche\ngegen das Sonnenlicht beäugend, die die keimende Roggensaat wie mit\neiner kurzen rostroten Bürste bedeckte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Ein gutes Stück Feld, und gerade neben meinem liegend, als ob\njemand das mit Absicht so gemacht hätte. Den Roggen haben sie,\ndeucht mir, gestern erst gesät. Er seufzte auf, die frisch\nzugeeggten Ackerbeete mit gierigem Blick umfassend und fuhr in den\nWald hinein.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Das Pferd trieb er jetzt häufiger an, weil der Weg durch ebenes\nGelände ging und härter war, aber das Wurzelwerk hatte ihn ziemlich\ndurchwachsen, und der Wagen holperte darüber mit lautem Rollen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page86",
      "title": "DaoH/gary"
    }
  }), _vm._v(" Er war ganz\nwach geworden durch den herben, kühlen Atem des Waldes.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Der Forst war gewaltig und alt/als dicht gedrängte Masse stand\ner in der vollen Majestät seiner Jahre und seiner Kraft, Baum an\nBaum, lauter Kiefern fast, dazwischen oft eine breitästige,\naltersgraue Eiche, und Birnek zuweilen in weißen Hemden mit\nauseinandergeflochtenen gelben Zöpfen, da es Herbst war. Das\ngeringere Buschwerk, Haseln, krüppelige Hainbuchen, zitternde\nEspen/ scharten sich um die roten mächtigen Stämme, die dermaßen\nmit ihren Kronen und Ästen ineinander verzweigt waren, daß das\nSonnenlicht nur spärlich hier und da sich hindurchzwängte und wie\ngoldene Spinnen über Moose und rostig-grüne Farnkräuter kroch.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Immerhin sind hier vier Morgen mein!« dachte er, verschlang den\nWald mit den Blicken und wählte schon dem Auge nach das Beste.\n»Herr Jesus wird's nicht zugeben, daß uns Unrecht geschieht/auch\nwerden wir's selbst nicht zulassen, nein ... Das Gut glaubt, es ist\nviel, was wir beanspruchen, wir glauben, es ist wenig ... Darum\nsind meine doch vier und Jaguscha kommt ein Morgen zu ... dann\nhaben wir vier und eins zusammen ... Wioh! Dumme, wirst Angst vor\nElstern haben!« Er klatschte ihr leicht über den Rücken, denn auf\ndem verdorrten Baum, an dem Christi Marter hing, zankten sich mit\nwütigem Geschrei die Elstern, so daß die Jungstute die Ohren\nspitzte und stehenblieb.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Elsternhochzeit/Regenzeit.« Er heftete ihr ein paar\nPeitschenhiebe an und fuhr im Trab weiter.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Es war schon gut nach acht, denn die Menschen auf den Feldern\nsetzten sich gerade an die Frühstücks-Zweierkrüge, als er in Tymow\neinfuhr; die leeren Straßen des Städtchens waren mit baufälligen\nHäusern umstellt, die wie alte Hökerinnen über den Rinnsteinen voll\nangesammelter Schmutzhaufen saßen, zwischen denen sich Hühner,\nzerlumpte Judenkinder und Schweine tummelten ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page87",
      "title": "DaoH/gary"
    }
  }), _vm._v(" Gleich an\nder Einfahrt umringten ihn die Juden, und alsbald ging es ans\nHerumstöbern und Hineintasten ins Erbsenstroh unter dem Sitz des\nKorbwagens – ob er nicht etwas Verkaufbares mitbrächte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Fort, grindiges Pack! ...« murrte er, den Wagen nach dem\nMarktplatz lenkend, wo schon etliche Wagen mit ausgespannten\nPferden daneben hielten, im Schatten alter zerzauster\nKastanienbäume, die in der Mitte des Platzes im herbstlichen\nAbsterben dastanden.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Dort brachte er auch seinen Korbwagen unter, spannte die\nJungstute aus, stellte sie mit dem Kopf nach dem Wagenkorb hin,\nschüttete ihr Hafer in den Kober und versteckte die Peitsche unter\ndem Wagensitz. Nachdem er seine Kleider vom Stroh gereinigt hatte,\nging er geradeswegs nach Mordka, wo die drei Messingteller\nglänzten, um sich ein wenig ausrasieren zu lassen. Bald darauf kam\ner glatt geschabt wieder zum Vorschein, nur auf dem Kinn hatte er\neinen einzigen Schnitt, der mit Papier verklebt war, durch das noch\netwas Blut sickerte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Gerichtssitzungen hatten noch nicht begonnen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Aber vor dem Gerichtsgebäude, das gleich vorne am Marktplatz\nstand, gegenüber einer großen Kirche, die ehemals zu einem Kloster\ngehörte, wartete schon viel Volk. Sie saßen auf den ausgetretenen\nStufen, oder scharten sich vor den Fenstern, um einmal ums andere\nins Innere zu spähen; die Frauen hockten an den geweißten Wänden\nentlang, hatten die roten Schürzen vom Kopf auf die Schultern\ngleiten lassen und schwadronierten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Boryna wurde, als er Eve mit dem Kind auf dem Arm entdeckte, wie\nsie im Haufen ihrer Zeugen stand, sofort wütig, denn der Jörn kam\nihn leicht an, er spie aus und betrat den langen Flur, der das\nGerichtsgebäude quer durchlief.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Linkerhand lagen die Gerichtszimmer und rechts hatte der\nGerichtsschreiber seine Wohnung; gerade hatte Hyacinthus "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page88",
      "title": "DaoH/gary"
    }
  }), _vm._v(" den Samowar auf die\nSchwelle gesetzt und schürte die Glut mit dem Schaft eines\nKrempstiefels so eifrig an, daß der Samowar wie ein Fabrikschlot\nqualmte und jeden Augenblick schnarrte eine verärgerte Stimme aus\ndem Hintergrund des qualmerfüllten Flurs.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hyacinth! die Stiefel für die Fräulein!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gleich, gleich!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Der Samowar brauste schon wie ein Vulkan und spie Flammen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hyacinth! Wasser zum Waschen für die Gnädige.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gleich doch, alles wird sich machen, alles!« Und schwitzend,\nhalb von Sinnen jagte er im Flur herum, daß es dröhnte, kehrte um,\nschürte wieder und raste wieder zurück, denn die Gnädige\nschrie.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hyacinthus! Du Lümmel, wo sind meine Strümpfe! ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Oh, du mein! Ein Aas, nicht 'n Samowar!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Das alles dauerte ein paar gute Paternoster oder vielleicht auch\nso lange wie man einen Rosenkranz betet, bis schließlich die\nGerichtstüren sich öffneten und das Volk die große weißgekalkte\nStube zu füllen begann.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Hyacinth, jetzt schon als Gerichtsdiener, barfuß in hellblauen\nHosen und in einer kurzen Jacke von der gleichen Farbe mit\nMessingknöpfen dran und mit einem roten schwitzigen Gesicht, das er\nimmer wieder mit dem Ärmel wischte, machte sich eifrig hinter dem\nschwarzen Gitter zu schaffen, das die Stube in zwei Hälften teilte.\nEr schüttelte den Kopf, wie ein Pferd, das eine Bremse sticht, und\ndie flachsblonden Haare fielen ihm wie eine Mähne über die Augen,\noder er sah behutsam in die Nebenstube und setzte sich auf einen\nAugenblick am grünen Ofen nieder.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Es hatte sich soviel Volk hineingedrängt, daß man nicht einmal\neinen Finger dazwischenstecken konnte, sie drängten immer stärker\ngegen die Schranke an, die schon zu krachen anfing; das erst noch\nleise Stimmengewirr steigerte sich allmählich, bis es wie ein\nSausen klang, das durch die Stube "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page89",
      "title": "DaoH/gary"
    }
  }), _vm._v(" fuhr und zuweilen aufbrauste und hier und da\nzu einem deutlich vernehmbaren Gezänk wurde, bei dem die Kraftworte\nimmer dichter fielen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Unter den Fenstern babbelten die Juden, und ein paar Weiber\nerzählten laut von dem Unrecht, das man ihnen angetan hatte und\nweinten noch lauter dazu, aber man konnte nicht auseinanderkennen,\nwo und wer es war, denn Kopf an Kopf gedrängt stand die Menge da,\nwie ein Roggenfeld voll roter Mohnblumen, über das der Wind\nstreicht, und das aufschaukelt und raunt und rauscht, und dann\nstehenbleibt Ähre neben Ähre. Auch Eve, die den an die Schranke\ngelehnten Boryna erspäht hatte, fing an zu schreien und ihm giftige\nBemerkungen zuzuwerfen, so daß er beleidigt und im scharfen Ton ihr\nantwortete.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Schweig still, du Hündin, sonst werde ich dir deine Knochen\nnachzählen, daß dich die eigene Mutter nicht auskennt.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Als Antwort darauf stürzte sich Eve mit gespreizten Krallen\ngegen ihn und fing an, sich durch das Menschendickicht\nhindurchzudrängeln, das Kopftuch rutschte ihr vom Kopf und das Kind\nbegann zu schreien. Gott weiß, womit es geendet hätte, wenn\nHyacinth, der Gerichtsdiener, nicht plötzlich aufgesprungen wäre\nund die Tür aufreißend gerufen hätte:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Still, Aaszeug, das Gericht kommt! ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Das Gericht trat ein; voraus der dicke, hohe Erbherr auf\nRaciborowice, und hinter ihm zwei Schöffen und der\nGerichtssekretär, der sich an ein Nebentischchen am Fenster setzte,\ndie Papiere ausbreitete und zu den Richtern hinüberblickte, die\nhinter einem großen mit rotem Tuch bedeckten Tisch stehengeblieben\nwaren und die goldenen Ketten um die dicken Nacken legten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Es wurde still, nur die Stimmen der Leute, die auf der Straße\nvor den Fenstern sprachen, hörte man noch.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Der Erbherr legte die Papiere auseinander, räusperte sich,\nblickte auf den Sekretär und kündete mit tiefer weit "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page90",
      "title": "DaoH/gary"
    }
  }), _vm._v(" vernehmbarer Stimme an, daß\ndie Gerichte begonnen hätten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Darauf las der Sekretär die auf diesen Tag fallenden Termine vor\nund flüsterte dann etwas dem ersten Schöffen zu, der es dem Richter\nweitergab, welcher bejahend mit dem Kopf nickte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Gerichtssitzung nahm ihren Lauf.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Zuerst kam die Klage eines Flurjägers gegen einen Stadtfratz\nwegen Verunreinigung eines Hofes.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Er wurde in Abwesenheit verurteilt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Dann eine Klage wegen Verprügelung eines Jungen, der die Pferde\nim fremden Klee geweidet hatte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Man einigte sich/die Mutter bekam fünf Rubel und der Junge neue\nHosen und eine neue Jacke.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Ein Termin wegen Einpflügens in ein fremdes Feld.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Vertagt aus Mangel an Beweisen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Ein Termin wegen Waldfrevels im Walde des Richters; der\nVerwalter stand Zeuge/verklagt waren die Bauern aus Rokiciny.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Verurteilt zu Geldstrafen oder zum Absitzen/jeder für zwei\nWochen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie nehmen das Urteil nicht an, sie werden appellieren.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und so laut fingen sie an über die Ungerechtigkeit zu schreien,\ndenn der Wald war gemeinsam, mit Servituten belegt, daß der Richter\ndem Hyacinthus ein Zeichen machte und dieser donnerte los:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Still, still da, hier ist das Gericht, keine Schenke.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("So ging ein Termin hinter dem andern vorüber, gleichmäßig wie\nErdscholle nach Erdscholle und ziemlich ruhig; nur manchmal erhoben\nsich Klagen und Schluchzen oder auch ein Fluch, den Hyacinthus\nsofort unterdrückte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Aus der Gerichtsstube waren schon einige gegangen, und doch war\nes abermals so gedrängt voll geworden, daß die Menschen, wie eine\nGarbe, zusammengepreßt standen, niemand konnte sich rühren, und die\nHitze war so groß, daß "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page91",
      "title": "DaoH/gary"
    }
  }), _vm._v(" man kaum Atem holen konnte, bis der Richter den\nBefehl gab, die Fenster zu öffnen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Jetzt kam die Gerichtssache des Bartek Kosiol aus Lipce; wegen\ndes Diebstahls eines Schweins bei Marziana Antonowna Patsches.\nZeugen: dieselbe Marziana, ihr Sohn Simeon und Barbara Kleinhund\n...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Die Zeugen zugegen?« fragte ein Schöffe.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Sind da!« riefen sie zusammen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Boryna, der bis jetzt geduldig und für sich an der Schranke\ngelehnt hatte, schob sich etwas näher zur Patscheswittib heran, um\nsie zu begrüßen, weil sie Jagnas Mutter, die Dominikbäuerin\nwar.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Der Beklagte, Bartek Kosiol, näher vor die Schranke.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Ein untersetzter Bauer, drängte mitten aus der Menge so heftig\nnach vorne, daß man zu fluchen begann, er träte die Leute und\nzerreiße die Kleidung.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Still, Aaszeug, das hochlöbliche Gericht spricht,« schrie\nHyacinth, den Bauer vorlassend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Seid ihr Bartholomäus Kosiol?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Der Bauer kratzte sich besorgt über das dichte, in einer geraden\nLinie verschnittene Haar; ein dummeliches Lächeln verzog sein\ndürres ausrasiertes Gesicht, und die kleinen rotbebuschten Äuglein\nsprangen wie Eichhörnchen schlau von Richter zu Richter.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Seid ihr der Bartholomäus Kosiol?« fragte der Richter abermals\nden schweigenden Bauer.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Sehr wohl, dieser hier ist der Bartholomäus Kosiol zu dienen\nder hochlöblichen Gerichtsamkeit!« piepste mit einmal eine\ngewaltige Frau, die sich energisch vor der Schranke\naufpflanzte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und ihr, was wollt ihr?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Bin doch die Frau, euer Hochwohlgeboren zu dienen, die Frau von\ndem mageren Schlucker da, dem Bartek Kosiol,« und sie grüßte mit\nder Hand bis zur Erde, so daß die gezängelte Haube an dem\nRichtertisch haken blieb.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page92",
      "title": "DaoH/gary"
    }
  }), _vm._v(" »Seid ihr\nZeuge?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Zeuge sozusagen? nicht ni ..., nur euer Hochwohlgeboren zu\ndienen ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Schmeiß' sie hinter die Schranke, Gerichtsdiener.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Zurück hier, Frau, hier ist kein Platz für euch ...« Er packte\nsie an den Schultern und schob sie hinterrücks der Schranke zu.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich möchte die hochlöbliche Gerichtsamkeit untertänigst gebeten\nhaben, weil Meiner nicht gut hören kann, sozusagen ...,« schrie\nsie.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Zurück solange ich gut bin!« Sie schnaufte, so hatte er sie\ngegen die Schranke geschoben, denn sie wollte keinen Schritt im\nguten weichen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Geht hinaus, wir werden laut reden, dann hört er schon und wenn\ner auch nur euer Kosiol ist.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Untersuchung begann.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wie ist der Name.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hää? ... Name? ... Haben doch gerufen, den wissen Sie doch\n...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Dummkopf. Wie ihr euch nennt?« forschte der Richter\nunerbittlich weiter.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Bartek Kosiol, hochlöbliche Gerichtsamkeit,« warf die Frau\ndazwischen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wie alt?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hää? alt? ... kann ich das wissen! Wieviel Jahr' Mutter?\n...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Zweiundfünfzig kann er schon im Frühjahr werden, mein'\nich.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hofbauer?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ih ... schöner Bauer... drei Morgen Land und ein Kuhschwanz\ndazu.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Schon vorbestraft?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hää? bestraft? ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ob ihr gesessen habt?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Im Kriminal meint ihr? ... von wegen Strafe? ... Mutter, war\nich denn im Kriminal, he? ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page93",
      "title": "rudi49/gary"
    }
  }), _vm._v(" »Das warst\ndu, Bartek, das warst du, da haben dich doch die Biester von dem\nGutshof wegen dem toten Lämmlein ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Is wahr, is wahr ... auf der Weide habe ich ein verrecktes Lamm\ngefunden ... da hab' ich's mitgenommen, was sollen's die Hunde\nauseinanderschleppen ... verklagt haben sie mich, geschworen, daß\nich gestohlen hab', das Gericht hat verurteilt ... Sie haben mich\neingesteckt, da hab' ich auch gesessen ... Ungerechtigkeit, nur\nUngerechtigkeit immer ...,« redete er dumpf und sah sich unmerklich\nnach seiner Frau um.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ihr seid angeklagt wegen Diebstahl eines Mutterschweins der\nMarziana Patsches! Ihr habt es vom Feld genommen, nach Hause\ngetrieben, abgeschlachtet und aufgegessen. Was habt ihr zu eurer\nVerteidigung zu sagen? ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hää? Aufgegessen! Daß ich den lieben Gott nicht bei meinem Tode\nsehe, wenn ich sie gegessen hab' ... Oh, Herr, aufgegessen! ... Oh,\nüber diese Welt, diese Welt, ich hab' sie aufgegessen!« rief er\nklagend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Was könnt ihr denn zu eurer Verteidigung sagen?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Verteidigung? ... sollt' ich was zu sagen haben, Mutter? ...\nJawohl, ich weiß schon; ich bin nicht schuldig, das Schwein hab'\nich nicht gegessen, aber dem Dominik sein' Wittib, mein' ich, bellt\nsich was, wie 'n Hund, daß man ihr nur so an die Schnauze langen\nsollte und verprügeln ... ah ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Menschenkinder, hört ihn bloß ...,« stöhnte die\nDominikbauerin.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das könnt ihr euch für später aufheben, erzählt nur jetzt, wie\nes kam, daß das Schwein der Patsches sich bei euch vorfand?\n...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das Schwein der Patsches ... bei mir? ... Mutter, was meint der\nhochwohlgeborene Erbherr? ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das ist doch wegen dem Ferkel, Bartek, das dir bis in die Hütte\nnachgekommen ist ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page94",
      "title": "clehners/gary"
    }
  }), _vm._v(" »Ich\nweiß schon, jawohl, ich weiß schon, ein Ferkel war das und gar kein\nSchwein, zu dienen dem Hochwohlgeborenen Gericht, man soll es\nhören, was ich gesagt habe, ich tu' es aussagen; ein Ferkel war es\nund kein Schwein; ein weißes Ferkel und schwarz gefleckt am Schwanz\noder noch etwas tiefer.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gut, wie hat sich das zu euch gefunden?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Zu mir, zum Beispiel? ... Gleich will ich alles gründlich\nerzählen, woraus sich ergeben wird vor dem hochlöblichen Gericht\nund vor allem Volk/daß ich nicht schuldig bin und die\nDominikwittib/ein Zigeuner, ein Klatschmaul und eine verdammte\nZunge ist! ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich betrüge! Bei der allerheiligsten Jungfrau will ich\nerflehen, daß dich der Blitz trifft ohne die heilige Beichte!«\nsagte die Dominikbäuerin leise, mit einem schweren Seufzer zum Bild\nder Mutter Gottes aufsehend, und dann, da sie nicht länger an sich\nhalten konnte, steckte sie die zusammengeballte dürre Faust ihm\nentgegen und zischte:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Du Schweinedieb, du Räuber, du!« ... und sie spreizte die\nFinger, als wollte sie ihn greifen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Aber Bartels Frau warf sich ihr kreischend entgegen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Was, schlagen möchtest du ihn, du Hündin, schlagen, du Hexe, du\nRabenmutter deiner Söhne, du!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ruhe!« rief der Richter.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Maul halten, wenn das Gericht spricht, sonst kriegt ihr das\nAlleinsein zu schmecken!« bekräftigte Hyacinth, die Leinwandhose\nhochziehend, denn der Hosengurt war ihm geplatzt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Es wurde gleich still, und die Weiber, die schon nahe daran\nwaren, einander in die Schöpfe zu fahren, blieben stehen und\nbohrten einander mit den Blicken an, vor Gift nach Atem schnappend\n...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Redet, Bartholomäus, erzählt alles, aber bei der Wahrheit\nbleiben.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Die Wahrheit? ... die reine Wahrheit will ich erzählen, "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page95",
      "title": "clehners/gary"
    }
  }), _vm._v(" rein wie Glas,\nehrlich will ich alles sagen, wie in der Beichte, wie 'n Hofbauer\nzu einem Hofbauer, wie man nur zu seinen Leuten spricht, denn ich\nbin ein Hofbauer vom Großvater und Urgroßvater her, kein Kätner,\nkein Prefessiant oder ein Stadtlump.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das war so.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Guck' gut auf deine Gedanken, damit du nichts vergißt,« rief\nihm die Frau zu.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Nee, ich werd' es nicht vergessen, Magdusch, nee. Das war so.\nIch geh' also ... ich glaube es war gerade Frühjahr... und hinter\nder Wolfskuhle, neben Boryna seinem Klee... ich geh' also und sage\nmein Gebet her, denn wenn ich so sagen soll, hatte man schon zum\nAve geläutet ... Es nächtelte schon ... ich geh' also ... da hör'\nich 'ne Stimme, oder keine Stimme? ... Du lieber Gott, denk' ich,\ngrunzt es oder grunzt es nicht? ... Ich sehe hinter mich – nichts\nzu sehen, ganz und gar still.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Der Böse versucht mich oder was? ... Ich gehe weiter, weil mir\naber etwas wie Ameisen über den Rücken kam, aus Angst, so spreche\nich das Ave für mich hin. Es grunzt wieder! Sieh, denk' ich, nichts\nals 'n Schwein oder auch 'n Ferkel. Ich steig' etwas 'runter in den\nKlee und sehe mich um ... jawohl, irgend etwas kriecht sich, ich\nbleibe stehen/ das bleibt auch stehen, was Weißes, Niedriges und\nLanges ... und die Glotzen leuchteten ihm wie bei einer Wildkatze\noder beim Schlechten ... Ich bekreuzigte mich, und da es mir nur so\nkalt über die Haut fuhr, mach ich, daß ich schneller\nvorwärtskomm'/versteht sich, weiß man denn, was sich in den Nächten\nherumtreibt? ... Und alle wissen es in Lipce, daß es in der\nWolfskuhle umgeht.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das is schon so,« erläuterte die Frau, »denn voriges Jahr, als\nder Kohlmeis dort nachts vorüberging, hat ihn irgendwas an die\nGurgel gepackt und zu Boden geschmissen und so verhauen, daß der\nMann zwei Wochen krank gelegen hat.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page96",
      "title": "Wunibald/gary"
    }
  }), _vm._v(" »Sei man\nstill, Magdusch, sei man still! Ich gehe also, ich gehe und gehe\n... und dieses kommt immerlos nachgekrochen und grunzt!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und da gerade das helle Mondlein herausgekommen ist, sehe ich /\ndas ist ja nur 'n Ferkel und nichts Schlechtes. Ich wurde\närgerlich, was bildet sich das dumme Vieh ein / den Menschen bange\nmachen, da hab' ich einen Zweig danach geschmissen und gehe heim.\nIch ging auf dem Feldrain zwischen Michaels Rüben und Boryna seinem\nWeizen, und dann zwischen Tomeks Sommerkorn und Jasieks Hafer, den,\nmein' ich, den man voriges Jahr zum Militär genommen hat, und dem\nseine Frau von gestern her im Kindbett liegt ... Und das Ferkel wie\n'n Hund immer wieder hinter mir drein, einmal nebenher, dann ab in\ndie Kartoffeln der Dominikwittib, und hier wird geschnüffelt, und\nda wird geschnüffelt, und hier wird gegrunzt und da wird gequiekt,\naber zurückbleiben, nein, immer wieder hinter mir drein ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Ich biege auf den Fußweg, der querfeldein geht – und das Ferkel\nauch. Da ist mir aber die Hitze angekommen, denn Herr du meine\nGüte, so 'n Schwein, das ist vielleicht gar kein Schwein! Ich biege\nauf den Weg neben dem Kruzifix, und das Ferkel auch... Weiß war es,\ndas sah ich, und weiter unten beim Schwanz schwarzgefleckt. Ich\nüber den Graben, es kommt mir nach; ich über die Grabhügel hinterm\nKruzifix/es kommt mir nach, ich auf den Steinhaufen d'rauf, und wie\nes sich mir zwischen die Beine schmeißt, da lieg' ich schon im\nDreck so lang ich bin. Ich denk', es is besessen oder was soll\npassieren! ... Kaum hab' ich meine Glieder wieder zusammen / und\ndas Ferkel, heidi den Schwanz hoch und in Sprüngen vor mir her!\nRenn' du nur, Pestige, hab' ich mir gedacht. Aber weglaufen, nee,\nimmer nur vor mir her ist es gerannt bis zu meiner Hütte / ganz bis\nzu meiner Hütte, hochlöbliches Gericht, bis in die Umzäumung ist es\nreingegangen, in den Flur auch, und weil die Tür offen "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page97",
      "title": "Frank_9901/gary"
    }
  }), _vm._v(" war,\ndirektemang in die Stube... So helfe mir Gott, Amen!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und dann habt ihr sie geschlachtet und aufgegessen, nicht\nwahr?« sagte der Richter amüsiert.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hä! Geschlachtet und aufgegessen? ... Ja, was sollten wir denn\ntun? Ein Tag geht vorüber / das Ferkel geht nicht weg; eine Woche /\nes ist immer noch da, gar nicht wegzutreiben, und schmeiß' ich es\nraus, kommt es mit Gequiek wieder zurück ... Die Meinige steckte\nihm zu, was wir über hatten, was sollten wir machen, verhungern\nlassen, ih nee, so was tut man doch nicht, ist doch auch 'n\nGeschöpf Gottes ... Das hochlöbliche Gericht ist klug, da wird es\nsich schon gerecht auslegen, daß ich armer Schlucker mit ihr so\numgehen mußte! Niemand holt sie und zu Hause nichts zu essen / und\ngefressen hat sie, daß zwei andere nicht so viel verschlingen ...\nNoch 'n Monat und sie hätte uns mit Haut und Haar mit aufgefressen\n... Was sollten wir tun? sollte sie uns / so haben wir sie selbst\naufgegessen und dazu noch nicht die ganze, denn im Dorf haben sie's\nzu hören gekriegt, und die Dominikbäuerin hat geklagt, den\nSchultheiß hat sie mir ins Haus gebracht und weggeholt haben sie\nmir alles ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Alles? Und die ganzen Hinterschinken, wo sind die geblieben,\nwas? ...« zischte die Dominikbäuerin drohend hervor.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wo? Fragt mal den Krutschek und andere Köter. / Für die Nacht\nhaben wir es in die kleine Scheune gebracht. Die Hunde, was so\nBiester für Witterung haben / und dabei hat die Scheunentür noch\nLöcher / haben sie 'rausgeschleppt und sich ein Fest gemacht, aus\nmeiner mühseligen Arbeit, daß sie 'rumgelaufen sind dickgefressen,\nwie die reinen Herren.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das Schwein ist, hast du nicht gesehen, von selbst ihm\nnachgelaufen, das glaubt ihm ein Dummer, aber nicht das Gericht.\nDiebsgesindel! und das Schaf, wer hat das "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page98",
      "title": "Frank_9901/gary"
    }
  }), _vm._v(" dem Müller gestohlen und\nHochwürden seine Gänse / was? ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hast du es gesehen, was? Hast du es gesehen!« kreischte Kosiols\nFrau auf, mit den Krallen heranspringend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und die Kartoffeln aus der Kartoffelgrube vom Organist, wer hat\nsie? ... Und immerzu is im Dorf was weg, einmal is es man 'n\nGänschen, denn wieder 'n Huhn, und dann wieder ein Stück Hausrat,«\nsetzte sie unerbittlich fort.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Du Aas! Und was hast du getrieben, wie du jung warst, man weiß,\nwas stellt die Deine mit den Burschen an, das wirft dir niemand\nvor, und du kläffst noch wie 'n Hund ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hüte dich, an meine Jagna zu rühren! Hüte dich, sonst schlag'\nich dir dein Maul bunt und blau, daß dir ... Hüt' du dich nur! ...«\nbrüllte sie auf, bis ins lebendige Fleisch getroffen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ruhig da, Krakeeler, sonst wird 'rausgeschmissen!«\nbeschwichtigte Hyacinth, seine Hosen zurechtrückend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Das Verhör der Zeugen begann.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Zuerst zeugte die Dominikbäuerin als Geschädigte / sie sagte aus\nmit einer leisen, andächtigen Stimme und schwor alle Augenblicke\nbei der Tschenstochauer Muttergottes, das Schwein sei ihrs, sie\nbekreuzigte sich und schlug sich vor die Brust / es wäre die\nlautere Wahrheit, daß Kosiol die Sau von der Weide gestohlen hätte,\nsie wolle aber keine Strafe dafür von seiten des hochlöblichen\nGerichts, der liebe Herr Jesus möge ihm schon dafür nicht am\nFegefeuer sparen; dagegen forderte sie aber mit mächtiger Stimme\nGericht und Strafe für die Beleidigung, die die Kosiols ihr und\nJagna vor allem Volke angetan.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Darauf zeugte Schymeck, einer von den Söhnen der Dominikbäuerin;\ndie Mütze hing an den wie zum Gebet zusammengefalteten Händen und\nseine Augen waren ununterbrochen auf den Richter gewendet. Mit\neiner kläglichen, geistesabwesenden Stimme sagte er aus, daß die\n"), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page99",
      "title": "Frank_9901/gary"
    }
  }), _vm._v(" Sau der\nMutter gehörte, sie wäre über den ganzen Körper weißlich gewesen\nund hatte nur am Schwanz einen schwarzen Fleck, auch ein\nzerrissenes Ohr habe sie gehabt, denn Boryna sein Waupa hätte sie\nim Frühjahr daran gepackt und sie hätte so geschrien, daß er,\nobgleich er in der Scheune war, es gehört habe ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Dann wurden Barbara Kleinhund und andere aufgerufen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie zeugten der Reihe nach und legten den Schwur ab, Schymek\naber stand immerzu da mit der Mütze in den Händen und gaffte den\nRichter an; Kosiols Frau versuchte sich mit Geschrei, Verleugnungen\nund Flüchen durch die Schranke zu drängen, und die Dominikbäuerin\nseufzte nur das heilige Bild an und blickte auf Kosiol, dessen\nAugen herumsprangen, der herumhorchte und sich immer wieder auf\nseine Magdusch umguckte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Das Volk hörte aufmerksam zu, und immer wieder schlugen\nGeflüster, bissige Bemerkungen oder Gelächter bis zur Balkendecke\nempor, so daß Hyacinth sie mit Drohungen beschwichtigen mußte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Verhandlung dauerte ohne Unterbrechung bis zur Pause,\nwährend der sich das Gericht in die Nebenstube zurückzog, um zu\nberatschlagen. Das Volk war auf den Flur und vor das Haus getreten,\num etwas Luft zu schöpfen: der eine um sich etwas zu stärken, der\nandere um sich mit seinen Zeugen zu besprechen, einer um sich über\nsein Unrecht auszubreiten, ein anderer wiederum um über die\nUngerechtigkeit Klage zu führen und zu fluchen, wie das üblich ist\nbei den Gerichtsterminen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Nach der Gerichtspause und nach dem Vorlesen der Gerichtssprüche\nkam Borynas Fall zur Verhandlung.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Eve stellte sich, das Kind schaukelnd, das in eine Schürze\ngewickelt war, vor die Richter und fing an, weinerlich und klagend\ndas ihr geschehene Unrecht vorzutragen; sie wäre bei Boryna in\nDienst gewesen und hätte gearbeitet bis ihr "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page100",
      "title": "Frank_9901/gary"
    }
  }), _vm._v(" die Füße wie Klumpen wurden,\nnie hätte sie ein gutes Wort gehört, nicht mal 'ne eigne Ecke zum\nSchlafen hätte man ihr gegeben, und für das Essen hätte sie bei den\nNachbarn herumlungern können, und ihren Lohn hätte er ihr\nzurückbehalten, und mit seinem eigenen Kind hatte er sie in die\nWelt hinausgejagt... und zuletzt kam ein heftiger Heulausbruch, und\nsie warf sich mit Geschrei vor den Richtern auf die Knie.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das hat er mir angetan! Das hat er, und dieses hier auch, das\nKind ist sein, durchlauchtigstes Gericht!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Die lügt wie 'n Hund,« murmelte Boryna entsetzt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich lüge?! Alle wissen es doch, das ganze Dorf, daß er ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Daß du 'ne Hündin und ein Rumtreiber bist ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und früher, hochwohlgeborenes Gericht, da nannte er mich Evka,\nseine Evusch und mit noch süßeren Namen, und Perlenschnüre brachte\ner mir, und oftmals 'ne Semmel aus der Stadt und sagte noch: hier\nhast du, Evusch, dich hab' ich am liebsten ... und jetzt, Jesu,\nmein Jesu! ...« sie brüllte los.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»So 'n Lügenmaul, vielleicht hab' ich dich noch mit dem\nFederbett zugedeckt und dir gesagt: schlaf, mein Evusch, schlaf!\n...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die ganze Stube erdröhnte vor Lachen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und habt ihr nicht vielleicht, nein? Wie 'n Hund vor der Tür\nhabt ihr gewinselt, und was habt ihr mir da alles versprochen,\nha?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Du mein Gott, Leute, daß der Blitz nicht solch Scheusal auf der\nStelle trifft!« rief er fassungslos aus.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hochwohlgeborenes Gericht, die ganze Welt hat es gesehen, wie\ner war, ganz Lipce kann es bezeugen, daß ich die Wahrheit spreche.\nIch war doch bei denen in Dienst, da hat er mir immerzu keine Ruhe\ngelassen. Oh, ich arme Waise, ich Arme ... Oh, mein unseliges Los\n... Was konnte ich mich denn gegen solch großes Mannsbild wehren?\n... Geschrien hab' ich, da hat er mich durchgeprügelt und gemacht\n"), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page101",
      "title": "Monne3/Pirki"
    }
  }), _vm._v(" was er\nwollte ... Wo soll ich denn nun abbleiben mit einem so kleinen\nKindelchen, wo nur? ... Die Zeugen werden es sagen und bezeugen!«\nschrie sie zwischen Heulen und Jammern.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Zeugen hatten aber inzwischen nichts ausgesagt als Klatsch\nund Vermutungen, darum begann sie von neuem zu beweisen und zu\nüberzeugen, bis sie zu guter Letzt als endgültigen Beweis, das Kind\nauswickelte und es vor die Richter legte; es strampelte mit den\nnackten Beinchen und schrie gottsjämmerlich.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das hochwohlgeborene Gericht wird selbst sehen, wessen es ist;\nda, grad' dieselbe Kartoffelnase und auch die Triefaugen grad' so\ngrau, wie seine ... Wie ein Ei aufs andere, das ist 'n Boryna, kein\nanderer! ...« rief sie.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Aber auch das Gericht konnte sich nicht länger vor Lachen\nhalten, und das Volk johlte vor Vergnügen. Man sah das Kind an,\ndann wieder den Boryna, und immer wieder fielen die\nBemerkungen:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Schöne Jungfer das, wie 'n geschundener Hund!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Boryna ist 'n Witwer, mag er sich mit der verheiraten, kriegt\ner gleich 'n Hüterjungen mit ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und ruppig is' sie, wie 'ne Kuh im Frühjahr.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Was Feines, ja, aber erst mit Erbsenstroh ausgestopft und in\ndie Hirse gesetzt / die Krähen wird sie vertreiben ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Die Hunde laufen so wie so schon, wenn Evusch durchs Dorf\nkommt! ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und ein Mäulchen hat sie, wie mit Spülwasser begossen...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Weil sie eine gute Hausfrau ist, die wäscht sich nur einmal im\nJahr, will doch Seife sparen ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Den Juden heizt sie die Öfen, da hat sie keine Zeit, ist auch\nkein Wunder! ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Man höhnte immer bissiger und erbarmungsloser, sie aber\nverstummte und sah mit Augen eines gejagten Hundes von einem zum\nanderen. Sie schien etwas zu überlegen ... "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page102",
      "title": "lesebaer/Pirki"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Still da! 'ne Sünde is es, so über die Arme herzuziehen!« rief\ndie Dominikbäuerin so laut, daß alle verstummten, und manch einer\nkratzte sich beschämt den Schädel.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Klage wurde abgewiesen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Boryna fühlte eine gewaltige Erleichterung, denn wenn er auch\nnicht schuldig war, so hatte er doch vor dem Gerede der Leute\nAngst, na ja, und auch deswegen, daß er hätte zahlen müssen/denn\ndas Gesetz ist nun mal so, daß niemand weiß, wen es beim Kragen\nfassen wird/den Schuldigen oder den, der recht hat. Das war nicht\neinmal oder zweimal, nein, zehnmal war es schon so.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Er verließ sofort das Gericht, und in Erwartung der\nDominikbäuerin fing er an, die ganze Angelegenheit noch einmal zu\nüberlegen und in sich abzuwägen. Er konnte noch immer nicht\nbegreifen, warum und zu welchem Zweck Eve geklagt hatte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Nein, das ist nicht ihr Verstand und nicht ihr Kopf, das war\nirgendein anderer, der durch sie nach ihm langte, aber wer nur?\n...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie gingen zu dritt, er, die Dominikbäuerin und ihr Schymek, in\ndie Schenke, einen Trunk zu tun und einen Happen zu essen, denn es\nwar schon spät am Mittag. Und obgleich ihm die Dominikbäuerin\nleichthin erwähnte, daß er sich bei seinem Schwiegersohn, dem\nSchmied, für die Klage der Eve bedanken müßte, konnte er es doch\ngar nicht glauben.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Was sollte der davon haben?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»So viel, daß er euch reizen will, daß er euch Kummer besorgt,\nund daß die Leute über euch lachen. Manch einer ist so, daß er dem\nanderen zum Spaß die Haut vom Leibe schinden möchte.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das ist mir doch merkwürdig, das mit Eve ihrer Verbissenheit!\nDenn ich hab' ihr nichts zu Leid getan, und noch für die Taufe von\ndem Wechselbalg hab' ich Hochwürden einen Sack Hafer gegeben...«\n"), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page103",
      "title": "Monne3/Wunibald"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Die dient beim Müller, dieser aber geht in Kumpanie mit dem\nSchmied ... versteht ihr? ..")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Verstehen tu ich's, aber ich kann mich gar nicht darin\nauskennen! Trinken wir noch einen!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gott bezahl's, Matheus, trinkt zuerst!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie tranken mal und noch einmal, aßen das zweite Pfund Wurst mit\neinem halben Laib Brot. Der Alte kaufte eine Semmelreihe für Fine,\nund sie schickten sich an, aufzubrechen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Setzt euch bei mir 'rauf, Dominikbäuerin, es wird einem mieß so\nallein, wir können zusammen reden ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Recht gern, nur will ich noch einen Sprung ins Kloster machen,\n'n bißchen beten.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie ging, kam aber in der Dauer von zwei Paternostern wieder\nzurück, und sie fuhren ab.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Schymek zuckelte gemächlich hinterdrein, denn er hatte einen\nalten Klepper vor dem Wagen, und die Sandwege waren schlimm. Da er\naber duselig war, denn er hatte nicht die Gewohnheit zu trinken,\nund weil ihn die Gerichtsverhandlung mitgenommen hatte, so wackelte\ner schlaftrunken in seinem Korbwagen hin und her, und wenn er zu\nsich kam, riß er die Mütze vom Kopf, bekreuzigte sich fromm und\nmurmelte, geistesabwesend den Schwanz seiner Mähre anstarrend, als\nwär' er das Gesicht des Gutsherrn aus der Gerichtsstube: »der\nMutter ihre Sau, ganz weißlich, nur am Schwanz der schwarze Fleck\n...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Sonne bog schon nach Westen, als sie in den Wald\neinfuhren.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie redeten kaum viel, obgleich sie nebeneinander auf dem\nVordersitz saßen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Hier und da sagte eins ein Wort, da es doch nicht Sitte ist,\nnebeneinander wie Murmeltiere zu sitzen, aber es war nur grad so\nviel, daß der Schlaf ihnen nicht ankam und die Zunge nicht trocken\nwürde ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Boryna trieb die Jungstute an, denn sie hatte den Gang "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page104",
      "title": "lesebaer/Wunibald"
    }
  }), _vm._v(" verlangsamt\nund war vor Müdigkeit und Hitze bis zur Hälfte der Flanken mit\nSchweiß bedeckt. Hin und wieder pfiff er vor sich hin und schwieg\nsich aus. Er schien etwas durchzukäuen, wägte etwas in seinem\nInnern ab, kalkulierte und blickte oft, aber unmerklich, zur Alten\nhinüber, auf ihr ausgedörrtes, wachsbleiches Gesicht, das zu\nlänglichen Runzeln erstarrt war. Sie bewegte den zahnlosen Mund,\nals ob sie im stillen betete; manchmal zog sie die rote, über den\nKopf geworfene Schürze tiefer in die Stirn, denn die Sonne schien\nihr in die Augen und blieb dann wieder unbeweglich sitzen, nur ihre\ndunkelgrauen Augen glühten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Seid ihr schon mit den Kartoffeln fertig, ha?« begann er\nschließlich.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Versteht sich. Die haben dies Jahr nicht schlecht\ngetragen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wird gut sein, wenn ihr Jungvieh aufziehen wollt.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Einen jungen Eber hab ich in die Mastkoje getan, zu Fastnacht\nkann man ihn brauchen...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gewiß, gewiß ... ich höre, Raphus sein Walek hat mit Schnaps zu\neuch geschickt? ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das haben schon mehr... aber das Geld hätten sie sich sparen\nkönnen ... für solche ist meine Jagusch nicht zu haben, nee...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie hob den Kopf und bohrte sich mit Sperberaugen in ihn hinein,\naber Boryna, der doch ein Mann in Jahren war, nicht irgendein\nWindbeutel, zeigte ein gleichgültiges, kühles Gesicht, aus dem\nnichts herauszulesen war. Lange sprachen sie kein Wort, als wollten\nsie in diesem Schweigen ihre Kräfte aneinander messen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Boryna war es nicht recht, als erster anzufangen, denn wieso\ndenn, er war doch schon in Jahren und der erste Bauer in ganz\nLipce; und wie konnte er denn kurzweg sagen, daß ihm Jagusch recht\nwar?... Er hatte doch seine Ehre und seinen Verstand ... aber da er\nvon Natur aus heißen Blutes war, konnte er kaum an sich halten vor\nArger, daß er "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page105",
      "title": "lesebaer/Wunibald"
    }
  }), _vm._v(" so aufpassen und im Bogen um den Brei\nherumgehen mußte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Dominikbäuerin meinte ihn etwas zu durchschauen und zu\nerraten, was ihm so wider den Strich ging und mißmutig machte, aber\nnicht mit einem Wörtlein half sie nach. Mal sah sie ihn an, mal\nschaute sie vor sich in die Welt, in die Himmelsweiten, und sagte\nwie unabsichtlich:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Eine Hitze haben wir, wie zur Erntezeit.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wie ihr sagt.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("So war es auch, denn den Weg umgaben die mächtigen Wände des\nForstes, die weder Luft noch den leisesten Windzug vom freien Feld\ndurchließen, und die Sonne hing gerade vor ihren Köpfen und brannte\nso, daß die lechzenden Bäume bewegungslos dastanden und die Köpfe\nmatt neigten. Nur hin und wieder ließen sie ein paar bernsteingelbe\nNadeln gleiten, die wirbelnd auf den Weg niedersanken. Der pilzige\nDuft, der von den Kolken kam, der Geruch des Eichenlaubs stieg\nihnen in die Nasen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wißt ihr, es ist mir und auch andern verwunderlich, daß ein\nGroßbauer wie ihr einer seid, der doch nicht den ersten besten\nVerstand hat, und so viel Grund und Boden, und so reputierlich bei\nein und jedem beisteht, gar keine Ehrsucht auf ein Amt hat...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ihr trefft recht, gar keine Ehrsucht hab' ich. Was soll mir\ndas? Schultheiß bin ich ganze drei Jahr gewesen, da hab' ich bar\nGeld zugezahlt. Und was hab' ich mich und meine Gäule dabei\nabgeschunden! was hab' ich mich gegiftet, was für Scherereien hab'\nich gehabt/ein Hund, der auf 'm Feld Wache halten soll, hat's nicht\nschlimmer. Und Niedergang war in der Wirtschaft, lauter Verlust, so\ndaß mir die Meine nicht ein gutes Wort gegönnt hat...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Die hatte auch ihren Verstand, aber ein Amt zu haben ist doch\n'ne Ehre und ein Profit.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Danke schön. Vor dem Gendarm mußt du den Rücken krumm machen,\nden Schreiber um die Beine fassen, und "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page106",
      "title": "lesebaer/Wunibald"
    }
  }), _vm._v(" den ersten besten Esel vom\nAmt auch ... Große Ehre! Werden die Steuern nicht bezahlt, wird\neine Brücke schlecht oder ein Hund toll, kriegt einer eins mit\neiner Runge über den Schädel/wer hat da Schuld?... Der Schultheiß\nhat Schuld, der Schultheiß muß es ausbaden! Jawohl, das ist Profit.\nGerade genug Hühner und Eier und manche Gans hab' ich zum Schreiber\nund aufs Kreisamt getragen ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wahr ist es schon, aber dem Pietrek stößt die Schulzenschaft\nnicht auf, nein; Feld hat er zugekauft und eine kleine Scheune\nangebaut, und Pferde hat er, die reinen Elefanten!...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das stimmt, man weiß nur nicht, was davon übrigbleibt, wenn er\nsein Amt niederlegt...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Glaubt ihr?...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich hab' so meine Augen und merk' schon manches.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Großschnauzig ist er und selbst mit Hochwürden rupft er manche\nKatz, denn Frieden kann er nicht halten.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und daß ihm alles gelingt/das ist nur durch die Frau. Er\namtiert und die hält alles in der Faust.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie schwiegen wieder gut ein Paternoster lang.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und ihr, schickt ihr denn nicht mit Schnaps zu einer?...«\nfragte sie vorsichtig.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ii... bei mir brennt's nicht mehr nach den Weibern, zu alt bin\nich dazu...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Redet nicht, was ihr selbst nicht glauben könnt. Alt ist nur,\nwer sich nicht rühren kann, dem man den Löffel an den Mund heben\nmuß und der auf der Ofenbank hockt und aufs Ende wartet... Ich sah\neuch neulich, wie ihr einen Sack Roggen schlepptet.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Na ja, derb bin ich noch, aber welch eine würde mich\nwollen?...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wer nicht selbst probiert/was weiß der? Seht zu!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Alt bin ich, die Kinder wachsen heran und die erste beste nehm'\nich nicht.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Macht nur 'ne Verschreibung beim Notar, und die Beste wird\nschon nichts gegen euch haben ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page107",
      "title": "lesebaer/Wunibald"
    }
  }), _vm._v("\n»Der Verschreibung wegen! Da hat man die Schweinerei! Für die paar\nMorgen würde selbst die jüngste den Bettler vor der Kirchtür\nheiraten...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und die Mannsleut', die gucken nicht nach dem Heiratsgut?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Antworten tat er nicht mehr, zog aber der Jungstute einen\nsolchen über, daß sie vom Platz weg in Galopp fiel.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie schwiegen lange.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Erst als sie aus dem Wald auf die Felder gekommen waren und\nunter den Pappeln, die am Wegrand standen, entlang fuhren, brauste\nBoryna, in den es inzwischen gegärt und gewühlt hatte, auf.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Für die Hunde ist eine solche Einrichtung in der Welt! Für\nalles mußt du zahlen, für das geringste gute Wort selbst! Schlecht\nist es und schlechter kann es gar nicht sein. Die Kinder selbst\nziehen gegen die Eltern los, keiner gehorcht mehr und alle fallen\nsie übereinander her, wie die Hunde.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das kommt davon, weil sie dumm sind und nicht bedenken, daß sie\nallesamt unter die heilige Erde kommen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Kaum ist der eine oder der andere ausgewachsen, und schon\ngebraucht er sein Maulwerk gegen die Väter, sie sollen ihm sein\nErbteil geben. Über die Älteren machen sie sich nur lustig! Bande,\ndas Dorf ist ihnen zu eng, die alte Ordnung paßt ihnen nicht mehr,\nselbst die Tracht ist schon manchem genierlich!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das ist alles so, weil sie Gott nicht mehr achten ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Darum, und auch nicht darum, aber es steht bös!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und zum Besseren geht's nicht, nein.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wie soll es auch gehen, wer wird sie dazu zwingen?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»'ne Strafe Gottes! denn die Stunde des Gerichtes unseres Herrn\nJesu wird kommen, und sie wird kommen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Aber was vorher noch an Volk zugrunde geht, das bringt niemand\nwieder ein.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Solche Zeiten, es wäre besser, die Seuche käme über das\nLand.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page108",
      "title": "lesebaer/lac"
    }
  }), _vm._v("\n»Zeiten, ja, aber die Menschen sind auch dran schuld. Und so einer\nwie der Schmied zum Beispiel? Oder der Schulze? Mit Hochwürden\nzanken sie 'rum, hetzen die Leute auf, streuen Sand in die Augen\nund die Dummen glauben's.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Dieser Schmied, das ist mein Gift, obgleich er mein\nSchwiegersohn ist ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und so klagten sie gemeinsam über die schlechte Welt und sahen\nauf das Dorf, das zwischen den Pappelbäumen ihnen immer näher\nrückte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Nahe am Friedhof leuchteten schon von weitem die roten Gewänder\nder in Reihen arbeitenden gebückten Frauen, über denen wie ein\nzarter Flor der Rauch lag, und bald begann der Windhauch ihnen das\ndumpfe eintönige Klatschen der Flachsbrechen zuzutragen, das aus\ndem Wiesengrund kam.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Die Zeit ist gut zum Flachsbrechen. Ich steig' da ab; meine\nJagusch ist dazwischen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ist mir kein Umweg, ich fahr' euch 'ran ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gut seid ihr, Matheus, daß es mich wundernimmt ...« Sie\nlächelte verschmitzt ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Er bog vom Pappelweg auf einen Feldpfad ab, der bis zur\nFriedhofspforte hinlief und fuhr sie bis zu der Stelle, wo unter\nder steingrauen Mauer, im Schatten der Birken und Ahorne und im\nBereich der Kreuze, die sich von den Grabhügeln zu den Feldern\nherüberneigten, etliche Frauen emsig den getrockneten Flachs\nbrachen, so daß der Staub wie Dunst über ihnen hing und die langen\nFasern sich ins gelbe Birkenlaub verknüpften und an den schwarzen\nArmen der Kreuze hängenblieben; nebenan an den aufgesteckten Ruten\ntrocknete man über Gruben, in denen Feuer brannten, den feuchten\nFlachs.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Flachsbrechen klappten rasch, und die ganze Reihe der Frauen\nbeugte sich immer wieder in kurzen und raschen Stößen, nur hin und\nwieder reckte sich die eine oder die andere gerade, klopfte ihren\nBüschel Flachs von den letzten "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page109",
      "title": "lesebaer/lac"
    }
  }), _vm._v(" Acheln frei, wickelte ihn zu einem Kogel\noder zu einer Puppe zusammen und warf sie vor sich auf ein\nausgebreitetes Leinentuch.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Sonne, die schon bis zu den Wäldern gerollt war, schien\nihnen direkt ins Gesicht, aber das störte sie nicht – denn die\nArbeit, das Gelächter und die frohen Reden ließen keinen Augenblick\nnach.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Glück zu bei der Arbeit!« rief Boryna nach Jagna hinüber, die\ngleich vornean am Flachs hantierte; sie trug nur ein Hemd und ihren\nroten Beiderwandrock, und um den Kopf ein Tuch gegen den Staub.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gott bezahl's!« gab sie ihm fröhlich zurück. Sie sah mit ihren\nleuchtenden blauen Augen zu ihm auf, und ein Lächeln durchflog ihr\nschönes sonnengebräuntes Gesicht.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Is trocken, Töchterchen, was?« fragte die Alte, die\ngeschwungenen Flachsbündel betastend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Trocken wie Pfeffer, er bricht schon ...,« wieder lächelte sie\ndem Alten zu, daß es ihm durch und durch ging; er schlug mit der\nPeitsche durch die Luft und fuhr davon, aber fortwährend sah er\nsich nach ihr um, obgleich sie schon längst außer Sicht war, so\nlebhaft stand sie vor seinen Augen ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ein Mädel wie eine Hinde ... Paßt gerade recht ...« überlegte\ner.")]), _vm._v(" "), _c('p', {
    staticClass: "pcalibre6 initial1"
  }, [_vm._v("Sonntag war's/ein stiller,\nspinnwebumsponnener, sonnendurchtränkter Septembertag. Auf dem\nStoppelfeld, sogleich hinter den Scheunen weidete das ganze Vieh\ndes Borynahofes, und unter dem hohen, bauchigen Getreideschober,\nden eine frischgrüne Bürste jungen Roggens umgab, der beim Verladen\ndes Kornes ausgeschüttet war, lag Jakob, gab auf das Vieh Obacht\nund unterwies Witek im Gebet. Er fuhr ihn öfters an oder knuffte\nihn mit dem Peitschenstiel, denn der Junge irrte sich fortwährend\nund überflog die Obstgärten mit den Blicken.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page110",
      "title": "lesebaer/lac"
    }
  }), _vm._v(" »Acht',\nwas ich sage, es ist doch das Gebet,« mahnte er ernst.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich acht' schon, Jakob, ich acht' schon.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Na, und was hast du dich denn da in die Obstgärten zu\nvergucken, hä...ä?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Klembs haben noch die Äpfel im Garten, glaub' ich.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Die kommen dir grad zu paß, was? Hast du sie denn gepflanzt?\nRepetier' du das Credo/noch emal.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Die Rebhündel habt ihr doch auch nicht aufgezogen und habt 'ne\nganze Schar davon weggenommen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Dämlack! Die Äpfel sind Klemb seine und die Vögel sind dem Herr\nJesus seine, verstanden?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Sie sind doch aber vom Gutsfeld.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Auch das Feld gehört dem Herrn Jesus. Seh' mir einer den\nKlugschnacker an! Repetier' du nur das Credo.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Witek wiederholte rasch, denn die Knie taten ihm schon weh, aber\ner hielt es nicht aus.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Mir scheint, das Füllen geht in Michel seinen Klee,« rief er,\nbereit, auf und davonzulaufen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hab' man keine Angst nich um das Füllen und paß aufs Gebet\n...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Endlich war er am Ende, konnte jedoch nicht länger stillehalten,\nkuschelte sich, drehte sich nach allen Seiten und schleuderte einem\nHaufen Spatzen auf den Pflaumenbäumen einen Erdklumpen nach, dann\nbegann er eilig sich auf die Brust zu schlagen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und den Schluß hast du einfach 'runtergeschluckt, wie 'ne\nMulschbirne, was?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Der Junge wiederholte den Schluß und machte sich mit großer\nErleichterung an den Hund heran, mit dem er sich herumzunecken\nbegann.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Paß auf; mußt du denn immerzu tollen, wie 'n albernes\nKalb?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Werdet ihr Hochwürden die Vögel hintragen? ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das werd' ich ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Aufm Feld hier könnten wir sie braten.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page111",
      "title": "lesebaer/DaoH"
    }
  }), _vm._v(" »Brat'\ndir Kartoffeln. Sieh' mal einer an, was er nicht alles will!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»In die Kirche gehen sie schon,« rief Witek plötzlich, da er die\nroten Schürzen auf dem Wege hinter den Hecken und Bäumen schimmern\nsah.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Sonne wärmte gehörig, so daß man alle Fenster und Türen in\nden Hütten durch und durch geöffnet hatte; hier und da wusch man\nsich noch an der Hauswand, hier wiederum strählte man das Haar und\nflocht es in Zöpfe, da klopfte man die Feiertagskleider aus, die\ndurch das lange Liegen in den Truhen zerknüllt waren, und trat\nschon da und dort auf die Straße, daß bald hier bald dort, gleich\nroten Mohnblumen, und gelben Georginen, die an den Wänden schon im\nVerblühen waren, oder wie Kresse und Feuernelken geputzte Menschen\nherauskamen. Frauen, Kinder, Mädchen, Knechte kamen angegangen, und\nwie große reife Roggengarben kamen die Bauern in ihren weißen\nHaartuchröcken anmarschiert und alles strebte bedächtig der Kirche\nzu, auf Wegen und Stegen kamen sie gegangen zu seiten des Weihers,\nder wie in einer goldenen Schale die Sonne wiederspiegelte, daß es\nvor den Augen zu flirren begann.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Glocken klangen ununterbrochen mit ihren freudigen Stimmen\ndes Sonntags, der Ruhe und der Andacht.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Jakob wartete, bis man ausgeläutet hatte, da ihm aber die Zeit\nzu lang wurde, steckte er seinen Bund Rebhühner unter den\nKapottrock und sagte:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Witek, du wirst das Vieh in die Ställe treiben, wenn sie\nausgeläutet haben, und kommst dann zum Gottesdienst.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Er ging so schnell er sich nur vorwärtsbewegen konnte, er hinkte\nnämlich stark, den Fußweg entlang, der zwischen den Gärten lief und\nso dicht mit gelbem Pappellaub bedeckt war, daß Jakob wie auf einem\nsafrangelben Perserteppich wandelte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Das Pfarrhaus stand gegenüber der Kirche, nur durch eine Straße\nvon dieser getrennt, im Hintergrund eines "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page112",
      "title": "lesebaer/DaoH"
    }
  }), _vm._v(" großen Gartens voll grüner\nBirnen und roter Äpfel. Vor der mit rotem Weinlaub bewachsenen\nVeranda blieb Jakob ratlos stehen, schüchtern in die sperrangelweit\noffenen Fenster, dann wieder in die offene Haustür lugend, und da\ner sich nicht hineinzugehen traute, wich er bis an ein großes\nBlumenbeet zurück, das voll Rosen, Levkojen und Astern war und aus\ndem ihm ein süßer betäubender Duft entgegenschlug; eine weiße\nTaubenschar krabbelte auf dem grünen, moosbewachsenen Dach umher\nund flatterte bis auf die Veranda herunter.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Der Pfarrer ging im Garten auf und ab mit dem Brevier in der\nHand, doch schüttelte er hin und wieder an einem Birn- oder\nApfelbaum, daß man das schwere Aufplatzen der Früchte auf den Boden\nhörte; er sammelte das Obst auf in den Schoß seines Priesterkleides\nund wollte es ins Haus tragen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Jakob vertrat ihm den Weg und bückte sich demütig bis an seine\nKnie.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Was gibt's denn? Ach so ... Jakob vom Borynahof.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Jawohl! 'n paar Rebhühndl hab' ich Hochwürden gebracht.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gott lohn's dir. Komm mit.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Jakob betrat den Vorplatz und blieb auf der Schwelle stehen,\ndenn er traute sich keinesfalls in die Zimmer hinein. Soweit es\ndurch die offene Tür möglich war, blinzelte er aber zu den Bildern\nhinüber, die an den Wänden hingen, bekreuzigte sich fromm, holte\ntief Atem und fühlte sich dermaßen geblendet durch all die\nHerrlichkeit, daß ihm selbst die Tränen in die Augen traten. Er\nhatte große Lust zu beten, nur traute er sich nicht, niederzuknien,\num das glänzende, glatte Parkett nicht zu beschmutzen. Doch der\nPfarrer kam gleich wieder aus den Zimmern heraus, gab ihm fünfzehn\nKopeken in Silber und sagte:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gott bezahl's, Jakob, du bist ein guter, frommer Mensch, du\ngehst auch jeden Sonntag zur Kirche.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page113",
      "title": "lesebaer/DaoH"
    }
  }), _vm._v(" Jakob\numfaßte seine Knie, doch er war dermaßen betäubt durch das Gefühl\nder plötzlichen Freude, daß er gar nicht gewahr wurde, wie er sich\nwieder auf der Straße befand.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Sieh mal an, für die paar Vögelchens und so 'n Geld!\nHochwürden/der Liebe ...« flüsterte er, die Münze beäugend. Nicht\ndas erstemal zwar brachte er Hochwürden etwas, mal 'n paar Vögel,\ndann wieder ein Häschen oder Pilze. Niemals aber hatte er so viel\nbekommen; auf den Höchstfall einen Groschen oder auch nur ein gutes\nWort ... und heute, du lieber Gott! einen ganzen Silberling, und\naufs Zimmer hatte man ihn gerufen, und so viel Gutes gesagt. Jesus!\nEs klemmte ihm die Gurgel zu, und Tränen flossen wie von selbst aus\nseinen Augen, und im Herzen fühlte er eine solche Wärme, als ob ihm\njemand Glut auf die Brust geschüttet hätte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Allein der Priester weiß den Menschen zu ehren, er nur einzig\nund allein./Daß ihn Gott gesund erhalte und die heilige Jungfrau\nMaria von Tschenstochau. 'n guter Herr bist du, oh 'n guter! ...«\nUnd die im Dorf, die konnten ihn nur Hinkefuß, Tölpel,\nunbrauchbares Subjekt nennen, die Bauern wie die Knechte, niemand\ngönnte ihm ein gutes Wort, niemand hatte Mitleid mit ihm/höchstens\nnur die Gäule und 'n paar Dorfhunde ... und war er nicht aus guter\nFamilie ... ein Bauernsohn ... kein Landstreicher, sondern ein\nguter Christ, ein Katholischer...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Immer höher und sicherer reckte er den Kopf, machte sich gerade\nso gut es ging und schaute von oben herab und herausfordernd in die\nWelt, auf die Menschen, die den Kirchhof betraten, und auf die\nPferde, die unter der Mauer bei den Wagen standen; die Mütze setzte\ner sich auf seinem Zottelkopf zurecht und begab sich langsam und\nwürdig nach der Kirche zu, wie irgendein Hofbauer, die Hände in den\nGürtel geschoben und mit dem schiefen Bein hinterherfegend, daß der\nStaub hinter ihm aufwirbelte. Nein, heute blieb er nicht in der\nVorhalle, wie sonst, und wie's für ihn, "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page114",
      "title": "lesebaer/lac"
    }
  }), _vm._v(" den armen Knecht vom Borynahof\npaßte, sondern er fing an, sich mächtig durch das Gedränge\nvorwärtszuschubsen und schob geradeaus nach dem Hauptaltar/da, wo\nnur die Hofbauern zu stehen pflegten, wo Boryna stand und der\nDorfschulze selbst, und all diejenigen, die den Traghimmel hinter\nHochwürden hertragen, und die auch, die mit Kerzen dick wie eine\nRunge vor dem Altar Wacht halten durften während der Ausstellung\ndes heiligen Sakraments.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Mit Staunen und Entsetzen betrachteten sie ihn, und häufig genug\nmußte er ein unangenehmes Wort hören oder erhielt einen Blick/wie\nein Hund, der sich hindrängt, wohin man ihn nicht gerufen hat. Doch\nJakob machte sich heute nichts daraus; fest hielt er die Münze in\nder Faust und hatte die Seele voll Süße und Güte; wie nach der\nBeichte fühlte er sich, oder selbst besser noch.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Der Gottesdienst begann.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Er kniete ganz dicht am Geländer und sang andächtig mit den\nandern, dabei den Hauptaltar angaffend, wo ganz oben Gott-Vater zu\nsehen war, ein weißhaariger Herr, streng und ganz dem Gutsherrn aus\nDschasgowa-Wola ähnlich. Und aus der Mitte, im goldigen Mantel, sah\nihn die Tschenstochauer Muttergottes selbst an ... Und überall\ngleißte Gold, lohten die Kerzenflammen, standen Sträuße aus roten\nPapierblumen und hoben sich aus den Wänden und bunten Fenstern\ngoldene Scheine und ernste Heiligengesichter heraus. Streifen von\nGold, Purpur und Violett fielen wie ein Regenbogen auf sein\nGesicht, auf seinen Kopf, ganz als ob er im Weiher untergetaucht\nwäre vor Sonnenuntergang, wenn die Sonne über das Wasser kommt. Und\ner fühlte sich in diesen Herrlichkeiten wie im Himmel, so daß er\nsich nicht zu bewegen traute und nur so kniete, versunken im\nAnschauen des schwärzlichen, lieben Muttergesichts der heiligen\nJungfrau, daß er ein Gebet nach dem anbeten mit fiebertrockenen\nLippen stammelte und dann vor sich hin sang mit solcher Andacht, so\naus allen "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page115",
      "title": "lesebaer/Vera6020"
    }
  }), _vm._v(" Kräften seiner glaubensstarken Seele, so\naus dem begeisterten Herzen heraus, daß seine eingetrocknete,\nknarrende Stimme am meisten vernehmbar war.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Jakob, ihr blökt ja, wie 'ne Judenziege,« flüsterte ihm einer\nvon der Seite zu.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Unsrem Herrn Jesus und der heiligen Jungfrau zu Ehren,«\nbrummelte er, nachdem er seinen Gesang unterbrochen hatte, denn in\nder Kirche wurde es allmählich still. Der Priester kletterte auf\ndie Kanzel und alle reckten die Köpfe und schauten Hochwürden an,\nder im weißen Chorhemd sich über das Volk beugte und das Evangelium\nlas. Und Lichter und Farben fluteten über seine Gestalt von den\nFenstern her, daß er allen wie ein Engel auf einem Regenbogen\ndünkte. Der Priester sprach lange und mit solchem Nachdruck, daß\nder eine und der andere aus reuigem Herzen aufseufzte und manchem\ndie Tränen übers Gesicht flossen, und ein anderer wiederum den\nBlick senkte, in seinem Gewissen bereute und sich vornahm, besser\nzu werden. Jakob starrte auf Hochwürden, wie auf ein Heiligenbild,\nund es war ihm fast seltsam, daß dieses derselbe gute Herr sein\nsollte, der mit ihm vorhin gesprochen hatte und ihm den Silberling\ngegeben hatte/denn jetzt sah er wie ein Erzengel auf dem Feuerwagen\nder Morgenröte aus, sein Gesicht war bleich geworden, die Augen\nschleuderten Blitze, als er die Stimme erhob und dem Volk alle\nSünden vorhielt: Geiz und Trunkenheit, Zügellosigkeit, Schädigung\ndes Nachbarn, Nichtachtung vor den Älteren und Gottlosigkeit! Und\ner rief mit großer Stimme, zur Besinnung mahnend, flehte, beschwor\nund bat/so daß Jakob nicht länger an sich halten konnte und unter\nder Last all dieser Sünden innerlich zu beben begann und laut\nlosheulte/und ihm nach das ganze Volk, Frauen, ja selbst\nHofbauern/so daß ein Weinen in der Kirche entstand, ein Schluchzen\nund Schneuzen; und als der Priester sich mit dem Bußgebet gegen den\nAltar wandte und niederkniete, überflog ein "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page116",
      "title": "lesebaer/Snoopy64"
    }
  }), _vm._v(" Stöhnen die Kirche, und\ndas ganze Volk stürzte, wie ein sturmgebeugter Forst, mit den\nGesichtern zu Boden, so daß der Staub aufwirbelte und wie mit einer\nWolke die reuigen, tränenschweren, seufzenden und flehenden Herzen,\ndie zum Herrn um Erbarmen riefen, umhüllte. Und Stille sank darauf\nherab, die Stille der tiefen Andacht und des innigsten\nZwiegesprächs mit dem Herrn, denn nun begann die Messe/die Orgel\nsetzte mit einer gedämpften, demütigen und tiefen Stimme ein/so daß\nJakobs Seele in Wonne und unaussprechlichem Glück schier\nerstarb.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und dann erhob sich plötzlich vom Altar her die Stimme des\nPriesters und floß über die gesenkten Köpfe, wie ein Bach von\nKlängen, oder die Schellen klangen in kurzen Stößen, und Weihrauch\nschlug in duftenden Säulen empor und umgab die knienden\nAndachtversunkenen wie mit einem Flor, Jakob aber wurde darob mit\neiner solchen Wollust erfüllt, daß er nur seufzte und die Arme\nausbreitete, gegen seine Brust hämmerte und in diesem süßen Gefühl\ndes Ersterbens sich ganz auflöste. Das Geflüster der Gebete, die\nSeufzer und plötzlichen Aufschreie, das vereinzelte Stöhnen, die\nheißen Atemzüge, die Lichter, der Dunst und der Orgelklang tauchten\nihn wie in eine Verzückung und in einen heiligen Traum.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Jeses, mein lieber Jeses,« flüsterte er geblendet und\ngeistesabwesend und hielt seine Silbermünze fest in der Faust. Und\nals Ambrosius, der Küster, mit einem Teller herumging und mit dem\nGeld zu klappern begann, damit man hörte, daß er Gaben fürs Licht\nsammelt, erhob sich Jakob, warf seine Münze laut hin und suchte\nlange, wie das die echten Hofbauern so taten, nach dem Rest von 26\nPfennigen. »Gott bezahl's« hörte er voll Behagen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und als die Kerzen verteilt wurden, denn die Messe war mit der\nZurschaustellung des heiligen Sakraments und mit einem Festgang um\ndie Kirche, streckte Jakob mutig seine Hand aus, und obgleich er\ngroße Lust hatte, eine ganze Kerze zu "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page117",
      "title": "lesebaer/Snoopy64"
    }
  }), _vm._v(" nehmen, griff er doch nur\nnach der kleinsten, nach einem Lichtstumpf fast, denn er begegnete\ndem gestrengen, rügenden Blick der Dominikbäuerin, die mit ihrer\nTochter Jagna neben ihm stand/er zündete rasch sein Licht noch an,\ndenn der Priester hatte schon die Monstranz erfaßt und sich mit ihr\nnach dem Volk umgedreht, so daß alle mit dem Gesicht zu Boden\nfielen. Nun stimmte Hochwürden den Gesang an und schritt langsam\ndie Treppenstufen des Altars hinab durch eine plötzlich gebildete\nStraße aus singenden Köpfen, flammenden Kerzen, grellen Farben und\nächzenden Stimmen. Der feierliche Umzug setzte sich in Bewegung,\ndie Orgel erdröhnte mächtig, die Schellen fingen an rhythmisch zu\nläuten, das Volk, die zweite Stimme ergreifend, sang mit einer\neinzigen großen Stimme des Glaubens, und vorne, vor dem Gedränge,\numgeben von bebenden Lichtern, blinkte das silberne Kreuz,\nschaukelten die Tragaltare ganz in Tüll gehüllt, voll Blumen und\nmit goldenen Kronen gekrönt, und am Hauptausgang, wo durch die\nWeihrauchwolken die Sonne einströmte, entfalteten sich schon die\ngesenkten Fahnen und schlugen wie purpurfarbene und grüne Vögel mit\nden Flügeln.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Prozession umkreiste die Kirche.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Jakob beschattete sein Licht mit der gekrümmten Handfläche und\nhielt sich eigensinnig ganz nahe hinter dem Priester, über dem die\nHofbauern Boryna, Thomas Klemb, der Schmied und der Dorfschulze den\nroten Traghimmel trugen, unter welchem die Monstranz golden\nleuchtete und so im Feuer des Sonnenlichts stand, daß man durch\nihre runde Glasscheibe in der Mitte die blasse durchsichtige Hostie\nsah.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Jakob war so geistesabwesend, daß er immer wieder stolperte und\nden anderen auf die Füße trat.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Paß auf, du Stummelaffe!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Mißgeburt, Hinkefuß,« warfen sie ihm zu, die Worte nicht selten\nmit Rippenstößen begleitend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page118",
      "title": "JohannN/Snoopy64"
    }
  }), _vm._v(" Er\nhörte nichts davon. Der Gesang des Volkes rauschte mächtig dahin,\nerhob sich wie eine Säule, schien wie eine Woge zu fließen und\nschlug gegen die weiße Sonne. Die Glocken dröhnten ununterbrochen\naus erzenen Mündern, so daß die Linden und Ahorne bebten und hin\nund wieder sich ein rotes Blatt von den Zweigen losriß, wie ein\naufgescheuchter Vogel, und auf die Köpfe niedersank. Und hoch, hoch\nüber den Wandelnden, über den Wipfeln der gebeugten Bäume, über dem\nKirchturm kreiste ein Schwarm aufgescheuchter Tauben ...")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("— — — — —")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Nach dem Gottesdienst ergoß sich die Volksmenge auf den um die\nKirche gelegenen Friedhof, auch Jakob kam mit den anderen hinaus,\naber heute hatte er keine Eile, obgleich er wußte, daß zu Mittag\nFleisch von der notgeschlachteten Kuh da sein würde; nein, warum\ndenn auch, hin und wieder blieb er stehen, redete mit diesem und\njenem von seiner Bekanntschaft und schob sich an seine Leute heran,\ndenn auch der Antek stand mit seiner Frau bei den anderen im\nHaufen. Man besprach sich, wie es immer an den Sonntagen nach der\nHochmesse Brauch ist.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("In einem anderen Haufen aber, der sich schon hinter der Pforte\nauf der Dorfstraße versammelt hatte, führte der Schmied das erste\nWort. Der war ein großer, schon ganz städtisch gekleideter Kerl, in\neinem schwarzen, auf dem Rücken mit Wachs betropften Knierock,\ndunkelblauer Mütze, langen über die Stiefelschäfte\nheruntergelassenen Hosen und einer silbernen Uhrkette auf der\nWeste. Er hatte ein rotes Gesicht, einen rosthaarigen Schnurrbart\nund wirres, steifes Kraushaar, schwadronierte weit vernehmbar und\nbrach hin und wieder in quarrendes Gelächter aus, denn er war der\nerste Spötter im Dorf, und Gott behüte den, welchen seine böse\nZunge sich zum Opfer ausersehen hatte. Der alte Boryna schielte\nimmerzu verdächtig zu ihm herüber und lauschte auf seine Worte,\ndenn er fürchtete sich vor seinem Geschwätz. Selbst den eigenen\nVater hätte der Schmied "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page119",
      "title": "JohannN/Snoopy64"
    }
  }), _vm._v(" nicht ungeschoren gelassen, geschweige denn\nden Schwieger, mit dem er in ständigem Krieg war wegen der Mitgift\nseiner Frau, doch konnte Boryna nicht viel heraushören, denn gerade\nwurde er die Dominikbäuerin mit Jagna gewahr, die nun die Kirche\nverließen. Sie gingen beide langsam, da viel Volk auf dem Kirchhof\nwar, warfen dem und jenem ein Wort hin und begrüßten den einen und\nden anderen, denn trotzdem sie sich alle kannten und obendrein\nversippt und verschwägert waren, wie es im Dorf zumeist so ist, wo\nman nur um einen Zaun oder Grenzrain voneinander entfernt sitzt, so\nwar es doch recht schön, vor der Kirche miteinander zu reden, und\nes paßte sich so ... Mit einer leisen, und andachtsvollen Stimme\nverbreitete sich die Dominikbäuerin über Hochwürden, wahrend Jagna\nsich nach den Leuten umsah. Sie war im Wuchse den größten Männern\ndes Dorfes gleich, und so schmuck schien sie heut, daß die\nBurschen, die sich qualmend auf dem Wege vor der Zufahrt in einem\nHaufen zusammengerottet hatten und ihr lachend die Zähne zeigten,\nmit den Augen an ihr hingen. Sie war so wohlgestaltet, so prächtig\naufgeputzt, und von so hoher Statur, daß selbst ein\nHerrschaftsfräulein sich mit ihr nicht hätte messen können.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Dorfmädchen und auch die Bäuerinnen, die vorbeigingen,\nblickten sie neidisch an oder blieben gar dicht neben ihr stehen,\num ihre Augen an dem gestreiften und reichen Beiderwandrock zu\nsättigen, der an ihr leuchtete, wie ein Regenbogen ihrer\nmazurischen Heimat, ihre schwarzen hohen Stiefel anzustaunen, die\nbis zum weißen Strumpf hinauf mit roter Litze verschnürt waren, das\nMieder aus grünem Samt, das so reich mit Gold bestickt war, daß es\neinem in den Augen flimmerte, und auch die Bernstein- und\nKorallenschnüre, die ihren weißen, vollen Hals umschlossen. Ein\nBüschel verschiedenfarbiger Bänder hing vom Verschluß der Schnüre\nauf den Rücken herab und flatterte, wenn sie ging, ihr buntfarben\nnach.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page120",
      "title": "JohannN/Snoopy64"
    }
  }), _vm._v("\nJagna merkte die neidischen Blicke nicht, aber eine plötzliche Röte\nschoß ihr ins Gesicht, als ihre lichtblauen Augen, von einem zum\nandern irrend, den sie anstarrenden Blicken Anteks begegneten. Sie\nzupfte die Mutter am Ärmel und ging voraus, ohne zu warten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wart' doch, Jagna« schrie diese ihr nach, indem sie den alten\nBoryna begrüßte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Mitten auf der Straße blieb Jagna aber stehen, denn die Burschen\numdrängten sie in hellem Haufen, begrüßten sie und fingen an, sich\nüber Jakob lustig zu machen, der hinter ihr her ging, in ihrem\nAnblick wie in ein Heiligenbild vergafft.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Der aber spuckte nur aus und wandte sich trägen Schritts\nheimwärts, denn auch seine Bauersleute waren auf dem Heimweg, und\nman mußte doch auch noch nach den Pferden sehen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Grad wie auf einem Bild!« rief er unwillkürlich aus, schon auf\nder Galerie des Bauernhauses sitzend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wer denn, Jakob?« fragte Fine, die das Mittagessen\nrichtete.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Er senkte beschämt seine Augen, aus Angst, daß man ihm etwas\nanmerken könnte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Da aber das Mittagessen reichlich und lang war, hatte er bald\nalles vergessen. Fleisch gab es heute, Kohl mit Erbsen, Brühe mit\nKartoffeln, und zum Schluß stellte man noch eine ordentliche\nSchüssel mit in Speck gerösteter Gerstengrütze auf den Tisch.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie aßen bedächtig, ernst und schweigsam vor sich hin, und als\nder erste Hunger gestillt war, fingen sie an, sich miteinander zu\nbereden und sich am Essen zu freuen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Fine, die in den Platz der Hausfrau aufgerückt war, setzte sich\nnur hin und wieder am Rande der Bank nieder, aß schnell und achtete\nfleißig darauf, daß es nicht am Essen fehlte, und daß die Töpfe aus\nder Stube rechtzeitig nach draußen zum Nachfüllen kamen, denn\nniemand sollte sich beklagen können, daß in den Schüsseln Grund\nkomme.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page121",
      "title": "DaoH/Snoopy64"
    }
  }), _vm._v(" Sie\naßen auf der Galerie, denn das Wetter war still und warm.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Waupa drehte sich um sie herum, scharwenzelte, rieb sich gegen\ndie Beine der Essenden und schnüffelte in den Schüsseln, bis ihm\njemand hin und wieder einen Knochen hinwarf, mit dem er nach der\nMauerbank rannte, und beglückt durch die Anwesenheit seiner Leute,\nvielleicht auch weil man seinen Namen laut nannte, fing er an,\nfreudig zu bellen und hinter den Spatzen her zu jagen, die in\nErwartung der Brocken vom Mahl sich in die Hecken hingen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und oft kam jemand über den Weg, den Essenden seinen Gruß\nzurufend, auf den sie einstimmig antworteten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hast Hochwürden ein paar Vöglein gebracht?« erkundigte sich\nBoryna.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Jawohl, jawohl!« Er legte plötzlich den Löffel hin und fing an\nzu erzählen, wie der Pfarrer ihn auf die Zimmer gerufen hatte, und\nwie es dort schön sei und welche Menge Bücher.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wann kann er die alle lesen?« sagte Fine.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wann? An den Abenden! Dann geht er durch die Zimmer auf und ab,\ntrinkt Tee und liest immerzu.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das muß wohl ... lauter Frommes sein?« warf Jakob ein.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Versteht sich, daß es keine Fibeln sind.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und Zeitungen bringt ihm der Gemeindebote jeden Tag,« fügte\nAnna hinzu.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Weil man in den Zeitungen schreibt, was in der Welt passiert\n...« ließ sich Antek vernehmen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Auch der Schmied mit dem Müller halten sie sich.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Päh ... so 'ne Schmiedszeitung! ...« sagte Boryna höhnisch.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ganz und gar dieselbe, wie dem Pastor seine,« entgegnete Antek\nscharf.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hast sie gelesen, daß du es weißt?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das hab' ich, und ob ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page122",
      "title": "DaoH/Snoopy64"
    }
  }), _vm._v(" »Und\nbist doch nicht klüger geworden, daß du dich mit dem Schmied\neinläßt.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Für den Vater ist nur der klug, der mindestens seine halbe Hufe\nLand hat und sein Dutzend Kuhschwänze dazu.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Halt's Maul, solang ich gut bin. Sieh einer nur, da sucht er\nsich wieder Gelegenheit, mir die Zähne zu zeigen. Das Brot bläht\ndich auf, wie's mir scheint ... mein Brot ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Jawohl, das steckt mir schon wie 'n Knochen in der Gurgel.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Such dir Besseres, auf Anna ihren drei Morgen wirst du Semmeln\nessen können.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und sollte ich selbst Kartoffeln fressen, so wird sie mir\nniemand vorwerfen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich werfe sie dir auch nicht vor.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wer denn sonst? ... Wie 'n Ochs muß man sich schinden und nicht\nmal ein freundliches Wort kriegst du dafür.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»In der Welt ist es leichter, da braucht man nicht zu arbeiten\nund kriegt alles.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Versteht sich! ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Dann geh' er doch hin und versuch' er es.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Mit leeren Händen nicht!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Einen Stecken kannst kriegen, damit du was für die Hunde\nhast.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Vater!« schrie Antek, von der Bank aufspringend, aber er fiel\ngleich zurück, denn Anna hielt ihn fest. Der Alte warf ihm einen\ndrohenden Blick zu, bekreuzigte sich, da das Mittagessen beendet\nwar, und sagte noch im Weggehen hart:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Auf den Altenteil geh ich nicht zu dir, nee!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie gingen gleich darauf auseinander, nur Antek blieb auf dem\nVorbau und grübelte. Jakob führte die Pferde aufs Kleefeld hinter\nden Scheunen und lagerte sich unter dem Getreideschober, um etwas\nzu schlummern, aber schlafen konnte er nicht, das Essen drückte ihn\nim Leib und der Gedanke quälte ihn, daß er, wenn er eine Flinte\nhätte, 'ne "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page123",
      "title": "DaoH/Snoopy64"
    }
  }), _vm._v(" Menge Vögel und manches Häschen schießen\nkönnte, um jeden Sonntag Hochwürden etwas zu bringen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Der Schmied würde ihm wohl eine Flinte machen können, gerade\nsolche wie dem Forstaufseher. Wenn einer daraus im Walde schießt,\nhört man es drin im Dorf!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ein schlaues Luder! Aber 5 Rubel müßte man ihm dafür bezahlen!«\nüberlegte er. »Und woher nehmen? ... Der Winter rückt näher, einen\nSchafpelz muß man kaufen, die Stiefel halten auch nur bis zum Fest\n... Gewiß, zehn Rubel bekommt er noch und zwei Stück Zeug, eine\nHose und ein Hemd ... Der Schafpelz kostet mindestens 5 Rubel ...\nder wird allerdings etwas kurz sein ... die Stiefel an die drei\nRubel ... und eine Mütze täte not ... einen Rubel muß man\nHochwürden für die Seelenmesse der Eltern wegen bezahlen ...\nVerflucht ..., daß auch nichts übrigbleibt! ...« Er spuckte aus und\nfing an, in der Tasche seiner Joppe nach Tabakresten zu kramen,\nstieß aber auf das Geld, das er während des Mittagsmahles ganz\nvergessen hatte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Sieh da, bar Geld, sieh da!« Die Schlaflust war plötzlich\nverflogen; von der Schenke her ertönte die Stimme der Musik, fern\nwie durchgesiebt; ein Wiederhall von Zurufen wurde vernehmbar.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Da tanzen sie, die Biester, trinken Schnaps und rauchen\nZigaretten!« Er seufzte auf, legte sich wieder bäuchlings hin und\nsah den gefesselten Gäulen zu, wie sie zu einem Haufen geschart\neinander in den Nacken griffen. Er überlegte, daß er abends\nebenfalls in die Schenke müßte, um etwas Tabak zu kaufen und\nwenigstens den Tanzenden zuzugucken. Immer wieder besah er seine\npaar Geldmünzen und blinzelte in die Sonne. Sie war noch recht hoch\nund schob sich heute so langsam gen Westen, als ob sie auch ein\nbißchen sonntäglich ausruhte. So mächtig zog's ihn schon nach der\nSchenke, daß er kaum an sich halten konnte, er drehte sich von\neiner Seite auf die andere und stöhnte nur hin und wieder voll\nsehnsuchtsvollen Begehrens; auf den "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page124",
      "title": "DaoH/Snoopy64"
    }
  }), _vm._v(" Weg machte er sich jedoch nicht gleich,\ndenn hinter den Scheunen hervor erschien gerade Antek mit Anna. Sie\ngingen über den Rain ins Feld.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Antek voraus und Anna mit dem Säugling im Arm hinterdrein. Hin\nund wieder sagten sie etwas. Sie gingen langsam, und immer wieder\nbeugte sich Antek über den Acker, mit der Hand die aufgehenden\nHalme betastend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Es kommt sich ... dicht wie eine Bürste,« brummte er und\numschlang mit den Blicken jene Ackerhufen, die er dem Vater gegen\nLohn bestellte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Dicht ist es schon, aber das Väterliche is besser, wie ein Wald\nschießt es hervor,« sagte Anna, die benachbarten Äcker\nbeäugend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Weil der Acker besser zubereitet ist.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wenn man drei Kühe hätte/dann würde auch der Boden mehr Nahrung\nhaben.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und sein eigenes Pferd dazu.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und noch was zu mästen zum Verkauf. Aber so? Jede Spreu, jede\nKartoffelschale rechnet der Vater an und hält es noch für Gott weiß\nwas für eine Wohltat.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und alles kriegt man noch vorgezählt.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie verstummten plötzlich. Ein Gefühl erlittenen Unrechts füllte\nihre Herzen mit Bitterkeit, Zorn und dumpfer, zerrender\nEmpörung.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Acht Morgen würden nur auf jeden zufallen,« rief er\nunwillkürlich aus.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Natürlich, mehr nicht. Fine ist doch da und dem Schmied seine\nFrau und Gregor und wir,« zählte sie her.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Dem Schmied seinen Teil könnte man auszahlen und bei dem Haus\nmit der halben Hufe bleiben.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und hast du, womit?« ... Sie stöhnte auf im Gefühl ihrer\nOhnmacht, das so stark war, daß ihr die Tränen kamen, als sie mit\nden Blicken die väterlichen Felder umfaßte, diese Erde, wie\ngediegenes Gold, wo man Weizen und Roggen, Gerste und Rüben von\nScholle zu Scholle "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page125",
      "title": "DaoH/Snoopy64"
    }
  }), _vm._v(" ernten konnte ... So viel Gut, und alles\nfremdes, nicht ihr's.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Heul' nicht, Dumme, acht Morgen davon sind immerhin unser.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wenn's wenigstens noch die Hälfte wäre und das Haus und das\nKohlfeld dazu!« sie wies links nach dem Wiesenland, wo lange\nKohlbeete blauten. Dahin wandten sie sich.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Unter die Knicks am Wiesenrand setzten sie sich, Anna machte\nsich an das Stillen des Kindes, da es angefangen hatte zu greinen,\nund Antek drehte sich eine Zigarette zurecht, brannte sie an und\nstarrte finster vor sich hin.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Er sprach zu seiner Frau nicht darüber, was ihm bis in die\nEingeweide hineinfraß und auf dem Herzen wie glühende Kohlen lag,\ndenn er hätte es weder ausdrücken können noch hätte sie ihn richtig\nverstanden. Wie die Weiber nun einmal sind, weder Überlegung haben\nsie noch können sie etwas selbständig bedenken und leben so wie ein\nSchatten, den ein Mensch wirft ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Die Wirtschaft, die Kinder, die Gevatterinnen/das ist ihre\nganze Welt. Und alle sind sie so, alle ...« sann er voll\nBitterkeit, und das Herz preßte sich ihm zusammen ... »Ein Vogel,\nder über die Moore fliegt, hat es besser, als manch ein Mensch ...\nWas hat er zu sorgen? Er fliegt und singt sich eins und Herr Jesus\nsäet für ihn, so daß er nur zu ernten und sich zu nähren braucht\n...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und fehlt denn Vater vielleicht an bar Geld?« fing Anna wieder\nan.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Freilich!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und Fine hat er solche Korallen gekauft/daß ein anderer dafür\neine Kuh haben könnte, und Gregor schickt er immerzu Geld durch den\nSchulzen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das tut er,« antwortete er, an anderes denkend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das ist doch ein Nachteil für die anderen. Und der seligen\nMutter ihre Kleider hält er in der Truhe unter Schloß und Riegel,\nnicht mal zeigen tut er sie ... Und was "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page126",
      "title": "DaoH/Snoopy64"
    }
  }), _vm._v(" für Röcke sind das, was für\nTücher, Hauben und Perlenschnüre,« sie begann umständlich alles Gut\naufzuzählen. Alles Unrecht, alle Bitternisse und Hoffnungen zählte\nsie her, aber Antek schwieg verbissen, bis sie ihn ungeduldig gegen\nden Arm stieß.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Schläfst du denn? ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich höre schon, rede nur, rede, das wird dich erleichtern, und\nwenn du fertig bist, sag' mir Bescheid ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Anna, die leicht bereit zum Weinen war und auch tatsächlich viel\nauf der Seele hatte, brach in Schluchzen aus und fing an, ihm\nVorwürfe zu machen, daß er zu ihr wie zu einer Magd spreche, daß er\nweder von ihr noch von den Kindern etwas halte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Bis Antek aufsprang und ihr höhnisch zurief:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Schreie nur, soviel wie du willst, die Krähen da werden dich\nschon hören und beklagen!« Er deutete mit den Augen auf die Vögel,\ndie über die Wiese geflogen kamen, drückte die Mütze tiefer auf und\nging hastig mit großen Schritten auf das Dorf zu.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Antek! Antek!« rief sie kläglich hinter ihm her, doch er wandte\nsich nicht einmal um.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie wickelte das Kind ein und eilte aufschluchzend über die\nFeldraine dem Bauernhof zu; ihr Herz war schwer/niemand war da, mit\ndem man reden konnte, vor dem man sich über sein Los hätte beklagen\nkönnen. Und man lebt allein wie 'n ... Termit, nicht mal zum\nNachbarn hat man Lust hinzugehen, um sich all den Kummer vom Herzen\nzu reden. Antek würde ihr schon kommen mit den Gevatterinnen,\nnichts als zu Hause sitzen, sorgen und sich abmoraken und zu guter\nLetzt kriegt man selbst nicht ein gutes Wort dafür! Andere gehen in\nden Dorfkrug und zu Hochzeiten ... aber der Antek ... kann man dem\nwas recht machen? ... Manchmal ist er so gut, wie Balsam auf die\nWunde, und dann kann man wochenlang nicht ein Wort aus ihm\nherauskriegen, nicht einmal ansehen tut er einen ... Immer nur\n"), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page127",
      "title": "DaoH/Snoopy64"
    }
  }), _vm._v(" grübeln\nund sinnieren ... Er weiß auch worüber, das ist wahr! Und der\nVater, könnte der ihnen nicht Land abschreiben, ist es nicht Zeit\nfür den Alten, auf seinen Altenteil zu gehen ... Ach, sie würde ihn\nschon pflegen, daß selbst der eigene Vater es nicht besser bei ihr\nhaben könnte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie wollte sich zu Jakob setzen, aber dieser klemmte sich mit\ndem Rücken gegen den Heuschober und tat, als ob er schliefe,\nobgleich ihm die Sonne gerade in die Augen schien; erst als sie\nhinter der Scheunenecke verschwunden war, erhob er sich, klopfte\ndas Stroh herunter und schlich sich bedächtig an den Obstgärten\nentlang dem Dorfkrug zu ... das Geld brannte ihm in der Tasche\n...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Schenke stand am Ende des Dorfes hinter dem Pfarrhof am\nAnfang der Pappelallee.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Menschen waren noch wenige da; die Musikanten klimperten hin und\nwieder, niemand jedoch tanzte; es war noch viel zu früh, und die\nJugend zog es vor, im Obstgarten herumzuscharmieren oder vor der\nEinfahrt an den Wänden entlang zu stehen, wo auf frischen und noch\ngelben Holzbalken schon ein ganzer Schwarm Mädchen und Weiber saß.\nIn der großen Stube mit der schwarzen rußigen Balkendecke war es\nfast leer, die kleinen angelaufenen Scheiben ließen das rote Licht\ndes Spätnachmittags so schwach durch, daß nur ein einziger Streifen\nauf dem ausgetretenen Fußboden lag, in den Ecken aber war es\ndämmerig. Ein paar Leute saßen da hinter den Tischen an der Wand,\naber unterscheiden konnte man nicht, wer es war.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Einzig Ambrosius, der Küster, stand mit einem von der\nBrüderschaft der Lichttragenden mit der Schnapsbuttel in der Faust\nam Fenster da/sie tranken einander häufig zu und redeten dies und\njenes ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Die tanzen heute wie die Fliegen im Pech! Los, rühr' dich mal,\nEve! Die ganze Nacht hast dich herumgetrieben und jetzt schläfst du\nim Tanz! Und das Thomasle! Mach doch, mach vorwärts! Ist's dir denn\nso schwer geworden, "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page128",
      "title": "DaoH/Snoopy64"
    }
  }), _vm._v(" dieses Maß Hafer, das du dem Juden verkauft\nhast, was? ... Hab nur keine Angst, der Vater weiß es noch nicht.\nLaß dich man mit den Rekruten ein, Maruschka, und bitte mich auf\nder Stelle zu Gevatter.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("So stichelte die alte Gusche gegen die Tänzer der Reihe nach,\nsie war eine Zügellose und hatte eine Wut gegen alle, weil sie die\neigenen Kinder benachteiligt hatten, so daß sie auf ihre alten Tage\nauf Tagelohn gehen mußte. Da ihr aber niemand antwortete, bekam sie\ndas Keifen bald satt und begab sich in die gute Stube, wo der\nSchmied mit Antek und noch einige jüngere Bauernsöhne saßen. Oben\nan der schwarzen Balkendecke hing eine Lampe und erhellte mit ihrem\nschwachen gelben Schimmer die hellen, wuscheligen Köpfe. Sie saßen\num den Tisch herum, stemmten sich fest auf die Ellbogen und hatten\nalle die Augen auf den Schmied gerichtet, der über den Tisch\ngebückt, ganz rot, mit den Händen breit fuchtelte und hin und\nwieder mit der Faust aufschlug und leise erzählte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Baßgeigen brummten, gerade als ob sich von draußen eine\nHummel in die Stube verflogen hätte und umhersauste ... manches Mal\nzwitscherte eine Geige ganz unerwartet auf, tief wie ein lockendes\nVöglein, dann wiederum turtelte und klirrte eine Trommel ... aber\nalsbald breitete sich wieder Stille aus.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Jakob ging geradeaus auf die Tonbank zu, hinter der Jankel mit\neinem Käppchen auf dem Hinterkopf und ohne Rock und Weste saß, denn\nes war warm in der Stube. Der Jude streichelte hin und wieder den\nweißen Bart, schaukelte hin und her und vertiefte sich in seine\nLektüre, die Augen dicht an die Blätter des Buches haltend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Jakob überlegte, trat von einem Fuß auf den anderen, zählte sein\nGeld, kratzte in seinem Zottelhaar und blieb lange so stehen, bis\nJankel ihn ein paarmal anblickte und ohne in seinem Schaukeln und\nseinem Gebet innezuhalten, das eine und das andere Mal die\nSchnapsgläser klirren ließ ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page129",
      "title": "DaoH/Snoopy64"
    }
  }), _vm._v(" »'n\nhalbes Maß, aber starken!« bestimmte er schließlich.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Zankel goß den Schnaps schweigend ein und langte mit der Linken\nnach dem Geld ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»In ein Glas schenken?« fragte er, nachdem die rostigen\nKupfermünzen ins Schubfach geschoben waren.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Versteht sich, doch nicht in 'n Stiebel! ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Er schob sich nach der Ecke der Tonbank, stürzte das erste Glas\nhinunter, spuckte aus und begann sich in der Schenke\numzuschauen;/den zweiten trank er gleich darauf, sah die\nSchnapsbuttel gegen das Licht an und klopfte mit ihr stark gegen\ndie Tonbank.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Noch einen und Tobak!« sagte er schon selbstbewußter, denn eine\nwohlige Wärme durchrieselte ihn nach dem Schnaps und eine\nmerkwürdige Kraft floß ihm durch die Glieder.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hat Jakob heute seinen Dienstlohn bekommen?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Warum denn das ... ist denn heut Neujahr?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Etwas Arrak gefällig?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Nee ... reicht nich.« Er zählte das Geld über und blickte\nkläglich nach der Arrakflasche.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich kann borgen, wir sind doch mit Jakob gute Bekannte.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Nich nötig./Wer borgt, der geht bald ohne Stiefel,« sagte Jakob\nscharf.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Trotzdem stellte Jankel ein Fläschchen mit Arrak vor ihm\nhin.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Er wehrte sich, machte selbst schon Anstalten wegzugehen, aber\ndas Luder von Arrak duftete so stark, daß es in der Nase kribbelte;\nso kämpfte er nicht länger, sondern trank nur, ohne viel zu\nüberlegen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Habt ihr im Wald was verdient?« fuhr Jankel fort, geduldig\nauszufragen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Nein, nicht im Walde ... sechs Rebhühndel, die ich im Netze\ngriff, brachte ich Hochwürden... der hat mir dafor einen Silberling\ngegeben.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page130",
      "title": "Snoopy64/rudi49"
    }
  }), _vm._v("\n»Fünfzehn Kopeken für sechs! 'n Zehner würde ich für jedes\nbezahlen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wieso, sind denn Rebhühndel koscheres Fleisch?...« Er war ganz\nerstaunt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Darüber brauchen sich Jakob kein Kopfzerbrechen machen ...\nbring' er mir welche und viel, und für jedes Rebhühndel kriegt er\n'n Zehner in bar, und zum Einverständnis werde ich einen extra\nStarken spendieren. Gelt?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»'n ganzen Zehner for das Stück wird Jankel bezahlen?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Mein Wort ist kein Wind. Und für die sechs hätte Jakob bei mir\nzwei halbe Maß reinen Schnaps und vier mit Arrak, einen Hering, 'ne\nSemmel und 'n Paket Tabak bekommen/verstanden?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Freilich ... vier halbe Maß mit Arrak und 'n Hering ... und\nfreilich ... 'n Vieh bin ich nicht, ohne Verstand ... richtig wahr!\nVier halbe mit Arrak und Tobak und Semmeln ... und 'n ganzen\nHering.« Der Schnaps umnebelte ihn schon und machte ihn etwas\nflau.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wird er welche bringen, Jakob?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Vier Halbe ... und 'n Hering und... Das werd' ich... Verflixt,\nwenn ich so 'n Gewehr hätte ...,« sagte er, etwas wieder zu\nBewußtsein kommend, und fing abermals an zu berechnen. »Ein\nSchafpelz zum Beispiel kostet 5 Rubel ... Stiefel sind auch nötig,\nan die drei Rubel ... nee, es reicht nich ... an die fünf Rubel\nwürde der Schmied für 'n Gewehr haben wollen ... wie von Raphus ...\nnee,« er überlegte laut weiter.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Jankel machte eine schnelle Berechnung mit der Kreide und\nflüsterte ihm leise ins Ohr.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Würde Jakob auch 'n Reh totschießen?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Freilich, aber aus der Faust kann keiner totschießen, mit dem\nGewehr würde ich das Luder schon treffen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Kann denn Jakob aus dem Gewehr schießen?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Jankel is 'n Jud', da weiß er nicht, was alle im Dorf "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page131",
      "title": "Snoopy64/wedi"
    }
  }), _vm._v(" wissen, daß ich\nmit den Herren in die Wälder ging, daß man mir dort diesen Klumpen\nangeschossen hat... warum soll ich da nicht schießen können.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich werde ein Gewehr geben, und Pulver werde ich geben und\nalles was Jakob braucht... und was er totschießt, das muß er mir\nbringen. Für 'n Reh gebe ich 'n ganzen Rubel, verstanden? 'n ganzen\nRubel. Und für das Pulver muß er 15 Kopeken pro Stück bezahlen, das\nkann man abziehen... Und dafür, daß das Gewehr wird schlechter\nwerden, wird er mir 'n Maß Hafer bringen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Einen Rubel für ein Reh... und wiederum ich für das Pulver 15\nKopeken... 'n ganzen Rubel!... ja, wieso denn!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Jankel rechnete nochmals genau vor.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hafer?... Ich werd' ihn doch nicht den Pferden unterm Maul\nwegholen...« Das eine hatte er verstanden.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wozu den Pferden nehmen! Auf dem Borynahof gibt's welchen auch\nanderswo.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ja, wieso denn...?« Er stierte den Juden an und überlegte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Alle machen es so! Und woher«, dachte Jakob, »haben die Knechte\nGeld?... jeder braucht Tabak und ein Glas Schnaps und möchte mal\nSonntags tanzen gehen. Woher nehmen?...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wieso... bin ich denn 'n Dieb, verfluchter Jud / oder was?«\ndonnerte er plötzlich los, mit der Faust aufs Tischbrett schlagend,\ndaß die Schnapsgläser hochsprangen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Was hat Jakob hier zu toben? Bezahlen soll er und sich zum\nTeufel scheren...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Aber Jakob bezahlte nicht und ging nicht fort, er hatte schon\nkein Geld mehr und war dem Juden selbst etwas schuldig... so\nstemmte er sich schwer gegen die Tonbank und fing an, schläfrig zu\nberechnen, und Jankel beruhigte sich und schenkte ihm nochmal ein\nGlas Arrak, aber reinen, ein, und sprach nichts mehr...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page132",
      "title": "Snoopy64/rudi49"
    }
  }), _vm._v("\nInzwischen strömten die Leute immer zahlreicher in die Schenke, die\nDämmerung wurde dichter, man brannte das Licht an, die Musikanten\nfingen an, flinker zu spielen, und ein lautes Stimmengewirr hatte\nsich erhoben. Das Volk sammelte sich vor der Tonbank, an den\nStubenwänden entlang oder auch mitten in der Schenkstube, beriet\nsich, unterhielt sich und der eine oder der andere trank dem\nNachbar zu, aber nicht allzuhäufig, denn sie waren nicht zum Saufen\ngekommen, sondern nur um mal 'n bißchen nachbarlich nebeneinander\nzu stehen, miteinander zu plaudern, auf die Geigen zu lauschen und\nauf die Baßviolen; auch dieses und jenes an Neuigkeiten zu\nerfahren... Es war doch Sonntagszeit/ da ist es keine Sünde,\nauszuruhen, die Neugierde zu befriedigen, oder selbst dieses Glas\nSchnaps mit dem Gevatter auszutrinken: wenn nur alles wie es sich\npaßte war und ohne Gotteslästerung vor sich ging, so hatte selbst\nHochwürden nichts dagegen... Warum denn auch nicht, auch das liebe\nVieh zum Beispiel ist froh, nach der Arbeit auszuruhen, und muß es\nauch. An den Tisch aber setzten sich die älteren Hofbauern und\neinige Frauen in rotleuchtenden Beiderwandröcken und Kopftüchern,\nsie sahen wie aufgeblühte Malven aus, und da die ganze Menschheit\ngleichzeitig sprach, ging es wie Waldesrauschen durch die Schenke,\nund das Stampfen der Füße war wie Dreschflegelgeklopf auf der\nTenne, und die Stimmen der Geigen, die ständig schäkernd sangen,\nklangen weit vernehmbar:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ach wer wird mich greifen wollen ... greifen wollen!?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich will's tun – ich will's tun – ich will's tun!« brummelten\ndie stöhnenden Baßgeigen als Antwort und die Trommel schüttelte\nsich nur immerzu und kicherte und schäkerte und machte Lärm mit\nihren Schellen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Nicht viele tanzten, aber sie trampelten so mächtig, daß die\nBretter des Tanzbodens krächzten und der Tisch bebte, daß hin und\nwieder die Flaschen klirrten und die Schnapsgläser umfielen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page133",
      "title": "Snoopy64/rudi49"
    }
  }), _vm._v(" Doch\ndie Lust war nicht allzugroß, denn es war auch keine richtige\nGelegenheit dazu, wie das bei Hochzeiten und Verlobungen üblich\nist. Man tanzte nur so, zum Spaß allein, oder um die Beine und das\nRückgrat gerade zu recken. Allein die Burschen, die im Spätherbst\nzur Musterung mußten, amüsierten sich eifriger und tranken aus\nKummer, was auch nicht verwunderlich war, denn sie sollten ja in\ndie weite Welt hinausgetrieben werden, unter Fremde.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Am lautesten aber lärmte der Bruder des Dorfschulzen, und dann\nauch Martin Weißer, Thomasle Kohlmeise, Paul Boryna, ein Vetter von\nAntek. Antek war heute allein in die Schenke gekommen, in der\nDämmerung, tanzte aber nicht. Er saß in der guten Stube mit dem\nSchmied und mit anderen noch. Auch Franz, der Müllerbursch, war da,\nein niedriger, stämmiger, krausköpfiger Bursche, das größte Maul,\nder ärgste Windbeutel und Maulaffe auf Gottes Erdboden, ein Kerl,\nder auf die Dirnen besonders happig war und darum auch häufig ein\nzerkratztes und zerschundenes Maul hatte. Aber da er heute gleich\nauf der Stelle sich vollgesoffen hatte, wie 'n Schwein, so stand er\nruhig an der Tonbank mit der dicken Magda vom Organisten, die\nbereits im sechsten Monat war.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Der Pastor hatte das schon von der Kanzel herab gerügt, und zur\nHeirat gemahnt, aber Franz wollte nichts davon hören, da er doch im\nHerbst dienen mußte, was sollte er da mit einem Frauenzimmer.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Magda zog ihn gerade in eine Ecke zur Ofenbank und redete mit\nweinerlicher Stimme auf ihn ein, er aber antwortete ihr darauf\nimmer wieder:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hab' ich mich dir aufgehängt... Dummes Luder!... Die Taufe\nwerd' ich bezahlen und einen Rubel schmeiße ich noch dazu, wenn's\nmir gefällt!...« Er war ganz unzurechnungsfähig und stieß sie von\nsich, daß sie auf der Ofenbank neben Jakob niedersitzen mußte, der\nsich bereits, mit den Füßen nach der Schenkstube zu, in der Asche\nschlafen gelegt "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page134",
      "title": "Snoopy64/rudi49"
    }
  }), _vm._v(" hatte; dort schluchzte sie leise vor sich\nhin, und Franz ging weitertrinken und die Dirnen in den Tanz zu\nnehmen. Die Bauerntöchter wollten ihn nicht, denn er war ein\nMüllerbursche, so etwas also wie ein Knecht etwa. Und die\neinfacheren Mädchen wollten ihn auch nicht, denn er war besoffen\nund stellte beim Tanzen allerhand Dummes an. So spuckte er denn\nverächtlich aus und fing an, sich mit dem Küster Ambrosius zu\numarmen und mit etlichen Bauern desgleichen, die, weil sie ihr\nGetreide in der Mühle hatten, ihn ihrerseits bewirteten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Trinke, Franz, und mahle mein Korn bald fertig. Meine Alte\nliegt mir schon immerzu in den Ohren, und zum Klößebacken ist auch\nnichts mehr da, nicht ein Krümelchen Mehl...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und meine rattert wegen der Grütze ohn' Unterlaß...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Es täte auch mächtig not wegen dem Schweinefutter für die\nMastsau ...,« redete ein dritter.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Franz trank, versprach und brüstete sich laut, daß alles in der\nMühle nach seinem Kopf gehe, daß der Müller auf ihn hören müsse,\ndenn andernfalls ... weiß er solche Sachen anzustellen, daß zum\nBeispiel Würmer in die Getreidekisten kämen ..., das Wasser\naustrocknete, die Fische ausstürben wenn er nur über den Teich\nhauchen würde ..., daß das Mehl klütig würde und keiner daraus\neinen Kuchen backen könnte...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Deinen Schafskopf würd' ich dir rupfen, wenn du mir das machen\nsolltest!« schrie Gusche, die sich überall 'rumdrückte, wo was los\nwar, obgleich sie nicht trank, denn selten hatte sie bar Geld\nparat; es war aber immer möglich, daß ihr ein Gevatter ein halbes\nMaß spendierte und ein Vetter desgleichen, denn man hatte Respekt\nvor ihrer scharfen Zunge. So bekam es auch Franz mit der Angst,\nobgleich er betrunken war und hielt sein Maul. Sie wußte über ihn\nmanches und mancherlei, wie er in der Mühle wirtschaftete, und da\nsie schon etwas angetrunken war, stemmte sie die Arme "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page135",
      "title": "Snoopy64/gary"
    }
  }), _vm._v(" in die Seiten\nund legte los, indem sie mit dem Fuß den Takt dazu schlug ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das ist die reine Wahrheit, denn so steht's auch in der Zeitung\nklar und deutlich ... So leben die Leute nicht in der Welt, wie\nhier bei uns, nein. Du lieber Gott, was hat man denn von seinem\nLeben? Der Gutsherr regiert, der Propst regiert, der Beamte\nregiert/und du arbeite und verrecke den Hungertod und verneige dich\nvor jedem, damit du nichts an den Kopf kriegst ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und kaum 'n Stück Land gehört dir, bald wird's nich mal für\neinen kleinen Streifen Acker pro Kopf reichen!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und der Gutsherr allein hat mehr als zwei Dörfer zusammen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gestern erzählten sie am Gericht, daß neues Land verteilt\nwerden soll.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Was für Land?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Na, herrschaftliches, welches denn sonst!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Sieh mal an! Geschenkt habt ihr's dem Gutsherrn, daß ihr es\nzurücknehmen wollt? Schau, schau, mit fremdem Gut wollen die schon\nwirtschaften,« brüllte Gusche und neigte sich lachend nach den\nDiskutierenden hin.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und sie regieren sich selbst,« erzählte der Schmied weiter,\nohne auf das Weibergerede zu achten, »und alle gehen zur Schule,\nleben in Herrenhöfen und sind Herren ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wo ist denn das so?« fragte Gusche den Antek Boryna, der gleich\nam Rande saß.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»In warmen Ländern!« gab er zurück.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Nee, wenn's dorten so gut ist, warum ist der Schmied da nicht\nhingegangen, wie? Das rußige Luder lügt ja wie gedruckt und\nschwindelt, und die Dummen glauben's!« rief sie schon ganz\nleidenschaftlich dazwischen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Geht, Gusche, woher ihr gekommen seid, solange ich gut bin\n...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das würde mir einfallen! Die Schenke ist für jedermann da und\nich bin für meine drei Groschen ebenso gut wie "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page136",
      "title": "Snoopy64/gary"
    }
  }), _vm._v(" du. Seht nur diesen\nKlugen, den Juden dient er, mit den Beamten hält er, nimmt vor dem\nGutsherrn die Mütze ab, und die hier glauben ihm! ... So 'n\nGroßmaul! ... Na, ich weiß schon ...« aber sie kam nicht zu Ende,\ndenn der Schmied faßte sie stark unter die Rippen, öffnete mit dem\nFuß die Tür und schmiß sie in die Vorderstube hinaus, wo sie, so\nlang wie sie war, liegen blieb.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Nicht einmal fluchen tat sie, und sagte nur lachend, nachdem sie\nsich erhoben hatte:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ein starkes Luder, wie 'n Pferd, so einer würde mir in die Ehe\npassen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Das Volk schlug eine Lache an, und gleich darauf ging sie\nhinaus, still vor sich hin schimpfend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Auch die Schenke leerte sich bereits, die Musik schwieg, die\nMenschen gingen auseinander nach Hause, einzelne standen noch in\nHaufen vor der Schenke, denn der Abend war hell und warm. Der Mond\nschien. Nur die Rekruten waren noch geblieben, tranken drauflos und\nlärmten. Der Küster Ambrosius aber, besoffen wie ein Vieh, war auf\ndie Mitte der Dorfstraße gewankt und sang, von einer Seite zur\nanderen taumelnd.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Auch die aus der guten Stube, mit dem Schmied voran, kamen\nheraus.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Später, als schon der Jude die Lichter zu löschen begann,\nschoben die Rekruten zur Türe hinaus, sie faßten sich recht fest\nunter, nahmen die ganze Straße ein und gingen aus voller Kehle\ngröhlend, so daß die Hunde geiferten und hin und wieder jemand aus\noffenem Fenster ihnen nachblickte ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Nur Jakob schlief ununterbrochen in der Asche und so fest, daß\nihn Jankel wecken mußte, aber der Bursche wollte nicht auf, er\nstieß noch ihm mit den Füßen, fuchtelte durch die Luft und\nbrummte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Scher' dich, Jud', verfluchter! So wie ich will, werde ich auch\nschlafen ... ein Hofbauer bin ich, habe meinen eigenen Willen und\ndu bist 'n Lausejud und 'n Rotkopf.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page137",
      "title": "Snoopy64/gary"
    }
  }), _vm._v(" Erst\nein Eimer Wasser half, so daß er aufstand, etwas klarer wurde und\nmit Angst und Staunen zu hören bekam, daß er einen ganzen Rubel\nvertrunken hatte/daß er in Schuld geblieben war ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wieso denn? Zwei Halbe mit Arrak ... ein ganzer Hering ...\nTobak und noch zwei Halbe ... und schon 'n ganzer Rubel? Wieso denn\n... zwei ...,« phantasierte er ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Jankel überzeugte ihn schließlich, und sie verständigten sich\nwegen des Gewehres, das ihm der Jude vom Jahrmarkt mitbringen\nsollte, und zum Schluß gab's noch ein Glas Essenz mit Spiritus.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Nur den Hafer weigerte sich Jakob entschieden zu versprechen\n...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Jakobs Vater war kein Dieb/so ist der Sohn auch kein Dieb.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Geht, geht doch endlich, 's ist schon Schlafenszeit ... und ich\nhabe noch meine Gebete zu lesen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Donnerwetter! ... So 'n Spekulant! Zum Stehlen will er einen\nüberreden, und muß Gebete lesen ...« brummte er vor sich hin im\nNachhausegehen und fing nun an, sich alles zu überlegen und\nnachzusinnen, denn es konnte ihm gar nicht in den Kopf, daß er\neinen ganzen Rubel vertrunken hatte ... Da er aber noch nicht\nnüchtern war und die frische Luft ihn flau gemacht hatte, so\ntorkelte er 'n bißchen und wankte hin und wieder gegen einen der\nZäune oder auch auf einen Haufen Bauholz, das verschiedentlich vor\nden Katen lag ... Dann fluchte er ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Krumm sollt ihr werden, ihr Ludersch! ... Halunken, so den Weg\nzu versperren! Besoffen sind sie, die Biester ... und Hochwürden\nkann umsonst mahnen ... und Hochwürden ...« hier wurde er\nnachdenklich und überlegte, bis über ihn schließlich die Erkenntnis\nkam und ein solcher Jammer, daß er stehenblieb, rings um sich\nblickte, sich beugte und nach irgendwas herumsuchte ... sofort\nhatte er es aber wieder vergessen und faßte sich an seine Zotteln\nund "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page138",
      "title": "Snoopy64/gary"
    }
  }), _vm._v(" fing\nan, sich mit der Faust aufs Maul zu schlagen und zu schreien.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Du Saufjan! Du verfluchtes Schwein! Zu Hochwürden werde ich\ndich hinschleppen, daß er dir vor dem ganzen Volk ins Gesicht sagt,\ndaß du ein Hund und 'n Saufjan bist ... daß du zwei halbe ... daß\ndu einen ganzen Rubel versoffen hast ... daß du 'n Vieh bist, oder\nnoch was Schlimmeres! ... Daß du ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und ein plötzliches Weh erfaßte ihn über sich selbst, daß er\nsich auf der Dorfstraße niedersetzte und losheulte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Der helle, große Mond ruderte durch die dunklen Räume und hier\nund da, nicht allzu dicht, blitzten die Sterne wie silberne\nNagelköpfe; die Nebel spannen sich in grauen unscheinbaren\nSpinnweben über dem Dorfe und wehten, wie ein Schleier über den\nWassern. Die unergründliche Stille einer Herbstnacht erfüllte die\nWelt, nur hin und wieder riß sich von ihr das Gesinge der von der\nSchenke Heimkehrenden los und das Kläffen der Hunde.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und auf der Dorfstraße vor der Schenke wankte Ambrosius von\neiner Seite der Straße zur anderen und sang immerzu, immerzu, ohne\nUnterbrechung bis er nüchtern wurde:")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Maruschka, oh Maruschka!"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nWem brautest du das Bier wohl da?"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nWem brautest du das Bier wohl da?"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nMaruschka, oh Maruschka!")]), _vm._v(" "), _c('p', {
    staticClass: "pcalibre6 initial1"
  }, [_vm._v("Es ging immer tiefer in den\nHerbst hinein. Blasse Tage schleppten sich durch die leeren,\nstummgewordenen Felder, erstarben in den Waldrevieren und wurden\nimmer stiller, immer bleicher/gleich heiligen Hostien im\nverlöschenden Schein der Totenkerzen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und bei jedem Morgengrauen stand der Tag träger auf, ganz von\nKälte erstarrt, im Rauhreifkleide und in der "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page139",
      "title": "Snoopy64/gary"
    }
  }), _vm._v(" schmerzerfüllten Stille der\nersterbenden Erde; die blasse, schwere Sonne erblühte aus den\nTiefen inmitten der Kränze von Krähen und Dohlen, die irgendwo über\nden Morgenröten aufflatterten und niederen Fluges über die Ebene\nzogen, dumpf, lange und kläglich krächzend ... Ihnen nach jagte der\nscharfe, kalte Wind/trübte die starren Gewässer, zehrte das letzte\nGrün der Blätter aus und riß das letzte Laubwerk von den gebeugten\nPappeln an den Wegen, so daß die Blätter still niedertropften, wie\nTränen/wie blutige Tränen des gestorbenen Sommers, die schwer auf\nden Boden fallen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und bei jedem Morgengrauen/wachten die Dörfer später auf: das\nVieh zog träger auf die Weiden, die Angeln der Tore knarrten\nleiser, leiser klangen die Stimmen, die die öde Totenstille der\nFelder gedämpft hatte, und leiser, ängstlicher ging der Pulsschlag\ndes Lebens. Manchmal nur sah man vor den Hütten oder auf den\nFeldern Menschen jäh stehenbleiben und lange in die düstere,\nbläuliche Ferne starren ... Und über den vergilbten Gräsern hoben\nsich mächtige gehörnte Köpfe und versenkten langsam wiederkäuend\ndie Augen in den weiten, weiten Raum ... Manchmal nur irrte über\ndas öde Land ein dumpfes, klagendes Gebrüll.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und bei jedem Morgengrauen war es immer dämmeriger und kälter,\nder Rauch spann sich niedriger durch die kahlen Obstgärten hin und\nimmer mehr Vögel kamen ins Dorf geflogen und suchten Schutz an den\nScheunen und Schobern; die Krähen ließen sich auf die Dachfirste\nnieder, hingen sich in die nackten Bäume oder zogen Kreise über der\nErde und krächzten stumpf, als müßten sie das Klagelied des Winters\nsingen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Mittage waren sonnig, aber so tot und glasig, daß das\nRauschen der Wälder wie ein beängstigendes Raunen bis hinein in das\nDorf drang, und das Gurgeln des Flusses wie ein schluchzendes\nGemurmel klang. Die Reste des Altweibersommers "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page140",
      "title": "Snoopy64/gary"
    }
  }), _vm._v(" kamen noch von irgendwo\ndahergeflogen und verschwanden in den scharfen, kühlen Schatten,\ndie zwischen den Hütten lagen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Wehmut des Sterben-Müssens war in diesen stillen Mittagen,\ndas Schweigen lag auf den leeren Wegen, und in den entblätterten\nObstgärten lauerte die tiefe Schwermut des Leids und des bangen\nWartens.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und oft und immer öfter umzog sich der Himmel mit graugelben\nWolken, so daß man schon zur frühen Vesperzeit vom Feld heim mußte,\ndenn die Dämmerung legte sich früh über die Erde ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Man pflügte noch die Äcker für das Sommerkorn und manch einer\nwarf die letzten Schollen schon im dichten Düster; heimwärts\nschreitend, sah er sich noch einmal um und umfing mit einem\nabschiednehmenden Blick sein Land, des fernen Lenzes mit einem\nSeufzer gedenkend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Nach der Vesperzeit gingen häufig Regenschauer nieder; sie\ndauerten noch kurz, waren aber kalt, und immer häufiger dehnten sie\nsich in die Länge, bis zum Eintritt der Dämmerung/der langen\nherbstlichen Dämmerung, in der die Fenster der Hütten wie goldene\nBlüten aufflammten und die Pfützen auf den leeren Wegen sich mit\nGlast überzogen. Die feuchte, kalte Nacht stieß gegen die Wände und\nstöhnte in den Gärten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Selbst der flügellahme Storch, der zurückgeblieben war und\neinsam auf den Wiesen watete, suchte immer häufiger Borynas Schober\nauf, oder kam sogar auf den Hof, wo Witek ihm als Lockmittel eifrig\nNahrung hinwarf.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und verschiedene Bettler besuchten immer öfter das Dorf; es war\ndas übliche Bettelvolk, das mit tiefen Säcken und langen Gebeten\nvon Tür zu Tür ging, vom Kläffen der Hunde geleitet/es kamen auch\nandere, solche, die von heiligen Statten kamen/sie kannten\nOstra-Brama, Tschenstochau und Kalwarya und erzählten gern an\nlangen Abenden, wo und was in der Welt geschehen war und welche\n"), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page141",
      "title": "DaoH/gary"
    }
  }), _vm._v(" Wunder sich\nirgendwo offenbart hatten, und zuweilen fand sich gar ein solcher\nein, der im stillen selbst über das Heilige Land zu reden wußte und\nsolche Wunder berichtete, solche Länder kannte, durch solche Meere\ngefahren war, so viele Abenteuer erlebt hatte, daß die andächtig\nlauschenden Zuhörer ein Staunen ergriff, und manch einem schwer\nwurde, an das alles zu glauben ... Doch horchte man gierig, da ja\njeder gern etwas Neues erfahren mochte, und auch die Abende waren\nlang, man konnte sich obendrein bis zum Morgengrauen reichlich\nausschlafen, selbst auf beiden Seiten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Das war der Herbst, der späte Herbst, juchhe!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Doch im Dorf hörte man weder Gesang noch frohe Juchzer, weder\ndas Piuken der Vögel, noch helle Zurufe/ nichts als den Wind, der\nin den Strohdächern wimmerte, als die Regenfälle, die wie mit\nGlassplittern gegen die Scheiben prasselten, und das dumpfe, sich\nvon Tag zu Tag mehrende Geklopfe der Dreschflegel in den\nScheunen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Lipce erstarb, wie seine umliegenden Felder, die erschöpft, grau\nund beraubt in der Ruhe, und in der Stille des Erstarrens dalagen;\nwie seine kahlen, zerzausten, trauernden Bäume, die langsam für\neinen langen, langen Winter abstarben.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Das war die Herbstzeit, die leibliche Mutter des Winters.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Man tröstete sich nur noch damit, daß es noch nicht das schlimme\nSchmutzwetter war, daß die Wege noch nicht allzusehr durchweicht\nwaren und daß vielleicht das Wetter bis zum Jahrmarkt aushalten\nwürde, zu dem ganz Lipce sich aufmachen wollte, wie zu einer\nKirmes.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Der Jahrmarkt sollte auf den Tag der heiligen Kordula fallen,\nund war der letzte große Markt vor dem Weihnachtsfest; darum\nbereitete sich alles mit großer Sorgfalt für den Tag vor.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Schon einige Tage vordem deliberierte man im Dorf, was sich wohl\nverkaufen ließe, sei es vom Inventar, sei es "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page142",
      "title": "wolfeh/gary"
    }
  }), _vm._v(" vom Korn oder auch vom\naufgezogenen Jungvieh. Und da es zum Winter ging, so hatte man auch\nnicht wenig einzukaufen, an Kleidung und Geräten und manchen\nWirtschaftssachen, was in den Hütten verschiedene Sorgen machte und\nwovon manche Zänke und Zwistigkeiten entstanden, denn man weiß es\nja, daß niemand es allzu reichlich hat, und daß bar Geld immer\nschwerer zu haben ist.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und gerade um die Zeit wurden die Steuern fällig, dann wieder\ndie Gemeindebeiträge und zu guter Letzt noch verschiedene\nAbzahlungen untereinander und bei manchen die Anleihen aus der\nVorerntezeit. Etliche mußten auch die Dienstlöhne ausbezahlen / all\ndas machte so viel zusammen aus, daß selbst einer, der eine halbe\nHufe besaß, schwer aufseufzend überlegte. Dabei kam aber doch\nnichts anderes heraus, als daß eine Kuh oder ein Pferd zu Markt\ngetrieben werden mußte; von den Ärmeren schon gar nicht zu\nreden.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("So führte denn mancher seine Kuh vor den Kuhstall, putzte ihr\nmit einem Strohwisch die mistbeschmutzten Flanken und warf ihr für\ndie Nacht noch Kleefutter in die Raufe, oder mit Kartoffeln\ngekochte Gerste in die Krippe, damit es sie noch ein bißchen\naufblähte inzwischen; ein anderer richtete seinen alten, ganz\nerblindeten Klepper her, damit er, sozusagen, wieder\nPferdeähnlichkeit hatte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Andere noch droschen eifrigst ganze Tage lang, um rechtzeitig\nzum Jahrmarkt fertigzuwerden.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Auch bei Boryna bereitete man sich emsig vor; der Alte drosch\nmit Jakob den Weizen zu Ende, und Fine und Anna mästeten, soviel\nsie noch konnten, in ihrer freien Zeit eine Sau und ein paar Gänse\nzurecht, die sie sich von den Zuchtgänsen ausgeschichtet hatten.\nUnd Antek, da schon jeden Tag die Regenzeit eintreten konnte, fuhr\nmit dem Hirtenjungen in den Forst, Reisig und Tannennadelstreu zu\nholen, von der ein Teil für den Kuhstall bestimmt war, während der\nRest zu einem Haufen vor dem Wohnhaus "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page143",
      "title": "wolfeh/gary"
    }
  }), _vm._v(" aufgeschüttet wurde, um für den\nWinterschutz der Wände zu dienen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Bis spät in die letzte Nacht vor dem Jahrmarkt dauerte diese\nbeschleunigte Arbeit; und erst als der Weizen schon in großen\nSäcken auf dem Wagen lag, den man in die Scheune geschoben hatte,\nund alles für den morgigen Tag bereitet war, setzten sich alle zum\nNachtmahl in Borynas Stube.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Auf dem Herd brannte lustig ein helles Feuer aus Tannenholz und\nknisterte fortwährend, sie aber aßen langsam und schweigend, da\nniemand nach der angestrengten Arbeit Lust hatte, sich zu äußern;\nerst als sie mit dem Essen fertig waren und die Frauen die\nSchüsseln und Töpfe von der Bank weggeräumt hatten, sagte Boryna,\ndem Herde leicht näherrückend:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Vor Tag soll aufgebrochen werden!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Natürlich, nicht später,« antwortete Antek und ging ans\nSchmieren des Pferdegeschirrs. Jakob schnitzte einen Klöppel für\nden Dreschflegel, und Witek schalte Kartoffeln für den Morgen,\nstieß dabei aber immer wieder den Waupa an, der neben ihm lag und\nsich mit den Zähnen Flöhe aus dem Pelz zog.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Eine Stille war eingetreten, so daß man nur das Knistern des\nFeuers hörte und ab und zu das Aufzirpen der Heimchen hinterm Herd.\nVon der anderen Seite des Hauses drang Wassergeplantsch herüber und\ndas Geklirr der gewaschenen Töpfe.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Jakob, bleibt er denn weiter im Dienst?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Jakob ließ das Schnitzmesser, mit dem er herumbastelte,\nzuschnappen und verguckte sich dermaßen ins Feuer, daß Boryna ihn\nmahnen mußte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hörst du nicht, was ich dir sage?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hören ..., das hab' ich schon, ich laß es mir nur durch den\nKopf gehen, daß ich, wahr gesagt, bei euch nichts auszustehen hatte\n... Alles was recht ist, aber doch ...,« er brach bestürzt ab.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page144",
      "title": "wolfeh/gary"
    }
  }), _vm._v(" »Fine,\ngib mal Schnaps und was zum Beißen, was sollen wir beim Trocknen\nberatschlagen, wie hergelaufene Juden,« befahl der Alte und schob\ndie Bank dicht an den Herd, auf dem Fine bald darauf eine Flasche,\nBrot und einen Kranz Würste hinstellte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Trink' mal einen, Jakob, und sag', was du zu sagen hast.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gott bezahl's, Bauer ... Bleiben, das würd' ich schon, aber ...\naber ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich will dir auch was zugeben ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das würde schon zu paß kommen, gewiß, der Schafspelz fällt\nschon ganz auseinander und die Stiefel auch, und den Kapottrock\nmüßt' ich auch wieder neu haben ... der Mensch sieht schon wie 'n\nLump aus, und selbst in die Kirche wagt man sich nicht hinein, man\nmuß schon rein in der Vorhalle bleiben ... denn wie kann man vor\nden Hauptaltar in solcher Verfassung ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und Sonntag, da hast das nicht gemeint, da hast du dich\nzwischen die Ersten gedrängt ...,« sagte Boryna streng.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gewiß schon ... aber ... das is wahr ...,« stotterte er sehr\nbeschämt und errötete heftig.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und Hochwürden predigt doch, daß man die Älteren ehren soll.\nTrink' mal eins zum Frieden, Jakob, und höre was ich dir sage, da\nwirst du schon selbst sagen, daß ein Knecht kein Bauer ist ...\nJeder hat seinen Platz und für jeden hat unser Herr Jesus etwas\nanderes bestimmt. Hat dir der Herr Jesus deinen Platz bestimmt, so\nhalt' dich dran und such' nicht gegen anzugehen, und dräng' dich\nnicht auf die erste Stelle, erhebe dich nicht über die anderen,\nsonst begehst du 'ne große Sünde, und selbst Hochwürden wird dir\ndas sagen, daß es so sein muß / damit Ordnung in der Welt ist.\nBegreifst du das, Kuba?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Da müßt' ich schon 'n dummes Vieh sein, wenn ich das nicht\nverstehen soll. Meine Vernunft hab' ich schon.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Dann paß auf, daß du dich nicht über die anderen erhebst.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page145",
      "title": "wolfeh/gary"
    }
  }), _vm._v(" »Ih ...\nnur dem Altar wollt' ich näher sein.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Herr Jesus wird dich selbst aus dem letzten Winkel hören, hab'\nkeine Angst. Und wozu sich unter die Allerersten drängeln, wo doch\nalle wissen, wer du bist.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gewiß, gewiß ... wär' ich ein Hofbauer, würde ich den\nTraghimmel tragen und Hochwürden am Arm führen, und in den Bänken\nsitzen und nach dem Buch laut singen ... aber da ich nur ein Knecht\nbin, wenn auch ein Bauernsohn, so soll ich in der Vorhalle stehen,\noder auch draußen vor der Kirchtür, wie 'n Hund ...« murrte er\ntraurig.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das ist schon eine solche Einrichtung in der Welt und dein Kopf\nwird's nicht ändern.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Freilich, meiner nicht, freilich ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Trink' noch einen, Kuba, und sage mir, was ich dir an Lohn mehr\ngeben soll.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Jakob trank aus; da ihn aber der Schnaps schon etwas umnebelt\nhatte, so bildete er sich ein, er säße in der Schenke mit dem\nMichael vom Organisten oder mit einem anderen Kameraden, und daß\nsie sich frei und guter Dinge miteinander berieten, wie unter\nseinesgleichen. Er lüftete seinen Kapottrock, streckte seine Beine\nvon sich, ließ die Faust auf die Bank niedersausen und schrie\nlos:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Vier Papierchen und einen Rubel Handgeld wird er zuzahlen, dann\nbleib' ich.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Es scheint mir, daß du besoffen bist, oder hat sich dir etwas\nim Kopf verdorben?« rief Boryna aus; aber Jakob ging schon seinen\nGedanken und seinen alten Träumen nach, und obendrein hörte er\nnicht mehr die Stimme des Hofbauers, so reckte er denn seine\ngeduckte Seele, wuchs in einen solchen Ehrgeiz und in solches\nSelbstbewußtsein hinein, daß er sich wie ein Hofbauer fühlte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Vier Papierchen und noch einen Rubel Handgeld / legt er das zu,\ndann bleib' ich bei ihm, und tut er das nicht, dann geh' ich,\nhundsverdammt nochmal, zum Jahrmarkt und finde mir schon einen\nDienst und vielleicht noch gar als "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page146",
      "title": "wolfeh/gary"
    }
  }), _vm._v(" Herrschaftskutscher ... Man kennt mich,\ndaß ich arbeiten kann und daß ich mich auf alles auskenne, was im\nFeld und um das Haus 'rum ist, manch ein Hofbauer könnt' bei mir\nVieh hüten und bei mir in die Lehre gehen ... Und tut er's nicht,\ndann werde ich Vögel schießen und sie Hochwürden hintragen oder\nauch dem Jankel ... und tut er's nicht ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Sieh mal an ... dieser Hinkfuß, was der hier auftitscht ...\nKuba!« rief er streng.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Jakob verstummte und ernüchterte sich aus seinen Zuständen, doch\nverlor er seinen Trotz nicht, denn er gab nicht nach, so daß\nBoryna, ob er wollte oder nicht, ihm hier einen halben Rubel, da\neinen Silberling zugab, bis es schließlich dabei bestehen blieb,\ndaß er ihm für das kommende Jahr einen Zuschuß von drei Rubeln und\nzwei Hemden anstatt des Handgelds versprach.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ho, ho, du bist mir ein netter Vogel,« rief der Alte, indem er\nihm zum Einverständnis zutrank, und obgleich er ärgerlich war, daß\ner so viel Gelb hinschmeißen mußte, so war es zwecklos, zu\nschwanken, denn Jakob war auch mehr wert, ein arbeitsamer Knecht,\ngut für zwei, was dem Bauer sein war, das war dem heilig, und um\ndas Vieh kümmerte er sich mehr wie um sich selbst, und wenn er auch\nlahmte, und nicht sehr stark war, so kannte er sich doch gut in der\nWirtschaft aus / man konnte sich ganz auf ihn verlassen, daß er\nalles, wie es sich gehörte, machen würde und dazu noch den\nTagelöhner überwachen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie beratschlagten noch über dieses und jenes, und als sie sich\nanschickten, auseinanderzugehen, ließ sich Jakob ganz schüchtern\nvon der Tür aus vernehmen:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Is so gut mit den drei Rubeln und den zwei Hemden, aber...\naber... die Jungstute, die dürft ihr nicht verkaufen ... ist doch\nbei mir geworfen worden ... mit meinem Schafpelz hab' ich sie doch\nzugedeckt, daß sie nicht umkam ..., das seh' ich nicht mit an, wenn\nsie ein Jude oder irgendein Lump aus der Stadt schlagen sollte...\nVerkauft "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page147",
      "title": "Frank_9901/gary"
    }
  }), _vm._v(" sie nicht ... ein Gold von einem Pferd ...\ngehorsam wie ein Kind ... so 'n Pferd, da ist manch Mensch 'n Vieh\ndabei. Tut sie nicht verkaufen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Nicht in den Kopf ist mir das gekommen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Sie haben es in der Schenke gesagt ... da hab' ich mich darum\ngesorgt ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Vormünder, Hundsgesindel, immer wissen sie 's am besten.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Jakob hätte am liebsten aus Freude seine Knie umschlungen, aber\ner traute sich nicht, so setzte er denn seine Mütze auf und ging\nbald, da es denn auch Zeit war, schlafen zu gehen, in Betracht auf\nden morgigen Jahrmarktstag.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("— — — — —")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Am nächsten Morgen, vor Tagesanbruch also, / kaum hatten die\nHähne zum zweiten Male gekräht, / rührten sich auf allen Wegen und\nStegen, die nach Tymow führten, die Menschen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Was nur lebte in der ganzen Umgegend, strömte zum Jahrmarkt hin.\nGegen Morgen war starker Regen gefallen, doch nach Sonnenaufgang\nhatte es sich etwas aufgehellt, aber der Himmel war noch mit grauen\nWolkenungetümen bedeckt und über den tiefgelegenen Landen hingen\ngraue Nebelschwaden, wie ganz durchnäßte Sackleinentücher; auf den\nWegen spiegelten die Pfützen und hier und da in den Wegsenkungen\nquantschte der Schmutz unter den Füßen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Auch von Lipce kamen sie schon vom frühen Morgen her\nangezogen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Auf dem Pappelweg hinter der Kirche und weithin bis an die\nWälder sah man eine Kette von Wagen sich Schritt für Schritt\nvorwärtsbewegen, so ein Gedränge war es, und auf den Stegen von\nbeiden Seiten des Weges schimmerte es von roten Beiderwandröcken\nder Frauen und weißen Haartuchkitteln der Männer.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("So viel Volk war unterwegs, als ob ein ganzes Dorf\nauswanderte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page148",
      "title": "Frank_9901/gary"
    }
  }), _vm._v(" Die\närmeren Bauern gingen zu Fuß, es kamen Frauen, Knechte und\nDorfmädchen, es kamen Kätner und auch ganz armes Volk, lauter\nTagelöhner / alles zog dahin, denn es war ein Jahrmarkt, zu dem die\nBauern dingten und auf dem Stellen gewechselt wurden.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Der eine hatte was zu kaufen, der andere was zu verkaufen, und\nnoch andere gingen, um sich zu amüsieren.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Dieser und jener führte eine armselige Kuh oder ein kräftiges\nKalb am Strick, der wiederum trieb eine Sau mit Ferkeln vor sich\nhin, die hin und her quiekten und dermaßen auseinanderdrängten, daß\nman sie immerfort zusammentreiben und hüten mußte, damit sie nicht\nunter die Wagen kämen; ein anderer zockelte auf einer Mähre dahin.\nEtliche aber trieben geschorene Schafe und hier und da blitzte eine\nkleine Herde Gänse, mit festgebundenen Flügeln auf, oder ein\nHahnenkamm guckte unter einer Frauenschürze hervor ... Auch die\nWagen waren nicht schlecht beladen, immer wieder schob sich in\nirgendeinem Korbwagen die Schnauze eines Mastschweins aus dem Stroh\nhervor und schrie, daß die Gänse erschrocken aufgackerten und die\nHunde, die mit den Menschen Schritt hielten, anfingen, gegen die\nWagen anzukläffen. Und so zogen sie dahin und füllten die ganze\nStraße, aber es war unmöglich, daß alle darauf Platz fanden trotz\nihrer Breite. Manch einer mußte vom Weg heruntertreten und zwischen\nden Furchen des Ackerlands gehen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Bei vollem Tag, nachdem sich der Himmel so erhellt hatte, daß\ndie Sonne jeden Augenblick zu erwarten war, trat auch Boryna\nhinaus; vordem schon hatten Anna und Fine bei Morgengrauen die Sau\nund den angemästeten Eber fortgetrieben, und Antek war mit zehn\nSäcken Weizen und einem halben polnischen Scheffel roten Klees\nweggefahren. Zu Hause blieb Jakob mit Witek und die Gusche, die man\nherbestellt hatte, um das Essen zu kochen und aufs Vieh zu\npassen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Witek heulte laut vor dem Kuhstall, denn er hatte auch Lust, mit\nzum Jahrmarkt zu gehen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page149",
      "title": "Frank_9901/gary"
    }
  }), _vm._v(" »Was\ndem nur einfällt« brummte Boryna, bekreuzigte sich und machte sich\nzu Fuß auf den Weg, denn er rechnete damit, unterwegs irgendwo\naufzusteigen. So geschah es auch gleich, denn dicht hinter der\nSchenke holte ihn der Organist ein, der in einer mit zwei tüchtigen\nPferden bespannten Britschka dahergefahren kam.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Nanu, Matheus, zu Fuß?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Der Gesundheit wegen ... Gelobt sei Jesus Christus.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»In Ewigkeit. Setzt euch bei uns auf, wir kommen alle zusammen\nunter!« schlug die Frau des Organisten vor.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gott bezahl's. Auch zu Fuß würd' ich schon hinkommen, aber wie\nman so sagt: es ist der Seele mehr wert, wenn sie im Wagen fährt«\nantwortete er, den Vordersitz einnehmend, indem er seinen Rücken\nden Pferden zugewandt hielt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie drückten sich freundschaftlich die Hände; die Pferde zogen\nan.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Der Herr Jasch, wo kommt er denn her, nicht mehr in den\nKlassen?« fragte er den Jungen, der neben dem Knecht auf dem Bock\nsaß.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Nur für den Jahrmarkt bin ich hergekommen!« rief der\nOrganistenbub fröhlich.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»'ne Prise gefällig? französischer ...,« bot der Organist an,\ngegen seine Tabakdose schnippend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie langten zu und niesten beiderseits gehörig.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Was gibt's bei euch? Verkauft ihr heute was?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gott, ja, in der Früh haben sie Weizen hingefahren und die\nFrauen haben ein Schwein fortgetrieben.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»So viel!« rief die Organistin aus, »Jaschu, nimm das\nHalstüchel, es ist kalt,« schrie sie dem Sohn zu.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Mir ist warm, ganz warm,« versicherte er, trotzdem aber\nwickelte sie den roten Wollschal um seinen Hals.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und die Ausgaben, die sind jetzt auch nicht klein. Man weiß\nschon nicht, woher man alles nehmen soll ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Klagt nicht, Matheus, ihr habt genug, Gott sei's gedankt.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page150",
      "title": "Frank_9901/gary"
    }
  }), _vm._v("\n»Meinen Grund und Boden kann ich doch nicht essen ... und bar Geld\nhat man nicht zu Hause liegen ..")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Im Grunde war Boryna nicht zufrieden mit diesen Anspielungen in\nGegenwart des Knechtes; er beugte sich schnell vor und fragte\nleise:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und Herr Jasch, wird er denn noch lange in den Klassen\nbleiben?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Nur noch bis zu den Feiertagen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Kommt er nach Hause oder wird er ein Amt lernen?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Oh, du mein, was sollte der wohl zu Hause auf den fünfzehn\nMorgen machen, da gibt es noch gerade genug Kleinzeug ... Und die\nZeiten sind schlecht / man muß es rein wie aus Steinen herausholen\n...,« seufzte sie auf.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das ist schon recht, Taufen gibt's da noch genug, aber viel\nProfit kommt nicht heraus dabei!« pflichtete der Organist bei.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»An Beerdigungen mangelt's doch aber nicht,« warf Boryna\nironisch hin.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Iii ... aber was für Beerdigungen, lauter armes Volk stirbt\nweg, und kaum paarmal im Jahr, daß sich ein ordentliches\nBauernbegräbnis trifft, bei dem was abfällt.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Messen werden auch immer weniger bestellt, und handeln tun sie\ndabei wie die Juden« ergänzte die Frau.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das kommt alles wegen der Armut und den schlechten Zeiten,«\nentschuldigte Boryna.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Aber auch von daher, daß die Menschen nichts auf ihr Seelenheil\ngeben und sich nicht um die kümmern, die im Fegefeuer sind. Der\nPropst hat's mehr wie einmal zu dem Meinen gesagt.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Auch die Herrenhöfe werden immer weniger. Als man früher zum\nErntedank "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0003#foot3",
      "id": "text3"
    }
  }, [_c('sup', {
    staticClass: "calibre6"
  }, [_vm._v("F3")])]), _vm._v(" oder mit den Oblaten herumfuhr, und zu\nWeihnachten gratulierte, oder wegen der Volkszählung "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0003#foot4",
      "id": "text4"
    }
  }, [_c('sup', {
    staticClass: "calibre6"
  }, [_vm._v("F4")])]), _vm._v(" kam, dann ging man, ohne\nsich lang zu bedenken, direktemang zum Herrenhof; da wurde dann\nnicht gespart an Getreide, Geld und Legümien. Und jetzt ist es rein\n"), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page151",
      "title": "DaoH/gary"
    }
  }), _vm._v(" zum\nGotterbarmen, jeder Bauer krümmt sich, und die kleinste Garbe\nRoggen, die er dir gibt, ist noch halb von Mäusen zerfressen, und\nwenn du ein viertel Maß Hafer kriegst, dann gibt's gewiß mehr Spreu\nwie Korn drin. Das laßt euch mal von meiner Frau erzählen, was für\nEier sie mir vergangenes Jahr zur Osterzählung "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0003#foot5",
      "id": "text5"
    }
  }, [_c('sup', {
    staticClass: "calibre6"
  }, [_vm._v("F5")])]), _vm._v(" mitgegeben haben/ mehr\nals die Hälfte war verrottet. Wenn der Mensch nicht sein bißchen\nGrund und Boden hätte, dann könnte man betteln gehen,« schloß er,\nBoryna die Tabaksdose anbietend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gewiß, gewiß ...,« gab Boryna bei, aber weismachen ließ er sich\nnichts, er wußte schon, daß der Organist Geld auf Prozente oder\ngegen Entgelt in Feldarbeit den Kätnern lieh, so lächelte er nur zu\ndiesen Klagen und wandte sich nochmals zu Jasch hin ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und was denn, wird er ins Amt gehen? ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Was? Mein Jasch ins Amt ... ein Schreiber? Dafür hab' ich's mir\nnicht vom Mund abgespart, daß er die Schulen durchmacht, ja nicht!\nIns Seminar kommt er, wird Priester werden ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Priester!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ist das vielleicht ein schlechtes Auskommen? Gibt's vielleicht\neinen Priester, der's schlecht hat?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das ist wohl recht ... und eine Ehre ist es auch; man sagt ja\ndoch: Wer einen Priester zum Verwandten hat, frißt sich alle Tage\nsatt ...,« sagte er langsam und sah mit Hochachtung über die\nSchulter auf den Jungen, der den Pferden zuflötete, für die es\ngerade nötig war, einen Augenblick anzuhalten ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Man erzählte, daß dem Müller sein Stacho Priester werden\nsollte, und jetzt praktiziert er auf den hohen Schulen und will 'n\nDoktre werden ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hat sich was, den Lump noch zum Priester machen, da ist doch\ndie Magda bei uns, die geht schon im sechsten Monat, und das ist\nvon ihm ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Man sagte, daß es der Müllersknecht gewesen ist.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page152",
      "title": "lac/DaoH"
    }
  }), _vm._v(" »Häh, wer\ndran glaubt, das sagt die Müllerin, um ihren reinzuwaschen. Das ist\nein Liederjahn, das Gott erbarm, der paßt zum Dokter.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Versteht sich, daß Priester sein besser ist, es ist auch unserm\nHerrn Jesus zu Ehren und den Menschen zum Trost,« pflichtete ihr\nBoryna schlau bei, was sollte er auch mit einer Frau herumzanken,\nund ganz aufmerksam hörte er ihren Ausführungen zu. Der Organist\nlüftete inzwischen ein übers andere Mal seine Mütze und antwortete\nmit einem lauten: »In Ewigkeit, Amen!« auf die Grüße der Leute, die\nihr Wagen überholte. Sie fuhren im leichten Trab, Jascho wich den\nWagen, Menschen und dem des Wegs getriebenen Vieh mit Bravour aus,\nbis er den Wald erreichte, wo es schon freier wurde und der Weg\nbreiter war.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Gleich am Waldrand holten sie die Dominikbäuerin ein; sie fuhr\nmit Jagna und Schymek, und eine an den Hörnern befestigte Kuh ging\nhinter dem Wagen, aus dem ein paar Gänseriche ihre weißen Hälse\nhervorstreckten und wie die Vipern zischten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Man bot einander Gott zum Gruß, und Boryna, der sich beim\nÜberholen ganz herausbeugte, rief:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ihr kommt zu spät!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wir kommen zurecht!« rief ihm Jagna lachend zurück.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Man fuhr vorbei, doch der Organistensohn drehte sich mehrmals\nnach ihr um, und fragte schließlich:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»War die der Dominikbäuerin ihre Jagna?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das war sie, jaja,« antwortete Boryna, sich aus der Ferne noch\nnach ihr umschauend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hab' sie gar nicht wiedererkannt, zwei Jahre sind es schon gut,\ndaß ich sie nicht gesehen habe.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Die ist noch grün, damals hat sie grad' das Vieh gehütet. Ist\nnur so aufgegangen, wie eine Färse im Klee,« und er bog sich weit\nüber den Wagenrand, um nach ihr hinzusehen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Sie ist sehr schön,« warf Junge der hin.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page153",
      "title": "lac/gary"
    }
  }), _vm._v(" »Wie alle\nMädel,« sagte die Organistin verächtlich.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Jawohl, die ist glatt, 'ne wohlgeratene Dirn'; keine Woche ist,\ndaß nicht jemand zu ihr mit Schnaps schickt.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»'ne wählerische is sie! Die Alte denkt, daß wenigstens ein\nVerwalter ihretwegen angefahren kommt, und jagt die Burschen zur\nTüre 'raus ...,« zischelte sie bissig.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Es könnte sie auch einer nehmen, der selbst 'ne ganze Hufe hat\n... denn so viel ist die wert ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Dann bleibt nichts anderes über, als daß ihr die Brautbitter\nschickt, Matheus, da ihr sie doch so lobt!« fing sie an zu lachen.\nBoryna sagte kein Wort mehr.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Sieh da, so 'n Stadtfetzen, hohe Persönlichkeit, die den\nBauernhühnern unter den Schwanz guckt, ob sie nicht für sie Eier\nlegen und den Menschen in die Hand, ob nichts für sie abfällt; will\nsich so eine lustig machen über ansässige Hofbauern! Wag' du dich\nan die Jagusch heran!« dachte er, stark beleidigt, und sah immerzu\nvor sich hin auf den Wagen der Dominikbäuerin aus dem die roten\nSchürzen leuchteten und der immer weiter zurückblieb, denn Jascho\nfuhr energisch mit der Peitsche zwischen die Pferde, daß sie von\nder Stelle aus wegstoben und die Räder tiefe Rillen in den Schmutz\ngruben.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Vergeblich fing die Organistin wieder an, über dies und jenes zu\nreden, er nickte nur mit dem Kopf und brummelte etwas vor sich hin;\ner hatte sich dermaßen in sich verbissen, daß er nicht mal mit\neinem einzigen Wort antworten wollte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und kaum waren sie auf dem holprigen Straßenpflaster des\nStädtchens, stieg er auch schon von der Britschka ab und bedankte\nsich für die Fahrt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gegen Abend kehren wir heim, da setzt euch wieder zu uns, wenn\nihr wollt.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gott bezahl's, meine eigenen Pferde sind ja da. Sonst würden\ndie Leute sagen, ich tät' mich zum Blasebalgtreten verdingen, oder\nals Organistengehilfe ... und ich kann "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page154",
      "title": "lac/gary"
    }
  }), _vm._v(" nicht einen einzigen Ton\n'rauskriegen und zum Lichterausblasen bin ich auch nicht angelernt\n...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie bogen in eine Nebengasse ab, und er zwängte sich langsam\ndurch die Hauptstraße nach dem Marktplatz hin vorwärts. Der\nJahrmarkt konnte sich sehen lassen, die Menschen stauten sich zu\neinem dichten Gewirr, obgleich es noch ziemlich früh war; alle\nStraßen, Plätze, Winkel und Höfe waren mit Menschen, Wagen und\nvielerlei Waren vollgepfercht/es war wie ein großes Wasser, zu dem\nnoch ohne Unterlaß aus allen Seiten neue Menschenstrome stießen;\nsie drängten sich, wallten und fluteten durch die engen Gassen, so\ndaß die Häuser zu zittern schienen und ergossen sich über den\ngroßen Klosterplatz. Der Schmutz, der auf den Wegen noch nicht\nallzu arg war, ging hier, wo ihn tausend Füße zerstampften und zu\nBrei zertraten, schon bis über die Knöchel und spritzte unter den\nRädern nach allen Seiten auf.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Das Stimmengewirr war beträchtlich, doch steigerte es sich mit\njedem Augenblick; es brauste wie ein Wald, es wogte wie ein Meer,\nes schlug gegen die Wände der Häuser und wälzte sich von einem Ende\nzum andern/so daß nur zuweilen Kuhgebrüll, Leierkastenklänge vom\nKarussell, weinerliche Lamentationen der Bettler oder die scharfen\ndurchdringenden Pfeifen der Korbmacher dazwischen hörbar\nwurden.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Der Jahrmarkt war in der vollen Bedeutung des Wortes groß, es\nhatte sich so viel Volk zusammengedrängt, daß es nicht leicht\nwurde, durchzukommen, und als Boryna aus dem Marktplatz vor dem\nKloster ankam, da mußte er sich mit Gewalt durchzwangen/eine solche\nMenschenwand stand um die Verkaufsbuden herum.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Es waren deren so viele, so furchtbar viele, daß man es gar\nnicht zählen noch fassen konnte, wer wäre damit auch fertig\ngeworden ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Zuerst die hohen, leinwandbespannten Buden, die an der "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page155",
      "title": "lac/gary"
    }
  }), _vm._v(" Klostermauer entlang\nin zwei Reihen standen, ganz mit Weiberkram vollgestopft/mit\nLeinwandstücken und Tüchern, die auf Stangen hingen und rot wie\nMohnblumen waren, daß es in den Augen flimmerte, oder auch ganz\ngelb aussahen, oder rübenrot ... wer hatte sich das alles merken\nsollen! Und es wimmelte von Mädchen und Frauen davor, so daß man\nnicht einmal einen Stock dazwischen stecken konnte/die einen\nfeilschten und wählten aus, und andere standen da, um nur zuzusehen\nund die Augen an den Herrlichkeiten zu weiden.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und weiterhin zogen sich wieder Krambuden, die vor\nPerlenschnüren, Spiegelchen, Goldtand, Bändern, Halskrausen und von\ngrünen, goldenen und verschiedenfarbigen Blümelein, von glitzernden\nHauben und Gott weiß was mehr flimmerten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Irgendwoanders wurden Heiligenbilder verkauft in goldgleißenden\nRahmen und hinter Glas, und obgleich sie an die Wand gelehnt\nstanden oder selbst am Boden lagen, kam von ihnen ein solcher\nGlanz, daß manch einer nach der Mütze langte und sich\nbekreuzigte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Boryna kaufte ein seidenes Kopftuch für Fine, das er ihr noch im\nFrühjahr für das Viehhüten versprochen hatte. Er schob es unter den\nBrustlatz und begann sich nach dem hinter dem Kloster gelegenen\nSchweinemarkt durchzudrängen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Vor einer Anzahl Häuser hatten die Hutmacher breite Leitern\nhingehängt, die von oben bis unten mit Mützen behangen waren.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Anderwärts hatten Schuster eine ganze Straße aus hohen\nHolzböcken gebildet, an denen ganze Stiefelreihen, an den Ösen\naufgehakt waren. Es waren da gewöhnliche gelbe Naturlederstiefel,\nzum Schmieren mit zerlassenem Talg, gegen die Nässe, und solche die\nzum Glanzwichsen zurechtgemacht waren, und Wadenstiefel für die\nFrauen mit roten Schnürlitzen und hohen Absätzen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Weiter unten kamen die Sattler, mit ihren Kummeten auf "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page156",
      "title": "lac/gary"
    }
  }), _vm._v(" eingerammten\nPflöcken und mit ausgebreitetem Pferdegeschirr.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und dahinter noch die Seiler und die Netzknüpfer.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und die, die mit Sieben durchs Land fahren.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und die, die mit Grütze von Jahrmarkt zu Jahrmarkt ziehen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und Rademacher und Gerber.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Anderwärts hatten Schneider und Kürschner ihre Ware zur Schau\ngestellt; sie strömte einen solchen Geruch aus, daß es einem in der\nNase zwickte, aber sie hatte einen guten Zuspruch, denn es ging ja\ndem Winter zu.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Es waren auch ganze Reihen von Tischen aufgestellt mit\nLeinwanddächlein darüber; da lagen Bündel roter taudicker Würste,\nWälle gelben Flomens; geräucherte Schweinsrippen, Speckschwarten\nund Schinken türmten sich zu Haufen, und daneben hingen auf Haken\nganze ausgeweidete Schweine, von denen das Blut noch tropfte, so\ndaß es nötig war, die heranschleichenden Hunde zu verscheuchen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Neben den Schlächtern hatten sich, wie leibhaftige Brüder, die\nBäcker niedergelassen; auf dick ausgebreitetem Stroh, auf Wagen,\nTischen, und in Körben wo es nur anging lagen Berge von radgroßen\nBrotlaiben, gelben Butterkuchen, Semmeln, Brezeln ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Wer hätte wohl all die Buden behalten und sich merken können,\nund obendrein noch das, was darin verkauft wurde? ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Es waren auch Buden mit Spielsachen da und Lebkuchenbuden, wo\nvielerlei Tiergestalten aus Teig geformt waren, und Herzen und\nSoldaten und solche Wunder, daß der erste beste sich da gar nicht\nauskennen konnte; es waren Buden mit Kalendern und frommen Büchern\nda, wo Geschichten von Räubern und grausamen Magellonen verkauft\nwurden, und Fibeln dazu. Es gab Buden mit Pfeifen, Harmonikas,\nTonhähnen und anderen musikalischen Dingen/ auf denen das\nrothaarige Judenvolk spielte, um Lust zu "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page157",
      "title": "lac/gary"
    }
  }), _vm._v(" machen, und wo ein solches\nGekreisch herrschte, daß es kaum zum Aushalten war/hier pfiff eine\nWasserpfeife, dort tutete eine Trompete, anderswo entlockte man\neinigen Flöten bunte Weisen, Geigen juchzten und Trommeln stöhnten\nund meckerten dazwischen/der Kopf platzte einem schier vor all dem\nLärm.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Mitten auf dem Marktplatz aber, rings um die Bäume, machten sich\ndie Küfer und Klempner breit, und die Töpfer hatten so viele\nSchüsseln und Töpfe aufgestellt, daß man kaum durchgehen konnte,\ndahinter hatten die Tischler ihr Lager; Betten und gemalte Laden,\nSchränke, Borte und Tische spielten in allen Farben, daß man mit\nden Augen blinzeln mußte ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und überall auf den Wagen, an den Rinnsteinen und Häuserwänden,\nwo nur irgendein Platz war, saßen verkaufende Weiber; die eine\nhatte Zwiebeln in Kränzen oder in Säcken; die andere\nselbstgesponnenes Leinen und Beiderwand; eine saß mit Eiern, Käsen,\nPilzen und verkaufte eiförmige Klumpen Butter, die mit\nLeinwandstücken umwickelt waren; und eine war mit Kartoffeln und\nGänsen da, stellte ein gerupftes Huhn, schön gekämmten Flachs,\nzaspeln Garn zur Schau, und jede saß bei ihrem Teil; sie besprachen\nsich würdevoll miteinander, wie es auf Jahrmärkten üblich ist, und\ntraf sich ein Käufer, so verkauften sie langsam, bedächtig, ohne\nHitzigkeit/wie es Bäuerinnen ziemt und nicht so wie die Juden, die\nschreien, sich einem anhängen und herumspringen, als wären sie\nnicht bei Verstand.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Ab und zu zwischen den Wagen und Krambuben sah man kleine\nblecherne Schornsteine qualmen/dort verkaufte man heißen Tee/und\nanderes Essen war auch da, geröstete Wurst, Kohl und Barschtsch mit\nKartoffeln.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und Bettler ohne Zahl waren aus allen Himmelsrichtungen\nzusammengekrochen; Blinde, Lahme, Stumme und auch solche, die weder\nArme noch Beine hatten, es wimmelte von ihnen, wie zu irgendeiner\nKirmeszeit; die einen spielten "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page158",
      "title": "Monne3/gary"
    }
  }), _vm._v(" auf der Geige fromme Lieder, die anderen\nsangen und klirrten mit ihren Geldnäpfen, um sich ein paar Groschen\noder eine andere Unterstützung zu ergattern; überall an den\nHäuserwänden entlang und unter den Wagen hervor, selbst mitten aus\ndem Dreck klang ihr flehentliches Betteln.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Das alles hatte sich Boryna schon besehen, manches erstaunt\nbetrachtet, hin und wieder mit Bekannten geredet, bis er sich\nschließlich zum Schweinemarkt hinterm Kloster durchgedrängt hatte.\nDer war auf einem großen, sandigen Platz, den vereinzelte Häuser\numsäumten. An der Klostermauer, über die sich mächtige, noch gelb\nbelaubte Eichen hervorreckten, drängten sich die Menschen reichlich\ndicht zwischen den Wagen, ganze Parzellen Schweine lagen da, die\nhier zum Verkauf zusammengetrieben waren.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Bald hatte er Anna und Fine herausgefunden, die dicht am Rand\nsaßen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Verkauft ihr was?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wie man's nehmen will, die Schlachter haben schon um die Sau\ngehandelt, aber sie geben nichts ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Sind die Schweine teuer?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Na Gott, teuer, die haben hier heuer so viel zusammengetrieben,\ndaß man nicht weiß, wer das alles kaufen soll.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Is wer aus Lipce da?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Da, da haben die Klembs ihre Ferkel, und der Dominik-Schymek\nsteht auch bei einem Eber.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Macht schnell, dann kriegt ihr auch 'was vom Jahrmarkt ab.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Es wird einem auch schon über, so zu sitzen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Was geben sie für die Sau?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Dreißig Papierer, weil sie nicht durchgemästet ist, dicke\nKnochen soll sie haben, aber kein Speck.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Die zigeunern nur 'rum, wo sie können ..., gut ihre vier Finger\nSpeck hat die Sau ...,« sagte er, nachdem er ihr den Rücken und die\nFlanken befühlt hatte. »Dem Eber fehlt schon was an den Seiten,\naber die Schinken sind "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page159",
      "title": "Monne3/gary"
    }
  }), _vm._v(" gut,« gab er zu, indem er das Tier vom nassen\nSand wegjagte, wo es sich bis zur Hälfte eingewühlt hatte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Für fünfunddreißig könnt ihr sie losschlagen, ich geh' nur noch\nnach Antek gucken, gleich bin ich wieder da. Ihr werdet wohl auch\nHunger haben? ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wir haben schon etwas Brot gegessen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Verkauft nur schön, ihr sollt auch Wurst kriegen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Väterchen, vergeßt aber nicht mein Tuch, was ihr mit im\nFrühjahr versprochen habt ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Boryna langte unter den Brustlatz, doch er hielt an, als ob ihm\netwas eingefallen wäre, und mit der Hand abwinkend sagte er im\nWeggehen:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich werd's dir kaufen, Fine, ich werd' schon ...« Er machte\nsich Beine, denn er hatte plötzlich Jagnas Gesicht zwischen den\nWagen auftauchen sehen, doch ehe er sie erreicht hatte, war sie\nspurlos von der Bildfläche verschwunden, als ob die Erde sie\nverschluckt hatte; er fing also an, nach Antek zu suchen; das war\nnicht gerade leicht, denn in der Gasse, die vom Schweinemarkt zum\nMarktplatz führte, standen Wagen an Wagen, und noch dazu in\nmehreren Reihen, so daß man nur mit großer Mühe und Vorsicht mitten\nhindurchfahren konnte, dennoch fand er ihn bald heraus. Antek saß\nauf den Säcken, holte mit der Peitsche nach den Judenhühnern aus,\ndie sich um die Kober scharten, aus denen die Pferde fraßen, und\nantwortete mundfaul auf die Frage der Käufer.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Sieben hab' ich gesagt, dabei bleibt's.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Sechs und halb geben mer, man kann nicht mehr, der Weizen ist\nbrandig.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wenn ich dir eins über die verdammte Schnauze lange, Krätzjude,\ndann wird sie dir auf der Stelle brandig werden, mein Weizen ist\nrein wie Gelb.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Kann sein, aber feucht is er ... Nach Maß könnte ich kaufen für\nsechs Rubel und fünf Silberlinge.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Nach Gewicht wirst du sie kaufen für sieben. Das sag' ich dir\nein für allemal!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page160",
      "title": "Monne3/gary"
    }
  }), _vm._v(" »Was\närgert sich der Bauer, werd' ich sie kaufen oder nicht kaufen, man\nkann doch handeln.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Kannst handeln, wenn dir dein Maul nicht zu schade ist.« Und er\nbeachtete schon die Juden nicht mehr, die die Säcke der Reihe nach\naufbanden und den Weizen besahen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Antek, ich geh' jetzt zum Schreiber und im Nu bin ich wieder da\n...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Was, wollt ihr den Gutshof verklagen?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und durch wen ist die Bunte verreckt?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Da wird euch viel 'bei 'rauskommen!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Mein Eigentum werd' ich niemand schenken.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ji ... den Heger müßte man im Forst gegen eine Fichte drücken\nund mit was Hartem durchbläuen, daß ihm die Rippen pfeifen, gleich\nwäre da Gerechtigkeit.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Der Heger, gewiß, der verdient's schon, aber der Gutshof auch,«\nsagte er hart.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gebt mir ein kleines Silberstück.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wozu denn das?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Einen Schnaps möcht' ich trinken und was essen ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hast du nicht dein eigen Geld? Aber nee, ständig soll Vater die\nHand offenhalten ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Antek drehte sich weg und fing ärgerlich an, vor sich\nhinzupfeifen, und der Alte knotete mißmutig und widerwillig einen\nSilberling aus und gab ihn her.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Mit seinem eigenen Blutschweiß muß man die alle nähren ...,«\ndachte er und drängte sich eilig nach der großen Eckschenke hin, wo\nschon viele Menschen waren, die ihre Mahlzeit einnahmen. In einem\nErkerstübchen, das auf den Hof ging, wohnte der Schreiber.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Er saß gerade vor dem Fenster am Tisch, mit einer Zigarre\nzwischen den Zähnen, hatte weder Rock noch Weste an und war\nungewaschen und zerzaust; irgendein Frauenzimmer schlief in der\nEcke auf einem Strohsack und war mit einem Paletot zugedeckt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Setzt euch, Herr Hofbesitzer!« Er warf einen dreckigen "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page161",
      "title": "lesdochmal/wedi"
    }
  }), _vm._v(" Anzug vom\nStuhl herunter und schob diesen Boryna hin, der sogleich den ganzen\nFall ausführlich vor ihm ausbreitete.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wie Amen im Gebet, tut ihr gewinnen. Das fehlte noch! Die Kuh\nist verreckt, der Junge liegt krank vor Schreck! Unsere Sache steht\ngut!« er rieb sich die Hände und suchte auf dem Tisch nach\nPapier.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Aber..., dem Jungen fehlt doch nichts.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Schadet nichts, ihm hätte was fehlen können. Geschlagen hat er\nihn doch...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das nicht, nur den Nachbarsjungen hat er geschlagen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Schade, das wäre noch besser gewesen. Aber das wird man schon\nirgendwie zusammenkriegen, wir werden Krankheit durch Verprügelung\nund eine verreckte Kuh haben. Laß den Gutshof zahlen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Versteht sich, um die Gerechtigkeit geht es hier allein.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gleich werden wir eine Klage schreiben. Franja, du Faulpelz,\nrühr' dich!« schrie er und gab der Liegenden einen solchen\nFußtritt, daß sie den strubbeligen Kopf emporrichtete. »Hol' man\nSchnaps und zu essen...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Keinen roten Heller hab' ich mehr, und du weißt, Gustav, daß\nsie nicht mehr borgen wollen...,« murmelte sie, erhob sich vom\nLager und fing an zu gähnen und sich zu recken; hoch war sie wie\nein Ofen und hatte ein großes, schwammiges, versoffenes Gesicht,\ndas voll blauer Flecke war, und dabei eine dünne Kinderstimme.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Der Schreiber arbeitete, daß die Feder krächzte, sog an der\nZigarre, pustete Boryna, der dem Schreiber zusah, Rauch ins\nGesicht, rieb sich seine mageren, sommersprossigen Hände und drehte\nsein blasses Gesicht voller Pusteln, nach Franja hin; seine\nVorderzähne waren schadhaft, seine Lippen bläulich, sein\nSchnurrbart groß und schwarz.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Er schrieb die Klage, nahm einen Rubel dafür, nahm einen zweiten\nfür die Gebühren und verabredete sich auf drei Rubel wegen der\nGerichtsvertretung, für den Fall, daß die Sache vor den grünen\nTisch käme.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page162",
      "title": "lac/wedi"
    }
  }), _vm._v(" Boryna\nerklärte sich zu allem eifrig bereit, denn er kombinierte, daß ihm\ndas Gut alles, und noch mit Überschuß, bezahlen würde.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gerechtigkeit muß sein, die Sache ist gewonnen!« sagte er im\nWeggehen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gewinnen wir nicht im Gemeindegericht, dann gehen wir vors\nLandgericht, und hilft das Landgericht nicht, dann gehen wir vor\ndas Oberlandesgericht, selbst bis zum Kassationshof, denen wollen\nwir nichts schenken.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das fehlte nun noch, mein Hab und Gut zu verschenken!« rief\nBoryna verbissen aus, »und wem dazu noch, dem Gut, das so viel\nWälder und Boden hat!« dachte er weiter, als er auf den Marktplatz\ntrat. Gleich darauf stieß er von ungefähr in der Hutmacherreihe auf\nJagna.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie stand da mit einer dunkelblauen Männermütze auf dem Kopf,\nund handelte noch um eine zweite.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Seht mal her, Matheus, der Rote sagt, sie ist gut, und gewiß\nbetrügt er...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Pik nobel, is wohl für Jendschych?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ja, für Jendschych, dem Schymek hab' ich schon eine\ngekauft.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wird sie denn nicht zu klein sein?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Grad so 'n Kopf wie ich hat er.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gäbst schon einen feinen Bursch' ab...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Vielleicht nicht?« rief sie keck und schob die Mütze ein wenig\naufs Ohr...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Auf der Stelle würden sie dich hier dingen...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ho-la... nur bin ich zu teuer für den Dienst.« Sie fing an zu\nlachen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Kommt drauf an, wem... mir würdest du nicht zu teuer\nsein...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und Feldarbeit, die tät' ich auch nicht...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Für dich würd' ich schon mitarbeiten, Jagusch, das tät' ich,«\nflüsterte er ihr etwas leiser zu und sah sie leidenschaftlich\n"), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page163",
      "title": "lac/wedi"
    }
  }), _vm._v(" an, daß das\nMädchen betroffen zurücktrat und, ohne weiterzuhandeln, für die\nMütze bezahlte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Habt ihr die Kuh verkauft?« fragte er nach einer kleinen Pause,\nnachdem er etwas zu sich gekommen war und von dieser Wohligkeit\naufatmete, die ihm, wie Branntwein, den Kopf benommen hatte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Sie haben sie für den Priester nach Jeschow gekauft, und die\nMutter ist mit den Organistenleuten eben fortgegangen, denn sie\nwill einen Knecht dingen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Dann könnten wir doch auf ein Gläschen Süßen irgendwo\neintreten!...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wie denn das?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Muß dir doch hier kalt geworden sein, Jagusch, kannst dich was\nwärmen...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wie sollt' ich denn... mit euch Schnaps trinken gehen!...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Na, denn sollen sie ihn hierher bringen, können ihn auch hier\ntrinken, Jagusch...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gott bezahl's, es war gut gemeint, ich muß aber nach der Mutter\nsehen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich werd' dir helfen, Jagusch...« meinte er mit gedämpfter\nStimme und ging voraus. Er arbeitete sich so mit den Ellenbogen\ndurch, daß Jagna ungehindert hinterdrein durchs Gedränge ging; doch\nals sie zwischen die Leinwandzelte kamen, verlangsamte sie den\nSchritt, blieb hier und da stehen und ihre Augen entbrannten im\nAnschauen all der Dinge, die hier ausgebreitet lagen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das sind dir aber mal Herrlichkeiten, du lieber Jesus!«\nmurmelte sie, vor den Bändern stehenbleibend, die oben befestigt\nwaren und im Winde wie ein greller Regenbogen flatterten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Welches meinst du, Jagusch, such' es dir aus,« sagte er nach\nkurzem Zögern, seinen Geiz überwindend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hale, dieses gelbe, geblümte, wird schon seinen Rubel kosten,\noder selbst zehn Silberlinge!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page164",
      "title": "lac/wedi"
    }
  }), _vm._v(" »Kehr dich\nnicht dran, nimm nur...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Aber Jagusch riß sich gewaltsam los und ging zum zweiten Stand\nweiter, nur Boryna blieb einen Augenblick zurück.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Hier waren wiederum Tücher und Stoffe für Mieder und Jacken.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Mein Jesus, so viel Herrlichkeiten!« flüsterte sie bezaubert\nvor sich hin und tauchte die zitternden Hände immer wieder in grüne\nAtlasgewebe und rote Samte, bis es ihr vor den Augen wirr wurde und\nihr das Herz vor Lust hüpfte. Und diese Kopftücher! Seidene,\nponceaufarbene mit grüngeblümter Borde, ganz goldige, wie die\nheilige Monstranz, und blaßblaue wie der Himmel nach dem Regen, und\nweiße, und die allerschönsten, die changierenden, die wie das\nWasser beim Sonnenuntergang gleißen, und leicht, wie aus\nSpinnweben! Nein nein, sie hielt es nicht mehr aus! sie fing an,\nsie anzuprobieren und sich im Spiegel zu besehen, den die Jüdin ihr\ngeschäftig vorhielt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Prächtig standen sie ihr, als ob sie die Morgenröte um ihr\nFlachshaar gewunden hätte, und ihre lichtblauen Augen flammten in\nsolcher Freude, daß sich ein veilchenblauer Schatten von ihnen auf\ndas erglühte Gesicht legte; sie lächelte sich zu, und so schön war\nsie und solche Jugend, solche Gesundheit strahlte sie aus, daß die\nMenschen nach ihr schauten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Eine vom Herrenhof in Tracht oder was?« tuschelte man.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie betrachtete sich lange und nahm mit einem schweren Seufzer\ndas Tuch ab, doch fing sie an, darum zu handeln, denn obgleich sie\ndas Geld nicht hatte, tat sie so, um sich noch länger daran freuen\nzu dürfen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie ernüchterte sich schnell, als die Handelsfrau fünf Rubel\nsagte, und selbst Boryna wurde eifrig, um sie wegzulocken.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie blieben noch vor den Perlschnüren stehen / von denen es eine\nsolche Menge gab, daß es schien, als ob die ganze "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page165",
      "title": "lac/gary"
    }
  }), _vm._v(" Bude mit kleinen Edelsteinen\nbenäht wäre; sie leuchteten und funkelten, daß es schwer war, die\nAugen abzuwenden /all die gelben Bernsteine, die wie aus duftendem\nHarz geformt waren, all die Korallenschnüre, wie aufgefädelte\nBlutstropfen, die Perlen weiß und groß wie Haselnüsse, und andere\naus Silber und Gold ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Jagusch probierte nicht nur eine an, sie wählte und wählte\nzwischen ihnen herum, und am schönsten bedünkte sie eine\nKorallenschnur; sie umwickelte viermal ihren weißen Hals damit und\ndrehte sich zum Alten hin.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Guckt mal her, na?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Die stehen dir schön, Jagusch! Korallen sind mir aber nichts\nNeues, denn in meiner Lade liegen noch zehn peitschenlange Schnüre\nvon der Seligen her, so groß wie Felderbsen sind die ...,« sagte er\nmit Bedacht, wie von ungefähr.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Was hab' ich davon, wenn sie nicht meine sind!« sie schleuderte\njäh die Perlen weg und ging finster und traurig weiter.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Jagusch, laß uns nur erst ein bißchen niedersetzen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Aber, 's ist doch Zeit, ich muß nach der Mutter sehen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Fürcht' dich nicht, sie fährt dir nicht weg.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie setzten sich auf eine herausragende Wagendeichsel\nnieder.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Fein großer Markt dieses Jahr,« sagte Boryna nach einem\nAugenblick, sich auf dem Marktplatz umschauend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Natürlich, nicht klein!« Sie blickte noch leidvoll zu den\nKrambuden hinüber und seufzte vor sich hin; aber die Traurigkeit\nfing schon an nachzulassen, denn sie sagte:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Die Gutsherrschaft, die hat es gut ... Ich hab' die Gnädige aus\nWola gesehen mit den Töchtern, die haben sich so viel gekauft, daß\nein Lakai hinter ihnen her die Sachen tragen mußte! Das geht so\njeden Jahrmarkt.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Is einer auf allen Märkten zu Gange/dem reicht's nicht\nlange.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page166",
      "title": "lac/DaoH"
    }
  }), _vm._v(" »Denen\nreicht's schon.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Solange die Juden was geben,« warf er knifflich ein, so daß\nJagusch sich nach ihm umdrehte und nicht wußte, was sie ihm darauf\nantworten sollte, der Alte aber fragte leise ohne sie\nanzusehen:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Waren sie mit Schnaps bei dir von Wojteks Michael, was Jagusch?\n...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Sie sind gekommen und sind gegangen! ... So'n Dösköpf, und denn\nnoch Brautbitter schicken,« lachte sie auf.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Boryna stand rasch auf, zog hinter dem Brustlatz ein Tuch hervor\nund noch irgend etwas in Papier Gewickeltes.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Halt mal das, Jagusch, denn ich muß nach Antek sehen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ist er denn auf dem Jahrmarkt?« Ihre Augen wurden lebhaft.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Beim Getreide ist er geblieben, dort in der Straße. Nimm dir\ndas, Jagusch, das ist für dich,« fügte er hinzu, als er sah, daß\nJagna erstaunt das Tuch beäugte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Mir gebt ihr das? ... wirklich für mich? Jesus, ist das fein!«\nschrie sie, das Band loswickelnd, gerade dasselbe, das ihr so\ngefallen hatte. »Hale, ihr spaßt wohl nur mit mir, wofür denn? So\nviel Geld ... und das Tuch ist reine Seide ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Nimm, Jagusch, nimm, für dich hab' ich's gekauft; und wenn\neiner von den Burschen dir zutrinken will, dann tu' keinen\nBescheid, was sollst du dich eilen ... und ich muß nun gehen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Meins is es, das ist Wahrheit?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Was sollt' ich dir da was vorzigeunern?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich kann es noch gar nicht glauben.« Sie breitete immer wieder\ndas Tuch und das Band auseinander.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Bleib' mit Gott, Jagusch.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gott soll's euch vergelten, Matheus.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Boryna ging; Jagna breitete noch einmal alles vor sich aus und\nbesah es, mit einem Male raffte sie es aber zusammen, um ihm\nnachzulaufen und es ihm wiederzugeben "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page167",
      "title": "lac/DaoH"
    }
  }), _vm._v(" ... wie sollte sie von einem\nFremden sich was schenken lassen, nicht mal verwandt oder mit der\nMutter verschwägert war er ... Aber der Alte war nicht mehr zu\nsehen. Sie ging langsam davon, die Mutter zu suchen und befühlte\nbehutsam und mit Behagen das hinter's Mieder geschobene Tuch. Sie\nwar so erfreut, daß ihr die weißen Zähne nur so beim Lachen\nblitzten und die Wangen glühten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Jaguscha! ... Um der Barmherzigkeit willen ... arme Waise ...\nliebe Menschen ... wahrhaftige Christen ... Ave Maria für die toten\nSeelchen ... Jaguscha! ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Jagna kam zu sich und blickte umher, wer sie wohl rufen konnte\nund von wannen die Stimme käme; bald wurde sie Agathe gewahr, die\nan der Klostermauer, auf einem Strohhäufchen saß, da der Schmutz an\ndieser Stelle bis über die Knöchel ging.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie blieb stehen, nach einer kleinen Gabe suchend, und Agathe,\nerfreut über die Begegnung mit einer aus dem Heimatsdorf, machte\nsich eifrig dran, sie auszufragen, wie es da wohl in Lipce ginge\n...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Seid ihr schon so weit mit dem Kartoffelausnehmen?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ganz und gar!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wißt ihr nicht, was es bei den Klembs gibt?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Haben euch auf den Bettel in die Welt gejagt, und ihr seid noch\nbegierig auf sie?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Weggejagt oder nicht weggejagt, selbst hab' ich mich\nfortgemacht, weil 's nötig war ... wieso denn auch, umsonst werden\nsie mir meine Ecke geben oder zu essen, wenn sie es selber nicht\ndick haben ... Und begierig bin ich auf sie, von wegen der\nVerwandtschaft ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und wie ist es mit euch?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wie es so gehen muß, von Kirche zu Kirche gehe ich, von Dorf zu\nDorf, von Jahrmarkt zu Jahrmarkt und bitt' mir bei guten Leuten\nhier und da ein Eckchen, einen Löffel Suppe aus, oder auch Geld.\nDie Menschen sind gut, lassen nicht den Armen Hungers sterben,\nnein. Wißt ihr "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page168",
      "title": "lesebaer/lac"
    }
  }), _vm._v(" vielleicht, sind die bei Klembs alle gesund?«\nfragte sie schüchtern.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Sie sind gesund, und ihr, seid ihr nicht krank?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ih ... wie man's nimmt, in der Brust zieht es mich immer, und\nwenn mich die Kälte ankommt, dann spuck' ich lebendiges Blut ...\nNicht lange mach' ich's schon, nicht mehr lange. Wenn man nur bis\nzum Frühjahr durchhält und ins Dorf heim kann, so ... da zwischen\nseinen Leuten sterben/darum bitt' ich das kleine Jesuskind, einzig\ndarum,« sie breitete die mit Rosenkränzen umwundenen Arme, hob das\nverweinte Gesicht und begann so inbrünstig zu beten, daß ihr die\nTränen aus den geröteten Augen quollen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Sprecht ein Gebet für Väterchen,« murmelte Jagna und steckte\nihr ein Geldstück zu.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das wird für die sein, die im Fegefeuer sind, für die Unsrigen\nbet' ich auch so schon immerzu und bitte zum lieben Gott für die\nLebendigen und die Toten. Jagusch, und haben sie nicht mit Schnaps\ngeschickt?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Sie sind schon gekommen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und keinen hat sie sich ausgesehen ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Keinen. Bleibt mit Gott, und im Frühjahr guckt zu uns 'rein,«\nsagte sie noch schnell und ging zur Mutter, die sie in der Ferne\nmit den Organistenleuten daherkommen sah.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Boryna jedoch kehrte langsam zu Antek zurück, zum ersten, weil's\nein großes Gedränge war, und zweitens, weil ihm Jagusch immerfort\nin seinen Gedanken stand, aber bevor er hinkam, traf er auf den\nSchmied.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie begrüßten sich und gingen schweigend nebeneinander her.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wollt ihr mit mir nu aber endlich mal zum Schluß kommen, häh?«\nfing der Schmied scharf an.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Womit zum Beispiel? Dasselbe hättest du mir auch in Lipce sagen\nkönnen.« Der Ärger überkam ihn.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page169",
      "title": "lesebaer/lac"
    }
  }), _vm._v(" »Die\nganzen vier Jahre wart' ich schon doch.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und den heutigen Tag mußtest du dir aussuchen! Dann warte noch\ndeine vierzig, bis ich wegsterbe.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Selbst die Leute raten mir schon, daß ich beim Gericht\npetitionier' ... aber ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Petitionier' du! Ich kann dir auch noch dazu sagen, wo man die\nKlagen schreibt und werd' dir für 'n Schreiber einen Rubel\ngeben.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Aber ich denke, daß wir im guten uns einigen werden ...,«\ndrehte der Schmied schlau bei.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das ist wahr, wenn's nicht mit Krieg/versucht man's mit\nFrieden.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das begreift ihr selbst nicht schlecht.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich brauch' da weder Krieg noch Frieden mit dir.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das sag' ich immer meiner Frau als erster, daß der Vater für\ndie Gerechtigkeit ist.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Jeder holt die Gerechtigkeit hinzu, der sie als Gevatterin\nbraucht/ich brauch' das nicht, denn ich weiß nichts von Schuld,«\nsagte er hart, so daß der Schmied klein wurde, da er ihm von dieser\nSeite nicht beikommen konnte, und als ob nichts geschehen wäre,\nsagte er in einem ruhigen und bittenden Ton:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich würde einen trinken, wollt ihr spendieren? ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gewiß. Warum denn nicht, wenn so 'n pikfeiner Schwiegersohn\nbittet, dann gibt man selbst 'ne ganze Quart aus,« höhnte er etwas,\nin die Eckschenke eintretend. Dort war auch schon Ambrosius da,\naber er trank nicht und saß mürrisch und trübsinnig in der\nEcke.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»In den Knochen reißt es mich, wir kriegen gewißlich schlechtes\nWetter,« klagte er.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie tranken ein- und zweimal, aber schwiegen sich an, denn sie\nhatten genug Wut aufeinander in den Eingeweiden.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wie auf einem Begräbnis trinkt ihr da herum!« ließ sich\nAmbrosius vernehmen, mit Recht giftig, daß sie ihn "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page170",
      "title": "lesebaer/DaoH"
    }
  }), _vm._v(" nicht mit aufgefordert\nhatten, denn er hatte seit früh noch so gut wie nichts im\nMagen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wie soll man da reden. Der Vater verkauft heute so viel, da muß\ner aufpassen, wem er das Geld auf Prozent gibt ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Matheus! Ich sag' es euch, Matheus, daß unser Herr Jesus\n...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ob Matheus oder nicht Matheus; nimm du dich für! So 'n\nHaderlump! Immer mal los mit der Brüderschaft, Schwein mit dem\nSchweinehirt,« er erboste heftig.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und der Schmied, der schon zwei Starke hinter sich hatte, wurde\ngroßspurig und sagte eindringlich:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Nun sagt mal das Wort, Vater/gebt ihr oder nicht?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Es bleibt dabei; ins Grab nehm' ich es nicht mit, und vorher\nlasse ich kein' einen Morgen ab. Auf den Altenteil zu euch geh' ich\nnicht ... noch sind mir die ein/zwei Jahre, die ich übrig hab',\nlieb.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Dann findet mich ab.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich hab's gesagt, hast du's nicht gehört?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Nach der dritten Frau sieht er sich um, was sind da die\nKinder,« knurrte Ambrosius.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»So wird's auch sein.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wenn's mir gefällt, heirat' ich. Willst du es mir\nverbieten?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Verbieten hin, verbieten her, aber ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wenn's mir gefällt, schick' ich gleich morgen mit Schnaps.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Schickt nur zu, ich habe nichts dawider. Gebt mir doch\nwenigstens das Kalb, das von der Bunten nachgeblieben ist, dann\nhelf' ich euch selbst. Ihr habt schon euren Verstand und werdet\nbegreifen, womit ihr am besten fahrt. Nicht ein- und nicht zweimal\nhab' ich der Meinen vorgestellt, daß euch nur die Frau fehlt, damit\nkein Ruin in die Wirtschaft kommt ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hast du das so gesagt, Michael? ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Die heilige Beichte soll ich nicht erleben, hab' ich das "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page171",
      "title": "lesebaer/DaoH"
    }
  }), _vm._v(" nicht gesagt.\nDem ganzen Dorf rat' ich doch, was jedem not tut, und soll nicht\nwissen, was ihr braucht!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Du lügst, du Halunke, daß es nur so raucht, kannst aber morgen\nkommen, das Kalb kannst du kriegen, denn wenn du bitten tust/dann\nlaß ich mit mir reden; und willst du mit mir rechten/kriegst du 'n\nzerbrochenen Stecken oder noch was Schlimmeres ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie tranken noch einen, den der Schmied schon spendierte; er\nhatte noch zur Gesellschaft Ambrosius zugeholt, der sich befriedigt\nzu ihnen heransetzte und solche possierlichen Erzählungen zum\nbesten gab, solche Witze machte, daß sie immer wieder in ein\nGelächter ausbrachen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie freuten sich nicht lange aneinander, denn jeder hatte es\neilig zu den Seinen und mußte noch verschiedene Angelegenheiten\nerledigen; so gingen sie in Frieden auseinander; aber der eine\nglaubte dem andern nicht einmal so viel, wie die Breite eines\nFingernagels.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie kannten sich gut, wie weißgescheckte Pferde, und\ndurchschauten einander wie Glas.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Nur noch Ambrosius blieb zurück und harrte der Gevattern und\nBekannten, ob ihm nicht jemand noch ein halbes Maß spendieren\nwurde, denn dem Hund ist auch 'ne Fliege gut, solange er keinen\nKnochen kriegt; das Trinken das paßte ihm schon, selbst aber wurd'\nes ihm schwer, sich eins zu spendieren, was kein Wunder war, denn\ner war doch nur ein Küster.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und der Jahrmarkt ging dem Ende zu.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Gerade zu Mittag leuchtete die Sonne auf, aber nur so viel, als\nob jemand mit einem Spiegel über die Welt geblinkt hätte, dann\nversteckte sie sich hinter Wolken; und schon gegen Abend\nverdüsterte sich der Tag; große Regenwolken senkten sich tief, daß\nsie fast auf den Dächern lagen, und ein feiner Regen stäubte, wie\ndurch ein dichtes Sieb. So fuhr man denn auch schneller\nauseinander/jeder eilte nach Hause, um noch vor Nacht und vor\nEinbruch des Unwetters unter Dach zu sein.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page172",
      "title": "lesebaer/DaoH"
    }
  }), _vm._v(" Auch\ndie Händler nahmen die Buden rascher auseinander und packten sie\nauf die Wagen, denn der Regen peitschte immer dichter und wurde\neisig.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Dunkelheit fiel schwer und naß.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Das Städtchen vereinsamte und verstummte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Nur die plärrenden Stimmen der Bettler hörte man hier und da an\nden Mauern, und aus den Schenken klang Geschrei und Gezänk der\nTrunkenen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Schon spät am Abend fuhren die Borynaleute aus dem Städtchen\nhinaus; sie hatten alles, was sie mit hatten, abgesetzt,\nverschiedenes eingekauft und den Jahrmarkt genossen, wie es sich\ngehört; Antek trieb die Pferde an und fuhr so scharf, daß im\nStraßenschmutz tiefe Furchen nachblieben; es war inzwischen tüchtig\nkalt geworden, und sie hatten alle nicht schlecht dem Glas\nzugesprochen. Der Alte, trotzdem er sonst geizig war und auf jeden\nGroschen erpicht, hatte sie heute dermaßen mit Speise und Getränk\nbewirtet und mit guten Worten traktiert, daß es verwunderlich\nwar.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Es wurde schon völlig Nacht, als sie zum Wald kamen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Dunkel war es, daß einer sich ruhig die Augen hatte ausstechen\nlassen können; die Regentropfen wurden immer dicker, und hier und\nda auf der Landstraße hörte man das Rollen der Wagen, das heisere\nSingen der Betrunkenen, und hin und wieder das Patschen langsamer\nSchritte durch den Schmutz.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Inmitten des Pappelwegs, über dem es dumpf sauste und wie vor\nKälte ächzte, ging Ambrosius, schon ganz besoffen, von einer Seite\nnach der anderen torkelnd, manchmal stolperte er gegen einen Baum\noder glitt in den Dreck aus; aber er erhob sich bald und sang\nimmerzu aus voller Kehle, wie das so seine Angewohnheit war.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Ein solches Unwetter und eine solche Dunkelheit kamen auf, daß\nman die Schwänze der Pferde nicht erkennen konnte, und die\nauftauchenden Lichter des Dorfes nur wie blinzelnde Wolfsaugen zu\nsehen waren.")]), _vm._v(" "), _c('ol', {
    staticClass: "calibre7"
  }, [_c('li', {
    staticClass: "calibre8"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0003#text3",
      "id": "foot3"
    }
  }, [_c('span', {
    staticClass: "pcalibre5 pcalibre4 footnote"
  }, [_c('span', {
    staticClass: "spaced"
  }, [_vm._v("Mit dem\nErntedank fahren:")]), _vm._v(" Da die Dorforganisten in Polen sehr kleine\nGehälter haben, so hat sich seit altersher die Sitte eingebürgert,\nmindestens zweimal im Jahre die Bewohner ihres Kirchspiels zu\nbesuchen, um freiwillige Gaben in Naturalien für sich einzusammeln.\nEine dieser Bittfahrten findet im Herbst statt, wenn die Ernte\neingefahren, aber noch nicht gedroschen ist. Sie heißt eigentlich\nGarbenfahrt.")])])]), _vm._v(" "), _c('li', {
    staticClass: "calibre8"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0003#text4",
      "id": "foot4"
    }
  }, [_c('span', {
    staticClass: "pcalibre5 pcalibre4 footnote"
  }, [_c('span', {
    staticClass: "spaced"
  }, [_vm._v("Volkszählung:")]), _vm._v("\nGleichbedeutend mit Osterzählung.")])])]), _vm._v(" "), _c('li', {
    staticClass: "calibre8"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0003#text5",
      "id": "foot5"
    }
  }, [_c('span', {
    staticClass: "pcalibre5 pcalibre4 footnote"
  }, [_c('span', {
    staticClass: "spaced"
  }, [_vm._v("Osterzählung:")]), _vm._v(" In der\nFastenzeit vor Ostern veranstalten die Organisten alljährlich eine\nZählung der katholischen Bevölkerung ihres Kirchspiels, bei welcher\nauch der alljährige Zuwachs an Seelen verzeichnet wird. Eine\nbesondere Rubrik wird über die im Beichtalter befindlichen geführt.\nVoraussichtlich ist diese alte Sitte dem kirchlichen Bedürfnis\neiner genauen Kontrolle entsprungen.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "pcalibre6 initial1"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page173",
      "title": "lesebaer/gary"
    }
  }), _vm._v(" Die Regenzeit war im\nvollen Gange. Schon seit dem Jahrmarktstag versank die Welt\nallmählich immer mehr in graue, trübe Regenglasten, so daß die\nUmrisse der Wälder und des Dorfes blaß geisterten, als wären sie\naus durchnäßten Gespinsten gewoben")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Es kamen die endlosen, kalten, durchdringenden Herbststürme.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Weiße, eisige Regenpeitschen schlugen auf den Boden ein und\ndurchnäßten ihn bis in die Tiefen, und jeder Baum, jeder Halm bebte\nim grenzenlosen Schmerz.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Unter den schweren, über der Erde zusammengeballten Wolken\ntauchten zuweilen aus den grünlichen Regengüssen Flächen\ngeschwärzter, durchweichter und plattgedrückter Felder auf,\nRinnsale schaumigen Wassers, das in den Furchen floß, blitzten\nhervor, oder Bäume, die einsam auf den Feldrainen wuchsen, hoben\nsich dunkel ab/wie vor Feuchtigkeit niedergedrückt und\naufgeschwollen schüttelten sie die letzten Fetzen der Blätter ab\nund rissen sich verzweifelt hin und her wie Hunde, die man an die\nKette gelegt hatte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die vereinsamten Wege zerflossen in morastige, faulende\nPfützen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Kurze, traurige, sonnenlose Tage schleppten sich schwer dahin\ngleich schmalen, von Verwesung zerfressenen Lichtstreifen, und\nNächte kamen, finster, dumpf und trostlos in ihrem unaufhörlichen,\neintönigen Glucksen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Eine grauenvolle Stille umklammerte die Erde.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Felder verstummten, die Dörfer wurden still, und taub wurden\ndie Wälder.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Siedelungen nahmen eine schwärzliche Düsterkeit an und\nschienen sich noch dichter an die Erde und an ihre Umzäunungen zu\nschmiegen und tiefer in die entlaubten Gärten zu sinken, die sich\nleise ächzend ineinander krallten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die grauen Dünste der Regen verschleierten die Welt, tranken die\nFarben aus, verlöschten die Lichter und ertränkten "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page174",
      "title": "lesebaer/gary"
    }
  }), _vm._v(" die Erde in Dunkelheiten,\nso daß alles wie ein Traumspuk erschien, und Traurigkeit sich von\nden durchfaulten Feldern, erstarrten Forsten und totem Ödland erhob\nund in schweren Nebeln wallte; sie blieb auf den abgeschiedenen\nKreuzwegen stehen unter Kreuzen, die ihre Arme verzweifelt\nausbreiteten, auf leeren Landstraßen, wo nackte Bäume vor Kälte\nbebten und in Qual schluchzten, sah mit leeren Augen in verlassene\nNester, in eingestürzte Hütten hinein, trieb sich auf den toten\nFriedhöfen zwischen vergessenen Grabhügeln, modrigen Kreuzen herum\nund floß durch die ganze Welt;/durch die nackten, beraubten,\ngeschändeten Felder, durch die versunkenen Dörfer und blickte in\ndie Wohnstätten, in die Stallungen und in die Gärten hinein/bis das\nVieh vor Angst brüllte, die Bäume sich mit dumpfem Gestöhn duckten\nund die Menschen wehmütig aufseufzten in der gräßlichen\nSehnsucht/in der unstillbaren Sehnsucht nach Sonne.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("— — — — —")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Der Regen sprühte ohn' Unterlaß, als ob jemand die Welt mit\nseinen Glassplitterchen verhüllte, und ganz Lipce tauchte unter ins\ndichte Nebelmeer der bösen Regenzeit. Nur die schwarzen Dächer und\ndunkle, vor Nässe triefende Steinmauern, ragten hier und da hervor,\nund darüber wanden sich die schmutzigen Rauchsträhnen und\nschleppten über die Gärten dahin.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Im Dorf war es still, nur hier und da war man in den Scheunen\nnoch beim Dreschen, aber vereinzelt nur, denn das ganze Dorf befand\nsich auf den Kohlfeldern.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Es war leer auf den schlammigen, aufgeweichten Wegen und leer\nauf den Zufahrtsstraßen und vor den Häusern, manchmal nur erschien\njemand im Nebel und verlor sich gleich darauf, so daß man nur das\nSchlurfen der Pantinen im Schmutz hörte; oder es schleppte sich\nlangsam ein mit Kohl vollgeladener Wagen von den Torffeldern her\nund trieb die Gänse auseinander, die hinter den Kohlblättern\nherwateten, welche von den Wagen herabgefallen waren.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page175",
      "title": "DaoH/gary"
    }
  }), _vm._v(" Der Weiher\nrüttelte an seinen engen Ufern und stieg immerzu, er überschwemmte\nvon der Borynaseite die niedriger gelegenen Teile des Weges, kam\nbis an die Zäune und spritzte Gischt an die Wände der Hütten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Das ganze Dorf war mit dem Schneiden und Einfahren des Kohls\nbeschäftigt; die ganzen Tennen, Dielen und Stuben waren voll davon,\nund bei manchen lagen die Haufen blauen Kohls selbst draußen unter\nder Dachtraufe.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Vor den Häusern rann der Regen über gewaltige Tonnen, die man in\ndie Nässe hinausgerollt hatte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Es herrschte große Eile überall, denn der Regen hörte fast gar\nnicht mehr auf, und die Wege wurden unfahrbar vor Schlick.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Auch bei der Dominikbäuerin schnitt man heute.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Schon am frühen Morgen war Jagna mit Schymek aufs Kohlfeld\nhinausgefahren, weil Jendschych daheim bleiben mußte, um das Dach\nzu flicken, sintemal es im Hause da und dort leckte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Es ging schon gegen Abend und die Dunkelheit schien sich bei\nkleinem einzustellen, so daß die Alte einmal ums andere vors Haus\ntrat und in die Nebel nach der Mühle zu spähte und hinaushorchte,\nob sie nicht schon kämen? ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Arbeit auf den Kohlfeldern, die tief hinter der Mühle auf\ndem Torfgrund lagen, war aber noch im vollen Gange.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Schwärzliche, nasse Nebel lagen auf den Wiesen, und nur da und\ndort blinkten breite Gräben voll silberweißen Wassers, und hoch\naufgeworfene Kohlbeete waren sichtbar und schimmerten bläulich,\nblaßgrün, oder sahen rostig aus, wie Streifen von Eisenblech. Hier\nund da hoben sich aus dem Nebel die roten Frauenröcke und Haufen\nabgeschnittener Kohlköpfe hervor.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("In der nebeldurchsetzten Ferne, am Fluß, der rauschend durch das\ndichte Buschwerk floß, das wie eine Wolkenwand blaute, zeichneten\nsich die Torfdiemen und die dastehenden Wagen ab, zu denen man den\nKohl in Leinwandtüchern "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page176",
      "title": "DaoH/gary"
    }
  }), _vm._v(" hinbrachte, denn infolge des durchweichten Bodens\nwar es unmöglich, an die Kohlfelder heranzufahren.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Einzelne schnitten schon den Rest und schickten sich an,\nheimzugehen; die Stimmen ließen sich immer lauter aus dem Nebel\nvernehmen und klangen von Beet zu Beet.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Jagna war soeben mit ihrem Beet fertig, sie war furchtbar müde,\nhungrig und bis auf die Haut durchnäßt, denn selbst ihre\nHolzpantinen versanken in die rotbraune Torferde, so daß sie sie\nabnehmen mußte, um das Wasser herauszuschütten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Schymek, rühr' dich doch schneller, ich fühl' meine Klumpen\nschon gar nicht mehr!« rief sie kläglich, und als sie sah, daß er\ndas große Bündel nicht aufladen konnte, riß sie es ihm ungeduldig\naus den Händen, warf es sich über die Schulter und ging damit zum\nWagen hin.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Bist doch schon so 'n großer Kerl und dabei schwach im Rücken\nwie 'ne Frau nach dem Wochenbett,« sagte sie verächtlich, den Kohl\nin den mit Stroh ausgelegten Korbwagen schüttend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Schymek brummte beschämt etwas vor sich hin, kratzte sein\nZottelhaar und spannte das Pferd vor.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Eil' dich, Schymek, die Nacht kommt!« trieb sie ihn an und trug\nimmer wieder Kohl herbei.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Nacht kam auch schon heran und die Dämmerung wurde dichter\nund tiefer, und der Regen steigerte sich, daß er auf die\ndurchweichte Erde und in die Gräben niedertroff, wie rieselndes\nKorn.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Werdet ihr heute fertig?« rief sie zu Borynas Fine hinüber, die\nmit Anna und Jakob nebenan auch beim Schneiden war.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wir kriegen es noch! Wird auch reichlich Zeit, nach Hause zu\ngehen bei dem Schweinewetter, klitschnaß bin ich. Fahrt ihr denn\nschon ab?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ja. In einem Nu is Nacht, ist ja schon so finster, daß man den\nWeg nicht auskennt. Morgen fährt man den Rest "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page177",
      "title": "MEsswein/gary"
    }
  }), _vm._v(" ein. Feinen Kohl habt ihr!«\nfügte sie hinzu und beugte sich zu ihnen hinüber, um auf die sich\nim Nebel abhebenden Kohlhaufen zu sehen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Eurer ist auch nicht schlecht, aber die Steckrüben habt ihr am\ngrößten ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Die Setzlinge, die waren auch vom neuen Samen, den sich\nHochwürden aus Warschau mitgebracht hat.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Jagna,« ließ sich wieder aus den Nebeln Fines Stimme vernehmen,\n»wißt ihr schon, daß morgen Josef sein Walek mit Schnaps nach\nMaruschka Potschiotek schickt ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»So'n Kiekindiewelt! Is die denn schon so weit! Mir deucht, daß\nsie noch Kühe gehütet hat im letzten Sommer! ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das Alter hat sie schon für 'n Mann, und denn noch all das\nLand, da haben es die Burschen hild.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Auch zu dir werden sie es hild haben, Fine, das werden sie\n...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wenn Papachen sich 'ne dritte nimmt!« schrie Gusche irgendwo\nvon einem anderen Beet.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Was euch ankommt, hat doch Mutter erst zum Frühjahr begraben,«\nwarf Anna mit beängstigter Stimme dazwischen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Was schadet das dem Mannsvolk. Jedes Mannsbild ist wie 'n\nSchwein; wenn es sich noch so vollgefressen hat, steckt es doch die\nSchnauze in einen neuen Trog. Ho, ho, die eine ist noch nicht so\nweit ... nicht mal richtig kalt, und dann wird sich gleich nach\neiner anderen umgesehen ... ein Hundevolk ist das ... Und wie hat\nes der Kohlmeis gemacht? Drei Wochen nach der Beerdigung der ersten\nhat er die zweite geheiratet.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das ist wahr, fünf kleine Kinder hat ihm aber auch die Selige\nnachgelassen ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ihr habt's gesagt! Aber nur 'n Dummer glaubt, daß es wegen der\nKinder ist ... für sich selbst hat er die geheiratet, weil es ihm\nalleine zu langweilig wurde unterm Federbett!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wir würden es Vater nicht erlauben, oho! ...« rief Fine\nenergisch.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page178",
      "title": "MEsswein/gary"
    }
  }), _vm._v(" »Bist\nnoch jung, darum bist du auch noch nicht klug ... Vaters Boden und\nVaters Wille, da gibt's nichts dran zu klimpern!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Die Kinder haben auch was dreinzureden und ihnen steht auch 'n\nRecht zu,« fing Anna wieder an.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Vom fremden Wagen heißt es heruntergehen, und wenn's auch ins\nWasser hinein ist,« brummte Gusche dumpf und verstummte, denn die\nempörte Fine fing an, nach Witek zu rufen, der sich irgendwo am\nFluß herumtrieb; Jagna aber mischte sich nicht in dieses Gespräch\nhinein, sie lächelte nur von Zeit zu Zeit, denn der Jahrmarkt kam\nihr in Erinnerung. Sie trug den Kohl auf den Wagen, und als sie\ndiesen gefüllt hatte, trieb Schymek an und lenkte nach der\nLandstraße hin.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Bleibt mit Gott,« warf sie den Nachbarinnen zu.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gott auf den Weg, wir wollen auch gleich ... Jagusch, kommst du\nnicht zu uns, Kohl schälen, was?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Sag' nur, wann's nötig ist, Fine, dann komm' ich ... ich komm'!\n...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und Sonntags spielen die Burschen zum Tanz auf bei Klembs, wißt\nihr es?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich weiß, Fine, ja, ich weiß ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wenn ihr Antek trefft, sagt ihm, daß er machen soll, wir warten\nauf ihn,« bat Anna.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gut, gut ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie fing an zu laufen, um den Wagen einzuholen, denn Schymek war\nschon ein Stück Wegs voraus, man hörte nur noch, wie er auf das\nPferd einschimpfte; der Wagen versank und schnitt bis über die\nAchsen in den aufgeweichten Torfboden ein/sie mußten beide an den\nschlechten, tieferen Stellen dem Pferd nachhelfen, um den Wagen aus\ndem Morast freizubekommen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie schwiegen miteinander, Schymek führte das Pferd, und achtete\ndarauf, nicht umzukippen, denn es waren überall viele Löcher, und\nJagna ging von der anderen Seite, "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page179",
      "title": "MEsswein/gary"
    }
  }), _vm._v(" stützte mit der Schulter den Wagen und\nsann nach, daß man sich zu diesem Kohlschälen bei Borynas fein\nmachen müßte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Dunkelheit senkte sich rasch; man konnte kaum noch das Pferd\nsehen; der Regen schien nachgelassen zu haben; es hing nur noch ein\nschwerer, nasser Nebel über der Erde, so daß es schwer war, zu\natmen, und in den Lüften rauschte dumpf der Wind und schlug gegen\ndie Bäume des Dammes, bei dem sie gerade anlangten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Auffahrt zum Damm war schwer, wegen der Steigung und Glätte;\ndas Pferd blieb stecken und hielt jede paar Schritte an, um\nauszuruhen, so daß sie kaum den Wagen halten konnten, damit er\nnicht ins Rollen kam.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Man hätte nicht soviel laden sollen für ein Pferd!« ließ sich\neine Stimme vom Damm herab vernehmen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Seid ihr das, Anton? ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ja, ich bin es.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Geht man schnell zu; Anna sieht schon nach euch aus ... Helft\nuns mal eben ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wart' 'n Augenblick, gleich komm ich 'runter und helf' nach. So\n'ne Dunkelheit, man sieht keine Hand vor den Augen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie kamen gleich auf den Damm hinauf, denn er hatte so mächtig\nden Wagen gestützt, daß das Pferd vom Fleck weg anzog und erst oben\nstehenblieb.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gott bezahl's; aber stark seid ihr, Herr Jesus noch mal!« sie\nhielt ihm die Hand hin.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie verstummten plötzlich, der Wagen setzte sich in Bewegung und\nsie gingen nebeneinander, ohne recht zu wissen, was sie sagen\nsollten, beide seltsam verlegen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wollt ihr umkehren?« flüsterte sie leise.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Nur bis zur Mühle bring' ich dich, Jagusch, weil da ein Loch\nist auf der Landstraße, das Wasser hat einen Schaden gemacht.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ist das aber düster, was?« rief sie aus.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Bist du bange, Jagusch?« flüsterte er, dichter herangehend.\n"), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page180",
      "title": "MEsswein/gary"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hale, was sollt' ich da bange sein ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie verstummten wieder und gingen nun Hüfte an Hüfte, Arm neben\nArm weiter.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wie euch die Augen leuchten, gerade wie beim Wolf ... es wird\neinem ganz sonderbar dabei ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Kommst du Sonntag zu Klembs, da ist Musik.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Als ob mir das Mutter erlaubt ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Komm doch, Jagusch, komm hin ...,« bat er mit leiser,\ngedämpfter Stimme.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wollt ihr denn das?« fragte sie weich, ihm in die Augen\nsehend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Herr Gott nochmal, für dich allein hab' ich doch den Geiger aus\nWola bestellt, und für dich den Klemb noch erst überredet, daß er\nbei sich aufspielen läßt, für dich doch, Jagusch ...« flüsterte er,\nund näherte heftig atmend sein Gesicht dem ihren, so daß sie etwas\nzurückwich und vor Erregung erbebte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Geht schon ... man wartet auf euch ... es wird uns noch einer\nsehen ... geht ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Tust du auch kommen? ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich komm' ... ich komm' ...« wiederholte sie, sich nach ihm\numsehend, aber er war schon im Nebel verschwunden, und man hörte\nihn nur noch durch den Schmutz waten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Ein plötzliches Frösteln ließ sie erschauern und eine jache Glut\ndurchflog sie von Herz zu Kopf, so daß sie wankte. Sie wußte nicht,\nwie ihr geschehen war./Die Augen brannten ihr, als ob heiße Asche\nunter ihre Lider gekommen wäre, sie war ganz atemlos und nicht\nimstande, das leidenschaftlich pochende Herz zu beruhigen; ohne es\nzu wissen breitete sie die Arme aus, wie zur Umarmung, alles\nspannte sich in ihr, denn es faßten sie solche wilden Schauer, daß\nsie hätte schreien mögen ... Sie holte laufend den Wagen ein, faßte\neine der Rungen, und obgleich es nicht nötig war, schob sie so\nmächtig nach, daß der Wagen knarrte und wankte und Kohlköpfe in den\nSchmutz kollerten ... vor ihren "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page181",
      "title": "MEsswein/gary"
    }
  }), _vm._v(" Augen stand immerzu sein Gesicht mit dem\nfunkelnden, begehrlichen ... brennenden Blick ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ein Ungetüm von Mensch ... es gibt wohl keinen zweiten solchen\nin der Welt ...,« dachte sie wirr.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Das Rattern der Mühle, an der sie vorbeifuhren, brachte sie zur\nBesinnung, und das Rauschen des Wassers, das unter dem geöffneten\nStauwerk auf die Räder floß, denn der Wasserzudrang war gewaltig,\nernüchterte sie. Der Fluß stürzte sich mit dumpfem Gebrüll in die\nTiefe, und zu weißem Gischt zerstoben wirbelte das Wasser und war\nschimmernd auf dem Strom zu sehen, der das Uferbett weit\nüberschwemmt hatte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Das Haus des Müllers, das gleich am Wege stand, war schon\nerleuchtet, und man sah durch die mit Gardinen verhängten Scheiben\neine Lampe auf dem Tisch stehen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Die haben eine Lampe, wie bei Hochwürden oder auf einem\nHerrenhof ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Sind sie etwa keine reichen Leute? ... Er hat doch mehr Grund\nund Boden wie selbst Boryna, und Geld leiht er auf Perzente, und\nbeim Mahlen tut er auch betrügen, das ist so,« meinte Schymek.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wie die Gutsherrn leben sie ... denen ist es gut sein... Gehen\nin ihren Zimmern spazieren ... liegen auf den Kanapees herum...\nsitzen in der Wärme ... essen süß, und die Leute lassen sie für\nsich arbeiten ...,« dachte sie neidlos, ohne auf Schymek zu hören,\nder, so sehr er auch brummig war, kein Ende finden konnte, wenn er\nins Reden kam.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Schließlich langten sie nach vieler Mühsal vor ihrem Hause\nan.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("In der Stube war es hell und warm, ein Feuer flackerte lustig\nauf dem Herd. Jendschych schälte Kartoffeln und die Alte setzte das\nEssen zum Abend auf.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Ein alter, weißhaariger Mann wärmte sich vor der\nFeuerstelle.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Habt ihr's fertiggekriegt, Jagusch?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page182",
      "title": "gary/DaoH"
    }
  }), _vm._v(" »Das\nschon, nur daß da noch ein wenig auf dem Beet nach ist, vielleicht\nan die drei Leinentücher voll.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie ging in die Kammer, um sich umzuziehen, bald darauf\nwirtschaftete sie emsig in der Stube umher, und bereitete das\nEssen, ab und zu nach dem Alten neugierig hinüberäugend, der im\ntiefen Schweigen dasaß, ins Feuer starrte, die Perlen des\nRosenkranzes durch die Finger schob und die Lippen bewegte. Und als\nsie sich zum Abendessen setzten, legte die Alte einen Löffel für\nihn hin und lud ihn ein.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Bleibt mit Gott ... ich komme noch bei euch einsehen, denn\nvielleicht bleibe ich für länger in Lipce ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Er kniete inmitten der Stube nieder, verneigte sich vor den\nHeiligenbildern, machte das Zeichen des Kreuzes und schritt\nhinaus.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wer ist das?« fragte Jagna verwundert.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ein gesegneter Wanderer, er kommt vom heiligen Grab ... ich\nkenn' ihn schon lange, denn er war hier schon eher und brachte\nverschiedene heilige Sachen mit ... An die drei Jahre können es\nschon her sein ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie endigte ihren Satz nicht mehr, denn Ambrosius trat herein,\ngab Gott zum Gruß und setzte sich vor den Herd.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»So 'ne Kälte, und was für ein Sauwetter, mein Holzfuß ist mir\nganz steif geworden.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Was habt ihr denn bei solcher Nacht und dem Schmutz auch noch\nherumzulaufen ... da tätet ihr besser, in euren vier Wänden zu\nsitzen und Gebete zu sprechen ...,« brummte die Dominikbäuerin.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Die Zeit ist mir lang geworden so allein, da wollt' ich mal\nnach den Mädchen sehen, du bist die erste, Jagusch ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Sucht euch ein Totengerippe, als erste ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Die Mamsell treibt sich jetzt mit jüngeren herum, mich läßt sie\nganz beiseite liegen! ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wie denn das? ...,« begann die Dominikbäuerin im fragenden\nTon.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page183",
      "title": "gary/DaoH"
    }
  }), _vm._v(" »Die reine\nWahrheit sag' ich. Hochwürden hat den Leib Christi nach dem Bartek,\ndem hinterm Weiher, getragen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hör' einer bloß ... auf dem Jahrmarkt hab' ich ihn doch noch\nmobil gesehen ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das liebe Schwiegersöhnchen hat ihn so mit dem Knüppel\nzugerichtet, daß er ihm die Eingeweide um und um geschlagen\nhat.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Nanu, was war denn da, wann denn?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Um was denn anders, als um Grund und Boden. Schon ein halbes\nJahr zanken sie herum, und heute mittag haben sie abgerechnet.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Daß es keine Gottesstrafe für diese Totschläger gibt,« ließ\nsich Jagna vernehmen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Die kommt, Jagna, hab' keine Angst, die kommt noch,« sagte die\nAlte hart und heftete die Augen auf die Heiligenbilder.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und wer schon gestorben ist, der kann nicht wieder aufstehen,«\nließ Ambrosius kaum merklich fallen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Setzt euch an die Schüssel und nehmt, was da ist.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Dagegen hab' ich nichts, nein. Mit einem Schüsselchen werd' ich\nschon fertig, aber groß muß sie sein,« neckte er.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ihr habt nur immer Späße und Spielereien im Kopf.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das ist auch mein Ganzes, was soll ich mit den Sorgen,\nhäh?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie setzten sich an die Bank, auf der die Schüsseln standen, und\naßen langsam und schweigend; Jendschych paßte auf, um zuzulegen und\nzuzugießen, nur Ambrosius sagte von Zeit zu Zeit ein kurzweiliges\nWort und lachte selbst am meisten dazu, denn die Jungen, obgleich\nsie Lust hatten zu lachen, trauten sich nicht, wegen drohenden\nBlicke der Mutter.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ist Hochwürden zu Hause?« fragte sie gegen Ende.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wo denn sonst bei solchem Schmutz, wie 'n Jude sitzt er bei den\nBüchern.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ein Kluger ist sich der, ein ganz Kluger ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page184",
      "title": "gary/DaoH"
    }
  }), _vm._v(" »Und gut,\ndaß man keinen besseren finden kann ...« fügte Jagna hinzu.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Versteht sich ... gewiß ... auf den Bauch spuckt er sich nicht,\noder einem anderen in den Bart, und was ihm einer gibt, das nimmt\ner ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ihr solltet lieber nicht das erste beste Zeug reden.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie standen vom Abendbrot auf. Jagna setzte sich mit der Alten\nam Herd zu den Wocken und die Söhne machten sich, wie gewöhnlich,\nan das Aufräumen und Aufwaschen des Geschirrs und an die andere\nHausarbeit. Das war schon immer so bei der Dominikbäuerin, daß sie\nihre Söhne mit eiserner Hand hielt und sie zu Mägden abrichtete,\ndamit Jagusch ja nicht ihre Händchen beschmutze.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Ambrosius zündete die Pfeife an und paffte in den Kamin oder\nrückte die glühenden Scheite zurecht und warf neue Zweige hinzu,\ndabei blickte er hin und wieder die Frauen an und schien etwas\nabzuwägen und zu bedenken.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich höre, ihr habt die Brautbitter gehabt?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Die ersten sind es nicht.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Was Wunder, die ist ja wie gemalt, die Jagna. Hochwürden hat\ngesagt, die in der Stadt kommen der nicht gleich.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Jagna wurde rot vor Vergnügen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das hat er gesagt, der liebe Gott lasse ihn bei Gesundheit\nbleiben. Ich wollte schon lange 'ne Frühmesse lesen lassen, lange\nschon, morgen früh gleich trag' ich es ihm hin.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Da würd' noch einer mit Schnaps zu euch schicken, er möcht'\nschon, aber er hat es noch etwas mit der Angst ...,« leitete er\nbehutsam ein.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ein Bauernsohn? ...« fragte die Alte, die auf dem Boden\nsurrende Spindel aufwickelnd.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ein Hofbauer, im ganzen Dorf angesehen, ein Erbangesessener ...\naber ein Witwer ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Denk' nicht dran, fremde Kinder zu wiegen ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Sind schon großgezogen, da brauchst keine Angst zu haben,\nJagusch.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page185",
      "title": "gary/DaoH"
    }
  }), _vm._v(" »Was soll\nsie mit 'm Alten ... sie kann noch warten, wenn sie Sinn auf einen\njüngeren hat.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Junge gibt's genug, die werden ihr nicht mangeln! Kerzengerade\nBurschen, rauchen Zigaretten, tanzen in der Schenke, trinken\nSchnaps und gucken nur hinter den Mädeln drein, welche ihre paar\nMorgen hat und etwas bar Geld, damit sie was zum Amesieren haben\n... Das sind mir dann schöne Hofbauern, schlafen bis Mittag, und\nnachmittags da wird Mist mit der Schubkarre gefahren und das Feld\nmit den Hacken gepflügt ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Einem solchen geb' ich die Jagna nicht, daß sie 'n Schandleben\nkriegt.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Nicht umsonst sagt man, daß ihr die Klügste im Dorf seid\n...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Aber mit einem Alten zusammen, das ist für eine Junge auch\nkeine Freude ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Für die Freude sind doch Junge genug da.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Alt seid ihr wie die Welt, und noch so viel buntes Zeug im\nKopf,« sagte sie streng.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ii ... wie man so redet, damit die Zunge nicht vermulscht.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie blieben eine Weile stumm.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ein Alter wird sie schon zu ehren wissen, und braucht nicht\nhappig sein auf fremdes Geld,« fing Ambrosius wieder an.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Nein, nein, nur Gotteslästerung kommt davon.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Er könnte eine Schenkung vor Gericht machen,« sagte er\nbedeutungsvoll, die Pfeife auf dem Herd ausklopfend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Jagna hat genug Eigenes,« antwortete sie nach einer Weile,\nschon schwankend und unsicher.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Der würde mehr geben als nehmen, viel mehr ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ihr habt's gesagt!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Was ich natürlich nicht aus dem Wind gegriffen habe und nicht\naus meinem Kopf, nicht von mir aus komme ich damit ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page186",
      "title": "gary/DaoH"
    }
  }), _vm._v(" Sie\nschwiegen wieder. Die Alte fuhr lange glättend mit der Hand über\ndie zausige Kunkel, benetzte sodann den Finger und fing an, die\nFlachsfasern mit der Linken herauszuzupfen und mit der Rechten ließ\nsie die Spindel kreisen, so daß sie sich wie ein Brummkreisel mit\nGesumm auf dem Boden drehte und surrte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wie ist's, soll er denn schicken?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Welcher?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wißt ihr's denn nicht? Der da!« er zeigte durchs Fenster auf\ndie kaum über den Weiher blinzelnden Lichter vom Borynahof.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Erwachsene Kinder, werden kein gutes Wort geben und haben\nRechte auf ihr Teil ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Was sein ist, kann er aber verschreiben ... wie wär's denn? ...\nEin guter Mensch und nicht der erste beste Hofbauer, und fromm und\nnoch rüstig, ich hab' selbst gesehen, wie er sich 'n ganzen\npoln'schen Scheffel Roggen auf den Buckel geladen hat. Der Jagna\nwürde da nichts abgehen, der würd' sie sich schon reineweg mit\nVogelmilch aufziehen ... und da sich euer Jendschych im Kommenden\nbeim Militär melden muß ... der Boryna kennt sich aus mit den\nBeamten, er weiß, an wen er sich zu halten hat, der könnt' euch\nschon helfen ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wie scheint dir das, Jagusch? ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Mir ist es eins, befehlt ihr, dann tu' ich ... das ist euer\nKopf, nicht meiner ...,« sprach sie leise, stützte die Stirne auf\ndie Kunkel und starrte gedankenlos ins Feuer, auf das lustige\nKnistern der brennenden Zweige horchend. Dieser oder ein anderer,\ndas war ihr ganz egal/ihr schauerte nur leicht, wenn sie an Antek\ndachte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wie ist's?« fragte Ambrosius, sich von der Bank erhebend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Sie sollen schicken ... Versprechung ist noch keine Heirat\n...,« antwortete sie langsam.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Ambrosius verabschiedete sich und ging geradeswegs zu\nBoryna.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page187",
      "title": "gary/DaoH"
    }
  }), _vm._v(" Jagna saß\nimmerzu unbeweglich und schweigend da.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Jagusch ... Töchterchen ... was denn? ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Nichts ... alles ist mir gleich ... wenn ihr wollt, nehm' ich\nden Boryna ... und denkt ihr nicht, dann bleib' ich bei euch ...\ngeht es mir denn hier vielleicht schlecht? ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Alte spann weiter und redete leise.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das Beste will ich für dich, das Beste ... Gewiß, er ist alt,\naber noch rüstig, und gutherzig auch, nicht so wie die anderen\nMannsleute, der wird dich in Ehren halten ... Feine Dame wirst du\nbei ihm spielen können, die Hofbäuerin wirst du sein ... Und wenn\ner eine Verschreibung macht, so werd' ich ihn schon so richten, daß\ndas Feld neben unserem kommt, neben dem Juden seinem am Hügel ...\nund wenn er so zum Beispiel sechs Morgen verschreiben würde ...\nHörst du zu? an die sechs Morgen! Und irgendein Mannsbild mußt du\nschon heiraten ... das mußt du ... was sollen sie über dich\nherziehen und dich auf den Zungen im Dorf herumtragen ... Ein\nSchwein könnte man schlachten... vielleicht auch nicht ... oder\nvielleicht ...,« sie verstummte und begann sich den Rest im Kopf\nzurechtzulegen, denn Jagusch war, als ob sie ihre Worte nicht\ngehört hätte, sie spann geistesabwesend weiter, als ob sie ihr\neigenes Los nichts anginge, so wenig dachte sie über diese Heirat\nnach.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und hatte sie es vielleicht schlecht bei der Mutter? Sie tat was\nsie wollte, kein Mensch mischte sich ein. Was ging sie Grund und\nBoden an, die Verschreibungen und der Besitz/ so gut wie gar\nnichts, so gut wie der Zukünftige? Es waren nicht wenig Burschen,\ndie ihr nachliefen/wenn sie nur gewollt hätte, so wären alle in\nderselben Nacht noch zusammengelaufen ... und ihre Gedanken spannen\nsich träge, wie der Flachsfaden vom Wocken, und drehten sich immer\nin gleicher Weise um das Eine herum, daß sie, wenn Mutter wollte,\nden Boryna heiraten würde ... Gewiß, daß sie ihn besser mag als die\nanderen, denn er hatte ihr das Band und das Seidentuch gekauft ...\ngewiß ... aber "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page188",
      "title": "gary/DaoH"
    }
  }), _vm._v(" Antek hätte ihr dasselbe gekauft ... und die\nanderen vielleicht auch ... wenn sie nur Borynas Geld hätten ...\njeder ist gut ... und alle zusammen ... als ob sie einen Kopf dazu\nhätte, sich erst lange einen auszusuchen! Dazu war Mutter da, um zu\ntun, was nötig war ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und abermals starrte sie vor sich hin, sie sah aufs Fenster,\ndenn die schwarz angelaufenen, verwelkten Georginen, die der Wind\nschaukelte, guckten in die Scheiben, aber bald vergaß sie auch\ndiese, vergaß alles, vergaß auch sich selbst und verfiel in eine so\nheilige Gefühllosigkeit, wie die Mutter Erde während der toten\nHerbstnächte/denn wie die heilige Erde war Jagnas Seele/ganz wie\ndiese Erde; sie lag in Tiefen, die niemand erkennen konnte, in der\nWirrnis schlaftrunkener Träume/riesig und unbewußt, mächtig, aber\nohne Willen, ohne Wollen, ohne Wünsche, totenstarr und dennoch\nunsterblich, und wie diese Erde nahm sie jeder Wind, umhüllte sie,\nschaukelte sie und trug sie dahin, wo er wollte ... sie war wie die\nErde, die die warme Sonne zur Frühjahrszeit weckt, mit Leben\nbefruchtet, mit dem Feuerschauer des Verlangens, der Liebe\nerschüttert/und sie gebiert, weil sie muß; sie lebt, singt,\nherrscht, schafft und vernichtet, weil sie muß; sie ist, weil sie\nmuß ... denn wie die heilige Erde war Jagnas Seele/ganz wie diese\nErde! ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und lange saß sie so im Schweigen, nur ihre Sternenaugen\nleuchteten wie die stillen Wasser zur Frühlingsmittagszeit, bis sie\nplötzlich erwachte, weil jemand die Flurtür aufmachte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Fine kam noch ganz atemlos herein, stürzte nach dem Herd hin,\nschüttelte das Wasser aus den Holzpantoffeln und sagte:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Morgen wird bei uns der Kohl geschält, Jagusch, kommst du?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich komm'.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»In der Stube werden wir schälen. Ambrosius sitzt beim Vater,\nich bin heimlich fortgerannt, um dir das vom "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page189",
      "title": "DaoH/gary"
    }
  }), _vm._v(" Kohl zu sagen. Ulischja, Maruscha\nund Vikta und die anderen Basen werden da sein ... und die Burschen\nwerden kommen ... und Peter mit der Geige hat zugesagt...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Welcher denn?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Den Michaels ihrer, die hinter dem Schulzen sitzen, er ist, wie\nwir die Kartoffeln ausnahmen, vom Militär heimgekehrt ... und redet\nso verdreht, daß man es schwer herauskriegt ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie plapperte die Stube voll, soviel sie nur konnte, und rannte\nnach Haus.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Wieder umfaßte Schweigen den Raum.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Manchmal schlug der Regen gegen die Scheiben, als ob jemand eine\nHandvoll Sand geschleudert hätte, oder der Wind rauschte und\nspielte im Garten und blies in den Schornstein, daß die Feuerbrände\nauf den Herd auseinanderstoben und Rauch in die Stube puffte ...\nUnd die Spindeln auf dem Boden surrten immerzu.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Der Abend zog sich langsam dahin, bis die Alte mit einer leisen,\nzittrigen Stimme das Abendlied anstimmte:")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Alle unsere Tagesmühen ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und die Jungen mit Jagna sangen halblaut und doch so\ndurchdringend mit, daß die Hühner im Flur auf den Staffeln\naufzuschnarren und zu gackern anfingen.")]), _vm._v(" "), _c('p', {
    staticClass: "pcalibre6 initial1"
  }, [_vm._v("Der nächste Tag war ebenso\nregnerisch und düster. Jeden Augenblick trat einer vor sein Haus\nund blickte lange und besorgt in die neblige Welt, ob es sich nicht\nirgendwo aufhellen wollte/aber es war nichts zu sehen als graue\nWolken, die so niedrig zogen, daß es schien, als ob sie sich an den\nBäumen zerrissen; der Regen rieselte ohn' Unterlaß, gegen Mittag\naber steigerte er sich zu einem solchen Wolkenbruch, als hätte\neiner die himmlischen Schleusen geöffnet; es trommelte nur so auf\ndie Dächer.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page190",
      "title": "DaoH/gary"
    }
  }), _vm._v(" Die Leute\ndrückten sich in den Stuben herum; der eine oder der andere\nschleppte sich durch Schmutz und Regen zu den Nachbarn, um sein\nKlagelied anzubringen. Man schimpfte auf das Wetter, in das man\nnicht einmal einen Hund hätte hinausjagen mögen, und manch einer\nhatte doch noch seine Nadelstreu im Wald liegen, ein anderer hatte\nsein Holz nicht eingefahren, ein dritter nur »fast alles«/die eine\nhatte noch den Kohl nicht zu Ende geschnitten, wegen dessen heute\ngar nicht hinauszufahren war, denn der Weiher war in der Nacht so\ngestiegen, daß man schon bei Tagesanbruch die Schleusen öffnen\nmußte, um das Wasser in den Fluß abzulassen, der dadurch aus den\nUfern trat; sogar die Wiesen kamen unter Wasser und die Kohlfelder\nragten wie Inseln mit den schwarzen Rücken ihrer Beete aus dem\nweißlichen schaumbedeckten Strudel auf.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Bei der Dominikbäuerin hatte man ebenfalls den Rest, der noch im\nFelde geblieben war, nicht eingefahren.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Jagna wußte schon vom frühen Morgen an nicht recht wohin, sie\nging von einer Ecke zur anderen, dann sah sie wieder durchs Fenster\nauf die Georginenbüsche, die das Wasser zu Boden gelegt hatte,\nstarrte in die verregnete Welt hinaus und seufzte sehnsüchtig.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Man langweilt sich zum Gotterbarmen!« flüsterte sie ungeduldig\nin Erwartung der Dämmerung und des kommenden Abends, an dem bei\nBorynas Kohl geschält werden sollte, und der Tag schleppte sich\ngerade so langsam wie ein Bettler durch den Dreck, so langweilig\nund so eigentümlich traurig, daß es schon gar nicht mehr zum\nAushalten war. Gereizt war sie auch, so daß sie in einem fort auf\ndie Jungen einschrie und mit allem, was ihr nur unter die Hände\nkam, herumstieß; obendrein hatte sie noch Kopfschmerzen, so daß sie\nsich die Schläfen mit gebrühtem Hafer, den sie mit Essig besprengt\nhatte, belegen mußte/da erst ging es vorüber. Trotzdem konnte sie\nsich keinen Platz finden, und die Arbeit glitt ihr aus den Händen,\nweil sie sich immer wieder in den "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page191",
      "title": "DaoH/wedi"
    }
  }), _vm._v(" Anblick des aufgepeitschten Weihers\nvertiefte, der, wie ein Vogel, schwere Flügel ausbreitete, damit um\nsich schlug und rauschend aufzufliegen versuchte, so daß das Wasser\nauf den Weg spritzte, und doch konnte er nicht auffliegen, als ob\nseine Füße mit dem Boden verwachsen wären. Hinter dem Wasser aber\nstand Borynas Haus, man konnte gut das altersgrüne Dach sehen, die\nneu mit Holzschindeln beschlagene Frontgalerie, deren Dächlein noch\ngelb leuchtete, und die Wirtschaftsgebäude hinter dem Obstgarten;\ndoch sie wußte gar nicht, worauf sie sah...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Dominikwittib war von früh an außer Haus, denn man hatte sie\naufs andere Ende des Dorfes zu einer Gebärenden geholt, da sie für\neine Heilkundige galt und sich auf verschiedene Krankheiten\nauskannte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Es war ein Drängen über Jagna gekommen, hinaus unter die\nMenschen zu gehen, sobald sie aber die Schürze über den Kopf schlug\nund über die Schwelle in den Schmutz und ins Regenwetter\nhinaustrat, verließ sie alle Lust... so daß sie sich zuletzt dem\nWeinen nahe fühlte, unter der Gewalt einer seltsamen\nSehnsüchtigkeit... Da sie sich nicht anders helfen konnte, öffnete\nsie ihre Lade und fing an, aus ihr den Sonntagsstaat hervorzukramen\nund über die Betten auszubreiten... In der Stube wurde es bunt vor\ngestreiften Beiderwandröcken..., Schürzen... Jacken... Doch all das\nwollte sie heute nicht freuen... mit gleichgültigem, gelangweiltem\nBlick sah sie auf ihr Hab und Gut und zog schließlich von unten das\nTuch und das Band hervor, die sie von Boryna hatte; sie schmückte\nsich damit und besah sich lange im Spiegelchen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Nicht schlecht... man muß das für den Abend umtun,« dachte sie,\nund nahm es gleich ab, denn irgend jemand kam zwischen den Hecken\nauf das Haus zu.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Mathias trat ein... Jagna schrie auf vor Staunen, denn es war\ndieser, um den man sie am meisten beschuldigte, daß sie mit ihm des\nNachts im Garten zusammenträfe und ihm "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page192",
      "title": "DaoH/gary"
    }
  }), _vm._v(" auch öfters anderswo Einlas\ngewährte ... Er war ein älterer Bursche, mochte gut über die\nDreißig sein, und noch Junggeselle, aber heiraten wollte er nicht,\nder Schwestern wegen, die noch nicht untergebracht waren, und, wie\nGusche sich zusammenredete, weil ihm die Mädchen und andermanns\nFrauen besser schmeckten ... Ein breitgewachsener Kerl war es, wie\neine Eiche, kräftig und selbstbewußt, dabei so hochmütig und\nunnachgiebig, daß ihn die meisten fürchteten. Und geschickt war das\nLuder zu allem; auf der Flöte spielte er, daß es einem bis an die\nSeele ging, konnte einen Wagen zurechtzimmern, baute Häuser, klebte\nOfen aus und machte alles mit solcher Geschicklichkeit, daß ihm die\nArbeit unter seinen Fäusten nur so hinflog/nur das Geld wollte an\nihm gar nicht haften bleiben, obgleich er gut im Verdienst war,\ndenn er vertrank und verspendierte gleich alles, oder borgte es aus\n... Täubich war sein Vatername, obgleich er eher einem Habicht\nähnlich war seinem Gesicht nach und in bezug auf seine\nHitzigkeit.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gelobt sei Jesus Christus! ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»In Ewigkeit ... Mathias!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich bin's schon selbst, Jagusch, ich bin's ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Er drückte ihr die Hand und sah ihr so feurig in die Augen, daß\ndas Mädchen errötete und unruhig nach der Tür sah.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Warst ein halbes Jahr in der Welt ...,« murmelte sie\nverlegen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ein ganzes halbes Jahr und dreiundzwanzig Tage ... ich hab' gut\ngezählt ...«; ihre Hände aber ließ er nicht los.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich will Licht machen!« rief sie, da es schon tüchtig dunkelte\nund um von ihm loszukommen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Willst du mich nicht begrüßen, Jagusch,« bat er leise und\nwollte sie umfassen, aber sie entglitt ihm schnell und ging zum\nHerd, um Licht zu machen, sie hatte Angst, daß sie die Mutter oder\nirgend jemand anders im Dunkeln überraschen könnte, aber sie kam\nnicht dazu, weil Mathias sie um die "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page193",
      "title": "DaoH/gary"
    }
  }), _vm._v(" Hüften faßte, stark an sich drückte und\nwütend zu küssen begann ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie wand sich wie ein gefangener Vogel, aber sie hatte nicht die\nMacht, sich einem solchen hungrigen Drachen zu entwinden, der sie\nan sich preßte, daß die Rippen fast knackten und dermaßen küßte,\ndaß ihr ganz schwach wurde; die Augen umnebelten sich, sie konnte\nkeinen Atem fangen, und nur mit dem Rest ihrer Beherrschung\nbettelte sie:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Laß ... Mathias ... die Mutter ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Noch ein bißchen, Jagusch, noch einmal, sonst werd' ich ganz\ntoll ... Und er küßte sie so, daß das Mädchen ganz willenlos wurde\nund ihm zwischen den Händen durchglitt, wie Wasser, aber er ließ\nsie mit einem Male los, denn es wurden im Flur Schritte laut; er\nzündete noch eigenhändig das Lämpchen über dem Rauchfang an und\nmachte sich dran, eine Zigarette zu drehen, mit vor Vergnügen\nfunkelnden Augen Jagusch betrachtend, die noch nicht zu sich kommen\nkonnte und schwer atmend sich fest gegen die Wand stützte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Jendschych trat ein und fing an, das Feuer auf dem Herd\nanzufachen, setzte Töpfe mit Wasser auf und machte sich in einem\nfort in der Stube zu schaffen, so daß sie nur wenig mehr\nmiteinander sprachen, und nur mit glühenden, gierigen Augen\neinander betrachteten, als ob sie sich am liebsten auffressen\nwollten ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("In Bälde, es mochten kaum ein paar Paternoster vergangen sein,\nkam die Dominikbauerin heim, sie mußte wohl böse sein, denn schon\nim Hausflur riß sie das Maul gegen Schymek auf und als sie Mathias\ngewahr wurde, blickte sie ihn streng an, ließ seine Begrüßung\nunbeachtet und ging in die Kammer, sich umzukleiden.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Geh schon, sonst wird die Mutter mit dir zanken ...,« bat Jagna\nleise.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Kommst du zu mir heraus, Jagusch, was?« bat er.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Bist schon aus der Welt zurückgekehrt?« sagte die Alte, als\nhätte sie ihn soeben erst entdeckt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page194",
      "title": "DaoH/gary"
    }
  }), _vm._v(" »Das bin\nich, Mutter ...,« sprach er sanft und wollte ihr die Hand\nküssen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Was da, Mutter, such dir 'ne Hündin als Mutter, nicht mich!«\nknurrte sie auf, ihm die Hand wütend entreißend. »Wozu bist du\nhierhergekommen? Hab' ich dir nicht schon gesagt, daß du hier\nnichts zu suchen hast ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Zu Jaguscha bin ich gekommen, nicht zu euch,« rief er trotzig,\ndenn die Wut packte ihn.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Bleib' du mir von der Jagna ab, verstanden! Komm du mir hier\nnoch einmal, daß man sie dann durch dich im Dorf auf den Zungen\nherumträgt, wie irgend so eine ..., daß dich nicht noch einmal\nmeine Augen hier sehen ... brüllte sie los.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ihr schreit, wie eine Krähe, das ganze Dorf wird's hören!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Laß sie hören, laß sie zusammenlaufen, laß sie wissen, daß du\ndich an Jagna gehängt hast, wie 'ne Klette an einen Hundeschwanz,\ndaß man dich selbst mit einer Feuergabel nicht verjagen kann\n...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wenn ihr nicht ein Frauenzimmer wäret, dann würd' ich euch mal\nan die Rippen fassen, für solches Reden ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Versuch' du, Bube, versuch' du bunter Hund ...,« sie griff nach\neinem eisernen Feuerhaken.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Aber dabei blieb es, denn Mathias spie aus, schmiß die Tür ins\nSchloß und ging rasch fort, wozu denn auch, sollte er sich\nvielleicht mit einem Weibsbild herumschlagen und sich zum Gelächter\ndes ganzen Dorfes machen?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Alte aber, als sie seiner nicht mehr habhaft werden konnte,\nmachte sich über Jagna her, und nu mal gleich los und auf sie\neingeifern und alles herholen, was sie schon lange auf der Leber\nhatte ... Jagusch saß indessen still dabei, fast wie erstorben vor\nSchreck, als ihr aber die Worte der Mutter schon bis aufs Blut\ngingen ... kam sie zur Besinnung, fing an zu heulen und steckte\nklagend den Kopf in die Federbetten ... Sie war heftig erbittert...\ndenn sie hatte keine Schuld "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page195",
      "title": "DaoH/gary"
    }
  }), _vm._v(" ... sie hatte ihn doch nicht ins Haus gerufen ...,\ner war ja von selbst gekommen ..., und was die Mutter ihr da vom\nFrühjahr vorhielt, da hatte er sie nur am Zaunüberstieg getroffen\n...; konnte sie sich solchem Ungeheuer entwinden? ... wo es ihr so\nin alle Glieder gefahren war, daß sie ... und später konnte sie\nsich ihn da vom Leibe halten? ... Immer ist es so mit ihr, wenn sie\nnur einer scharf ansieht oder stark anpackt ... dann bebt in ihr\nalles, die ganze Kraft geht von ihr ab und es wird ihr so schwach\nim Magen, daß sie schon nichts mehr weiß ... was kann sie\ndafür?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie klagte still und unter Tränen, bis die Alte sich begütigte\nund ihr besorgt die Augen und das Gesicht abtrocknete, über den\njungen Kopf strich und sie zu beruhigen begann.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Nu, sei man still, Jagusch, weine nicht ... nein ... sonst\nkriegst du rote Augen, wie ein Karnickel, und wie sollst du denn so\nauf den Borynahof gehen?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ist es denn schon Zeit?« fragte sie nach einer Weile, schon\netwas beruhigt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Natürlich, daß es Zeit ist, und mach' dich recht fein, viele\nLeute werden da sein und auch Boryna selbst gibt acht ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Jagusch erhob sich gleich und fing an, sich anzuziehen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Soll ich dir nicht Milch kochen?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Nein, ich hab' gar keinen Hunger, Mutter.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Schymek, du mißratene Kreatur, wärmst dich hier, und da nagen\ndie Kühe an den Krippen,« schrie sie mit dem Rest ihrer Wut, und\nSchymek rannte davon, um nicht etwas abzukriegen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Es scheint sich mir,« sprach sie stiller, indem sie Jagna beim\nAnkleiden behilflich war, »daß der Schmied mit Boryna in gutem\nEinvernehmen ist. Ich bin ihm begegnet, wie er vom Alten ein feines\nBullenkalb wegholte ... Schade ... gut seine fünfzehn Papierer war\nes wert ... vielleicht ist es aber doch gut, daß sie miteinander in\nFrieden sind, weil der Schmied ein großes Maul hat und sich "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page196",
      "title": "DaoH/gary"
    }
  }), _vm._v(" aufs Recht auskennt\n...« Sie trat ein paar Schritte zurück und sah ihre Tochter mit\nWohlgefallen an. »Aber diesen Dieb, den Kosiol, haben sie, scheint\nmir, schon wieder freigelassen, man wird wieder alles zuschließen\nmüssen und Obacht geben ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich geh' schon!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ja, geh' du nur und scharmezier' mit den Burschen bis über\nMitternacht 'rum,« platzte sie noch einmal mit dem Rest des Ärgers\nlos.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Jagna ging hinaus, aber noch vom Weg her hörte sie die Alte, wie\nsie auf Jendschych einschimpfte, daß die Schweine nicht\neingetrieben wären und die Hühner auf den Bäumen nächtigten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Bei Boryna waren schon viele Leute.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Ein Feuer flammte auf dem Herd und erleuchtete die große Stube,\ndaß die Scheiben der Bilder gleißten und die Weltkugeln\n"), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0003#foot6",
      "id": "text6"
    }
  }, [_c('sup', {
    staticClass: "calibre6"
  }, [_vm._v("F6")])]), _vm._v(" aus farbigen Oblaten, die an Fäden von den\nschwarzen, rußigen Deckenbalken herabhingen, hin und her\nschaukelten; inmitten der Stube lag ein Haufen Rotkohl und drum\nherum in einem weitgezogenen Halbkreis mit den Gesichtern nach dem\nFeuer hingewandt, saßen Mädchen und ein paar ältere Frauen\nbeisammen/sie schälten den Kohl und warfen die Köpfe auf ein am\nFenster ausgebreitetes Leinwandtuch.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Jagusch wärmte sich die Hände am Herd, stellte ihre Holzpantinen\nunters Fenster und setzte sich gleich am Rand neben die alte Gusche\nzum Arbeiten nieder.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Das Stimmengewirr stieg immer mehr, denn es kamen noch immerfort\nFrauen hinzu und auch etliche Burschen, die mit Jakob zusammen Kohl\naus der Scheune trugen, mehr aber noch Zigaretten rauchten, den\nMädchen lachend die Zähne zeigten und sich untereinander\nneckten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Fine, die doch eigentlich noch der reine Kiekindiewelt war, war\nüberall die erste an der Arbeit und beim Amüsieren, denn der Alte\nwar nicht zugegen, und Anna kroch "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page197",
      "title": "DaoH/gary"
    }
  }), _vm._v(" wie gewöhnlich herum, als ob sie eine\nNachteule oder ein Brummkater wäre.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das ist hier rot in der Stube, wie von Mohnblumen,« rief Antek,\nder die Fässer auf den Flur gerollt hatte und jetzt etwas abseits\nvom Herd die Krauthobel aufstellte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Huch! Die haben sich geputzt wie für eine Hochzeit!« ließ sich\neine der älteren Frauen vernehmen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und Jagusch hat sich wohl in Milch gewaschen,« fing Gusche an\nzu sticheln.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Laßt das,« murmelte sie errötend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Freut euch, Mädel, Mathias ist schon hergewandert aus der Welt,\ngleich fangen hier wieder die Musiken und Tänze und das Herumstehen\nin den Obstgärten an ...,« redete sie weiter.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Den ganzen Sommer über war er nicht da.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Versteht sich, hat doch das Herrenhaus in Wola gebaut.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»So 'n Luder, versteht alles, läßt selbst Seifenblasen aus der\nNase fliegen,« sagte einer der Burschen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und auf die Mädchen versteht er sich, daß man nicht einmal drei\nQuartal zu warten braucht ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Von der Gusche kriegt keiner 'n gutes Wort ab,« fing eines der\nMädchen an.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Paß auf, daß ich über dich nicht was zu sagen wüßte ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wißt ihr schon, man sagt, der alte Wanderer ist\nangekommen?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Er kommt zu uns heute,« rief Fine.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ganze drei Jahre war er in der Welt.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»In der Welt? ... Am heiligen Grab war er doch!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hale! Hat ihn da einer gesehen? Lügen tut das Biest und die\nDummen werden nicht alle; ebenso erzählt ja auch der Schmied von\nüberseeischen Ländern, alles was er sich in den Zeitungen\nzusammenliest ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Sagt das nicht, Gusche, denn selbst Hochwürden hat es der\nMutter zugesichert.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das ist ja wahr, daß die Dominikbäuerin so gut wie ihr "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page198",
      "title": "DaoH/gary"
    }
  }), _vm._v(" zweites Haus auf\ndem Pastorat hat und immer weiß, wann der Pastor Leibschmerzen hat,\nsie ist doch 'ne Heilkundige ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Jagna verstummte, aber sie hatte große Lust, sie mal mit dem\nKohlmesser zu stechen, denn die ganze Stube brach in schallendes\nGelächter aus; nur dem Gregor seine Ulischja neigte sich zur\nKlembbäuerin hin und fragte:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Woher ist er denn?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Woher? Von weit her, wer kann das wissen!« sie beugte sich\netwas vor, legte einen Kohlkopf auf ihre Handfläche, säuberte ihn\nvon den Blättern und sprach rasch und immer lauter, damit es auch\ndie anderen hörten: »Jeden dritten Winter kommt er nach Lipce und\nnimmt bei Boryna Quartier./ Rochus ließ er sich nennen, obgleich\ngewißlich sein Name nicht Rochus ist ... Ein Bettler ist er und\nauch kein Bettler, wer kann das wissen ... aber ein frommer Mensch\nist er und ein guter ... es fehlt ihm nur der goldene Reif um den\nKopf, dann wäre er richtig, wie die Heiligen auf den Bildern.\nRosenkränze hat er um den Hals hängen, damit hat er übers heilige\nGrab gestrichen ... Heiligenbilder schenkt er den Kindern, und\nmanchen auch solche mit Königen, die früher aus unserem Volke kamen\n... und fromme Bücher hat er, auch solche, in denen alles steht und\nauch verschiedene Geschichten über die Welt ... meinem Walek hat er\nsie doch vorgelesen, da haben wir, ich und der Meine, mit zugehört,\nnur daß ich es wieder vergessen habe, weil's auch schwer\nherauszubringen ist ... Und so fromm wie der ist, einen halben Tag\nkniet er oft durch, manchesmal unterm Kreuz am Wege oder auch\nirgendwo im Feld; und in die Kirche, da geht et immer nur zur\nMesse. Hochwürden hat ihn schon zu sich auf die Propstei\neingeladen, da hat er ihm gesagt:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Beim Volk ist es mir zu bleiben, nicht in den feinen Zimmern ist\nmein Platz.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Alle tun auch 'rausfinden, daß er wohl nicht vom Bauernstand\nist, obgleich er auch spricht, wie alle, und gelehrt ist "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page199",
      "title": "DaoH/gary"
    }
  }), _vm._v(" er; das ist er\nauch, mit dem Juden hat er deutsch geredet und auf dem Herrenhof in\nTschasgowa/hat er mit dem Fräulein, das für die Gesundheit in\nwarmen Ländern war, auch auf ausländ'sch sich besprochen ... und\nvon keinem nimmt er was an, nur vielleicht den kleinen Tropfen\nMilch und einen Brotknust, und dafür lernt er noch den Kindern was\n... man sagt ...«/die Klembbäuerin unterbrach sich plötzlich, denn\ndie Mädchen brachen in ein solches Gelächter aus, daß sie fast auf\nden Rücken fielen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie lachten über Jakob, der in einem Leinwandtuch Kohl\nhereintrug und, durch irgendwen angestoßen, mitten in der Stube so\nlang er war hinpurzelte, so daß der Kohl nach allen Ecken\nauseinanderrollte, er versuchte sich mühevoll auszurichten; doch\njedesmal, wenn er auf allen Vieren hochkrabbeln wollte, wurde er\nvon neuem angestoßen und fiel wieder um.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Fine kam ihm zur Hilfe und stand ihm bei, wieder hochzukommen,\nwas er da aber geflucht und geflucht hat ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und langsam ging das Gespräch auf etwas anderes über.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Alle sprachen halblaut durcheinander, und ein Gesumm von Stimmen\nentstand darob, wie in einem Bienenstock vor dem Ausschwärmen, und\nein Gekicher, ein Geneck und ein Spaß war in der Runde, daß die\nAugen nur so funkelten und die Münder lachten. Die Arbeit ging\ndabei blitzgeschwind vorwärts, nur die Messer knirschten gegen die\nStrünke und die Kohlköpfe flogen wie Kugeln in dichten Abständen\nhintereinander auf das Leinwandtuch und häuften sich zu einem immer\ngrößeren Berg. Antek aber schnitt den Kohl klein über einem großen\nZuber am Herd; er hatte seine Oberkleidung abgelegt und stand nur\nnoch im Hemd und in den gestreiften Beiderwandhosen da, er war ganz\nrot geworden, und über der Stirn unter dem zerzausten Haar perlten\ndie Schweißtropfen; er schaffte mächtig, lachte in einem fort,\nneckte sich weidlich herum und sah so wohlgestaltet aus, daß Jagna\nauf ihn, wie auf ein Bild "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page200",
      "title": "DaoH/gary"
    }
  }), _vm._v(" schaute und nicht nur Jagna allein ...; er aber\nhielt hin und wieder an, um Atem zu schöpfen und sah sie mit seinen\nfrohen Blicken so an, daß sie die Augen senkte und errötete. Doch\nniemand sah es, außer Gusche, die tat, als ob sie nichts merke und\nlegte es sich im Kopf zurecht, wie sie das im Dorf erzählen\nwürde.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Marzicha ist, sagt man, niedergekommen, wißt ihr das?« fing die\nKlembbäuerin an.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das ist nichts Neues bei ihr, jedes Jahr macht sie sich\ndas.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ein Frauenzimmer wie 'n Stier, das Kind zieht ihr nur das Blut\nvom Kopf ab,« brummte Gusche und wollte sich darüber noch besser\nausbreiten, aber die anderen Frauen wiesen sie zurecht, daß sie\nüber solche Sachen rede bei den Mädchen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Die wissen auch über bessere Bescheid, braucht euch nicht zu\nsorgen. Heut sind schon solche Zeiten da, daß, wenn man selbst\neinem Gänsemädchen vom Storch redet, dann lacht sie dir ins Gesicht\n... das war so früher nicht, nein, nein ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Na, ihr habt schon alles gewußt, wie ihr noch hinterm Vieh\nwar't ...,« sagte die alte Wawschjonbäuerin ernst, »ich weiß schon\nnoch, was ihr da auf den Weidenplätzen getrieben habt.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wenn ihr es wißt, könnt ihr es behalten,« krächzte Gusche\nschrill.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Damals war ich schon verheiratet ... mit Mathias scheint mir\n... nein, mit Michael, ja, stimmt, denn Wawschjon war doch der\ndritte ...;« murmelte sie, ohne recht zu treffen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Heda, ihr sitzt hier so und wißt nicht mal, was passiert ist!«\nschrie Nastuscha Täubich, Mathias seine Schwester, atemlos\nhereinstürzend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Von allen Seiten wurden neugierige Fragen laut, und aller Augen\nhafteten an ihr.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Dem Müller seine Pferde sind gestohlen!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page201",
      "title": "DaoH/wedi"
    }
  }), _vm._v(" »Wann\ndenn?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Kaum drei Paternoster her. Soeben hat es Jankel dem Mathias\nerzählt.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Der Jankel, der weiß immer alles gleich und manchmal selbst ein\nbißchen früher...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Solche Pferde, die reinen Riesen!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Aus dem Stall haben sie sie hinausgeführt. Der Knecht war in\nder Mühle um Hafer zu holen, kommt zurück, und, hast du nicht\ngesehen, weder Pferde noch Geschirr, und der Hofhund vergiftet,\ndenkt nur!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Zum Winter geht es, da fängt manch Verschiedenes an.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das kommt davon, weil keine Strafe für die Diebe da ist. Hale,\nviel werden sie ihm machen, stecken ihn ins Kriminal, geben ihm zu\nessen, in der Wärme wird er sitzen, lernt verschiedene Praktiken\nmit den Kollegen, und wenn sie ihn rauslassen, dann gibt's noch\neinen besseren Dieb, einen studierten.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wenn man mir so mein Pferd herausholen würde und ich würde\neinen solchen zu fassen kriegen, dann würd' ich ihn auf dem Fleck\numbringen, wie einen tollen Hund,« rief einer der Burschen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Nur das hätte so einer verdient, die Dummen warten nur auf\nGerechtigkeit. Jeder hat das Recht, wenn ihm Unrecht geschieht,\nsich Recht zu verschaffen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»So einen müßte man einfangen und dann gemeinsam umbringen, dann\ngibt's auch keine Strafe, denn alle können sie doch nicht\nbestrafen?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich weiß schon... das haben sie bei uns so gemacht... gleich,\nda war ich schon mit dem zweiten verheiratet... nein, ich glaube,\nMathias war es noch...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Aber diese Ausführungen unterbrach Boryna, der gerade in die\nStube trat.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ihr flüstert hier so schön miteinander, daß man es von der\nanderen Seite des Weihers hört!« rief er lustig, nahm die Mütze ab\nund begrüßte alle der Reihe nach. Er mußte "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page202",
      "title": "DaoH/wedi"
    }
  }), _vm._v(" schon einen sitzen haben, denn er\nwar rot wie ein Spitzhahn, den Knierock hatte er aufgelassen und\nsprach laut und viel, was sonst nicht seine Gewohnheit war. Er\nhatte Lust, sich neben Jagna zu setzen, aber er wägte ab, daß es\nwohl nicht gut anginge so vor den Augen der ganzen Versammlung,\nsolange sie nicht mit ihm versprochen war; so redete er denn lustig\ndarauf los und besah sie sich mit Wohlgefallen, wie schön sie heute\nwar und wie fein sie sich mit dem von ihm geschenkten Kopftuch\naufgeputzt hatte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Gleich darauf trugen Witek und Jakob eine lange Bank an den Herd\nheran, Fine wischte sie mit einem reinen Linnen ab und fing an, die\nSchüsseln und Löffel für das Essen aufzusetzen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und Boryna brachte aus der Kammer eine dickbäuchige, zwei Quart\ngroße Buttel Aquavit und begann damit, alle der Reihe nach\nabzugehen und jedem zuzutrinken.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Mädchen zierten sich etwas, bis schließlich einer der\nBurschen sagte:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Die sind auf Schnaps lecker, wie die Katz' auf die Milch, nur\nwollen sie sich erst bitten lassen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Selbst der richtige Säufer, sitzt immerzu bei Jankel, da denkt\ner, daß alle dasselbe!«...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und sie tranken, drehten sich weg, versteckten ihre Gesichter\nhinter der Hand, gossen den Rest auf den Boden aus, zogen eine\nFratze, sagten: »Stark is er« und gaben Boryna das Glas zurück.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Nur Jagna versteifte sich und trank nicht, trotz der Bitten und\nÜberredungen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Selbst den Geschmack von Branntwein kenn' ich nicht, und bin\nnicht neugierig darauf,« sagte sie.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Na, setzt euch nur hin, liebe Leute, was da ist, wollen wir\nessen,« lud der Alte ein.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie setzten sich nach vielen Umständen, wie das die gute Sitte\nwollte und aßen gemächlich, zwischendurch miteinander redend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page203",
      "title": "DaoH/lac"
    }
  }), _vm._v(" Aus den\nSchüsseln stieg der Dampf und hüllte alle in eine Dunstwolke ein\n... aus der nur das Schaben der Löffel, Schmatzen und gelegentlich\nein Wort zu hören war.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie hatten ein leckeres Essen gekocht, manch einer wunderte sich\nselbst darob. Es gab Fleischbrühe mit Kartoffeln, gekochtes Fleisch\nmit gerösteter Gerstengrütze und Kohl mit Erbsen – es war eine\nehrliche Bewirtung, wie es ein Hofbauer zu spendieren hat, und\naußerdem tat Boryna immerzu auffordern und mehrmals nötigen, und\nFine ihrerseits sowohl wie Anna paßten auf, um zuzulegen und\nzuzugießen ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Witek warf trockene Klötze aufs Feuer, das lustig knatterte, und\nJakob trug in der Zeit, da gegessen wurde, Kohl in die Stube und\nschüttete ihn aus einen Haufen, zog begierig die Düfte ein, leckte\nsich den Bart und seufzte vor sich hin.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Einen halben Ochsen würd' ich runterschlucken, mit einem oder\nzwei Schüsselchen Grütze ... und die Biester fressen so wie die\nausgehungerten Pferde, bringen's noch fertig, einem nicht mal einen\nKnochen übrigzulassen,« dachte er mit Unbehagen und schnallte den\nGurt fester, denn es knurrte ihm nur so vor Hunger in den\nEingeweiden.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie waren bald zu Ende und erhoben sich mit einem »Gott\nbezahl's!« für die Wirte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Laßt es euch wohl bekommen!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Ein Lärmen entstand; der ging hinaus, um sich durchzulüften und\ndie Knochen zu recken, der war begierig nach dem Wetter zu sehen,\nob es sich nicht aufhellte, und die Burschen, die machten, daß sie\nzu den Mädchen auf die Galerie kamen, um mit ihnen\nherumzutollen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Jakob aber saß auf der Schwelle mit einer Schüssel zwischen den\nKnien und aß, daß ihm die Ohren bebten, ohne auf Waupa zu achten,\nder sich verschiedenartig in Erinnerung brachte, und als er sah,\ndaß nichts zu holen war, auf die Galerie zu den Hunden hinausschob,\ndie den Menschen nachgefolgt waren und sich um die Knochen balgten,\ndie Fine ihnen hingeworfen hatte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page204",
      "title": "DaoH/lac"
    }
  }), _vm._v(" Sie machten\nsich gerade abermals an die Arbeit, als Rochus unter die Tür trat\nmit einem: »Gelobt sei Jesus Christus!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»In Ewigkeit, Amen!« antworteten sie im Chor.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Beeilt euch, Wanderer, setzt euch her/solang noch nicht die\nSchüssel leer ... Verspätet habt ihr euch, aber es wird noch für\neuch reichen ...,« rief Boryna und schob ihm einen Stuhl an den\nHerd heran.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gib mir Milch und Brot, Fine, das wird schon reichen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Es ist auch noch ein bißchen Fleisch,« ließ sich Anna\nschüchtern vernehmen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Nein, Gott bezahl's, aber Fleisch esse ich nicht.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie schwiegen erst und betrachteten ihn mit einer freundlichen\nNeugierde; als er sich aber ans Essen setzte, erhoben sich\nGespräche und Gelächter aufs neue.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Nur Jagna sah oft mit Staunen auf den Wandersmann, daß ein\nsolcher Mensch, ganz wie alle anderen, doch am heiligen Grabe\ngewesen war, die halbe Welt gesehen hatte und so viele Wunder ...\n»Wie mag es denn da in dieser Welt sein? Wohin muß man gehen, um da\nhinzukommen? ... Ringsherum sind doch nur Dörfer, Felder und\nWälder, und hinter ihnen wieder Dörfer, Felder und Wälder ... An\ndie hundert Meilen muß einer wohl gehen, oder vielleicht auch an\ndie tausend,« dachte sie und hatte eine seltsame Lust, zu fragen,\naber wie hätte sie das wagen können, er hätte sie gewiß noch\nausgelacht ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Rafus sein Sohn, dieser, der vom Militär zurück war, hatte eine\nGeige gebracht, sie gestimmt, und fing an, verschiedene Lieder\naufzuspielen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Eine Stille entstand, nur der Regen peitschte gegen die Scheiben\nund die Hunde geiferten vor dem Haus. Und er spielte immerzu und\nimmer wieder etwas Neues, mit den Händen fingerte er und strich so\nmit dem Bogen über die Saiten, daß die Melodie wie von selbst\nherauskam ... Er spielte fromme Lieder, als ob sie für jenen\nWandersmann "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page205",
      "title": "DaoH/lac"
    }
  }), _vm._v("\nbestimmt wären, der das Auge nicht von ihm wandte; und darauf\nwiederum spielte er andere, ganz weltliche, vom Hans, der in den\nKrieg gemußt/jenes Lied, das die Mädchen so oft auf dem Feld\nanstimmten ... und so klagend stieg es aus jenen Hölzern, daß ein\nFrösteln durch alle Knochen ging, und Jagusch, die auf Musik\nempfindlich war, wie selten eine, fühlte, daß ihr die Tränen über\ndie Wangen liefen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hör' doch auf, denn Jagusch weint ...,« rief Nastuscha\nhinüber.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Nein ... das ist nur so ... es nimmt mich immer mit ... das\nSpiele n... nein ...,« flüsterte sie beschämt und verbarg das\nGesicht hinter der Schürze.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Es half aber nichts, denn obgleich sie nicht wollte, tropften\nihr die Tränen von selbst aus jener seltsamen Sehnsüchtigkeit, die\nihr im Herzen geblieben war, Gott weiß wonach ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Doch der Bursche hörte nicht auf zu spielen, nur daß er jetzt\nfeurige Mazurken und solche Obereks vom Ohr ausholend über die\nFiedel schnitt und geigte, daß die Mädchen sich nicht mehr zu\nhelfen wußten und vor lauter Lust die bebenden Knie\naneinanderpreßten, dabei mit den Armen schwingend, und die Burschen\nhell aufjuchzten und hin und wieder im Takte trampelten ... Die\nStube füllte sich mit solchem Lärm, Getrampel und Gelächter, daß\ndie Scheiben klirrten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Plötzlich fing aus dem Flur ein Hund an, zu winseln, und heulte\nso furchtbar auf, daß alle verstummten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Was ist geschehen?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Rochus stürzte so schnell nach dem Flur hin, daß er fast über\ndie Krauthobel zu Fall gekommen wäre.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ist nichts ... irgendein Junge hat dem Hund den Schwanz\nzwischen die Tür geklemmt, darum schrie er,« rief Antek, nachdem er\nauf den Flur geguckt hatte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das ist gewiß Witek seine Arbeit,« bemerkte Boryna.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»I, wie denn, Witek würde einem Hund was zuleide "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page206",
      "title": "DaoH/lac"
    }
  }), _vm._v(" tun, er, der das ganze\nkrüpplige Tierzeug vom Dorf zusammentreibt und auskuriert ...,«\nverteidigte Fine empört.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Rochus kehrte stark aufgebracht zurück, er mußte wohl den Hund\nbefreit haben, denn man hörte das Winseln nur noch irgendwo fern\nzwischen den Hecken.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Auch der Hund ist Gottes Kreatur und fühlt, wenn man ihm\nUnrecht zufügt, ganz wie ein Mensch ... Herr Jesus hatte auch\nseinen Hund und ließ ihm von niemand was antun ...,« sagte er\nleidenschaftlich.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Herr Jesus sollte da einen Hund gehabt haben, wie alle\nMenschen?« zweifelte Gusche.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Daß ihr es wißt, daß er einen hatte, und Burek hat er ihn\ngenannt ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hale ... Na! Sieh mal an ...!« ließen sich neugierige Stimmen\nvernehmen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Rochus schwieg eine Weile, dann aber hob er seinen weißen Kopf,\nder mit langen, über der Stirn gerade geschnittenen Haaren gekrönt\nwar, heftete seine hellen, wie blaßgeweinten Augen auf die\nFeuersglut und ließ sich leise vernehmen, indem er mit den Fingern\ndie Perlen des Rosenkranzes abtastete.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»... In jener fernen Zeit ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Als der Herr Jesus noch auf Erden wandelte und das Volk selber\nregierte, ist also geschehen, was ich hier sagen werde ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Es ging sich der Herr Jesus zur Kirchweih nach Mstow, und kein\nWeg war nirgends da, nur böse glühende Sande überall, denn die\nSonne brannte und es war eine solche Hitze, als wie wenn Gewitter\nkommt ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und kein Schatten und kein Schutz.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Herr Jesus ging mit vieler Geduld, denn zum Wald war noch ein\ngutes Stück Wegs, und da er seine lieben heiligen Füße schon nicht\nmehr fühlte vor Müdigkeit und arg zu leiden hatte wegen dem\nDurst/so setzte er sich eins ums "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page207",
      "title": "DaoH/lac"
    }
  }), _vm._v(" andere Mal, wenn es da auch noch so mächtig\nbrannte, auf einen der Flugsandhaufen, wo nur lauter Ziegenbart\nwuchs. Schatten war da nur so viel, was die verdorrten Stauden der\nKönigskerzen hergaben, so daß selbst ein Vöglein dort keinen\nUnterschlupf gefunden hätte ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und kaum hatte er sich zum Sitzen niedergelassen und hatte nicht\neinmal redlich aufgejapst, als auch gleich der Böse, wie dieser\nhäßliche Habicht, der von oben herab auf ein müdes Vöglein stößt,\ndahergefahren kam, und so hatte der Verpestete mit seinen Hufen den\nSand aufgeschlagen und hat sich so wie 'n Vieh herumgewälzt, daß\neine solche Staubwolke aufkam und eine solche Finsternis entstand,\ndaß die Welt nicht mehr zu sehen war.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Herr Jesus, obschon es ihm den Atem in der Brust einklemmte und\nihm die Glieder matt wurden, stand allemal auf und ging seiner Wege\nweiter, und lachte sich nur über den Dummen, denn er wußte ja, daß\nder Böse ihm den Weg verwirren wollte, damit er nicht zur Kirchweih\nankäme, dem sündigen Volk Vergebung zu bringen ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und so wanderte der Herr Jesus ... und wanderte ... bis er denn\nzum Wald hinkam ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Er ruhte sich nicht schlecht in diesem Schatten aus, labte sich\nan dem Wasser und langte sich einen Bissen aus dem Bettelsack,\ndanach brach er sich einen tüchtigen Stecken aus dem Buschwerk\n'raus, bekreuzigte sich und stapfte in den Wald hinein.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und der Forst war alt und dicht, und die Sümpfe ungangbar, und\ndie Moräste und Moorwasser so fürchterlich, daß der Böse wohl dort\nhausen mußte, und das Dickicht so groß, daß selbst manchem Vogel\nnicht leicht war, da durchzudringen. Kaum ist da der Herr Jesus\ndrin, da fängt auch schon der Böse an, den Forst zu schütteln, zu\nheulen, und die Tannen wegzubrechen./Und der Wind, da er doch ein\nHöllenknecht ist, half ihm so schnell er konnte, riß das Dürrholz\nab, riß die Äste zu Boden, riß die ganzen Eichen "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page208",
      "title": "DaoH/Wunibald"
    }
  }), _vm._v(" um, dröhnte und knatterte\nim Forst herum, wie nur 'n Dummer kann.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Eine solche Dunkelheit kam über den Wald, daß man sich ruhig\nhatte das Auge ausstechen lassen können und hätte grad soviel\ngesehen/und dazu ein Rauschen und ein Knacken ... und dazu ein\nWirbelwind ... und plötzlich springt ein solches Tiergezeug hervor,\nbleckt die Zähne... und knurrt ... und schreckt... und leuchtet mit\nden Glotzen und langt schon fast ... fast mit den Krallen zu ...\naber natürlich, daß sie sich nicht trauten, denn wieso denn sollten\nsie ... es war doch Herr Jesus in der eigenen heiligen Person\n...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Doch auch der Herr Jesus hatte es satt, dieses dumme Scheuchen,\nund da er es eilig zur Kirchweih hatte, so machte er das Zeichen\ndes heiligen Kreuzes über dem Forst, und gleich versank der Böse\nmit seiner ganzen Anverwandtschaft in den Moorwassern.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Es blieb nur so ein wilder Hund nach, denn zu jener Zeit waren\ndie Hunde noch nicht mit den Menschen verbrüdert.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Dieser Hund da war zurückgeblieben, kam hinter Herrn Jesus\nhergestürzt, bellte, und machte sich an seine lieben heiligen Füße\nheran, das eine Mal schnappte er mit den Hauern nach den Hosen, das\nandere Mal riß er ihm den Kapottrock entzwei, griff nach den\nBettelsacken und versuchte mit Gewalt an das lebendige Fleisch\nheranzukommen ... Herr Jesus aber, da er barmherzig war und keiner\nKreatur etwas zuleide getan hätte/und er hätte ihn doch mit dem\nStecken leicht zuschanden machen können oder selbst mit einem\neinzigen Gedanken vernichten/sagte nur:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("›Da hast du ein Brötlein, Dummer, wenn du hungrig bist,‹ und er\nwarf ihm etwas aus dem Sack zu.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Der Hund aber war so böse und verstockt, daß er gar nichts\ndanach fragte, seine Hauer bleckte, knurrte, geiferte, immer\ndichter herandrängte und schon ganz dem Herrn Jesus seine Hosen\nverdorben hatte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("›Brot hab' ich dir gegeben, dir kein Unrecht getan und du "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page209",
      "title": "DaoH/Wunibald"
    }
  }), _vm._v(" reißt mir hier\ndie Kleider vom Leib und bellst drauflos. Dumm bist du, mein\nHündchen, weil du deinen Herrn nicht erkannt hast. Das wirst du\nnoch beim Menschen abdienen müssen und wirst ohne ihn nicht\nauskommen können ...« Herr Jesus sagte das so stark, daß der Hund\nsich mit eins auf den Hintern setzte; er drehte um, tat seinen\nSchwanz einklemmen, heulte auf und rannte wie besessen in die Welt\nhinein.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und Herr Jesus kam zur Kirchweih.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Auf der Kirchweih war so viel Volk wie Bäume im Wald oder Gras\nauf den Wiesen/ganz dicht.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("In der Kirche war aber es leer/denn in der Schenke wurde\ngespielt, und gleich an der Kirchentür wurde Markt abgehalten,\ngetrunken und Lotterei getrieben, Gott zum Verdruß, wie das um\nsolche Zeit sich trifft.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Es tritt Herr Jesus nach dem Hochamt heraus und schaut, er sieht\ndas Volk wogen wie das Korn unterm Wind, einmal nach dieser Seite,\neinmal nach der andern, und rennen; einer rennt mit einer Peitsche,\nein anderer reißt eine Latte vom Zaun, ein dritter langt sich eine\nRunge, und noch einer sucht sich einen Stein, die Weiber kreischen\nund klettern auf die Zäune und auf die Wagen, die Kinder heulen los\nund alles schreit:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("›Toller Hund, toller Hund!‹")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und der Hund mitten durch das Volk, wie durch eine plötzlich\naufgerissene Gasse mit heraushängender Zunge schnurstracks auf\nHerrn Jesus zu.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Es erschrak nicht unser Herr, nein ... er erkannte, daß es\nderselbe Hund aus dem Wald war, so breitete er denn seinen heiligen\nKapottrock aus und spricht zum Tier, das plötzlich stehengeblieben\nwar:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("›Komm her, Burek, bei mir bist du noch sicherer geborgen, wie\nselbst im Wald.‹")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Er deckte ihn mit dem Kapottrock zu, legte die Hände über ihn\nund sprach:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page210",
      "title": "DaoH/Wunibald"
    }
  }), _vm._v(" ›Tötet\nihn nicht, Leute, das ist auch Gottes Geschöpf, und es ist arm,\nhungrig, gehetzt und herrenlos.‹")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Aber die Bauern fingen an zu schreien und zu schimpfen, zu\nbrummen und mit den Rungen auf den Boden zu schlagen: ›Das wäre ein\nwildes und tolles Tier, und hätte ihnen schon so viel Gänslein und\nLämmlein gestohlen, und Schaden machte es immerzu und kein Respekt\nhabe es vor den Menschen, und wäre gleich mit den Zähnen bereit ...\nso daß niemand ins Feld ohne Stock gehen kann, denn es gäbe keine\nSicherheit vor dieser Teufelsbrut ... und man müßte ihn durchaus\nerschlagen.‹")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und sie wollten den Hund mit Gewalt unter dem Herrn Jesus seinen\nKapottrock hervorholen und umbringen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Bis Herrn Jesus der Zorn ankam und er sie anfuhr:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("›Rührt nicht an, alle miteinander! Den Hund, den tut ihr\nfürchten, ihr Liederjahne und Säufer, aber den Herrgott, den\nfürchtet ihr nicht, was? ...‹")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie wichen zurück, denn er hatte mit Macht gesprochen, und\nweiter sagte ihnen Herr Jesus, daß sie Liederjane wären ... zur\nKirchweih wären sie gekommen und täten hier nur in den Schenken\nherumsitzen, und Gott zum Zorn sein, und keine Buße täten sie, und\nwären Schandmäuler und Schinder füreinander und Diebe und gottloses\nPack, und Gottes Strafe würde sie schon erreichen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("So schloß Herr Jesus, erhob seinen Stecken und wollte fortgehen\n...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Aber das Volk hatte ihn schon erkannt und nu hin, da, auf die\nKnie, und nur so losgeheult und geweint und gewimmert ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("›Herr, bleibe mit uns! Bleibe, oh Herr Jesu Christ! Bleibe! Treu\nwollen wir zu dir halten, wie 'n Hund ... wir Säufer, wir\nGottvergessenen, wir schlechten Menschen, oh bleibe, bestrafe,\nschlage, aber bleibe ..., wir verlassenen Waisen, wir herrenlosen\nMenschen ...‹ Und sie weinten so und bettelten so und küßten seine\nHände und seine heiligen Füße, daß das "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page211",
      "title": "lac/DaoH"
    }
  }), _vm._v(" Herz des Herrn weich wurde; ein\npaar Paternoster lang blieb er mit ihnen, belehrte sie, sprach sie\nder Sünden ledig und segnete alles.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und dann, als er schon im Weggehen war, sprach er:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Hat euch der Hund unrecht getan, so soll er von nun an euch\ndienen. Die Gänslein wird er hüten, die Lämmlein beschützen, und so\ndu der eine oder der andere dich besäufst/ wird er dein Hab und Gut\nbewachen und wird euch von nun an Freund sein.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("›Aber ehren sollt ihr ihn und kein Unrecht tun.‹")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und unser Herr Jesus ging fort in die weite Welt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und als er sich umsieht/sitzt Burek auf demselben Platz.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("›Burek, was kommst du nicht, willst du Dummer denn allein\ndableiben? ...‹")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und der Hund ging mit und folgte jetzunder dem Herrn auf Weg und\nSteg so sacht und bedachtsam und so treu, wie der beste Knecht.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und sie gingen fortan miteinander.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Durch die Wälder, über die Wasser/und durch die ganze Welt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und wenn sie manchmal Hunger zu leiden hatten, dann spürte der\nHund wohl ein Vögelein oder ein Gänslein auf oder brachte ein\nSchaf, und so lebten sie gemeinsam.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und manches gute Mal, wenn der liebe Herr ermüdet ruhte, jagte\nBurek die bösen Menschen fort oder vertrieb ein wildes Tier und gab\nunsern Herrn Jesus nicht heraus, mitnichten ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Als die Zeit kam, daß die häßlichen Juden und die bösen\nPharisäer den Herrn zur Richtstätte brachten/warf sich Burek auf\nalle und biß um sich und verteidigte so gut er konnte, seinen\nHerrn, das arme, liebe Tier:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und Herr Jesus sprach zu ihm unter der Last des Kreuzes, das er\nfür seine heilige Marter schleppen mußte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("›Das Gewissen wird sie stärker beißen ... Du kommst da nicht\ngegenan ...‹")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page212",
      "title": "lac/DaoH"
    }
  }), _vm._v(" Und als sie\nden Gemarterten ans Kreuz geschlagen hatten, setzte sich Burek hin\nund heulte ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("... Am zweiten Tag, als alle fortgegangen waren und weder die\nallerheiligste liebe Jungfrau noch die heiligen Apostel da waren\n... blieb nur noch Burek allein ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("... Er leckte immerzu die heiligen, mit Nageln durchbohrten,\nabsterbenden lieben Füße des Herrn Jesus und heulte ... und heulte\n... und heulte ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("... Und als schon der dritte Tag gekommen war ... erwachte Herr\nJesus und sieht, daß niemand mehr am Kreuze geblieben ist, nur\neinzig der Burek winselt kläglich und drückt sich dicht an seine\nFüße ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("... Da sah unser allerheiligster Herr Jesus Christus mitleidig\naus ihn herab in jener Stunde und sagte mit dem letzten Hauch:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("›Komm mit mir, Burek!‹")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("— — — — —")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und in diesem Augenblick ließ das Hündlein seinen letzten Atem\nund folgte dem Herrn.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Amen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»So war es, wie ich sagte, liebe Leute!« sprach er sanft, als er\nbeendigt hatte, bekreuzigte sich und ging auf die andere Seite, wo\nihm schon Anna seine Schlafstätte bereitet hatte, denn er war sehr\nermüdet.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Tiefes Schweigen lag über die Stube gebreitet, alle ließen sich\ndie seltsame Geschichte durch den Kopf gehen, und einige Madchen,\nwie Jagna, Fine und Nastuscha wischten sich ein paar heimliche\nTränen ab, so hatte sie das Los des Herrn und Bureks Abenteuer mit\nRührung erfüllt; und das schon allein, daß sich ein solcher Hund in\nder Welt fand, der besser und treuer unserm Herrn diente, als die\nMenschen, gab allen nicht wenig zu denken ... und sie fingen\nallmählich an, langsam verschiedene leise Bemerkungen zu machen und\nsich über diese Bestimmung Gottes zu wundern, bis Gusche, die\naufmerksam "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page213",
      "title": "lac/DaoH"
    }
  }), _vm._v("\nzugehört hatte, den Kopf erhob, höhnisch auflachte und sprach:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Eia popei, der Bauer pflückt Pflaumen und es sind ihrer zwei!\nIch werd' euch was Besseres sagen, wie der Mensch zum Ochsen\ngekommen ist:")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Es schuf Gott einen Stier,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nUnd der Stier war allhier,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nUnd der Bauer nahm ein Messer"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nUnd machte es besser."), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nHat ihm von unten abgeschnitten."), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nEin Ochse kam sich angeschritten ..."), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\n... Und der Ochs ist da,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nJu-hi-vallera.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Meine Wahrheit ist grad so gut, wie dem Rochus seine.« Sie fing\nan zu lachen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Auch alle in der Stube brachen in ein Gelächter aus und bald\nschwirrten Scherze, lustige Reden und verschiedene Erzählungen\ndurch den Raum.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gusche, die weiß alles ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Warum denn auch nicht, Witwe von drei Männern, da lernt man\nschon was.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Natürlich, der eine lehrte ihr was des Morgens mit dem\nPeitschenstiel ... der zweite mittags mit dem Riemen, und der\ndritte trieb's ihr oft abends mit der Runge ein ...,« schrie\nRaphus.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Einen vierten würd' ich auch noch heiraten, aber nicht dich,\ndenn du bist mir zu dumm und läufst mit einer Rotznase herum, wie\n'n Judenjunge.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wie es dem Herrn Jesus seinem Hund ohne Herrn erging, geradeso\nkann ein Frauenzimmer nicht ohne Prügel auskommen ... Der Gusche\nist dabei auch nicht gut zumut,« warf einer der Burschen ein.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Dumm bist du ... paß du nur auf, wenn du dem Vater seine\nQuärtchen zu Jankel trägst, daß dich niemand sieht, und die\nWitwenschaft laß mal in Ruh, das ist nichts für deinen Verstand,«\nknurrte sie ihn scharf an, daß sie allesamt "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page214",
      "title": "lac/DaoH"
    }
  }), _vm._v(" schwiegen, denn sie fürchteten, daß\nsie in der Wut alles laut sagen würde, was sie wußte, und sie\nkonnte eine Menge wissen. Ein eigensinniges Weib war sie, ein\nunverträgliches, und hatte über alles ihr Urteil fertig, und\nmanchmal ein solches, daß den Menschen ein Schauer über die Haut\nlief und die Haare sich sträubten, denn sie achtete nichts, nicht\nmal den Priester und die Kirche, so daß Hochwürden sie schon öfters\nermahnen mußte und ihr ans Herz legen, es nicht wieder zu\nvergessen. Das hatte aber nicht geholfen, und sie erzählte bann\nnoch obendrein im Dorf herum:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Auch ohne Priester findet jeder den Weg zum lieben Gott, wenn\ner nur ehrlich ist; es ist besser, er paßte auf seine\nWirtschafterin auf, denn sie läuft jetzt mit noch einem und wird\nwieder irgendwo was ablegen ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Das war Gusche ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie wollten schon auseinandergehen, als der Schulze mit dem\nSchultheiß eintraten. Sie gingen gerade von Hütte zu Hütte, um zu\nsagen, daß man morgen, laut Verordnung, auf dem Weg hinter der\nMühle zum Scharwerk zu kommen habe, denn die Regengüsse hätten die\nErde unterspült ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Kaum daß er eingetreten war, breitete der Schulze die Arme\nauseinander und rief:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Die besten Mädchen hat sich das alte Biest\nzusammengerufen!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Er hatte wahr gesprochen, denn es waren ja wirklich nur lauter\nHofbauerntöchter, von guter Abkunft und mit einer guten\nMitgift.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Denn Boryna war doch auch der erste im ganzen Dorf, sollte er\nsich denn da Dienstvolk und Kätnerinnen oder solche Armut, die zu\nzehnen an einem Kuhschwanz hängt, zusammenholen und zu sich\neinladen!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Der Schulze trat mit dem Alten beiseite, redete aber so leise,\ndaß niemand etwas hören konnte, schäkerte mit den Mädchen herum und\nging bald darauf, denn er hatte noch "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page215",
      "title": "lac/DaoH"
    }
  }), _vm._v(" die Hälfte des Dorfes für morgen\nzusammenzurufen. Es dauerte auch nicht mehr lange, daß sie alle\nauseinander gingen, da es spät war und Kohl zum Schälen fast schon\nfehlte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Boryna dankte allen und jedem einzeln, und was die älteren\nFrauen waren, so öffnete er ihnen die Tür und brachte sie vors Haus\n...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Aber Gusche sagte noch im Weggehen ganz laut:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gott bezahl's für die Bewirtung, aber ganz gut war es\nnicht.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hale! Na ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Eine Wirtin fehlt euch, Matheus, und ohnedem kann keine Ordnung\nsein ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ih du mein, was soll man machen, was soll man machen, ist schon\nGottes Fügung, daß sie gestorben ist ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gibt es denn wenig Mädchen! Jeden Donnerstag lauern sie doch im\nDorf, ob nicht zu irgendeiner Brautbitter von euch gehen ...,«\nsprach sie listig, um ihm die Zunge zu lockern. Boryna aber,\nobgleich er schon die Antwort fertig hatte, kratzte sich nur über\nden Kopf, lächelte und suchte unwillkürlich mit den Augen nach\nJagusch, die sich zum Gehen anschickte ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Darauf hatte schon Antek gelauert, er zog sich unmerklich an und\nging zuerst hinaus.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Jagusch ging allein nach Hause, denn die anderen wohnten auf der\nanderen Seite nach der Mühle zu.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Jagusch!« flüsterte er, sich in der Dunkelheit hinter\nirgendeinem Zaun hervorschiebend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie blieb stehen und erbebte, denn sie hatte seine Stimme\nerkannt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich werd' dich heimbringen, Jagusch!« Er sah sich um, die Nacht\nwar dunkel und ohne Sterne; der Wind brauste in den Lüften und fuhr\nüber die Baumkronen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Er umfaßte sie fest, und so aneinandergeschmiegt verschwanden\nsie in den Dunkelheiten.")]), _vm._v(" "), _c('ol', {
    staticClass: "calibre7"
  }, [_c('li', {
    staticClass: "calibre8"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0003#text6",
      "id": "foot6"
    }
  }, [_c('span', {
    staticClass: "pcalibre5 pcalibre4 footnote"
  }, [_c('span', {
    staticClass: "spaced"
  }, [_vm._v("Weltkugeln:")]), _vm._v(" Aus\nden geweihten, buntfarbenen Weihnachtsoblaten, die der Organist von\nHaus zu Haus herumschickt und die man am Weihnachtsabend vor der\nMahlzeit unter gegenseitigen Glückwünschen teilweise verzehrt,\nwerden von Dorfmädchen Kugeln geklebt, die man an bunten Fäden an\ndie Deckenbalken hängt. Diese Kugeln, die aus vier\nverschiedenfarbenen Teilen bestehen, nennt man Welten, Weltkugeln.\nWelten werden auch besonders kunstvoll aus Strohhalmen\nangefertigt.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "pcalibre6 initial1"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page216",
      "title": "lac/DaoH"
    }
  }), _vm._v("  Am nächsten Tag durchflog ganz\nLipce die Kunde von Borynas Versprechung mit Jagna.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Der Schulze war als Brautbitter gegangen/ darum lief die\nSchulzin, denn er hatte ihr strengstens verboten, auch nur einen\nHauch vom Munde zu lassen, bis daß er wiederkäme, erst um die\nVesperzeit zur Nachbarin, um sozusagen Salz zu borgen, und im\nWeggehen schon konnte sie nicht länger an sich halten, nahm die\nGevatterin auf die Seite und tuschelte ihr die Nachricht zu:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wißt ihr denn schon, Boryna hat zu Jagna mit Schnaps geschickt!\nAber nicht erzählen, der Meine hat es verboten.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ist nicht die Möglichkeit! Wo werd' ich denn mit der Zunge so\nherumlaufen! Bin doch kein Klatschmaul ... So 'n alter Kerl und\nmacht sich an die dritte Frau heran! Was werden bloß die Kinder\nsagen! Oh diese Welt!« stöhnte sie empört heraus.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und kaum war die Schulzin aus dem Haus, wickelte sie die Schürze\num und stürzte, vorsichtig Umschau haltend, durch den Obstgarten zu\nden Klembs, die nebenan wohnten, um eine Heedebürste zu borgen, da\nihre irgendwo weggekommen sei.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Habt ihr gehört! Boryna heiratet dem Dominik seine Jagna!\nGerade eben sind sie zu ihr mit Schnaps hin.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Nein!/was ihr nicht sagt! Wie sollte er denn, hat doch\nerwachsene Kinder und ist doch schon selbst in Jahren!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das schon, jung ist er nicht mehr, aber abschlagen werden sie\nihm nicht, nein, ein Hofbauer wie der und noch dazu so reich!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und dann die Jagna! Hat man so was gesehen! Mit dem ... und mit\nwem die sich wohl alles 'rumgetrieben hat ... und jetzt wird die\ndie erste Hofbäuerin sein! Das ist 'ne Gerechtigkeit in der Welt!\n... und wieviel Mädchen sind noch da ... wenn schon, ist da doch\nauch meiner Schwester ihre ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Oder meine Brudertochter! Und Kopschiwa seine, und "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page217",
      "title": "lac/DaoH"
    }
  }), _vm._v(" die andern und\nNastuscha! Sind die nicht auch Bauerntöchter, nett und\nreputierlich, was? ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wie die sich aufblasen wird! Geht ja schon jetzt wie 'n Pfau\nherum und steckt die Nase in die Luft.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das wird schon nicht ohne Gotteslästerung abgehen/ der Schmied\nund die anderen Kinder werden der Stiefmutter nichts schenken, was\nihnen zukommt, nein.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hale, werden sie da was machen können? Grund und Boden gehört\ndem Alten, sein Wille gilt da.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Dem Recht nach, versteht sich, versteht sich, aber was die\nGerechtigkeit ist, da ist doch auch den Kindern ihrs mit.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ih, du lieber Gott, Gerechtigkeit is da, wo das Geld is\n...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie ereiferten sich und klagten über den Lauf der Welt, dann\ngingen sie auseinander und mit ihnen kam die Neuigkeit wie eine\nFlut über das ganze Dorf.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und da nicht viel Arbeit zu tun war, und sonst nichts Wichtiges,\nund die Menschen in den Häusern herumsaßen, denn die Wege waren bis\nzum Grund aufgeweicht, so hatte man nichts Besseres zu tun, als die\nVersprechung in allen Häusern durchzunehmen. Das ganze Dorf war\nvoll Neugierde, wie das wohl ausgehen sollte; von vornherein wurden\nSchlägereien und Prozesse und Gott weiß was für Geschichten\nerwartet. Wieso denn, man kannte doch Borynas Heftigkeit, wenn der\nsich mal in was verbeißen würde, tät' er für Hochwürden selbst\nnicht davon ablassen; und was Antek sein Trotz war, da wußte man\nauch Bescheid.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Selbst die Menschen, die zum Scharwerk auf dem durchbrochenen\nDamm hinter der Mühle zusammengetrieben waren, blieben hier und da\nstehen und fingen an, über diesen Fall zu debattieren.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Der eine sagte was, der andere sagte was, bis schließlich der\nalte Klemb, der ein kluger und würdiger Bauer war, sich streng\nvernehmen ließ:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Da kommt noch was Schlimmes davon, fürs ganze Dorf, paßt nur\nauf.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page218",
      "title": "lac/DaoH"
    }
  }), _vm._v(" »Antek wird\nnicht Platz machen, wieso denn, noch ein neues Maul für die\nSchüssel,« sagte irgendeiner.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Dummes Zeug, bei Boryna reicht es auch für fünf/um den\nErbanteil geht es da.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ohne daß er ihr was verschreibt, wird das nicht abgehen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Die Dominikbäuerin ist nicht dumm, die wird schon allen was\neinrichten.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das ist die Mutter, da ist es ihr hundsverdammtes Recht, wenn\nsie für ihr Kind einsteht,« warf Klemb ein.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»In der Kirche sitzt sie nur immerzu und ist schlau auf die\nGroschen wie 'n Jude.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Red' nicht das erste beste von den Menschen, damit dir die\nZunge nicht steif wird.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und so befaßte sich das Dorf den ganzen Nachmittag mit der\nVersprechung, was auch kein Wunder war, denn die Borynas waren\nerbangesessene, alte Hofbauern; und Matheus war doch obenan in der\nGemeinde, wenn er auch kein Amt hatte. Wie sollte es denn auch\nanders sein, auf urewiger Bauernerde saß er, sein Ahn und Urahn\nhatten schon da gesessen, und Verstand hatte er und Reichtum hatte\ner auch/so daß sie alle, ob sie wollten oder nicht, auf ihn hören\nmußten und ihn hoch achteten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Nur keins von den Kindern, selbst der Schmied nicht, hatten noch\netwas von der Versprechung gehört, jedermann fürchtete, mit dieser\nNachricht zu ihnen zu laufen, um nicht im ersten Ärger etwas\nabzubekommen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("So war es denn bei Borynas noch still, selbst stiller heute noch\nwie gewöhnlich/der Regen hatte nachgelassen, und schon vom Morgen\nan begann der Himmel sich aufzuklären; darum war Antek mit Jakob\nund den Frauensleuten gleich nach dem Frühstück in den Wald\ngefahren, um Dürrholz für die Feuerung zu sammeln und zu versuchen,\nob es nicht möglich wäre, etwas Fichtenstreu zusammenzuharken.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Der Alte war zu Hause geblieben.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page219",
      "title": "lac/DaoH"
    }
  }), _vm._v(" Schon vom\nfrühen Morgen an war er seltsam unverträglich und eigentümlich\nmißgestimmt, so daß er nur nach einer Gelegenheit suchte, die\nUnruhe und das Gift, die in ihm gärten, auf jemanden abzuschieben;\nWitek hatte er schon durchgeprügelt, weil er vergessen hatte, den\nKühen frische Streu hinzuwerfen und weil sie bis zur Hälfte der\nFlanken im Mist lagen; mit Antek hatte er sich gezankt; Anna hatte\ner angeschrien wegen des Jungen, der auf allen Vieren vors Haus\ngekrochen war und sich über und über mit Schmutz besudelt hatte;\nselbst auf Fine hatte er losgehackt, daß sie allzulange trödelte\n... und die Pferde auf sie warteten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und als er schließlich allein mit Gusche zurückgeblieben war,\ndie seit gestern da war, um aufs Vieh zu sehen, da wußte er schon\ngar nicht mehr, was er mit sich anfangen sollte. Er brachte sich\nständig in Erinnerung, was ihm Ambrosius über den Empfang bei der\nDominikbäuerin erzählt hatte, und was Jagna gesagt hatte, trotzdem\nhatte er in sich nicht die rechte Sicherheit und glaubte dem Alten\nnicht recht, der für ein Glas Schnaps einen schon belügen konnte.\nEr kroch in der Stube herum, sah durchs Fenster auf den leeren Weg,\noder guckte unruhig von der Galerie sogar auf Jagusch ihr Haus/und\nerwartete das Dunkelwerden wie eine Erlösung ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Hundertmal hatte er Lust, nach dem Schulzen zu laufen, um sie zu\ntreiben, daß sie doch eher gingen/aber er blieb daheim, da die\nAugen Gusches, die überall hinter ihm her waren, ihn zurückhielten;\ndas waren zusammengekniffene Augen, die voll Hohn leuchteten und\nsich lustig machten ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das Hexenaas dreht mit ihren Glotzen an einem herum, wie mit\neinem Bohrer!« dachte er.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Gusche aber machte sich in Haus und Hof mit dem Wocken unter dem\nArm zu schaffen und sah sich fleißig um, sie spann, daß die Spindel\nin der Luft surrte, wickelte den Faden auf und ging weiter, zu den\nGänsen, zu den Schweinen/ nach dem Kuhstall, und Waupa trottete\nschläfrig und "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page220",
      "title": "lac/DaoH"
    }
  }), _vm._v("\nträge hinter ihr her. Sie redete den Alten nicht an, obgleich sie\ngut wußte, was ihn so mitnahm und mißmutig machte, und ihn so\numhertrieb, daß er sich sogar entschloß, die Pflöcke an der\nHauswand einzuschlagen, die den Winterbelag der Wände stützen\nsollten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie blieb nur immer wieder bei ihm stehen und sagte\nschließlich:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Die Arbeit geht euch heut nicht gut vonstatten.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ja, sie geht nicht. Gottverdamm mich! Sie geht nicht ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das wird hier noch 'ne Hölle geben, du lieber Jesus, das wird\nwas geben!« dachte sie im Weitergehen. »Der Alte hat recht, ganz\nrecht, daß er heiratet! Sonst würden ihm die Kinder so ein\nAltenteil geben, wie meine mir!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ganze zehn Morgen Feld hab' ich weggegeben, wie reines Gold,\nund was hab' ich davon?« ... Sie spie aus vor Wut. »Lohnarbeit muß\nich tun, zu einer Kätnerin bin ich heruntergekommen! ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Der Alte aber, der nicht länger an sich halten konnte, schmiß\ndie Art zu Boden und rief aus:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Für den Hund ist solche Arbeit!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Es sitzt euch was innen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Es sitzt, es sitzt ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Gusche setzte sich auf die Wandbank, spann einen langen Faden,\nwickelte ihn auf die Spindel und sagte leise, etwas ängstlich:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ihr habt doch keinen Grund, euch zu verdrießen und zu\nsorgen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wißt ihr's denn?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Habt keine Angst, die Dominikbäuerin ist klug und Jagna hat\nauch ihren Verstand.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Meint ihr!« rief er freudig und setzte sich zu ihr.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wieso denn, meine Augen hab' ich doch.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie schwiegen lange, sich gegenseitig hinhaltend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ladet mich zur Hochzeit ein, dann werd' ich euch ein solches\nHopfenlied "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0003#foot7",
      "id": "text7"
    }
  }, [_c('sup', {
    staticClass: "calibre6"
  }, [_vm._v("F7")])]), _vm._v(" singen,\ndaß gleich in neun Monaten "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page221",
      "title": "lac/DaoH"
    }
  }), _vm._v(" Taufe ist ...,« fing sie spöttisch an; aber da sie\nmerkte, daß der Alte finster wurde, warf sie in einem anderen Tone\nhin:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Recht tut ihr schon, Matheus, das ist gewiß. Hätt' ich mir\ndamals einen genommen, als der Meine gestorben war, dann ständ' ich\nheute nicht wie 'ne Kätnerin da, nein ... Dumm war ich, habe den\nKindern vertraut, bin auf den Altenteil gegangen, habe ihnen meinen\nGrund und Boden abgeschrieben, und was denn nu? ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich schreib' nicht eine einzige Feldparzelle ab!« sagte er\nhart.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ihr habt Vernunft, daß ihr so redet, das habt ihr! Auf den\nGerichten habe ich mich herumschleppen müssen, da sind mir noch die\npaar Silberlinge, die ich hatte, draufgegangen, und Gerechtigkeit\nhabe ich mir doch nicht damit gekauft ... und für die alten Tage\nbin ich auf Lohnarbeit und auf Herumgestoßensein angewiesen! Daß\ndies Aaszeug unterm Zaun verreckt für das, was sie mir angetan.\nSonntag bin ich hingegangen, um doch wenigstens das Haus mal zu\nsehen und den Fruchtgarten, wo ich die Bäume noch alle selbst\ngepfropft habe/da hat die Schwiegertochter das Maul auf mich\nlosgelassen, daß ich da spijenieren hingekommen bin. Du lieber Herr\nJesus! Zum Spijenieren auf meinem eignen Grund und Boden! Ich\ndachte, ich sollte gleich totfallen, so hat mich das abgewürgt! Zu\nHochwürden bin ich gewesen, wenn schon nicht anders, daß er sie von\nder Kanzel 'runtermacht, da hat er mir gesagt, daß der Herr Jesus\nmich für dieses Unrecht belohnen wird! Natürlich, natürlich ...\nwenn einer nichts hat, dann ist er gut für die Gnade vom Jesus, so\nist es schon ... aber immerhin hätt' ich lieber gemocht auf meinem\nGrund und Boden herumzuwirtschaften, in der warmen Stube unterm\nFederbett zu schlafen, fette Sachen zu essen und amesieren ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und sie begann mit einem solchen Feuereifer auf alles zu\nschimpfen, daß Boryna aufstand und fortging ins Dorf zum Schulzen\nhin, da es ja auch schon schummerig wurde.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page222",
      "title": "lac/DaoH"
    }
  }), _vm._v(" »Geht ihr\ndenn bald, was?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»In diesem Augenblick noch, Simeon muß schon kommen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Er kam auch gleich, und sie gingen zusammen zur Schenke, um ein\nGläschen zu trinken und Arrak zum Brauttraktament mitzunehmen.\nAmbrosius war schon da und schloß sich ihnen an, aber sie tranken\nnur kurz, denn Matheus trieb sie an.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich werde hier auf euch warten; und wenn sie euch Bescheid\ntrinken, dann bringt die Frauen gleich mit her,« rief er noch\nhinterdrein.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie stapften so kräftig mittwegs vorwärts, daß der Schmutz nur\nso aufsprang; die Dämmerung verdichtete sich und umhüllte die Welt\nmit einem grauen, traurigen Gewebe, unter dem das ganze Dorf\nversunken lag; nur hier und da begannen aus den Dunkelheiten die\nLichter auszublitzen, und die Hunde fingen auf den Heckenwegen an\nzu bellen, wie gewöhnlich vor der Abendmahlzeit.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gevatter?« ließ sich nach einer Weile der Schulze\nvernehmen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Häh?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Mir deucht, Boryna wird 'ne feine Hochzeit herrichten?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Herrichten, oder nicht herrichten!« sagte der andere hämisch,\ndenn er war von Natur aus ein Nörgler.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Er wird schon eine herrichten! Der Schulze sagt euch das, da\nkönnt ihr's mir glauben. Wir werden schon aus ihnen ein solches\nPaar drehen; haha, ihr werdet sehen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Nur daß die Stute noch durchgehen wird, denn der Hengst, deucht\nmir, hat schon Hanf im Schweif!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das ist nicht eure Sache.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hale ... Die Kinder werden auf uns fluchen ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Es wird schon alles sein werden, das sag' ich euch, als\nSchulze.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie traten gleich darauf ins Haus der Dominikbäuerin ein.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page223",
      "title": "lac/DaoH"
    }
  }), _vm._v(" Die fein\nsauber gefegte Stube war schon erleuchtet/denn man erwartete sie\ndoch.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Brautbitter gaben Gott zum Gruß, nickten allen Anwesenden\nzu, auch den Jungen, die in der Stube waren, setzten sich auf die\nan's Herdfeuer gerückten Stühle und fingen von diesem und jenem an\nzu reden.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Eine Kälte ist das, als ob's schon zum Frost ginge,« begann der\nSchulze das Gespräch und wärmte sich die Hände.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Na, natürlich, zum Frühjahr geht's ja auch nicht, da kann man\nsich nicht wundern!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Habt ihr schon den Kohl eingefahren, was?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ih ... etwas ist da auf dem Kohlfeld nachgeblieben, aber jetzt\nkann man ja nicht 'ran,« antwortete die Alte gelassen und folgte\nmit den Augen der Jagna, die am Fenster das Garn auf eine Weise\ndoppelfädig haspelte und heut so wohlgeraten aussah, daß der\nSchulze, noch ein junger Mann, sie mit begehrlichen Augen ansah/und\nschließlich dergestalt anknüpfte:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Da es so schlimmes Wetter und solch ein Schmutz und solche\nDunkelheit ist, so sind wir, ich und der Simeon, vom Wege zu euch\neingekehrt; ihr habt uns würdig empfangen, mit gutem Wort\nbewirtet/so wollen wir von euch denn etwas einhandeln, Mutter\n...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»In der Welt kann man dies und jenes einhandeln, nur muß man\nsich umtun danach ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wahr habt ihr geredet, Mutter; doch ist es uns nicht danach,\nuns umzutun, denn bei euch, dünkt uns, sind wir am rechten\nOrt.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Handelt man los,« rief sie vergnügt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Eine Färse würden wir so zum Beispiel vielleicht wollen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ho, ho! Die steht hoch im Preis; am ersten besten Schnürchen\nwird sie schon nicht fortgeführt!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Aus geweihtem Silber bringen wir ein Schnürchen für sie mit und\naus solchem, daß selbst ein Drache das nicht zerreißen "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page224",
      "title": "lac/DaoH"
    }
  }), _vm._v(" könnte. Na, wieviel\ndenn, Mutter?« Und er fing an, die Flasche aus der Tasche\nherauszuziehen ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wieviel? Das ist nicht leicht zu sagen! Jung ist die noch, aufs\nneunzehnte Frühjahr geht's ihr erst, und gut und arbeitsam, daß sie\nnoch paar Jahr bei der Mutter bleiben könnte ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ein müßiges Bleiben ist das/da kommt kein Zuwachs raus, das ist\nein müßiges Bleiben ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Manch eine könnt' ihn auch leicht bei der Mutter schon haben!«\nmurmelte Simeon.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Der Schulze lachte schallend auf, und die Alte blitzte nur mit\nden Augen und sagte rasch:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Sucht euch eine andere, meine kann warten.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Natürlich kann sie das, aber wir finden keine schmuckere und\nvon keiner besseren Mutter!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Meint ihr! ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich, der Schulze, sag es euch, da müßt ihr es glauben.« Er\nholte ein Glas hervor, wischte es mit dem Rockschoß aus, goß Arrak\nein und sagte ernst: »Hört aufmerksam zu, Dominikbäuerin, was ich\neuch sagen werde; ein Beamter bin ich, und mein Wort ist nicht wie\nso 'n Vöglein, das hier mal pfeift und da mal piukt, und hast du\nnicht gesehen! Und Simeon, das weiß man auch, wer der ist/kein\nLandstreicher doch nicht, aber ein Hofbauer, Vater von Kindern und\nSchultheiß! ... Versteht ihr, was für 'ne Personage zu euch\ngekommen ist und wozu sie gekommen sind, versteht ihr das?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich versteh' schon recht, Peter, und weiß schon.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Eine kluge Frau seid ihr, da wißt ihr, daß die Jagusch früher\noder später mal aus dem Hause muß und auf ihr Eigenes, so hat es\nschon Herr Jesus bestimmt, und die Eltern ziehen die Kinder für die\nWelt groß, nicht für sich.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das ist schon wahr, wahr, und du, Mutter/")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Hüte, hege, pflege ..."), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nUnd rück' noch Geld heraus."), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nNimmt sie dir einer aus dem Haus!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page225",
      "title": "lac/DaoH"
    }
  }), _vm._v(" »So ist es\nschon in der Welt, das wird man auch nicht ändern. Vielleicht\ntrinken wir uns einen Tropfen zu, was, Mutter?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Was weiß ich denn? ... Zwingen werd' ich sie nicht, was,\nJagusch, willst du ihm Bescheid trinken? ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ih ... wie weiß ich ...,« pipste Jagna auf, das gerötete\nGesicht zum Fenster abdrehend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gehorsam ist sie! Ein demütiges Kalb, wird von zwei Müttern\ngesäugt ...,« warf Simeon ernst bei.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»In eure Hände, Mutter!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Trinkt in Gottes Namen; aber ihr habt noch nicht gesagt, wer es\nist:« sagte sie, da es nicht schicklich war, im voraus und aus\neinem anderen Munde, als dem der Brautbitter, darüber Bescheid zu\nwissen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wer? Der Boryna selbst doch!« rief er, das Glas\nherunterstürzend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ein alter Witwer!« rief sie wie enttäuscht zurück.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Alt! Beleidigt doch nicht den Herrgott! Alt, und hatte doch vor\nkurzem noch eine Gerichtssache wegen Alimente!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das ist wahr, aber es war doch nicht seins.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wie sollte er auch, ein solcher Hofbauer und sich mit der\nersten besten einlassen! Trinkt Mutter ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Trinken würd' ich schon, aber weil es doch man 'n Witwer ist,\nund ein Alter ist ja näher dran, bei Abraham sein Bier trinken zu\nmüssen, und was dann? ... Die Kinder werden die Stiefmutter\n'rausjagen und ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Matheus sagte, daß eine Verschreibung wohl sein müßte,« brummte\nSimeon.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Vor der Hochzeit wohl noch!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Brautbitter verstummten; erst nach einer Weile goß der\nSchulze ein neues Glas voll und wandte sich damit nach Jagna.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Trink' mal, Jagusch, trink' mal! Einen Eh'mann freien wir dir\nzu, der ein Mann wie eine Eiche ist, Herrin wirst "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page226",
      "title": "lac/DaoH"
    }
  }), _vm._v(" du sein, Hofbäuerin, die erste\nim Dorf; nu, komm' mal, in deine Hände, Jagusch, brauchst dich\nnicht zu schanieren ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie zögerte, wurde rot und drehte sich zur Wand hin; doch\nschließlich, nachdem sie ihr Gesicht mit der Schürze verdeckt\nhatte, trank sie einen kleinen Schluck und schüttete den Rest zu\nBoden ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Danach machte das Glas die Runde von einem zum andern. Die Alte\nbot Brot und Salz an und gab noch schließlich geräucherte Dörrwurst\nals Beigabe zum Schnaps.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie tranken ein paarmal der Reihe nach, daß ihnen allen die\nAugen sich aufhellten und die Zungen locker wurden. Nur Jagna lief\ndavon nach ihrer Kammer, denn ein Weinen hatte sie gepackt, sie\nwußte selbst nicht, warum; man konnte durch die Wand hindurch ihr\nSchluchzen hören.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Alte wollte zu ihr laufen, aber der Schulze hielt sie\nzurück.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Auch das Kalb blökt, wenn man es von der Mutter absetzt ... die\nSache kennt man. Nicht in die Welt geht sie doch, nicht in ein\nanderes Dorf, da werdet ihr euch noch dran freuen können ... Kein\nUnrecht wird ihr passieren, ich, der Schulze, sag' es euch/glaubt\nmir ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das schon ... nur habe ich immer gedacht, daß ich noch\nEnkelkinder erleben sollte, zur Freude auf die alten Tage ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Da sorgt euch nicht darüber, eh' noch die Ernte anfängt, werdet\nihr schon den ersten haben ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das weiß nur der Herr Jesus voraus, nicht wir schuldigen\nMenschen! Getrunken haben wir, das ist schon wahr ... aber mir ist\nso sonderlich schwer ums Herz, wie bei einem Begräbnis ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Is auch kein Wunder, die einzige Tochter im Haus, da ist euch\nnoch ihr schon gleich bange ... Noch ein Schluck gegen den Kummer!\nWißt ihr was, wir gehen mitsammen zur Schenke, denn mir ist schon\nder Branntwein ausgegangen und der Herr Bräutigam sitzt da und hat\nschon Kohlchen unterm Hintern.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page227",
      "title": "lac/DaoH"
    }
  }), _vm._v(" »Sollen wir\ndenn in einer Schenke Verlobung feiern?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Nach alter Sitte, wie es unsere Väter taten, ich der Schulze\nhab' es euch gesagt/dann glaubt.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Frauen zogen sich etwas festlicher an und bald gingen sie\nalle zum Hause hinaus.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und die Jungen sollen denn die nicht mit? Der Schwester ihre\nVerlobung ist für die doch auch ein Fest,« bemerkte der Schulze, da\ndie Burschen traurige Gesichter machten und unruhig auf die Mutter\nblickten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Es ist schwer, das Haus nur Gottes Vorsehung zu\nüberlassen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ruft doch die Agathe von den Klembs, die wird schon hier\neinhüten.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Agathe, die ist schon auf den Bettel gegangen. Man wird\njemanden unterwegs auffinden. Kommt nur, Jendschych, und du auch,\nSchymek, zieht die Kapottröcke an; was denn, wollt ihr denn wie die\nLumpen gehen ... und wenn sich mir einer betrinkt ... dann soll er\nwas erleben. Die Kühe sind noch nicht besorgt, für die Schweine\nmüssen noch die Kartoffeln zerstoßen werden/denkt daran.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wir denken, Mutter, wir denken!« flüsterten sie ängstlich,\nobgleich sie schon lange Kerle bis fast an die Decke heran waren\nund breit gewachsen, wie Birnbäume auf den Feldrainen, aber sie\ngehorchten der Mutter, wie Halbwüchsige, weil sie sie mit eiserner\nHand an den Schöpfen hielt, und wenn es nötig war, ihnen selbst mal\nüber die Sitzgegend fuhr und nach den Zotteln langte oder\nMaulschellen austeilte; aber Gehorsam und Achtung, das mußte\nsein.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie gingen nach der Schenke.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Es war schon dunkle Nacht, daß man keine Hand vor Augen sah, wie\ngewöhnlich in der Herbstregenzeit. Der Wind ging oben in den Lüften\nund schlug auf die Kronen der Bäume ein, daß sie sich schüttelten\nund aufrauschend auf die Zäune legten; der Weiher brauste und warf\nsich so hin und her, daß zu Gischt zerstobene Spritzer auf die\nMitte "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page228",
      "title": "lac/DaoH"
    }
  }), _vm._v(" des\nWeges flogen und nicht selten den Gehenden ins Gesicht\npeitschten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Schenke war auch nicht sehr hell, der Wind blies durch eine\nkleine eingedrückte Scheibe und ließ das Lämpchen, das an einer\nSchnur über dem Schenktisch hing, hin und her schaukeln, wie eine\ngoldene Blume.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Boryna stürzte ihnen entgegen, um sie zu begrüßen und umarmte\nund küßte sie mit plötzlicher Wärme, da er merkte, daß Jagusch\nschon so gut wie sein war.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und Herr Jesus sagte: nimm dir armes Erdenwurm ein\nFrauenzimmer, damit dir armseligem Tropf die Zeit nicht über werde\ndahiero. Amen!« lallte Ambrosius, der schon über eine Stunde\ngetrunken hatte und nun natürlich mit der Zunge und auf den Beinen\nnicht sicher war.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Der Jude stellte also gleich Arrak, süßen Schnaps und Essenz auf\ndie Tonbank, dazu Heringe, einen Safrankuchen und irgendwelche\nseltsame Brezelchen mit Mohn.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Eßt, trinkt, liebe Leute, leibliche Brüder, treue\nChristenmenschen!« forderte Ambrosius auf. »Ich hatte auch mal eine\nFrau, nur ich weiß schon gar nicht mehr wo ... in Frankreich glaub'\nich ... nein, in Italien war es, nein ... jetzt aber bin ich eine\nalleinstehende Waise ... Ich sag' euch, rief da mal der Korporal:\nSchließt euch zusammen!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Trinkt mal, Leute! Fangt an, Peter,« unterbrach ihn Boryna, der\nfür einen ganzen Silberling Karamelbonbons brachte und sie Jagna in\ndie Faust drückte. »Da, Jagusch, fein süß sind sie, da.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hale ... ihr macht euch Schaden ...,« zierte sie sich.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Fürcht' dich nicht ... ich kann's mir leisten, du wirst selbst\nsehen ... da ... für dich würd' ich selbst Vogelmilch finden ... du\nwirst schon bei mir nichts auszustehen haben ...« ... und er fing\nan, sie um die Taille zu fassen und sie zum Essen und Trinken\naufzufordern. Jagna nahm alles ruhig, kalt und gleichgültig an, als\nob es nicht ihre Verlobung heute wäre. Nur an eines hatte sie\ngedacht, ob der Alte "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page229",
      "title": "lac/DaoH"
    }
  }), _vm._v(" wohl die Korallenschnüre, von denen er auf dem\nJahrmarkt gesprochen hatte, noch vor der Hochzeit hergeben\nwürde.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie fingen an, die Gläser dicht hintereinander zu leeren, Arrak\nund Süßen umschichtig, und alle sprachen auf einmal, selbst die\nDominikbauerin hatte sich einen Ordentlichen angetrunken, und nu\nmal schlankweg allerhand Verschiedenes auseinandergesetzt und\nlosgeredet, so daß der Schulze sich wunderte, was für eine kluge\nFrau sie doch wäre.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Auch die Söhne hatten einen Festen sitzen, denn Ambrosius und\nder Schulze tranken ihnen häufig zu und forderten sie auf.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Trinkt, Jungen, ist doch Jagnas Versprechung, trinkt ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wir wissen, wir wissen,« antworteten sie zugleich und wollten\nAmbrosius die Hand küssen. Schließlich zog die Dominikbäuerin\nBoryna nach dem Fenster beiseite und sagte ohne Umschweife:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Sie ist euer/die Jagusch, Matheus, euer.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gott lohn's euch für die Tochter, Mutter.« Er griff sie um den\nHals und küßte sie.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ihr habt doch versprochen, eine Verschreibung zu machen,\nwas?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Verschreibung! Wozu Verschreibung, was mein ist, das ist auch\nihres ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hale, damit sie doch ein mutiges Auge hat vor den Stiefkindern,\ndaß sie sie nicht beschimpfen!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Die sollen sich bloß hüten! Alles ist mein, da ist es auch der\nJagusch ihr eigen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gott bezahl's euch, aber merkt zu, etwas älter seid ihr doch,\nund jeder ist doch sterblich, denn")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Der Tod wählt nicht lang,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nNimmt hier einen Menschen/da ein Lamm"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nUnd morgen/bist selbst du nicht geborgen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Noch bin ich rüstig, an die zwanzig Jahr halt' ich noch aus,\nfürchtet euch nicht!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Den Fürchtenicht haben die Wölfe gefressen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page230",
      "title": "gary/DaoH"
    }
  }), _vm._v(" »Ich freu'\nmich so, sagt, was ihr möchtet! Soll ich euch die drei Morgen neben\nLucas seinen abschreiben?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»'ne Fliege ist dem Hund noch recht, wenn er hungrig ist/ wir\nsind nicht hungrig. Jagusch fallen vom Vater her fünf Morgen zu und\nwohl ein Morgen Wald ... verschreibt ihr auch sechs Morgen; die\nsechs Morgen am Weg, wo ihr dieses Jahr Kartoffeln hattet.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Mein bestes Feld!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ist vielleicht die Jagusch ein Ausschuß und nicht die Beste im\nDorf!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Natürlich, das ist sie, darum Hab' ich ja auch die Brautbitter\ngeschickt; aber, mein Gott, sechs Morgen, das ist ein mächtiges\nStück Land, eine ganze Wirtschaft. Was würden die Kinder dazu\nsagen!« Er fing an, sich auf dem Kopf zu kratzen, denn es hatte ihn\nganz schmerzhaft gepackt; wie denn auch, so viel von der besten\nErde herzugeben!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ih du meine Güte, ihr seid doch auch klug, so leicht findet man\nkeinen zweiten wie ihr, ihr müßt doch selbst begreifen, daß eine\nVerschreibung nur da ist, um das Mädchen sicherzustellen. Es wird\neuch doch euer Leben lang von diesem Boden keiner etwas abmessen\nund nehmen; und was Jagusch ihres ist, was ihr dem Recht nach vom\nVater zukommt, da wird man gleich zum Frühjahr einen Dmeter\nbestellen und das ist dann schon euer, da könnt ihr schon säen ...\nBegreift ihr, daß es nicht euer Nachteil ist, und die sechs Morgen\nwerdet ihr abschreiben.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Versteht sich, für Jagusch schreib' ich sie ab ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wann denn?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Kann auch morgen sein! Nein, Sonnabend bestellen wir das\nAufgebot und fahren gleich nach der Stadt. Was da, einmal muß die\nZiege sterben!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Jagusch, komm mal, Töchterchen, komm!« rief sie dem Mädchen zu,\ndem der Schulze etwas auseinandersetzte und sie dermaßen an die\nTonbank drängte, daß sie aus vollem Halse lachte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page231",
      "title": "gary/DaoH"
    }
  }), _vm._v(" »Da\nverschreibt dir der Matheus die sechs Morgen am Weg,« sagte\nsie.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gott bezahl's euch,« murmelte sie, ihm die Hand\nhinstreckend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Trinkt mal Jagna von diesem Süßen zu ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie tranken aus, Matheus faßte sie um und war im Begriff, sie\nden Leuten vorzuführen, aber sie entglitt ihm und trat an die\nBrüder heran, mit denen Ambrosius reformierte und trank.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("In der Schenke erhob sich ein immer größeres Stimmengewirr, und\nes wurde immer voller, denn dieser und jener, der die Stimmen\ndrinnen horte, trat herein, um nachzusehen, und manch einer\nwiederum, um bei dieser Gelegenheit sich auf fremde Kosten einen zu\nleisten; selbst der blinde Bettler, der sich vom Hund führen ließ,\nfand sich ein und saß auf einer sichtbaren Stelle, horchte herum\nund betete ein ums andere Mal laut und vernehmlich, bis sie ihn\nmerkten. Die Dominikbäuerin ging selbst zu ihm hin mit Schnaps und\nEssen und drückte ihm ein paar Kupfermünzen in die Faust.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie hatten sich einen Tüchtigen angetrunken, so daß schon alle\ndurcheinander redeten, einander auf die Schultern klopften, sich\numfaßten und küßten, und ein jeder war dem andern Bruder und\nFreund, wie gewöhnlich, wenn die Gläser dicht nacheinander\nfolgen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Nur der Jude machte sich leise zu schaffen und stellte immer\nneue Maße und Bierflaschen hin und schrieb mit Kreide an die Tür,\nwas jeder spendierte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und Boryna war vor Freude wie benebelt, trank, traktierte,\nforderte auf, redete, wie man ihn selten reden gehört hatte und\nstrebte in einen fort nach Jagusch hin, sprach verliebtes Zeug auf\nsie ein, strich ihr ums Mäulchen, und da es sich nicht schickte in\naller Leute Gegenwart sie zu umhalsen und abzuküssen, obgleich es\nihn mächtig danach gelüstete, so faßte er sie nur immer wieder um\ndie Taille und zog sie in eine dunkle Ecke.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page232",
      "title": "gary/DaoH"
    }
  }), _vm._v(" Die\nDominikbäuerin hatte sich bald besonnen, daß es schon Zeit war,\nnach Hause zu gehen, und begann die Söhne zu rufen, sich bereit zu\nhalten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Schymek aber war schon regelrecht besoffen, so daß er auf die\nReden der Mutter nur den Gurt zurechtrückte, mit der Faust auf den\nTisch lostrommelte und schrie:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ein Hofbauer bin ich, hundsverdammt noch mal ... Wer Lust hat,\nder kann gehen ... Will ich trinken, dann werd' ich trinken ...\nJude, Schnaps her!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Still, Schymek, still, sonst wird sie dich durchprügeln!«\njammerte Jendschych mit weinerlicher Stimme, er war auch schon\nstark angetrunken, und hielt den Bruder am Kapottrock zurück.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Nach Hause, Burschen, nach Hause!« zischte die Dominikbauerin\ndrohend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ein Hofbauer bin ich! Wenn ich bleiben will, dann bleib' ich\nund werde Schnaps trinken ... genug schon der mütterlichen\nRegiererei ... und will sie nicht ... dann schmeiß' ich 'raus,\nhundsverdammt noch mal ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Doch die Alte schlug ihn vor die Brust, daß es schallte; er kam\nins Wanken und wurde nüchtern; Jendschych setzte ihm die Mütze auf\nund führte ihn hinaus. Die Luft hatte Schymek augenscheinlich\nwieder benebelt, denn kaum war er ein paar Schritte gegangen,\ntorkelte er, klammerte sich an den Zaun und fing an zu schreien und\nzu skandalieren.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ein Hofbauer bin ich, hundsverdammt noch mal ... mein ist der\nGrund und Boden ... was mir paßt ... mache ich ... Branntwein\ntrink' ich ... Jude, Arrak her ... und will sie nicht ... schmeiß'\nich 'raus ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Schymek! Um Gottes willen, Schymek, komm nach Hause, die Mutter\nkommt schon!« jammerte Jendschych, und weinte helle Tränen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Bald darauf kam auch die Alte mit Jagna und nahm die Söhne mit,\ndie sich inzwischen schon in die Haare gefahren waren und sich am\nZaun im Schmutz herumprügelten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page233",
      "title": "gary/DaoH"
    }
  }), _vm._v(" In der\nSchenke wurde es, nachdem die Frauen gegangen waren, etwas stiller,\ndie Leute gingen langsam auseinander, so daß nur Boryna mit den\nBrautbittern zurückblieb, außerdem noch Ambrosius und der Bettler,\nder nun auch mittrank.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Ambrosius war schon gar nicht mehr bei Besinnung, stand mitten\nin der Stube, sang und erzählte laut vor sich hin.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Schwarz war er ... so schwarz wie ein Kochtopf ... er zielte\nauf mich ... aber kannst mich wo treffen ... das Bajonett hab' ich\nihm in den Bauch gerannt ... 'rumgedreht hab' ich, daß es nur\ngeknackt hat ... das war der erste! ... Wir stehen ... und stehen,\nda kommt der Kapitän angesetzt ... Jesus Christus! Der Kapitän\nselbst! ... Jungens ... sagt er ... Leute ... sagt er.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Schließt zusammen! ... Schließt zusammen! ...« schrie er mit\neiner gewaltigen Stimme, reckte sich kerzengerade und ging langsam\nzurück und der Holzfuß stieß auf/»trinkt mir zu, Peter, trinkt ...\neine arme Waise bin ich ...« lallte er undeutlich von der Wand her,\nan der er lehnte; er wartete aber nicht mehr ab, sondern sprang\ngleich auf und ging hinaus /nur vom Weg aus drang seine heisere\nStimme herüber, denn er hatte zu singen begonnen ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("In die Schankstube trat der Müller, ein gewaltiger Kerl in\nstädtischer Kleidung, mit rotem Gesicht, weißhaarig und mit\nkleinen, flinken Äuglein!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Die Hofbauern trinken sich einen! Ho, ho, der Schulze und der\nSchultheiß und Boryna! 'ne Hochzeit oder was!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Nichts anderes. Trinkt einen mit uns, Herr Müller, trinkt,«\nschlug Boryna vor.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wenn das so ist, kann ich euch eine Neuheit sagen, daß ihr mit\neinem Male nüchtern sein werdet!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie starrten ihn mit geistesabwesenden Augen an.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Nicht einmal eine Stunde ist es her, daß der Gutsherr den Hau\nin der Wolfsschlucht verkauft hat!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Dieser Gauner, hundsverflucht! ... Verkauft, unsern "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page234",
      "title": "Konmax/DaoH"
    }
  }), _vm._v(" Wald verkauft!«\nschrie Boryna auf und schleuderte außer sich die erste beste\nFlasche zu Boden.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Verkauft hat er! Das Recht ist auch für den Gutsherrn, und für\njeden ist das Recht...,« lallte der völlig betrunkene Simeon.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das ist nicht wahr! Ich, der Schulze sag' es euch, daß es nicht\nwahr ist, dann glaubt's!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Verkauft kann er ihn haben, nur daß wir ihn nicht hergeben, so\nwahr ein Gott im Himmel ist, geben tun wir ihn nicht!« rief Boryna\nund hämmerte mit der Faust auf den Tisch ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Der Müller ging davon, sie aber beratschlagten noch bis tief in\ndie Nacht hinein und drohten nach dem Herrenhof hinüber.")]), _vm._v(" "), _c('ol', {
    staticClass: "calibre7"
  }, [_c('li', {
    staticClass: "calibre8"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0003#text7",
      "id": "foot7"
    }
  }, [_c('span', {
    staticClass: "pcalibre5 pcalibre4 footnote"
  }, [_c('span', {
    staticClass: "spaced"
  }, [_vm._v("Das\nHopfenlied:")]), _vm._v(" Ein uraltes polnisches, recht anzügliches und\nderbes Hochzeitslied, das der Braut nach der Trauung von älteren\nverheirateten Frauen gesungen wird. Es ist ein an ausgelassensten\nVarianten reicher Chorus der Erfahrenen, die sich in allerlei\nRatschlägen und gepfefferten Enthüllungen ergehen.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "pcalibre6 initial1"
  }, [_vm._v("Ein paar Tage waren vergangen,\nseit Jagusch versprochen war.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Regenfälle hatten aufgehört, die Wege waren angetrocknet und\netwas froststeif geworden, das Wasser hatte sich verlaufen, so daß\nnur in den Ackerfurchen, hier und da in den Niederungen und auf den\nMooren trübe Lachen, wie verweinte Augen, glasten ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Allerseelen kam, grau, sonnenlos und tot, nicht einmal der Wind\nwühlte in den vertrockneten Stauden, und schüttelte die Bäume\nnicht, die schwer über die Erde gebeugt dastanden ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Eine schmerzliche, dumpfe Stille lastete auf der Welt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und in Lipce tonten schon vom Morgen an die Glocken langsam und\nunaufhörlich/leidschwere, klagende Töne begannen über den im Nebel\nliegenden, leeren Feldern aufzustöhnen, und riefen mit düsterer\nTrauerstimme in den trüben Tag hinein/in jenen Tag, der sich blaß\nerhoben hatte, in Nebel verhüllt bis weit in die unerreichbaren\nFernen, bis weit in jene Grenzenlosigkeit des Himmels und der\nErde/dunstblau, wie eine unergründliche Wassertiefe.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page235",
      "title": "Konmax/DaoH"
    }
  }), _vm._v(" Von der\nMorgenröte im Osten her, die noch blaß glimmte, wie gerinnendes\nKupfer, begannen unter den blaugrauen Wolken hin Schwärme von\nDohlen und Krähen dahinzuflitzen ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie zogen hoch, hoch, daß man sie kaum mit dem Auge erkennen\nkonnte, daß man kaum mit dem Ohr dieses wilde, klagende Gekrächze\nund Geschrei unterscheiden konnte, das dem Gestöhn der Herbstnächte\nähnlich war.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und die Glocken läuteten immerzu.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Der düstere Hymnus ergoß sich schwer in die tote, stumpfe Luft,\nsank in Klagelauten auf die Felder nieder, dröhnte trauervoll durch\ndie Dörfer und Wälder/floß durch die ganze Welt, so daß Menschen,\nFelder und Dörfer nur ein einziges großes Herz zu sein schienen, in\ndem wehmütige Klage pochte ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Vögelzüge fluteten in einem fort dahin; Staunen und Angst\nerweckte ihr Anblick, denn sie zogen immer tiefer und in immer\ngrößeren Schwärmen, so daß sie auf dem Himmel wie verwehte\nRußflocken zu sehen waren; das dumpfe Rauschen ihrer Flügel und\nihrer Rufe steigerte sich, wurde mächtiger und brauste wie ein\nnahender Sturm ... Sie kreisten über dem Dorf und flatterten über\nden Feldern, wie ein Haufen Blätter, den die Windsbraut\nemporgerissen hatte, sie gingen in die Wälder nieder, hängten sich\nan die nackten Pappeln, besetzten die Kirchenlinden, die Bäume auf\ndem Friedhof, die Obstgärten, die Firste der Hütten und selbst die\nZäune ... bis sie, durch das ununterbrochene Dröhnen der Glocken\naufgescheucht, emporflatterten und in einer schwarzen Wolke\nwaldwärts zogen ... und das scharfe durchdringende Rauschen zog\nihnen nach.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ein schwerer Winter kommt,« sagten die Leute.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Sie ziehen nach den Wäldern, das gibt sicherlich bald\nSchnee.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und das Volk trat immer zahlreicher vor die Hütten, denn niemals\nwaren noch so viel Vögel zusammen gesehen worden "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page236",
      "title": "Konmax/DaoH"
    }
  }), _vm._v(" /lange blickte ihnen alles\nmit seltsamem Bangen nach, bis sie in die Wälder versanken. Man\nstarrte, seufzte schwer, dieser oder jener machte das Zeichen des\nKreuzes auf die Stirn zum Schutz gegen das Böse, und sie fingen an,\nsich zum Kirchgang anzukleiden und hinauszutreten, denn die Glocken\nstöhnten dumpf ... immerzu, und es kamen schon aus den anderen\nDörfern Leute des Wegs. Sie tauchten aus dem Nebel auf den\nFußstegen und Feldpfaden auf.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Zehrende Trauer fiel auf alle Seelen; eine eigentümlich\nschmerzliche Stille umspann die Herzen/die Stille wehmütigen\nSinnens und eines Gedenkens jener, die schon dort hingegangen\nwaren, unter die überhängenden Birken und die schwarzen, gebeugten\nKreuze.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Oh, du mein lieber Jesu! Mein Jesu!« seufzten sie und hoben\nihre Gesichter, fahl wie die Erde, empor, und tauchten\nunerschrockene Augen in das Geheimnis, und gingen ruhig hin, Opfer\nund Gebete für die Toten zu bringen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Das ganze Dorf war wie ertrunken in dieser schweren,\nwehmutsvollen Stille/nur die ängstlichen Bittgesänge der Bettler\nklangen zuweilen von der Kirche herüber.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Auch auf dem Borynahof war es stiller wie gewöhnlich/ obgleich\ndort drinnen die Hölle auf der Lauer saß, bereit bei der ersten\nbesten Gelegenheit hervorzubrechen...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Es mußte ja ..., denn die Kinder wußten schon alles.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und am gestrigen Sonntag war das erste Aufbot des Alten mit\nJagusch herausgekommen ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Am Sonnabend waren sie nach der Stadt gewesen, wo Boryna ihr\nbeim Notar sechs Morgen abgeschrieben hatte ... Er war spät und mit\neinem zerkratzten Gesicht nach Hause gekommen, denn da er etwas\nangetrunken war, wollte er schon auf dem Wagen Jagusch nehmen, und\nkriegte gerade so viel, wie sie mit Faust und Krallen ihm\nverabfolgt hatte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Zu Hause sprach er mit keinem, obgleich ihm Antek immerzu unter\ndie Augen kam; er legte sich gleich schlafen, so wie er stand, in\nden Stiefeln und im Schafpelz ... so daß "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page237",
      "title": "lesebaer/Wunibald"
    }
  }), _vm._v(" am nächsten Morgen Fine\ngegen ihn zu murren anfing, er hätte das Federbett mit Schmutz\nbeschmiert.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Still, Fine, still! Das passiert schon manch einem, der sonst\nnie Schnaps trinkt...,« sagte er lustig und ging gleich am frühen\nMorgen zu Jagna, dort saß er bis in die späte Nacht, so daß sie mit\ndem Mittagessen und Abendbrot vergeblich auf ihn gewartet\nhatten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Auch heute war er spät aufgestanden, denn es war schon lange\nnach Sonnenaufgang, hatte den besten Knierock übergezogen, befahl\nWitek, die guten Stiefel mit Schmer einzuschmieren und neue\nStroheinlage dafür zurechtzuschneiden/ Jakob hatte ihn rasiert, er\nhatte sich seinen Gurt umgewickelt, setzte den schwarzen Hut mit\nder roten Kokarde auf und sah ungeduldig zum Fenster hinaus auf die\nFrontgalerie, wo Anna ihren Jungen lauste; er wollte ihr nicht\nbegegnen. Schließlich hatte er es doch erspäht, daß sie auf einen\nAugenblick in die Stube gegangen war, und schob heimlich hinaus\nzwischen die Hecken./So viel nur gerade hatten sie ihn an diesem\nTag zu sehen bekommen...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Fine weinte den ganzen Tag herum und irrte in der Stube hin und\nher wie ein gefangener Vogel! Antek aber glühte in immer\nschmerzlicheren und grausameren Qualen/ er aß nicht, schlief nicht,\nes wollte ihm nichts gelingen; betäubt und gänzlich geistesabwesend\nwar er noch und wußte nicht, was ihm geschehen war. Auf seinem\nGesicht lagerten tiefe Schatten, so daß die Augen noch größer\nwurden und glasig glühten, wie durch Stein gewordene Tränen/mit\nzusammengebissenen Zähnen, um nicht laut zu schreien und zu\nfluchen, wanderte er in der Stube herum, und dann ums Haus. Oder er\nging in den Heckenweg, auf die Dorfstraße, kehrte um, ließ sich auf\ndie Bank in der Galerie fallen und saß, stundenlang vor sich\nhinbrütend und ganz ertrunken im Schmerz, der immer noch in ihm\nwuchs und ihn immer stärker packte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Das Haus lag stumm, nur Weinen, Aufstöhnen und "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page238",
      "title": "lesebaer/Wunibald"
    }
  }), _vm._v(" Seufzer ertönten\ndarin, wie nach einem Begräbnis. Die Türen von den Ställen standen\nsperrangelweit auf, so daß das Vieh sich im Obstgarten herumtrieb\nund in die Fenster guckte; aber niemand war da, der es eingetrieben\nhätte, nur der alte Waupa versuchte, es bellend zusammenzutreiben/\naber vergeblich, er konnte es nicht bewältigen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Im Stall reinigte Jakob ein Gewehr auf der Pritsche und Witek\nsah mit andächtigem Staunen zu und lugte durch das enge\nFensterchen, damit man sie nicht überraschte...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hat das einen Knall gegeben, Jesus!/Ich dachte, daß der\nGutsherr oder der Förster schießen ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hale... jawohl... ich habe lange nicht mehr geschossen, tüchtig\nhatte ich es geladen und 'n Donner hat es gegeben, wie aus einer\nKanone...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Seid ihr wohl gleich am Abend hingegangen?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ja, aufs Gutsfeld beim Wald bin ich hingegangen, denn da lieben\ndie Ricken auf die Wintersaat hinauszukommen... Es war dunkel, da\nhab' ich denn lange gesessen ... und plötzlich beim Morgengrauen\nkommt ein guter Bock... Ich hab' mich so hingekauert, daß er nur\nfünf Schritt von mir ab war... ich habe nicht geschossen, weil er\nfurchtbar groß war, wie ein Ochs ... da denk' ich ... mit dem wirst\ndu nicht fertig ... Ich habe ihn durchgelassen ... und so in ein\nPaternoster oder in zwei... kamen die Ricken heraus ... Ich hab'\nmir die beste ausgesucht... und kaum daß ich anlege, da gibt es\neinen Knall! Tüchtig hab' ich geladen, ha, der Arm ist mir\ngeschwollen, so hat mich der Kolben gestoßen ... aber sie ist\numgefallen ... nur mit den Füßen hat sie noch gezappelt... wie\nsollte sie nicht auch ... 'ne halbe Handvoll Blei hat sie in die\nSeite gekriegt... und geblökt hat das Vieh... daß ich Angst hatte,\nder Förster könnte es hören; abschlachten mußt' ich sie\nnoch...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ist sie im Walde geblieben, was?« fragte der Junge, ganz\nerhitzt durch die Erzählung.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Sie ist geblieben, wo sie geblieben ist, das ist nicht deine\n"), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page239",
      "title": "lesebaer/Wunibald"
    }
  }), _vm._v("\nSache, und sagst du einem wenn auch nur ein kleines Wort, dann\nsollst du sehen, was ich dir mache...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wenn ihr verbietet, dann sag' ich auch nichts, aber Fine, der\nkann man doch?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hale, damit es das ganze Dorf gleich zu wissen kriegt, da hast\ndu einen Groschen, kauf' dir was ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Nein, ich sag' es auch so nicht, nur nehmt mich mal mit, mein\nguter, goldener...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Frühstücken!« rief Fine vorm Haus.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Nur still sein, dann nehm' ich dich schon mal mit, das tu'\nich!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und laßt ihr mich nur ein einziges Malchen einen Schuß machen,\nwollt ihr, hm?« flehte er.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Na... das Pulver, denkst du, Dummer, kriegt man umsonst...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Geld hab' ich, Jakob, hab' ich schon, noch vom Jahrmarktstag\nher, da hat mir der Bauer zwei Silberlinge geschenkt, die ich für\nSeelengebete aufbewahrt habe, diese...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Schön, schön, ich will es dir lernen,« murmelte er und strich\ndem Burschen über den Kopf... so hatte ihm dieser durch sein\nBetteln das Herz gewonnen...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Einige Paternoster nach dem Frühstück waren schon beide auf dem\nWeg zur Kirche. Jakob humpelte rüstig voraus und Witek war etwas\nzurückgeblieben, weil es ihn genierte, daß er keine Stiefel hatte\nund barfuß gehen mußte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und darf man denn barfuß in die Sakristei, was?« fragte er\nleise.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Dummerjahn. Herr Jesus wird wohl auf fremde Stiefel achtgeben,\nanstatt auf das Gebet...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das schon wohl, aber in Stiefeln schickt es sich doch\nbesser...,« flüsterte er betrübt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Stiefel wirst du dir auch noch mal kaufen, das wirst du\nschon...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Die kauf' ich, Jakob, die will ich kaufen. Wenn ich nur erst\ngroß bin und ein Knecht bin, dann fahre ich gleich "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page240",
      "title": "Monne3/horst48"
    }
  }), _vm._v(" nach Warschau und werde\nmich zu den Pferden verdingen .. und in der Stadt, da gehen sie\nschon alle in Stiefeln, nicht, Jakob?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Natürlich, natürlich!/und was weißt du denn davon?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und wie noch!/Fünf Jahre war ich da, als sie mich aus Kozlow\nbrachten, da weiß ich's noch gut ... jawohl, 'ne Kälte war es ...\nzu Fuß gingen wir zur Arbeit an der Maschine ... ich weiß noch ...\nund die vielen hellen Lichter ... ich seh' noch wie das flimmert\n... ich weiß ... ein Haus neben dem andern, und solche großen, da\nsind die Kirchen nichts dagegen ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Was du nicht zusammenschnackst!« warf ihm Jakob verächtlich zu\n...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich weiß gut, Jakob ... die Dächer könnt' ich doch nicht sehen\n... und die vielen Kutschen ... Fenster bis zur Erde ... jawohl ...\nganze Wände waren, glaub' ich, aus Glas ... und in einem fort ein\nsolches Läuten ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Natürlich, was sollte denn das sonst für Läuten sein?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»So viele Kirchen, das ist kein Wunder!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie schwiegen, denn sie waren schon auf dem Kirchhof und fingen\nan, sich durch die dichte Menschenschar durchzudrängen, die die\nKirche ringsum belagerte, weil drinnen nicht genug Platz war.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Bettler hatten vom Haupteingang bis weit auf die Dorfstraße\nhinaus eine Gasse gebildet und jeder machte sich auf seine Art\nbemerkbar, schrie und betete laut und bettelte um Unterstützung,\nund manche strichen die Geige und stimmten Lieder mit klagender\nStimme an, andere spielten Flöte oder auf der Ziehharmonika, und es\nwar ein Lärm, daß es in den Ohren gellte ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("In der Sakristei standen die Leute so dicht gedrängt, daß um den\nTisch herum, an dem der Organist Gaben für die Seelenfürbitten\nempfing, den Menschen fast die Rippen krachten; an einem anderen\nTisch aber saß sein Sohn, der Jascho, derselbe der die höheren\nSchulen durchmachte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page241",
      "title": "lesebaer/gary"
    }
  }), _vm._v(" Jakob\nhatte sich zuerst durchgedrängt und überreichte dem Organisten eine\nnicht kleine Liste von Namen. Dieser vermerkte sich alle Namen und\nnahm für jede Seele drei Kopeken oder auch, wenn einer kein parates\nGeld hatte, drei Eier.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Witek blieb etwas zurück, da man ihm tüchtig auf die bloßen Füße\ngetreten hatte, aber er drängelte vorwärts so gut er konnte,\nobgleich manch einer aufmurrte, daß er sich unter die Ellenbogen\ndrücke und den älteren Leuten den Weg vertrete; das Geld hielt er\nfest in der Faust/erst als sie ihn bis vor den Tisch hingeschubst\nhatten, gerade auf den Organisten zu, versagte ihm die Zunge ...\nWie denn auch, um ihn herum nichts als Hofbauern und Hofbäuerinnen,\nfast das ganze Dorf, auch die Müllerin im Hut, wie eine Gutsherrin,\nund die Schmiedsleute und der Schulze mit der Seinen ... und alle\nsehen ihn an ... hören zu ... und zählen sich laut die\nverschiedenen Seelen vor ... und geben jeder zehn, zwanzig Namen\nauf ... für die ganze Familie ... für Väter, Großeltern und Urahnen\n... Und er, was? ... Weiß er denn, wer seine Mutter ist? Wer der\nVater? Weiß er das? ... Hat er denn einen, für den er hier was\ngeben kann? Mein Jesu! Oh du mein Jesulein... er stand da mit weit\naufgerissenem Mund und großen himmelblauen Augen, hilflos, wie ein\nrichtiger Dummerjahn ... Das Herz hatte sich ihm im Leibe gekrümmt\nvor lauter Pein, so daß er kaum japste, kaum Atem holen konnte ...\nund so bang wurd' es ihm im Leibe, als ob er schon den letzten\nHauch lassen sollte ... aber er blieb nicht so stehen, denn man\nhatte ihn in die Ecke unter das Weihwasserbecken zurückgeschoben.\nEr stützte sich mit seinem jungen Kopf gegen die Zinnschüssel, um\nnicht zu fallen, und die Tränen liefen wie Perlenschnüre aus seinen\nAugen ... wie Rosenkränze des Schmerzes ... Vergeblich versuchte er\nsie zurückzuhalten ... es war umsonst ... und es war in ihm ein\nsolches Beben, daß es ihn in allen seinen jungen Knochen\nschüttelte, daß er weder gerade stehen "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page242",
      "title": "Monne3/gary"
    }
  }), _vm._v(" noch die Zähne zusammenkriegen\nkonnte; er hockte sich in der Ecke nieder, abseits von den\nMenschenblicken und weinte herzhafte Tränen eines verlassenen\nWaisenkindes ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Mütterchen! Mütterchen!« wimmerte etwas in ihm und zerriß ihm\ndie Seele bis in alle Gründe. Und er konnte es nicht fassen und es\nsich nicht erklären, warum denn alle Väter haben, Mütter haben, und\ner allein nur Waise ist, er allein nur, er allein ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Jesu, mein Jesu! ...« schluchzte er und klagte, wie ein\nVöglein, das von den Netzen gewürgt wird. Erst Jakob fand ihn\nwieder und rief ihm zu:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Witek, hast du denn schon für Seelenfürbitten gegeben?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Nein,« antwortete er, riß sich plötzlich empor, trocknete die\nAugen und schritt entschlossen nach dem Tisch hin ... jawohl, auch\ner wird Namen aufgeben ... was brauchen sie zu wissen, daß er\nniemanden hat ... wozu ... daß er Waise ist, weiß er für sich\nallein genug ... und daß er ein Findelkind ist, nun dann ist er\neben eins ... Selbstsicher ließ er die Augen in die Runde wandern\nund gab mit fester Stimme die Namen: Josepha, Marianne und Anton\nauf, die ihm als erste einfielen ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Er bezahlte, nahm den Rest und betrat mit Jakob die Kirche, um\nein Gebet zu sprechen und zuzuhören, wie der Priester auch die\nNamen seiner Seelen aufrufen würde ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Mitten in der Kirche stand ein Katafalk mit einem Sarg darauf,\nder mit hell brennenden Lichtern umstellt war, der Priester las von\nder Kanzel herab unzählige Namens-Verzeichnisse vor ... und wenn er\nsich einmal unterbrach, antwortete ihm das laute Gebet, daß alle\nfür die Seelen, die im Fegefeuer weilen, sprachen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Witek kniete neben Jakob hin, der einen Rosenkranz unter dem\nRock hervorzog und alle Aves und Credos abzubeten begann, die der\nPriester verordnet hatte. Auch er sprach ein und das andere Gebet,\naber die eintönigen Stimmen der "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page243",
      "title": "lesebaer/gary"
    }
  }), _vm._v(" Betenden, die Wärme und die Erschöpfung\nnach dem Weinen hatten ihn müde gemacht, so daß er sich etwas gegen\ndie Hüfte Jakobs stützte und einschlief ...")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("— — — — —")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Nachmittags zogen zur Vesperandacht, die einmal im Jahr in der\nFriedhofskapelle abgehalten wurde, alle Borynaleute hinaus.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Es gingen die Anteks mit den Kindern, es gingen die\nSchmiedsleute, es ging Fine mit Gusche und zuletzt humpelte Jakob\nneben Witek/um diesen Festtag bis zur Neige auszukosten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Der Tag schloß schon die grauen, müden Lider, erlosch und\nversank langsam in die erschreckenden, trüben Abgründe der\nDunkelheiten; der Wind regte sich und begann stöhnend über die\nFelder zu ziehen, er warf sich zwischen die armseligen Bäume und\nblies mit dem scharfen, faulichten Atem des Herbstes.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Still war es, eine seltsam düstere Allerseelenstille; die Menge\nging des Wegs im strengen Schweigen, nur das dumpfe Aufstampfen der\nFüße ließ sich vernehmen, nur die Bäume am Weg schaukelten unruhig,\nund das leise, schmerzliche Rauschen der Zweige zitterte über den\nHäuptern, nur das Musizieren der Bettler und die Bettelgesänge\nschluchzten in der Luft und zerfielen ohne Widerhall.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Vor dem Tor und selbst schon zwischen den Grabhügeln an der\nFriedhofsmauer standen Reihen von Fässern, wie man sie sonst für\ndie Salzlauge gebraucht, und um sie herum machten sich Scharen von\nBettlern breit.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Das Volk flutete auf der ganzen Breite des Wegs, unter den\nPappelbäumen dem Friedhof zu; in der Dämmerung, die die Welt wie\nmit grauer Asche bestreut hatte, blinkten die Lichter der kleinen\nKerzen, die einzelne bei sich hatten, und schaukelten die gelben\nFlämmchen der Öllampen, und jeder zog vor dem Eintritt ein Brot,\neinen Käse, ein Stückchen Speck oder Wurst aus seinem Bündel\nhervor, oder auch eine "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page244",
      "title": "lesebaer/gary"
    }
  }), _vm._v(" Haspel Garn, oder eine Handvoll gekämmten\nFlachses, einen Kranz getrockneter Pilze,... sie legten alles\nandächtig in die Fässer hinein. Einige davon waren für den Priester\nbestimmt; für den Organisten und für Ambrosius standen auch welche\nda, und der Rest war für die Bettler. Und wer nichts hineinlegte,\nder drückte etwas Geld in die ausgestreckten Hände der Armen ...\nund flüsterte die Namen der Verstorbenen, für die er um eine\nFürbitte bat... Der Chorus von Gebeten, Gesängen, von aufgezählten\nNamen erhob sich immerzu mit einem klagenden Klang weit über die\nFriedhofspforte hinaus; die Leute gingen vorüber, gingen weiter,\nzerstreuten sich zwischen die Grabhügel, so daß bald\nJohanniswürmchen gleich Lichtlein hier und da aus der Dunkelheit,\naus dem Dickicht der Bäume aus den vertrockneten Gräsern\naufzuglimmen und zu flimmern begannen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Das dumpfe, ängstlich gedämpfte Flüstern der Gebete bebte durch\ndie Stille, die dicht über der Erde lag; manchmal riß sich ein\nschmerzliches Schluchzen von den Grabhügeln los, und manches Mal\nrankte sich zwischen den Kreuzen hindurch ein jammervolles\nWeheklagen und stieg auf in herzzerreißenden Windungen; oder ein\njäher, kurzer, verzweiflungsvoller Schrei fuhr wie ein Blitz durch\ndie Luft, und Kindergewimmer klang aus den dämmerigen Dickichten,\nwie das Zirpen verwaister Vögel im Nest.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Zuweilen senkte sich dumpfes, schweres Schweigen auf den\nFriedhof, so daß man nur das düstere Rauschen der Bäume hörte; die\nStimmen waren verhallt und nur noch in die fernen Himmel stieg ein\nEcho von all dem Weinen, all den Klagen und bangen Rufen und zog\nhoch über die weite Welt dahin ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Menschen bewegten sich nur noch lautlos zwischen den Gräbern\numher, flüsterten ängstlich und schauten voll Bangen in die\nnachtverhüllte, unergründliche Weite ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Jeder muß sterben!« seufzten sie schwer mit starrer Ergebung\nund schleppten sich weiter, ließen sich an den Gräbern "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page245",
      "title": "lesebaer/gary"
    }
  }), _vm._v(" der Väter\nnieder, sprachen Gebete, oder saßen stumm und versunken da, taub\nauf die Sprache des Lebens, taub auf die Sprache des Todes, taub\ngegen die Stimme des Schmerzes/den Bäumen ähnlich, und wie die\nBäume bebten ihre Seelen im traumhaften Gefühl der Angst...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Mein Jesus! Barmherziger Herr, Maria!« entströmte es der\nWirrnis ihrer gequälten Seelen, und fahl, wie das Antlitz der\nMutter Erde, hoben sich ihre erstarrten und erschöpften Gesichter;\nihre grauen Augen, die wie die Lachen waren, die aus der Dämmerung\nnoch weißlich starren, hefteten sie auf die Kreuze, und mit\nBewegungen, rote das traumbefangene Wanken der Baume, ließen sie\nsich auf die Knie fallen; Christus zu Füßen legten sie ihre\ngeängsteten Herzen nieder und brachen in das heilige Weinen der\nHingabe und Ergebung aus.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Jakob und Witek gingen mit den anderen herum, und als es\ngänzlich dunkel wurde, wandte sich Jakob nach dem im Hintergrunde\nliegenden alten Friedhof.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Dort zwischen den verfallenen Gräbern war es still, leer und\ndüster/dort lagen die Vergessenen, an die alle Erinnerung längst\ngestorben war/wie ihre Tage, wie ihre Zeiten, und wie alles, was zu\nihnen gehörte; es ließen dort nur irgendwelche Vögel ihre\nunheimlichen Schreie vernehmen, das Dickicht raschelte dort\ntraurig, und hier und da ragte ein vermodertes Kreuz./Dort lagen\nganze Geschlechter, ganze Dörfer, ganze Generationen hingemäht/dort\nbetete schon niemand mehr, man weinte dort nicht und brannte keine\nLämpchen ... Der Wind nur heulte da in den Ästen, riß die letzten\nBlätter von den Zweigen und schleuderte sie in die Nacht der\nendgültigen Vernichtung zu ... Dort stießen sich nur Stimmen, die\nkeine Stimmen waren, und Schatten, die doch keine Schatten waren,\ngegen die nackten Bäume, wie erblindete Vögel, und schienen um\nErbarmung zu winseln.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Jakob holte ein paar ersparte Brotschnitten hervor, riß sie in\nBrocken, kniete nieder und warf sie über die Grabhügel. "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page246",
      "title": "lesebaer/gary"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Esse, christliche Seele, die ich dich zu dieser Abendzeit\nanrufe, esse, menschliche Büßerin, esse!« flüsterte er ganz\nhingenommen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Nehmen sie es denn?« fragte Witek leise mit geängsteter\nStimme.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Versteht sich! Der Priester läßt es nicht zu, sie zu füttern!\n... Manch einer legt was in die Tonnen, aber die Armen haben nichts\ndavon ... dem Pfarrer seine Schweine und den Bettlern ihre haben\nihren Fraß davon ... und die büßenden Seelen leiden Hunger ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Werden sie auch kommen? ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Fürcht' dich nicht ... alle, die im Fegefeuer Qualen leiden ...\nalle. Herr Jesus läßt sie an diesem Tage die Erde betreten, damit\nsie die Ihren besuchen ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Damit sie die Ihren besuchen!« wiederholte Witek mit einem\nGruseln.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Fürcht' dich nicht, Dummer, du, der Böse hat heute keinen\nZutritt, die Fürbitten jagen ihn weg und die Gebete und Lichter ...\nDer Herr Jesus geht doch heute selbst durch die Welt und zählt\nnach, wieviel Seelen er noch hat, der liebe Hausherr, bis er sie\nsich alle ausfindet, alle ... Gut weiß ich noch, wie meine Mutter\nsagte, und auch die alten Leute sagen es aus ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Der Herr Jesus geht heute in der Welt herum?« flüsterte Witek\nund blickte sich aufmerksam um ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Du wirst ihn wohl gerade sehen können ... den sehen doch nur\ndie Heiligen, oder die, welche am meisten dulden müssen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Sieh mal, da leuchtet was, das sind doch Menschen,« rief Witek\nangstvoll und zeigte auf eine Reihe Grabhügel, ganz schon am\nFriedhofszaun ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Da liegen die, die man im Forst erschlagen hat ... jawohl ...\nauch meine Herrschaft liegt da ... und meine Mutter ... jawohl\n...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie zwängten sich durch das Dickicht und knieten an einer Anzahl\nverfallener Grabhügel, die so auseinandergeweht "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page247",
      "title": "lesebaer/gary"
    }
  }), _vm._v(" waren, daß kaum einer von\nihnen übriggeblieben war; weder Kreuze bezeichneten die Stellen\nnoch Bäume beschatteten sie; nichts war da, nur der kahle Sand und\nein paar vertrocknete Stauden von Königskerzen und darüber Stille,\nVergessenheit und Tod ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Ambrosius mit Gusche und der alte Klemb knieten an den Gräbern\ndieser Toten; zwei Lämplein, die man in den Sand gedrückt hatte,\nglimmten, der Wind kam herangefegt, ließ die Lichtlein schaukeln,\nriß die Worte der Gebete auseinander und trug sie davon in die\nschwarze Nacht...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das ist so ... meine Mutter liegt da ... ich entsinne mich ...«\nflüsterte Jakob leise, mehr vor sich hin als zu Witek, der sich\nneben ihm hingekauert hatte, denn ein Frösteln war ihm durch alle\nGlieder gefahren.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und man nannte sie Magdalena ... Der Vater hatte sein eigenes\nLand, diente aber im Gutshof als Kutscher ... fuhr mit dem\nHengstgespann mit dem älteren Herrn ... und dann ist er gestorben\n... den Grund und Boden haben die Oheime genommen ... und ich habe\ndie Schweine von der Herrschaft gehütet ... Jawohl, Magdalena hat\ndie Mutter geheißen und der Vater/Peter, und der Familienname war\nSocha, wie auch der meine ist. Und dann hat mich der Gutsherr zu\nden Pferden genommen, damit ich an Vaters Stelle mit dem\nHengstgespann fahren sollte ... auf Jagden sind wir immerlos\ngefahren zu anderen Herrschaften ... auch ich habe nicht schlecht\ngeschossen ... der jüngere Gutsherr hatte mir ein Gewehr gegeben\n... und die Mutter, die saß nur immerzu mit der älteren Gnädigen im\nHerrenhof ... Ich weiß es noch gut ... und als alle gehen mußten\n... haben sie mich auch genommen ... Ein ganzes Jahr war ich\ndabei... und habe gemacht, was mir befohlen wurde ... Gewiß habe\nich nicht einen Graurock kalt gemacht ... und nicht zwei ... und\nder jüngere Gutsherr kriegte einen in die Kaldaunen ... die\nEingeweide sind ihm rausgegangen. Ist doch mein Herr gewesen ...\nein "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page248",
      "title": "lesebaer/gary"
    }
  }), _vm._v("\nherzensguter Mann ... auf die Schultern hab' ich ihn genommen und\nhinausgetragen ... und dann ist er in die warmen Länder gefahren,\nmir aber hat er befohlen Briefe nach dem alten Herrn zu bringen ...\nda bin ich denn gegangen ... das ist schon gewißlich wahr, daß ich\nabgejagt war und herunter bis auf den Hund ... die Pfote haben sie\nmir durchgeschossen, heilen wollte die da nicht mehr, da ich in\neinem zu draußen war, immer unter freiem Himmel ... und Schnee lag\nbis an den Gurt hoch, verteufeltes Frostwetter dabei ... ich weiß\nnoch ... jawohl ... Nachts hab' ich mich da angeschleppt ... ich\nsuche herum. Jesus, Maria! Als ob mir einer mit der Runge einen\nüber den Schädel gehauen hätte! ... Das Herrenhaus ist nicht da,\ndie Wirtschaftsgebäude sind weg ... selbst die Zäune sind nicht\nübriggeblieben, alles abgebrannt bis auf den Grund ... und der alte\ngnädige Herr und die alte Gnädige und meine Mutter ... und die\nJosefa, die sie als Kammermädchen da hatten ... liegen zu Tode\ngeschlagen im Garten! ... Jesu! Jesu! alles weiß ich noch ...\njawohl ... Maria,« stöhnte er leise und erbsengroße Tränen\nkollerten ihm dicht hintereinander über sein Gesicht, so daß er sie\nnicht einmal abwischte ... Er seufzte kummervoll und sehnsüchtig\nvor sich hin, denn alles war lebendig vor ihm aufgewacht, neben ihm\nwar Witek eingeschlafen, denn das Weinen hatte den armen Wicht müde\ngemacht ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Es ging immer tiefer in die Nacht hinein, der Wind zerrte immer\nheftiger an den Bäumen, so daß die langen Strähnen der Birken über\ndie Grabhügel fegten, und ihre weißen Stämme tauchten aus den\nDunkelheiten hervor, wie in Totenlinnen gehüllt ... Die Menschen\ngingen auseinander ... die Lichter erloschen ... die Gesänge der\nBettler verstummten ... ein feierliches Schweigen, voll seltsamer\nGeräusche und ergreifender Stimmen nahm Besitz vom Gräberhain ...\nEs war als ob der Friedhof sich mit Schatten füllte ... als ob eine\nSchar Gespenster sich drängte ... als ob ein Dickicht voll\ndämmriger Umrisse aufwuchs ... und "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page249",
      "title": "lac/gary"
    }
  }), _vm._v(" ein Chorus leiser schluchzender Stimmen zu\nspinnen begann ... als ob ein Meer nie zu ergründender Zuckungen\naus den Dunkelheiten hervorzuquellen begann ... durchwebt von\nAngstblitzen, von schütterndem Aufschluchzen ... vom Geheimnis voll\nGrauen und Wirrwarr, bis sich ein Krähenschwarm von der Kapelle\naufwarf und schreiend nach den Feldern flügelte, da begannen mit\neinem Male in ganz Lipce die Hunde zu heulen, lange und trostlos\nbang ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Das Dorf verhielt sich still, trotz des Festtages; die Wege\nwaren leer, die Schenke verschlossen und nur hier und da durch die\nkleinen schwitzigen Scheibchen blinkten Lichtlein und flossen\nleise, andächtige Gesänge und laute Gebete, die für die\nVerstorbenen gesprochen wurden ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Mit Angst schlich man vor die Türen der Häuser, mit Angst\nlauschte man auf das Rauschen der Bäume, mit Angst blickte man sich\nnach den Fenstern um/ob die nicht da stehen, ob die nicht\nerscheinen, die an diesem Tage herumirren, getrieben durch die\nSehnsucht und durch Gottes Willen ... ob sie nicht an den\nKreuzwegen mit Büßerstimmen wimmern ... ob sie nicht wehmütig durch\ndie Scheiben starren ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und hier und da stellten die Hausmütter nach altem heiligen\nBrauch die Reste der Abendmahlzeit auf die Mauerbänke an den\nHäusern, bekreuzigten sich mit frommem Schauer und flüsterten\n...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Da nimm, labe dich, christliche Seele, die du im Fegefeuer\nweilest ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("In Stille, Wehmut, Erinnerungen und Bangen floß dieser\nAllerseelenabend dahin ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Drinnen in der Stube bei Anteks saß Rochus, jener Wanderer aus\ndem heiligen Land; er las und erzählte fromme, heilige\nGeschichten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Es waren genug Menschen da, denn auch Ambrosius mit Gusche und\nKlemb waren gekommen, und Jakob mit Witek, und Fine mit Nastuscha\nwaren zugegen; nur der alte Boryna war fort, er saß bis spät in der\nNacht bei Jagna.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page250",
      "title": "lac/JohannN"
    }
  }), _vm._v(" Es war\neine Stille in der Stube, nur das Heimchen knarrte überm Herd, und\ndie trockenen Scheite knallten in der Feuersglut.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie saßen alle auf den Bänken vor dem Herd, nur Antek blieb am\nFenster. Rochus stocherte hin und wieder mit einem Stecken in den\nKohlen herum und redete mit leiser Stimme:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»... Es ist nicht grauenvoll zu sterben, nein, denn wahrlich,\nwie jene Vögelchen, die, wenn es gegen Winter geht, nach den warmen\nLändern ziehen, so ist auch die mühselige liebe Seele, die nach\nJesu verlangt ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Wie jene Bäumchen in ihrer Nacktheit, die der Herrgott zur\nLenzzeit in grüne Blättlein und wohlriechende Blümelein kleidet, so\nist die Menschenseele, die nach Jesus geht, um Freude, Lust, Lenz\nund ihr ewiges Kleid zu empfangen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Wie jene müde Mutter Erde von der Sonne umarmt wird / so wird\nder Herr jede liebe Seele liebkosend umfangen, daß ihr weder Winter\nnoch Schmerz, noch der Tod selbst etwas werden anhaben können\n...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Denn seht! nur Weinen ist auf dieser Erden, nur Kummer und\nLeid!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und die Bosheit mehrt sich, wie die Disteln, und wächst zu\nWäldern auf!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und alles ist eitel und vergeblich, alles ist wie dieser Moder,\nwie jene Bläslein, die ein Wind auf dem Wasser aufbläht, und ein\nzweiter zunichte macht.«")]), _vm._v(" "), _c('p', {
    staticClass: "pcalibre6 initial1"
  }, [_vm._v("Von der Kanzel sag' ich es\nimmer wieder, einem nach dem andern, aber ihr seid, wie die Hunde,\nimmer aufeinander los, immer nur,« / der Wind stieß dem Priester\nden Rest seiner Rede in die Kehle zurück, so daß er einen\nHustenanfall bekam; Antek schritt neben ihm daher, schwieg und\nspähte zwischen die Bäume ins Dunkel.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page251",
      "title": "lac/JohannN"
    }
  }), _vm._v(" Der Wind\nfuhr immer stärker einher, wälzte sich über den Weg und schlug so\nstark gegen die Pappeln und rüttelte sie so heftig, daß sie sich\nstöhnend neigten und empört aufrauschten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und hab' ich dem Biest nicht gesagt,« fing wieder der Priester\nan, »daß er die Stute selbst nach dem Weiher führen soll, da hat er\nsie doch herausgelassen / na, und da hat sie sich nun glücklich\nverlaufen ... Wo sie doch blind ist, ... und wenn sie nun zwischen\ndie Zäune kommt. Die Beine kann sie sich brechen!« jammerte er und\nsuchte sorgsam umher, sah fast hinter jeden Zaun und ließ die\nBlicke über die Felder gehen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Sie ist doch aber immer selbst gegangen ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Die kennt den Weg nach dem Weiher ... das schon, wenn einer das\nFaß mit Wasser füllen würde und sie nur in die Richt drehen wollte,\ndann würde sie schon von selbst zum Pfarrhaus zurechtfinden ...\nAber sonst haben sie sie doch bei Tag herausgelassen ... und heute\nhat Magda oder Walek sie doch erst bei Dunkel vorgespannt ...\nWalek!« rief er laut, denn irgendein Schatten tauchte zwischen den\nPappeln auf ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Walek hab' ich auf unserer Seite gesehen, aber noch vor\nDunkelwerden.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Der ist natürlich erst suchen gegangen, als die rechte Zeit\nschon vorbei war! / Die Stute ist an die zwanzig Jahre schon, die\nist bei mir zur Welt gekommen ... und ihr Gnadenbrot hat sie sich\nschon langst verdient ... und anhänglich ist sie wie ein Mensch ...\nMein Gott, wenn ihr nur nichts Böses passiert!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Was soll ihr da geschehen,« brummte Antek voll Wut, denn hätte\ner sich etwa nicht ärgern sollen, er war doch zu Hochwürden\ngegangen, um sich Rat zu holen, um sich zu beklagen, aber der, nur\nangeschrien hatte er ihn da, und obendrein hatte er ihn dann noch\nmitgeschleppt, um seine Stute zu suchen! Natürlich ist es schade um\ndie Stute, wenn sie auch "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page252",
      "title": "lac/JohannN"
    }
  }), _vm._v(" blind und alt ist, aber immerhin ist doch der\nMensch die Hauptsache!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und du, gehe in dich und hüte deine Zunge, denn es ist dein\nleiblicher Vater! Hörst du!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das weiß ich gut genug!« antwortete er giftig.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Eine Todsünde ist es und Gottesfrevel. Nichts Gutes wird sich\nder da erkämpfen, wer in Pflichtvergessenheit die Hand gegen die\nEltern hebt und sich dem Gebot Gottes widersetzt. Deinen Verstand\nhast du, du solltest es doch wissen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich will nur Gerechtigkeit!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und suchst Rache, was?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Antek wußte nicht, was er darauf sagen sollte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und das will ich dir noch sagen, ein frommes Kalb wird von zwei\nMüttern gesäugt.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das sagen mir alle ... natürlich, nur daß ich diese Frommheit\nsatt habe, länger halt' ich's nicht mehr aus! Wenn er selbst ein\nRäuber und ein Betrüger wäre ... weil es der leibliche Vater ist,\nda ist ihm schon alles erlaubt, und die Kinder dürfen nicht für ihr\nRecht stehen! Herrgott nochmal, das ist 'ne Einrichtung in der\nWelt, daß man ausspeien möchte und so weit fortlaufen, wie einen\ndie Augen nur führen können.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Na, da geh' doch, wer hält dich denn!« warf der Priester\naufbrausend dazwischen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Vielleicht geh' ich auch, was soll ich denn hier noch tun, was\nbloß?« murmelte er leise und tränenschwer.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Du redest, und das ist alles. Manch einer hat auch nicht ein\nAckerbeet und sitzt da, arbeitet und dankt noch Gott dafür. An die\nArbeit solltest du dich halten und nicht herumjammern wie 'n Weib.\nGesund bist du, stark, hast was, wo du dich dran halten kannst\n...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gewiß, ganze drei Morgen sogar!« warf Antek verächtlich\nhin.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hast Frau und Kind, daran solltest du lieber denken.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page253",
      "title": "lac/JohannN"
    }
  }), _vm._v(" »Ich\ndenk' schon, ich denk' ...,« murrte er zwischen den Zähnen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie kamen auf die Schenke zu, deren Fenster erleuchtet waren.\nBis auf den Weg drangen vereinzelte Stimmen herüber.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Was ist denn das, wieder eine Sauferei, was?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das sind die Rekruten, die man dieses Jahr ausgehoben hat, sie\ntrinken zum Zeitvertreib ... Sonntags treibt man sie in die Welt\nhinaus, da machen sie sich noch heute einen lustigen Tag ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Die Schenke ist so gut wie voll!« murmelte der Priester, an der\nPappel stehenbleibend, von wo man gut durchs Fenster den ganzen\nInnenraum überblicken konnte, der mit Menschen vollgepfropft\nwar.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Sie sollten doch heute zusammenkommen, um wegen dem Wald Rat zu\nhalten ... den der Gutsherr an die Juden zum Fällen losgeschlagen\nhat ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Den ganzen hat er doch nicht verkauft, es ist noch so viel\nnachgeblieben!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Bevor er mit uns nicht einig ist, wird nicht eine Tanne\nangerührt!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wie denn?« ... fragte der Priester mit etwas erschrockener\nStimme.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wir lassen's nicht zu, dagegen hilft nichts! Der Vater will\nprozessieren, doch Klemb und die, die mit ihm halten, sagen, daß\nsie keine Gerichte wollen, aber daß die Bäume gefällt werden, das\nließen sie nicht zu, und wenn es selbst nötig wäre, daß das ganze\nDorf hinaus müßte, dann werden sie gehen, selbst wenn es mit Äxten\nund Heugabeln ist, wie es gerade kommt, ihr Eigenes geben sie nicht\nher ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Jesus Maria! Dann würd' es ja ohne Schlägerei und ohne Unglück\nnicht abgehen!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das versteht sich! Erst muß man ein paar Köpfe der\nHerrenhofleute mit der Axt spalten, dann hat man gleich\nGerechtigkeit!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page254",
      "title": "lac/JohannN"
    }
  }), _vm._v(" »Antek!\nDu hast wohl den Verstand verloren vor Wut, oder was fehlt dir? Du\nredest ja Unsinn, mein Bester!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Aber Antek hörte nicht mehr auf ihn, er wandte sich rasch ab und\nverschwand im Dunkel; und der Priester, der das Rädergeroll und das\nleise, klagende Wiehern der Stute vernommen hatte, schritt rasch\nauf den Pfarrhof zu ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Antek seinerseits ging in der Richtung der Mühle, ins untere\nDorf und zwar auf der anderen Seite des Weihers entlang, um nicht\nan Jagnas Haus vorüber zu müssen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Wie ein Splitter steckte sie ihm unter dem Herzen, wie ein böser\nSplitter, so daß man sie weder herausreißen noch vor ihr flüchten\nkonnte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Ein grelles Licht strahlte aus ihrem Haus, hell und besonders\nlustig ... er blieb stehen, um nur das eine einzige Mal\nhineinzusehen, um wenigstens seiner Wut Luft zu machen / aber es\nriß ihn irgendwas von der Stelle, so daß er davonraste wie ein\nSturm, ohne sich umzusehen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Dem Vater Seine war sie schon, dem Vater Seine!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Zum Schwager, dem Schmied flüchtete er / einen Rat wird der auch\nnicht geben, aber man kann unter Menschen sitzen und nicht dort\nsein in Vaters Haus ... Und dieser Priester zum Beispiel! Die\nArbeit hält er ihm vor! Hale, und selbst macht er nichts, hat\nkeinen Kummer und keine Sorgen, dann ist es leicht, andere\nanzutreiben. Auf Weib und Kinder hat er ihn verwiesen ... Die\nvergißt er schon nicht, nein! Dieses Geflenn, diese Demut und die\nbettelnden Hundeaugen hat er schon gerade genugsam satt ... und\nwenn sie nicht wäre! ... Wenn er allein wäre! Herr Jesus! Er\nstöhnte auf und es packte ihn eine solche wahnsinnige Wut, daß ihn\ndie Lust ankam, irgendwem an die Gurgel zu springen, zu würgen, zu\nzerreißen und bis zum Tod zu schlagen! ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Aber wen? ... Nein, er wußte es nicht und die Wut schwand so\nplötzlich, wie sie gekommen war; mit leeren Augen starrte er in die\nNacht und horchte auf das Rütteln des "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page255",
      "title": "lac/JohannN"
    }
  }), _vm._v(" Sturmes, der sich durch die\nGärten wühlte und so an den Bäumen rüttelte, daß sie sich über die\nZäune lehnten und ihn mit ihren Zweigen gegen das Gesicht\npeitschten ... Er schleppte sich so langsam und schwerfällig\nweiter, daß er kaum vorwärtskam, denn es begannen seine Seele die\nGespenster der Müdigkeit, Trauer und Ohnmacht zu bedrängen, so daß\ner bald vergessen hatte, wohin er ging und was er gewollt hatte\n...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Dem Vater Seine ist Jagna, dem Vater Seine!« sprach er immer\nwieder vor sich hin / »dem Vater Seine,« immer stiller / wie ein\nGebet, das einem nicht entschwinden darf.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("In der Schmiede war es rot von der Feuerglut, ein Bursche blies\nso mächtig mit dem Blasebalg, daß die aufglühenden Kohlen brausten\nund zu einer blutigen Flamme aufloderten; der Schmied stand am\nAmboß, hatte die Mütze aus der Stirn geschoben, die Ärmel\nhochgekrempt, einen Lederschurz um und ein dermaßen rußgeschwärztes\nGesicht, daß ihm die Augen nur wie kleine Kohlen im Kopfe glühten;\ner hämmerte ein rotgeglühtes Eisenstück so stark, daß es donnerte,\nund ein Funkenregen unter dem Hammer hervorsprühte, mit Zischen in\ndie aufgeweichte Erde fallend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Was gibt's denn?« fragte er nach einer Weile.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ja, was soll es da geben!« antwortete Antek leise, gegen einen\nKorbwagen lehnend, von denen etliche zum Beschlagen dastanden, und\nstarrte versunken in die Glut.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Der Schmied schaffte tüchtig, immer wieder glühte er das Eisen\nund hämmerte, schlug den Hammer im Takt oder half dem Burschen nach\nbeim Blasen mit dem Blasebalg, wenn man stärkeres Feuer brauchte,\nund heimlich sah er zu Antek hinüber. Ein boshaftes Lächeln\nschlängelte sich unter seinem rostroten Schnurrbart.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Du warst, hör' ich, bei Hochwürden? Na und was gab's?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Was sollte es geben, gar nichts. Dasselbe hätte man in der\nKirche hören können.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page256",
      "title": "lac/JohannN"
    }
  }), _vm._v(" »Und\nhast du was anderes erwartet?« meinte der Schmied ironisch\nlachend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Er ist doch der Priester, ein gelernter Mann ...,« sprach\nAntek, sich gleichsam entschuldigend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gelernt, wie man was nehmen soll, aber nicht wie man einem was\ngibt.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Antek war schon die Lust vergangen, etwas dagegen zu sagen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich geh' in die Stube,« sagte er nach einer Weile.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Geh nur, der Schulze kommt auch 'rüber, da kommen wir gleich\nnach! Und der Tabak ist auf dem Schränkchen, kannst was rauchen\n...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Er hörte kaum hin und trat in die Wohnung, die auf der anderen\nSeite vom Weg lag.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Schwester zündete Feuer an und der älteste Junge lernte am\nTisch aus der Fibel ... sie begrüßten sich schweigend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Lernt er da?« bemerkte er, denn der Junge buchstabierte laut\nund deutete mit einem zugespitzten Stöcklein von Buchstabe zu\nBuchstabe.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Seit der Kartoffelernte schon; das Fräulein von der Mühle zeigt\nihm das, denn Meiner hat keine Zeit dafür.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Rochus tut auch seit gestern in Vaters Stube wieder\nlehren.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich wollte den Jasiek da auch hinschicken, aber Meiner läßt das\nnicht zu, weil es bei Vater ist und weil das Fräulein mehr gelehrt\nist, denn sie war auf den Schulen in Warschau ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gewiß, gewiß ...,« sagte er, um irgendwas zu sagen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und Jasiek ist so anstellig dabei, daß sich das Fräulein selbst\nwundert.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wie sollt' er auch nicht ... ist doch dem Schmied sein Fleisch\nund Blut ..., der Sohn von solchem Klugschnacker ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Du machst dich lustig, und er hat doch recht, wenn er "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page257",
      "title": "DaoH/JohannN"
    }
  }), _vm._v(" sagt, daß der\nVater, solange er lebt, die ganze Schenkung zunichte machen\nkann.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Versteht sich, reiß mal dem Wolf aus der Gurgel, was er schon\nverschluckt hat! Sechs ganze Morgen Land. Ich mit der Frau, wir\ndienen ihm da fast wie Gesinde, und er verschreibt's einer Fremden,\nder ersten besten ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wenn du dich zanken wirst, und fluchen, und Rat bei anderen\nholen, und dich prozessieren / dann jagt er dich noch zum Hause\n'raus,« redete sie leise, sich nach der Tür umblickend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wer hat das gesagt?« brach er los, vom Stuhl auffahrend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Still doch ... das sagen die Leute, still! ...« flüsterte sie\nängstlich.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Weichen tu' ich keinen Schritt, laß ihn mich mal mit Gewalt\n'rausjagen, zum Gericht geh ich, prozessieren werd' ich mich,\nweichen tu' ich nicht!« schrie er schon fast.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Du wirst die Mauer schon nicht mit dem Kopf einrennen, und wenn\ndu auch noch so sehr, wie ein Schafsbock, drauflos stoßen würdest!«\nsagte der Schmied, die Stube betretend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Was soll man da tun? Du hast klug reden, da gib denn auch einen\nklugen Rat ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Mit Böswilligkeiten ist nichts vom Alten 'rauszukriegen!« Er\nzündete die Pfeife an und fing an, ihm vorzustellen, zu erklären\nund ihn zu begütigen, und er drehte so viel herum, daß Antek\nendlich ein Licht aufging.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Du hältst es mit ihm?« schrie er los.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Für die Gerechtigkeit bin ich!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hat er dir gut dafür bezahlt?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wenn er bezahlt hat, dann nicht aus deiner Tasche.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gerade aus meiner, hundsverdammt noch mal, aus meiner! Das ist\nmir ein Wohltäter aus andermanns Tasche, so 'n Aas. Genug hast du\ngekriegt, da soll's dir wohl nicht eilig sein.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page258",
      "title": "DaoH/JohannN"
    }
  }), _vm._v("\n»Dasselbe nur, was du auch bekommen hast!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hale, dasselbe ... und das Hausgerät, und die Kleider und die\nKuh, und was hast du nicht alles dem Vater abgelistet? Ich merk' es\nmir schon, und die jungen Gänse, und Ferkel, wer kann das alles\naufzählen. Und das Bullenkalb, das er dir neulich gegeben hat, ist\ndas nichts?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Du hättest es ja auch nehmen können.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ein Dieb bin ich nicht und 'n Zigeuner auch nicht!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich aber bin der Dieb, ich? ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie sprangen aufeinander zu, bereit, sich gleich an den\nRockklappen zu packen, aber sie ließen bald nach, denn Antek sagte\nleiser.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich sag' das nicht für dich ... Aber das Meine geb' ich nicht\nab, wenn ich drumumkommen sollte.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ih ... dir geht es nicht so um den Grund und Boden, deucht\nmir...,« warf der Schmied spöttisch ein.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und warum denn sonst?...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hinter der Jagna bist du her gewesen, da kommt es dir jetzt\nsauer an.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hast du 's gesehen?...« schrie Antek, wie ins Herz\ngetroffen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Es gibt solche im Dorf, die es gesehen haben, und das nicht nur\neinmal ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Daß ihre Augen mit Nacht geschlagen werden!« murmelte er schon\netwas leiser, denn gerade trat der Schulze in die Stube und\nbegrüßte die Anwesenden; er schien zu wissen, weshalb sie sich\nzankten, denn auch er begann alsogleich den Alten zu verteidigen\nund zu entschuldigen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gut mit Schnaps traktiert hat er euch und mit Würsten\ngefüttert, kein Wunder daß ihr jetzt zu ihm haltet ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Rede nicht das erste beste Zeug, wenn der Schulze zu dir\nspricht!« rief dieser hochmütig.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Eure Schulzenschaft ist für mich grob so viel wert, wie dieser\nzerbrochene Stecken ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Was hast du gesagt, was?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page259",
      "title": "DaoH/JohannN"
    }
  }), _vm._v(" »Ihr\nhabt es gehört! Und wenn nicht, dann sag' ich euch noch solches\nWort dazu, daß euch die Fersen jucken werden ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Sag' dieses Wort, untersteh' dich!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das sag' ich / ihr seid ein Saufkumpan, Wortbrecher, ein\nJudassohn! Ich will es sagen, ich tu' es sagen, daß ihr für das\nGeld der Gemeinde herumludert, und daß ihr euch gut dafür vom\nHerrenhof habt schmieren lassen, daß der Gutsherr unsern Wald hat\nverkaufen können! ... Und wenn ihr noch was wollt, dann leg' ich\neuch noch was drauf, aber mit diesem Knüttel ... rief er hitzig,\nnach seinem Stecken langend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Du sprichst zu einem Beamten, mäßige dich, ehe es dich gereuen\nsollte, Antek!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und in meinem Haus falle nicht die Menschen an, denn hier ist\nkeine Schenke,« schrie der Schmied, indem er sich schützend vor den\nSchulzen aufpflanzte; aber Antek achtete auf nichts mehr, schnauzte\ndie beiden hundsmäßig an, schmiß die Türe zu und entfernte sich\n...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Es hatte ihn redlich erleichtert, und er kehrte etwas beruhigt\nnach Hause zurück; nur das eine tat ihn verdrießen, daß er sich\nunnötigerweise mit seinem Schwager gezankt hatte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Jetzt werden sie schon alle gegen mich sein,« dachte er am\nnächsten Tag des Morgens beim Frühstück, und erblickte mit Staunen\nden Schmied, der in die Stube trat.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie begrüßten sich, als ob nie etwas zwischen ihnen vorgefallen\nwäre.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und da Antek im Begriff war, nach der Scheune zu gehen, um\nHäcksel zu schneiden, ging ihm der Schmied nach, setzte sich auf\neinen Garbenhaufen nieder, den man von der Banse zum Dreschen\nhinuntergeworfen hatte und fing leise an:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Zum Teufel alle Zänkereien und weswegen noch? Wegen einem\ndummen Wort! Da bin ich denn als erster zu dir gekommen, hier hast\ndu meine Hand, wir wollen wieder Frieden machen ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page260",
      "title": "DaoH/JohannN"
    }
  }), _vm._v(" Antek\nreichte ihm die Hand, sah ihn mißtrauisch an und murmelte:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Selbstredend war es nur wegen der Worte, denn Ärger gegen euch\nhatt' ich nicht. Der Schulze hat mich aufgebracht, denn was soll er\nfür ihn eintreten, ... ist doch nicht seine Sache, da soll er seine\nFinger davon lassen!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gerade das habe ich ihm auch gesagt, als er dir noch nachrennen\nwollte ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Mich schlagen ... ich würde ihm schon eine Tracht verabfolgen\nwie seinem Vetter, der noch von der Erntezeit her seine Rippen\nkuriert ...,« rief er aus und fing an, das Stroh in die\nHäckselschneide zu stopfen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Auch daran hab' ich ihn erinnert ...,« warf der Schmied\nbescheiden ein und lächelte durchtrieben.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich werd' schon mit ihm abrechnen, er wird schon an mich denken\n... Diese noblichte Personage, so 'n Beamtenbiest! ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ist doch nur 'n Hohlkopf, und damit genug, laß ihn fahren.\nEtwas anderes hab' ich mir ausgedacht und darum will ich mit dir\nreden ... Das muß man so machen ... Nachmittags wird hier die Meine\nkommen, dann geht ihr mit ihr zusammen zum Alten, euch gründlich zu\nbereden ... Das Gewüte und Geklage in allen Ecken herum hat da\nkeinen Wert, vor die Augen muß man treten und geradeaus sagen, was\nman auf der Leber hat ... Gut kann es werden, oder nicht gut\nwerden, aber vorgehalten muß ihm alles werden!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Was hat man ihm da vorzuhalten, wenn er die Verschreibung\ngemacht hat!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Mit Wut bringt man es bei ihm zu nichts! Natürlich, daß er ihr\ndie Verschreibung gemacht hat, solange er lebt kann er sie aber\nimmer wieder zurücknehmen, merk' dir das; darum eben braucht man\nnicht gegen ihn anzugehen. Laß ihn sich verheiraten, laß ihn seinen\nSpaß haben.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Antek erblaßte etwas bei dieser Erwähnung und begann innerlich\nzu beben, so daß er mit dem Häckselschneiden aufhören mußte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page261",
      "title": "DaoH/JohannN"
    }
  }), _vm._v("\n»Dagegen empöre dich nicht ihm direkt ins Gesicht hinein, lob' nur\nerst, daß er gut dran tut zu heiraten und daß er das mit der\nVerschreibung nach seinem Willen tun konnte ..., wenn er nur den\nRest uns verspricht, dir und der Meinen, aber vor Zeugen!« fügte er\nschlau hinzu.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und Fine und Gregor?« fragte Antek widerwillig.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Die wird man auszahlen! Hat denn vielleicht der Gregor wenig im\nvoraus bekommen? Fast jeden Monat schickt er ihm doch was nach\nseinem Regiment. Hör' nur auf mich und tu' wie ich rate, und du\nwirst nichts dabei verlieren. Das ist schon mein Verstand, ich\nwerde das schon so deichseln, daß alles unser sein wird ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Der Hammel lebt noch und der Kürschner näht schon einen\nSchafspelz aus seinem Fell ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Höre auf mich ... Laß ihn erst mal vor Zeugen versprechen,\ndamit man was hat, wo man die Krallen ansetzen kann ... Gerichte\nsind noch da und Gerechtigkeit auch, hab' keine Angst. Und es ist\nschon ein Haken dran, denn von deiner Mutter ist doch Grund und\nBoden nachgeblieben ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Große Geschichte, vier Morgen zusammen / für mich und für die\nDeine ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Aber weder du noch die Meine haben ihn gekriegt! Und so viele\nJahre, die er darauf sät und erntet! / Dafür wird er euch gut\nzahlen müssen und mit Prezenten! ... Ich wiederhole es dir noch\neinmal, sei dem Alten in keiner Sache entgegen, lobe und red' ihm\num den Bart, gehe hin zur Hochzeit, spare nicht an guten Worten und\ndu wirst sehen, daß wir ihn uns deichseln werden ... Und wenn es\nnicht in Güte geht, dann wird das Gericht ihn schon 'rumkriegen ...\nMit Jagusch kennt ihr euch gut aus... da könnte sie dir auch was\nnützen ... sag' ihr nur was davon ... sie könnte den Alten noch\nbesser auf unsere Seite kriegen ..., na, einverstanden? ... Ich muß\nnämlich schon gehen ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Einverstanden! beeil' du dich, mir aus den Augen zu kommen,\ndamit ich dir nicht eines ins Maul gebe und dich "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page262",
      "title": "DaoH/JohannN"
    }
  }), _vm._v(" vors Tor schmeiße!« preßte\ner zwischen den Zähnen hervor.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Was ... Antek? Was ist dir?« stotterte der Schmied erschrocken,\ndenn Antek ließ die Sense fahren und kam auf ihn zu; blaß und mit\nschrecklichen Augen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Judas, Aas, Dieb!« gurgelte er aus sich heraus mit schnaubendem\nHaß, so daß der Schmied aufsprang und auf und davon rannte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Er ist wohl nicht richtig geworden, oder was war das? ...«\ndachte er immerzu unterwegs. »Was soll ich da denken, ich hab' ihm\neinen guten Rat gegeben ... und der? ... wenn er so dumm ist, dann\nlaß ihn als Tagelöhner gehen, mag der Alte ihn fortjagen, da will\nich noch mithelfen ... und so oder anders, ich laß nicht von dem\nGrund und Boden ... So einer bist du also! Ins Maul wolltest du mir\neine langen, vors Tor schmeißen, daß ich mit dir teilen wollte, ...\ndaß ich wie zu einem Bruder gekommen bin mit einem guten Wort! So\neiner bist du! Aha, allein möchtest du alles einstecken! Daß du's\nnicht erlebst! Meine Pläne hast du mir 'rausgelockt, da werd' ich\ndir, Biest, schon was einbrocken, daß dich das englische Fieber\nschütteln wird.« Er wurde immer wütiger, denn es ärgerte ihn\nfürchterlich, daß Antek seine Pläne durchschaut hatte und\nvielleicht noch gar imstande sein würde, ihn vor dem Alten zu\nverraten. Davor hatte er die größte Angst.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Dem muß man vorbeugen!« entschied er sofort; und trotz der\nAngst vor Antek kehrte er nach dem Borynahof um.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ist der Hofbauer da?« fragte er Witek, der vor dem Haus auf die\nGänse im Weiher mit Steinen warf.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hale, was soll er zu Hause sein, ist ja zu den Müllers gegangen\nzur Hochzeit zu laden ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich geh' ihm entgegen, wir werden uns sozusagen zufällig\ntreffen,« dachte er und ging in der Richtung der Mühle davon; aber\nunterwegs kehrte er noch bei sich ein und befahl der Frau, sich\nschön anzukleiden, die Kinder mitzunehmen "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page263",
      "title": "halei/JohannN"
    }
  }), _vm._v(" und gleich, wenn man zu Mittag\ngeläutet hatte, zu Anteks hinüberzugehen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Er wird dir schon sagen, was du zu tun hast! Mache nichts\nallein und nichts nach deinem eigenen Kopf, denn du bist dumm\ngenug, und nur wenn 's nötig sein wird, dann heule los, umfange\nVaters Knie und leg' dich aufs Bitten ... und höre gut zu, was\nVater sagen wird und was Antek vordem sagt...« Ein gutes\nPaternoster lang unterwies er sie so und schaute dabei zum Fenster\nhinaus, ob der Alte nicht auf der Brücke auftauchen sollte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich geh' in die Mühle gucken, ob sie die Hirse schon fertig\nhaben.« Die Zeit wurde ihm zu Hause lang.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Er ging langsam, blieb stehen und überlegte. Gewiß, wer kann da\nwissen, was er tun wird.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Angefahren hat er mich, und tun könnte er doch was ich ihm\ngeraten habe ... dann ist's besser, daß die Frau dabei ist ... und\nwenn er es nicht tut, werden sie sich verzanken ... der Alte wird\nihn 'rausschmeißen ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»So oder so, immer gibt's für einen was ab ...,« er lachte\nbefriedigt auf, rieb sich die Hände, drückte die Mütze fester auf,\nknöpfte den Knierock zu, denn es war windig und eine durchdringende\nKühle kam vom Weiher.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Einen Nachtfrost kriegen wir oder neue Regenfälle!« murmelte\ner, auf der Brücke anhaltend und den Himmel beschauend. Die Wolken\njagten tief, waren dunkelgrau und schwer und wie beschmutzt, gleich\nHerden ungewaschener Schafe. Der Weiher murrte dumpf, seine Wasser\nplatschten von Zeit zu Zeit an die Ufer, wo hier und da zwischen\nschwarzen gebeugten Erlen und weit ausladenden Weiden Frauen in\ngrellroten Röcken sichtbar waren, die Wäsche wuschen / die\nWaschhölzer klopften wütend an den beiden Ufern des Weihers. Die\nWege waren leer, nur ganze Scharen von Gänsen paddelten im dicken\nSchmutzbrei und in den Gräben, die voll abgefallener Blätter und\nKehricht waren, und Kinder schrien vor den Häusern. Die Hähne\nfingen an "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page264",
      "title": "halei/JohannN"
    }
  }), _vm._v("\nauf den Zäunen zu krähen, als ob sie einen Witterungswechsel melden\nwollten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»In der Mühle paß ich ihn schneller ab!« brummte er vor sich hin\nund ging talwärts.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Nachdem der Schmied gegangen war, fing Antek mit solcher Wut an,\nHäcksel zu schneiden und hatte sich dermaßen in diese Arbeit\nvertieft und so viel Häcksel bis Mittag fertig gemacht, daß Jakob,\nder vom Walde gekommen war, rief:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Für eine ganze Woche wird das reichen, na!« Er gab seiner\nVerwunderung so laut Ausdruck, daß Antek zur Besinnung kam, das\nHäckselmesser hinwarf, sich räkelte und den Weg zum Wohnhaus\neinschlug.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Was kommt, das kommt; aber heute sprech' ich mit dem Vater!«\nbeschloß er ... »Ein Zigeuner ist er, der Schmied, und ein Judas,\nvielleicht tut er aber doch gut raten ... gewiß steckt da was\ndahinter ...,« dachte er und ging in Vaters Stube nachzusehen, er\ntrat aber gleich zurück, denn es saßen dort an die zwanzig Kinder,\ndie alle zugleich buchstabierten ... Rochus unterrichtete sie und\npaßte fleißig auf, daß sie keine dummen Streiche machten ... Er\nwandelte in der Stube herum mit einem Rosenkranz in der Hand, hörte\nzu, verbesserte manchmal eins, zupfte ein anderes am Ohr,\nstreichelte hier und da einen der kleinen Köpfe und setzte sich des\nöfteren heran, um geduldig zu erklären, was da im Buch stand; er\nstellte Fragen, und die ganze Schar der Kinder drängte sich, eins\ndas andere überbietend, zur Antwort heran, wie Truthähne, wenn sie\neiner aufgereizt hat ... sie machten einen solchen Lärm, daß man\nsie auch auf der anderen Seite hören konnte...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Anna bereitete das Mittagessen und redete hier und da mit ihrem\nVater, dem alten Bylica, der sich bei ihr selten sehen ließ, da er\nviel kränkelte und sich kaum mehr fortbewegen konnte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Er saß am Fenster, auf seinen Stock gestützt, ließ die "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page265",
      "title": "halei/JohannN"
    }
  }), _vm._v(" Augen durch die\nStube schweifen und blickte einmal zu den Kindern hin, die in der\nEcke zusammengekauert und still dasaßen, dann wieder auf Anna ...\ner war ganz weißhaarig, seine Lippen bewegten sich rastlos und\nseine Stimme war schwach, wie die eines Vögleins ... sein Atem ging\nin pfeifenden Tönen ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Habt ihr denn schon gefrühstückt, he?« fragte sie leise.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ih... die Wahrheit zu sagen, hat es Veronka vergessen ... und\nich hab' mich auch nicht gemeldet, nein ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Veronka läßt selbst die Hunde hungern, denn sie kommen hier zu\nmir manchmal zum Nachfuttern!« rief sie. Sie hatte außerdem noch\netwas gegen die ältere Schwester seit dem vergangenen Winter, weil\ndiese nach dem Tode der Mutter alles, was übriggeblieben war, an\nsich gerissen hatte und nichts wieder herausgeben wollte, deswegen\nsahen sie sich so gut wie gar nicht.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Weil sie doch auch keinen Überfluß haben, nein ...« versuchte\ner mit leiser Stimme zu verteidigen ... »Stach drischt beim\nOrganist', da ißt er auch was mit, und nimmt noch vier Groschen\njeden Tag ... und zu Haus sind so viel Mäuler zu stopfen ... daß es\nselbst mit den Kartoffeln nicht reicht ... Das ist schon wahr ...\ndaß sie zwei Kühe haben, und Milch ist auch da ... so daß sie Käse\nund Butter nach der Stadt tragen kann und dafür manchen Groschen\nbekommt ... aber sie vergißt oft, daß man essen braucht ... kein\nWunder, wohl / wohl ... die vielen Kinder ... Beiderwand webt sie\nden Leuten auch noch ... und spinnt und tut sich abschinden, wie\nein Lasttier ... viel brauch' ich doch auch nicht ... wenn es nur\nzur rechten Zeit was gäbe und jeden Tag ... dann könnte man\n...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Dann zieht doch zum Frühjahr besser zu uns, wenn ihr es bei\ndieser Hündin so schlecht habt ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich tu' mich doch nicht beklagen, klagen tu' ich nicht, nur ...\nvon wegen ...« die Stimme brach ihm plötzlich zusammen ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page266",
      "title": "halei/gary"
    }
  }), _vm._v(" »Ihr\nkönntet die Gänse hüten und auf die Kinder passen...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich würd' schon alles machen, Hanusch, alles,« flüsterte er\nganz leise.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»In der Stube ist Platz, da würde man ein Bett hineinstellen,\ndamit ihr es warm habt ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich würd' ja schon im Kuhstall oder auch bei den Pferden...,\nwenn ich nur bei dir sein könnte, Hanusch, nur nicht mehr zurück!\nNur nicht ...« er verschluckte sich bei dieser flehentlichen Bitte\nund die Tränen fingen an, ihm aus den tiefliegenden, geröteten\nAugen zu tropfen ... »Das Federbett hat sie mir weggenommen/sie\nsagt, die Kinder haben nichts zum Zudecken ... das ist wahr... sie\nfroren, daß ich sie selbst zu mir nahm ... aber der alte Schafspelz\nist nun schon ganz ausgeschabt, der wärmt mich gar nicht mehr ...\nund das Bett hat sie mir genommen... und auf meiner Seite ist es\nkalt ... nicht ein Stück Holz erlaubt sie mir... und jeden Löffel\nEssen hält sie vor ... zum Betteln treibt sie mich 'raus ... Aber\nich hab' doch gar keine Kraft, zu dir hab' ich mich kaum noch\nhingeschleppt ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Um Gottes willen! Warum habt ihr uns denn nie etwas gesagt, daß\nihr's so schlecht habt ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wie soll man denn ... die eigene Tochter ... er ist 'n guter\nMann, aber immer auf Taglohn... wie soll man denn ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Dieses Höllenweib! Die Hälfte des Bodens hat sie genommen, und\ndas halbe Haus und alles, und gibt euch solch ein Altenteil! An die\nGerichte muß man sich wenden! Sie sollten euch doch Essen geben und\nHeizung und das, was ihr an Kleidern braucht, und wir die zwölf\nRubel das Jahr ... denn wir haben auch noch eure Schuld bezahlt ...\nist es nicht so? ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Is wahr! Ehrlich seid ihr, is wahr ... Aber auch die paar\nSilberlinge von euch, die ich, weil ich doch mal begraben werden\nmuß, zurückgelegt habe, hat sie mir abgetrieben "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page267",
      "title": "halei/gary"
    }
  }), _vm._v(" ... und dann, man mußte es\ndoch auch geben... das hätte man doch nicht anders können... das\nKind doch ..Er schwieg, still und zusammengekauert blieb er sitzen\nund glich mehr einem Haufen alter Hobelspäne, denn einem lebendigen\nMenschen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Nach dem Mittagessen, als die Schmiedin mit ihren Kindern\neingetreten war und man gerade angefangen hatte, sich zu begrüßen,\nnahm er das Bündelchen, das ihm Anna im geheimen zurechtgemacht\nhatte, und machte sich leise davon.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Boryna war zu Mittag nicht gekommen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Schmiedin beschloß also zu warten, selbst wenn es bis in die\nNacht gehen sollte. Anna stellte den Webstuhl am Fenster zurecht\nund zog die Wergfasern durch den Weberkamm. Hin und wieder nur,\nwenn auch schüchtern, warf sie irgendein Wort ins Gespräch, das\nAntek mit der Schwester führte. Er breitete vor ihr seine Klagen\naus, denen sie beipflichtete; aber das dauerte nicht lange, denn\nGusche stürzte herein und sagte so nebenher:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Von den Organistenleuten komm' ich eben zu euch 'rübergelaufen,\nich hab' da waschen müssen ... Eben war Matheus mit der Jagna da,\nzur Hochzeit zu bitten. Die gehen hin! Natürlich, Art find' sich zu\nArt, der Reiche zum Reichen ... auch der Priester ist gebeten\n...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Auch Hochwürden haben sie gebeten!...« rief Anna.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Warum denn nicht, ist er vielleicht ein Heiliger, oder was? Sie\nhaben gebeten, er hat gesagt vielleicht wollte er kommen ... warum\ndenn auch nicht? Ist die Braut vielleicht nicht schmuck, werden sie\nvielleicht kein gutes Essen und Trinken bereit halten! Die\nMüllersleute haben auch zugesagt mit der Tochter. Ho, ho, solche\nHochzeit hat man noch nicht gesehen, seit Lipce Lipce ist! Ich weiß\nBescheid, weil ich doch mit Müllers Eve das Essen kochen soll. Ein\nMastschwein hat ihnen schon Ambrosius ausgeweidet, Würste machen\nsie auch schon ...«/sie unterbrach sich plötzlich, denn "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page268",
      "title": "halei/lac"
    }
  }), _vm._v(" niemand sagte\netwas, niemand befragte sie, sie saßen mürrisch da. Gusche sah die\nganze Gesellschaft aufmerksam an und rief aus:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Bei euch soll's wohl Sturm geben?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Sturm oder nicht, das ist nicht eure Sache!« sagte die\nSchmiedin so schneidend, daß Gusche beleidigt nach der anderen\nSeite zu Fine abschob, die die Bänke und Stühle wieder\nzurechtrückte, denn die Kinder hatten sich schon zerstreut und\nRochus war ins Dorf gegangen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gewiß wird sich Vater nichts abgehen lassen,« murmelte die\nSchmiedin mit einer gekränkten Stimme.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hat er's am Ende nicht dazu!« sagte Anna und verstummte\nerschrocken, weil Antek drohend zu ihr herübergeblickt hatte. Sie\nsaßen nun fast schweigend da und warteten; hin und wieder sagte\neines von ihnen ein Wort und wiederum trat das dumpf-drückende und\nbeunruhigende Schweigen ein ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Vor dem Hause auf der Galerie machte Witek mit den Kindern einen\nsolchen Spektakel, daß Waupa bellte und das ganze Haus dröhnte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Bares Geld muß er auch genug haben, denn immerzu verkauft er\nwas, und wo sollte er es sonst lassen?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Antek machte eine wegwerfende Bewegung bei den Worten seiner\nSchwester und trat aus der Stube ins Freie. Es wurde ihm langweilig\nzu Hause, die Unruhe und die Angst wurden stärker in ihm, er wußte\nselbst nicht warum; er wartete auf den Vater, konnte sich kaum mehr\ngedulden, und war doch in tiefster Seele zufrieden, daß dieser sich\nso lange nicht blicken ließ. »Nicht wegen Grund und Boden ist es\ndir zu tun, sondern um die Jaguscha!« Er dachte an diese Worte, die\nder Schmied gestern gesagt hatte ... »Wie ein Hund lügt er!« rief\ner ganz außer sich. Er machte sich daran, die Wände nach der\nHofseite zu für den Winter abzudichten. Witek trug ihm von einem\nHaufen Nadelstreu herbei, er stampfte sie fest und umsteckte sie\nmit kleinen Latten, "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page269",
      "title": "halei/lac"
    }
  }), _vm._v(" aber die Hände zitterten ihm und immer wieder\nunterbrach er die Arbeit. Er stützte sich gegen die Wand und sah\nzwischen den nackten, blätterlosen Bäumen hindurch auf den Weiher,\nhinüber zu Jaguscha ihrem Haus ... Nein, nicht Liebe wuchs da in\nihm, sondern Wut und tausend feindliche Gefühle, so daß es ihn\nschon wundernahm! »Hündin, Aas, einen Knochen hat man ihr\nhingeworfen und sie läuft,« dachte er. Aber es kamen auf ihn\nErinnerungen zu, krochen von irgendwo heran aus den öden Feldern,\nvon den Wegen, aus den schwarzen Obstgärten mit ihren krummästigen\nBäumen, umstellten sein Herz, hakten sich an seine Gedanken,\ntauchten vor seinen Augen auf ... bis Schweiß seine Stirn bedeckte,\nseine Augen aufglühten und ein starker feuriger Schauer ihn\ndurchrieselte! ... Hah, dort im Obstgarten ... und damals im Wald\n... und als sie zusammen aus der Stadt heimkamen ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Jesus! er torkelte fast, dann plötzlich sah er ganz nahe vor\nsich ihr glutüberflammtes Gesicht, glaubte den leidenschaftlichen\nAtem zu hören; ihre hellblauen Augen, ihr voller Mund, so rot und\nso nah, daß er seinen Hauch spürte, übergossen ihn mit einer Glut\n... und ihre leise, stockende Stimme hörte er leidenschaftlich und\nliebestrunken: »Antosch! ... Antosch!« flüstern/sie neigte sich\nnahe an ihn heran, so daß er ihren Leib dicht bei sich fühlte, ihre\nBrüste, ihre Arme, ihre Knie/und er rieb sich die Augen und jagte\ndiese lockenden Traumgesichte von sich. Seine ganze verbissene Wut\ntaute ihm vom Herzen herab, wie das Eis der Strohdächer, das die\nSonne zur Frühlingszeit erwärmt, und eine solche Liebe erwachte in\nihm aufs neue, eine so schmerzliche Sehnsucht erhob in ihm ihr\nstachlichtes Haupt, ein solches furchtbares Sehnen, daß er am\nliebsten mit dem Kopf gegen die Wand gerannt wäre und gellend\naufgebrüllt hätte!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Daß da der Blitz hineinfahren möchte!« rief er, zu sich\nkommend, und sah scharf auf Witek, ob er nicht irgend etwas merke\n...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page270",
      "title": "lac/rudi49"
    }
  }), _vm._v(" Seit drei\nWochen war er in Fieber, in Erwartung irgendeines Wunders, er wußte\nkeinen Rat, konnte keinen Einspruch erheben! Wie oft waren ihm\nschon die wahnsinnigsten Gedanken und Entschlüsse gekommen, so daß\ner schon hinlaufen wollte, um sie zu sehen, war es eine Nacht\nvielleicht, daß er in Regen und Kälte wie ein Hund vor ihrer Tür\nauf der Lauer gelegen hatte! Sie war nicht herausgekommen, sie mied\nihn, auf der Straße ging sie ihm schon von weitem aus dem\nWeg!...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Wenn nicht, dann schon nicht! Und immer mehr verbiß er sich in\nGroll gegen sie und gegen alles! Dem Vater Seine ist sie, dann gilt\nsie mir dasselbe, wie eine Fremde, irgend so eine Hergelaufene, so\n'n herrenloser Hund, so 'n Dieb, der unser höchstes Gut an sich\nreißt, unseren Boden nimmt/mit dem Knüttel werd' ich sie\nhinaustreiben und noch dazu zu Tode schlagen!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und wollte er nicht oft genug dem Vater vor die Augen treten und\nsagen: ihr könnt Euch nicht mit Jagna verheiraten, denn sie ist\nMeine! Aber die Angst ließ ihm das Haar zu Berge stehen, was wird\ndarauf der Alte sagen, die Leute, das Dorf?...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Jagusch will doch aber seine Stiefmutter werden, eine Mutter\nsozusagen/wie darf denn das sein, wie?... Das muß doch eine Sünde\nsein, eine Sünde! Er hatte sogar Angst, daran zu denken, weil ihm\ndas Herz vor unerklärlichem Grausen zu stocken drohte, aus Furcht\nvor irgendeiner entschlichen Strafe Gottes... Und niemandem davon\nsagen können, und es immer in sich zu tragen, wie eine Glut/wie ein\nlebendiges Feuer, das bis auf die Knochen brennt ... das geht über\nMenschenkraft, das kann er nicht!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und schon in einer Woche soll der Priester sie ihm\nantrauen...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Der Hofbauer kommen!« rief Witek hastig, so daß Antek\nerschrocken aufzuckte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Es dunkelte schon rings im Land...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page271",
      "title": "rudi49/Wunibald"
    }
  }), _vm._v(" Die\nDämmerung schüttete sich über das Dorf aus, wie noch nicht\nerloschene Asche, noch rötlich von verborgenen Gluten/die\nAbendröten brannten aus, verblaßten zur Farbe der dunkelbraunen\nWolken, die der Wind vor sich hertrieb, im Westen aufstaute und zu\nriesenhaften Bergen aufeinandertürmte. Es wurde kalt, die Erde\nerstarrte, die Luft hatte eine Schärfe und eine Frische, als wäre\nNachtfrost zu erwarten, und so hellhörig war sie, daß das\nAufstampfen des zur Tranke getriebenen Viehs lauter herklang, und\ndas Knarren der Einfahrtstore und der hölzernen Brunnenschwengel,\nsowie die Gespräche, Kindergeschrei und Hundegebelfer deutlicher\nvon jenseits des Weihers herüberkamen; hier und da leuchteten schon\ndie Fenster auf und lange, zuckende, zerfetzte Lichtspiegelungen\nfielen auf die Wasserfläche... Am Waldsaum schob sich langsam eine\nrostrote Mondscheibe hervor, Feuerbrände standen über ihr, als ob\nin der Tiefe des Waldes eine große Feuersbrunst lohte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Boryna zog seine Werktagskleider an und ging über den Hof, nach\nder Wirtschaft zu sehen, er guckte zu den Kühen ein, bei den\nPferden, in die Scheune und selbst noch zu den Ferkeln, schnauzte\nJakob wegen irgend etwas an, und Witek kriegte auch was ab wegen\nder Kälber, die aus der Umzäumung ausgebrochen waren und sich\nzwischen den Kühen herumtrieben. Als er wieder in seine Stube\neintrat, warteten sie da schon alle auf ihn... Sie schwiegen, nur\naller Augen richteten sich auf ihn und glitten gleich wieder ab,\ndenn er blieb mitten in der Stube stehen, sah sie sich nacheinander\nan und fragte spöttisch:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Alle da! wie zu irgendeinem Gericht!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Darum nicht, Vater, aber mit einer Bitte sind wir zu euch\ngekommen,« sagte die Schmiedin eingeschüchtert.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und warum ist denn der Deine nicht dabei?...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Er hat eine dringende Arbeit vor, da ist er zu Hause\ngeblieben...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Natürlich ... Arbeit ... natürlich ...,« lächelte er\nverständnisvoll, "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page272",
      "title": "DaoH/horst48"
    }
  }), _vm._v(" warf den Kapottrock ab und fing an, die Stiefel\nauszuziehen; und sie schwiegen, ohne zu wissen, wo sie ansetzen\nsollten. Die Schmiedin räusperte sich und ermahnte die Kinder zur\nRuhe, die anfingen, herumzutollen, Anna saß auf der Schwelle und\nstillte den Jungen und überflog mit unruhigen Augen das Gesicht\nAnteks, der am Fenster lehnte und sich im Kopfe zurechtlegte, was\ner sagen sollte. Er zitterte am ganzen Leibe vor Aufregung und\nUngeduld. Die einzige, Fine, schälte ruhig Kartoffeln am Herd, warf\nStücke Holz aufs Feuer und blickte neugierig alle der Reihe nach\nan, denn sie konnte nichts begreifen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Was wollt ihr, redet?« rief er scharf, durch das Schweigen\nunruhig gemacht.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das heißt ... red' doch, Antek ... das heißt, wir sind\ngekommen, von wegen ... was die Verschreibung ist,« stotterte die\nSchmiedin.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Die Verschreibung hab' ich gemacht und Sonntag ist die Hochzeit\n... laßt es euch gesagt sein!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das wissen wir, aber nicht darum sind wir gekommen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und warum denn sonst?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ganze sechs Morgen habt ihr abgeschrieben!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Weil ich das so wollte, und wenn es mir einfällt, dann werde\nich diesen Augenblick alles verschreiben ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wenn alles euer sein wird, dann werdet ihr's verschreiben!«\nsagte Antek.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und wem seins ist es denn, was, wem seins? ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Der Kinder ihr's, unser.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Dumm bist du, wie 'n Hammel! Der Boden ist mein und ich mach'\nmit ihm, was mir gefällt.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ihr macht es, oder ihr macht es auch nicht ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wirst du's mir verbieten, du?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich, versteht sich, und wir alle, und wenn nicht, dann werden\nes euch die Gerichte verbieten,« schrie er, denn er konnte nicht\nlänger an sich halten und ließ sich von einer sinnlosen Wut\nhinreißen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page273",
      "title": "DaoH/Vera6020"
    }
  }), _vm._v(" »Mit\nGerichten drohst du mir, was? Mit Gerichten! Halt' deine Schnauze,\nsolang ich noch gut bin, sonst wirst du es bereuen!« schrie er, mit\nden Fäusten auf ihn losspringend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Unrecht lassen wir uns nicht tun!« kreischte Anna auf, sich\nhochrichtend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und was willst du? Drei Morgen Land hat sie in die Ehe gebracht\nund einen alten Fetzen und wird hier das Maul aufreißen?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Selbst das nicht habt ihr Antek gegeben, selbst die paar\nMorgen, die ihm von der Mutter Seite zukommen, und arbeiten müssen\nwir für euch wie Gesinde, rein wie die Ochsen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Dafür nehmt ihr die Ernte von drei Morgen ein.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und Arbeit leisten müssen wir euch wie für zwanzig oder noch\nmehr.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wenn ihr meint, daß euch unrecht geschieht, geht hin und sucht\neuch was Besseres.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Suchen brauchen wir nicht, denn hier ist unser Besitz! Unser\nseit Ahn und Urahn!« rief Antek mit Wucht.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Der Alte warf ihm einen harten Blick zu und antwortete nicht; er\nsetzte sich an den Feuerherd und stieß so heftig mit dem Feuerhaken\nin die Scheite, daß die Funken auseinanderstoben. Böse war er,\nfeurige Zornwellen gingen über sein Gesicht und die Haarsträhnen\nfielen ihm immer wieder über die Augen, die wie bei einer Wildkatze\nglühten ... doch er bezwang sich noch, obgleich er kaum an sich\nhalten konnte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Ein lange währendes Schweigen, erfüllte die Stube, so daß man\nnur das Keuchen und die raschen Atemzüge hören konnte. Anna\nschluchzte leise und schaukelte das Kind, das zu greinen angefangen\nhatte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wir haben nichts gegen diese Heirat, wenn ihr wollt, dann\nheiratet ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ihr könnt euch widersetzen, ich geb' nichts drum.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Nehmt doch nur die Abschreibung zurück,« warf Anna unter Tränen\nein.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page274",
      "title": "DaoH/Vera6020"
    }
  }), _vm._v("\n»Willst du wohl still sein, was hast du, gottverflucht nochmal, in\neinem fort herumzuplärren, wie eine Hündin!« Er warf so stark den\nFeuerhaken in die Glut, daß Feuerbrände durchs Zimmer flogen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und ihr mäßigt euch, denn es ist nicht eure Magd, daß ihr das\nMaul aufreißt!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Was hat die denn hier zu schnauzen!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das Recht hat sie schon, denn sie tritt für ihr Eigenes ein!«\nschrie Antek immer lauter.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wenn ihr wollt, dann könnt ihr schon verschreiben, aber was\nübriggeblieben ist, das schreibt für uns ab,« fing die Schmiedin\nleise wieder an ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Guck einer die Dumme an, mit meinem Hab und Gut will sie hier\ndisponieren. Brauchst keine Angst zu haben, auf den Altenteil geh'\nich zu euch nicht ... laßt euch das gesagt sein!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und wir lassen doch nicht ab. Gerechtigkeit wollen wir.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wenn ich einen Knüttel nehme, dann werd' ich euch Gerechtigkeit\nausteilen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Versucht nur anzutippen, dann erlebt ihr gewißlich die Hochzeit\nnicht mehr ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und sie fingen an, sich gegenseitig zu beschimpfen, aufeinander\nloszuspringen, sich zu bedrohen, mit den Fäusten auf den Tisch zu\nschlagen und alle ihre Kränkungen und Klagen herzuzählen! Antek war\nso außer sich geraten und hatte sich so erbost, eine solche Wut\nbrach aus ihm hervor, daß er den Alten mal am Arm, mal an der\nRockklappe schüttelte und bereit war loszuschlagen ..., aber Boryna\nbeherrschte sich immer noch, er wollte keine Schlägerei, schob\nAntek beiseite, antwortete nur hin und wieder auf die\nBeleidigungen, um nur den Nachbarn und dem ganzen Dorf kein\nSchauspiel zu geben! In der Stube erhob sich ein solches Geschrei,\neine solche Unordnung und ein solches Heulen, denn die beiden\nWeiber weinten und schrien um die Wette, und die Kinder kreischten\nebenfalls, daß Jakob und "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page275",
      "title": "DaoH/enterprise11"
    }
  }), _vm._v(" Witek vom Hof aus unter die Fenster\ngelaufen kamen, aber auseinanderkennen konnten sie nichts, weil\nalle zugleich schrien, und zuletzt, als die Stimmen ihnen schon\nversagten, krächzten sie einander nur noch mit Flüchen und\nDrohungen an. Da brach Anna in ein neues gewaltiges Schluchzen aus;\nsie lehnte gegen den Rauchfang und begann mit einer sinnlos\nerregten Stimme, deren Worte durch Tränen fast erstickt waren, zu\nschreien:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Bleibt uns nur übrig, auf den Bettel zu gehen, in die Welt ...\noh, mein Jesus, mein Jesus! ... Wie die Lasttiere haben wir\ngearbeitet, tage- und nächtelang ..., als Gesinde hat er uns\ngehalten ... und jetzt, was? ... Der liebe Gott wird euch strafen\nfür unser Unrecht! ... das wird er ... Ganze sechs Morgen hat er\nverschrieben ... und die Kleiderstücke der Mutter ... und die\nPerlenschnüre ... alles das ... Und für wen ist das alles? Für ein\nsolches Schwein ... Daß du unter dem Zaun verreckst für unser\nUnrecht, daß dich die Würmer zernagen, du Abschaum, du\nStraßendirne, du!...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Was hast du gesagt? ...« brüllte der Alte auf und sprang auf\nsie zu ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Daß sie ein Frauenzimmer für alle ist und ein Rumtreiber, das\nweiß das ganze Dorf ... die ganze Welt weiß das ... alle ... alle\n... alle ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Heb' du dich weg von ihr, sonst schlag' ich dir die Schnauze an\nder Mauer entzwei ... wahr' dich! ...«/Und er fing an, sie hin und\nher zu schütteln, aber Antek sprang hinzu, schützte sie und fing\nebenfalls an, laut zu schreien:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich sag' es mit, daß sie ein Frauenzimmer für jeden ist, ich!\nMit der schlief schon jeder, der es gewollt hat, ich! ...« rief er\nund redete, was ihm der Speichel in den Mund trug; er kam nicht zu\nEnde, denn der Alte, schon bis zum äußersten aufgebracht, schlug\nihm dermaßen mit der Faust ins Gesicht, daß er mit dem Kopf gegen\neinen Glasschrank taumelte und im Fallen ihn mit sich zu Boden riß\n... Er sprang blutüberströmt auf und stürzte sich auf den Vater.\n"), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page276",
      "title": "DaoH/enterprise11"
    }
  }), _vm._v(" Sie\nwarfen sich aufeinander, wie zwei wütige Hunde, packten sich vor\ndie Brust und schoben sich, miteinander ringend, in der Stube hin\nund her, sie warfen einander, schlugen gegen die Betten, gegen die\nLaden und Wände auf, daß die Köpfe krachten. Ein unbeschreibliches\nGeschrei erhob sich, die Frauen wollten sie auseinanderzerren, aber\nes gelang ihnen nicht, denn sie waren schon zu Boden gestürzt, und\nso verknäult miteinander durch Haß und Kränkung, wälzten, drückten\nund würgten sie sich ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Zum Glück hatten sie die Nachbarn bald auseinandergebracht und\nvoneinander entfernt ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Antek trugen sie auf die andere Seite und gossen kaltes Wasser\nüber ihn, weil er ohnmächtig geworden war vor Ermattung und\nBlutverlust, denn die Scheiben des Schrankes hatten ihm das Gesicht\nzerschnitten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Dem Alten war nichts geschehen; sein Spenzer war nur etwas\nzerrissen, das Gesicht zerschunden und ganz blau vor Wut ... Er\nbeschimpfte die Leute, die zusammengelaufen waren, und wies sie zum\nHause hinaus, die Tür zum Flur schloß er ab und setzte sich an den\nFeuerherd ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Aber beruhigen konnte er sich nicht, denn in einem fort kehrte\nihm die Erinnerung an das wieder, was sie von Jagna gesagt hatten,\nes stieß ihn wie mit einem Messer ins Herz ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das werd' ich dir nachtragen, du Hund, das sollst du fühlen!«\nschwor er sich zu. »Wie kann man denn, auf Jagusch ...« Aber gleich\nkam ihm zu Bewußtsein, was er schon öfters über sie gehört hatte,\nwas früher über sie geredet worden war und was er nie beachtet\nhatte! Es überkam ihn heiß und es wurde ihm seltsam atembeklemmend\nund verdrießlich zumute ... »Lügenkram, Klatschmäuler und\nneidisches Pack, das weiß man!« rief er laut aus, aber immer mehr\nvon dem Gerede der Leute kam ihm in den Sinn. »Wie denn, der eigene\nSohn sagt's ja! Wie sollten denn die "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page277",
      "title": "DaoH/gary"
    }
  }), _vm._v(" da nicht herumkläffen? Aaszeug!« Aber diese\nGedanken fraßen wie Feuer in ihm ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Nachdem Fine die Spuren des Kampfes beseitigt hatte, und das\nAbendbrot, wenn auch verspätet, auf den Tisch kam, machte er den\nVersuch, ein paar Kartoffeln zu essen. Er legte aber den Löffel\nbald weg. Es war ihm unmöglich, irgend etwas\nherunterzuschlucken.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hast du den Pferden Futter eingeschüttet?« fragte er Jakob.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Versteht sich ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wo ist Witek?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Zu Ambrosius ist er gelaufen, damit er Antek den Kopf\nverbindet; sein Gesicht ist ihm aufgeschwollen, sieht schon aus wie\n'n Suppentopf,« fügte er hinzu und machte sich gleich davon, denn\nder Mond schien und er hatte gerade heute vor, sich auf Jagd auf\ndie am Waldrand liegenden Felder zu begeben ... »Biester,« brummte\ner vor sich hin, das gute Leben bläht sie auf, darum schlagen sie\nsich.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Auch der Alte hatte sich noch aufgemacht und war ins Dorf\ngegangen, zu Jagna sah er aber nicht ein, obgleich noch Licht bei\nihr war; gerade schon vor ihrer Tür kehrte er um und ging die\nDorfstraße entlang der Mühle zu.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Nacht war kalt und sternenklar; der Nachtfrost ließ die Erde\nerstarren; der Mond hing hoch und schien so hell, daß der ganze\nWeiher wie Quecksilber auffunkelte, die Bäume warfen lange zittrige\nSchatten auf die leeren Wege. Es war schon spät, die Lichter in den\nHäusern erloschen, nur die geweißten Wände traten noch stärker\nhervor aus den kahlen Gärten. Stille und Nacht umfingen das ganze\nDorf, einzig die Mühle ratterte und das Wasser gurgelte eintönig\n... Matheus ging mal auf der einen, mal auf der anderen Seite des\nWeihers auf und ab und wußte nicht, was er mit sich anfangen\nsollte; er hatte sich nicht beruhigt, nein, weit davon entfernt,\ndie Wut und der Haß gruben noch stärker in ihm; bis er schließlich\nnach der Schenke ging und nach dem Schulzen "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page278",
      "title": "rudi49/DaoH"
    }
  }), _vm._v(" schickte, mit dem er dann bis\nMitternacht saß und trank, aber den nagenden Wurm zu ertränken,\nwollte ihm nicht gelingen ... nur einen Entschluß faßte er.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Am nächsten Tag des Morgens, sobald er aufgestanden war, ging er\nauf die andere Seite hinüber. Antek lag noch im Bett, mit einem\nTuch verbunden, das voller Blutflecken war; er richtete sich\nauf.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»In diesem Augenblick verlaßt ihr mein Haus, daß nicht eine Spur\nvon euch nachbleibt,« schrie der Alte. »Willst du Krieg, willst du\nGericht, geh' nach dem Gericht, verklage mich, such' dir dein\nRecht. Was du von deinem gesäet hast, wirst du im Sommer ernten,\nund jetzt, schere dich! Daß meine Augen euch nicht mehr sehen! Hast\ndu gehört!« brüllte er los, denn Antek erhob sich, antwortete\nnichts ... und fing an, sich langsam anzuziehen...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Daß ihr mir bis Mittag weg seid!« rief er noch vom Flur\nher.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Auch darauf antwortete Antek kein Wort, als ob er nichts gehört\nhätte ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Fine, rufe mal Jakob her, er soll die Stute vor den Wagen\nspannen und sie hinausfahren, wohin sie wollen!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hale, dem Jakob fehlt aber was, er liegt auf der Pritsche und\nstöhnt in einem fort, und sagt, daß er gar nicht aufstehen kann, so\nschmerzt ihn das schiefe Bein ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hale, das Bein schmerzt ihn! Das Faultier, sich ausruhen will\ner ...,« und er machte sich selbst an die morgendliche Verrichtung\nder Wirtschaftsarbeit ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Aber Jakob wurde ernstlich krank; er sagte nicht, was ihm\nfehlte, obgleich ihn Boryna danach gefragt hatte; er klagte nur, er\nwäre krank und stöhnte und ächzte so, daß die Pferde wieherten, an\ndie Pritsche herankamen und ihm das Gesicht beschnupperten und\nleckten; Witek trug ihm immer wieder Wasser in einem Eimer zu und\nwusch heimlich im Strom irgendwelche blutige Fetzen ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Der Alte merkte es nicht, denn er stand und paßte auf, daß die\nAnteks wegkamen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page279",
      "title": "beda/DaoH"
    }
  }), _vm._v(" Sie zogen\nauch wirklich aus.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Schon ohne Geschrei, ohne zu zanken, ohne sich zu widersetzen,\nsie packten ihre Sachen, trugen ihre Wirtschaftsgeräte hinaus und\nschnürten ihre Bündel; Anna wurde ein paarmal schlecht vor Kummer,\nso daß Antek ihr Wasser holen mußte, um sie wieder hochzukriegen;\ner trieb in einem fort an, um nur so schnell wie möglich dem Vater\naus dem Gesicht zu kommen ... je eher je besser...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Er hatte sich ein Pferd von Klembs geborgt, das väterliche\nwollte er nicht, und brachte sein Hab und Gut zu Annas Vater\nhinüber, der am Ende des Dorfes, noch hinter der Schenke wohnte\n...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Aus dem Dorf kamen ein paar Hofbauern mit Rochus an der Spitze;\nsie wollten Frieden stiften zwischen den beiden; doch weder Vater\nnoch Sohn ließen sich irgendwie beikommen ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Er mag versuchen, wie die Freiheit schmeckt und das eigene\nBrot,« entgegnete der Alte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Antek antwortete nichts auf die Zureden, er hob nur die Faust\nund stieß einen solchen Fluch aus und drohte so furchtbar, daß\nselbst Rochus erblaßte und zu den Weibern zurücktrat, von denen\nsich eine gehörige Anzahl an den Hecken und auf der Galerie des\nHauses angesammelt hatte, um Anna zu helfen, hauptsächlich aber, um\nlaut zu jammern, das Mundwerk im Gange zu halten und miteinander zu\nklatschen! ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Als Fine mit verheultem Gesicht das Mittagessen für den Vater\nund Rochus aus den Tisch stellte, bogen die anderen mit den letzten\nSachen und den Kindern aus dem Heckenweg auf die Landstraße ...\nAntek sah sich nicht einmal um nach dem Haus, er bekreuzigte sich\nnur und seufzte schwer auf, schlug auf das Pferd ein, stützte den\nWagen, der hoch vollgeladen war und ging, wie ein Toter,\nleichenblaß nebenher. Die Augen glühten ihm im verbissenen Haß und\ndie Zähne knirschten wie im Fieber ... aber er sprach nicht ein\n"), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page280",
      "title": "lac/DaoH"
    }
  }), _vm._v(" einziges Wort;\nAnna aber schleppte sich hinter dem Wagen her, der ältere Junge\nklammerte sich an den mütterlichen Beiderwandrock und schrie\ngottsjämmerlich, den jüngeren hielt sie an ihre Brust gepreßt und\ntrieb ein paar Kühe, zwei magere Ferkel und eine Schar Gänse vor\nsich her, und sie heulte, und wehklagte und fluchte so laut, daß\ndie Menschen aus den Häusern traten und im Zuge wie auf einer\nProzession ihnen nachfolgten ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Beim Alten aß man Mittag in düsterem Schweigen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Der alte Waupa bellte auf der Galerie, lief dem Wagen nach,\nkehrte wieder um und heulte ... Witek rief ihn, aber der Hund hörte\nnicht, lief im Garten umher, beschnüffelte den Hof, stürzte in die\nleere Stube, raste in ihr ein paarmal umher und rannte zurück auf\nden Flur, wo er zu bellen und zu winseln begann; er strich um Fine\nherum, raste wie toll wieder hinaus, blieb sitzen mit starren,\nwirren Augen und sprang schließlich auf, klemmte den Schwanz\nzwischen die Beine und rannte hinter Anteks drein ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Da ist auch der Waupa ihnen nachgegangen ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Der kehrt schon zurück, wenn er erst hungern muß, der kehrt\nzurück, brauchst keine Angst zu haben, Fine,« sagte der Alte weich.\n»Weine nicht. Dummchen, mach' die andere Seite rein, dann wird der\nRochus da 'ne Wohnung haben können. Ruf' Gusche, dann wird sie dir\nhelfen ... und guck' auf die Wirtschaft, bist doch die Hofbäuerin\njetzt, auf deinen Schultern liegt jetzt alles ... na, nun wein' man\nnicht mehr,« er zog ihren Kopf zu sich heran, streichelte, preßte\nsie in die Arme und liebkoste sie.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Nach der Stadt werde ich gehen, dann kauf' ich dir neue\nSchuhe!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Kauft ihr, Väterchen? Werdet ihr wirklich kaufen? ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich kauf' sie dir, ich kauf' dir auch noch mehr, sei nur 'ne\ngute Tochter und paß schön auf die Wirtschaft.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Werdet ihr mir denn auch Stoff für eine Jacke kaufen, wie\nNastuscha Täubich eine hat?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page281",
      "title": "lac/DaoH"
    }
  }), _vm._v(" »Ich kauf'\nihn dir, meine Tochter, ich kauf' ihn ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und Bänder, aber lange, damit ich sie auf eurer Hochzeit tragen\nkann.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Was du nur brauchst, kannst du sagen, alles wirst du kriegen,\nalles.«")]), _vm._v(" "), _c('p', {
    staticClass: "pcalibre6 initial1"
  }, [_vm._v("»Schläfst du denn, Jagusch?\n...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Kann ich denn da schlafen. Schon beim Morgengrauen bin ich\naufgewacht, und immerzu hab' ich es im Kopfe, daß heute Hochzeit\nist ... man kann es kaum glauben.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Bist du bange, meine Tochter, was?« fragte sie etwas leiser mit\neiner ängstlichen Hoffnung im Herzen ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Was sollte es mir da bange sein! Nur daß ich von euch gehen muß\nauf Meines ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Alte erwiderte nichts, sie unterdrückte das Wehmutsgefühl,\ndas sie plötzlich erfaßt hatte, erhob sich vom Lager, kleidete sich\nflüchtig an und ging in den Stall, um die Jungen zu wecken, die\nnach dem gestrigen Polterabend nicht zur rechten Zeit aufgestanden\nwaren und in den vollen Tag hinein schliefen. Der Morgen hatte die\nErde mit einer silbrigen Lichtflut überschwemmt, aus der hier und\nda der Rauhreif aufblinkte. Im Osten entbrannte die Morgenröte, als\nob irgendwer Gluten über den Himmel ausgestreut hatte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Dominikbäuerin hatte ihre Morgenwaschung auf dem Flur\nvorgenommen und machte sich leise in der Stube zu schaffen, doch\nvon Zeit zu Zeit sah sie nach Jagna hinüber, deren Kopf zwischen\nden Kissen des Lagers im Morgengrauen, das noch die Stube erfüllte,\nkaum zu erkennen war ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Liege nur, Tochter, liege du nur! ... Das letztemal schläfst du\nin deiner Mutter Haus,« dachte sie mit Zärtlichkeit und immer\nwiederkehrendem Wehmutsgefühl. Sie konnte nicht glauben, daß es\nwirklich heute schon so weit war und mußte sich alles erst deutlich\nwieder in Erinnerung rufen ... Sie hatte es doch selbst so\ngewünscht, und nun, "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page282",
      "title": "lac/gary"
    }
  }), _vm._v(" nun ... eine Angst hatte sie gepackt und fing sie\nso an zu schütteln, daß sie sich vor Schmerzen krümmte ... Sie ließ\nsich auf den Bettrand nieder ... »Boryna ist ein guter Mann, der\nwird sie in Ehren halten und ihr kein Unrecht antun ... und Jagusch\nwird ihn leiten, wie sie will, denn der Alte sieht nichts in der\nganzen Welt, nur sie ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Nein, nein, deswegen brauchte sie sich nicht zu ängstigen,\ndeswegen nicht ... aber die Stiefkinder! Das war es ... wozu\nbrauchte er die Anteks gleich aus dem Haus zu jagen? Jetzt werden\nsie erst schüren und auf Rache sinnen! ... Und wären sie geblieben,\nund der Antek so dicht daneben, da wär' doch nur was\nGotteslästerliches daraus geworden, oder noch Schlimmeres! ... Oh,\ndu mein Jesus! Und zu helfen gibt's da nichts mehr ... Das Aufgebot\nist schon 'raus ... das Schwein ist geschlachtet, die\nHochzeitsgäste auch schon geladen ... so viel schon fertig ... die\nVerschreibungsurkunde in der Lade ... Nein, nein! Komme was da\nwill, aber ein Unrecht laß ich ihr nicht tun, solange ich lebe!«\ndachte sie entschlossen und ging wieder und schrie die Jungen an,\nwarum sie nicht aufstanden.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Nachdem sie zurückgekommen war, wollte sie Jagna laut anrufen,\ndoch diese war wieder eingeschlafen; vom Bett her kam ihr leiser\ngleichmäßiger Atem, und die Alte faßten wieder verschiedene\nZweifel, und Wehmutsgefühle griffen mit Sperberklauen nach ihrem\nHerzen, zerfleischten es und schrien in ihr mit den Stimmen der\nSorge und der Angst! Sie kniete am Fenster nieder, starrte mit\nihren geröteten, fiebrigen Augen ins Morgenlicht und betete lange\nund heiß. Sie stand neu gekräftigt wieder auf, bereit allem die\nStirn zu bieten!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Jagusch! Steh' auf, Tochter, es ist schon Zeit! die Eve wird\ngleich zum Kochen hier sein, und noch so viel Arbeit ist da!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Is gutes Wetter?« fragte sie, schläfrig den Kopf\nhochrichtend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page283",
      "title": "MEsswein/gary"
    }
  }), _vm._v(" »Und\nwas für eins, es glitzert nur so in der Welt vom Morgenfrost!\nGleich geht die Sonne auf ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Jagna kleidete sich schnell an. Die Alte war ihr dabei\nbehilflich und schien lange zu überlegen, bis sie schließlich\nsagte:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und das will ich dir nochmal sagen, was ich dir schon früher\ngesagt habe ... Den Boryna muß man achten ... ein guter Mensch ist\ner ... Und laß dich nicht wieder mit irgend jemand ein ... damit\nman dich nicht auf den Zungen 'rumträgt ... die Menschen sind wie\ndie Hunde ... die beißen wo sie können! Hörst du mich denn, meine\nTochter? ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich hör' schon, ich hör' schon, und ihr redet, als ob ich nicht\nselber meinen Verstand hätte ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Guter Rat ist niemandem zuviel ... Paß auch darauf, daß du mir\nmit dem Boryna nicht so holterdiepolter umgehst, immer nur sanft\nund mit Güte ... Ein Älterer gibt mehr acht auf so was, wie\nirgendein Grünschnabel ..., und wer weiß, er kann dir noch Grund\nzuschreiben oder etwas Bargeld zustecken!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich geb' nichts drauf,« murrte sie verärgert auf.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Weil du jung bist und dumm ... Seh dich nur mal im Dorf um,\nzwischen den Menschen, da kannst du sehen, um was sie sich zanken\nund abarbeiten und Sorge tragen! Nur um den Grund und Boden, um Hab\nund Gut! Wäre es dir vielleicht gut, ohne diesen heiligen Streifen\nErde, wie? Dich hat der Herr Jesus nicht dazu geschaffen, auf\nLohnarbeit zu gehen und dich durchzuhungern. Und weswegen hab' ich\ndenn mein ganzes Leben gesorgt/nur für dich, Jagusch! Und jetzt\nbleib' ich, wie der einzelne Finger, ganz allein auf mich gestellt?\n...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gehen die Jungen vielleicht in die Welt? Die bleiben dir doch\n...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Von denen hab' ich grad soviel wie von einem Tag, der vergangen\nist!« rief sie aus und zerfloß in Tränen. »Und mit "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page284",
      "title": "MEsswein/gary"
    }
  }), _vm._v(" den Stiefkindern mußt du\nFrieden halten!« fügte sie hinzu, die Augen trocknend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Fine ist 'n gutes Mädchen, Gregor kommt noch nicht bald vom\nMilitär heim ... und ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Vor den Schmiedsleuten mußt du dich in acht nehmen ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Die stehen sich doch mit Matheus, und wie dick ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Da hat der Schmied seine Berechnung bei, die hat er! Aber ich\nwach' schon ... Am schlimmsten ist es mit Anteks, weil sie sich\nnicht versöhnen wollen ... selbst Hochwürden wollte gestern Frieden\nstiften ... sie haben aber nicht gewollt ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Weil Matheus wie 'n böser Hund ist, ... sie so aus dem Hause zu\njagen!« rief sie leidenschaftlich.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Was ist dir bloß, Jagusch, was ist denn? Der Antek hat doch am\nschlimmsten auf dich geredet, den Grund und Boden hat er dir wieder\nwegnehmen wollen und geflucht hat er und hat sich gegen dich\nverschworen, daß man das gar nicht alles wiedersagen kann.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Antek gegen mich? Belogen haben sie euch, daß ihnen ihre\nhäßlichen Zungen verdorren ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Warum hältst du denn auf Anteks Seite, du? ...« klagte sie\ndrohend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Weil alle gegen ihn sind! Ich bin nicht so wie ein Bettlerhund,\nder hinter jedem herläuft, der ihm nur einen Brocken hinwirft! Ich\nsehe gut, daß ihm Unrecht geschieht ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Dann würdest du ihm vielleicht das Verschriebene zurückgeben\n... wie? ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Aber Jagna kam nicht zur Antwort, denn die Tränen stürzten ihr\naus den Augen. Sie rannte in den Alkoven, drückte die Tür hinter\nsich zu und heulte da lange.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Dominikbäuerin störte sie nicht; aber eine neue Sorge glitt\nihr ins Herz hinein... Doch die Zeit war nicht zum Meditieren: Eve\nkam, die Jungen räkelten sich vor der Flurtür, man mußte\ndarangehen, Ordnung zu machen und die letzten Vorbereitungen\ntreffen ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page285",
      "title": "rudi49/gary"
    }
  }), _vm._v(" Die\nSonne war aufgestanden, der Tag rollte rüstig vorwärts.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Es war ein ordentlicher Nachtfrost gewesen, so daß die Pfützen\nauf den Wegen und die Ränder des Weihers sich mit Eis bedeckt\nhatten und das leichtere Vieh sich schon auf den festgefrornen\nWegen halten konnte, ohne einzubrechen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Wärme kam auf, an den Hecken und im Schatten schimmerte es noch\nweißlich, von den Strohdächern jedoch tropfte das Tauwasser in\nleuchtenden Perlenschnüren und auf den Mooren dampften die Dünste,\nwie aufsteigender Rauch. Die Luft war so klar, daß man die\numliegenden Felder wie auf der eigenen Handfläche vor sich liegen\nsah, die Wälder hatten sich näher herangeschoben, so daß man die\neinzelnen Bäume auseinanderkennen konnte ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Auf dem blauen, tiefhängenden Himmel war nicht ein Wölkchen zu\nsehen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Es ging auf gut Wetter, denn die Krähen flatterten zwischen den\nHäusern herum und die Hähne krähten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Ein rechter Sonntag war es, und obgleich die Kirchenglocken noch\nnicht läuteten, wimmelte es im Dorf wie in einem Bienenhaus. Die\nHälfte des Dorfes traf ihre Vorbereitungen zur Hochzeit Jagnas mit\ndem Boryna.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Von einem Haus zum anderen liefen durch die reifbedeckten\nObstgärten Mädchen und trugen Bündel von Bändern, Beiderwandröcke\nund verschiedenfarbenen Putz ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("In den Bauernhöfen herrschte ein großer Wirrwarr, man bereitete\nsich vor, probierte den feinsten Staat an, putzte sich, und durch\ndie vielfach geöffneten Fenster und Türen erklangen schon freudige\nStimmen und selbst Hochzeitslieder.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Auch im Hause der Dominikbäuerin entstand ein Lärm und eine\nVerwirrung, wie es an solchen Tagen üblich ist.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Das Haus war frisch geweißt worden, und obgleich der Kalk von\nder Nässe etwas abgeblättert war, leuchtete es schon von weitem;\nauch geschmückt war es wie zum Pfingstfest. "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page286",
      "title": "MEsswein/gary"
    }
  }), _vm._v(" Die Burschen hatten schon\ngestern überall, ins Strohdach und wo nur Ritzen in den Wänden\nwaren, Tannenreiser gesteckt und den ganzen Heckenweg, von der\nDorfstraße bis zum Flur mit Fichtennadeln bestreut/es duftete wie\nim Forst zur Frühlingszeit.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und auch innen war alles fein säuberlich hergerichtet.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Auf der anderen Seite, wo sonst ein Aufbewahrungsort für altes\nGerümpel war, loderte ein tüchtiges Feuer, an dem die Eve vom\nMüller unter Beihilfe von Gusche und ein paar Nachbarinnen das Amt\nder Köchin versah.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Aus der ersten Stube hatten sie jegliches überflüssige Gerät in\ndie Kammer getragen, daß nur die Bilder zurückgeblieben waren. Die\nJungen stellten starke Bänke und lange Tische an den Wänden entlang\nauf. Die Stube war auch neu geweißt, sauber gescheuert und der Herd\nmit einem hellblauen Leintuch bedeckt. Die Stubendecke und die\naltersschwarzen Balken aber hatte Jagusch reich mit Papiermustern\nverziert. Matheus hatte aus der Stadt buntes Papier gebracht und\nsie hatte daraus zackige Räderchen, Blümlein und verschiedene\nSeltsamkeiten ausgeschnitten; Hunde zum Beispiel, die Schafe vor\nsich herjagen, und den Hirten mit seinem Stock hinterdrein laufend,\noder eine ganze Prozession mit einem Priester, mit Fahnen und\nBildern und andere Verschiedenheiten, daß es schwer ist alles zu\nbehalten; und alles war so getroffen und so lebendig wiedergegeben,\ndaß sich die Menschen gestern am Polterabend darüber gewundert\nhatten./Sie konnte auch ganz anderes noch, alles was sie sich nur\ndachte, oder was sie ansah, konnte sie machen ..., so daß es in\nLipce kein Haus gab ohne diese ihre Papierbilder ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie hatte sich in der Kammer etwas in Ordnung gebracht und kam\nheraus, den Rest der Papierbilder an den Wänden entlang unter den\nHeiligenbildern aufzukleben, denn anderswo war schon kein Platz\nmehr.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Jagusch! du könntest jetzt wahrlich schon deinen wunderlichen\n"), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page287",
      "title": "MEsswein/gary"
    }
  }), _vm._v(" Kram in\nRuhe lassen, die Brautjungfern müssen in diesem Augenblick noch\nkommen... die Menschen fangen bald an, sich einzufinden; die Musik\ngeht auch schon im Dorf herum ... und die gibt sich mit Spielereien\nab...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich komm noch zurecht ...,« gab sie kurzweg zur Antwort, und\nließ bald das Aufkleben nach; denn sie hatte schon keine rechte\nGeduld mehr dazu ... Sie streute noch Fichtennadeln über den\nFußboden aus, bedeckte die Tische mit feinem Linnen, räumte in der\nKammer auf, neckte sich mit den Brüdern herum und ging dann vor die\nTür hinaus, um lange in die Weite zu sehen! Gar keine Freude fühlte\nsie in sich, gar keine. Sie dachte nur, daß sie sich satt tanzen\nwürde und daß es Musik und Singen geben würde, worauf sie gerade\nLust hatte. Sie war wie dieser helle, funkelnde und doch\nherbsttote, stumme Tag. Wenn sie nicht alles daran erinnert hätte,\ndaß heute Hochzeit sein sollte, würde sie nicht daran gedacht\nhaben. Boryna hatte ihr gestern am Polterabend acht Schnüre\nKorallen geschenkt, die er von den beiden Seligen noch hatte... Sie\nlagen tief in der Lade, nicht einmal anprobiert hatte sie sie...\nSie gab nichts drauf, ihr war heute überhaupt alles gleich ... Nur\nirgendwo fortlaufen hatte sie mögen, vor sich hinrennen, wenn auch\nin die weite Welt ... aber wohin da? Wußte sie es denn! Alles war\nihr heute zuwider, immer nur kam es ihr in den Sinn, was die Mutter\nüber Antek gesagt hatte ... »Wie denn nur, er hatte Schlechtes über\nsie geredet, er? ...« Sie konnte das nicht glauben, sie wollte\nnicht ... ein Weinen kam ihr an, wenn sie nur daran dachte! ...\nWenn er aber doch! ... gestern, als sie am Weiher die Wäsche wusch,\nging er vorbei, ohne sie auch nur anzusehen! Und als sie des\nMorgens mit Boryna zur Beichte gingen und ihm vor der Kirche\nbegegneten ... ist er doch auf der Stelle umgekehrt, wie vor einem\nbösen Hund ... Und wenn aber doch? ... Dann laß ihn geifern, wenn\ner so ist, laß ihn geifern!...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie fing an, sich gegen ihn zu empören, plötzlich aber "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page288",
      "title": "rudi49/gary"
    }
  }), _vm._v(" stürzten die\nganzen Erinnerungen an jenen Abend, als sie von Boryna vom\nKohlschälen heimkehrten, auf sie ein, tauchten sie ganz in Feuer,\numschlangen ihre Seele mit solcher Macht und lebten so greifbar in\nihr auf, daß sie sich nicht mehr zu helfen wußte ... und sich mit\neinmal an die Mutter wandte:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wißt ihr aber, nach der Trauung sollt ihr mir nicht mein Haar\nabschneiden!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hale, was die sich Kluges ausgedacht hat!/Hat man das je\ngehört, daß man dem Mädchen nach der Trauung die Haare nicht\nstutzt!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Aber die auf den Herrenhöfen und in den Städten werden auch\nnicht geschoren!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Natürlich, versteht sich, weil ihnen das so paßt für ihre\nZügellosigkeit, damit sie die Menschen beschwindeln und sich für\nwas anderes ausgeben können. Neue Ordnungen wird sie hier\neinführen! Laß die Frauenspersonen vom Herrenhof was Komisches aus\nsich machen, daß die Leute darüber lachen müssen, laß sie mit\nZotteln wie die Judenmädchen herumlaufen/das können sie, wenn sie\nso dumm sind; du aber bist eine Hofbauerntochter von Ahn und Urahn\nund keine Stadtschlampe, darum mußt du es machen, wie es unser\nHerrgott befohlen hat und wie man es immer in unserem Bauernstand\ngehalten hat ... Ich kenne diese städtischen Erfindungen, ich kenn'\nsie ... die sind noch niemandem zum Wohl geraten! Ist nicht die\nPakulanka in die Stadt dienen gegangen, und was nun? ... Der\nSchulze hat es mir gesagt, ein Papier wäre in die Kanzlei gekommen,\ndaß sie ihr Kind erwürgt hat und im Kriminal sitzt ... oder auch\ndieser Wojtek, Borynas Verwandter von der Schwester Seite, hat sich\nmächtig was in der Stadt beiseitegelegt, daß er jetzt in den\nDörfern rundum auf den Bettel gehen muß ... und früher da hatte er\neinen Hof in Wolka, und Pferde und Brot soviel er wollte ...\nSemmeln wollte er essen, da hat er nun einen Stock und einen\nBettelsack für die alten Tage.« "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page289",
      "title": "Monne3/gary"
    }
  }), _vm._v(" Jagna aber gab nicht acht auf die weisen\nBeispiele und wollte nichts vom Abschneiden des Haares wissen ...\nAuch Eve versuchte sie zu überreden, und gerade sie war eine, die\nsich auskannte, nicht nur ein Dorf hatte sie gesehen, und ging\njahraus jahrein mit den Pilgerzügen nach Tschenstochau. Auch die\nGusche machte ihr die Sache klar, aber wie sie nun einmal war,\nkonnte es nicht ohne Sticheleien und Gespött abgehen, und\nschließlich sagte sie:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Laß du den Zopf, laß ihn nur, der wird Boryna zu paß kommen, um\ndie Hand wird er ihn sich wickeln, um dich besser dran zu halten\nund dir fester mit dem Stock welche draufzuzählen ... dann wirst du\nihn noch selber abschneiden... Ich kannte manch eine ...« weiter\nkam sie nicht, denn Witek tauchte auf, um sie zu rufen. Nach der\nVertreibung der Anteks war sie nämlich zu Boryna übergesiedelt,\nweil Fine mit der Wirtschaft nicht fertig werden konnte. Sie half\nheute der Eve beim Kochen, und ging ab und zu hinüber, auf die\nWirtschaft zu sehen, denn der Alte hatte heute zu nichts Sinn, die\nFine war schon seit Morgen bei den Schmiedsleuten, um sich da\nauszuputzen, und der Jakob lag noch immer krank.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Kommt rasch, der Jakob verlangt nach euch,« drängte der\nJunge.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Geht es ihm denn schlechter?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Versteht sich, er jammert und stöhnt, daß man es bis auf der\nDorfstraße hört!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich komm' in diesem Nu. I du mein, ich will nur eben sehen, was\nmit ihm los ist und komm' gleich wieder ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Beeil' du dich auch, Jagusch. Wir haben gleich die\nBrautjungfern im Haus,« trieb die Mutter an.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Aber Jagusch eilte sich nicht, sie ging wie im Traum herum, ließ\nsich hier und da auf eine Bank fallen, dann wieder sprang sie auf\nund fing an aufzuräumen, aber die Arbeit glitt ihr aus den Händen,\nund sie blieb lange stehen, gedankenlos durchs Fenster starrend.\nDie Seele schaukelte in "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page290",
      "title": "Monne3/gary"
    }
  }), _vm._v(" ihr wie bewegtes Wasser und schlug immer wieder\nan die Erinnerungen, wie gegen einen Stein ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Im Hause aber entstand ein immer lauteres Stimmengewirr, denn in\neinem fort kamen verschiedene Gevatterinnen, Verwandte und\nHofbäuerinnen hereingelaufen und brachten nach der alten Sitte\nHühner, einen Leib Weißbrot, Butterkuchen, Salz, Mehl, Speck oder\nauch einen in Papier gewickelten Silberrubel / und alles das als\nDank für die Hochzeitseinladung, damit die Wirtin sich nicht zu\ngroße Unkosten machen sollte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie tranken der Brautmutter mit einem Gläschen Süßen zu,\nplauschten miteinander, bestaunten alles und liefen rasch ihrer\nWege.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Dominikbäuerin war emsig an der Arbeit / sie überwachte die\nZubereitung des Festschmauses, räumte auf, gab Anweisungen, hielt\nihr wachsames Auge über allem und hatte für alles einen guten Rat\nbereit; sie mußte die Jungen immerzu antreiben, denn sie ließen\nsich viel Zeit, und sobald es nur ging, lief einer von ihnen ins\nDorf zum Schulzen, denn da waren schon die Musikanten, und die\nBrautführer sammelten sich dort.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Zum Gottesdienst war kaum einer gegangen, was Hochwürden recht\nerzürnt hatte, denn um einer Hochzeit willen durfte man doch nicht\nden Kirchgang vergessen / was ja schon recht war, aber das Volk\nmeinte, daß solche Hochzeiten nicht jeden Sonntag gefeiert\nwürden.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Gleich nach Mittag fingen die geladenen Gäste aus den\nbenachbarten Dörfern an einzutreffen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Sonne hatte schon die Mittagshöhe überschritten und streute\nblasses herbstliches Licht aus, so daß die Erde wie übertaut\ngleißte, die Fenster flammten, der Weiher schimmerte und glitzerte,\ndie wassergefüllten Gräben am Weg flimmerten wie Fensterscheiben\nund die ganze Welt war wie gesättigt mit dem Licht und mit der\nletzten Wärme des ersterbenden Herbstes.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page291",
      "title": "DaoH/gary"
    }
  }), _vm._v(" Eine\ndumpfe, stumme Stille umhüllte die übergoldete Erde.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Der Tag brannte grell zu Ende und erlosch langsam.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Aber in Lipce war ein Getöse wie auf einem Jahrmarkt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Gleich nachdem man die Vesper ausgeläutet hatte, schoben die\nMusikanten vom Hause des Schulzen auf die Dorfstraße hinaus.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Zu vorderst kam die Geige mit der Flöte, hintennach brummelte\ndie Trommel mit den klirrenden Schellen, und der Brummbaß im Putz\nder bunten Bänder hupfte hinterdrein.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Hinter den Musikanten kamen die beiden Brautbitter und die\nBrautführer/sechs an der Zahl.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und alles junge Burschen, stattlich und schlank wie Fichten\nanzuschauen, dünn in der Taille, in den Schultern breit gewachsen,\nleidenschaftliche Tänzer, trotzige, herrische Schnauzen, stolze\nDraufgänger, die vor nichts beiseite drehen/lauter Hofbauernsöhne,\nerbangesessene.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie stampften zu einem Haufen eng aneinander gedrängt inmitten\ndes Wegs daher, so daß die Erde unter ihren Füßen dröhnte; sie\nkamen freudig und festlich angeschritten und waren prächtig\nanzusehen. Die gestreiften Hosen, die roten Spenzer, die Büschel\nbunter Bänder an den Hüten ließen ihre Farben im Sonnenschein\nspielen und die aufgeknöpften weißen Haartuchröcke blähten sich im\nWind wie Flügel ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie juchheiten hellauf, sangen sich einen, trampelten verwegen\nim Takt dazu und kamen so brausend dahergezogen, als ob ein junger\nForst sich im Sturm auf die Wanderschaft gemacht hätte ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Musik spielte ihnen einen Polnischen auf und sie zogen von\nHaus zu Haus, die Hochzeitsgäste einzuholen./ Hier trug man ihnen\nBranntwein heraus, dort lud man sie in die Stube ein, anderswo\nantwortete man ihnen mit Gesängen/ und von überall kamen\ngeschmückte Menschen herbei, "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page292",
      "title": "DaoH/gary"
    }
  }), _vm._v(" die sich ihnen anschlossen, um gemeinsam\nweiterzuziehen. Vor den Fenstern der Brautjungfern stimmten schon\nalle miteinander das althergebrachte Lied an:")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Komm' heraus, Brautjungferlein, komm' heraus\nKathrinchen,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nKomm', es ist schon Zeit/"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nEs werden dir spielen, es werden dir singen"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nBaß und Geige zum Geleit/"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nUnd wer nicht satt zu essen kriegt und nicht genug zu trinken\n..."), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nDer geh' nach Haus zur rechten Zeit!"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nOj-ta-dana-dana! Oj-ta-dana-da! ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie juchzten gemeinsam und mit solcher Macht, daß es durchs\nganze Dorf schallte, daß die frohen Stimmen über die Felder\nklangen, im Wald hallten und in die weite Welt flogen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Leute traten vor die Häuser, eilten in die Gärten,\nkletterten auf die Zäune, und auch manch einer, der nicht zu der\nHochzeitsgesellschaft gehörte, schloß sich ihnen an, um Aug und Ohr\nzu sättigen. Fast das ganze Dorf hatte sich um die Hochzeitsbitter\ngeschart und sie mit einem dichten Haufen umdrangt, ehe sie noch\nankamen, so daß sie immer langsamer gingen. Ein zahlloser\nKinderschwarm rannte ihnen voraus, kreischte und sang mit.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie geleiteten die Gäste bis ans Hochzeitshaus und spielten\nihnen zu einem würdigen Eintritt auf, um dann nach dem Haus des\nBräutigams umzukehren.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Witek, der im Spenzerrock mit Bandkokarde und flatternden\nBändern stolz hinter den Brautführern herging, sprang jetzt\nvoraus.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hofbauer, die Musik mit den Brautführern kommt!« schrie er ins\nFenster hinein und rannte zu Jakob hin.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Mit Schwung begannen sie auf der Hausgalerie zu spielen; da trat\nin einem Nu Boryna heraus, sperrte die Tür weit auf, begrüßte sie\nalle und lud sie ein, hineinzutreten; doch der Schulze und Simeon\nfaßten ihn unter die Arme und führten ihn schon geradewegs zu\nJagna, denn es war Zeit, zur Kirche zu gehen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page293",
      "title": "DaoH/gary"
    }
  }), _vm._v(" Er ging\nrasch, und es war erstaunlich, wie jung er aussah; das Haar\ngestutzt, das Gesicht sein sauber ausrasiert, sah er stattlich aus\nin seiner festlichen Kleidung wie kaum einer; und da er mächtig\nviel von sich hielt, so fiel seine breitgewachsene Gestalt schon\nvon weitem auf durch die Würde, die sich auch in seinem Antlitz\nausprägte; er scherzte fröhlich mit den Burschen, redete dies und\ndas und wandte sich immer wieder an den Schmied, der ihm ständig in\nden Weg kam.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Würdig führten sie ihn zur Dominikbäuerin hinein; das Volk trat\nauseinander, sie aber geleiteten ihn mit Musik und Singen\ngeräuschvoll in die Stube.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Jagusch war nicht zugegen, die Frauen putzten sie noch in der\nKammer, die fest verschlossen war und eifrig gehütet wurde, denn\ndie Burschen versuchten gegen die Tür anzudrücken und eine Ritze in\nder Bretterwand aufzukratzen. Sie neckten sich in einem fort mit\nden Brautjungfern herum, so daß ein Gekreisch, Gelächter und\nWeibergeschrei entstand.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Mutter mit den Söhnen empfing die Gäste, bewirtete sie mit\nSchnaps, führte die Respektspersonen nach den Bänken und gab auf\nalles acht. Es hatte sich so viel Volk eingefunden, daß man sich\nnur mit Mühe durch die Stube drängen konnte; sie standen bis auf\ndem Flur und selbst noch auf dem Heckenweg. Und nicht geringe\nGäste, nein. Lauter Hofbauern, erbangesessene und von den\nreichsten. Alles Verwandte und Verschwägerte, Vetters- und\nGevattersleute der Borynas und Patsches, obendrein noch alle guten\nBekannten selbst aus den Dörfern weit im Umkreis.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Natürlich, daß weder Klemb noch die Wintzioreks noch die armen\nTeufel, die auf einem Morgen saßen, mit dabei waren, oder gar das\nkleine Volk, das auf Taglohn ging und es immer mit dem alten Klemb\nhielt ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Nicht für den Hund ist die Wurst und nicht für die Schweine der\nHonig!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page294",
      "title": "DaoH/gary"
    }
  }), _vm._v(" Erst in\netwa zwei Paternostern öffnete man die Tür zur Kammer und die\nOrganistin mit der Müllerin führten Jagusch in die Stube. Die\nBrautjungfern bildeten einen Kranz um sie; sie hatten sich so\ngeputzt und sahen so stattlich aus, daß sie wie Blumen waren und\ndoch nicht Blumen, und die Braut, die am stattlichsten gewachsene\nvon allen, stand wie die schönste Rose mitten unter ihnen, ganz in\nbunten Samten, in weißen Stoffen, in Federn, Bändern, Silber und\nGold/so daß sie wie ein Bild anzusehen war, daß man bei den\nProzessionen voranträgt. Es wurde plötzlich ganz still, so stumm\nund starr waren die Leute.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Ha! wahrlich! Seit Mazuren Mazuren ist, gab es hier keine\nschönere Braut!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Im Nu vollführten die Brautführer einen starken Lärm und sangen\naus voller Kehle:")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Spiele, Geiger, spiele vor dem Haus,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nUnd du, Jagusch, söhn' dich mit den Eltern aus!"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nSpiele, Geiger, spiele vor dem Haus,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nUnd du, Jagusch, söhn' dich mit den Brüdern aus!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Boryna trat hervor, faßte ihre Hand und kniete mit ihr nieder,\ndie Mutter machte ein Kreuz über beide mit einem Heiligenbild,\nsegnete sie und sprengte Weihwasser aus, bis Jagusch mit einem Male\nzu weinen anfing und ihre Füße umfaßte, dann umschlang sie die Knie\nder anderen, bat um Verzeihung und nahm Abschied von allen. Die\nFrauen nahmen sie in die Arme, umhalsten sie und schoben sie\neinander zu, bis sie alle mitsammen zu weinen anfingen; mit der\ngrößten Inbrunst begann aber Fine zu schluchzen, da ihr die selige\nMutter in den Sinn kam.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Alles strömte zum Hause hinaus, stellte sich in Reih und Glied\nund ging zu Fuß der nahegelegenen Kirche zu.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Musikanten gingen voraus und bliesen und schwangen die\nFiedelbogen aus vollen Kräften.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Hinter ihnen wurde Jagna von den Brautführern geleitet/ sie ging\nim üppigen Gang, durch Tränen lächelnd, die "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page295",
      "title": "DaoH/gary"
    }
  }), _vm._v(" ihr noch an den Wimpern hingen;\nfestlich war sie wie ein Blütenstrauch und zog wie eine Sonne die\nAugen aller auf sich; ihr Haar umkränzte die Stirn in Flechten, und\nüber ihnen trug sie eine Brautkrone aus Pfauenfedern, güldenem Tand\nund Rosmarinblütenzweigen. Und lange buntfarbene Bänder fielen von\ndieser Krone auf ihre Schultern herab und flatterten und flogen\nsurrend in einem Regenbogen hinter ihr her; der weiße Rock war\nreich gekräuselt in der Taille, das Mieder aus himmelblauem Samt\nwar mit Silber ausgenäht, das Hemd hatte weitgebauschte Ärmel und\nschloß am Halse mit einer blau festonierten, reich gefältelten\nFalte ab; Schnüre von Korallen und Bernsteinperlen hingen ihr bis\nauf die Brust herab.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Dann folgten die Brautjungfern mit Matheus. Wie die breitastige\nEiche im Forst der schlanken Fichte folgt, so folgte er Jagusch\nnach; er schaukelte sich in den Hüften und sah sich nach beiden\nSeiten des Weges um. Ihm war als hatte er eben Anteks Gesicht im\nGedränge auftauchen sehen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und dann erst kam die Dominikbäuerin mit den Brautbittern, die\nSchmiedsleute, Fine, die Müllersleute, die Organistin und was so\ndie ersten waren.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Zum Schluß aber drängte das ganze Dorf ihnen nach, den Weg dicht\nfüllend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Sonne ging schon unter, hing rot und groß über dem Walde und\nübergoß den ganzen Weg, den Weiher und die Häuser mit einem\nblutigen Schein; sie aber gingen langsam in diesen Gluten dahin,\ndaß es einem in den Augen flimmerte, von diesen Bändern,\nPfauenfedern, Blumen und all diesen roten Beinkleidern,\norangefarbenen Frauenröcken, Kopftüchern und weißen Männerröcken.\nEs war als ob ein mit aufgeblühten Blumen bedecktes Feld langsam\ndem Wind entgegenging und schaukelte und sang, die Brautjungfern\nnämlich stimmten immer wieder mit dünnen Stimmen das Lied an:")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page296",
      "title": "DaoH/gary"
    }
  }), _vm._v(" Es fahren, es fahren, es rollen die Wagen/"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nSie taten dir weinend den Abschied sagen ..."), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\n          Hei!"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\n\nDie frohen Lieder singen und klingen/"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nSie werden dir, Jagusch, Bitternis bringen ..."), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\n          Hei!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Dominikbäuerin setzte während des ganzen Weges immer wieder\nzum Weinen an und bestaunte die Tochter wie ein Heiligenbild, so\ndaß sie nichts hörte, was man zu ihr sprach.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("In der Kirche zündete schon Ambrosius die Kerzen auf dem Altar\nan.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("In der Vorhalle machten sie sich noch zurecht, ordneten sich zu\nPaaren und marschierten dann auf den Altar los, denn auch der\nPriester kam schon aus der Sakristei.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Trauung vollzog sich rasch, denn der Priester hatte es eilig\nzu einem Kranken. Und als sie die Kirche verlassen wollten, fing\nder Organist an, auf der Orgel solche Mazurkas, Obereks und solche\nKujawentänze aufzuspielen, daß die Füße von selbst aufzuckten, und\nmanch einem wäre fast ein Lied entschlüpft;/ein Glück, daß er sich\nnoch zur rechten Zeit besonnen hatte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie kehrten schon ohne jegliche Festordnung, die ganze Breite\nder Dorfstraße einnehmend, heim, und gingen wie es grad' einem\njeden gefiel. Es ging schon ziemlich hoch her, denn die Brautführer\nund Brautjungfern sangen, als gälte es ihr Leben.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Dominikbäuerin lief schneller voraus, und als sie kamen,\nbegrüßte sie schon Braut und Bräutigam auf der Schwelle des Hauses\nmit geweihtem Brot, Salz und einem Heiligenbild, und fing danach\nerst an, die anderen von neuem zu bewillkommnen, zu umarmen und in\ndie Stube zu bitten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Musik spielte im Flur auf, und jeder, der über die Schwelle\nkam, griff nach der ersten besten Frau, deren er habhaft werden\nkonnte und fügte sich mit ihr gleitenden "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page297",
      "title": "DaoH/gary"
    }
  }), _vm._v(" Schrittes in den »Gehetanz« ein/so\nzogen die Paare wie eine buntgescheckte Schlange in der Stube im\nKreise herum, bogen sich, umkreisten sich, kehrten bedächtig um,\nstampften würdevoll auf, wiegten sich wie es sich gehörte, gingen,\nschoben sich vorüber, schlängelten sich Paar nach Paar, Kopf bei\nKopf/wie ein ins Wogen gekommener Streifen reifen Roggens, den Mohn\nund Kornblumen reich durchwirken/ und vorne als erstes Paar war\nJagusch mit Boryna!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Lichter, die am Gesims des Rauchfanges aufgestellt waren,\nflackerten, das Haus wankte, so daß es schien als müßten die Wände\nbersten von all dem Gedränge und der Macht, die von den Tänzern\nströmte ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie wandelten ein gutes Paternoster lang, ehe sie fertig\nwurden.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Musik fing jetzt an, zum ersten Brauttanz zu präludieren,\neiner alten Sitte gemäß.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Leute hatten sich an den Wänden entlang dicht\nzusammengedrängt und füllten alle Winkel, die Burschen aber\nbildeten einen großen Kreis, in dem Jagna zu tanzen begann! Das\nBlut wallte in ihr auf, daß ein Leuchten in ihre blauen Augen stieg\nund die weißen Zähne aus dem erglühten Gesicht aufblitzten; sie\ntanzte unermüdlich, die Tänzer immer wieder wechselnd, denn wenn es\nauch nur einmal in die Runde sein sollte, so mußte sie doch mit\njedem herumtanzen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Musikanten spielten scharf, daß ihnen fast die Hände lahm\nwurden, aber Jagusch hatte erst begonnen; ihr Gesicht hatte sich\nnur etwas stärker gerötet; sie wirbelte mit solcher Leidenschaft im\nKreise herum, daß die Bänder surrend hinter ihr her flatterten, die\nGesichter der Umstehenden peitschend, und ihre Röcke, vom\nWirbelwind des Tanzes aufgebläht, sich in der Stube\nausbreiteten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und die Burschen trommelten vor Vergnügen mit den Fäusten auf\ndie Tische und stießen verwegene Juchzer aus.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page298",
      "title": "DaoH/gary"
    }
  }), _vm._v(" Erst zum\nSchluß wählte sie sich den Bräutigam/Boryna hatte darauf schon\nlängst gewartet; er sprang wie ein Luchs auf sie zu, faßte sie um\ndie Taille und drehte sie stürmisch vom Fleck weg im Kreise herum,\nden Musikanten zuschreiend:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Den mazurischen Jungen, aber 'n festen!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("... Sie stießen aus ganzer Macht in die Instrumente, so daß es\nin der Stube aufkochte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Boryna aber umfaßte Jagna nur noch stärker, warf die Rockschöße\nüber den Arm, setzte den Hut zurecht, klappte die Absätze\ngegeneinander und stob von der Stelle wie ein Sturmwind davon!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Heia! wie der tanzte! ... tanzte ... tanzte ... wie er sich auf\neiner Stelle um sich selber drehte, linksum schwenkte, mit den\nHacken einen Wirbel schlug, daß vom Fußboden die Splitter flogen\nund laut aufjuchzte, und mit Jagusch herumwarf und wirbelte, bis\nsie nur noch wie ein wirres Knäuel waren und wie eine\nvollgewickelte Spindel sich in der Stube drehten./Es strömte nur\nmehr ein Wind und eine einzige Kraft von ihnen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("... Die Musik fiedelte glühend, selbstvergessen ihre maurische\nWeise ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Alles drängte sich in die Türen und staute sich in den Ecken,\nverstummte und sah mit Staunen zu; er aber tanzte, unermüdlich und\nimmer verwegener. Es konnte schon manch einer nicht mehr an sich\nhalten, denn die Füße sprangen ihm schon von selber, so trampelte\nman nur im Takte mit, und wer hitziger war, nahm sein Mädchen und\nwarf sich in den Tanz, auf nichts mehr achtend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Jagusch aber wurde doch bald matt, obgleich sie kräftig genug\nwar, und fing an, ihm aus den Händen zu gleiten; da erst hörte er\nauf und führte sie in die Kammer.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Da du ein solcher Prachtkerl bist, so laß uns Brüder sein, und\nbei der ersten Taufe sollst du mich zum Paten haben!« rief der\nMüller, ihn in seine Arme schließend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page299",
      "title": "DaoH/gary"
    }
  }), _vm._v(" Sie\nverbrüderten sich gleich herzlich, denn die Musik verstummte und\ndie Bewirtung begann.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Dominikbäuerin, die Söhne, der Schmied, die Gusche gingen\neifrig mit vollen Flaschen, die Schnapsgläser in der Hand, herum\nund tranken einem jeden einzeln zu. Fine aber und die Gevatterinnen\nreichten Butterbröte und Kuchen auf Sieben umher.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Ein immer größerer Lärm entstand, denn jeder sprach laut sein\nTeil, und alle griffen erfreut nach den Gläsern, um sich das Fest\nso recht zugute kommen zu lassen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Auf die Bänke am Fenster setzten sich der Müller mit Boryna, der\nSchulze, der Organist und was so die ersten Hofbauern waren. Es\nging dort schon eine nicht zu kleine Flasche Arrak von Hand zu Hand\nund nicht in einer Runde; man trug ihnen außerdem noch Bier\nhinzu/sie tranken eifrig auf gegenseitiges Wohl, fingen schon an,\nsich zu umarmen und sich miteinander mächtig zu verbrüdern!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und in der Stube stand das Volk haufenweis beieinander, mit wem\nund wie es einem gerade paßte, man redete laut und unterhielt sich\nnicht schlecht bei seinem Gläschen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("In der Kammer, die von einer von den Organistenleuten geborgten\nLampe erhellt war, hatten sich die Hofbäuerinnen, mit der\nOrganistin und Müllerin an der Spitze, niedergelassen; auf Truhen\nund Bänken, die mit Beiderwandröcken bedeckt waren, saßen sie\nwürdevoll, schlürften Meth durch die Zähne, bröckelten sich mit\ngespreizten Fingern Stückchen von ihrem süßen Kuchen ab, und wenn\neine hin und wieder etwas sagte, so war es nur ein Wort: sie hörten\naufmerksam zu, was die Müllerin von ihren Kindern erzählte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Selbst im Hausflur herrschte eine Enge, und etliche versuchten\nobendrein schon auf die andere Seite einzudringen. Eve mußte sie\nhinaustreiben, denn man bereitete emsig das Abendessen vor, von dem\nschon liebliche Düfte durchs ganze Haus zogen, so daß es manch\neinen in die Nase stach.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page300",
      "title": "DaoH/gary"
    }
  }), _vm._v(" Die Jugend\nhatte sich vors Haus begeben, verweilte auf dem Heckenweg und saß\nauf der Mauerbank. Die Nacht war kalt, still und ganz wie mit\nSternen betaut, man kühlte sich ab und tollte lustig herum, daß es\nvor Lachen, Gekreisch und Gelaufe nur so dröhnte; einige jagten im\nObstgarten hintereinander her, so daß die Alten ihnen aus den\nFenstern zuschrien:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Blümlein sucht ihr da, Mädels? Paßt ihr auf, daß ihr da nichts\nverliert im Dustern.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Wer tat auf sie achten?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("In der ersten Stube aber wandelten Jagusch und Nastuscha Täubich\nherum, hielten sich umschlungen, kicherten immerzu und flüsterten\nsich allerhand ins Ohr. Schymek, der Älterste der Dominikbäuerin,\nhatte sein Augenmerk auf sie gerichtet und verfolgte Nastuscha mit\nseinen Blicken überallhin, trat immer wieder mit Schnaps an sie\nheran, lachte sie an und versuchte ein Gespräch anzuknüpfen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Der Schmied, festlich gekleidet in einem schwarzen Knierock, die\nHosen über die Stiefelschäfte, machte sich am eifrigsten zu\nschaffen, er war überall da, trank mit jedermann, forderte auf,\nbewirtete, räsonnierte und war so geschäftig, daß man immerzu in\neiner anderen Ecke seinen rothaarigen Kopf mit dem sommersprossigen\nGesicht auftauchen sah.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Jugend hatte ein paarmal herumgetanzt, doch nur kurz und\nohne große Lust, da man schon auf das Festmahl lauerte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Alten aber redeten untereinander, und der Schulze, der schon\nangetrunken war, schrie immer lauter, blähte sich, schlug mit der\nFaust auf den Tisch und trumpfte auf:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Der Schulze sagt es euch, dann glaubt. Ein Beamter bin ich, das\nPapier hab' ich gekriegt und Order hab' ich, die Gemeinde zu\nberufen, damit wir ein paar Groschen pro Morgen für die Schule\nbewilligen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ihr könnt euch gern auch fünf Kopeken pro Morgen bewilligen,\nPeter, wir tun nicht einen Heller geben!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page301",
      "title": "lesebaer/gary"
    }
  }), _vm._v(" »Das\ntun wir nicht!« wetterte einer los.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Still da, nötig ist es, wenn eine amtliche Person das sagt\n...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Eine solche Schule brauchen wir nicht!« sagte Boryna.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Jawohl, die brauchen wir nicht,« wiederholten die anderen im\nChor.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hast du nicht gesehen ... In Wola haben sie solche Schule, drei\nWinter lang sind meine Kinder hingegangen; und was? ... nicht mal\nihr Gebet können sie aus dem Gebetbuch lesen ... für die Katz ist\nsolch ein Unterricht!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Laßt die Mütter das Gebet lehren, dazu ist nicht die Schule da,\nich sag' es euch, der Schulze.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und wozu denn sonst zum Beispiel?« brüllte der andere aus Wola\nlos und sprang von der Bank auf.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich, der Schulze, will es euch sagen, paßt nur gut auf...\ngleich, zum ersten ...« aber er brachte seine Erklärung nicht zum\nSchluß, denn Simeon schrie über den ganzen Tisch herüber, den\nverkauften Wald hätten die Juden schon gezeichnet und würden ihn\nbald fällen, sie warteten nur auf Frost und Schlittenbahn.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Laß sie sich man ihren Wald zeichnen, das Fällen können sie\nsich in den Baum hängen ...,« warf Boryna ein.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Zum Bauernkommissar gehen wir klagen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das ist nichts, der Kommissar hält es doch mit dem Gutsherrn;\naber alle zusammen sollte man hingehen und die Holzschläger\nauseinander jagen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Nicht eine Tanne darf man fällen lassen!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Man wird eine Klage vor Gericht einreichen!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Trinkt nur zu, Matheus, jetzt ist nicht die Zeit zum\nBeratschlagen! Wenn man beim guten Trunk sitzt, ist es schon\nleicht, zu drohen, und wenn es selbst dem Herrgott wäre,« rief der\nMüller, frisch einschenkend. Diese Reden und Drohungen gingen ihm\nwider den Strich, denn er hatte sich mit den Juden geeinigt und\nsollte ihnen auf seiner Sägemühle das Holz schneiden.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page302",
      "title": "lesebaer/gary"
    }
  }), _vm._v(" Sie\ntranken einander sitzend zu und erhoben sich darauf, denn man fing\nschon an, sich für das Abendessen vorzubereiten, das nötige Gerät\nzusammenzutragen und auf die Tische zu setzen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Bauern ließen aber die Waldfrage nicht fahren, wie sollte\nman das auch, ein solcher wunder Punkt,... darum drängten sie sich\nzusammen und mit gedämpfter Stimme, damit es der Müller nicht\nhörte, beratschlagten sie und verabredeten sich, bei Boryna\nzusammenzukommen, um irgendeinen Beschluß zu fassen ... aber sie\nkamen nicht zu Ende, denn Ambrosius kam herein und schloß sich\nihnen ohne weiteres an. Er hatte sich verspätet, da er mit\nHochwürden bis im dritten Dorf, in Krosnowa, bei einem Kranken\ngewesen war, und machte sich jetzt tüchtig ans Trinken, um alles\nnachzuholen ... Doch es war nicht mehr Zeit genug, denn die älteren\nFrauen sangen schon im Chor:")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Und ihr lieben Brautführer, heut'"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nLadet zu Tisch die guten Leut'!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Darauf mit den Bänken einen Lärm vollführend, gaben die\nBrautführer zur Antwort:")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Sie sind schon geladen, sie sitzen zu Hauf"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nUnd gebt ihr was gutes dann essen sie's auf!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und bedächtig ging man um die Tische herum, sich auf die Bänke\nzu setzen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Selbstverständlich saß auf den ersten Plätzen das Brautpaar, und\ndaneben von beiden Seiten, was so die ersten im Dorf waren dem\nAnsehen, dem Vermögen und dem Alter nach, bis herunter zu den\nBrautjungfern und Kindern. Sie hatten kaum Platz gefunden, obgleich\ndie Tische an drei Wänden entlang aufgestellt waren.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Nur die Brautführer, die die Gäste bedienten, sowie die\nMusikanten setzten sich nicht.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Das Gewirr der Stimmen hatte sich gedämpft und nur der Organist\nsprach laut und stehend das Gebet/der Schmied allein sprach mit,\ndenn, wie man wußte, konnte er ... auf "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page303",
      "title": "lesebaer/gary"
    }
  }), _vm._v(" Lateinisch, und dann tranken\nsie jeder einen auf die Gesundheit und zum guten Appetit.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Köchinnen begannen unter Beihilfe der Brautführer gewaltige\ndampfende Schüsseln voll Essen hineinzutragen und sangen dazu:")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Wir bringen euch Schüsseln voll Brühe mit\nReis"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nUnd drin selbst ein Federvieh zart und weiß!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und beim zweiten Gang wurde gesungen:")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Kutteln mit Pfeffer und Salzen"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nLaßt froh die Zungen schnalzen!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Musikanten aber setzten sich um die Herdstelle und spielten\nleise verschiedene Liedchen vor, um das Behagen am Schmaus zu\nsteigern.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie aßen denn auch voll Würde, langsam und fast im Schweigen vor\nsich hin, kaum einer ließ ein Wort fallen, so daß nur das Schnalzen\nder Zungen und das Schaben der Löffel die Stube füllte. Und als sie\nschon etwas gegessen hatten und der erste Hunger gestillt war, ließ\nder Schmied wieder eine Flasche die Runde machen, wobei man schon\nanfing, etwas lebhafter zu reden und über den Tisch weg miteinander\nzu räsonnieren.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Einzig Jagusch aß so gut wie gar nichts, vergeblich redete\nBoryna auf sie ein, faßte sie um die Taille und redete ihr zu, wie\neinem kleinen Kind. Nicht einmal ein Stückchen Fleisch konnte sie\nherunterschlucken, so ermüdet war sie und heiß. Hin und wieder nur\ntrank sie einen Schluck kaltes Bier, ließ die Augen durch die Stube\nschweifen und hörte mit einem Ohr auf Borynas Geflüster hin.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Freust du dich, Jagusch, was? Du mein Schönchen! Du brauchst\ndich nicht zu fürchten, Jagusch, gut wirst du es bei mir haben, daß\nes dir selbst bei der Mutter nicht besser war ... Eine Herrin wirst\ndu sein, Jagusch, nur die Herrin ... ich will dir eine Magd halten,\ndamit du dich nicht abzuquälen brauchst ... du sollst schon sehen!\n...« redete er leise in sie ein und sah ihr verliebt in die Augen,\nohne "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page304",
      "title": "lesebaer/gary"
    }
  }), _vm._v(" mehr\nauf die Menschen zu achten, so daß man sich schon laut über ihn\nlustig machte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wie so'n Kater um die Speckschwarte streicht er um sie\nherum.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ist auch ein fetter Bissen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und was der Alte sich dreht und um sie herumzappelt, da ist ein\nHahn nichts dagegen!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wird der sich was auskosten, das alte Biest,« rief der\nSchulze.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wie der Hund im Frost,« brummte der alte Simeon bissig.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie brachen in ein Gelächter aus, und der Müller legte sich fast\nüber den Tisch vor Vergnügen und trommelte mit der Faust\ndrauflos.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Köchinnen stimmten abermals an:")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Fette Hirse tun wir euch tragen"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nIhr armen Teufel mit hungrigem Magen!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Jagna, beug' dich zu mir 'ran, dann sag' ich dir was!« sprach\nder Schulze, neigte sich hinter Borynas Rücken hinüber, denn er saß\nneben ihm und kniff sie in die Hüfte; »mich da sollst du zum Paten\nbitten!« rief er lachend und ließ seine lüsternen Augen über sie\nhingehen, denn sie tat ihm ausnehmend gut gefallen. Sie errötete\nstark, die Frauen aber stimmten dazu ein Gelächter an, und nu aber\nlos mit Geneck und gepfefferten Witzen und mit Ratschlägen, wie man\nmit einem Mannsbild umgehen müsse!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und das Federbett mußt du jeden Abend vor dem Herd wärmen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Die Hauptsache ist, daß er fettes Essen kriegt, dann wird er\nschon Kräfte haben ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und schmeichle ihm, faß ihn oft um den Hals.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Nicht zu stramm halten, dann merkt er nicht, wo du ihn hinhaben\nwillst!« räsonnierten sie alle miteinander, wieso Frauen gewöhnlich\ntun, wenn sie angeheitert sind und den Zungen freien Lauf\nlassen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page305",
      "title": "lesebaer/gary"
    }
  }), _vm._v(" Die\nStube erdröhnte vor Lachen, und zuletzt wurden sie so lose mit\nihren Mäulern, daß die Müllerin ihnen nahelegen mußte, doch auf die\njungen Mädchen und Kinder Rücksicht zu nehmen. Auch der Organist\nsetzte auseinander, daß es eine große Sünde sei, Ärgernis zu\nverbreiten und ein schlechtes Beispiel zu geben.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Denn Herr Jesus,« sprach er, »hat uns gesagt, und auch die\nheiligen Apostel, was alles in den lateinischen Büchern dick\ngedruckt steht, daß Totschlagen noch besser ist, als Ärgernis zu\nerregen, denn wenn du bei einem von den Kleinen Ärgernis erregst,\ndann ist es, als hättest du es mir selbst getan; so steht es in der\nHeiligen Schrift/denn die Unzucht im Trinken und Essen, desgleichen\nin Taten wird streng bestraft, das sag' ich euch, lieben Leute,«\nstotterte er undeutlich, denn er hatte schon nicht ein und nicht\nzwei Gläser getrunken ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das Biest von Blasebalgtreter, den Spaß möchte er den Menschen\nverbieten.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Am Priesterrock hat er gerochen, jetzt meint er, daß er heilig\nist!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Laß ihn sich die Ohren mit dem Kapottrock zustopfen!«\nschwirrten die feindseligen Stimmen, denn man mochte ihn nicht im\nDorf.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Heute ist doch Hochzeit, Sünde gibt es da nicht, wenn man mal\nSpaß macht, sich amesiert und lacht, wo was zu lachen ist, das tu'\nich schon sagen, ich, der Schulze, ich sag' es euch, Leute.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und auch Herr Jesus zum Beispiel ging zu Hochzeiten und trank\nWein ...,« warf Ambrosius ernst, aber leise dazwischen; er war\nschon betrunken, und da er ganz am Ende an der Tür saß, hörte ihn\nniemand./Alle redeten jetzt durcheinander, lachten, stießen mit den\nGläsern an und langten immer bedächtiger zu, um sich ganz und gar\nsattzuessen; manch einer lockerte schon den Gürtel und reckte sich,\num mehr hineinzukriegen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page306",
      "title": "Snoopy64/gary"
    }
  }), _vm._v(" Die\nKöchinnen trugen wieder singend neue Schüsseln herein:")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Gegrunzt, gequiekt, gegraben hat es im\nGärtelein,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nJetzt muß es den Schaden zahlen – das Schwein!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Haben die sich angestrengt, na, na!« wunderten sich die\nMenschen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das will ich meinen, an die tausend Silberlinge wird die\nHochzeit kosten ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Es hat sich nicht schlecht bezahlt gemacht, er hat ihr doch die\nsechs Morgen verschrieben! Zum Schaden der Kinder amüsieren sie\nsich hier.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und Jagna sitzt dabei wie der reine Brummkater.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Dafür leuchten Matheus seine Augen aber wie bei einem\nLuchs!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ist nur Moder, der lichtert, ih du meine Güte, was sonst!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Der wird noch weinen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»So einer ist das nicht, der langt ihr eher einen mit dem Stock\n...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Dasselbe hab' ich schon der Schulzin gesagt, als sie mir von\nder Verlobung erzählte.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Warum ist die denn heute nicht gekommen?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wie soll sie denn, die muß doch jeden Augenblick niederkommen\n...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Die Hand könnt' ich mir abhauen lassen, daß es nicht lange\ndauert und die Jagna treibt sich mit den Burschen herum, laßt mal\nerst die Musiken in die Schenke kommen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Der Mathias wartet nur darauf!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hale, hale?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Versteht sich! Dem Wawschon Seine hat gehört, was er in der\nSchenke herumgeredet hat.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Daß sie ihn aber nicht eingeladen haben, mit aufzuspielen?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Der Alte wollte es, aber die Dominikwittib hat sich dagegen\nverwahrt, wie soll sie denn auch anders, alle wissen doch, was war\n...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page307",
      "title": "MEsswein/gary"
    }
  }), _vm._v(" »Jeder\ngibt sein Teil dazu, hat sie denn einer gesehen?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Dann tut man wohl in den Wind reden?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und der Bartek Kosiol hat sie doch im Frühling mal im Wald\nausgespäht.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Der Kosiol ist ein Dieb und ein Betrüger, er hat doch mit der\nPatsches vor Gericht das wegen dem Schwein gehabt, nu tut er aus\nGift herumreden.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Andere haben auch Augen, können auch noch sehen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und schlecht wird es enden, man kriegt es schon zu sehen ...\nversteht sich, mich soll es nichts angehen, aber wenn ich mir so\ndenke, daß den Anteks und deren Kindern solch ein Unrecht geschehen\nist/Strafe muß da sein, und sie wird nicht ausbleiben.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Versteht sich, der Herr Jesus ist nicht rasch bei der Hand,\naber gerecht ist er ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Von Antek hat man doch auch was gemunkelt, mit dem will sie\nauch mancher hier und da gesehen haben, wie sie sich miteinander\nverabredeten ...,« sie dämpften die Stimmen, klatschten immer\nbissiger und nahmen die ganze Familie ohne Gnade vor, der Alten\nauch nicht das kleinste schenkend und hauptsächlich die Söhne\nbeklagend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ist denn das keine Sünde! Den Burschen wächst schon der Bart\nunter der Nase, Schymek ist schon gut an die Dreißig und heiraten\nläßt sie ihn nicht, nicht mal aus dem Haus kann er alleine gehen\nund bei der ersten besten Kleinigkeit ist da rein der Teufel\nlos.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das ist doch wirklich auch 'ne Schande, so alte Mannsbilder und\nmüssen die ganzen Frauenarbeiten machen ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Damit nur ja die Jagusch nicht ihre Händchen beschmutzt!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und jeder von ihnen hat seine fünf Morgen, da könnten sie doch\nheiraten!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»So viele Mädchen sind im Dorf ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und eure Marzicha wartet doch auch wirklich schon lange genug,\nund der Grund und Boden liegt gerade neben Patsches ihrem!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page308",
      "title": "MEsswein/gary"
    }
  }), _vm._v(" »Paßt\nihr nur besser auf eure Franka, daß sie nicht was vom Adam kriegt!\nDie Alte ist ein Teufelsweib, das weiß man, aber die Burschen sind\nauch Strohköpfe und Waschlappen!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Solche Kerle schon und trauen sich nicht, Mutters Rock\nloszulassen!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Die lassen ihn schon fahren ... Der Schymek läuft schon heute\nin einem fort hinter Nastuscha Täubich her.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ihr Vater war ganz ebenso/ich weiß noch gut, und wie die Alte\njung war, hat sie es ebenso getrieben wie die Jaguscha!...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wie die Wurzel, so die Staude!/Und wie die Mutter/ die\nTochter!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Musik verstummte; die Musikanten gingen auf die andere Seite\nessen, denn der Abendschmaus war zu Ende.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Es wurde plötzlich still, wie in der Kirche während des\nOffertoriums, nach einer Weile aber entlud sich ein noch stärkeres\nStimmengewirr, so daß es schier wie ein Aufbrodeln war; alle\nredeten auf einmal, schrien und sprachen aufeinander ein über die\nTische hinweg, so daß schon der eine den anderen nicht mehr\nverstehen konnte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Zum Schluß brachten sie für die Respektspersonen einen mit Honig\nund Gewürzen zubereiteten Krupnik, "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0003#foot8",
      "id": "text8"
    }
  }, [_c('sup', {
    staticClass: "calibre6"
  }, [_vm._v("F8")])]), _vm._v(" und für den Rest stellten sie starken Branntwein\nund Bier hin.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Kaum einer beachtete, was er trank, denn die Köpfe waren schon\nnicht schlecht benebelt, und ein Wohligkeitsgefühl versetzte alle\nin eine behagliche Mattigkeit. Sie setzten sich wie es einem jeden\nbequemer war, knöpften vor Hitze die Röcke auf und räkelten sich um\ndie Tische herum ... Mit den Fäusten schlugen sie auf, daß die\nSchüsseln hochsprangen, hielten sich umschlungen, griffen einander\nan die Rockklappen, oder umarmten sich, redeten einander zu und\nschütteten sich die Herzen aus, wie der Bruder seinem Bruder, wie\nder wahre Christ seinem christlichen Nachbarn.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page309",
      "title": "Snoopy64/gary"
    }
  }), _vm._v("\n»Schlecht ist es in der Welt! Jawohl! Immer nur zugrunde gehen kann\nder Mensch und Not leiden ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wollt ihr euch schicken, verdammtes Hundspack! ...« Unter den\nTischen balgten sich die Hunde um die Knochen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»... Und Trost kann es nur geben, wenn der Nachbar mit dem\nNachbarn zusammenkommt, wenn sie beim Glase Schnaps sich die\nWahrheit sagen, das Herz ausschütten, und einander vergeben, was\neiner sich bei dem anderen hat zuschulden kommen lassen/versteht\nsich, das abgeweidete Getreide oder die eingepflügte Grenze nicht,\ndenn darüber werden schon die Gerichte Bescheid wissen und die\nZeugen werden es aussagen, wer unrecht hat und wem sein Recht\nzukommt; aber das, was von wegen der Nachbarschaft vorkommt /mal\nist es dem einen sein Vieh, das im Garten gewühlt hat, mal sind's\ndie Frauen, die sich herumgezankt haben, manchmal prügeln sich die\nKinder, grad wie es kommt ... Dazu ist doch solch Freudetag, daß\ndie Leute vom Groll ablassen und daß Brüderschaft und Eintracht\nzwischen den Menschen aufkommt!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wenn's auch nur für diese Freudezeit ist, für diesen einen\nTag!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und morgen kommt immer noch früh genug! Hei! Vor deinem Los\nkannst du dich doch nicht verstecken, und wenn schon, dann nur\nunter die heilige Erde wohl; es kommt, es wird dich ans Genick\npacken, dir das Joch um den Nacken legen, mit der Not wird es dich\nantreiben, und nu schlepp' du mal, Volk, lasse dein Blut fließen;\nsorg' um dein bißchen Habe, laß es nicht aus den Fäusten, nicht für\neinen Augenblick, damit die Brüder nicht über dich weggehen!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Zu Brüdern hat Herr Jesus die Menschen geschaffen, und Wölfe\nsind sie füreinander!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Nein, nicht Wölfe, das ist die Not, die sie jagt, verzankt und\ndie einen auf die andern schleudert, daß sie sich beißen, wie die\nHunde um einen benagten Knochen!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page310",
      "title": "MEsswein/gary"
    }
  }), _vm._v(" »Nein,\nnicht die Not allein, der Böse ist es, der die Finsternis über das\nVolk wirft, daß es nicht auskennt, was gut und was böse ist!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wahrhaftig, wahrhaftig! Und er bläst in die Seele wie in eine\nGlut, die doch schon verglimmt, bis er Gier und Wut und alle Sünden\nwachgeblasen hat!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Versteht sich, wer auf die Gebote taub ist, hört besser die\nTeufelsmusik!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Einstens war es nicht so! Gehorsam war da, das Alter hat man\nrespektiert und Eintracht tat man halten!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und Grund und Boden hatte jeder, soviel er nur bearbeiten\nkonnte, und Weideland, und Wiesen, und Wald.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und hat denn je einer da von Steuern gehört?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Oder hat einer Holz kaufen müssen? ... In den Wald fuhr er und\nnahm was er brauchte, und wenn es selbst die beste Kiefer oder\nEiche war! ... Was dem Gutsherrn seins, war auch dem Bauern\nseins.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und jetzt ist es nicht dem Gutsherrn, noch dem Bauern seins/dem\nJuden gehört es, oder noch einem Schlimmeren.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Aaszeug! Euch hab' ich zugetrunken, trinkt ihr mir zu!\nFestgesetzt haben sie sich, wie auf dem eigenen, trinkt mal, dein\nWohl, mein Wohl, damit Gerechtigkeit sich machen tut ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Räudiges Herrenvolk! In eure Hände! Nehmt das Glas! Schnaps ist\nkeine Sünde, wenn es nur mit der Würde geht, ein gutes Glas unter\nBrüdern bekommt der Gesundheit, reinigt das Blut und zieht die\nbösen Krankheiten ab!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wenn schon trinken, dann lieber gleich 'ne ganze Quart, und\nwenn sich freuen, dann den ganzen Sonntag lang. Und hast du was zu\ntun, Menschenkind/dann arbeite flink, schone deine Klumpen nicht\nund halt' dich ehrlich dran! Und kommt mal sozusagen eine\nGelegenheit/Hochzeit, Taufe, oder stirbt einer weg/dann spann' aus,\nmach' es dir bequem, "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page311",
      "title": "MEsswein/gary"
    }
  }), _vm._v(" nimm wahr und mach' dir deine Freude! Und geht\nes einmal schlecht/die Frau geht zuschanden, ein Vieh verreckt,\noder es kommt ein Feuerschaden/Gottes Wille, lehn' dich nicht\ndawider auf, denn was kannst du, armer Teufel, mit Geschrei und\nWeinen dir da helfen?/Gar nichts; deine Ruhe wirst du nur los, daß\nselbst das Essen dir wie Brennesseln im Maule deucht!/Darum dulde\ndu und vertraue auf dem Herrn Jesu seine Gnade ... kommt\nSchlimmeres, packt dich der Knochenmann an der Gurgel und guckt dir\nin die Augen/versuch' nicht zu entweichen, das ist nicht deine\nMacht /denn alles ist in Gottes Hand ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das ist so, wer kann es nur voraussehen, wann Jesus sagt: Bis\ndahin deins/hier ist meins, Menschenkind.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wahr, wahr! Hoch, da oben fliegen sie wie Blitze die Befehle\nvon unserem Herrgott und niemand, selbst der Priester, der klügste\nselbst kann sie im voraus durchschauen, bis daß sie aufs Volk, wie\nreifes Korn, fallen!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Du aber, Mensch, hast nur eins zu wissen/tue deine Sache und\nlebe, wie die heiligen Gebote befehlen, und sehe nicht in das\nKommende ... Herr Jesus tut jedem seinen Lohn zurechtlegen und wird\nehrlich jedem seinen Teil zahlen ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das hat das polnische Volk immer aufrechterhalten/ und so soll\nes in alle Ewigkeit bleiben, Amen!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und mit Geduld wirst du selbst die Tore der Hölle\nüberwinden.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("So redeten sie miteinander, dazwischen häufig einander\nzutrinkend, und jeder äußerte sich über das, was ihm gerade am\nHerzen lag und woran er schon lange gewürgt hatte! Am meisten und\nam lautesten aber räsonierte Ambrosius, natürlich tat man nicht\nviel auf ihn hinhören, denn jeder redete und wollte seine Sache\nanbringen, ohne viel auf die anderen zu achten ... In der Stube\ntoste schon ein immer lauteres Stimmengewirr, als plötzlich Gusche\nmit der Eve hereintraten, gravitätisch einen großen geschmückten\nKochlöffel "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page312",
      "title": "MEsswein/gary"
    }
  }), _vm._v(" vor sich tragend./Ein Musikant, der\nhinterdrein schritt, spielte auf der Geige, sie aber sangen:")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Hebt euch, Leute, von den Tischen,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nHebt euch von der Bank."), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nEin paar Heller für die Brüh"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nUnd zehn Heller für die Müh"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nGebt uns hier zum Dank!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Das Volk war satt, angeheitert und leichtgiebig gestimmt durch\ndas gute Essen und viele Trinken, so daß selbst einzelne\nSilbermünzen in den Kochlöffel warfen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Allzusammen fingen sie an, sich von den Tischen zu erheben und\nlangsam auseinanderzugehen; die einen wollten frische Luft\nschöpfen, etliche blieben im Flur oder in der Stube stehen,\ndiskutierten weiter, und andere wiederum umarmten sich zum Zeichen\nder gegenseitigen Freundschaft, manch einer aber torkelte schon und\nfegte mit dem Kopf die Wände oder er bockte mit seinem Schädel\ngegen die anderen an, wie ein Widder/was kein Wunder war, da\nwährend des Abendessens die Schnapsbuttel reichlich gekreist\nhatte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Am Tisch blieben nur der Schulze und der Müller sitzen. Die\nbeiden zankten sich und gingen mit solcher Hitzigkeit aufeinander\nlos, wie zwei Habichte, so daß Ambrosius sie mit Schnaps zu\nversöhnen versuchte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Paß auf die Kirchtür, alter Kirchenschließer, und laß die\nHofbesitzer in Ruh,« knurrte der Schulze.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Ambrosius ging mißmutig davon, er stieß mit seinem Stelzfuß laut\nauf, und die Schnapsflasche gegen die Brust pressend, sah er sich\nnach einem Kumpan um, mit dem er in guter Freundschaft sich satt\nreden und einen ordentlichen trinken könnte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Jugend war auf den Heckenweg hinausgetreten, wo sie sich\nallesamt eingehakt hatten und miteinander plaudernd und schäkernd\nauf die Dorfstraße hinausgingen, um allerhand Schabernack zu\ntreiben, so daß es dröhnte vor Gejage und Geschrei. Die Nacht war\nklar, der Mond hing "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page313",
      "title": "Snoopy64/gary"
    }
  }), _vm._v(" über dem Weiher; das Wasser glänzte so hell,\ndaß die kleinsten Kreise, die wie unter den Schlägen des Lichts\nsich ausbreiteten, in halbkreisrunden Schlänglein silbern durch die\nStille glitten. Der Nachtfrost griff immer stärker um sich, die\nErdkrusten brachen unter den Tritten und der Reif hatte die Dächer\nweiß überzogen und die Erde eisgrau bestreut.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Es war schon spät, denn die ersten Hähne ließen sich im Dorf\nvernehmen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("In der Stube machte man inzwischen Ordnung und bereitete alles\nzum Tanzen vor.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und als die Musikanten genug gegessen hatten und ausgeruht\nwaren, fingen sie an leise aufzuspielen, um die Hochzeitsgäste\nwieder zu sammeln.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Doch es war nicht nötig, sie lange anzutreiben, im hellen Haufen\ndrangen sie in die Stube, denn die Geigen lockten so zum Tanz, daß\ndie Füße einen von selbst schon trugen/ es war aber zu guter Letzt\ndoch verlorene Liebesmüh, die Burschen fühlten sich noch zu schwer\nnach dem Festessen, der eine und der andere versuchte sich etwas zu\ndrehen, sie liefen aber bald wieder hinaus auf den Flur, um eine\nZigarette zu rauchen oder die festen Wände zu stützen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Frauen führten Jagna in die Kammer ab und Boryna blieb mit\nder Dominikbäuerin auf der Fensterbank sitzen, und was die Älteren\nwaren, so hatten sie sich auf den Bänken und in den Ecken breit\ngemacht und redeten miteinander. In der Mitte der Stube waren nur\nnoch die Mädchen geblieben, deren Kichern immer von neuem hörbar\nwurde; da ihnen aber die Zeit bald lang wurde, richteten sie\nverschiedene Spiele ein, um die Burschen etwas aus sich\nherauszulocken.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Zuerst spielten sie das Spiel: »Es geht der Fuchs um den Weg\nherum, ohne Hand und Fuß.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Als Fuchs hatten sie Jaschek mit dem Spitznamen »der Verkehrte«\nverkleidet und ihm einen Schafspelz umgetan, dessen zottelige\nInnenseite noch außen gekehrt war. Das "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page314",
      "title": "MEsswein/gary"
    }
  }), _vm._v(" war ein Tolpatsch und\nDummerjahn. Sie hielten ihn alle zum Narren im Dorf. Obgleich er\nein ausgewachsener Bursche war, lief er mit offenem Maul herum,\nspielte mit den Kindern und liebäugelte mit allen Mädchen. Er\nmachte den Eindruck, als ob er nicht ganz richtig sei; da er aber\nder einzige Sohn war und seine zehn Morgen zu erwarten hatte, so\nwurde er überall eingeladen./Häschen war Borynas Fine.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und sie lachten ... wie sie lachten, Jesus! Jede paar Schritte\nplusterte sich Jaschek auf und plumps, lag er am Boden, wie ein\nStück Holz, denn jedermann versuchte ihm ein Bein zu stellen, und\nFine hopste so schön, machte Männchen, muffelte mit den Lippen, daß\nein wahrer Hase nichts dagegen war.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und dann spielte man »Wachtel«.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Nastuscha Täubich führte an, und sie war so flink, flitzte so\ngeschickt durch die Stube, daß sie sie gar nicht greifen konnten,\nbis sie ihnen von selbst unter die Hände schlüpfte, um mal\nherumzutanzen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und »Schweinchen« wurde gespielt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Zum Schluß aber machte einer der Brautführer, scheinbar Tomek\nWachnik, einen Storch; er hatte sich mit einem Leinentuch den Kopf\nbedeckt und darunter ließ er als Schnabel einen langen Stock hängen\nund klapperte so geschickt, daß es sich ganz wie Storchklappern\nanhörte; Fine, Witek und die kleineren rannten hinter ihm her und\nschrien:")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Le, le, le ..."), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nDein' Mutter in der Hölle."), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nWas tut sie denn da suchen?"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nSie backt den Kindern Kuchen."), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nWas hat sie denn gemacht?"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nDie Kinder umgebracht.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie zerstreuten sich schreiend und suchten in den Ecken Schutz,\ndenn er verfolgte sie, stieß mit dem Schnabel nach ihnen und schlug\nmit den Flügeln um sich.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page315",
      "title": "Snoopy64/gary"
    }
  }), _vm._v(" Die\nStube erzitterte vor diesem Gelächter, Gekreisch und Gejage.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Eine gute Stunde mochte schon das Spiel gedauert haben, als der\nälteste der Brautführer ein Zeichen gab, sich ruhig zu\nverhalten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Aus der Kammer führten die Frauen Jagna heraus, die mit einem\nweißen Linnentuch bedeckt war, und setzten sie inmitten der Stube\nauf einen Backtrog, über den ein Federbett ausgebreitet lag/die\nBrautjungfern sprangen hinzu und taten als ob sie sie ihnen\nentreißen wollten, aber die älteren Frauen und die Männer wehrten\nihnen, darum drängten sie sich ihr gegenüber zu einem Haufen\nzusammen und sangen wie durch Tränen mit trauriger Stimme:")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Nun mußt du sein"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nOhne Kränzelein!"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nDie gewundene Frauenhaube"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nOj-ta-dana-da"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nDie benähte Frauenhaube"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nZiemt dir jetzt allein! ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Dann erst deckte man sie auf.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie hatte schon eine Haube auf den aufgesteckten dicken Zöpfen,\naber sie erschien noch schmucker in dieser Tracht, denn sie lachte,\nwar froh und blickte mit leuchtenden Augen von einem zum\nanderen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Musik fing in langsamem Takt an zu spielen, und das ganze\nversammelte Volk, die Alten und die Jungen und die Kinder selbst\nstimmten mit einer einzigen großen Freudestimme das »Hopfenlied«\nan. Nach dem Absingen des Liedes wurde Jagusch nur von\nHofbäuerinnen zum Tanz geholt. Gusche aber, die sich schon\nordentlich einen angetrunken hatte, stemmte die Arme in die Seiten\nund fing an, ihr zuzusingen:")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Hei! das hätt' ich wissen sollen,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nDaß dich da ein Witwer freit."), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nHei! ein Kränzelein aus Wicken,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nHei! das hielt ich dir bereit!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page316",
      "title": "Snoopy64/gary"
    }
  }), _vm._v(" Und\nsie sang auch noch andere Lieder mit allerlei versteckten\nAnspielungen und Anzüglichkeiten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Doch niemand achtete darauf, denn die Musikanten geigten schon\naus voller Macht und die Menschen traten an zum Tanz. Der Boden\nerdröhnte plötzlich, als schlügen hundert Dreschflegel auf die\nTenne und ein undurchdringbares Gewirr füllte die Stube, denn dicht\nan dicht folgten die einen den andern, Paar auf Paar, Kopf neben\nKopf, und nahmen einen Anlauf./Die Kapottröcke ließen sie wehen,\nwiegten sich im breitspurigen Tanzschritt, stampften mit den\nAbsätzen auf, schwenkten die Hüte, und hier und da stimmte einer\nein schallendes Lied zur Musik an und die Mädchen sangen ihr\n»da-dana« dazu. Sie drehten sich immer schneller, ihre Körper\nschaukelten sich hin und her, bis sie in einen so raschen,\nwirbelnden, selbstvergessenen Tanz übergingen, daß keiner mehr im\nGedränge auseinander zu kennen war.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und jedesmal, wenn die Geigen einen Hopsa erschallen ließen,\nstampften hundert Hackenpaare auf den Boden, hundert Stimmen\njuchten auf, hundert Menschen schwenkten herum, als ob sie ein\nWindstoß herumgeschleudert hätte/ so daß nur das Sausen der\nRockschöße und Beiderwandröcke und das Flattern der Kopftücher\nvernehmbar wurde, die wie farbige Vögel in der Stube aufflogen.\nEin, zwei, drei Paternoster gingen vorbei und sie tanzten immerzu,\nohne aufzuatmen, ohne Unterbrechung; der Fußboden dröhnte, die\nWände bebten, in der Stube brodelte der Lärm, und die Lust wuchs\nimmerzu; wie die Fluten nach dem Gewitterregen /so wogte und wälzte\nsich der Tanz durch die Stube.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Als sie geendigt hatten, kamen verschiedene Bräuche an die\nReihe, wie es beim Aufsetzen der Frauenhaube üblich war.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Zuerst mußte sich Jagna bei den Bäuerinnen einkaufen!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Danach wurden noch manche Hochzeitszeremonien vollführt; bis\nschließlich die Burschen ein langes Strohseil aus "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page317",
      "title": "Snoopy64/gary"
    }
  }), _vm._v(" ungedroschenem Weizen\ndrehten und es den Brautjungfern in die Hände gaben, die damit\neinen großen Kreis umspannten, den sie eifrig bewachten. Mitten\ndrin stand Jagna, und wer mit ihr tanzen wollte, mußte sich\ngewaltsam zu ihr den Weg bahnen, um sich mit ihr im Kreise zu\nschwingen, nichtachtend, daß sie ihn mit verschiedenen Strohseilen\nnur immer so über die Lenden prügelten. Zum Schluß aber begann die\nWachnikbäuerin mit der Müllerin für die Haube zu sammeln. Als\nerster warf der Schulze ein Goldstück auf den Teller, und darauf\nfingen, wie ein klirrender Hagel, die Silberstücke an\nniederzuprasseln, und wie Blätter im Herbst flogen die\nPapierrubel.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Mehr wie dreihundert Silberlinge hatten sie gesammelt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Ein mächtiges Stück Geld, für die Dominikbäuerin aber war das\nwie eine Mücke; im übrigen legte sie kein Gewicht auf Geschenktes,\ndenn sie hatte genug Eigenes, nur daß sie sich für Jagusch so\nbereitwillig auf Unkosten einließen, hatte sie ordentlich\nmitgenommen, so daß ihr vor Rührung ein Weinen ankam, das sie nicht\nmehr unterdrücken konnte/ sie schrie den Jungen zu, den Schnaps zu\nbringen und fing selbst an, zu traktieren, zuzutrinken und durch\ndie Tränen, die ihr über die Backen rannen, Gevatter und\nGevatterinnen abzuküssen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Trinkt, Nachbarn ... trinkt, liebe Leute, Brüderherzen ... Das\nist mir ein Freudentag heute ... auf Jagusch ihr Wohl ... dieses\nGläschen noch ... dieses;« und hinter ihr drein trank noch der\nSchmied den anderen zu, und die Jungen auch auf eigene Hand/denn es\nwar ein nicht kleiner Haufen Volk beisammen. Auch Jagusch dankte\nihrerseits für die Güte und umfaßte die Knie der älteren Leute!\n...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Es brauste auf in der Stube, denn auch die Gläser kreisten dicht\nhintereinander von Hand zu Hand, und eine Wärme und Fröhlichkeit\nstieg auf von allen Seiten! Die Gesichter röteten sich, die Augen\nblitzten auf und die Herzen strebten brüderlich, nachbarlich\neinander zu. »Hoppla/heh! einmal "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page318",
      "title": "Snoopy64/gary"
    }
  }), _vm._v(" nur kann die Ziege sterben! Das hat der\nMensch, was er mit seinen Menschenbrüdern genossen hat, was er sich\namüsiert hat, ohne sich lange um die Welt zu kümmern! Jeden für\nsich nimmt nur die Knochenfrau vor, aber feiern muß man im Haufen,\nzum Freuen gehört eine ganze Kompagnie. Sie füllten auch in Haufen\ndie ganze Stube, tranken einander zu und besprachen sich froh und\njeder setzte laut auseinander, was er zu sagen hatte, so daß schon\nder eine den andern nicht mehr hörte; aber das war einerlei, denn\nsie fühlten so wie so dasselbe, dieselbe Freude hatte sie\nzusammengebracht und alle ganz durchdrungen!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und wenn einer trauern will, laß ihn das für morgen aufheben,\nheute soll er sich amüsieren, Freundschaft genießen, seine Seele\nerfreuen! So wie der Herr Jesus der heiligen Erde nach ihrem\nsommerlichen Gebären Ruhe zukommen läßt, so ziemt es, daß auch dem\nMenschen in der Herbstzeit Ruhe werde, nachdem er sein Feld\nbestellt hat. Und hast du, Mensch, die Schober und Scheuern voll\nKorn, schwer wie Gold, das nur auf die Dreschflegel wartet, dann\ngenieße du, und lohne dir die schweren Mühen und Sorgen der langen\nSommertage!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("So redeten die einen vor sich hin, andere wiederum breiteten\nsich über ihre Angelegenheiten und Sorgen aus; und etliche, die\nnicht nur den Kuhschwanz vor sich sahen oder Weiberläufe, scharten\nsich um den alten Simeon und sprachen über alte Zeiten, neues\nUnrecht, von Steuern und den Geschäften der ganzen Gemeinde; und\nsie redeten leise, da es sich auch um des Schulzen Streiche\nhandelte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Nur Boryna schloß sich keinem Haufen an, er ging von den einen\nzu den anderen, mal hier- mal dahin, und ließ die Augen hinter\nJagna wandern, und blähte sich mächtig, daß sie so schmuck war, den\nMusikanten warf er immer wieder Silbermünzen hin, damit sie die\nFiedelbogen nicht schonten, da sie gedämpfter spielten, um\nauszuruhen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie stießen plötzlich einen wuchtigen Oberek in die Instrumente,\n"), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page319",
      "title": "Snoopy64/gary"
    }
  }), _vm._v(" daß einem\nein Schauer durch die Knochen lief, und Boryna sprang zu Jagna hin,\nriß sie fest an sich und schob vom Platz weg einen solchen Tanz,\ndaß die Dielenbretter aufwimmerten, er fegte durch die Stube,\nwendete, klappte mit den eisenbeschlagenen Hacken auf den Fußboden,\nwirbelte, das Knie beugend, seine Tänzerin um sich herum, dann\nglitt er breitspurig durch die Stube, sich im Takte nur so\nschüttelnd, auf und nieder, hin und her von Wand zu Wand, sang den\nMusikanten zu, die ihm einen Tusch zur Antwort bliesen, tobte\nrasend weiter und führte hitzig den Tanz an, denn hinter ihm fingen\ndie anderen Paare an, sich aus den verschiedenen Gruppen zu lösen,\naufzutrampeln, zu singen und mit gewaltigem Anlauf loszutanzen, daß\nsie sich wie hundert surrende Spindeln voll farbiger Garne durch\ndie Stube drehten und so schnell herumwirbelten, daß schon kein\nAuge auseinanderkennen konnte, wo der Bursch und wo das Mädchen\nwaren. Das war als ob jemand einen Regenbogen ausbreitete und auf\nihn mit einem Sturmwind einpeitschte, daß er in allen Farben\nspielte, aufschillerte und immer schneller, wütender, wilder sich\nwand, so daß zuweilen die Lichter vom Luftzug verlöscht wurden und\nNacht die Tänzer umfing. Durch die Fenster floß das Mondlicht, das\nin einem sich versprühenden Lichtstreifen funkelte wie siedendes\nSilber, mitten durch die Dunkelheit, mitten durch das kreisende\nMenschengewühl, das herangeflutet kam in einer schäumenden,\nsangerfüllten Welle und aufflimmerte und sich zusammenballte in\ndiesem Lichtschimmer, wie in einem Traumgesicht, um wieder\naufzutauchen und für einen Augenblick vor der anderen Wand\naufzudämmern, wo die durch das Mondlicht getroffenen Gläser der\nBilder sprühende Wiederscheine rieseln ließen, um sich\nvorbeizuwälzen und in die Nacht zurückzustürzen, daß in der\nverdunkelten Stube nur schweres Keuchen, Getrampel und Rufe\naufstiegen und sich ineinander wirrten mit dumpfem Gedröhn.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page320",
      "title": "Snoopy64/gary"
    }
  }), _vm._v(" Und\neine einzige lange Kette von Tanzen begann, ohne Unterbrechung und\nRuhepause ... denn kaum hob die Musik an, einen neuen Tanz zu\ngeigen, erhob sich das Volk jäh, reckte sich hoch auf, wie ein\nForst, und stürzte sich in den Tanz mit der Wucht eines\nWirbelwindes; das Aufstoßen der Hacken klang wie Donnergetöse,\nSchreie der Lust ließen das ganze Haus erbeben. Und sie überließen\nsich dem Tanz mit einer Selbstvergessenheit und Raserei, als ginge\nes in den Sturm, in den Kampf auf Tod und Leben.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und sie tanzten!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("... Die zappelnden, schäkernden Krakowiaks mit der abgerissenen,\nklirrenden Melodie, die wie mit Ziernäglein beschlagene Gürtel mit\ntanzfrohen Liedlein ausgeputzt war; die Krakowiaks voll Lachen und\nMutwillen, voll fröhlichen Sangs und üppiger, starker, kecker\nJugend und zugleich voll lustiger Possen, voll Haschen und Greifen\nund voll Glut des jungen, liebeshungrigen Blutes. Hei!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("... Mazurkas langgedehnt, wie Feldraine, breitgestreckt wie die\nMathiasbirnbäume, "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0003#foot9",
      "id": "text9"
    }
  }, [_c('sup', {
    staticClass: "calibre6"
  }, [_vm._v("F9")])]), _vm._v(" rauschend, und wie die unabsehbaren Ebenen so breit,\nvoll Schwergewicht und schlank aufstrebend, sehnsüchtig und\nverwegen, gleitend und dräuend gepackt, würdevoll und\ndraufgängerisch und steifnackig dazu, wie jene Mannsleute, die zu\neinem Haufen zusammengeschart, wie ein Wald aufragend, sich in den\nTanz werfen mit Juchzern und solcher Macht, als ob es zu hundert\ngegen Tausende angehen sollte/und wenn man dabei die ganze Welt\nzerreißen, verprügeln, zerstampfen, zu Splittern zerschlagen auf\nden Absätzen auseinandertragen müßte und selbst zugrunde gehen, um\ndann noch nach dem Tode zu tanzen, mit den Hacken aufzutrampeln und\nforsch auf mazurische Art aufzujuchzen: »da-dana!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("... Und mächtige Obereks tanzten sie, ruckweise Springetänze,\nschwindelnde, tolle, rasende, herausfordernde und wehmütige,\nsengende und versonnene, mit Klageliedern durchwobene, im Siedetakt\ndes feurigen Blutes pulsende "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page321",
      "title": "DaoH/gary"
    }
  }), _vm._v(" und doch voll Güte und Lieben, plötzlich\nniedersausende, wie eine Hagelwolke und voll herzlicher Stimmen,\nvoll himmelblauer Blicke, voll lenzverheißender Lüfte, voll\ndüfteschwangeren Zweigerauschens, das aus blütenschweren Obstgärten\nkommt/Tänze, die wie jene sangerfüllten Frühlingsfelder sind,\nTänze, wo auch die Tränen noch durch Lachen fließen, und das Herz\nFreudelieder singt, und die Seele sich sehnsüchtig losreißt, den\nfernen Weiten, den entlegenen Wäldern entgegen und in die große\nWelt hinausfliegt, ahnender Träume voll, vor sich her singend: »Oj\nDa-dana!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Solche unsagbaren Tanze folgten einer dem anderen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Denn also freut sich das Bauernvolk zur gelegenen Zeit.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("So tat man auch die Hochzeit von Boryna und Jagusch feiern.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Stunden auf Stunden eilten und versanken unbemerkt im Lärm, im\nGeschrei, in rauschender Freude und Tanzvergessenheit, so daß sie\nes gar nicht gewahr wurden, wie es sich schon im Osten zu lichten\nbegann, die Frühlichtschimmer langsam durchzusickern anfingen und\ndie Nacht bleichten. Die Sterne verblaßten, der Mond ging unter,\nund von den Wäldern erhob sich ein Wind und wehte einher, als\nwollte er die zerrinnende Dämmerung auseinanderblasen; durch die\nFenster sahen krause bepelzte Bäume hinein und neigten immer tiefer\ndie schläfrigen Köpfe voll Rauhreif ... Im Hause aber sang und\ntanzte man noch immerzu.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Es war als ob Wiesen, Erntefelder und aufgeblühte Obstgärten\nsich zu einem Fest zusammengefunden hätten und, durch einen\nWirbelwind ergriffen, einen endlosen, taumelnden, feurigen Reigen\nschlangen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Man hatte die Tür weit geöffnet und die Fenster aufgerissen, das\nHaus aber spie immer noch Lärm und Lichterschein aus, bebte und\nzitterte, und krachte, und stöhnte auf, und gab sich immer wilderem\nTaumel preis, so daß es schon war, als ob die Bäume und Menschen,\ndie Erde und die "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page322",
      "title": "Snoopy64/gary"
    }
  }), _vm._v(" Sterne, die Zäune und das alte Haus und alles\nsich bei den Schultern gefaßt hätte, sich zu einem Knäuel\nverwickelt, sich verstrickt hätte und berauscht, blind, auf nichts\nmehr achtend, von Sinnen von Wand zu Wand taumelte, von der Stube\nauf den Flur, vom Flur auf den Weg flutete, von dem Weg waldwärts\nüber die unübersehbaren Felder in die weite Welt hinaus in\nTanzraserei drängte, rollte, kreiste und als eine einzige\nflimmernde Kette in den Lichtscheinen des aufsteigenden Morgenrots\nsich verlor.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Musik war es, die sie da führte, dieses Spielen und Singen\n...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("... Die Baßgeigen juchzten im Takt und brummten mit zittrigen\nStimmen, wie Hummeln, und die Flöte gab die zweite Stimme an, pfiff\nlustig vor sich hin, zwitscherte, trieb Schabernack scheinbar der\nTrommel zum Verdruß, die possierlich hüpfte, mit den Schellen Lärm\nschlug, schäkerte und wackelte, wie ein Judenbart im Wind. Und die\nGeige führte, ging an der Spitze, wie die beste Tänzerin, sang erst\nlaut und hell, als wollte sie ihre Stimme versuchen, und fing dann\ngedehnt, durchdringend und traurig an zu klagen, als ob an den\nKreuzwegen das Weinen der Verlassenen wimmerte, bis sie sich im Nu\numdrehte und plötzlich mit einer kurzen, blitzenden, scharfen\nMelodie dreinfuhr, als hätten hundert Paare mit den Absätzen\ngeklappt, als hätten hundert Mann aus voller Brust juchheit. Der\nAtem stockte und ein Schauer lief über die Haut. Und sie fing\ngleich wieder an, Kreise zu ziehen, vor sich her zu singen, zu\nwenden, im zierlichen Schritt zu trippeln, zu hüpfen, zu lachen und\nin Lust sich zu ergehen, so daß die Warme zum Herzen strömte und\ndie Lust zu Kopfe stieg, wie Branntwein ... dann sang sie wieder\neine schleppend-traurige Weise, die wie mit Tränentau überperlt\nwar; sie sang das traute, herzliche Lied der Heimat, das trunken\nist voll großer Macht und Liebe, und führte in den\nleidenschaftlich-selbstvergessenen mazurischen Tanz.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("— — — — —")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page323",
      "title": "Snoopy64/gary"
    }
  }), _vm._v(" Das\nFrühlicht wurde immer heller, so daß die Lichter verblaßten und die\nStube eine schmutzig-trübe Dämmerung überflutete, sie aber\nvergnügten sich noch aus vollem Herzen, und wem die Bewirtung zu\nwenig war, der schickte nach der Schenke, Schnaps zu holen, suchte\nsich Kumpane und trank bis er umfiel.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Wer weggegangen war, der war weg, wer müde war, ruhte aus, wer\nsich vollgetrunken hatte, der schlief auf der Wandbank oder im\nFlur; andere aber, die noch weniger ihre Füße regieren konnten,\nlagen unter den Zäunen und wo es sich gerade traf, der Rest aber\ntanzte bis zum letzten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Bis die, die noch am nüchternsten waren, sich zu einem Haufen an\nder Tür geschart hatten, und mit den Füßen auf dem Fußboden Takt\nstampfend, zu singen begannen:")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Jetzt geht es heim, ihr Gäste, jung und alt!"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nÜber weite Wege"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nüber Wasserstege"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nDurch dunklen Wald!")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Jetzt geht es heim, ihr Gäste, jung und alt!"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nUnd Morgen wieder"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nSingen wir Lieder,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nKommen her zu frohem Aufenthalt!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Doch niemand hörte auf sie.")]), _vm._v(" "), _c('ol', {
    staticClass: "calibre7"
  }, [_c('li', {
    staticClass: "calibre8"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0003#text8",
      "id": "foot8"
    }
  }, [_c('span', {
    staticClass: "pcalibre5 pcalibre4 footnote"
  }, [_c('span', {
    staticClass: "spaced"
  }, [_vm._v("Krupnik:")]), _vm._v(" Ein altpolnisches\nGetränk aus sehr starkem reinen Schnaps, Honig und frischer Butter.\nWird mit Nelken und Zimt zum Kochen gebracht und heiß\ngetrunken.")])])]), _vm._v(" "), _c('li', {
    staticClass: "calibre8"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0003#text9",
      "id": "foot9"
    }
  }, [_c('span', {
    staticClass: "pcalibre5 pcalibre4 footnote"
  }, [_c('span', {
    staticClass: "spaced"
  }, [_vm._v("Mathiasbirnbäume:")]), _vm._v(" Scherzname für wildwachsende\nFeldbirnbäume. Anspielung auf die Genealogie dieser Baume: das\nunentkernte Obst, das die Bauern essen und die Spuren davon an den\nFeldrainen entlang. Mathias entspricht gewissermaßen dem deutschen\nSepp.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "pcalibre6 initial1"
  }, [_vm._v("Gerade brach der Tag an, als\nWitek, ganz müde vom Fest und von Gusche angetrieben, nach Hause\nrannte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Das Dorf schlief noch im tiefen Grund der Dämmerung, die sich\nschon im Vergehen zu einem dicken Wall dicht über der Erde gestaut\nhatte, der Weiher lag starr, wie erdrückt, unter dem düsteren\nDickicht der Uferbäume und so in die Dunkelheit vergraben, daß er\nsich kaum gegen die Mitte zu aus der Nacht herausschälte und in\nmilchigem Schimmer, wie ein erblindetes Auge, geisterte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page324",
      "title": "Snoopy64/gary"
    }
  }), _vm._v(" Es war\nein starker Morgenfrost, ein kalter Windzug strich durch die\nfroststarre Luft, die in die Nüstern stach und den Atem beklemmte,\ndie Erde klang hohl unter den Tritten, und die zugefrorenen Pfützen\nlagen glasig auf den Wegen, wie angelaufene Glasscheiben; die Welt\nwurde kalkig blaß unter dem allmählich wachsenden Frühlicht und\ntauchte froststumm und bereift aus den Dämmerungen hervor; nur\nirgendwo begannen schläfrig ein paar Hunde aufzukläffen, und die\nMühle schlurrte aus der Ferne; und um das Hochzeitshaus schlug der\nfestliche Lärm Kreise um Kreise in eines Steinwurfs Breite.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("In Borynas Stube glimmte noch, wie ein Johanniswürmchen, ein\nwinziges Lichtlein, so daß Witek neugierig durchs Fenster blickte;\nder alte Rochus saß am Tisch und sang aus dem Buch fromme Lieder\nvor sich hin.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Der Junge schlich leise nach dem Kuhstall und wollte nach dem\nRiegel tasten; plötzlich aber schrie er auf und fuhr erschrocken\nzurück, denn mit Gewinsel war ein Hund an ihm hochgesprungen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Waupa! Waupa! Bist du denn wieder da, mein gutes Hundchen,\nwieder da, du armer Kerl!« rief er, nachdem er den Hund erkannt\nhatte und hockte vor Freude zu ihm auf der Schwelle nieder. »Bist\nhungrig, armer Teufel, was?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Er suchte unter dem Brustlatz nach der Wurst, die er sich vom\nHochzeitsschmaus abgespart hatte und schob sie ihm ins Maul, aber\nWaupa hatte es nicht eilig mit dem Essen, er bellte in einem fort,\nsprang an ihm hoch und winselte vor Freude.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hungern haben sie dich lassen und dich dann noch\n'rausgeschmissen, armer Kerl!« murmelte er, die Tür zum Kuhstall\naufsperrend, und warf sich gleich, wie er ging und stand, auf seine\nPritsche. »Ich werd' dir schon nichts ankommen lassen und für dich\nsorgen ...,« brummte er und vergrub sich ins Stroh, der Hund legte\nsich neben ihn, knurrte ein paarmal auf und leckte ihn hin und\nwieder ins Gesicht.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page325",
      "title": "Snoopy64/gary"
    }
  }), _vm._v(" Es\ndauerte nicht mehr lange, da schliefen sie beide. Und vom\nnebenanliegenden Stall rief Jakob mit schwacher, kranker Stimme; er\nrief lange, doch Witek schlief wie ein Stein, erst Waupa, der die\nStimme erkannt hatte, fing an, so wütend zu bellen und ihn am Rock\nzu zerren, bis er aufwachte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Was denn?« lallte er schlaftrunken.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wasser! Die Hitze packt mich so an ... Wasser!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Obgleich er verdrießlich war, und der Schlaf ihm in den Gliedern\nsaß, ging er doch, einen ganzen Eimer Wasser für Jakob holen, den\ner ihm zum Trinken hinstellte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich bin so krank, daß ich kaum Luft schnappen kann ... Was\nknurrt denn da?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Der Hund ist es! ist von den Anteks zurückgekommen, das arme\nTier!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Waupa!« flüsterte er, in der Dunkelheit nach dem Hundekopf\ntastend, und Waupa sprang empor, bellte und versuchte auf die\nPritsche zu klettern.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Witek, tu' mal den Pferden etwas Heu einlegen, denn sie klopfen\nmit den Zähnen an die leeren Krippen, ich kann mich ja nicht\nrühren. Tanzen sie noch?« fragte er nach einer Weile, nachdem Witek\nHeu vom Stallboden heruntergeworfen hatte und es in die Raufen\nhineintat.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Die werden wohl zu Mittag erst fertig, und manche haben sich so\nbetrunken, daß sie draußen auf der Straße liegen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Die amesieren sich was, die amesieren sich, die Hofbauern,«\nseufzte er schwer auf.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Waren die Müllersleute da?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Sie waren, nur daß sie früher gegangen sind.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Sind wohl viele dagewesen?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wer die zählen könnte ... nicht mehr rühren konnt' man sich im\nHaus.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Haben sie reichlich was aufgetischt?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das war schon rein wie im Herrenhof. Ganze Schüsseln Fleisch\nhaben sie herumgetragen, und was sie Schnaps ausgesoffen "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page326",
      "title": "Snoopy64/gary"
    }
  }), _vm._v(" haben und noch\nall das Bier und Met noch! Allein Wurst waren drei gehäufte Mulden\nvoll.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wann ist denn die Brauteinholung?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Heute doch, zur Vesper.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Die haben noch was vor sich, die werden sich noch genug was\namesieren ... Du lieber Jesus, ich dachte, ich sollt' auch was\ndavon abkriegen, und wenn auch man 'n Brocken für mich\nübergeblieben wär', daß ich mich doch mindestens einmal ordentlich\nsatt essen könnte, und nun lieg' einer hier und verreck', und hör'\nzu, wie die anderen das Vergnügen haben.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Witek ging wieder schlafen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wenn man doch mindestens die Augen satt sehen könnte ... wenn\ndoch ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Ermattet verstummte er und käute in seinem Innern sein Leid\nwieder/stille, schüchterne Klagen, die in seiner Brust hin- und\nherflatterten, wie flügellahme Vöglein, und schmerzvoll\nzirpten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Möge es ihnen wohl bekommen, laß sie wenigstens was vom Leben\nhaben ...,« dachte er, den Kopf des Hundes streichelnd.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Das Fieber umnebelte ihn immer mehr, und um Schutz zu finden,\nfing er an, das Gebet zu murmeln und sich Jesu Barmherzigkeit warm\nanzuempfehlen auf Gnade und Ungnade, aber er vergaß, was er sagen\nwollte, der Schlaf überfiel ihn immer wieder, und die Reihenfolge\nseiner geflüsterten Worte, die von Bitten und Tränen geschwellt\nwaren, zerriß und verstreute sich, wie eine rote Korallenschnur, so\ndaß er die einzelnen Perlen zusammenraffen wollte, so sichtbar\nrollten sie über seinen Schafpelz; doch alles entschwand ihm/er\nschlief ein.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Manchmal wachte er auf, ließ den leeren Blick schweifen, und\nohne etwas wahrzunehmen, sank er und stürzte wieder in die tote,\nleichenstarre Dunkelheit zurück.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Dann wieder stöhnte er und schrie im Schlaf, daß die "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page327",
      "title": "Snoopy64/gary"
    }
  }), _vm._v(" Pferde\nschnaubend an den Ketten rissen; das brachte ihn wieder etwas zur\nBesinnung, und er richtete den Kopf ein wenig auf.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Jesus, mindestens noch den Tag erleben!« jammerte er angstvoll\nund ließ die Blicke durchs Fensterchen gehen, um in der Welt den\nkommenden Tag zu suchen; nach der Sonne spähte er am grauen kalten\nHimmel, der mit erblassenden Sternen beschlagen war.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Aber der Tag war noch weit.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Der Stall war versunken im trüben dunstigen Licht der\nMorgendämmerung, so daß schon die Umrisse der Pferde sich\nabzuzeichnen begannen und die Raufen an den Fenstern wie Rippen\ngegen das Licht zu sehen waren.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Er konnte nicht mehr einschlafen, denn neue Schmerzen überkamen\nihn, sie glitten ihm ins Bein, wie Knüttelstöcke, trieben es\nauseinander, bohrten und brannten, als ob ihm einer mit lebendiger\nGlut die Wunden bestreute, so daß er sich plötzlich emporriß und\naus ganzer Kraft zu schreien begann, bis Witek davon aufwachte und\nhereingestürzt kam.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich tu' sterben! Ich tu' sterben! Es schmerzt so in mir, die\nKrankheit wächst sich aus und tut mich erwürgen ... Witek, lauf'\nAmbrosius holen ... oh Jesus, oder Gusche, vielleicht helfen sie\nwas, denn ich mach' es nicht mehr ... die letzte Stunde kommt schon\nüber mich ... die letzte Zeit ...« er brach in ein furchtbares\nWeinen aus, wühlte das Gesicht ins Stroh und schluchzte bang und\nschwer.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und Witek lief trotz seiner Schläfrigkeit zum Hochzeitshaus\nzurück.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie waren immer noch im vollen Tanz, Ambrosius aber war besoffen\nund stand, wie es bei ihm immer so war, mitten auf der Dorfstraße\nvor dem Haus, torkelte hin und her zwischen Weiher und Zaun und\nsang sich einen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Vergeblich flehte ihn Witek an und zerrte ihn am Ärmel, der Alte\nwar wie taub und wußte nichts mehr von sich, er wankte nur und sang\nverbohrt immerzu dasselbe Lied. "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page328",
      "title": "Snoopy64/gary"
    }
  }), _vm._v(" Jetzt lief Witek zu Gusche, da sie\nErfahrungen in Krankheiten hatte, doch sie saß mit den\nGevatterinnen in der Kammer, und sie tranken einander mit dem\nKupnik dermaßen zu, taten sich so gütlich am Bier, daß sie alle auf\neinmal redeten und Gesänge jaulten. Es war nichts mit ihr zu reden.\nImmer wieder wimmerte Witek, daß sie doch zu Jakob kommen müsse,\nbis sie ihn schließlich zur Tür hinaus schmiß und ihm mit der Faust\nnoch ein paar nachknuffte. Nachdem er so viel erreicht hatte,\nrannte er weinend zum Stall zurück.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Da aber Jakob gerade schon wieder eingeschlafen war, so wühlte\ner sich ins Stroh hinein, zog einen alten Fetzen über den Kopf und\nschlief ein.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Eine gute Zeit nach dem Frühstück, weckte ihn das Brüllen der\nhungrigen und ungemelkten Kühe auf und dazu das Keifen Gusches,\ndie, wie die anderen, die Zeit verschlafen hatte und das durch\nGeschrei in der Wirtschaft wieder gut zu machen versuchte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Erst nachdem sie etwas Arbeit abgewälzt hatte, sah sie nach\nJakob.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Helft mir doch, ratet mir doch,« bat er leise.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Heirat' dir 'ne Junge an, dann wirst du gleich auskuriert\nsein!« fing sie vergnügt an; als sie aber sein blau angelaufenes,\ngeschwollenes Gesicht sah, wurde sie merklich ernster. »Einen\nPriester brauchst du mehr als einen Arzt! Was soll ich dir da\nhelfen? Besprechen könnt' ich, beräuchern, aber wird das helfen?\n... Es scheint mir, daß du die Todkrankheit hast, die reine\nTodkrankheit ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Soll ich denn sterben?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das steht in Gottes Macht, aber mir deucht, daß du der\nKnochenfrau nicht mehr entwischst.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Sterben soll ich, sagt ihr?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Nach Hochwürden müßte man schicken, wie?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hochwürden!« stieß er erstaunt hervor. »Hochwürden\nhierherbringen in den Stall zu mir? ... Was kommt euch an?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page329",
      "title": "Snoopy64/gary"
    }
  }), _vm._v(" »Was\ndenn, ist doch nicht aus Zucker, der wird sich hier schon im\nPferdemist nicht auflösen! Dazu ist doch der Priester da, daß er\nkommt, wohin man ihn zu einem Kranken ruft.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Jesus! und ich sollte die Frechheit haben, zu mir, in diesen\nMist? ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Bist dumm wie'n Schaf!« Sie zuckte mit den Achseln und ging\ndavon.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Selbst dumm, weiß nicht was sie redet ...« brummte er, arg\nempört, fiel schwer auf sein Lager zurück und sann noch lange nach.\n»Hat sich was, das Frauenzimmer ... hale, Hochwürden, der liebe,\nspaziert sich in den Zimmern herum ... liest aus den Büchern ...\nredet mit dem lieben Gott ... und zu mir soll man ihn rufen ...\ndiese Frauen, ... nur um die Zunge laufen zu lassen ... Dumme\n...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("So blieb er denn einsam liegen, und es war als ob sie ihn\nvergessen hätten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Zuweilen nur ließ sich Witek blicken, um den Pferden Hafer\naufzuschütten oder sie zu tränken; dann reichte er auch ihm Wasser\nund verschwand bald wieder. Er lief zurück ins Hochzeitshaus, wo\nsich die Gäste allmählich zur Brauteinholung einzufinden begannen.\nZuweilen stürzte auch Fine mit Geschrei herein und steckte Jakob\nein Stück vom Hochzeitskuchen zu, sie plapperte, schnatterte,\nfüllte den Stall mit Geschrei, so daß die Hühner auf den Staffeln\nerschrocken zu gackeln anfingen, und rannte schnell davon.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Natürlich, die konnte gut rennen, denn man amüsierte sich da\nschon nicht schlecht, die Musik dröhnte durch die Wände und frohes\nGeschrei und Singen kam von daher.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Jakob lag still, denn von Zeit zu Zeit packten ihn von ungefähr\ndie Schmerzen; so horchte er denn nur hin und suchte zu erkennen,\nwas sie sich da amüsierten, dabei redete er mal mit Waupa, der ihn\nnicht für einen Augenblick verließ und gemeinsam mit ihm Fines\nKuchen verzehrte; er schnalzte zu den Pferden hinüber und redete\nmit "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page330",
      "title": "DaoH/gary"
    }
  }), _vm._v(" ihnen,\nbis sie freudig wieherten und die Köpfe von den Krippen nach ihm\ndrehten, die Jungstute riß sich sogar vom Halfter los und kam bis\nan die Pritsche zu schäkern und die feuchten, warmen Nüstern an\nsein Gesicht zu reiben.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Bist mager geworden, mein Armes, mager!« Er streichelte sie\nzärtlich und küßte sie auf die geblähten Nüstern. »Hab man keine\nAngst, bald werd' ich schon gesund, dann will ich dir die Flanken\nwieder rund machen und wenn es mit reinem Hafer sein soll ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Er wurde bald wieder still und blickte gedankenlos auf die\nschwärzlichen Aststellen, von denen an den Wänden Harz herunter\ngeronnen war, wie erstarrte blutige Tränen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Der blasse Sonnentag schaute mit stillen Augen durch die Ritzen,\ndurch die aufgesperrte Tür aber ergoß sich ein Strom flirrender,\nblitzender Helligkeit, die wie die goldenen Spinnweben der\nStoppelfelder war; die Fliegen schwirrten darin mit einem\ntaumeligen, schläfrigen Summen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Stunden auf Stunden gingen dahin, schleppten sich langsam\nvorüber, wie blinde, lahme Bettler, die mühselig über schlimme\nSandwege ziehen; sie gingen in Stille, oder sie waren wie ein\nStein, der ins Bodenlose fällt und stürzt, sich verliert,\nentschwindet, daß selbst das Auge ihn nicht mehr greifen kann.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Manchmal nur stürmte ein Haufen schilpender Spatzen in den Stall\nund machte sich keck über die Krippen her ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Was für verständige Biester!« flüsterte er. »So ein Vöglein,\nund der Herr Jesus gibt ihm den Verstand, daß es weiß, wo es die\nNahrung finden kann. Ruhig, Waupa, laß sie sich satt essen und\ndurchhelfen, die armen Dinger, auch für sie kommt der Winter.« Er\nbesänftigte den Hund, der aufgesprungen war, die Räuber\nfortzujagen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Auf dem Hof fingen die Schweine an zu quieken und sich gegen die\nEcken der Stallwand zu reiben, so daß das ganze Gebäude bebte, und\ndanach schoben sie ihre langen, dreckigen Rüssel durch die Tür und\ngrunzten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page331",
      "title": "wolfeh/gary"
    }
  }), _vm._v(" »Treib'\nsie 'raus, Waupa, dieses Lungervolk, die haben nie genug!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Kaum waren sie weg, da begannen die Hühner am Eingang zu gacksen\nund ein großer roter Hahn guckte behutsam herein, wich zurück,\nschlug mit den Flügeln und krähte, bis er plötzlich frech über die\nSchwelle sprang und sich über den Kober voll Hafer machte, und\nhinter ihm her erschienen seine Hühner, aber sie kamen nicht zum\nrechten Essen, denn ein Trupp schnatternder Gänse tauchte auf; es\nflimmerten auf der Schwelle die roten zischelnden Schnäbel und die\nlanggestreckten Halse bewegten sich hin und her.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Treib' sie 'raus, mein Hund, treib' sie 'raus! Das Kroppzeug\nhat nur immerzu miteinander zu zanken, ganz wie die Weiber!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Es ertonte denn auch gleich ein Lärm, Geschrei und ein Flug elf\nlatschen, und Federn flogen auf, wie aus einem aufgerissenen\nFederbett, denn Waupa ließ sich nicht sein Vergnügen entgehen, er\nkehrte keuchend mit heraushängender Zunge zurück und winselte\nfreudig.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Still da!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Vom Haus herüber tönte das Schimpfen Gusches, Hin- und Herlaufen\nund das Stoßen der von Stube zu Stube gezerrten Gegenstände.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Sie bereiten sich zur Brauteinholung!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Über die Straße kam hin und wieder einer gefahren, und jetzt\nschlurfte knarrend irgendein Wagen vorüber. Jakob suchte eifrig\nalles zu erkennen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Klembs Leiterwagen, ein Pferd hat er vor, will gewiß Nadelstreu\naus dem Wald holen. Natürlich vorne ist die Achse ausgerieben und\ndarum scheuert die Nabe und knarrt.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Auf den Wegen hallten Schritte; Gespräche, Stimmen ließen sich\nhören und kaum vernehmbare, kaum empfundene Töne zitterten in der\nLuft, aber er ergriff sie im Fluge und suchte sie zu\nunterscheiden.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page332",
      "title": "wolfeh/DaoH"
    }
  }), _vm._v(" »Der\nalte Pietraß geht in die Schenke,« brummte er. Walentys Frau hat\nwas zu schreien ... gewiß sind die Gössel von irgendwem auf ihre\nSeite gekommen ... Ein Teufel, nicht ein Weib ist das! Kosiols\nFrau, scheint mir ... natürlich ... sie läuft und schreit ...\nnatürlich ist sie es!... Rafus sein Peter ... schwadroniert, das\nBiest, als ob er Klöse im Maul hat ... sieh, die Priesterstute\nfährt nach Wasser, jawohl ... sie bleibt stehen ... hat sich\nfestgefahren ... wird noch mal die Beine brechen ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und so tat er langsam sich alles heraushören, und wanderte mit\nseinen Gedanken und seinem hellsehenden Empfinden durchs ganze\nDorf, er sorgte, kümmerte, beunruhigte sich und lebte das Leben des\nDorfes, so daß er kaum bemerkte, wie der Tag langsam verstrich; das\nLicht auf den Wänden begann zu erlöschen, der Türausschnitt\nerblaßte und im Stall fing die Dämmerung an zu weben.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Schon ganz gegen Abend kam Ambrosius, er war noch nicht ganz\nnüchtern, denn er ging noch unsicher und redete so schnell, daß man\nihn kaum verstehen konnte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das Bein sollst du dir verrenkt haben?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Seht mal nach und helft.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Schweigend wickelte er die blutgetränkten Lappen ab. Sie waren\nangetrocknet und klebten so fest am Bein, daß Jakob himmelhoch zu\nschreien anfing.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Selbst 'ne Jungfrau bei der Geburt quiekt nicht so!« knurrte er\nverächtlich.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Es schmerzt doch! Jesus! Zerrt doch nicht so!« Er heulte auf,\nfast wie ein Tier.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Die haben dich aber noblicht zugerichtet! Ein Hund hat dir die\nWade ausgebissen, oder was ist das?« rief er erstaunt, denn die\nWade war zerfetzt und eiterig und das Bein dick geschwollen wie\neine Kanne.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Da ... sagt es nur ja nicht ... der Förster hat mich\nangeschossen ... nur ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wahrhaftig ... Schrot sitzt unter der Haut dicht wie "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page333",
      "title": "DaoH/gary"
    }
  }), _vm._v(" Mohn ... Hat er dir\ndie denn von weitem aufgebrannt? Ho, ho! mir deucht mit dem Klumpen\nist es aus ... die Knöchelchen knacken nur so. Warum hast du mich\ndenn nicht gleich gerufen?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich hab' mich gefürchtet ... wenn die das gemerkt hätten, einen\nHasen wollt' ich ... ich hatt' ihn auch schon geschossen ... und\nwar schon mitten auf dem Feld ... und da knallt der auf mich los\n...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Einmal hat der Förster in der Schenke erzählt, daß ihnen da\njemand Schaden macht ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hale ... Schaden ... als ob die Hasen vielleicht jemandem\ngehörten ... Aas... hat sich lauern gelegt, um mich zu kriegen ...\nauf dem Feld bin ich schon, und der schießt aus beiden Läufen auf\nmich ... daß dich, du Satan ... sagt es nur ja nicht... vor Gericht\nwürden sie einen bringen ... die Flurjäger... und auf der Stelle\nwürden sie die Flinte wegnehmen ... und sie tut mir doch nicht\ngehören ... Ich dachte, das soll selbst vorübergehen ... helft mir\ndoch bloß, denn es schmerzt und reißt so schrecklich ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»So ein Schlaumeier bist du! So ein Heimlicher, sieht aus, als\nob er von nichts nicht weiß und teilt sich mit dem Gutsherrn die\nHasen auf ... Sieh mal an ... aber mit dem Klumpen wirst du\nbezahlen müssen bei dem Kompagniegeschäft ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Er besah das Bein noch einmal und wurde arg bedenklich.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Zu spät, viel zu spät!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Helft doch, helft doch nur,« stöhnte Jakob entsetzt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Ambrosius antwortete nichts mehr, krempte nur die Ärmel hoch,\nholte ein scharfes Taschenmesser hervor, packte das Bein fest an\nund fing an, die Schrotkörner herauszukratzen und den Eiter\nherauszudrücken.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Zu Anfang brüllte Jakob los wie ein Tier, das geschlachtet wird,\nbis ihm Ambrosius das Maul mit dem Schafpelz zustopfte, dann wurde\ner plötzlich still, denn er war vor "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page334",
      "title": "wolfeh/DaoH"
    }
  }), _vm._v(" Schmerzen besinnungslos geworden.\nAmbrosius reinigte ihm das wunde Bein, belegte es mit einer Salbe\nund umwickelte es mit neuen Lappen, dann erst machte er sich daran,\nihn wieder zu Bewußtsein zu bringen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ins Spital mußt du gehen ...,« knurrte er leise.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ins Spital? ...« Jakob war noch ganz benommen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das Bein würden sie dir abschneiden, dann würdest du vielleicht\ngesund werden.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das Bein?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Natürlich, nichts mehr wert ist es, ganz verdorben, wird schon\nschwarz.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Abschneiden?« fragte er, ohne zu begreifen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Im Knie. Hab' man keine Angst, mir hat die Kugel das Bein\ngleich unterm Hintern abgerissen und ich leb' doch auch noch.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ihr meint, man braucht nur das kranke Teil abzuschneiden, und\ndann war' ich wieder gesund? ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»In einem Nu ... aber du mußt gleich ins Spital ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Nee, ich hab' Angst, nee... nicht ins Spital...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Dummer! ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Da schneiden sie einen bei lebendigem Leibe kaputt ... da ...\nSchneidet ihr ... ich zahl' euch was ihr wollt, tut es doch ... ich\nwill nicht ins Spital, lieber schon hier verrecken ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Dann verreckst du auch ... das kann dir nur der Doktor\nabschneiden. Gleich geh' ich zum Schulzen, daß sie dir für morgen\neine Fuhre geben und dich in die Stadt fahren.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ihr redet umsonst, denn ins Spital geh' ich nicht ...« sagte er\nentschlossen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hale, als wenn man dich erst fragen tut, so 'n Dummer!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Abschneiden und gleich werd' ich wieder gesund ...,«\nwiederholte Jakob leise nach seinem Weggehen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Der Fuß hörte auf zu schmerzen noch der Behandlung, aber er war\nsteif geworden bis zu den Weichen und über die ganze Seite fühlte\ner ein Kribbeln, wie von Ameisen; er "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page335",
      "title": "wolfeh/DaoH"
    }
  }), _vm._v(" achtete nicht darauf, denn er war ganz in\nGedanken versunken.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gesund würde ich werden! Das muß schon so sein, daß es so ist,\ndem Ambrosius fehlt doch auch das ganze Bein ... einen Stelzfuß hat\ner ... Und er sagt, daß es in einem Nu wieder gut ist ... Aber der\nBoryna würde mich fortjagen ... natürlich, ein Knecht ohne Bein ...\ntaugt nicht zum Pflug und nicht zur Arbeit. Was soll ich da bloß\nanfangen? Das Vieh hüten oder auf den Bettel gehen ... in die Welt\nhinaus, an die Kirchenmauer ...? Oder wie ein alter Schuh auf den\nMüllhaufen kommen ... am Zaun verrecken. Barmherziger Jesus! Oh\nJesus!« Plötzlich hatte er es klar begriffen und richtete sich fast\nganz auf in betäubender Angst. »Jesus! Jesus!« wiederholte er wie\nim Fieber, am ganzen Körper schlotternd und geistesabwesend vor\nsich hinstarrend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Ein tiefes, schmerzzerrissenes Weinen quoll in ihm auf, ein\nSchrei der Hilflosigkeit eines rettungslos in den Abgrund\nStürzenden.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sein Weinen wurde zu einem Heulen, lange rang er hin und her mit\nseiner Qual, doch durch Tränen und Verzweiflung fingen sich in ihm\nirgendwelche Entschlüsse und Überlegungen an zu regen, er wurde\nlangsam still, beruhigte sich und vertiefte sich so in sich selbst,\ndaß er nicht mehr hörte, was um ihn geschah; wie durch einen fernen\nTraum dämmerte ihm ein Spielen, Singen und ein naher Lärm auf.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Gerade um diese Zeit siedelten die Hochzeitsgäste zu Boryna\nüber.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Man bewerkstelligte die Einholung Jagnas zu ihrem Ehemann.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Kurz vordem hatte man eine mächtige Kuh herübergeführt und eine\nTruhe, Federbetten, sowie verschiedenes Gerät, das sie noch als\nMitgift bekommen hatte, herübergefahren.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Jetzt aber, vielleicht ein Paternoster nach Sonnenuntergang, als\nes schummerig wurde und die Welt infolge eines "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page336",
      "title": "wolfeh/DaoH"
    }
  }), _vm._v(" bevorstehenden\nWitterungswechsels sich mit Nebeln zu umspinnen begann, schoben die\nMenschen im Haufen aus dem Hause der Dominikbäuerin auf die\nStraße.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Musik ging an der Spitze und spielte frisch auf; hinterher\naber wurde die noch ganz hochzeitsmäßig gekleidete Jagusch von der\nMutter, den Brüdern und Gevattern geführt; nebenher und\nhinterdrein, wie es gerade kam, drängte sich die Schar der\nHochzeitsgäste.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie gingen langsam am Weiher entlang, der wie schwarz angelaufen\ndalag und unter der Last der Dämmerung zu erlöschen begann, mitten\ndurch den immer dichter werdenden Nebel in der Stille einer noch\nstumpfen und blinden Dunkelheit, so daß das Getrampel der Füße und\ndas Spiel der Instrumente dumpf und eingeengt klang, als kämen die\nTöne aus der Tiefe des Wassers.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Jugend stimmte hin und wieder ein Liedchen an, eine\nGevatterin trällerte los, oder einer von den Männern juchzte sein\n»da-dana,« doch sie verstummten bald, es war noch keine rechte Lust\nda, und die nasse Kälte fuhr einem durch Mark und Bein.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Erst als sie in den Heckenweg einbogen, der auf den Borynahof\nzuführte, fingen die Brautjungfern an zu singen:")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Und es kam der Dirn' das Weinen"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nvor dem Traualtar;"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nvier Lichter wurden angebrannt,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nman spielte die Orgel sogar."), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nUnd du, Mädchen, hast gedacht,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\ndaß sie dir ewig spielen werden? ..."), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nGestern etwas, heute etwas ..."), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nUnd sonst Not und Leid auf Erden ..."), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nDa-dana! Und sonst Not und Leid auf Erden!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Auf der Galerie, auf der Schwelle wartete schon Boryna, die\nJunggesellen und Fine.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Vorweg kam die Dominikbäuerin mit einem Bündel, in dem sich eine\nBrotschnitte, eine Prise Salz, ein Stück Kohle, Wachs von einer\nTotenkerze und ein Büschel Ähren, das "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page337",
      "title": "wolfeh/DaoH"
    }
  }), _vm._v(" am Kräutersonntag geweiht war,\nbefanden, und als Jagusch über die Schwelle ging, warfen die\nGevatterinnen ausgezupfte Stoffasern und Hede hinter ihr her, damit\nder Böse keinen Zutritt habe und daß ihr alles gedeihen sollte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Gleichzeitig begrüßten sie sich, küßten sich und wünschten dem\njungen Paar Glück, Gesundheit und was da der liebe Gott noch geben\nmag, und alles strömte in die Stube, so daß sie bald alle Bänke und\nWinkel besetzt hatten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Musikanten klimperten leise, ihre Instrumente stimmend, um\ndie Bewirtung nicht zu stören, mit der Boryna selbst den Gästen\naufwartete.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Er ging mit einem vollen Maßkrug von Gevatter zu Gevatter, bot\nan, nötigte, umarmte und trank jedem zu; der Schmied war ihm dabei\nbehilflich und schenkte in der anderen Ecke der Stube ein, wahrend\nMagda und Fine einen mit Honig zubereiteten Quarkkuchen auf Tellern\nherumtrugen, den die Schmiedin absichtlich für die Brauteinholung\ngebacken hatte, um sich bei Vätern lieb Kind zu machen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Aber es wollte nicht recht mit dem Amüsement vorwärtskommen,\nnatürlich goß man nicht den Schnaps hinter sich, anstatt in den\nMund und mied die Gläser nicht; sie tranken selbst mit Lust\neinander zu, nur daß sie irgendwie nicht zur rechten Feststimmung\nkommen konnten und nicht ins Sieden gerieten, kaum daß die Freude\nein paar Bläslein steigen ließ, wie Wasser auf schwachem Feuer; sie\nsaßen matt herum, bewegten sich schwer, linkisch, sprachen wenig\nund leise und der eine oder der andere der Älteren gähnte heimlich,\nstreckte sich sehnsüchtig und dachte nur daran, wie er wohl\nirgendwo so schnell wie möglich ins Stroh kommen könnte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und die Frauen, obgleich sie ein Gezücht sind, das am meisten\nLärm macht und nie genug vom Amüsieren kriegt, drückten sich auf\nden Bänken herum und steckten in den Ecken einsilbig\nbeieinander.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Jaguscha hatte sich in der ehelichen Kammer gleich die sonstige\nFesttracht angezogen und trat hinaus, um zu bewirken "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page338",
      "title": "wolfeh/DaoH"
    }
  }), _vm._v(" und die Gäste zu\nempfangen, aber die Mutter ließ sie nichts anrühren.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Genieß du deine Hochzeit, mein Töchterchen! Wirst noch genug\nArbeit und Mühe haben!« flüsterte sie; sie zog sie immer wieder in\nihre Arme und drückte sie mit Tränen in den Augen ans Herz, so daß\nes manch einem seltsam dünkte, sie ging doch nicht in die Welt,\nheiratete nicht in ein anderes Dorf und hatte keine Armut zu\nerwarten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie lachten über diese mütterliche Zärtlichkeit und wetzten ihre\nZungen mit Spötteleien; jetzt erst bei der Brauteinholung, da\nJagusch als Hofbäuerin und Besitzerin in das eheliche Haus\neingezogen war, gingen ihnen die Augen auf; so viel Grund und\nBoden, das viele Hab und Gut, und alles das hatte sie jetzt. Manch\neiner der Mütter, deren Töchter schon lange in den Heiratsjahren\nwaren, fuhr der Neid in die Gurgel, und den Mädchen war es auch\nnicht recht gut zumute, es kam ihnen irgendwelche Verdrießlichkeit\nan.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie gingen miteinander auf die andere Seite des Hauses hinüber,\nwo früher Anteks gewohnt hatten; Gusche und Eve bereiteten hier das\nAbendessen vor. Es war ein starkes Geknatter auf dem Feuerherd, und\nWitek konnte gar nicht genug Holzkloben zutragen und unter die\ngewaltigen Kochtöpfe schieben.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie krochen im ganzen Haus herum und lugten mit ihren neidischen\nAugen durch jede Ritze.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Wie hätte das auch anders zugehen können, daß man so ein Los\nnicht neiden sollte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Allein schon das Haus, das beste im ganzen Dorf war's, groß,\nhell, hoch, die Stuben rein, wie im Herrenhof, sein geweißt und mit\nFußböden und wie sauber! Und das viele Mobiliar, die verschiedenen\nGeräte, und dann all die Bilder, an die zwanzig Stück sicherlich,\nund alle mit Glas. Und was war da nicht alles: Kuhställe,\nPferdeställe, und die Scheune, und der Schuppen! Und war da nicht\nvielleicht genug lebendes Inventar! Fünf Kuhschwänze allein, ohne\nden "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page339",
      "title": "wolfeh/DaoH"
    }
  }), _vm._v(" Bullen,\nder doch auch ein ordentliches Stück Profit abwirft! Drei Pferde;\nund die Felder, und die Schweine, und die Gänse, und ...!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie seufzten schmerzlich und immer wieder fing die oder jene\neins ums andere Mal zu reden an.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Mein Gott, daß doch der Herr Jesus immer solchen alles gibt,\ndie es gar nicht verdient haben!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Die haben es verstanden, sich zu helfen, die wissen\nBescheid!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das ist mal sicher, allemal kriegt der was, der angelaufen\nkommt.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Warum ist denn eure Ulisja nicht so klug gewesen,\nentgegenzukommen?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Weil sie Gottesfurcht genug hat und ein ehrliches Leben\nführt.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das ist mit den anderen auch so.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und einer anderen wird nichts nachgesehen, man braucht sie nur\neinmal zur nächtlichen Zeit mit einem zu sehen, und gleich wird sie\nauf den Zungen durch die ganze Welt getragen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»So eine hat Glück ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Weil sie keine Scham hat.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Kommt doch 'rüber« rief Jendschych. »Die Musik spielt und in\nder Stube ist kein einziger Weiberrock. Man will doch was zu tanzen\nhaben!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Guck mal an, was der für Lust hat, und wird dir denn die Mutter\n... erlauben?...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Laß dir nur nicht deine Höschen abrutschen bei dieser Fahrt,\nsonst gibt's noch'n Spiegel zu sehen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Und halt die Klumpen besser beisammen!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Geh mit Walentys Frau tanzen, dann gibt es zwei Plumpsäcke\nbeieinander!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Jendschych ließ nur einen Fluch fahren, griff sich die erste\nbeste heraus und führte sie mit sich, ohne viel darauf zu achten,\nwas da hinter ihm her summte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page340",
      "title": "wolfeh/DaoH"
    }
  }), _vm._v(" In der\nStube tanzten sie schon, wenn auch nur langsam und fast\nwiderwillig; Nastuscha Täubich und Schymek Patsches allein drehten\nsich eifrig im Tanz. Sie hatten sich schon vordem verabredet, und\nals die Musik ansetzte, nahmen sie sich fest in die Arme und\ntanzten gründlich und ehrlich, und jedesmal wenn sie absetzten,\nwandelten sie umschlungen in der Stube einher, Hüfte an Hüfte\ngeschmiegt, so daß es sie ordentlich nach einander verlangte; man\nhörte sie lustig reden und laut lachen, die Dominikbäuerin aber\nverfolgte ihren Sohn immerzu mit unruhigen Augen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Erst als der Schulze kam, denn er hatte sich verspätet, weil er\ndie Rekruten nach dem Kreisamt bringen mußte, kam Leben in die\nLeute; kaum war er eingetreten, kaum hatte er dem und jenem\nzugetrunken, da fing er schon an mit seinen Gastgebern herumzureden\nund die jungen Eheleute zu necken.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Der Herr Bräutigam ist wie eine gekalkte Wand und die Braut wie\nfeines rotes Haartuch.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das könnt ihr morgen sagen ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ihr seid doch ein Praktikus, Matheus, da habt ihr doch den Tag\nnicht verpaßt.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ist doch nicht wie ein Gänserich, ... vor allen Leuten!\n...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Nicht ein halbes Maß Schnaps wett' ich dafür! Wirf du mal einen\nStein in die Büsche, da wird schon immer irgendein Vöglein\nherausgeflogen kommen, das sag' ich euch, der Schulze!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie lachten laut los, denn Jagna war auf die andere Seite\ngeflüchtet.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Auch die Weiber stichelten, soviel ihnen die Spucke nur\n'rantrug.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Bald steigerte sich das Stimmengewirr, und Fröhlichkeit ergriff\ndie Gemüter; der Schulze hatte ehrlich dazu geholfen, und auch der\nSchnaps tat das seine; Boryna sparte nicht und ließ die Flasche oft\ndie Runde machen; auch der Tanz "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page341",
      "title": "wolfeh/DaoH"
    }
  }), _vm._v(" ging nun lebhafter und rascher vonstatten,\nsie fingen schon an zu singen und aufzutrampeln und drehten sich in\neinem immer größeren Kreise durch die Stube.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Gerade zu dieser Zeit erschien Ambrosius, ließ sich, kaum daß er\nüber die Schwelle war, nieder und ging mit seinen gierigen Augen\nder Branntweinflasche nach.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Euer Kopf dreht sich immer nur dahin, wo die Gläser klirren!«\nwarf der Schulze hin.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Die klirren, weil das ihr Amt ist; und wer den labet, der da\nlechzt, der tuet wohl!« entgegnete er ernst.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wasser gefällig, alter Schlauch?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Was dem Vieh schmeckt, schadet dem Menschen! Man sagt doch:\n›Wen das Wasser erlöst, den erlöst es ... der Schnaps stellt aber\njeden auf die Beine‹.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Denn trink 'mal einen Branntwein, wenn du so'n Kalkulant\nbist.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Trinkt mir zu, Herr Schulze! Man sagt auch das: ›Die Taufe nimm\nin Wasser, die Hochzeit begieß mit Wein und den Tod mit\nTränen‹.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Recht haben sie, trinkt einen zweiten ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Vor dem dritten lauf' ich auch nicht weg! Ich trinke immer\neinen für meine erste Frau und zwei für die zweite.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Warum denn das?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Weil sie zur rechten Zeit gestorben ist, damit ich noch 'ne\ndritte haben kann.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Auf 'ne Frau sinniert er, und es ist doch schon nach der\nAbendzeit bei ihm, die Nacht sitzt ihm schon in den Glotzen\n...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Mein Stecken find't schon noch bei Nacht die Weiberbeine!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Stube erdröhnte vor Gelächter.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Die Gusche wollen wir euch anheiraten!« schrien die Frauen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Den Schnaps mag sie und das Maulwerk hat sie auch,« ergänzten\ndie anderen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page342",
      "title": "wolfeh/DaoH"
    }
  }), _vm._v(" »Man\nsagt: ›ein arbeitsamer Mann und eine Frau, die ihre Schnauze\nbrauchen kann, kriegen sich die halbe Welt zusamm'n‹.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Der Schulze setzte sich zu ihm hin und die anderen ringsherum,\nwo nur ein Platz auf den Bänken war; und als keiner mehr zu finden\nwar, blieben sie stehen, drängten sich zu einem Haufen zusammen und\nnahmen fast die Hälfte der Stube ein, ohne auf die Tanzenden zu\nachten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Gleich begannen da allerhand Neckereien, Erfindungen,\nErzählungen, lustige Reden und Anekdötchen, so daß schier die Wände\nbebten; am meisten aber räsonierte Ambrosius, den Buckel voll log\nsich die Kanaille und erzählte einem seine Lügengeschichten direkt\nins Gesicht, aber so geschickt und ergötzlich, daß sie sich vor\nLachen krümmten; und von den Frauen ließ sich die Wachnikbäuerin\nvon keinem übertrumpfen, ihr Maulwerk war obenan, und auch der\nSchulze pflichtete ihr bei, soweit ihm das sein Ansehen und sein\nAmt erlaubte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Musik geigte schwungvoll und mächtig, und die Jugend schwang\nsich frisch herum, juchzte und stieß scharf mit den Absätzen auf,\nsie aber belustigten sich gemeinsam so froh, daß sie die ganze\nliebe Welt vergessen hatten, bis einer plötzlich im Flur Jankel\nentdeckte. Sie schleppten ihn in die Stube. Der Jude nahm die Mütze\nab, verbeugte sich, begrüßte die Anwesenden freundschaftlich, ohne\ndarauf zu achten, daß ihm die Spottnamen wie Steine um die Ohren\nflogen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Rotkopf! Ungetaufter! Sohn einer Stute!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ruhig da! Schnaps geben, traktiert ihn mal,« rief der\nSchulze.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Bin ich gegangen den Weg, wollt' ich sehen, wie sich die Herren\nHofbauern vergnüglich machen. Gott vergelt's, Herr Schulze, ich\nwill den Schnaps trinken, was soll ich nicht trinken auf die\nGesundheit von dem Brautpaar?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Boryna brachte eine Flasche und schenkte ein. Jankel "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page343",
      "title": "wolfeh/DaoH"
    }
  }), _vm._v(" wischte das Glas\nmit dem Schoß seines Kaftans ab, bedeckte sich und trank aus und\ngoß noch einen zweiten hinter die Binde.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Bleibt da, Jankel, Unkoscheres sollt ihr nicht haben. Heda,\nMusikanten, spielt den Jüdischen auf! laßt Jankel tanzen!« riefen\nsie lachend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich kann schon tanzen, das ist keine Sünde!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Doch bevor die Musikanten die Zurufe begriffen hatten, schob\nsich Jankel auf den Flur hinaus und verschwand im Hof, er war nach\nJakob geeilt, das Gewehr in Empfang zu nehmen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie hatten nicht einmal sein Verschwinden gemerkt, denn\nAmbrosius setzte seine Aufschneidereien fort, und die\nWachnikbäuerin tat ihr Bestes, ihn zu begleiten, als müßte sie die\nBaßgeige zu seinem Schelmenlied spielen; so war ihnen die Zeit bis\nzum Abendessen vergangen; die Musik spielte schon leiser, man hatte\ndie Tische aufgestellt und lärmte mit den Schüsseln, sie aber\nlachten in einem fort.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Vergeblich lud Boryna zum Essen ein, man hörte nicht einmal auf\nihn. Darauf wiederholte auch Jagusch mehrmals, daß sie doch kommen\nmöchten, da hatte sie aber schon der Schulze mitten in den Haufen\ngezogen, an seine Seite gesetzt und hielt sie fest bei der\nHand.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Schließlich rief Jaschek, den man den ›Verkehrten‹ nannte, ganz\nlaut:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»An die Schüsseln, Leute, das Essen wird sonst kalt!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Halt's Maul, Dummkopf, auch für dich wird sich eine Schüssel\nzum Auslecken finden.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Der Küster lügen nur so, daß es raucht. Er denkt wohl, daß ihm\neiner was glauben tut ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Höre mal, du, was man dir ins Maul gibt, das kannst du nehmen,\ndas ist deins, aber rühr' mich nicht an, damit wirst du nicht\nfertig.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wollen sehen!« schrie der Bursche zurück; er war etwas dummelig\nund schwer von Begriff.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page344",
      "title": "wolfeh/DaoH"
    }
  }), _vm._v(" »Der\nOchs wird ebenso mit mir fertig, vielleicht selbst besser noch,«\nwarf Ambrosius ihm zu.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Was der Pfarrer in den Eimer leert, tragt Ambrosius hinaus, nun\nmeint er, er hat den ganzen Pfarrer.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Laß du nur ein Kalb in die Kirche, dann hat es auch nichts\nBesseres zu tun, als den Schwanz hochzuheben! Dummes Frauenzimmer!«\nknurrte er gekränkt, denn es war Jascheks Mutter, die den Versuch\ngemacht hatte, ihren Sohn zu verteidigen. Als erster erhob er sich\nund hinter ihm her fingen die anderen an, ihre Plätze an den\nTischen einzunehmen. Sie beeilten sich, denn die Köchinnen trugen\ndie dampfenden Schüsseln herein und schmackhafte Düfte zogen durch\ndie Stube.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie setzten sich dem Alter nach hin, wie es sich bei einem\nBrauteinholungsfest schickte. Die Dominikbäuerin mit ihren Söhnen\nsaß in der Mitte; die Brautjungfern und die Brautführer setzten\nsich beieinander zu Tisch, und Boryna war mit Jagusch mitten in der\nStube geblieben, um die Gäste zu bedienen und auf alles Obacht zu\ngeben.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Es wurde ganz still. Nur hinter den Fensterscheiben kreischten\ndie Dorfkinder und prügelten sich untereinander, und Waupa lief\nbellend ums Haus und versuchte in den Hausflur einzudringen. Die\nLeute aber bewältigten mit ruhiger Würde das Essen und stachen auf\ndie gehäuften Schüsseln ein. Man hörte nur die Löffel gegen die\nKerben des Geschirrs kratzen und die Gläser klirren, die fleißig\ndie Runde machten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Jagusch aber forderte immerzu auf, schob fast jedem etwas zu,\nsei es Fleisch oder andere Speisen; sie nötigte die Gäste, daß sie\nsich ja an allem gütlich tun möchten, und es ging ihr so geschickt\nvonstatten, sie verstand jedem so passend etwas Schmeichelhaftes zu\nsagen und tat zu jedermann mit solcher Anmut freundlich, daß manch\neiner von den Burschen sie mit sehnsüchtigen Augen verfolgte, und\ndie Mutter sich vor Zufriedenheit reckte, ihren Löffel beiseite\nlegte, um "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page345",
      "title": "wolfeh/DaoH"
    }
  }), _vm._v("\nbesser nach ihr hinschauen zu können und sich über sie zu\nfreuen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Auch Boryna merkte es, eilte ihr nach, als sie zu den Köchinnen\nwollte, holte sie im Flur ein, preßte sie fest an sich und küßte\nsie heftig ab.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Du meine liebe Wirtin! Wie eine Gutsherrin weißt du dir zu\nhelfen und zu raten!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Bin ich denn vielleicht nicht die Wirtin? Aber geht nur wieder\nin die Stube. Gulbas und Simeon sitzen mürrisch da und essen kaum\nwas. Trinkt ihnen mal zu.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Versteht sich, daß er ging und ihr gehorchen tat, und alles\nmachte, was sie nur wollte. Jagusch aber war es seltsam froh und\nlustig zumute. Sie fühlte sich Hausherrin und keine geringe / eine\nGutsfrau fast; das Regieren kam ihr wie von selbst, und\ngleichzeitig wuchs in ihr die Würde und ein machtvoller,\nselbstsicherer Stolz. Sie ging durch die Stuben und trug sich\naufrecht und ungezwungen, sah nach allem scharf und leitete alles\nso verständig, als ob sie Gott weiß wie lange schon auf Eigenem\ngewirtschaftet hätte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wie sie ist, wird der Alte bald selber merken müssen, das ist\nschon seine Sache, aber mir scheint, sie gibt 'ne gute Hausfrau\nab,« flüsterte Eve der Gusche zu.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Klug ist auch die Kathrine, wenn sie was hat in der Terrine!«\nantwortete diese hämisch. »Laß den Alten ihr erst mal zuwider\nwerden, und laß sie erst mal hinter den Burschen herjagen ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das wird sie doch nicht tun, nur dahinter sitzt doch noch der\nMatthias, der wird sie schon nicht so leicht fahren lassen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ih ... fahren lassen! Dazu wird ihn schon ein anderer\nkriegen...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Boryna?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hale, Boryna! Da gibt es doch noch einen, der stärker ist als\ndie beiden ... jawohl... laßt nur erst die Zeit kommen und ihr\nsollt sehen ...,« sie lächelte listig. »Witek, jag mal den Hund\nweg, der bellt und bellt, daß einem die Ohren "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page346",
      "title": "lac/DaoH"
    }
  }), _vm._v(" weh tun, kannst auch die verdammten\nJungen auseinandertreiben, die drücken uns hier noch die Scheiben\nein und zerren den Wandschutz auseinander.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Witek rannte mit der Peitsche hinaus, der Hund verstummte und\nman hörte nur noch das Gekreisch von Kinderstimmen und das\nGetrappel der fortlaufenden Füße; er jagte sie bis auf den Weg\nhinaus und lief dann vornübergebeugt zurück, denn ein Hagel von\nSteinen und Schmutzklumpen sauste ihm nach.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Witek! wart' mal!« rief Rochus, der an der Hausecke nach dem\nHof zu im Dunkeln stand. »Ruf' Ambrosius, er soll gleich kommen\nwegen einer wichtigen Angelegenheit, ich wart' auf der\nGalerie.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Erst nach einem Paternoster kam Ambrosius stark erzürnt heraus,\ndenn er war mächtig böse, daß man ihm das Essen im besten\nAugenblick, grad' beim Spanferkel mit Erbsen unterbrochen\nhatte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Brennt die Kirche, oder was?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Schreit nicht, kommt mit zu Jakob, mir ist, er stirbt.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Laß ihn verrecken ... Leute hier beim Essen stören. Nach dem\nVesper bin ich doch bei ihm gewesen und hab' ihm gesagt, daß er\nsich zum Spital bereit hält, das Bein würden sie ihm da abschneiden\nund dann wäre er gleich wieder gesund! ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das habt ihr ihm gesagt! Jetzt begreif' ich; ich glaube, er hat\nes sich selber abgeschnitten ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Jesus, Maria! Was denn, selbst abgeschnitten? ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Kommt, kommt schnell, ihr könnt ja nachsehen. Ich ging in den\nKuhstall, um mich schlafen zu legen, kaum bin ich auf dem Hof,\nspringt Waupa mich an, bellt, winselt, zerrt mit den Zähnen an\nmeinem Rock, reißt mich vorwärts, ich wußte gar nicht, was er\nwollte ... und er voraus, und sitzt an der Schwelle des\nPferdestalles und winselt. Ich ging also hin und will sehen, was da\nist; da liegt Jakob auf der Schwelle, mit dem Kopf noch im Stall.\nIch dacht' erst, er "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page347",
      "title": "wolfeh/DaoH"
    }
  }), _vm._v(" wollte Luft schnappen und daß ihm dabei schwach\ngeworden wär'. Ich trug ihn also auf die Pritsche und hab' die\nLaterne angezündet, um Wasser zu finden, und wie ich ihn zu sehen\nkrieg', liegt er ganz in Blut und leichenblaß, und vom Bein her\nströmt nur immer so das Blut. Laß uns nur rasch gehen, damit er uns\nnicht wegstirbt ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie traten in den Stall, und Ambrosius machte sich scharf dran,\nihn in die Besinnung zu bringen; Jakob lag regungslos, atmete wenig\nund stoßweise und röchelte durch die zusammengepreßten Zähne, so\ndaß man sie ihm geradezu auseinanderzwängen mußte, um ihm etwas\nWasser einzuflößen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Das Bein war ihm am Knie abgetrennt, es hing kaum noch an der\nHaut fest und blutete stark. An der Schwelle hatten sich\nverschiedene Blutlachen gebildet, und daneben lag eine\nblutbesudelte Axt, und der Schleifstein, der sonst unter der\nDachtraufe des Pferdestalls stand, lag neben der Schwelle.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Da haben wir's, sich selbst das Bein abgehackt. Angst hat er\ngehabt vor dem Spital, und der Dumme denkt, daß er sich selber\nhelfen kann, aber ein starkes Mannsbild! Jesus, sich selbst seinen\nKlumpen abzuschneiden! Gar nicht zu glauben! Hat mächtig viel Blut\nverloren.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Jakob schlug die Augen plötzlich aus und ließ sie ziemlich klar\numherschweifen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ist es abgeflogen? Zweimal hab ich drauflos gehackt, aber es\nist mir ganz schwarz vor Augen geworden ...« murmelte er.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Hast du denn Schmerzen?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Nicht die Spur ... Nur die Kräfte sind mir ganz abgegangen,\naber ich bin wohler!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Er lag still und gab nicht einen Schrei von sich, als Ambrosius\nihm das Bein zurechtlegte, reinigte und in nasse Tücher\nwickelte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Rochus hielt kniend die Laterne hin und betete so inbrünstig,\ndaß ihm die Tränen über die Wangen liefen. Jakob "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page348",
      "title": "lac/DaoH"
    }
  }), _vm._v(" lag immer noch still da und\nlächelte freudig bewegt und voll inniger Zuversicht, wie ein\nverlassenes Kindlein auf dem Feld, das den Gräsern zulächelt, die\nüber ihm säuseln, der Sonne nachschaut, zu den vorüberfliegenden\nVöglein seine Hände hebt und sich auf seine Art vergnügt und mit\nallen Dingen redet, ehe es noch weiß, daß es ohne Mutter ist, so\nwar es ihm jetzt zumute; gut war es ihm, ruhig fühlte er sich und\nohne Schmerzen, und die Seele war ihm so leicht und froh, daß er\nsich nichts aus dem Kranksein machte, sich selbst ein klein wenig\nbrüstete ..., wie gut es ihm geglückt war, das Beil zu schärfen ...\nwie er sich das Bein auf der Schwelle zurechtgelegt hatte ... und\nmitten in die Kniescheibe hatte er sich dann geschlagen ...\nAufgeschmerzt hat es, aber das Bein hat nicht auf einmal locker\ngelassen ..., da hat er aus ganzer Macht zum zweitenmal ausgeholt\n... und sieh da, jetzt ist es alle mit den Schmerzen; es wird wohl\ngenützt haben ... Wenn er nur mehr Kraft hätte, würde er keinen\nAugenblick mehr hier auf der Pritsche faulen, gleich mal mit\nHochzeit feiern ... und sich einen Tanz leisten ... auch essen,\ndenn er hat große Lust dazu.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Lieg' du ruhig und rühr' dich kein bißchen, zu essen kriegst du\ngleich, ich will's der Fine sagen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Rochus fuhr ihm mit der Hand über's Gesicht und ging mit\nAmbrosius hinaus.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Den Priester muß man ihm herholen, solange er bei Bewußtsein\nist!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Der Priester ist doch aber für den Abend nach Wola zu dem\nGutsherrn.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich hole ihn, man darf nicht zögern!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wola ist eine Meile ... in der Nacht ... und den Weg findet ihr\nnicht durch den Wald./Es steht hier ein fertiges Gespann für die\nLeute, die nach dem Abendessen wegfahren, nehmt das und fahrt.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Sie führten die Pferde auf die Dorfstraße und Rochus kletterte\nauf den Sitz.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page349",
      "title": "wolfeh/gary"
    }
  }), _vm._v(" »Und\nvergeßt mir nur den Jakob nicht, man muß für ihn sorgen!« rief er\nim Abfahren.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Allein laß ich ihn nicht, ich sorg' für ihn.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Bald aber hatte er ihn vergessen, er hatte nur gerade noch so\nviel gedacht, der Fine vom Essen zu sagen, er selbst kehrte an den\nTisch zurück und setzte sich mit einer solchen Liebe bei einer\nFlasche fest, daß er kurz darauf von der ganzen lieben Welt nichts\nmehr wußte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Fine, die ein gutmütiges Ding war, sammelte alles was sie\nkriegen konnte, bereitwillig in eine Schüssel, goß ein tüchtiges\nMaß Schnaps ein und trug alles hinüber.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Jakob, eßt ein bißchen, macht euch auch ein Fest!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Gott bezahl's dir! Die Wurst, deucht mit, hat einen guten Duft,\nes weht von ihr.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ich hab' sie doch selbst gebraten, daß ihr sie nur ja auch\nschmeckt.« Sie drückte ihm die Schüssel in die Hände, weil es im\nStall dunkel war. »Trinkt erst den Schnaps.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Er trank alles bis auf den Grund.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Bleib' doch etwas sitzen, mit ist so einsam hier.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Er fing an herumzuschmecken, hier und da ein Stückchen in den\nMund zu schieben und daran herumzukauen; aber herunterschlucken\nkonnte er nicht recht etwas.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Amesieren sie sich, was?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»So eine Hochzeit und so viel Volk, daß ich mein Leben lang\nnichts Größeres gesehen habe.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Is ja auch Boryna seine, da ist es kein Wunder,« murmelte er\nstolz.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das ist so, und der Vater freut sich so und läuft in einem zu\nhinter Jagusch her, in einem zu.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wie sollt' es auch anders ... so eine Feine und so schön ums\nMaul, wie eine Herrin!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Wißt ihr was, und der Dominikbäuerin ihr Schymek hält zu\nNastuscha Täubich.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Die Alte wird es nicht zugeben, bei der Nastuscha sitzen doch\nan die zehn Mäuler auf den drei Morgen.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page350",
      "title": "lac/gary"
    }
  }), _vm._v(" »Sie treibt\nsie auch wo sie nur kann auseinander und paßt mächtig auf.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Ist der Schulze da?«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Der amüsiert die andern und ist immer vorweg mit dem Maul, und\nder Ambrosius auch.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Das sollen sie auch, wenn sie auf solcher Hochzeit sind und bei\nso einem Bauer! Und weißt du etwas über Anteks?« fragte er\nleise.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Natürlich, ich bin am Abend schnell zu ihnen 'rübergelaufen und\nhabe den Kindern Fleisch und Kuchen und Brot gebracht ... Zum Hause\nhat er mich hinausgeworfen und hat mir, was ich gebracht habe,\nnachgeschmissen ... Er ist stark erzürnt und so böse, so böse ...\nund Not und Sorge ist im Haus ... Anna muß sich immer mit der\nSchwester herumzanken und in die Haare sollen sie sich schon\ngefahren sein.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Er sagte nichts darauf, schneuzte sich nur stark und begann\nseltsam schnell zu atmen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Fine,« sagte er nach einer Weile, »die Stute stöhnt so herum\nund legt sich seit Abend immerzu hin, die ist gewiß vor dem Fohlen\n... man müßte da Obacht geben. Was zum Trinken zurechtmachen. Wie\nsie da herumstöhnt. Das arme gute Vieh, und ich kann nicht helfen\n... furchtbar schwach bin ich ... ganz ohne Kraft ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Er wurde müde, verstummte und schien einzuschlafen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Fine ging rasch davon.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Tseschu! Tseschu, Stute,« rief er, wieder zur Besinnung\nkommend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Stute wieherte gedehnt auf und fing an hin und her zu\nzerren, so daß die Kette klirrte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Satt essen will ich mich doch einmal! Du kriegst auch deinen\nTeil, mein Hund, das kriegst du, nur nicht winseln ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Er machte sich eifrig über die Wurst her, aber er konnte nicht\n..., die Lust war ihm ganz vergangen, das Essen quoll ihm im Munde\nauf.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page351",
      "title": "lac/gary"
    }
  }), _vm._v(" »Lieber\nJesus, so viel Wurst und so viel Fleisch ... und ich kann nicht ...\nganz und gar nicht.«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Vergeblich versuchte er, beleckte, beroch/er konnte nicht, der\nArm sank schlaff herab; er schob ihn zwischen das Stroh, ohne die\nWurst aus der Hand zu lassen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Mein Gott, so viel von all dem Guten, wie ich nie im Leben\nhatte, und nu kann ich nicht ...«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Wehmut preßte ihm die Seele zusammen und Tränen flossen über\nsein Gesicht, er weinte hell auf vor Bedauern und schluchzte wie\nein Kind, dem man Unrecht getan hat.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Später will ich was essen, ich ruhe jetzt ein bißchen aus,\ndanach will ich mir ordentlich was zugute tun,« dachte er.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Aber auch später konnte er nicht, er verfiel in einen Schlaf,\nohne die Wurst aus der Hand zu lassen und ohne zu merken, daß Waupa\nim stillen davon abbiß ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Plötzlich wurde er wach, denn die Musik legte nach dem\nAbendessen so mächtig los, daß die Wände im Stall erbebten; aus den\nSchweineställen drang zu ihm das erschrockene Gackern der erwachten\nHühner.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Schreie platzten in die Welt hinaus und sprühten aus dem\nFesttrubel wie rote Lichter in die Nacht, sie hallten wie\nDonnerschläge im Stalle wieder.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Ein mächtiges Vergnügen war dort schon im Gange, Gelächter,\nFröhlichkeit und Tanz; immer wieder erdröhnte die Erde vom Gejage,\nund Mädchengekreisch zerriß die Luft.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Jakob hörte zuerst hin, doch bald vergaß er alles; ein Schlaf\nergriff ihn und trug ihn in eine unbekannte lärmerfüllte\nDunkelheit, wie unter rauschendes Wasser hinab, ... in den Schoß\nmächtiger Wälder, die irgendein Sturm aufbrausen ließ.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und als die Freude in Strömen zu fluten begann und der Wirbel\nder wütend aneinander geklappten Hacken das ganze Haus\nauseinanderzuspalten schien, wachte er etwas auf, ließ die Seele\naus den Dunkelheiten emportauchen, erhob sich aus "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page352",
      "title": "lac/gary"
    }
  }), _vm._v(" seiner Versunkenheit, kehrte\nzurück aus grauenerregenden Weiten und horchte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und manchmal versuchte er zu essen, oder flüsterte leise und\nherzlich:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("»Tsesch, Tsesch, Tseschka ... Stute!«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Aber schon ging die Seele langsam aus ihm hinaus und strebte den\nWeltenräumen zu, sie schlug noch irre Kreise/ ein armes\nJesusvögelein, und konnte sich noch nicht losreißen, so daß sie von\nZeit zu Zeit sich wieder an die heilige Erde klammerte, um von\nihrer Mühsal auszuruhen und ihr einsames Weinen im Menschenlärm zu\nertränken; sie kehrte zu denen zurück, die ihr lieb waren, kehrte\nunter die Lebendigen, rief klagend nach den Menschenbrüdern und\nflehte um Hilfe zu ihren Herzen, bis sie schließlich, durch die\nMacht und Gnade Jesu gestärkt, sich jenen Frühlingsauen\nentgegenschwang und jenen unermeßlich weiten Brachfeldern Gottes,\ndie mit ewigem Licht und ewiger Freude umspönnen sind.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und sie flog höher, weiter, weiter bis nach dahin ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Bis nach dahin, wo man schon weder menschliches Weheklagen, noch\ndas leidvolle Knirschen jeglicher Seele hört ...")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Nach dahin, wo nur noch die duftenden Lilien atmen, wo\nBlütenfelder eingebettet in ihres eigenen Honigs Süße säuseln, wo\nSternenflüsse über reichgefärbte Gründe fließen, wo der ewige Tag\nist.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("... Nach dahin, wo nur leises Beten wallt und Weihrauchdüfte wie\nNebel ziehen, wo Schellen summen und Orgelklänge leise tönen und\ndas heilige Hochamt ewig abgehalten wird, wo das schon entsühnte\nVolk, die Engel und die Heiligen gemeinsam Gottes Ehre singen/zu\njener allerheiligsten, urewigen Gotteskirche hin, wo die\nMenschenseele nichts mehr braucht, als zu beten, unter seligen\nTränen aufzuatmen und sich mit dem Herrn zu freuen auf alle ewigen\nZeiten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page353",
      "title": "lac/gary"
    }
  }), _vm._v(" Dahin riß\nsich die gequälte, ruhelechzende Seele Jakobs.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("— — — — —")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Im Hochzeitshause aber tanzten sie immerzu und freuten sich aus\nvollem Herzen. Die Lust war selbst größer noch als am gestrigen\nTage, denn die Bewirtung war noch reichlicher und die Wirte\nnötigten mit größerer Herzlichkeit. So wurde denn auch getanzt bis\nzum letzten Atemzug.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Es war eine Siedehitze in ihnen, und wenn sie nur etwas\nnachließen, erdröhnte die Musik mit erneuter Macht, so daß sie sich\nnur vorbeugten wie ein Kornfeld, in das der Sturm hineinfährt,\nneuen Anlauf nahmen, mit den Füßen Lärm aufwirbelten und mit hellem\nGeschrei einen frischen Tanz begannen, singend, festlich, dicht\ngedrängt und glutentfacht.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Glut hatte ihre Seelen weit gemacht, ließ ihr Blut\naufbrausen, ihren Verstand auf und davon rasen, und ihre Herzen\naufblühen im Übermaß der Lust; jeder Nerv bebte mit im Takt, jede\nRegung war Tanz, jeder Aufschrei/ein Gesang, und jedes Auge/ein\nLeuchten in nimmersatter Seligkeit.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("So brachten sie die Nacht dahin, bis der Morgen graute.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Und es kam der Tag ... schwer und leise erhob er sich; von den\ndüsteren, undurchdringlichen Wolkenwällen rieselte die\nMorgendämmerung auf die Welt herab. Und als die Sonne bald aufgehen\nsollte, wurde er mit einem Male wieder dunkel, und Schnee begann zu\nfallen. Es flog zuerst nur eine Flocke hin und wieder und zog\nKreise in die Luft, wie fallende Fichtennadeln am windigen Tag. Und\ndann begann es zu schneien.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Der Schnee fiel wie durch ein dichtes Sieb gerade zur Erde\nnieder, er fiel gleichmäßig, eintönig und still, breitete sich über\ndie Dächer, Bäume und Hecken aus, wie ein gebleichtes Gewebe und\nbedeckte die ganze Erde mit seinen weichen Daunen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Die Hochzeit war nun ausgefeiert, man wollte sich jedoch am\nAbend in der Schenke noch zusammenfinden, um sich aufzubessern;\nalles begann dann auseinanderzugehen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page354",
      "title": "lac/Konmax"
    }
  }), _vm._v(" Die\nBrautführer und die Brautjungfern aber mit den Musikanten an der\nSpitze stellten sich vor der Galerie auf und sangen gemeinsam ihr\nletztes Lied:")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Gute Nacht dem Brautpaar,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\n          Gute\nNacht!"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nWir wünschen gute nächtliche Zeit"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nUnd bleiben zu Diensten stets bereit."), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\n          Gute\nNacht!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page357",
      "title": "lac/Konmax"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page358",
      "title": "lac/Konmax"
    }
  })])])])
}]}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(66),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Thank you for reading this title.  Here are other classic books you might enjoy.")]), _c('div', [_c('div', {
    attrs: {
      "id": "textcafe-gallery-widget-container"
    }
  }), _vm._v(" "), _c('script', {
    attrs: {
      "type": "application/javascript"
    }
  }, [_vm._v("\n      TextCafeWidget.config({\n          'type':'related',\n          'id':'9783988264619',\n          'coverImageWidth': '30',\n          'hideDescriptions': true\n      });\n      var textCafeGalleryWidget = TextCafeWidget.widgets.galleryWidget.new({selector:'#textcafe-gallery-widget-container'});\n      textCafeGalleryWidget.render();\n    ")])])])
}]}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Vuetify"] = factory();
	else
		root["Vuetify"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 29);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = createSimpleFunctional;
/* harmony export (immutable) */ __webpack_exports__["e"] = createSimpleTransition;
/* harmony export (immutable) */ __webpack_exports__["b"] = createJavaScriptTransition;
/* harmony export (immutable) */ __webpack_exports__["f"] = directiveConfig;
/* harmony export (immutable) */ __webpack_exports__["a"] = addOnceEventListener;
/* harmony export (immutable) */ __webpack_exports__["g"] = getObjectValueByPath;
/* harmony export (immutable) */ __webpack_exports__["c"] = createRange;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function createSimpleFunctional(c) {
  var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';

  return {
    functional: true,

    render: function render(h, _ref) {
      var data = _ref.data,
          children = _ref.children;

      data.staticClass = (c + ' ' + (data.staticClass || '')).trim();

      return h(el, data, children);
    }
  };
}

function createSimpleTransition(name) {
  var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top center 0';
  var mode = arguments[2];

  return {
    functional: true,

    props: {
      origin: {
        type: String,
        default: origin
      }
    },

    render: function render(h, context) {
      context.data = context.data || {};
      context.data.props = { name: name };
      context.data.on = context.data.on || {};

      if (mode) context.data.props.mode = mode;

      context.data.on.beforeEnter = function (el) {
        el.style.transformOrigin = origin;
        el.style.webkitTransformOrigin = origin;
      };

      return h('transition', context.data, context.children);
    }
  };
}

function createJavaScriptTransition(name, functions) {
  var css = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'in-out';

  return {
    functional: true,

    props: {
      css: {
        type: Boolean,
        default: css
      },
      mode: {
        type: String,
        default: mode
      }
    },

    render: function render(h, context) {
      var data = {
        props: _extends({}, context.props, {
          name: name
        }),
        on: functions
      };

      return h('transition', data, context.children);
    }
  };
}

function directiveConfig(binding) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.assign({}, defaults, binding.modifiers, { value: binding.arg }, binding.value || {});
}

function addOnceEventListener(el, event, cb) {
  var once = function once() {
    cb();
    el.removeEventListener(event, once, false);
  };

  el.addEventListener(event, once, false);
}

function getObjectValueByPath(obj, path) {
  // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
  if (!path || path.constructor !== String) return;
  path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  path = path.replace(/^\./, ''); // strip a leading dot
  var a = path.split('.');
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (obj instanceof Object && k in obj) {
      obj = obj[k];
    } else {
      return;
    }
  }
  return obj;
}

function createRange(length) {
  return [].concat(_toConsumableArray(Array.from({ length: length }, function (v, k) {
    return k;
  })));
}

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dark: Boolean,
    light: Boolean
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isActive: !!this.value
    };
  },


  props: {
    value: {
      required: false
    }
  },

  watch: {
    value: function value(val) {
      this.isActive = !!val;
    },
    isActive: function isActive(val) {
      !!val !== this.value && this.$emit('input', val);
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__["a" /* default */]],

  props: {
    disabled: Boolean,
    fa: Boolean,
    mdi: Boolean,
    large: Boolean,
    left: Boolean,
    medium: Boolean,
    right: Boolean,
    xLarge: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        _ref$children = _ref.children,
        children = _ref$children === undefined ? [] : _ref$children;

    if (props.fa || props.mdi) console.warn('The v-icon prop \'fa\' and \'mdi\' will be deprecated in the next release. Use \'fa\' or \'mdi\' prefix in icon name instead.');
    var iconName = '';
    var iconType = 'material-icons';

    if (children.length) {
      iconName = children.pop().text;
    } else if (data.domProps && data.domProps.textContent) {
      iconName = data.domProps.textContent;
      delete data.domProps.textContent;
    } else if (data.domProps && data.domProps.innerHTML) {
      iconName = data.domProps.innerHTML;
      delete data.domProps.innerHTML;
    }

    var thirdPartyIcon = iconName.indexOf('-') > -1;
    if (thirdPartyIcon) iconType = iconName.slice(0, iconName.indexOf('-'));

    // To keep things backwards compatible for now
    iconType = props.fa ? 'fa' : props.mdi ? 'mdi' : iconType;

    data.staticClass = (iconType + ' icon ' + (data.staticClass || '')).trim();
    data.attrs = data.attrs || {};

    var classes = {
      'icon--large': props.large,
      'icon--left': props.left,
      'icon--medium': props.medium,
      'icon--right': props.right,
      'icon--x-large': props.xLarge,
      'primary--text': props.primary,
      'secondary--text': props.secondary,
      'success--text': props.success,
      'info--text': props.info,
      'warning--text': props.warning,
      'error--text': props.error,
      'theme--dark': props.dark,
      'theme--light': props.light
    };

    var iconClasses = Object.keys(classes).filter(function (k) {
      return classes[k];
    }).join(' ');
    iconClasses && (data.staticClass += ' ' + iconClasses);

    // To keep things backwards compatible for now
    if (props.fa || props.mdi) {
      var comparison = props.fa ? 'fa' : 'mdi';

      if (iconName.indexOf(' ') > -1) data.staticClass += ' ' + comparison + '-' + iconName;else data.staticClass += ' ' + comparison + '-' + iconName.split(' ').join('-');
    }

    if (thirdPartyIcon) data.staticClass += ' ' + iconName;
    if (props.disabled) data.attrs.disabled = props.disabled;
    !(thirdPartyIcon || props.fa || props.mdi) && children.push(iconName);

    return h('i', data, children);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__badge__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resize__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scroll__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tooltip__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__touch__ = __webpack_require__(81);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return __WEBPACK_IMPORTED_MODULE_0__badge__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClickOutside", function() { return __WEBPACK_IMPORTED_MODULE_1__click_outside__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Ripple", function() { return __WEBPACK_IMPORTED_MODULE_3__ripple__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Resize", function() { return __WEBPACK_IMPORTED_MODULE_2__resize__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Scroll", function() { return __WEBPACK_IMPORTED_MODULE_4__scroll__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return __WEBPACK_IMPORTED_MODULE_5__tooltip__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Touch", function() { return __WEBPACK_IMPORTED_MODULE_6__touch__["a"]; });










/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__["a" /* default */]],

  props: {
    activeClass: {
      type: String,
      default: 'btn--active'
    },
    block: Boolean,
    fab: Boolean,
    flat: Boolean,
    icon: Boolean,
    large: Boolean,
    loading: Boolean,
    outline: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: true
    },
    round: Boolean,
    small: Boolean,
    tag: {
      type: String,
      default: 'button'
    },
    type: {
      type: String,
      default: 'button'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'btn': true,
        'btn--absolute': this.absolute,
        'btn--active': this.isActive,
        'btn--block': this.block,
        'btn--bottom': this.bottom,
        'btn--disabled': this.disabled,
        'btn--flat': this.flat,
        'btn--floating': this.fab,
        'btn--fixed': this.fixed,
        'btn--hover': this.hover,
        'btn--icon': this.icon,
        'btn--large': this.large,
        'btn--left': this.left,
        'btn--loader': this.loading,
        'btn--outline': this.outline,
        'btn--raised': !this.flat,
        'btn--right': this.right,
        'btn--round': this.round,
        'btn--small': this.small,
        'btn--top': this.top,
        'theme--dark': this.dark,
        'theme--light': this.light,
        'primary': this.primary && !this.outline,
        'secondary': this.secondary && !this.outline,
        'success': this.success && !this.outline,
        'info': this.info && !this.outline,
        'warning': this.warning && !this.outline,
        'error': this.error && !this.outline,
        'primary--text': this.primary && (this.outline || this.flat),
        'secondary--text': this.secondary && (this.outline || this.flat),
        'success--text': this.success && (this.outline || this.flat),
        'info--text': this.info && (this.outline || this.flat),
        'warning--text': this.warning && (this.outline || this.flat),
        'error--text': this.error && (this.outline || this.flat)
      };
    }
  },

  methods: {
    // Prevent focus to match md spec
    click: function click(e) {
      !this.fab && e.detail && this.$el.blur();

      this.$emit('click', e);
    },
    genContent: function genContent() {
      return this.$createElement('div', { 'class': 'btn__content' }, [this.$slots.default]);
    },
    genLoader: function genLoader() {
      var children = [];

      if (!this.$slots.loader) {
        children.push(this.$createElement('v-progress-circular', {
          props: {
            indeterminate: true,
            size: 26
          }
        }));
      } else {
        children.push(this.$slots.loader);
      }

      return this.$createElement('span', { 'class': 'btn__loading' }, children);
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    var children = [this.genContent()];

    tag === 'button' && (data.attrs.type = this.type);
    this.loading && children.push(this.genLoader());

    return h(tag, data, children);
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VCarouselTransition */
/* unused harmony export VCarouselReverseTransition */
/* unused harmony export VTabTransition */
/* unused harmony export VTabReverseTransition */
/* unused harmony export VMenuTransition */
/* unused harmony export VFabTransition */
/* unused harmony export VDialogTransition */
/* unused harmony export VDialogBottomTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VFadeTransition; });
/* unused harmony export VScaleTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VSlideXTransition; });
/* unused harmony export VSlideXReverseTransition */
/* unused harmony export VSlideYTransition */
/* unused harmony export VSlideYReverseTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VExpandTransition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__expand_transition__ = __webpack_require__(71);




// Component specific transitions
var VCarouselTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-transition');
var VCarouselReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-reverse-transition');
var VTabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-transition');
var VTabReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-reverse-transition');
var VMenuTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('menu-transition');
var VFabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fab-transition', 'center center', 'out-in');

// Generic transitions
var VDialogTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-transition');
var VDialogBottomTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-bottom-transition');
var VFadeTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fade-transition');
var VScaleTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('scale-transition');
var VSlideXTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-transition');
var VSlideXReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-reverse-transition');
var VSlideYTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-transition');
var VSlideYReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-reverse-transition');

// JavaScript transitions
var VExpandTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["b" /* createJavaScriptTransition */])('expand-transition', __WEBPACK_IMPORTED_MODULE_1__expand_transition__["a" /* default */]);

/* harmony default export */ __webpack_exports__["d"] = ({
  VCarouselTransition: VCarouselTransition,
  VCarouselReverseTransition: VCarouselReverseTransition,
  VDialogTransition: VDialogTransition,
  VDialogBottomTransition: VDialogBottomTransition,
  VFabTransition: VFabTransition,
  VFadeTransition: VFadeTransition,
  VMenuTransition: VMenuTransition,
  VScaleTransition: VScaleTransition,
  VSlideXTransition: VSlideXTransition,
  VSlideXReverseTransition: VSlideXReverseTransition,
  VSlideYTransition: VSlideYTransition,
  VSlideYReverseTransition: VSlideYReverseTransition,
  VTabReverseTransition: VTabReverseTransition,
  VTabTransition: VTabTransition,
  VExpandTransition: VExpandTransition
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themeable__ = __webpack_require__(1);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__themeable__["a" /* default */]],

  data: function data() {
    return {
      errorBucket: [],
      focused: false,
      tabFocused: false,
      lazyValue: this.value
    };
  },


  props: {
    appendIcon: String,
    appendIconCb: Function,
    disabled: Boolean,
    error: Boolean,
    errorMessages: {
      type: [String, Array],
      default: function _default() {
        return [];
      }
    },
    hint: String,
    hideDetails: Boolean,
    label: String,
    persistentHint: Boolean,
    placeholder: String,
    prependIcon: String,
    prependIconCb: Function,
    required: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tabindex: {
      default: 0
    },
    value: {
      required: false
    }
  },

  computed: {
    hasError: function hasError() {
      return this.validations.length || this.error;
    },
    inputGroupClasses: function inputGroupClasses() {
      return Object.assign({
        'input-group': true,
        'input-group--focused': this.focused,
        'input-group--dirty': this.isDirty,
        'input-group--tab-focused': this.tabFocused,
        'input-group--disabled': this.disabled,
        'input-group--error': this.hasError,
        'input-group--append-icon': this.appendIcon,
        'input-group--prepend-icon': this.prependIcon,
        'input-group--required': this.required,
        'input-group--hide-details': this.hideDetails,
        'input-group--placeholder': !!this.placeholder,
        'theme--dark': this.dark,
        'theme--light': this.light
      }, this.classes);
    },
    isDirty: function isDirty() {
      return this.inputValue;
    },
    modifiers: function modifiers() {
      var modifiers = {
        lazy: false,
        number: false,
        trim: false
      };

      if (!this.$vnode.data.directives) {
        return modifiers;
      }

      var model = this.$vnode.data.directives.find(function (i) {
        return i.name === 'model';
      });

      if (!model) {
        return modifiers;
      }

      return Object.assign(modifiers, model.modifiers);
    },
    validations: function validations() {
      return (!Array.isArray(this.errorMessages) ? [this.errorMessages] : this.errorMessages).concat(this.errorBucket);
    }
  },

  watch: {
    rules: function rules() {
      this.validate();
    }
  },

  mounted: function mounted() {
    this.validate();
  },


  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    genMessages: function genMessages() {
      var _this = this;

      var messages = [];

      if ((this.hint && this.focused || this.hint && this.persistentHint) && this.validations.length === 0) {
        messages = [this.genHint()];
      } else if (this.validations.length) {
        messages = this.validations.map(function (i) {
          return _this.genError(i);
        });
      }

      return this.$createElement('transition-group', {
        'class': 'input-group__messages',
        props: {
          tag: 'div',
          name: 'slide-y-transition'
        }
      }, messages);
    },
    genHint: function genHint() {
      return this.$createElement('div', {
        'class': 'input-group__hint',
        key: this.hint,
        domProps: { innerHTML: this.hint }
      });
    },
    genError: function genError(error) {
      return this.$createElement('div', {
        'class': 'input-group__error',
        key: error
      }, error);
    },
    genIcon: function genIcon(type) {
      var _class;

      var icon = this[type + 'Icon'];
      var cb = this[type + 'IconCb'];
      var hasCallback = typeof cb === 'function';

      return this.$createElement('v-icon', {
        'class': (_class = {}, _defineProperty(_class, 'input-group__' + type + '-icon', true), _defineProperty(_class, 'input-group__icon-cb', hasCallback), _class),
        on: {
          click: function click(e) {
            hasCallback && cb(e);
          }
        }
      }, icon);
    },
    genInputGroup: function genInputGroup(input) {
      var _this2 = this;

      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var children = [];
      var wrapperChildren = [];
      var detailsChildren = [];

      data = Object.assign({}, {
        'class': this.inputGroupClasses,
        attrs: {
          tabindex: this.tabindex
        },
        on: {
          blur: function blur() {
            return _this2.tabFocused = false;
          },
          click: function click() {
            return _this2.tabFocused = false;
          },
          keyup: function keyup(e) {
            if ([9, 16].includes(e.keyCode)) {
              _this2.tabFocused = true;
            }
          },
          keydown: function keydown(e) {
            if (!_this2.toggle) return;

            if ([13, 32].includes(e.keyCode)) {
              e.preventDefault();
              _this2.toggle();
            }
          }
        }
      }, data);

      if (this.$slots.label || this.label) {
        children.push(this.genLabel());
      }

      wrapperChildren.push(input);

      if (this.prependIcon) {
        wrapperChildren.unshift(this.genIcon('prepend'));
      }

      if (this.appendIcon) {
        wrapperChildren.push(this.genIcon('append'));
      }

      children.push(this.$createElement('div', {
        'class': 'input-group__input'
      }, wrapperChildren));

      detailsChildren.push(this.genMessages());
      this.counter && detailsChildren.push(this.genCounter());

      children.push(this.$createElement('div', {
        'class': 'input-group__details'
      }, detailsChildren));

      return this.$createElement('div', data, children);
    },
    validate: function validate() {
      var _this3 = this;

      this.errorBucket = [];

      this.rules.forEach(function (rule) {
        var valid = typeof rule === 'function' ? rule(_this3.value) : rule;

        if (valid !== true) {
          _this3.errorBucket.push(valid);
        }
      });
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    primary: Boolean,
    secondary: Boolean,
    success: Boolean,
    info: Boolean,
    warning: Boolean,
    error: Boolean
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    append: Boolean,
    disabled: Boolean,
    exact: Boolean,
    href: [String, Object],
    to: [String, Object],
    nuxt: Boolean,
    replace: Boolean,
    router: Boolean,
    ripple: {
      type: Boolean,
      default: true
    },
    tag: String
  },

  methods: {
    click: function click() {},
    generateRouteLink: function generateRouteLink() {
      var exact = this.exact;
      var tag = void 0;

      var data = {
        attrs: { disabled: this.disabled },
        class: this.classes,
        props: {},
        directives: [{
          name: 'ripple',
          value: this.ripple || false
        }],
        on: Object.assign({
          click: this.click
        }, this.$listeners || {})
      };

      if (typeof this.exact === 'undefined') {
        exact = this.to === '/' || this.to === Object(this.to) && this.to.path === '/';
      }

      if (this.to) {
        tag = this.nuxt ? 'nuxt-link' : 'router-link';
        data.props.to = this.to;
        data.props.exact = exact;
        data.props.activeClass = this.activeClass;
        data.props.append = this.append;
        data.props.replace = this.replace;
      } else {
        tag = this.href && 'a' || this.tag || 'a';

        if (tag === 'a') {
          data.attrs.href = this.href || 'javascript:;';
        }
      }

      return { tag: tag, data: data };
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isBooted: false
    };
  },


  watch: {
    isActive: function isActive() {
      this.isBooted = true;
    }
  },

  methods: {
    showLazyContent: function showLazyContent(content) {
      return this.lazy && this.isBooted || !this.lazy ? content : null;
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VListTileActionText */
/* unused harmony export VListTileAvatar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VListTileContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VListTileTitle; });
/* unused harmony export VListTileSubTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VListGroup__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VListTileAction__ = __webpack_require__(21);







var VListTileActionText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__action-text', 'span');
var VListTileAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__avatar', 'v-avatar');
var VListTileContent = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__content', 'div');
var VListTileTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__title', 'div');
var VListTileSubTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__sub-title', 'div');

/* harmony default export */ __webpack_exports__["c"] = ({
  VList: __WEBPACK_IMPORTED_MODULE_1__VList__["a" /* default */],
  VListTile: __WEBPACK_IMPORTED_MODULE_3__VListTile__["a" /* default */],
  VListGroup: __WEBPACK_IMPORTED_MODULE_2__VListGroup__["a" /* default */],
  VListTileAction: __WEBPACK_IMPORTED_MODULE_4__VListTileAction__["a" /* default */],
  VListTileActionText: VListTileActionText,
  VListTileAvatar: VListTileAvatar,
  VListTileContent: VListTileContent,
  VListTileTitle: VListTileTitle,
  VListTileSubTitle: VListTileSubTitle
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    absolute: Boolean,
    bottom: Boolean,
    fixed: Boolean,
    left: Boolean,
    right: Boolean,
    top: Boolean
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    flat: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    hover: Boolean,
    img: String,
    raised: Boolean,
    tile: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card ' + (data.staticClass || '')).trim();
    data.style = data.style || {};
    data.style.height = props.height;

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.flat) data.staticClass += ' card--flat';
    if (props.horizontal) data.staticClass += ' card--horizontal';
    if (props.hover) data.staticClass += ' card--hover';
    if (props.light) data.staticClass += ' theme--light';
    if (props.raised) data.staticClass += ' card--raised';
    if (props.tile) data.staticClass += ' card--tile';

    if (props.img) {
      data.style.background = 'url(' + props.img + ') center center / cover no-repeat';
    }

    return h('div', data, children);
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isSaving: false
    };
  },


  props: {
    actions: Boolean,
    autosave: Boolean,
    landscape: Boolean,
    noTitle: Boolean,
    scrollable: Boolean,
    value: {
      required: true
    },
    light: {
      type: Boolean,
      default: true
    },
    dark: Boolean
  },

  methods: {
    save: function save() {},
    cancel: function cancel() {},
    genSlot: function genSlot() {
      return this.$scopedSlots.default({
        save: this.save,
        cancel: this.cancel
      });
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    contentClass: {
      default: ''
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      if (_this._isDestroyed) return;

      var app = document.querySelector('[data-app]');

      if (!app) {
        return console.warn('Application is missing <v-app> component.');
      }

      app.insertBefore(_this.$refs.content, app.firstChild);
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.$refs.content) return;

    // IE11 Fix
    try {
      this.$refs.content.parentNode.removeChild(this.$refs.content);
    } catch (e) {}
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      overlay: null,
      overlayOffset: 0,
      overlayTransitionDuration: 500
    };
  },


  props: {
    hideOverlay: Boolean
  },

  beforeDestroy: function beforeDestroy() {
    this.removeOverlay();
  },


  methods: {
    genOverlay: function genOverlay() {
      var _this = this;

      if (!this.isActive || this.hideOverlay || this.isActive && this.overlay) return;

      this.overlay = document.createElement('div');
      this.overlay.className = 'overlay';
      this.overlay.onclick = function () {
        if (_this.permanent) return;else if (!_this.persistent) _this.isActive = false;else if (_this.isMobile) _this.isActive = false;
      };

      if (this.absolute) this.overlay.className += ' overlay--absolute';

      this.hideScroll();

      if (this.absolute) {
        // Required for IE11
        var parent = this.$el.parentNode;
        parent.insertBefore(this.overlay, parent.firstChild);
      } else {
        document.querySelector('[data-app]').appendChild(this.overlay);
      }

      this.overlay.clientHeight; // Force repaint
      requestAnimationFrame(function () {
        _this.overlay.className += ' overlay--active';
      });

      return true;
    },
    removeOverlay: function removeOverlay() {
      var _this2 = this;

      if (!this.overlay) {
        return this.showScroll();
      }

      this.overlay.classList.remove('overlay--active');

      setTimeout(function () {
        // IE11 Fix
        try {
          _this2.overlay.parentNode.removeChild(_this2.overlay);
          _this2.overlay = null;
          _this2.showScroll();
        } catch (e) {}
      }, this.overlayTransitionDuration);
    },
    hideScroll: function hideScroll() {
      // Check documentElement first for IE11
      // this.overlayOffset = document.documentElement &&
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop

      // document.body.style.top = `-${this.overlayOffset}px`
      // document.body.style.position = 'fixed'
      document.documentElement.style.overflow = 'hidden';
    },
    showScroll: function showScroll() {
      document.documentElement.removeAttribute('style');

      // if (!this.overlayOffset) return
      // document.body.scrollTop = this.overlayOffset
      // document.documentElement.scrollTop = this.overlayOffset
    }
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list',

  provide: function provide() {
    return {
      listClick: this.listClick,
      listClose: this.listClose
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      uid: null,
      groups: []
    };
  },


  props: {
    dense: Boolean,
    subheader: Boolean,
    threeLine: Boolean,
    twoLine: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list': true,
        'list--two-line': this.twoLine,
        'list--dense': this.dense,
        'list--three-line': this.threeLine,
        'list--subheader': this.subheader,
        'theme--dark dark--bg': this.dark,
        'theme--light light--bg': this.light
      };
    }
  },

  watch: {
    uid: function uid() {
      var _this = this;

      this.$children.filter(function (i) {
        return i.$options._componentTag === 'v-list-group';
      }).forEach(function (i) {
        return i.toggle(_this.uid);
      });
    }
  },

  methods: {
    listClick: function listClick(uid, force) {
      if (force) {
        this.uid = uid;
      } else {
        this.uid = this.uid === uid ? null : uid;
      }
    },
    listClose: function listClose(uid) {
      if (this.uid === uid) {
        this.uid = null;
      }
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      attrs: { 'data-uid': this._uid }
    };

    return h('ul', data, [this.$slots.default]);
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-tile',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_2__directives__["Ripple"]
  },

  inheritAttrs: false,

  props: {
    activeClass: {
      type: String,
      default: 'list__tile--active'
    },
    avatar: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list__tile': true,
        'list__tile--avatar': this.avatar,
        'list__tile--disabled': this.disabled
      };
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    data.attrs = Object.assign({}, data.attrs, this.$attrs);

    return h('li', {
      attrs: {
        disabled: this.disabled
      }
    }, [h(tag, data, [this.$slots.default])]);
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function directive(e, el, binding, v) {
  var cb = function cb() {
    return true;
  };

  if (binding.value) cb = binding.value;

  if (v.context.isActive && e && e.target && e.target !== el && !el.contains(e.target) && cb(e)) {
    v.context.isActive = false;
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, v) {
    v.context.$vuetify.load(function () {
      var outside = document.querySelector('[data-app]');
      var click = function click(e) {
        return directive(e, el, binding, v);
      };
      outside.addEventListener('click', click, false);
      el._clickOutside = click;
    });
  },
  unbind: function unbind(el) {
    var outside = document.querySelector('[data-app]');
    outside && outside.removeEventListener('click', el._clickOutside, false);
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function style(el, value) {
  ['transform', 'webkitTransform'].forEach(function (i) {
    el.style[i] = value;
  });
}

var ripple = {
  show: function show(e, el, _ref) {
    var _ref$value = _ref.value,
        value = _ref$value === undefined ? {} : _ref$value;

    var container = document.createElement('span');
    var animation = document.createElement('span');

    container.appendChild(animation);
    container.className = 'ripple__container';

    if (value.class) {
      container.className += ' ' + value.class;
    }

    var size = el.clientWidth > el.clientHeight ? el.clientWidth : el.clientHeight;
    animation.className = 'ripple__animation';
    animation.style.width = size * (value.center ? 1 : 2) + 'px';
    animation.style.height = animation.style.width;

    el.appendChild(container);
    var computed = window.getComputedStyle(el);
    if (computed.position !== 'absolute' && computed.position !== 'fixed') el.style.position = 'relative';

    var offset = el.getBoundingClientRect();
    var x = value.center ? '50%' : e.clientX - offset.left + 'px';
    var y = value.center ? '50%' : e.clientY - offset.top + 'px';

    animation.classList.add('ripple__animation--enter');
    animation.classList.add('ripple__animation--visible');
    style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ') scale3d(0.01,0.01,0.01)');
    animation.dataset.activated = Date.now();

    setTimeout(function () {
      animation.classList.remove('ripple__animation--enter');
      style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ')  scale3d(0.99,0.99,0.99)');
    }, 0);
  },

  hide: function hide(el) {
    var ripples = el.getElementsByClassName('ripple__animation');

    if (ripples.length === 0) return;
    var animation = ripples[ripples.length - 1];
    var diff = Date.now() - Number(animation.dataset.activated);
    var delay = 400 - diff;

    delay = delay < 0 ? 0 : delay;

    setTimeout(function () {
      animation.classList.remove('ripple__animation--visible');

      setTimeout(function () {
        // Need to figure out a new way to do this
        try {
          if (ripples.length < 1) el.style.position = null;
          animation.parentNode && el.removeChild(animation.parentNode);
        } catch (e) {}
      }, 300);
    }, delay);
  }
};

function directive(el, binding, v) {
  if (binding.value === false) return;

  if ('ontouchstart' in window) {
    el.addEventListener('touchend', function () {
      return ripple.hide(el);
    }, false);
    el.addEventListener('touchcancel', function () {
      return ripple.hide(el);
    }, false);
  }

  el.addEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.addEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.addEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

function unbind(el, binding) {
  el.removeEventListener('touchstart', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('touchend', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('touchcancel', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  unbind: unbind
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  name: 'list-tile-action',

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children;

    data.staticClass = data.staticClass ? 'list__tile__action ' + (data.staticClass || '') : 'list__tile__action';
    if ((children || []).length > 1) data.staticClass += ' list__tile__action--stack';

    return h('div', data, children);
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_activator__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_position__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_utils__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-menu',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_activator__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_position__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_utils__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__["a" /* default */]],

  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_7__directives__["ClickOutside"]
  },

  data: function data() {
    return {
      autoIndex: null,
      dimensions: {
        activator: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        content: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        list: null,
        selected: null
      },
      direction: { vert: 'bottom', horiz: 'right' },
      isContentActive: false,
      isBooted: false,
      maxHeightAutoDefault: '200px',
      resizeTimeout: {},
      startIndex: 3,
      stopIndex: 0,
      tileLength: 0,
      window: {},
      absoluteX: 0,
      absoluteY: 0,
      hasJustFocused: false,
      focusedTimeout: {}
    };
  },


  props: {
    top: Boolean,
    left: Boolean,
    bottom: Boolean,
    right: Boolean,
    fullWidth: Boolean,
    auto: Boolean,
    offsetX: Boolean,
    offsetY: Boolean,
    disabled: Boolean,
    maxHeight: {
      default: 'auto'
    },
    nudgeTop: {
      type: Number,
      default: 0
    },
    nudgeBottom: {
      type: Number,
      default: 0
    },
    nudgeLeft: {
      type: Number,
      default: 0
    },
    nudgeRight: {
      type: Number,
      default: 0
    },
    nudgeWidth: {
      type: Number,
      default: 0
    },
    openOnClick: {
      type: Boolean,
      default: true
    },
    openOnHover: {
      type: Boolean,
      default: false
    },
    lazy: Boolean,
    closeOnClick: {
      type: Boolean,
      default: true
    },
    closeOnContentClick: {
      type: Boolean,
      default: true
    },
    activator: {
      default: null
    },
    origin: {
      type: String,
      default: 'top left'
    },
    transition: {
      type: String,
      default: 'menu-transition'
    },
    positionX: {
      type: Number,
      default: null
    },
    positionY: {
      type: Number,
      default: null
    },
    positionAbsolutely: {
      type: Boolean,
      default: false
    },
    maxWidth: [Number, String],
    minWidth: [Number, String]
  },

  computed: {
    calculatedMinWidth: function calculatedMinWidth() {
      var minWidth = parseInt(this.minWidth) || this.dimensions.activator.width + this.nudgeWidth + (this.auto ? 16 : 0);

      if (!this.maxWidth) return minWidth;

      var maxWidth = parseInt(this.maxWidth);

      return maxWidth < minWidth ? maxWidth : minWidth;
    },
    styles: function styles() {
      return {
        maxHeight: this.auto ? '200px' : isNaN(this.maxHeight) ? this.maxHeight : this.maxHeight + 'px',
        minWidth: this.calculatedMinWidth + 'px',
        maxWidth: parseInt(this.maxWidth) + 'px',
        top: this.calcTop() + 'px',
        left: this.calcLeft() + 'px'
      };
    },
    hasActivator: function hasActivator() {
      return !!this.$slots.activator || this.activator;
    }
  },

  watch: {
    activator: function activator(newActivator, oldActivator) {
      this.removeActivatorEvents(oldActivator);
      this.addActivatorEvents(newActivator);
    },
    disabled: function disabled(val) {
      val && this.deactivate();
    },
    hasJustFocused: function hasJustFocused(val) {
      var _this = this;

      if (!val) return;

      clearTimeout(this.focusedTimeout);
      this.focusedTimeout = setTimeout(function () {
        return _this.hasJustFocused = false;
      }, 550);
    },
    isActive: function isActive(val) {
      if (this.disabled) return;

      val && this.activate() || this.deactivate();
    },
    windowResizeHandler: function windowResizeHandler() {
      this.isBooted = false;
    }
  },

  mounted: function mounted() {
    window.addEventListener('resize', this.onResize, { passive: true });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize, { passive: true });
    window.removeEventListener('resize', this.windowResizeHandler);
  },


  methods: {
    activate: function activate() {
      if (typeof window === 'undefined') return;
      this.isBooted = true;
      this.getTiles();
      this.updateDimensions();
      requestAnimationFrame(this.startTransition);
      this.$emit('activate');
    },
    deactivate: function deactivate() {
      this.isContentActive = false;
      this.$emit('deactivate');
    },
    onResize: function onResize() {
      clearTimeout(this.resizeTimeout);
      if (!this.isActive) return;
      this.resizeTimeout = setTimeout(this.updateDimensions, 200);
    },
    startTransition: function startTransition() {
      var _this2 = this;

      requestAnimationFrame(function () {
        return _this2.isContentActive = true;
      });
      requestAnimationFrame(this.calculateScroll);
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': 'menu',
      style: {
        display: this.fullWidth ? 'block' : 'inline-block'
      },
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this3.closeOnClick;
        }
      }],
      on: {
        keydown: function keydown(e) {
          if (e.keyCode === 27) _this3.isActive = false;else _this3.changeListIndex(e);
        }
      }
    };

    return h('div', data, [this.genActivator(), this.genTransition()]);
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-linear',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["b" /* VFadeTransition */],
    VSlideXTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["c" /* VSlideXTransition */]
  },

  props: {
    active: {
      type: Boolean,
      default: true
    },
    buffer: Boolean,
    bufferValue: Number,
    error: Boolean,
    height: {
      type: [Number, String],
      default: 7
    },
    indeterminate: Boolean,
    info: Boolean,
    secondary: Boolean,
    success: Boolean,
    query: Boolean,
    warning: Boolean,
    value: {
      type: [Number, String],
      default: 0
    },
    colorFront: {
      type: String,
      default: null
    },
    colorBack: {
      type: String,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'progress-linear--query': this.query,
        'progress-linear--secondary': this.secondary,
        'progress-linear--success': this.success,
        'progress-linear--info': this.info,
        'progress-linear--warning': this.warning,
        'progress-linear--error': this.error
      };
    },
    styles: function styles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      if (this.buffer) {
        styles.width = this.bufferValue + '%';
      }

      return styles;
    },
    bufferStyles: function bufferStyles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      return styles;
    }
  },

  methods: {
    genDeterminate: function genDeterminate(h) {
      return h('div', {
        ref: 'front',
        class: ['progress-linear__bar__determinate', this.colorFront],
        style: { width: this.value + '%' }
      });
    },
    genBar: function genBar(h, name) {
      return h('div', {
        class: ['progress-linear__bar__indeterminate', name, this.colorFront]
      });
    },
    genIndeterminate: function genIndeterminate(h) {
      return h('div', {
        ref: 'front',
        class: {
          'progress-linear__bar__indeterminate': true,
          'progress-linear__bar__indeterminate--active': this.active
        }
      }, [this.genBar(h, 'long'), this.genBar(h, 'short')]);
    }
  },

  render: function render(h) {
    var fade = h('v-fade-transition', [this.indeterminate && this.genIndeterminate(h)]);
    var slide = h('v-slide-x-transition', [!this.indeterminate && this.genDeterminate(h)]);

    var bar = h('div', { class: ['progress-linear__bar', this.colorBack], style: this.styles }, [fade, slide]);

    return h('div', {
      class: ['progress-linear', this.classes],
      style: { height: this.height + 'px' },
      on: this.$listeners
    }, [bar]);
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_helpers__ = __webpack_require__(0);



















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-select',

  components: {
    VCard: __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__["a" /* default */],
    VCheckbox: __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__["a" /* default */],
    VList: __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__["a" /* default */],
    VListTile: __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__["a" /* default */],
    VListTileAction: __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__["a" /* default */],
    VListTileContent: __WEBPACK_IMPORTED_MODULE_10__components_lists__["a" /* VListTileContent */],
    VListTileTitle: __WEBPACK_IMPORTED_MODULE_10__components_lists__["b" /* VListTileTitle */],
    VMenu: __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__["a" /* default */]
  },

  directives: {
    clickOutside: __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */]],

  data: function data() {
    return {
      content: {},
      hasFocused: false,
      inputValue: this.multiple && !this.value ? [] : this.value,
      isBooted: false,
      lastItem: 20,
      isActive: false,
      searchInputValue: this.searchInput
    };
  },


  props: {
    appendIcon: {
      type: String,
      default: 'arrow_drop_down'
    },
    auto: Boolean,
    autocomplete: Boolean,
    bottom: Boolean,
    chips: Boolean,
    close: Boolean,
    debounce: {
      type: Number,
      default: 200
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    filter: Function,
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    itemDisabled: {
      type: String,
      default: 'disabled'
    },
    maxHeight: {
      type: [Number, String],
      default: 300
    },
    minWidth: {
      type: [Boolean, Number, String],
      default: false
    },
    multiple: Boolean,
    multiLine: Boolean,
    offset: Boolean,
    searchInput: null,
    singleLine: Boolean,
    top: Boolean,
    returnObject: Boolean,
    overflow: Boolean,
    segmented: Boolean,
    editable: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field input-group--select': true,
        'input-group--auto': this.auto,
        'input-group--overflow': this.overflow,
        'input-group--segmented': this.segmented,
        'input-group--editable': this.editable,
        'input-group--autocomplete': this.autocomplete,
        'input-group--single-line': this.singleLine || this.isDropdown,
        'input-group--multi-line': this.multiLine,
        'input-group--chips': this.chips,
        'input-group--multiple': this.multiple
      };
    },
    computedContentClass: function computedContentClass() {
      var children = [this.auto ? 'menu__content--auto' : '', this.isDropdown ? 'menu__content--dropdown' : ''];

      return children.join(' ');
    },
    filteredItems: function filteredItems() {
      var items = this.autocomplete && this.searchValue ? this.filterSearch() : this.items;

      return !this.auto ? items.slice(0, this.lastItem) : items;
    },
    hasError: function hasError() {
      return this.validations.length || this.error || this.hasFocused && !this.focused && !this.isDirty && this.required;
    },
    isDirty: function isDirty() {
      return this.selectedItems.length;
    },
    isDropdown: function isDropdown() {
      return this.segmented || this.overflow || this.editable;
    },

    searchValue: {
      get: function get() {
        return this.searchInput || this.searchInputValue;
      },
      set: function set(val) {
        this.searchInputValue = val;
        this.$emit('update:searchInput', val);
      }
    },
    selectedItems: function selectedItems() {
      var _this = this;

      if (this.inputValue === null || typeof this.inputValue === 'undefined') return [];

      return this.items.filter(function (i) {
        if (!_this.multiple) {
          return _this.getValue(i) === _this.getValue(_this.inputValue);
        } else {
          // Always return Boolean
          return _this.inputValue.find(function (j) {
            return _this.getValue(j) === _this.getValue(i);
          }) !== undefined;
        }
      });
    }
  },

  watch: {
    inputValue: function inputValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      this.inputValue = val;
      this.validate();
      if (this.autocomplete || this.editable) {
        this.$nextTick(this.$refs.menu.updateDimensions);
      }
    },
    isActive: function isActive(val) {
      this.isBooted = true;
      this.lastItem += !val ? 20 : 0;

      if (!val) this.blur();else this.focus();
    },
    isBooted: function isBooted() {
      var _this2 = this;

      this.$nextTick(function () {
        if (_this2.content) {
          _this2.content.addEventListener('scroll', _this2.onScroll, false);
        }
      });
    },
    searchValue: function searchValue() {
      this.$refs.menu.listIndex = -1;
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    this.$vuetify.load(function () {
      if (_this3._isDestroyed) return;

      _this3.content = _this3.$refs.menu.$refs.content;
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isBooted) {
      if (this.content) {
        this.content.removeEventListener('scroll', this.onScroll, false);
      }
    }
  },


  methods: {
    blur: function blur() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.focused = false;
        _this4.hasFocused = true;
        _this4.searchValue = null;
        _this4.$el.blur();
      });
    },
    focus: function focus() {
      var _this5 = this;

      this.focused = true;
      this.$refs.input && (this.autocomplete || this.editable) && this.$refs.input.focus();

      if (this.editable && this.inputValue !== null && typeof this.inputValue !== 'undefined') {
        this.$nextTick(function () {
          _this5.$refs.input.value = _this5.getValue(_this5.inputValue);
        });
      }
    },
    genLabel: function genLabel() {
      if (this.searchValue && !this.focused && this.isDirty) return null;

      var data = {};

      if (this.id) data.attrs = { for: this.id };

      return this.$createElement('label', data, this.label);
    },
    getPropertyFromItem: function getPropertyFromItem(item, field) {
      if (item !== Object(item)) return item;

      var value = Object(__WEBPACK_IMPORTED_MODULE_13__util_helpers__["g" /* getObjectValueByPath */])(item, field);

      return typeof value === 'undefined' ? item : value;
    },
    getText: function getText(item) {
      return this.getPropertyFromItem(item, this.itemText);
    },
    getValue: function getValue(item) {
      return this.getPropertyFromItem(item, this.itemValue);
    },
    onScroll: function onScroll() {
      var _this6 = this;

      if (!this.isActive) {
        requestAnimationFrame(function () {
          return _this6.content.scrollTop = 0;
        });
      } else {
        var showMoreItems = this.content.scrollHeight - (this.content.scrollTop + this.content.clientHeight) < 200;

        if (showMoreItems) {
          this.lastItem += 20;
        }
      }
    },
    selectItem: function selectItem(item) {
      var _this7 = this;

      if (!this.multiple) {
        this.inputValue = this.returnObject ? item : this.getValue(item);
      } else {
        var inputValue = this.inputValue.slice();
        var i = this.inputValue.findIndex(function (i) {
          return _this7.getValue(i) === _this7.getValue(item);
        });

        i !== -1 && inputValue.splice(i, 1) || inputValue.push(item);
        this.inputValue = inputValue.map(function (i) {
          return _this7.returnObject ? i : _this7.getValue(i);
        });
      }

      if (this.autocomplete || this.editable) {
        this.$nextTick(function () {
          _this7.searchValue = null;
          _this7.$refs.input && _this7.$refs.input.focus();
        });
      }

      this.$emit('change', this.inputValue);
    }
  },

  render: function render(h) {
    var _this8 = this;

    return this.genInputGroup([this.genSelectionsAndSearch(), this.genMenu()], {
      ref: 'activator',
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this8.isActive = false;
        }
      }],
      on: {
        keydown: this.onKeyDown // Located in mixins/autocomplete.js
      }
    });
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    noDataText: {
      type: String,
      default: 'No data available'
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-checkbox',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_2__components_transitions__["b" /* VFadeTransition */],
    VIcon: __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__["a" /* default */]
  },

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_1__directives_ripple__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  data: function data() {
    return {
      inputIndeterminate: this.indeterminate
    };
  },


  props: {
    indeterminate: Boolean
  },

  computed: {
    classes: function classes() {
      return this.addColorClassChecks({
        'checkbox': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      if (this.inputIndeterminate) {
        return 'indeterminate_check_box';
      } else if (this.isActive) {
        return 'check_box';
      } else {
        return 'check_box_outline_blank';
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', [h('v-icon', {
      'class': {
        'icon--checkbox': this.icon === 'check_box'
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var data = {
      attrs: {
        role: 'checkbox',
        'aria-checked': this.inputIndeterminate && 'mixed' || this.isActive && 'true' || 'false',
        'aria-label': this.label
      }
    };

    return this.genInputGroup([transition, ripple], data);
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colorable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: null,
    falseValue: null,
    trueValue: null
  },

  computed: {
    isActive: function isActive() {
      if (Array.isArray(this.inputValue)) {
        return this.inputValue.indexOf(this.value) !== -1;
      }

      if (!this.trueValue || !this.falseValue) {
        return this.value ? this.value === this.inputValue : Boolean(this.inputValue);
      }

      return this.inputValue === this.trueValue;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      this.inputIndeterminate = val;
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle },
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    toggle: function toggle() {
      if (this.disabled) {
        return;
      }

      var input = this.inputValue;
      if (Array.isArray(input)) {
        input = input.slice();
        var i = input.indexOf(this.value);

        if (i === -1) {
          input.push(this.value);
        } else {
          input.splice(i, 1);
        }
      } else if (this.trueValue || this.falseValue) {
        input = input === this.trueValue ? this.falseValue : this.trueValue;
      } else if (this.value) {
        input = this.value === this.inputValue ? null : this.value;
      } else {
        input = !input;
      }

      this.$emit('change', input);
    }
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    color: String
  },
  methods: {
    addColorClassChecks: function addColorClassChecks(classes) {
      var parts = this.color ? this.color.trim().split(' ') : [''];
      var color = parts[0] + '--text';
      if (parts.length > 1) color += ' text--' + parts[1];
      classes[color] = !!this.color;
      return classes;
    }
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_load__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_semver__);
__webpack_require__(30);







function plugin(Vue) {
  Object.keys(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */]).forEach(function (key) {
    Vue.component(key, __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */][key]);
  });

  Object.keys(__WEBPACK_IMPORTED_MODULE_2__directives__).forEach(function (key) {
    Vue.directive(key, __WEBPACK_IMPORTED_MODULE_2__directives__[key]);
  });

  Vue.prototype.$vuetify = {
    load: __WEBPACK_IMPORTED_MODULE_3__util_load__["a" /* default */]
  };
}

function checkVueVersion() {
  var vueDep = __WEBPACK_IMPORTED_MODULE_0__package_json__["devDependencies"].vue;
  if (!__WEBPACK_IMPORTED_MODULE_4_semver___default.a.satisfies(window.Vue.version, vueDep)) {
    console.warn('Vuetify requires Vue version ' + vueDep);
  }
}

if (typeof window !== 'undefined' && window.Vue) {
  if (window.Vue.version) {
    checkVueVersion();
  }
  window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["default"] = (plugin);

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = {
	"name": "vuetify",
	"version": "0.14.10",
	"author": {
		"name": "John Leider",
		"email": "john.j.leider@gmail.com"
	},
	"license": "MIT",
	"homepage": "http://vuetifyjs.com",
	"main": "dist/vuetify.js",
	"types": "index.d.ts",
	"scripts": {
		"watch": "cross-env TARGET=dev webpack --config build/config.js --progress --hide-modules --watch",
		"dev": "cross-env NODE_ENV=development webpack-dev-server --config build/webpack.dev.config.js --open --hot",
		"build": "rimraf dist && cross-env NODE_ENV=production node build/build.js --progress --hide-modules",
		"debug-build": "node --inspect --debug-brk build/build.js",
		"test": "cross-env NODE_ENV=test jest --no-cache --verbose",
		"test-coverage": "cross-env NODE_ENV=test jest --no-cache --coverage --verbose",
		"lint": "eslint --ext .js,.vue src"
	},
	"description": "Vue.js 2 Semantic Component Framework",
	"devDependencies": {
		"autoprefixer": "^6.6.0",
		"avoriaz": "^3.2.0",
		"babel-cli": "^6.24.1",
		"babel-core": "^6.24.1",
		"babel-eslint": "^7.1.1",
		"babel-jest": "^20.0.3",
		"babel-loader": "^7.1.1",
		"babel-plugin-add-filehash": "^6.9.4",
		"babel-plugin-module-resolver": "^2.7.1",
		"babel-plugin-transform-async-to-generator": "^6.24.1",
		"babel-plugin-transform-runtime": "^6.23.0",
		"babel-preset-env": "^1.5.1",
		"babel-preset-es2015": "^6.24.1",
		"babel-preset-stage-2": "^6.24.1",
		"chalk": "^1.1.3",
		"chromedriver": "^2.21.2",
		"cross-env": "^3.1.3",
		"cross-spawn": "^4.0.2",
		"css-loader": "^0.23.1",
		"css-mqpacker": "^6.0.1",
		"cssnano": "^3.10.0",
		"eslint": "^3.7.1",
		"eslint-config-standard": "^6.1.0",
		"eslint-config-vue": "^2.0.2",
		"eslint-friendly-formatter": "^2.0.5",
		"eslint-loader": "^1.6.1",
		"eslint-plugin-html": "^1.3.0",
		"eslint-plugin-promise": "^3.4.0",
		"eslint-plugin-pug": "^1.0.0",
		"eslint-plugin-standard": "^3.0.1",
		"eslint-plugin-vue": "^2.1.0",
		"eventsource-polyfill": "^0.9.6",
		"extract-text-webpack-plugin": "^3.0.0",
		"friendly-errors-webpack-plugin": "^1.6.1",
		"function-bind": "^1.0.2",
		"jest": "^20.0.4",
		"jest-cli": "^20.0.4",
		"jest-css-modules": "^1.1.0",
		"jest-serializer-html": "^4.0.0",
		"jest-vue-preprocessor": "^0.2.0",
		"lolex": "^1.4.0",
		"nightwatch": "^0.9.8",
		"opn": "^4.0.2",
		"optimize-css-assets-webpack-plugin": "^2.0.0",
		"optimize-js-plugin": "^0.0.4",
		"ora": "^0.3.0",
		"phantomjs-prebuilt": "^2.1.3",
		"postcss-loader": "^1.2.1",
		"precss": "^1.4.0",
		"pug": "^2.0.0-beta3",
		"pug-loader": "^2.3.0",
		"ress": "^1.1.1",
		"rimraf": "^2.5.4",
		"selenium-server": "2.53.1",
		"semver": "^5.3.0",
		"serialize-javascript": "^1.3.0",
		"shelljs": "^0.7.4",
		"style-loader": "^0.13.1",
		"stylus": "^0.54.5",
		"stylus-loader": "^2.1.1",
		"uglifyjs-webpack-plugin": "^0.4.6",
		"vue": "^2.4.1",
		"vue-loader": "^10.1.0",
		"vue-router": "^2.7.0",
		"vue-server-renderer": "^2.4.1",
		"vue-template-compiler": "^2.4.1",
		"webpack": "^3.2.0",
		"webpack-bundle-size-analyzer": "^2.7.0",
		"webpack-dev-server": "^2.6.1",
		"webpack-merge": "^4.1.0"
	},
	"dependencies": {},
	"engines": {
		"node": ">= 4.0.0",
		"npm": ">= 3.0.0"
	},
	"jest": {
		"verbose": false,
		"roots": [
			"<rootDir>/src"
		],
		"moduleFileExtensions": [
			"js",
			"vue"
		],
		"moduleDirectories": [
			"node_modules"
		],
		"moduleNameMapper": {
			"src/(.*)": "<rootDir>/src/$1"
		},
		"transform": {
			".*\\.(vue)$": "<rootDir>/node_modules/jest-vue-preprocessor",
			"\\.(styl)$": "<rootDir>/node_modules/jest-css-modules",
			".*\\.(vue|js)$": "<rootDir>/node_modules/babel-jest"
		},
		"transformIgnorePatterns": [
			"node_modules/(?!vue-router)"
		],
		"snapshotSerializers": [
			"jest-serializer-html"
		]
	}
};

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__alerts__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__avatars__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bottom_nav__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__buttons__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cards__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__carousel__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chips__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pickers__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dialogs__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dividers__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__expansion_panel__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__footer__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__grid__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__icons__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__menus__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__toolbar__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pagination__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__parallax__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__progress__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__selects__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__selection_controls__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__sliders__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__subheaders__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__steppers__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__tables__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__tabs__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__text_fields__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__snackbars__ = __webpack_require__(129);


































/* harmony default export */ __webpack_exports__["a"] = (Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__alerts__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__app__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__avatars__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__bottom_nav__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__buttons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__cards__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__carousel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__chips__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__pickers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__dialogs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__dividers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__expansion_panel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__footer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__grid__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__icons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__lists__["c" /* default */], __WEBPACK_IMPORTED_MODULE_17__menus__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__toolbar__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__pagination__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__parallax__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_23__selects__["a" /* default */], __WEBPACK_IMPORTED_MODULE_24__selection_controls__["a" /* default */], __WEBPACK_IMPORTED_MODULE_25__sliders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_26__subheaders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_27__steppers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_28__tables__["a" /* default */], __WEBPACK_IMPORTED_MODULE_29__tabs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_30__text_fields__["a" /* default */], __WEBPACK_IMPORTED_MODULE_31__transitions__["d" /* default */], __WEBPACK_IMPORTED_MODULE_32__snackbars__["a" /* default */]));

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VAlert__ = __webpack_require__(34);


/* harmony default export */ __webpack_exports__["a"] = ({
  VAlert: __WEBPACK_IMPORTED_MODULE_0__VAlert__["a" /* default */]
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__ = __webpack_require__(35);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-alert',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__["a" /* default */]],

  props: {
    dismissible: Boolean,
    hideIcon: Boolean,
    icon: String
  },

  computed: {
    classes: function classes() {
      return {
        'alert': true,
        'alert--dismissible': this.dismissible,
        'error': this.error,
        'info': this.info,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'warning': this.warning
      };
    },
    mdIcon: function mdIcon() {
      switch (true) {
        case !!this.icon:
          return this.icon;
        case this.error:
          return 'warning';
        case this.info:
          return 'info';
        case this.success:
          return 'check_circle';
        case this.warning:
          return 'priority_high';
      }
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [h('div', this.$slots.default)];

    if (!this.hideIcon && this.mdIcon) {
      children.unshift(h('v-icon', {
        'class': 'alert__icon'
      }, this.mdIcon));
    }

    if (this.dismissible) {
      var close = h('a', {
        'class': 'alert__dismissible',
        domProps: { href: 'javascript:;' },
        on: { click: function click() {
            return _this.$emit('input', false);
          } }
      }, [h('v-icon', {
        props: { right: true }
      }, 'cancel')]);

      children.push(close);
    }

    var alert = h('div', {
      'class': this.classes,
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, children);

    if (!this.transition) return alert;

    return h('transition', {
      props: {
        name: this.transition,
        origin: this.origin,
        mode: this.mode
      }
    }, [alert]);
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    mode: String,
    origin: String,
    transition: String
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VApp__ = __webpack_require__(37);


/* harmony default export */ __webpack_exports__["a"] = ({
  VApp: __WEBPACK_IMPORTED_MODULE_0__VApp__["a" /* default */]
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    fixedFooter: Boolean,
    footer: Boolean,
    id: {
      type: String,
      default: 'app'
    },
    toolbar: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('application ' + (data.staticClass || '')).trim();
    data.staticClass += ' application--' + (props.dark ? 'dark' : 'light');

    props.footer && (data.staticClass += ' application--footer');
    props.fixedFooter && (data.staticClass += ' application--footer-fixed');
    props.toolbar && (data.staticClass += ' application--toolbar');

    data.attrs = { 'data-app': true };
    data.domProps = { id: props.id };

    return h('div', data, children);
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VAvatar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var VAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('avatar');

/* harmony default export */ __webpack_exports__["a"] = ({
  VAvatar: VAvatar
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBottomNav__ = __webpack_require__(40);


/* harmony default export */ __webpack_exports__["a"] = ({
  VBottomNav: __WEBPACK_IMPORTED_MODULE_0__VBottomNav__["a" /* default */]
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    shift: Boolean,
    value: { required: false }
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('bottom-nav ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' bottom-nav--absolute';
    if (props.shift) data.staticClass += ' bottom-nav--shift';
    if (props.value) data.staticClass += ' bottom-nav--active';

    return h('div', data, children);
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__ = __webpack_require__(43);



/* harmony default export */ __webpack_exports__["a"] = ({
  VBreadcrumbs: __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__["a" /* default */],
  VBreadcrumbsItem: __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__["a" /* default */]
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs',

  provide: function provide() {
    return {
      divider: this.divider
    };
  },


  props: {
    divider: {
      type: String,
      default: '/'
    },
    icons: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'breadcrumbs': true,
        'breadcrumbs--with-icons': this.icons
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': this.classes,
      props: { items: this.items }
    }, this.$slots.default);
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs-item',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  inject: ['divider'],

  props: {
    activeClass: {
      type: String,
      default: 'breadcrumbs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = _defineProperty({
        'breadcrumbs__item': true
      }, this.activeClass, !this.disabled);

      return classes;
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      attrs: { 'data-divider': this.divider }
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__ = __webpack_require__(46);




/* harmony default export */ __webpack_exports__["a"] = ({
  VBtn: __WEBPACK_IMPORTED_MODULE_0__VBtn__["a" /* default */],
  VBtnToggle: __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__["a" /* default */],
  VSpeedDial: __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__["a" /* default */]
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn-toggle',

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: {
      required: false
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    mandatory: Boolean,
    multiple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'btn-toggle': true,
        'btn-toggle--selected': this.inputValue && (!this.multiple || this.inputValue.length)
      };
    }
  },

  methods: {
    isSelected: function isSelected(item) {
      if (!this.multiple) {
        return this.inputValue === item.value;
      }

      return this.inputValue.includes(item.value);
    },
    updateValue: function updateValue(item) {
      if (!this.multiple) {
        if (this.mandatory && this.inputValue === item.value) return;
        return this.$emit('change', this.inputValue === item.value ? null : item.value);
      }

      var items = this.inputValue.slice();

      var i = items.indexOf(item.value);
      if (i > -1) {
        items.length >= 1 && !this.mandatory && items.splice(i, 1);
      } else {
        items.push(item.value);
      }

      this.$emit('change', items);
    }
  },

  render: function render(h) {
    var _this = this;

    var buttons = this.items.map(function (item, index) {
      var children = [];

      item.text && children.push(h('span', item.text));
      item.icon && children.push(h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], item.icon));

      return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], {
        key: index,
        props: {
          flat: true
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.updateValue(item);
          }
        },
        attrs: {
          'data-selected': _this.isSelected(item),
          'data-index': index,
          'data-only-child': _this.isSelected(item) && (!_this.multiple || _this.inputValue.length === 1)
        }
      }, children);
    });

    return h('div', { class: this.classes }, buttons);
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-speed-dial',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    direction: {
      type: String,
      default: 'top',
      validator: function validator(val) {
        return ['top', 'right', 'bottom', 'left'].includes(val);
      }
    },
    hover: Boolean,
    transition: {
      type: String,
      default: 'scale-transition'
    }
  },

  computed: {
    classes: function classes() {
      return _defineProperty({
        'speed-dial': true,
        'speed-dial--top': this.top,
        'speed-dial--right': this.right,
        'speed-dial--bottom': this.bottom,
        'speed-dial--left': this.left,
        'speed-dial--absolute': this.absolute,
        'speed-dial--fixed': this.fixed
      }, 'speed-dial--direction-' + this.direction, true);
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [];
    var data = {
      'class': this.classes,
      directives: [{
        name: 'click-outside'
      }],
      on: {
        click: function click() {
          return _this.isActive = !_this.isActive;
        }
      }
    };

    if (this.hover) {
      data.on.mouseenter = function () {
        return _this.isActive = true;
      };
      data.on.mouseleave = function () {
        return _this.isActive = false;
      };
    }

    if (this.isActive) {
      children = (this.$slots.default || []).map(function (b, i) {
        b.key = i;

        return b;
      });
    }

    var list = h('transition-group', {
      'class': 'speed-dial__list',
      props: {
        name: this.transition,
        tag: 'div'
      }
    }, children);

    return h('div', data, [this.$slots.activator, list]);
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VCardMedia__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VCardTitle__ = __webpack_require__(49);





var VCardActions = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__actions');
var VCardText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__text');

/* harmony default export */ __webpack_exports__["a"] = ({
  VCard: __WEBPACK_IMPORTED_MODULE_1__VCard__["a" /* default */],
  VCardActions: VCardActions,
  VCardMedia: __WEBPACK_IMPORTED_MODULE_2__VCardMedia__["a" /* default */],
  VCardText: VCardText,
  VCardTitle: __WEBPACK_IMPORTED_MODULE_3__VCardTitle__["a" /* default */]
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-card-media',

  props: {
    contain: Boolean,
    height: {
      type: [Number, String],
      default: 'auto'
    },
    src: {
      type: String
    }
  },

  render: function render(h) {
    var data = {
      'class': 'card__media',
      style: {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      },
      on: this.$listeners
    };

    var children = [];

    if (this.src) {
      children.push(h('div', {
        'class': 'card__media__background',
        style: {
          background: 'url(' + this.src + ') center center / ' + (this.contain ? 'contain' : 'cover') + ' no-repeat'
        }
      }));
    }

    children.push(h('div', {
      'class': 'card__media__content'
    }, this.$slots.default));

    return h('div', data, children);
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    primaryTitle: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card__title ' + (data.staticClass || '')).trim();

    if (props.primaryTitle) data.staticClass += ' card__title--primary';

    return h('div', data, children);
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCarousel__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__ = __webpack_require__(52);



/* harmony default export */ __webpack_exports__["a"] = ({
  VCarousel: __WEBPACK_IMPORTED_MODULE_0__VCarousel__["a" /* default */],
  VCarouselItem: __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__["a" /* default */]
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      current: null,
      items: [],
      slideInterval: {},
      reverse: false
    };
  },


  props: {
    cycle: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: 'fiber_manual_record'
    },
    interval: {
      type: Number,
      default: 6000
    },
    leftControlIcon: {
      type: [Boolean, String],
      default: 'chevron_left'
    },
    rightControlIcon: {
      type: [Boolean, String],
      default: 'chevron_right'
    }
  },

  computed: {
    defaultState: function defaultState() {
      return {
        current: null,
        reverse: false
      };
    }
  },

  watch: {
    current: function current() {
      var _this = this;

      // Evaluate items when current changes to account for
      // dynamic changing of children
      this.items = this.$children.filter(function (i) {
        return i.$el.classList && i.$el.classList.contains('carousel__item');
      });

      this.items.forEach(function (i) {
        return i.open(_this.items[_this.current]._uid, _this.reverse);
      });

      !this.isBooted && this.cycle && this.restartInterval();
      this.isBooted = true;
    },
    cycle: function cycle(val) {
      val && this.restartInterval() || clearInterval(this.slideInterval);
    }
  },

  mounted: function mounted() {
    this.init();
  },


  methods: {
    genControls: function genControls() {
      return this.$createElement('div', {
        staticClass: 'carousel__controls'
      }, this.genItems());
    },
    genIcon: function genIcon(direction, icon, fn) {
      if (!icon) return null;

      return this.$createElement('div', {
        staticClass: 'carousel__' + direction
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
        props: {
          icon: true,
          dark: this.dark || !this.light,
          light: this.light
        },
        on: { click: fn }
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], icon)])]);
    },
    genItems: function genItems() {
      var _this2 = this;

      return this.items.map(function (item, index) {
        return _this2.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
          class: {
            'carousel__controls__item': true,
            'carousel__controls__item--active': index === _this2.current
          },
          props: {
            icon: true,
            dark: _this2.dark || !_this2.light,
            light: _this2.light
          },
          key: index,
          on: { click: _this2.select.bind(_this2, index) }
        }, [_this2.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], _this2.icon)]);
      });
    },
    restartInterval: function restartInterval() {
      clearInterval(this.slideInterval);
      this.$nextTick(this.startInterval);
    },
    init: function init() {
      this.current = 0;
    },
    next: function next() {
      this.reverse = false;

      if (this.current + 1 === this.items.length) {
        return this.current = 0;
      }

      this.current++;
    },
    prev: function prev() {
      this.reverse = true;

      if (this.current - 1 < 0) {
        return this.current = this.items.length - 1;
      }

      this.current--;
    },
    select: function select(index) {
      this.reverse = index < this.current;
      this.current = index;
    },
    startInterval: function startInterval() {
      this.slideInterval = setInterval(this.next, this.interval);
    }
  },

  render: function render(h) {
    return h('div', {
      staticClass: 'carousel',
      directives: [{
        name: 'touch',
        value: {
          left: this.next,
          right: this.prev
        }
      }]
    }, [this.genIcon('left', this.leftControlIcon, this.prev), this.genIcon('right', this.rightControlIcon, this.next), this.genControls(), this.$slots.default]);
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel-item',

  data: function data() {
    return {
      active: false,
      reverse: false
    };
  },


  props: {
    src: {
      type: String,
      required: true
    },

    transition: {
      type: String,
      default: 'tab-transition'
    },

    reverseTransition: {
      type: String,
      default: 'tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    },
    styles: function styles() {
      return {
        backgroundImage: 'url(' + this.src + ')'
      };
    }
  },

  methods: {
    open: function open(id, reverse) {
      this.active = this._uid === id;
      this.reverse = reverse;
    }
  },

  render: function render(h) {
    var item = h('div', {
      class: {
        'carousel__item': true,
        'reverse': this.reverse
      },
      style: this.styles,
      on: this.$listeners,
      directives: [{
        name: 'show',
        value: this.active
      }]
    }, [this.$slots.default]);

    return h('transition', { props: { name: this.computedTransition } }, [item]);
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VChip__ = __webpack_require__(54);


/* harmony default export */ __webpack_exports__["a"] = ({
  VChip: __WEBPACK_IMPORTED_MODULE_0__VChip__["a" /* default */]
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-chip',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    close: Boolean,
    label: Boolean,
    outline: Boolean,
    small: Boolean,
    value: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'chip': true,
        'chip--label': this.label,
        'chip--outline': this.outline,
        'chip--small': this.small,
        'chip--removable': this.close
      };
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [this.$slots.default];
    var data = {
      'class': this.classes,
      attrs: { tabindex: -1 },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    };

    if (this.close) {
      children.push(h('a', {
        'class': 'chip__close',
        domProps: { href: 'javascript:;' },
        on: {
          click: function click(e) {
            e.stopPropagation();

            _this.$emit('input', false);
          }
        }
      }, [h('v-icon', { props: { right: true } }, 'cancel')]));
    }

    return h('span', data, children);
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDatePicker__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTimePicker__ = __webpack_require__(61);



/* harmony default export */ __webpack_exports__["a"] = ({
  VDatePicker: __WEBPACK_IMPORTED_MODULE_0__VDatePicker__["a" /* default */],
  VTimePicker: __WEBPACK_IMPORTED_MODULE_1__VTimePicker__["a" /* default */]
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_date_title__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_helpers__ = __webpack_require__(0);







var defaultDateFormat = function defaultDateFormat(val) {
  return new Date(val).toISOString().substr(0, 10);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-date-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_date_title__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_picker__["a" /* default */]],

  data: function data() {
    return {
      tableDate: new Date(),
      originalDate: this.value,
      currentDay: null,
      currentMonth: null,
      currentYear: null,
      isSelected: false,
      isReversing: false,
      narrowDays: []
    };
  },


  props: {
    locale: {
      type: String,
      default: 'en-us'
    },
    dateFormat: {
      type: Function,
      default: defaultDateFormat
    },
    titleDateFormat: {
      type: Object,
      default: function _default() {
        return { weekday: 'short', month: 'short', day: 'numeric' };
      }
    },
    headerDateFormat: {
      type: Object,
      default: function _default() {
        return { month: 'long', year: 'numeric' };
      }
    },
    formattedValue: {
      required: false
    },
    allowedDates: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    firstDayOfWeek: {
      type: [String, Number],
      default: 0
    },
    yearIcon: String
  },

  computed: {
    firstAllowedDate: function firstAllowedDate() {
      var date = new Date();
      date.setHours(12, 0, 0, 0);

      if (this.allowedDates) {
        var millisecondOffset = 1 * 24 * 60 * 60 * 1000;
        var valid = new Date(date);
        for (var i = 0; i < 31; i++) {
          if (this.isAllowed(valid)) return valid;

          valid.setTime(valid.getTime() + millisecondOffset);
        }
      }

      return date;
    },

    inputDate: {
      get: function get() {
        if (!this.value) return this.firstAllowedDate;
        if (this.value instanceof Date) return this.value;
        if (!isNaN(this.value) || typeof this.value === 'string' && this.value.indexOf(':') !== -1) return new Date(this.value);

        return new Date(this.value + 'T12:00:00');
      },
      set: function set(val) {
        this.$emit('input', val ? defaultDateFormat(val) : this.originalDate);
        this.$emit('update:formattedValue', val ? this.dateFormat(val) : this.dateFormat(this.originalDate));
      }
    },
    day: function day() {
      return this.inputDate.getDate();
    },
    month: function month() {
      return this.inputDate.getMonth();
    },
    year: function year() {
      return this.inputDate.getFullYear();
    },
    tableMonth: function tableMonth() {
      return this.tableDate.getMonth();
    },
    tableYear: function tableYear() {
      return this.tableDate.getFullYear();
    },
    computedTransition: function computedTransition() {
      return this.isReversing ? 'v-tab-reverse-transition' : 'v-tab-transition';
    }
  },

  watch: {
    isSelected: function isSelected(val) {
      var _this = this;

      val && this.$nextTick(function () {
        _this.$refs.years.scrollTop = _this.$refs.years.scrollHeight / 2 - 125;
      });
    },
    tableDate: function tableDate(val, prev) {
      this.isReversing = val < prev;
    },
    value: function value(val) {
      if (val) this.tableDate = this.inputDate;
    }
  },

  methods: {
    save: function save() {
      if (this.originalDate) {
        this.originalDate = this.value;
      } else {
        this.originalDate = this.inputDate;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputDate = this.originalDate;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(date) {
      if (!this.allowedDates) return true;

      if (Array.isArray(this.allowedDates)) {
        return !!this.allowedDates.find(function (allowedDate) {
          var d = new Date(allowedDate);
          d.setHours(12, 0, 0, 0);

          return d - date === 0;
        });
      } else if (this.allowedDates instanceof Function) {
        return this.allowedDates(date);
      } else if (this.allowedDates instanceof Object) {
        var min = new Date(this.allowedDates.min);
        min.setHours(12, 0, 0, 0);
        var max = new Date(this.allowedDates.max);
        max.setHours(12, 0, 0, 0);

        return date >= min && date <= max;
      }

      return true;
    }
  },

  created: function created() {
    var _this2 = this;

    var date = new Date();
    date.setDate(date.getDate() - date.getDay() + parseInt(this.firstDayOfWeek));

    Object(__WEBPACK_IMPORTED_MODULE_5__util_helpers__["c" /* createRange */])(7).forEach(function () {
      var narrow = date.toLocaleString(_this2.locale, { weekday: 'narrow' });
      _this2.narrowDays.push(narrow);

      date.setDate(date.getDate() + 1);
    });
  },
  mounted: function mounted() {
    this.currentDay = this.tableDate.getDate();
    this.currentMonth = this.tableDate.getMonth();
    this.currentYear = this.tableDate.getFullYear();
    this.tableDate = this.inputDate;
  },
  render: function render(h) {
    var children = [];

    !this.noTitle && children.push(this.genTitle());

    if (!this.isSelected) {
      var bodyChildren = [];

      bodyChildren.push(this.genHeader());
      bodyChildren.push(this.genTable());

      children.push(h('div', {
        'class': 'picker__body'
      }, bodyChildren));
    } else {
      children.push(this.genYears());
    }

    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--date': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark
      }
    }, children);
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYearIcon: function genYearIcon() {
      return this.yearIcon ? this.$createElement('v-icon', {
        props: {
          dark: true
        }
      }, this.yearIcon) : null;
    },
    genTitle: function genTitle() {
      var _this = this;

      var date = new Date(this.year, this.month, this.day);
      date = date.toLocaleString(this.locale, this.titleDateFormat);

      if (this.landscape) {
        if (date.indexOf(',') > -1) date = date.replace(',', ',<br>');else if (date.indexOf(' ') > -1) date = date.replace(' ', '<br>');
      }

      var text = this.$createElement('transition', {
        props: {
          name: 'slide-x-transition',
          mode: 'out-in'
        }
      }, [this.$createElement('div', {
        domProps: { innerHTML: date },
        key: date
      })]);

      return this.$createElement('div', {
        'class': 'picker__title'
      }, [this.$createElement('div', {
        'class': {
          'picker--date__title-year': true,
          'active': this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = true;
          }
        }
      }, [this.year, this.genYearIcon()]), this.$createElement('div', {
        'class': {
          'picker--date__title-date': true,
          'active': !this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = false;
          }
        }
      }, [text])]);
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genHeader: function genHeader() {
      return this.$createElement('div', {
        'class': 'picker--date__header'
      }, [this.genSelector()]);
    },
    genBtn: function genBtn(change, children) {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          dark: this.dark,
          icon: true
        },
        nativeOn: {
          click: function click(e) {
            e.stopPropagation();
            _this.tableDate = new Date(_this.tableYear, change);
          }
        }
      }, children);
    },
    genSelector: function genSelector() {
      var date = new Date(this.tableYear, this.tableMonth);
      var header = this.$createElement('div', {
        'class': 'picker--date__header-selector-date'
      }, [this.$createElement(this.computedTransition, [this.$createElement('strong', {
        key: this.tableMonth
      }, date.toLocaleString(this.locale, this.headerDateFormat))])]);

      return this.$createElement('div', {
        'class': 'picker--date__header-selector'
      }, [this.genBtn(this.tableMonth - 1, [this.$createElement('v-icon', 'chevron_left')]), header, this.genBtn(this.tableMonth + 1, [this.$createElement('v-icon', 'chevron_right')])]);
    }
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    wheelScroll: function wheelScroll(e) {
      e.preventDefault();

      var month = this.tableMonth;

      if (e.deltaY < 0) month++;else month--;

      this.tableDate = new Date(this.tableYear, month);
    },
    touch: function touch(value) {
      this.tableDate = new Date(this.tableYear, this.tableMonth + value);
    },
    genTable: function genTable() {
      var _this = this;

      var children = [];
      var data = {
        'class': 'picker--date__table',
        directives: [{
          name: 'touch',
          value: {
            left: function left(e) {
              return e.offsetX < -15 && _this.touch(1);
            },
            right: function right(e) {
              return e.offsetX > 15 && _this.touch(-1);
            }
          }
        }]
      };

      if (this.scrollable) {
        data.on = { wheel: this.wheelScroll };
      }

      children.push(this.$createElement('table', {
        key: this.tableMonth
      }, [this.genTHead(), this.genTBody()]));

      return this.$createElement('div', data, [this.$createElement(this.computedTransition, children)]);
    },
    genTHead: function genTHead() {
      var _this2 = this;

      var days = this.narrowDays.map(function (day) {
        return _this2.$createElement('th', day);
      });
      return this.$createElement('thead', this.genTR(days));
    },
    genTBody: function genTBody() {
      var _this3 = this;

      var children = [];
      var rows = [];
      var length = new Date(this.tableYear, this.tableMonth + 1, 0).getDate();

      var day = new Date(this.tableYear, this.tableMonth).getDay() - parseInt(this.firstDayOfWeek);

      for (var i = 0; i < day; i++) {
        rows.push(this.$createElement('td'));
      }

      var _loop = function _loop(_i) {
        var date = new Date(_this3.tableYear, _this3.tableMonth, _i, 12, 0, 0, 0);
        rows.push(_this3.$createElement('td', [_this3.$createElement('button', {
          'class': {
            'btn btn--floating btn--small btn--flat': true,
            'btn--active': _this3.isActive(_i),
            'btn--current': _this3.isCurrent(_i),
            'btn--light': _this3.dark,
            'btn--disabled': !_this3.isAllowed(date)
          },
          attrs: {
            type: 'button'
          },
          domProps: {
            innerHTML: '<span class="btn__content">' + _i + '</span>'
          },
          on: {
            click: function click() {
              var day = _i < 10 ? '0' + _i : _i;
              var tableYear = _this3.tableYear;
              var tableMonth = _this3.tableMonth + 1;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;

              _this3.inputDate = tableYear + '-' + tableMonth + '-' + day + 'T12:00:00';
              _this3.$nextTick(function () {
                return _this3.autosave && _this3.save();
              });
            }
          }
        })]));

        if (rows.length % 7 === 0) {
          children.push(_this3.genTR(rows));
          rows = [];
        }
      };

      for (var _i = 1; _i <= length; _i++) {
        _loop(_i);
      }

      if (rows.length) {
        children.push(this.genTR(rows));
      }

      children.length < 6 && children.push(this.genTR([this.$createElement('td', { domProps: { innerHTML: '&nbsp;' } })]));

      return this.$createElement('tbody', children);
    },
    genTR: function genTR() {
      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return [this.$createElement('tr', data, children)];
    },
    isActive: function isActive(i) {
      return this.tableYear === this.year && this.tableMonth === this.month && this.day === i;
    },
    isCurrent: function isCurrent(i) {
      return this.currentYear === this.tableYear && this.currentMonth === this.tableMonth && this.currentDay === i;
    }
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYears: function genYears() {
      return this.$createElement('ul', {
        'class': 'picker--date__years',
        ref: 'years'
      }, this.genYearItems());
    },
    genYearItems: function genYearItems() {
      var _this = this;

      var children = [];

      var _loop = function _loop(i, length) {
        children.push(_this.$createElement('li', {
          'class': {
            active: _this.year === i
          },
          on: {
            click: function click(e) {
              e.stopPropagation();

              var tableMonth = _this.tableMonth + 1;
              var day = _this.day;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;
              day = day < 10 ? '0' + day : day;

              _this.inputDate = i + '-' + tableMonth + '-' + day;
              _this.isSelected = false;
            }
          }
        }, i));
      };

      for (var i = this.year + 100, length = this.year - 100; i > length; i--) {
        _loop(i, length);
      }
      return children;
    }
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_helpers__ = __webpack_require__(0);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-time-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_picker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__["a" /* default */]],

  data: function data() {
    return {
      isDragging: false,
      rotate: 0,
      originalTime: this.value,
      period: 'am',
      selectingHour: true,
      ranges: {
        hours: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(24),
        minutes: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(60)
      }
    };
  },


  props: {
    format: {
      type: String,
      default: 'ampm',
      validator: function validator(val) {
        return ['ampm', '24hr'].includes(val);
      }
    },
    allowedHours: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    allowedMinutes: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    }
  },

  computed: {
    is24hr: function is24hr() {
      return this.format !== 'ampm';
    },
    is24hrAfter12: function is24hrAfter12() {
      return this.selectingHour && this.is24hr && this.hour >= 12;
    },
    divider: function divider() {
      return this.selectingHour ? 12 : 60;
    },
    degrees: function degrees() {
      return this.degreesPerUnit * Math.PI / 180;
    },
    degreesPerUnit: function degreesPerUnit() {
      return 360 / this.divider;
    },

    inputTime: {
      get: function get() {
        if (this.value && !(this.value instanceof Date)) {
          if (!this.is24hr) {
            this.period = this.value.match(/pm/) ? 'pm' : 'am';
          }

          return this.value;
        }
        var value = new Date();

        if (this.value instanceof Date) {
          value = this.value;
        }

        var hour = value.getHours();
        var minute = value.getMinutes();
        var period = '';

        if (!this.is24hr) {
          hour = hour > 12 ? hour - 12 : hour;
          period = hour > 12 ? 'pm' : 'am';
        }

        period && (this.period = period);

        hour = this.firstAllowed('hour', hour);
        minute = this.firstAllowed('minute', minute);

        return hour + ':' + minute + period;
      },
      set: function set(val) {
        return this.$emit('input', val);
      }
    },
    timeArray: function timeArray() {
      return this.inputTime.replace(/(am|pm)/, '').split(':');
    },

    hour: {
      get: function get() {
        return parseInt(this.timeArray[0]);
      },
      set: function set(val) {
        if (!this.is24hr) {
          val = val > 12 ? val - 12 : val < 1 ? 12 : val;
        } else {
          val = val < 10 ? '0' + val : val > 23 ? '00' : val;
        }

        this.inputTime = val + ':' + this.minute + (!this.is24hr ? this.period : '');
      }
    },
    minute: {
      get: function get() {
        var minute = parseInt(this.timeArray[1]);

        return minute < 10 ? '0' + minute : minute > 59 ? '00' : minute;
      },
      set: function set(val) {
        val = val < 10 ? '0' + parseInt(val) : val > 59 ? '00' : val;
        var hour = this.hour;

        if (this.is24hr && hour < 10) {
          hour = '0' + hour;
        }

        this.inputTime = hour + ':' + val + (!this.is24hr ? this.period : '');
      }
    },
    clockHand: function clockHand() {
      if (this.selectingHour) return this.degreesPerUnit * this.hour;
      return this.degreesPerUnit * this.minute;
    },
    radius: function radius() {
      return this.clockSize / 2;
    },

    clockSize: {
      get: function get() {
        return this.size;
      },
      set: function set(val) {
        this.size = val;
      }
    },
    size: function size() {
      return this.landscape ? 250 : 280;
    }
  },

  watch: {
    period: function period(val) {
      var hour = !!this.allowedHours && this.selectingHour ? this.firstAllowed('hour', this.hour - 1) : this.hour;
      this.inputTime = hour + ':' + this.minute + val;
    },
    value: function value(val) {
      if (this.isSaving) {
        this.originalTime = this.inputTime;
        this.isSaving = false;
      }
    }
  },

  methods: {
    save: function save() {
      if (this.originalTime) {
        this.originalTime = this.value;
      } else {
        this.inputTime = this.inputTime;
        this.originalTime = this.inputTime;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputTime = this.originalTime;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(type, value) {
      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return true;

      if (Array.isArray(allowed)) {
        return !!allowed.find(function (v) {
          return v === value;
        });
      } else if (allowed instanceof Function) {
        return allowed(value);
      } else if (allowed === Object(allowed)) {
        var range = type === 'minute' ? this.ranges.minutes : this.ranges.hours;
        var mod = type === 'minute' ? 60 : 24;

        if (allowed.min === String(allowed.min)) {
          allowed.min = this.convert12to24hr(allowed.min);
        }

        if (allowed.max === String(allowed.max)) {
          allowed.max = this.convert12to24hr(allowed.max);
        }

        var steps = allowed.max - allowed.min;
        value = type === 'hour' && !this.is24hr && this.period === 'pm' ? value + 12 : value;

        for (var i = 0; i <= steps; i++) {
          var index = (allowed.min + i) % mod;
          if (range[index] === value) return true;
        }

        return false;
      }

      return true;
    },
    convert12to24hr: function convert12to24hr(input) {
      input = input.toLowerCase();
      var pm = input.indexOf('pm') !== -1;
      var hour = parseInt(input.slice(0, input.indexOf(pm ? 'pm' : 'am')));

      return pm ? hour + 12 : hour;
    },
    generateRange: function generateRange(type, start) {
      var range = type === 'hour' ? this.ranges.hours : this.ranges.minutes;
      var offset = 1;

      if (type === 'hour' && !this.is24hr) {
        range = range.slice(1, 13);
        offset = 0;
      }

      return range.slice(start + offset, range.length).concat(range.slice(0, start + offset));
    },
    firstAllowed: function firstAllowed(type, value) {
      var _this = this;

      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return value;

      var range = this.generateRange(type, value);

      var first = range.find(function (v) {
        return _this.isAllowed(type, v);
      });

      return first || value;
    }
  },

  render: function render(h) {
    var children = [this.genBody()];

    !this.noTitle && children.unshift(this.genTitle());
    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--time': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark,
        'picker--time--hours': this.selectingHour
      }
    }, children);
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTitle: function genTitle() {
      var children = [this.genTime()];

      if (this.format === 'ampm') {
        children.push(this.genAMPM());
      }

      return this.$createElement('div', {
        'class': 'picker__title'
      }, children);
    },
    genTime: function genTime() {
      var _this = this;

      var hour = this.hour;

      if (this.is24hr && hour < 10) {
        hour = '0' + hour;
      }

      return this.$createElement('div', {
        'class': 'picker--time__title'
      }, [this.$createElement('span', {
        'class': { active: this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = true;
          }
        }
      }, hour), this.$createElement('span', {
        'class': { active: !this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = false;
          }
        }
      }, ':' + this.minute)]);
    },
    genAMPM: function genAMPM() {
      return this.$createElement('div', [this.genPeriod('am'), this.genPeriod('pm')]);
    },
    genPeriod: function genPeriod(period) {
      var _this2 = this;

      return this.$createElement('span', {
        'class': { active: this.period === period },
        on: { click: function click() {
            return _this2.period = period;
          } }
      }, period.toUpperCase());
    }
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hasChanged: false
    };
  },

  methods: {
    genBody: function genBody() {
      var _this = this;

      var children = [this.genHand(this.selectingHour ? 'hour' : 'minute')];
      var data = {
        'class': 'picker--time__clock',
        on: {
          mousedown: this.onMouseDown,
          mouseup: this.onMouseUp,
          mouseleave: function mouseleave() {
            _this.isDragging && _this.onMouseUp();
          },
          touchstart: this.onMouseDown,
          touchend: this.onMouseUp,
          mousemove: this.onDragMove,
          touchmove: this.onDragMove
        },
        key: this.selectingHour ? 'hour' : 'minute',
        ref: 'clock'
      };

      this.selectingHour && children.push(this.genHours()) || children.push(this.genMinutes());

      if (this.scrollable) {
        data.on.wheel = function (e) {
          e.preventDefault();

          var diff = e.wheelDelta > 0 ? 1 : -1;
          var changing = _this.selectingHour ? 'changeHour' : 'changeMinute';

          _this[changing](diff);
        };
      }

      return this.$createElement('div', {
        'class': 'picker__body'
      }, [this.$createElement('v-fade-transition', {
        props: { mode: 'out-in' }
      }, [this.$createElement('div', data, children)])]);
    },
    genHand: function genHand(type) {
      var scale = this.is24hrAfter12 ? 'scaleY(0.6)' : '';
      return [this.$createElement('div', {
        'class': 'picker--time__clock-hand ' + type,
        style: {
          transform: 'rotate(' + this.clockHand + 'deg) ' + scale
        }
      })];
    },
    genHours: function genHours() {
      var hours = this.is24hr ? 24 : 12;
      var children = [];
      var start = 0;

      if (hours === 12) {
        hours++;
        start = 1;
      }

      for (var i = start; i < hours; i++) {
        children.push(this.$createElement('span', {
          'class': {
            'active': i === this.hour,
            'disabled': !this.isAllowed('hour', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + i + '</span>' }
        }));
      }

      return children;
    },
    genMinutes: function genMinutes() {
      var children = [];

      for (var i = 0; i < 60; i = i + 5) {
        var num = i;

        if (num < 10) num = '0' + num;
        if (num === 60) num = '00';

        children.push(this.$createElement('span', {
          'class': {
            'active': num.toString() === this.minute.toString(),
            'disabled': !this.isAllowed('minute', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + num + '</span>' }
        }));
      }

      return children;
    },
    getTransform: function getTransform(i) {
      var _getPosition = this.getPosition(i),
          x = _getPosition.x,
          y = _getPosition.y;

      return { transform: 'translate(' + x + 'px, ' + y + 'px)' };
    },
    getPosition: function getPosition(i) {
      var radiusPercentage = this.selectingHour && this.is24hr && i >= 12 ? 0.5 : 0.8;
      var r = this.radius * radiusPercentage;
      i = this.selectingHour && this.is24hr ? i % 12 : i;
      return {
        x: Math.round(Math.sin(i * this.degrees) * r),
        y: Math.round(-Math.cos(i * this.degrees) * r)
      };
    },
    changeHour: function changeHour(time) {
      var _this2 = this;

      var range = this.generateRange('hour', this.hour);

      time < 0 && (range = range.reverse().slice(1));
      this.hour = range.find(function (h) {
        return _this2.allowedHours ? _this2.isAllowed('hour', h) : true;
      });

      return true;
    },
    changeMinute: function changeMinute(time) {
      var _this3 = this;

      var current = Number(this.minute);
      var range = this.generateRange('minute', current);

      time < 0 && (range = range.reverse().slice(1));
      var minute = range.find(function (m) {
        return _this3.allowedMinutes ? _this3.isAllowed('minute', m) : true;
      });

      this.minute = minute < 10 ? '0' + minute : minute;

      return true;
    },
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();

      this.isDragging = true;
      this.onDragMove(e);
    },
    onMouseUp: function onMouseUp() {
      this.isDragging = false;
      !this.selectingHour && this.autosave && this.save();
      if (this.hasChanged) {
        this.selectingHour = false;
        this.hasChanged = false;
      }
    },
    onDragMove: function onDragMove(e) {
      e.preventDefault();
      if (!this.isDragging && e.type !== 'click') return;

      var rect = this.$refs.clock.getBoundingClientRect();
      var center = { x: rect.width / 2, y: 0 - rect.width / 2 };
      var clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var coords = {
        y: rect.top - clientY,
        x: clientX - rect.left
      };

      var selecting = this.selectingHour ? 'hour' : 'minute';
      var value = Math.round(this.angle(center, coords) / this.degreesPerUnit);

      if (this.selectingHour && this.is24hr) {
        var insideClick = this.euclidean(center, coords) / this.radius < 0.65;
        value = insideClick ? value + 12 : value;

        // Necessary to fix edge case when selecting left part of 0 and 12
        value = this.angle(center, coords) >= 345 ? (value + 12) % 24 : value;
      }

      if (this.isAllowed(selecting, value)) {
        this[selecting] = value;
        this.hasChanged = true;
      }
    },
    euclidean: function euclidean(p0, p1) {
      var dx = Math.abs(p1.x - p0.x);
      var dy = Math.abs(p1.y - p0.y);

      return Math.sqrt(dx * dx + dy * dy);
    },
    angle: function angle(center, p1) {
      var p0 = {
        x: center.x,
        y: center.y + Math.sqrt(Math.abs(p1.x - center.x) * Math.abs(p1.x - center.x) + Math.abs(p1.y - center.y) * Math.abs(p1.y - center.y))
      };

      var value = 2 * Math.atan2(p1.y - p0.y, p1.x - p0.x);
      return Math.abs(value * 180 / Math.PI);
    }
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDialog__ = __webpack_require__(65);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDialog: __WEBPACK_IMPORTED_MODULE_0__VDialog__["a" /* default */]
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-dialog',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__["a" /* default */]],

  props: {
    disabled: Boolean,
    persistent: Boolean,
    fullscreen: Boolean,
    fullWidth: Boolean,
    lazy: Boolean,
    origin: {
      type: String,
      default: 'center center'
    },
    width: {
      type: [String, Number],
      default: 290
    },
    scrollable: Boolean,
    transition: {
      type: [String, Boolean],
      default: 'dialog-transition'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'dialog': true,
        'dialog--active': this.isActive,
        'dialog--persistent': this.persistent,
        'dialog--fullscreen': this.fullscreen,
        'dialog--stacked-actions': this.stackedActions && !this.fullscreen,
        'dialog--scrollable': this.scrollable
      };
    }
  },

  watch: {
    isActive: function isActive(val) {
      if (val) {
        !this.fullscreen && !this.hideOverlay && this.genOverlay();
        this.fullscreen && this.hideScroll();
      } else {
        if (!this.fullscreen) this.removeOverlay();else this.showScroll();
      }
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.isBooted = this.isActive;
    this.$vuetify.load(function () {
      return _this.isActive && _this.genOverlay();
    });
  },


  methods: {
    closeConditional: function closeConditional(e) {
      // close dialog if !persistent and clicked outside
      return !this.persistent;
    }
  },

  render: function render(h) {
    var _this2 = this;

    var children = [];
    var data = {
      'class': this.classes,
      ref: 'dialog',
      directives: [{ name: 'click-outside', value: this.closeConditional }, { name: 'show', value: this.isActive }]
    };

    if (!this.fullscreen) {
      data.style = {
        width: isNaN(this.width) ? this.width : this.width + 'px'
      };
    }

    if (this.$slots.activator) {
      children.push(h('div', {
        'class': 'dialog__activator',
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (!_this2.disabled) _this2.isActive = !_this2.isActive;
          }
        }
      }, [this.$slots.activator]));
    }

    var dialog = h('transition', {
      props: {
        name: this.transition || '', // If false, show nothing
        origin: this.origin
      }
    }, [h('div', data, this.showLazyContent(this.$slots.default))]);

    children.push(h('div', {
      'class': ('dialog__content ' + this.contentClass).trim(),
      ref: 'content'
    }, [dialog]));

    return h('div', {
      'class': 'dialog__container',
      style: {
        display: !this.$slots.activator && 'none' || this.fullWidth ? 'block' : 'inline-block'
      }
    }, children);
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDivider__ = __webpack_require__(67);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDivider: __WEBPACK_IMPORTED_MODULE_0__VDivider__["a" /* default */]
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('divider ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.inset) data.staticClass += ' divider--inset';
    if (props.light) data.staticClass += ' theme--light';

    return h('hr', data);
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__ = __webpack_require__(70);



/* harmony default export */ __webpack_exports__["a"] = ({
  VExpansionPanel: __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__["a" /* default */],
  VExpansionPanelContent: __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__["a" /* default */]
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel',

  props: {
    expand: Boolean
  },

  computed: {
    params: function params() {
      return {
        expand: this.expand
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': 'expansion-panel'
    }, this.$slots.default);
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      height: 'auto'
    };
  },


  props: {
    ripple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'expansion-panel__header': true,
        'expansion-panel__header--active': this.isActive
      };
    }
  },

  methods: {
    closeConditional: function closeConditional(e) {
      return this.$parent.$el.contains(e.target) && !this.$parent.expand && !this.$el.contains(e.target);
    },
    toggle: function toggle() {
      this.isActive = !this.isActive;
    },
    genHeader: function genHeader(h) {
      var _this = this;

      return h('div', {
        class: this.classes,
        directives: [{
          name: 'click-outside',
          value: this.closeConditional
        }, {
          name: 'ripple',
          value: this.ripple
        }],
        on: {
          click: function click() {
            _this.isActive = !_this.isActive;
          }
        }
      }, [this.$slots.header]);
    },
    genBody: function genBody(h) {
      return h('div', {
        ref: 'body',
        class: 'expansion-panel__body',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [this.$slots.default]);
    }
  },

  render: function render(h) {
    var children = [];

    this.$slots.header && children.push(this.genHeader(h));
    children.push(h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [this.genBody(h)]));

    return h('li', children);
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  enter: function enter(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Get height that is to be scrolled
    el.style.overflow = 'hidden';
    el.style.height = null;
    el.style.display = 'block';
    var height = el.clientHeight + 'px';
    el.style.height = 0;
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = height;
    }, 50);
  },
  afterEnter: function afterEnter(el) {
    el.style.height = 'auto';
    el.style.overflow = null;
  },
  leave: function leave(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Set height before we transition to 0
    el.style.overflow = 'hidden';
    el.style.height = el.clientHeight + 'px';
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = 0;
    }, 50);
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VFooter__ = __webpack_require__(73);


/* harmony default export */ __webpack_exports__["a"] = ({
  VFooter: __WEBPACK_IMPORTED_MODULE_0__VFooter__["a" /* default */]
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    fixed: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('footer ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' footer--absolute';
    if (props.fixed) data.staticClass += ' footer--fixed';

    return h('footer', data, children);
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var Grid = function Grid(name) {
  return {
    functional: true,

    props: {
      id: String
    },

    render: function render(h, _ref) {
      var props = _ref.props,
          data = _ref.data,
          children = _ref.children;

      data.staticClass = (name + ' ' + (data.staticClass || '')).trim();

      if (data.attrs) {
        data.staticClass += ' ' + Object.keys(data.attrs).join(' ');
        delete data.attrs;
      }

      if (props.id) {
        data.domProps = data.domProps || {};
        data.domProps.id = props.id;
      }

      return h('div', data, children);
    }
  };
};

var VContainer = Grid('container');
var VFlex = Grid('flex');
var VLayout = Grid('layout');
var VSpacer = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('spacer');

/* harmony default export */ __webpack_exports__["a"] = ({
  VContainer: VContainer,
  VFlex: VFlex,
  VLayout: VLayout,
  VSpacer: VSpacer
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  VIcon: __WEBPACK_IMPORTED_MODULE_0__VIcon__["a" /* default */]
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-group',

  inject: ['listClick', 'listClose'],

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      isBooted: this.value
    };
  },


  props: {
    group: String,
    lazy: Boolean,
    noAction: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list--group__header': true,
        'list--group__header--active': this.isActive,
        'list--group__header--no-action': this.noAction
      };
    }
  },

  watch: {
    isActive: function isActive() {
      this.isBooted = true;

      if (!this.isActive) {
        this.listClose(this._uid);
      }
    },
    $route: function $route(to) {
      var isActive = this.matchRoute(to.path);

      if (this.group) {
        if (isActive && this.isActive !== isActive) {
          this.listClick(this._uid);
        }
        this.isActive = isActive;
      }
    }
  },

  mounted: function mounted() {
    if (this.group) {
      this.isActive = this.matchRoute(this.$route.path);
    }

    if (this.isActive) {
      this.listClick(this._uid);
    }
  },


  methods: {
    click: function click() {
      var _this = this;

      if (!this.$refs.item.querySelector('.list__tile--disabled')) {
        requestAnimationFrame(function () {
          return _this.listClick(_this._uid);
        });
      }
    },
    toggle: function toggle(uid) {
      this.isActive = this._uid === uid;
    },
    matchRoute: function matchRoute(to) {
      if (!this.group) return false;
      return to.match(this.group) !== null;
    }
  },

  render: function render(h) {
    var group = h('ul', {
      'class': 'list list--group',
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      ref: 'group'
    }, [this.lazy && !this.isBooted ? null : this.$slots.default]);

    var item = h('div', {
      'class': this.classes,
      on: Object.assign({}, { click: this.click }, this.$listeners),
      ref: 'item'
    }, [this.$slots.item]);

    var transition = h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [group]);

    return h('div', { 'class': 'list--group__container' }, [item, transition]);
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    icon: false,
    left: false,
    bottom: false,
    overlap: false,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  if (config.overlap) el.classList.add('badge--overlap');
  if (config.icon) el.classList.add('badge--icon');
  if (config.left) el.classList.add('badge--left');
  if (config.bottom) el.classList.add('badge--bottom');

  el.dataset.badge = config.value;
  el.classList.add('badge');
}

function unbind(el) {
  el.removeAttribute('data-badge');
  el.classList.remove('badge');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var debounce = function debounce(cb) {
    return setTimeout(cb, 50);
  };
  var onResize = function onResize() {
    clearTimeout(debounce);
    debounce(binding.value);
  };

  window.addEventListener('resize', onResize, { passive: true });
  el._onResize = onResize;
}

function unbind(el, binding) {
  window.removeEventListener('resize', el._onResize);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var callback = typeof binding.value === 'function' ? binding.value : binding.value.callback;
  var options = binding.value.options || { passive: true };
  var target = binding.value.target || window;
  if (target === 'undefined') return;

  if (target !== window) {
    target = document.querySelector(target);
  }

  target.addEventListener('scroll', callback, options);

  el._onScroll = {
    target: target,
    options: options
  };
}

function unbind(el, binding) {
  var _el$_onScroll = el._onScroll,
      target = _el$_onScroll.target,
      options = _el$_onScroll.options;


  target.removeEventListener('scroll', binding.callback, options);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    top: true,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  unbind(el, binding, config);

  el.dataset.tooltip = config.html;
  el.dataset['tooltipLocation'] = config.value;
}

function unbind(el) {
  el.removeAttribute('data-tooltip');
  el.removeAttribute('data-tooltip-location');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var touchstart = function touchstart(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchstartX = touch.clientX;
  wrapper.touchstartY = touch.clientY;

  wrapper.start && wrapper.start(Object.assign(event, wrapper));
};

var touchend = function touchend(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchendX = touch.clientX;
  wrapper.touchendY = touch.clientY;

  wrapper.end && wrapper.end(Object.assign(event, wrapper));

  handleGesture(wrapper);
};

var touchmove = function touchmove(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchmoveX = touch.clientX;
  wrapper.touchmoveY = touch.clientY;

  wrapper.move && wrapper.move(Object.assign(event, wrapper));
};

var handleGesture = function handleGesture(wrapper) {
  var touchstartX = wrapper.touchstartX,
      touchendX = wrapper.touchendX,
      touchstartY = wrapper.touchstartY,
      touchendY = wrapper.touchendY;

  wrapper.offsetX = touchendX - touchstartX;
  wrapper.offsetY = touchendY - touchstartY;

  if (touchendX < touchstartX) {
    wrapper.left && wrapper.left(wrapper);
  }
  if (touchendX > touchstartX) {
    wrapper.right && wrapper.right(wrapper);
  }
  if (touchendY < touchstartY) {
    wrapper.up && wrapper.up(wrapper);
  }
  if (touchendY > touchstartY) {
    wrapper.down && wrapper.down(wrapper);
  }
};

function inserted(el, _ref) {
  var value = _ref.value;

  var wrapper = {
    touchstartX: 0,
    touchstartY: 0,
    touchendX: 0,
    touchendY: 0,
    touchmoveX: 0,
    touchmoveY: 0,
    offsetX: 0,
    offsetY: 0,
    left: value.left,
    right: value.right,
    up: value.up,
    down: value.down,
    start: value.start,
    move: value.move,
    end: value.end
  };

  var target = value.parent ? el.parentNode : el;
  var options = value.options || {};

  target.addEventListener('touchstart', function (e) {
    return touchstart(e, wrapper);
  }, options);
  target.addEventListener('touchend', function (e) {
    return touchend(e, wrapper);
  }, options);
  target.addEventListener('touchmove', function (e) {
    return touchmove(e, wrapper);
  }, options);
}

function unbind(el, _ref2) {
  var value = _ref2.value;

  var target = value.parent ? el.parentNode : el;

  if (!target) return;

  target.removeEventListener('touchstart', touchstart);
  target.removeEventListener('touchend', touchend);
  target.removeEventListener('touchmove', touchmove);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VMenu_js__ = __webpack_require__(22);


/* harmony default export */ __webpack_exports__["a"] = ({
  VMenu: __WEBPACK_IMPORTED_MODULE_0__VMenu_js__["a" /* default */]
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getActivator: function getActivator() {
      if (this.activator) return this.activator;
      return this.$refs.activator.children ? this.$refs.activator.children[0] : this.$refs.activator;
    },
    activatorClickHandler: function activatorClickHandler(e) {
      if (this.disabled) return;else if (this.openOnClick && !this.isActive) {
        this.isActive = true;
        this.absoluteX = e.clientX;
        this.absoluteY = e.clientY;
      } else if (this.closeOnClick && this.isActive) this.isActive = false;
    },
    mouseEnterHandler: function mouseEnterHandler(e) {
      if (this.disabled || this.hasJustFocused) return;
      this.hasJustFocused = true;
      this.isActive = true;
    },
    mouseLeaveHandler: function mouseLeaveHandler(e) {
      if (this.isContentActive) return;
      this.isActive = false;
    },
    addActivatorEvents: function addActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.addEventListener('click', this.activatorClickHandler);
    },
    removeActivatorEvents: function removeActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.removeEventListener('click', this.activatorClickHandler);
    }
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genActivator: function genActivator() {
      if (!this.$slots.activator) return null;

      var options = {
        'class': {
          'menu__activator--active': this.hasJustFocused || this.isActive
        },
        staticClass: 'menu__activator',
        ref: 'activator',
        slot: 'activator',
        on: {}
      };

      if (this.openOnHover) {
        options.on['mouseenter'] = this.mouseEnterHandler;
        options.on['mouseleave'] = this.mouseLeaveHandler;
      } else if (this.openOnClick) {
        options.on['click'] = this.activatorClickHandler;
      }

      return this.$createElement('div', options, this.$slots.activator);
    },
    genTransition: function genTransition() {
      return this.$createElement('transition', {
        props: {
          name: this.transition,
          origin: this.origin
        }
      }, [this.genContent()]);
    },
    genContent: function genContent() {
      var _this = this;

      var booted = this.lazy && this.isBooted || !this.lazy;
      return this.$createElement('div', {
        'class': ('menu__content ' + this.contentClass).trim(),
        ref: 'content',
        style: this.styles,
        directives: [{
          name: 'show',
          value: this.isContentActive
        }],
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (e.target.getAttribute('disabled')) return;
            if (_this.closeOnContentClick) _this.isActive = false;
          },
          mouseleave: function mouseleave(e) {
            _this.openOnHover && (_this.isActive = false);
          }
        }
      }, [booted ? this.$slots.default : null]);
    }
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    // Revisit this
    calculateScroll: function calculateScroll() {
      if (this.selectedIndex === null) return;

      var scrollTop = 0;

      if (this.selectedIndex >= this.stopIndex) {
        scrollTop = this.$refs.content.scrollHeight;
      } else if (this.selectedIndex > this.startIndex) {
        scrollTop = this.selectedIndex * 48 - 56;
      }

      this.$refs.content.scrollTop = scrollTop;
    },
    calcLeftAuto: function calcLeftAuto() {
      var a = this.dimensions.activator;

      return parseInt(a.left - 16);
    },
    calcTopAuto: function calcTopAuto() {
      if (!this.hasActivator) return this.calcTop(true);

      var selectedIndex = Array.from(this.tiles).findIndex(function (n) {
        return n.classList.contains('list__tile--active');
      });

      if (selectedIndex === -1) {
        this.selectedIndex = null;

        return this.calcTop(true);
      }

      this.selectedIndex = selectedIndex;
      var actingIndex = selectedIndex;

      var offsetPadding = 1;
      // #708 Stop index should vary by tile length
      this.stopIndex = this.tiles.length > 4 ? this.tiles.length - 4 : this.tiles.length;

      if (selectedIndex > this.startIndex && selectedIndex < this.stopIndex) {
        actingIndex = 2;
        offsetPadding = 41;
      } else if (selectedIndex >= this.stopIndex) {
        offsetPadding = 9;
        actingIndex = selectedIndex - this.stopIndex;
      }

      return this.calcTop(true) + offsetPadding - actingIndex * 48;
    },
    calcLeft: function calcLeft() {
      if (this.auto) return this.calcLeftAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var left = this.left ? a.right - c.width : a.left;

      if (this.offsetX) left += this.left ? -a.width : a.width;
      if (this.nudgeLeft) left += this.nudgeLeft;
      if (this.nudgeRight) left -= this.nudgeRight;

      return this.calcXOverflow(left);
    },
    calcTop: function calcTop(force) {
      if (this.auto && !force) return this.calcTopAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var top = this.top ? a.bottom - c.height : a.top;

      if (this.offsetY) top += this.top ? -a.height : a.height;
      if (this.nudgeTop) top -= this.nudgeTop;
      if (this.nudgeBottom) top += this.nudgeBottom;

      var defined = typeof window !== 'undefined';
      var pageYOffset = defined ? window.pageYOffset : 0;

      return this.calcYOverflow(top) + pageYOffset;
    },
    calcXOverflow: function calcXOverflow(left) {
      var hasWindow = typeof window !== 'undefined';
      var innerWidth = hasWindow ? window.innerWidth : 0;
      var maxWidth = Math.max(this.dimensions.content.width, this.calculatedMinWidth, parseInt(this.maxWidth) || 0);
      var totalWidth = left + maxWidth;
      var availableWidth = totalWidth - innerWidth;

      if ((!this.left || this.right) && availableWidth > 0) {
        left = innerWidth - maxWidth - (innerWidth > 1024 ? 30 : 12) // Account for scrollbar
        ;
      } else if (this.left && left < 0) left = 12;

      return left;
    },
    calcYOverflow: function calcYOverflow(top) {
      var totalHeight = top + this.dimensions.content.height;
      var defined = typeof window !== 'undefined';
      var innerHeight = defined ? window.innerHeight : 0;

      if (this.top && top < 0) top = 12;else if ((!this.top || this.bottom) && innerHeight < totalHeight) {
        top = innerHeight - this.dimensions.content.height;
      }

      return top < 12 ? 12 : top;
    },
    sneakPeek: function sneakPeek(cb) {
      var _this = this;

      requestAnimationFrame(function () {
        var el = _this.$refs.content;
        var currentDisplay = el.style.display;

        el.style.display = 'inline-block';
        cb();
        el.style.display = currentDisplay;
      });
    },
    absolutePosition: function absolutePosition() {
      return {
        offsetTop: 0,
        scrollHeight: 0,
        top: this.positionY || this.absoluteY,
        bottom: this.positionY || this.absoluteY,
        left: this.positionX || this.absoluteX,
        right: this.positionX || this.absoluteX,
        height: 0,
        width: 0
      };
    },
    updateDimensions: function updateDimensions() {
      var _this2 = this;

      this.sneakPeek(function () {
        _this2.dimensions = {
          activator: !_this2.hasActivator || _this2.positionAbsolutely ? _this2.absolutePosition() : _this2.measure(_this2.getActivator()),
          content: _this2.measure(_this2.$refs.content)
        };
      });
    }
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    measure: function measure(el, selector) {
      var getParent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      el = selector ? el.querySelector(selector) : el;

      if (!el) return null;

      var _el$getBoundingClient = el.getBoundingClientRect(),
          top = _el$getBoundingClient.top,
          bottom = _el$getBoundingClient.bottom,
          left = _el$getBoundingClient.left,
          right = _el$getBoundingClient.right,
          height = _el$getBoundingClient.height,
          width = _el$getBoundingClient.width;

      return {
        offsetTop: el.offsetTop,
        scrollHeight: el.scrollHeight,
        top: top, bottom: bottom, left: left, right: right, height: height, width: width
      };
    }
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      listIndex: -1,
      isUsingKeys: false,
      tiles: []
    };
  },

  watch: {
    isActive: function isActive(val) {
      if (!val) this.listIndex = -1;
    },
    listIndex: function listIndex(next, prev) {
      // For infinite scroll and autocomplete, re-evaluate children
      this.getTiles();

      if (next in this.tiles) {
        this.tiles[next].classList.add('list__tile--highlighted');
        this.$refs.content.scrollTop = next * 48;
      }

      prev in this.tiles && this.tiles[prev].classList.remove('list__tile--highlighted');
    }
  },

  methods: {
    changeListIndex: function changeListIndex(e) {
      [40, 38, 13].includes(e.keyCode) && e.preventDefault();
      e.keyCode === 32 && !this.isActive && e.preventDefault();

      if (this.listIndex === -1) this.setActiveListIndex();
      if ([27, 9].includes(e.keyCode)) return this.isActive = false;else if (!this.isActive && [13, 32].includes(e.keyCode)) {
        return this.isActive = true;
      }

      if (e.keyCode === 40 && this.listIndex < this.tiles.length - 1) {
        this.listIndex++;
      } else if (e.keyCode === 38 && this.listIndex > 0) {
        this.listIndex--;
      } else if (e.keyCode === 13 && this.listIndex !== -1) {
        this.tiles[this.listIndex].click();
      }
    },
    getTiles: function getTiles() {
      this.tiles = this.$refs.content.querySelectorAll('.list__tile');
    },
    setActiveListIndex: function setActiveListIndex() {
      var _this = this;

      this.tiles.forEach(function (t, i) {
        if (t.classList.contains('list__tile--active')) {
          _this.listIndex = i;
          return;
        }
      });
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__ = __webpack_require__(89);


/* harmony default export */ __webpack_exports__["a"] = ({
  VNavigationDrawer: __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__["a" /* default */]
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-navigation-drawer',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_2__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isActive: this.value,
      isBooted: false,
      isMobile: false,
      touchArea: {
        left: 0,
        right: 0
      }
    };
  },


  props: {
    absolute: Boolean,
    clipped: Boolean,
    disableRouteWatcher: Boolean,
    enableResizeWatcher: Boolean,
    height: String,
    floating: Boolean,
    miniVariant: Boolean,
    mobileBreakPoint: {
      type: Number,
      default: 1024
    },
    permanent: Boolean,
    persistent: Boolean,
    right: Boolean,
    temporary: Boolean,
    touchless: Boolean,
    value: { required: false }
  },

  computed: {
    calculatedHeight: function calculatedHeight() {
      return this.height || '100%';
    },
    classes: function classes() {
      return {
        'navigation-drawer': true,
        'navigation-drawer--absolute': this.absolute,
        'navigation-drawer--clipped': this.clipped,
        'navigation-drawer--close': !this.isActive,
        'navigation-drawer--floating': this.floating,
        'navigation-drawer--is-booted': this.isBooted,
        'navigation-drawer--is-mobile': this.isMobile,
        'navigation-drawer--mini-variant': this.miniVariant,
        'navigation-drawer--open': this.isActive,
        'navigation-drawer--permanent': this.permanent,
        'navigation-drawer--persistent': this.persistent,
        'navigation-drawer--right': this.right,
        'navigation-drawer--temporary': this.temporary,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    showOverlay: function showOverlay() {
      return !this.permanent && this.isActive && (this.temporary || this.isMobile);
    }
  },

  watch: {
    $route: function $route() {
      if (!this.disableRouteWatcher) {
        this.isActive = !this.closeConditional();
      }
    },
    isActive: function isActive(val) {
      this.$emit('input', val);
      this.showOverlay && val && this.genOverlay() || this.removeOverlay();
      this.$el.scrollTop = 0;
    },
    isMobile: function isMobile(val) {
      !val && this.removeOverlay();
    },
    permanent: function permanent(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      if (this.permanent) return;
      if (val !== this.isActive) this.isActive = val;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.checkIfMobile();
      setTimeout(function () {
        return _this.isBooted = true;
      }, 0);

      if (this.permanent) this.isActive = true;else if (this.isMobile) this.isActive = false;else if (!this.value && (this.persistent || this.temporary)) this.isActive = false;
    },
    checkIfMobile: function checkIfMobile() {
      this.isMobile = window.innerWidth < parseInt(this.mobileBreakPoint);
    },
    closeConditional: function closeConditional() {
      return !this.permanent && (this.temporary || this.isMobile);
    },
    onResize: function onResize() {
      var _this2 = this;

      clearTimeout(this.resizeTimeout);

      if (!this.enableResizeWatcher || this.permanent || this.temporary) return;

      this.resizeTimeout = setTimeout(function () {
        _this2.checkIfMobile();
        _this2.isActive = !_this2.isMobile;
      }, 200);
    },
    swipeRight: function swipeRight(e) {
      if (this.isActive && !this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (!this.right && e.touchstartX <= this.touchArea.left) this.isActive = true;else if (this.right && this.isActive) this.isActive = false;
    },
    swipeLeft: function swipeLeft(e) {
      if (this.isActive && this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (this.right && e.touchstartX >= this.touchArea.right) this.isActive = true;else if (!this.right && this.isActive) this.isActive = false;
    },
    calculateTouchArea: function calculateTouchArea() {
      if (!this.$el.parentNode) return;
      var parentRect = this.$el.parentNode.getBoundingClientRect();

      this.touchArea = {
        left: parentRect.left + 50,
        right: parentRect.right - 50
      };
    },
    genDirectives: function genDirectives() {
      var directives = [{
        name: 'click-outside',
        value: this.closeConditional
      }, {
        name: 'resize',
        value: this.onResize
      }];

      !this.touchless && directives.push({
        name: 'touch',
        value: {
          parent: true,
          left: this.swipeLeft,
          right: this.swipeRight
        }
      });

      return directives;
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': this.classes,
      style: { height: this.calculatedHeight },
      directives: this.genDirectives(),
      on: Object.assign({}, {
        click: function click() {
          return _this3.$emit('update:miniVariant', false);
        }
      }, this.$listeners)
    };

    return h('aside', data, [this.$slots.default, h('div', { 'class': 'navigation-drawer__border' })]);
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VSystemBar__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VToolbar__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__ = __webpack_require__(93);






var VToolbarTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__title');
var VToolbarItems = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__items');

/* harmony default export */ __webpack_exports__["a"] = ({
  VSystemBar: __WEBPACK_IMPORTED_MODULE_1__VSystemBar__["a" /* default */],
  VToolbar: __WEBPACK_IMPORTED_MODULE_2__VToolbar__["a" /* default */],
  VToolbarItems: VToolbarItems,
  VToolbarTitle: VToolbarTitle,
  VToolbarSideIcon: __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__["a" /* default */]
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    lightsOut: Boolean,
    status: Boolean,
    window: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('system-bar ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.light) data.staticClass += ' theme--light';
    if (props.status) data.staticClass += ' system-bar--status';
    if (props.window) data.staticClass += ' system-bar--window';
    if (props.lightsOut) data.staticClass += ' system-bar--lights-out';

    return h('div', data, children);
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isExtended: false,
      isScrolling: false,
      marginTop: 0,
      previousScroll: null,
      target: null
    };
  },

  props: {
    absolute: Boolean,
    card: Boolean,
    dense: Boolean,
    extended: Boolean,
    fixed: Boolean,
    flat: Boolean,
    floating: Boolean,
    prominent: Boolean,
    scrollOffScreen: Boolean,
    scrollTarget: String,
    scrollThreshHold: {
      type: Number,
      default: 100
    }
  },

  computed: {
    classes: function classes() {
      return {
        'toolbar': true,
        'elevation-0': this.flat,
        'toolbar--absolute': this.absolute,
        'toolbar--card': this.card,
        'toolbar--dense': this.dense,
        'toolbar--fixed': this.fixed,
        'toolbar--floating': this.floating,
        'toolbar--prominent': this.prominent,
        'toolbar--extended': this.isExtended,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    styles: function styles() {
      return {
        marginTop: this.marginTop
      };
    }
  },

  watch: {
    isScrolling: function isScrolling(val) {
      if (!val) this.marginTop = 0;else this.marginTop = -this.$refs.content.clientHeight - 6 + 'px';
    }
  },

  methods: {
    onScroll: function onScroll() {
      if (typeof window === 'undefined') return;

      if (!this.target) {
        this.target = this.scrollTarget ? document.querySelector(this.scrollTarget) : window;
      }

      var currentScroll = this.scrollTarget ? this.target.scrollTop : this.target.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll < this.scrollThreshHold) return;

      if (this.previousScroll === null) {
        this.previousScroll = currentScroll;
      }

      this.isScrolling = this.previousScroll < currentScroll;

      this.previousScroll = currentScroll;
    }
  },

  render: function render(h) {
    this.isExtended = this.extended || !!this.$slots.extension;
    var children = [];
    var data = {
      'class': this.classes,
      style: this.styles,
      on: this.$listeners
    };

    if (this.scrollOffScreen) {
      data.directives = [{
        name: 'scroll',
        value: {
          callback: this.onScroll,
          target: this.scrollTarget
        }
      }];
    }

    children.push(h('div', {
      'class': 'toolbar__content',
      ref: 'content'
    }, this.$slots.default));

    if (this.isExtended) {
      children.push(h('div', {
        'class': 'toolbar__extension'
      }, this.$slots.extension));
    }

    return h('nav', data, children);
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar-side-icon',

  functional: true,

  render: function render(h, _ref) {
    var slots = _ref.slots,
        listeners = _ref.listeners,
        props = _ref.props;

    var data = {
      staticClass: 'toolbar__side-icon',
      props: Object.assign(props, {
        icon: true
      }),
      on: listeners
    };

    var defaultSlot = slots().default;

    return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], data, defaultSlot || [h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], 'menu')]);
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VPagination__ = __webpack_require__(95);


/* harmony default export */ __webpack_exports__["a"] = ({
  VPagination: __WEBPACK_IMPORTED_MODULE_0__VPagination__["a" /* default */]
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-pagination',

  props: {
    circle: Boolean,
    disabled: Boolean,
    length: {
      type: Number,
      default: 0,
      validator: function validator(val) {
        return val % 1 === 0;
      }
    },
    value: {
      type: Number,
      default: 0
    },
    prevIcon: {
      type: String,
      default: 'chevron_left'
    },
    nextIcon: {
      type: String,
      default: 'chevron_right'
    }
  },

  watch: {
    value: function value() {
      this.init();
    }
  },

  computed: {
    classes: function classes() {
      return {
        'pagination': true,
        'pagination--circle': this.circle,
        'pagination--disabled': this.disabled
      };
    },
    items: function items() {
      if (this.length <= 5) {
        return this.range(1, this.length);
      }

      var min = this.value - 3;
      min = min > 0 ? min : 1;

      var max = min + 6;
      max = max <= this.length ? max : this.length;

      if (max === this.length) {
        min = this.length - 6;
      }

      var range = this.range(min, max);

      if (this.value >= 4 && this.length > 6) {
        range.splice(0, 2, 1, '...');
      }

      if (this.value + 3 < this.length && this.length > 6) {
        range.splice(range.length - 2, 2, '...', this.length);
      }

      return range;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load.call(this, this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.selected = null;

      // Change this
      setTimeout(function () {
        return _this.selected = _this.value;
      }, 100);
    },
    next: function next(e) {
      e.preventDefault();
      this.$emit('input', this.value + 1);
      this.$emit('next');
    },
    previous: function previous(e) {
      e.preventDefault();
      this.$emit('input', this.value - 1);
      this.$emit('previous');
    },
    range: function range(from, to) {
      var range = [];

      from = from > 0 ? from : 1;

      for (var i = from; i <= to; i++) {
        range.push(i);
      }

      return range;
    },
    genIcon: function genIcon(h, icon, disabled, fn) {
      return h('li', [h('a', {
        class: {
          'pagination__navigation': true,
          'pagination__navigation--disabled': disabled
        },
        attrs: { href: '#!' },
        on: { click: fn }
      }, [h(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], [icon])])]);
    },
    genItem: function genItem(h, i) {
      var _this2 = this;

      return h('a', {
        class: {
          'pagination__item': true,
          'pagination__item--active': i === this.value
        },
        attrs: { href: '#!' },
        on: {
          click: function click(e) {
            e.preventDefault();
            _this2.$emit('input', i);
          }
        }
      }, [i]);
    },
    genItems: function genItems(h) {
      var _this3 = this;

      return this.items.map(function (i) {
        return h('li', [isNaN(i) && h('span', { class: 'pagination__more' }, [i]) || _this3.genItem(h, i)]);
      });
    }
  },

  render: function render(h) {
    var children = [this.genIcon(h, this.prevIcon, this.value === 1, this.previous), this.genItems(h), this.genIcon(h, this.nextIcon, this.value === this.length, this.next)];

    return h('ul', { class: this.classes }, children);
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VParallax__ = __webpack_require__(97);


/* harmony default export */ __webpack_exports__["a"] = ({
  VParallax: __WEBPACK_IMPORTED_MODULE_0__VParallax__["a" /* default */]
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_translatable__ = __webpack_require__(98);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-parallax',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_translatable__["a" /* default */]],

  props: {
    height: {
      type: [String, Number],
      default: 500
    },
    src: String
  },

  computed: {
    styles: function styles() {
      return {
        display: 'block',
        transform: 'translate3d(-50%, ' + this.parallax + 'px, 0)'
      };
    }
  },

  methods: {
    init: function init() {
      var _this = this;

      if (!this.$refs.img) return;

      if (this.$refs.img.complete) {
        this.translate();
        this.listeners();
      } else {
        this.$refs.img.addEventListener('load', function () {
          _this.translate();
          _this.listeners();
        }, false);
      }
    },
    objHeight: function objHeight() {
      return this.$refs.img.naturalHeight;
    },
    elOffsetTop: function elOffsetTop() {
      return this.$el.offsetTop;
    }
  },

  render: function render(h) {
    var container = h('div', {
      staticClass: 'parallax__image-container'
    }, [h('img', {
      staticClass: 'parallax__image',
      style: this.styles,
      attrs: {
        src: this.src
      },
      ref: 'img'
    })]);

    var content = h('div', {
      staticClass: 'parallax__content'
    }, this.$slots.default);

    return h('div', {
      staticClass: 'parallax',
      style: {
        height: parseInt(this.normalizedHeight) + 'px'
      },
      on: this.$listeners
    }, [container, content]);
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      parallax: null,
      parallaxDist: null,
      percentScrolled: null,
      scrollTop: null,
      windowHeight: null,
      windowBottom: null
    };
  },


  computed: {
    normalizedHeight: function normalizedHeight() {
      return Number(this.height.toString().replace(/(^[0-9]*$)/, '$1'));
    },
    imgHeight: function imgHeight() {
      return this.objHeight();
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.translate, false);
    window.removeEventListener('resize', this.translate, false);
  },


  methods: {
    listeners: function listeners() {
      window.addEventListener('scroll', this.translate, false);
      window.addEventListener('resize', this.translate, false);
    },
    translate: function translate() {
      this.calcDimensions();

      this.percentScrolled = (this.windowBottom - this.elOffsetTop) / (this.normalizedHeight + this.windowHeight);

      this.parallax = Math.round(this.parallaxDist * this.percentScrolled);

      if (this.translated) {
        this.translated();
      }
    },
    calcDimensions: function calcDimensions() {
      var offset = this.$el.getBoundingClientRect();

      this.scrollTop = window.pageYOffset;
      this.parallaxDist = this.imgHeight - this.normalizedHeight;
      this.elOffsetTop = offset.top + this.scrollTop;
      this.windowHeight = window.innerHeight;
      this.windowBottom = this.scrollTop + this.windowHeight;
    }
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__ = __webpack_require__(100);



/* harmony default export */ __webpack_exports__["a"] = ({
  VProgressLinear: __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__["a" /* default */],
  VProgressCircular: __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__["a" /* default */]
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _this = this;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-circular',

  props: {
    button: Boolean,

    fill: {
      type: String,
      default: function _default() {
        return _this.indeterminate ? 'none' : 'transparent';
      }
    },

    indeterminate: Boolean,

    rotate: {
      type: Number,
      default: 0
    },

    size: {
      type: [Number, String],
      default: 32
    },

    width: {
      type: Number,
      default: 4
    },

    value: {
      type: Number,
      default: 0
    }
  },

  computed: {
    calculatedSize: function calculatedSize() {
      var size = Number(this.size);

      if (this.button) {
        size += 8;
      }

      return size;
    },
    circumference: function circumference() {
      return 2 * Math.PI * this.radius;
    },
    classes: function classes() {
      return {
        'progress-circular': true,
        'progress-circular--indeterminate': this.indeterminate,
        'progress-circular--button': this.button
      };
    },
    cxy: function cxy() {
      return this.indeterminate && !this.button ? 50 : this.calculatedSize / 2;
    },
    normalizedValue: function normalizedValue() {
      if (this.value < 0) {
        return 0;
      }

      if (this.value > 100) {
        return 100;
      }

      return this.value;
    },
    radius: function radius() {
      return this.indeterminate && !this.button ? 20 : (this.calculatedSize - this.width) / 2;
    },
    strokeDashArray: function strokeDashArray() {
      return Math.round(this.circumference * 1000) / 1000;
    },
    strokeDashOffset: function strokeDashOffset() {
      return (100 - this.normalizedValue) / 100 * this.circumference + 'px';
    },
    styles: function styles() {
      return {
        height: this.calculatedSize + 'px',
        width: this.calculatedSize + 'px'
      };
    },
    svgSize: function svgSize() {
      return this.indeterminate ? false : this.calculatedSize;
    },
    svgStyles: function svgStyles() {
      return {
        transform: 'rotate(' + this.rotate + 'deg)'
      };
    },
    viewBox: function viewBox() {
      return this.indeterminate ? '25 25 50 50' : false;
    }
  },

  methods: {
    genCircle: function genCircle(h, name, offset) {
      return h('circle', {
        class: 'progress-circular__' + name,
        attrs: {
          fill: 'transparent',
          cx: this.cxy,
          cy: this.cxy,
          r: this.radius,
          'stroke-width': this.width,
          'stroke-dasharray': this.strokeDashArray,
          'stroke-dashoffset': offset
        }
      });
    },
    genSvg: function genSvg(h) {
      var children = [!this.indeterminate && this.genCircle(h, 'underlay', 0), this.genCircle(h, 'overlay', this.strokeDashOffset)];

      return h('svg', {
        style: this.svgStyles,
        attrs: {
          xmlns: 'http://www.w3.org/2000/svg',
          height: this.svgSize,
          width: this.svgSize,
          viewBox: this.viewBox
        }
      }, children);
    }
  },

  render: function render(h) {
    var info = h('div', { class: 'progress-circular__info' }, [this.$slots.default]);
    var svg = this.genSvg(h);

    return h('div', {
      class: this.classes,
      style: this.styles,
      on: this.$listeners
    }, [svg, info]);
  }
});

/*
<template lang="pug">
  div(
    class="progress-circular"
    v-bind:class="classes"
    v-bind:style="styles"
    v-on="$listeners"
  )
    svg(
      xmlns="http://www.w3.org/2000/svg"
      v-bind:height="svgSize"
      v-bind:width="svgSize"
      v-bind:viewBox="viewBox"
      v-bind:style="svgStyles"
    )
      circle(
        class="progress-circular__underlay"
        fill="transparent"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="0"
        v-if="!indeterminate"
      )
      circle(
        class="progress-circular__overlay"
        v-bind:fill="fill"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="strokeDashOffset"
      )
    div(class="progress-circular__info")
      slot
</template>
*/

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSelect__ = __webpack_require__(24);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSelect: __WEBPACK_IMPORTED_MODULE_0__VSelect__["a" /* default */]
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    filterSearch: function filterSearch() {
      var _this = this;

      return this.items.filter(function (i) {
        var text = _this.getText(i);
        if (typeof text !== 'string') return false;

        return text.toLowerCase().indexOf(_this.searchValue.toLowerCase()) !== -1;
      });
    },
    onKeyDown: function onKeyDown(e) {
      this.$refs.menu.changeListIndex(e);
    }
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genMenu: function genMenu() {
      var _this = this;

      var offsetY = this.autocomplete || this.offset || this.isDropdown;
      var data = {
        ref: 'menu',
        props: {
          activator: this.$refs.activator,
          auto: this.auto,
          closeOnClick: false,
          closeOnContentClick: !this.multiple,
          contentClass: this.computedContentClass,
          disabled: this.disabled,
          maxHeight: this.maxHeight,
          nudgeTop: this.isDropdown ? 22 : offsetY ? 38 : 0,
          offsetY: offsetY,
          value: this.isActive
        },
        on: { input: function input(val) {
            return _this.isActive = val;
          } }
      };

      this.minWidth && (data.props.minWidth = this.minWidth);

      return this.$createElement('v-menu', data, [this.genList()]);
    },
    genSelectionsAndSearch: function genSelectionsAndSearch() {
      var _this2 = this;

      var input = void 0;

      if (this.autocomplete || this.editable) {
        input = this.$createElement('input', {
          'class': 'input-group--select__autocomplete',
          domProps: { value: this.searchValue },
          on: { input: function input(e) {
              return _this2.searchValue = e.target.value;
            } },
          attrs: { tabindex: -1 },
          ref: 'input',
          key: 'input'
        });
      }

      var selections = this.isDirty && (!this.editable || this.editable && !this.focused) ? this.genSelections() : [];
      input && selections.push(input);
      var group = this.$createElement('div', selections);

      return this.$createElement('div', {
        'class': 'input-group__selections',
        style: { 'overflow': 'hidden' },
        ref: 'activator'
      }, [group]);
    },
    genSelections: function genSelections() {
      var _this3 = this;

      var children = [];
      var chips = this.chips;
      var slots = this.$scopedSlots.selection;
      var length = this.selectedItems.length;

      this.selectedItems.forEach(function (item, i) {
        if (slots) {
          children.push(_this3.genSlotSelection(item));
        } else if (chips) {
          children.push(_this3.genChipSelection(item));
        } else {
          children.push(_this3.genCommaSelection(item, i < length - 1));
        }
      });

      return children;
    },
    genSlotSelection: function genSlotSelection(item) {
      return this.$scopedSlots.selection({ parent: this, item: item });
    },
    genChipSelection: function genChipSelection(item) {
      var _this4 = this;

      return this.$createElement('v-chip', {
        'class': 'chip--select-multi',
        props: { close: true },
        on: {
          input: function input() {
            return _this4.selectItem(item);
          },
          click: function click(e) {
            return e.stopPropagation();
          }
        },
        key: this.getValue(item)
      }, this.getText(item));
    },
    genCommaSelection: function genCommaSelection(item, comma) {
      return this.$createElement('div', {
        'class': 'input-group__selections__comma',
        key: JSON.stringify(this.getValue(item)) // Item may be an object
      }, '' + this.getText(item) + (comma ? ', ' : ''));
    },
    genList: function genList() {
      var _this5 = this;

      var children = this.filteredItems.map(function (o) {
        if (o.header) return _this5.genHeader(o);
        if (o.divider) return _this5.genDivider(o);else return _this5.genTile(o);
      });

      if (!children.length) {
        children.push(this.genTile(this.noDataText, true));
      }

      return this.$createElement('v-card', [this.$createElement('v-list', {
        ref: 'list'
      }, children)]);
    },
    genHeader: function genHeader(item) {
      return this.$createElement('v-subheader', {
        props: item
      }, item.header);
    },
    genDivider: function genDivider(item) {
      return this.$createElement('v-divider', {
        props: item
      });
    },
    genTile: function genTile(item, disabled) {
      var _this6 = this;

      var active = this.selectedItems.indexOf(item) !== -1;

      if (typeof disabled === 'undefined') {
        disabled = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["g" /* getObjectValueByPath */])(item, this.itemDisabled);
      }

      var data = {
        on: { click: function click(e) {
            return _this6.selectItem(item);
          } },
        props: {
          avatar: item === Object(item) && 'avatar' in item,
          ripple: true,
          value: active
        }
      };

      if (disabled) {
        data.props.disabled = disabled;
      }

      if (this.$scopedSlots.item) {
        return this.$createElement('v-list-tile', data, [this.$scopedSlots.item({ parent: this, item: item })]);
      }

      return this.$createElement('v-list-tile', data, [this.genAction(item, active), this.genContent(item)]);
    },
    genAction: function genAction(item, active) {
      var _this7 = this;

      if (!this.multiple) return null;

      var data = {
        'class': {
          'list__tile__action--select-multi': this.multiple
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this7.selectItem(item);
          }
        }
      };

      return this.$createElement('v-list-tile-action', data, [this.$createElement('v-checkbox', { props: { inputValue: active } })]);
    },
    genContent: function genContent(item) {
      return this.$createElement('v-list-tile-content', [this.$createElement('v-list-tile-title', this.getText(item))]);
    }
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VRadio__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSwitch__ = __webpack_require__(106);




/* harmony default export */ __webpack_exports__["a"] = ({
  VCheckbox: __WEBPACK_IMPORTED_MODULE_0__VCheckbox__["a" /* default */],
  VRadio: __WEBPACK_IMPORTED_MODULE_1__VRadio__["a" /* default */],
  VSwitch: __WEBPACK_IMPORTED_MODULE_2__VSwitch__["a" /* default */]
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(28);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'radio',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: [String, Number]
  },

  computed: {
    isActive: function isActive() {
      return this.inputValue === this.value;
    },
    classes: function classes() {
      return this.addColorClassChecks({
        'radio': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      return this.isActive ? 'radio_button_checked' : 'radio_button_unchecked';
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle }
      }, this.label);
    },
    toggle: function toggle() {
      if (!this.disabled) {
        this.$emit('change', this.value);
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', {}, [h('v-icon', {
      'class': {
        'icon--radio': this.isActive
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    return this.genInputGroup([transition, ripple]);
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'switch',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  computed: {
    classes: function classes() {
      return {
        'input-group--selection-controls switch': true
      };
    },
    rippleClasses: function rippleClasses() {
      return {
        'input-group--selection-controls__ripple': true,
        'input-group--selection-controls__ripple--active': this.isActive
      };
    },
    containerClasses: function containerClasses() {
      return this.addColorClassChecks({
        'input-group--selection-controls__container': true,
        'input-group--selection-controls__container--light': this.light,
        'input-group--selection-controls__container--disabled': this.disabled
      });
    },
    toggleClasses: function toggleClasses() {
      return {
        'input-group--selection-controls__toggle': true,
        'input-group--selection-controls__toggle--active': this.isActive
      };
    }
  },

  render: function render(h) {
    var ripple = h('div', {
      'class': this.rippleClasses,
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var container = h('div', {
      'class': this.containerClasses
    }, [h('div', { 'class': this.toggleClasses }), ripple]);

    return this.genInputGroup([container]);
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSlider__ = __webpack_require__(108);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSlider: __WEBPACK_IMPORTED_MODULE_0__VSlider__["a" /* default */]
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_helpers__ = __webpack_require__(0);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-slider',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  data: function data() {
    return {
      app: {},
      isActive: false,
      inputWidth: 0
    };
  },


  props: {
    inverted: Boolean,
    min: {
      type: [Number, String],
      default: 0
    },
    max: {
      type: [Number, String],
      default: 100
    },
    step: {
      type: [Number, String],
      default: null
    },
    thumbLabel: Boolean,
    value: [Number, String],
    vertical: Boolean,
    snap: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group input-group--slider': true,
        'input-group--active': this.isActive,
        'input-group--dirty': this.inputWidth > 0,
        'input-group--disabled': this.disabled,
        'input-group--ticks': !this.disabled && this.step
      };
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        var min = this.min,
            max = this.max,
            step = this.step,
            snap = this.snap;

        val = val < min ? min : val > max ? max : val;
        if (Math.ceil(val) !== Math.ceil(this.lazyValue)) {
          this.inputWidth = this.calculateWidth(val);
        }

        var value = snap ? Math.round(val / step) * step : parseInt(val);
        this.lazyValue = value;

        if (value !== this.value) {
          this.$emit('input', value);
        }
      }
    },
    interval: function interval() {
      return 100 / (this.max - this.min) * this.step;
    },
    thumbContainerClasses: function thumbContainerClasses() {
      return {
        'slider__thumb-container': true,
        'slider__thumb-container--label': this.thumbLabel
      };
    },
    thumbStyles: function thumbStyles() {
      return {
        left: this.inputWidth + '%'
      };
    },
    tickContainerStyles: function tickContainerStyles() {
      return {
        transform: 'translate3d(0, -50%, 0)'
      };
    },
    trackStyles: function trackStyles() {
      var scaleX = this.calculateScale(1 - this.inputWidth / 100);
      var translateX = this.inputWidth < 1 && !this.isActive ? 8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    trackFillStyles: function trackFillStyles() {
      var inputWidth = this.inputWidth;
      var scaleX = this.calculateScale(inputWidth / 100);
      var translateX = inputWidth > 99 && !this.thumbLabel ? -8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    numTicks: function numTicks() {
      return parseInt((this.max - this.min) / this.step);
    }
  },

  watch: {
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.inputValue = this.value;
    this.$nextTick(function () {
      _this.inputWidth = _this.calculateWidth(_this.inputValue);
    });

    // Without a v-app, iOS does not work with body selectors
    this.app = document.querySelector('[data-app]') || console.warn('The v-slider component requires the present of v-app or a non-body wrapping element with the [data-app] attribute.');
  },


  methods: {
    calculateWidth: function calculateWidth(val) {
      if (this.snap) {
        val = Math.round(val / this.step) * this.step;
      }

      val = (val - this.min) / (this.max - this.min) * 100;

      return val < 0.15 ? 0 : val;
    },
    calculateScale: function calculateScale(scale) {
      if (scale < 0.02 && !this.thumbLabel) {
        return 0;
      }

      return this.disabled ? scale - 0.015 : scale;
    },
    onMouseDown: function onMouseDown(e) {
      var options = { passive: true };
      this.isActive = true;

      if ('touches' in e) {
        this.app.addEventListener('touchmove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'touchend', this.onMouseUp);
      } else {
        this.app.addEventListener('mousemove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'mouseup', this.onMouseUp);
      }
    },
    onMouseUp: function onMouseUp() {
      var options = { passive: true };
      this.isActive = false;
      this.app.removeEventListener('touchmove', this.onMouseMove, options);
      this.app.removeEventListener('mousemove', this.onMouseMove, options);
    },
    onMouseMove: function onMouseMove(e) {
      var _$refs$track$getBound = this.$refs.track.getBoundingClientRect(),
          offsetLeft = _$refs$track$getBound.left,
          trackWidth = _$refs$track$getBound.width;

      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var left = (clientX - offsetLeft) / trackWidth * 100;

      left = left < 0 ? 0 : left > 100 ? 100 : left;

      this.inputValue = this.min + left / 100 * (this.max - this.min);
    },
    onKeyDown: function onKeyDown(e) {
      if (!e.keyCode === 37 && !e.keyCode === 39) return;

      var direction = e.keyCode === 37 && -1 || e.keyCode === 39 && 1 || 0;
      var multiplier = e.shiftKey && 3 || e.ctrlKey && 2 || 1;
      var amount = this.snap && this.step || 1;

      this.inputValue = this.inputValue + direction * amount * multiplier;
    },
    sliderMove: function sliderMove(e) {
      if (!this.isActive) {
        this.onMouseMove(e);
      }
    },
    genThumbLabel: function genThumbLabel(h) {
      return h('v-scale-transition', {
        props: { origin: 'bottom center' }
      }, [h('div', {
        'class': 'slider__thumb--label__container',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [h('div', { 'class': 'slider__thumb--label' }, [h('span', {}, parseInt(this.inputValue))])])]);
    },
    genThumbContainer: function genThumbContainer(h) {
      var children = [];
      children.push(h('div', { 'class': 'slider__thumb' }));

      this.thumbLabel && children.push(this.genThumbLabel(h));

      return h('div', {
        'class': this.thumbContainerClasses,
        style: this.thumbStyles,
        on: {
          touchstart: this.onMouseDown,
          mousedown: this.onMouseDown
        },
        ref: 'thumb'
      }, children);
    },
    genSteps: function genSteps(h) {
      var _this2 = this;

      var ticks = Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["c" /* createRange */])(this.numTicks + 1).map(function (i) {
        var span = h('span', {
          class: 'slider__tick',
          style: {
            left: i * (100 / _this2.numTicks) + '%'
          }
        });

        return span;
      });

      return h('div', {
        'class': 'slider__ticks-container',
        style: this.tickContainerStyles
      }, ticks);
    },
    genTrackContainer: function genTrackContainer(h) {
      var children = [h('div', {
        'class': 'slider__track',
        style: this.trackStyles
      }), h('div', {
        'class': 'slider__track-fill',
        style: this.trackFillStyles
      })];

      return h('div', {
        'class': 'slider__track__container',
        ref: 'track'
      }, children);
    }
  },

  render: function render(h) {
    var children = [];

    children.push(this.genTrackContainer(h));
    this.step && children.push(this.genSteps(h));
    children.push(this.genThumbContainer(h));

    var slider = h('div', { 'class': 'slider' }, children);

    return this.genInputGroup([slider], {
      attrs: {
        role: 'slider',
        tabindex: this.tabindex
      },
      on: Object.assign({}, {
        mouseup: this.sliderMove,
        keydown: this.onKeyDown
      }, this.$listeners),
      directives: [{
        name: 'click-outside'
      }]
    });
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSubheader__ = __webpack_require__(110);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSubheader: __WEBPACK_IMPORTED_MODULE_0__VSubheader__["a" /* default */]
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children,
        props = _ref.props;

    data.staticClass = ('subheader ' + (data.staticClass || '')).trim();

    if (props.inset) data.staticClass += ' subheader--inset';
    if (props.light) data.staticClass += ' theme--light';
    if (props.dark) data.staticClass += ' theme--dark';

    return h('li', data, children);
  }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VStepper__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VStepperStep__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VStepperContent__ = __webpack_require__(114);





var VStepperHeader = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('stepper__header');

/* harmony default export */ __webpack_exports__["a"] = ({
  VStepper: __WEBPACK_IMPORTED_MODULE_1__VStepper__["a" /* default */],
  VStepperContent: __WEBPACK_IMPORTED_MODULE_3__VStepperContent__["a" /* default */],
  VStepperHeader: VStepperHeader,
  VStepperStep: __WEBPACK_IMPORTED_MODULE_2__VStepperStep__["a" /* default */]
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    return {
      stepClick: this.stepClick
    };
  },
  data: function data() {
    return {
      inputValue: null,
      isBooted: false,
      steps: [],
      content: [],
      isReverse: false
    };
  },


  props: {
    nonLinear: Boolean,
    altLabels: Boolean,
    vertical: Boolean,
    value: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper': true,
        'stepper--is-booted': this.isBooted,
        'stepper--vertical': this.vertical,
        'stepper--alt-labels': this.altLabels,
        'stepper--non-linear': this.nonLinear,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    inputValue: function inputValue(val, prev) {
      var _this = this;

      this.isReverse = Number(val) < Number(prev);
      this.steps.forEach(function (i) {
        return i.toggle(_this.inputValue);
      });
      this.content.forEach(function (i) {
        return i.toggle(_this.inputValue, _this.isReverse);
      });

      this.$emit('input', this.inputValue);
      prev && (this.isBooted = true);
    },
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this2 = this;

      this.$children.forEach(function (i) {
        if (i.$options._componentTag === 'v-stepper-step') {
          _this2.steps.push(i);
        } else if (i.$options._componentTag === 'v-stepper-content') {
          i.isVertical = _this2.vertical;
          _this2.content.push(i);
        }
      });

      this.inputValue = this.value || this.steps[0].step || 1;
    },
    stepClick: function stepClick(step) {
      this.inputValue = step;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes
    }, this.$slots.default);
  }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-step',

  inject: ['stepClick'],

  data: function data() {
    return {
      isActive: false,
      isInactive: true
    };
  },


  props: {
    complete: Boolean,
    completeIcon: {
      type: String,
      default: 'check'
    },
    editIcon: {
      type: String,
      default: 'edit'
    },
    errorIcon: {
      type: String,
      default: 'warning'
    },
    editable: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    step: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__step': true,
        'stepper__step--active': this.isActive,
        'stepper__step--editable': this.editable,
        'stepper__step--inactive': this.isInactive,
        'stepper__step--error': this.hasError,
        'stepper__step--complete': this.complete
      };
    },
    hasError: function hasError() {
      return this.rules.some(function (i) {
        return i() !== true;
      });
    }
  },

  methods: {
    click: function click(e) {
      e.stopPropagation();

      if (this.editable) {
        this.stepClick(this.step);
      }
    },
    toggle: function toggle(step) {
      this.isActive = step.toString() === this.step.toString();
      this.isInactive = Number(step) < Number(this.step);
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      directives: [{
        name: 'ripple',
        value: this.editable
      }],
      on: { click: this.click }
    };
    var stepContent = void 0;

    if (this.hasError) {
      stepContent = [h('v-icon', {}, this.errorIcon)];
    } else if (this.complete) {
      if (this.editable) {
        stepContent = [h('v-icon', {}, this.editIcon)];
      } else {
        stepContent = [h('v-icon', {}, this.completeIcon)];
      }
    } else {
      stepContent = this.step;
    }

    var step = h('span', { 'class': 'stepper__step__step' }, stepContent);
    var label = h('div', { 'class': 'stepper__label' }, this.$slots.default);

    return h('div', data, [step, label]);
  }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-content',

  data: function data() {
    return {
      height: 0,
      isActive: false,
      isReverse: false,
      isVertical: false
    };
  },


  props: {
    step: {
      type: [Number, String],
      required: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__content': true
      };
    },
    computedTransition: function computedTransition() {
      return this.isReverse ? 'v-tab-reverse-transition' : 'v-tab-transition';
    },
    styles: function styles() {
      if (!this.isVertical) return {};

      return {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'stepper__wrapper': true
      };
    }
  },

  watch: {
    isActive: function isActive() {
      if (!this.isVertical) {
        return;
      }

      if (this.isActive) {
        this.enter();
      } else {
        this.leave();
      }
    }
  },

  mounted: function mounted() {
    this.$refs.wrapper.addEventListener('transitionend', this.onTransition, false);
  },
  beforeDestroy: function beforeDestroy() {
    this.$refs.wrapper.removeEventListener('transitionend', this.onTransition, false);
  },


  methods: {
    onTransition: function onTransition() {
      if (!this.isActive) return;

      this.height = 'auto';
    },
    enter: function enter() {
      var _this = this;

      var scrollHeight = 0;

      // Render bug with height
      setTimeout(function () {
        scrollHeight = _this.$refs.wrapper.scrollHeight;
      }, 0);

      this.height = 0;

      // Give the collapsing element time to collapse
      setTimeout(function () {
        return _this.height = scrollHeight || 'auto';
      }, 450);
    },
    leave: function leave() {
      var _this2 = this;

      this.height = this.$refs.wrapper.clientHeight;
      setTimeout(function () {
        return _this2.height = 0;
      }, 0);
    },
    toggle: function toggle(step, reverse) {
      this.isActive = step.toString() === this.step.toString();
      this.isReverse = reverse;
    }
  },

  render: function render(h) {
    var contentData = {
      'class': this.classes
    };
    var wrapperData = {
      'class': this.wrapperClasses,
      style: this.styles,
      ref: 'wrapper'
    };

    if (!this.isVertical) {
      contentData.directives = [{
        name: 'show',
        value: this.isActive
      }];
    }

    var wrapper = h('div', wrapperData, [this.$slots.default]);
    var content = h('div', contentData, [wrapper]);

    return h(this.computedTransition, {
      on: this.$listeners
    }, [content]);
  }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VTableOverflow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VDataTable__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VEditDialog__ = __webpack_require__(121);




var VTableOverflow = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('table__overflow');

/* harmony default export */ __webpack_exports__["a"] = ({
  VDataTable: __WEBPACK_IMPORTED_MODULE_1__VDataTable__["a" /* default */],
  VEditDialog: __WEBPACK_IMPORTED_MODULE_2__VEditDialog__["a" /* default */],
  VTableOverflow: VTableOverflow
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_head__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_body__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_foot__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_progress__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_helpers__ = __webpack_require__(0);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-datatable',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_head__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_foot__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__["a" /* default */]],

  components: {
    VBtn: __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__["a" /* default */],
    VProgressLinear: __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__["a" /* default */],
    VSelect: __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__["a" /* default */],
    // Importing does not work properly
    'v-table-overflow': Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["d" /* createSimpleFunctional */])('table__overflow')
  },

  data: function data() {
    return {
      all: false,
      searchLength: 0,
      defaultPagination: {
        page: 1,
        rowsPerPage: 5,
        descending: false,
        totalItems: 0
      }
    };
  },


  props: {
    headers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    headerText: {
      type: String,
      default: 'text'
    },
    hideActions: Boolean,
    noResultsText: {
      type: String,
      default: 'No matching records found'
    },
    rowsPerPageItems: {
      type: Array,
      default: function _default() {
        return [5, 10, 25, { text: 'All', value: -1 }];
      }
    },
    rowsPerPageText: {
      type: String,
      default: 'Rows per page:'
    },
    selectAll: [Boolean, String],
    search: {
      required: false
    },
    filter: {
      type: Function,
      default: function _default(val, search) {
        return val !== null && ['undefined', 'boolean'].indexOf(typeof val === 'undefined' ? 'undefined' : _typeof(val)) === -1 && val.toString().toLowerCase().indexOf(search) !== -1;
      }
    },
    customFilter: {
      type: Function,
      default: function _default(items, search, filter) {
        search = search.toString().toLowerCase();
        return items.filter(function (i) {
          return Object.keys(i).some(function (j) {
            return filter(i[j], search);
          });
        });
      }
    },
    customSort: {
      type: Function,
      default: function _default(items, index, isDescending) {
        if (index === null) return items;

        return items.sort(function (a, b) {
          var sortA = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(a, index);
          var sortB = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(b, index);

          if (isDescending) {
            var _ref = [sortB, sortA];
            sortA = _ref[0];
            sortB = _ref[1];
          }

          // Check if both are numbers
          if (!isNaN(sortA) && !isNaN(sortB)) {
            return sortA - sortB;
          }

          // Check if both cannot be evaluated
          if (sortA === null && sortB === null) {
            return 0;
          }

          var _map = [sortA, sortB].map(function (s) {
            return (s || '').toString().toLocaleLowerCase();
          });

          var _map2 = _slicedToArray(_map, 2);

          sortA = _map2[0];
          sortB = _map2[1];


          if (sortA > sortB) return 1;
          if (sortA < sortB) return -1;

          return 0;
        });
      }
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    items: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    totalItems: {
      type: Number,
      default: null
    },
    loading: {
      type: [Boolean, String],
      default: false
    },
    selectedKey: {
      type: String,
      default: 'id'
    },
    pagination: {
      type: Object,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'datatable table': true,
        'datatable--select-all': this.selectAll !== false,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    computedPagination: function computedPagination() {
      return this.pagination || this.defaultPagination;
    },
    hasSelectAll: function hasSelectAll() {
      return this.selectAll !== undefined && this.selectAll !== false;
    },
    itemsLength: function itemsLength() {
      if (this.search) return this.searchLength;
      return this.totalItems || this.items.length;
    },
    indeterminate: function indeterminate() {
      return this.hasSelectAll && this.someItems && !this.everyItem;
    },
    everyItem: function everyItem() {
      var _this = this;

      return this.filteredItems.length && this.filteredItems.every(function (i) {
        return _this.isSelected(i);
      });
    },
    someItems: function someItems() {
      var _this2 = this;

      return this.filteredItems.some(function (i) {
        return _this2.isSelected(i);
      });
    },
    getPage: function getPage() {
      var rowsPerPage = this.computedPagination.rowsPerPage;


      return rowsPerPage === Object(rowsPerPage) ? rowsPerPage.value : rowsPerPage;
    },
    pageStart: function pageStart() {
      return this.getPage === -1 ? 0 : (this.computedPagination.page - 1) * this.getPage;
    },
    pageStop: function pageStop() {
      return this.getPage === -1 ? this.itemsLength : this.computedPagination.page * this.getPage;
    },
    filteredItems: function filteredItems() {
      if (this.totalItems) return this.items;

      var items = this.items.slice();
      var hasSearch = typeof this.search !== 'undefined' && this.search !== null;

      if (hasSearch) {
        items = this.customFilter(items, this.search, this.filter);
        this.searchLength = items.length;
      }

      items = this.customSort(items, this.computedPagination.sortBy, this.computedPagination.descending);

      return this.hideActions && !this.pagination ? items : items.slice(this.pageStart, this.pageStop);
    },
    selected: function selected() {
      var _this3 = this;

      var selected = {};
      this.value.forEach(function (i) {
        return selected[i[_this3.selectedKey]] = true;
      });
      return selected;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      if (val) this.all = true;
    },
    someItems: function someItems(val) {
      if (!val) this.all = false;
    },
    search: function search() {
      this.updatePagination({ page: 1 });
    },
    everyItem: function everyItem(val) {
      if (val) this.all = true;
    }
  },

  methods: {
    updatePagination: function updatePagination(val) {
      var pagination = this.pagination || this.defaultPagination;
      var updatedPagination = Object.assign({}, pagination, val);

      if (this.pagination) {
        this.$emit('update:pagination', updatedPagination);
      } else {
        this.defaultPagination = updatedPagination;
      }
    },
    isSelected: function isSelected(item) {
      return this.selected[item[this.selectedKey]];
    },
    sort: function sort(index) {
      var _computedPagination = this.computedPagination,
          sortBy = _computedPagination.sortBy,
          descending = _computedPagination.descending;

      if (sortBy === null) {
        this.updatePagination({ sortBy: index, descending: false });
      } else if (sortBy === index && !descending) {
        this.updatePagination({ descending: true });
      } else if (sortBy !== index) {
        this.updatePagination({ sortBy: index, descending: false });
      } else {
        this.updatePagination({ sortBy: null, descending: null });
      }
    },
    needsTR: function needsTR(row) {
      return row.length && row.find(function (c) {
        return c.tag === 'td';
      });
    },
    genTR: function genTR(children) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.$createElement('tr', data, children);
    },
    toggle: function toggle(value) {
      var _this4 = this;

      var selected = Object.assign({}, this.selected);
      this.filteredItems.forEach(function (i) {
        return selected[i[_this4.selectedKey]] = value;
      });

      this.$emit('input', this.items.filter(function (i) {
        return selected[i[_this4.selectedKey]];
      }));
    }
  },

  created: function created() {
    var firstSortable = this.headers.find(function (h) {
      return !('sortable' in h) || h.sortable;
    });

    this.defaultPagination.sortBy = firstSortable ? firstSortable.value : null;

    if (!this.rowsPerPageItems.length) {
      console.warn('The prop \'rows-per-page-items\' in v-data-table can not be empty.');
    } else {
      this.defaultPagination.rowsPerPage = this.rowsPerPageItems[0];
    }

    this.updatePagination(Object.assign({}, this.defaultPagination, this.pagination));
  },
  render: function render(h) {
    return h('v-table-overflow', {}, [h('table', {
      'class': this.classes
    }, [this.genTHead(), this.genTProgress(), this.genTBody(), this.genTFoot()])]);
  }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTHead: function genTHead() {
      var _this = this;

      var children = [];

      if (this.$scopedSlots.headers) {
        var row = this.$scopedSlots.headers({
          headers: this.headers,
          indeterminate: this.indeterminate,
          all: this.all
        });

        children = this.needsTR(row) ? this.genTR(row) : row;
      } else {
        var _row = this.headers.map(function (o) {
          return _this.genHeader(o);
        });
        var checkbox = this.$createElement('v-checkbox', {
          props: {
            dark: this.dark,
            light: this.light,
            color: this.selectAll === true && '' || this.selectAll,
            hideDetails: true,
            inputValue: this.all,
            indeterminate: this.indeterminate
          },
          on: { change: this.toggle }
        });

        this.hasSelectAll && _row.unshift(this.$createElement('th', [checkbox]));

        children = this.genTR(_row);
      }

      return this.$createElement('thead', [children]);
    },
    genHeader: function genHeader(header) {
      var array = [this.$scopedSlots.headerCell ? this.$scopedSlots.headerCell({ header: header }) : header[this.headerText]];

      return this.$createElement.apply(this, ['th'].concat(_toConsumableArray(this.genHeaderData(header, array))));
    },
    genHeaderData: function genHeaderData(header, children) {
      var _this2 = this;

      var classes = ['column'];
      var data = {};
      var pagination = this.computedPagination;

      if ('sortable' in header && header.sortable || !('sortable' in header)) {
        data.on = { click: function click() {
            return _this2.sort(header.value);
          } };
        if (!('value' in header)) {
          console.warn('Data table headers must have a value property that corresponds to a value in the v-model array');
        }

        classes.push('sortable');
        var icon = this.$createElement('v-icon', 'arrow_upward');
        if (header.align && header.align === 'left') {
          children.push(icon);
        } else {
          children.unshift(icon);
        }

        var beingSorted = pagination.sortBy === header.value;
        if (beingSorted) {
          classes.push('active');
          classes.push(pagination.descending ? 'desc' : 'asc');
        }
      }

      classes.push('text-xs-' + (header.align || 'right'));
      data.class = classes;

      return [data, children];
    }
  }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTBody: function genTBody() {
      var children = [];

      if (!this.itemsLength) {
        children.push(this.genEmptyBody(this.noDataText));
      } else if (!this.filteredItems.length) {
        children.push(this.genEmptyBody(this.noResultsText));
      } else {
        children.push(this.genFilteredItems());
      }

      return this.$createElement('tbody', children);
    },
    genFilteredItems: function genFilteredItems() {
      var _this = this;

      return this.filteredItems.map(function (item, index) {
        var props = { item: item, index: index };
        var key = _this.selectedKey;

        Object.defineProperty(props, 'selected', {
          get: function get() {
            return _this.selected[item[_this.selectedKey]];
          },
          set: function set(value) {
            var selected = _this.value.slice();
            if (value) selected.push(item);else selected = selected.filter(function (i) {
              return i[key] !== item[key];
            });

            _this.$emit('input', selected);
          }
        });

        var row = _this.$scopedSlots.items(props);

        return _this.needsTR(row) ? _this.genTR(row, {
          attrs: { active: _this.isSelected(item) }
        }) : row;
      });
    },
    genEmptyBody: function genEmptyBody(text) {
      return this.genTR([this.$createElement('td', {
        'class': 'text-xs-center',
        attrs: { colspan: '100%' }
      }, text)]);
    }
  }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genPrevIcon: function genPrevIcon() {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          disabled: this.computedPagination.page === 1,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this.computedPagination.page;
            _this.updatePagination({ page: page - 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_left')]);
    },
    genNextIcon: function genNextIcon() {
      var _this2 = this;

      var pagination = this.computedPagination;
      var disabled = pagination.rowsPerPage < 0 || pagination.page * pagination.rowsPerPage >= this.itemsLength || this.pageStop < 0;

      return this.$createElement('v-btn', {
        props: {
          disabled: disabled,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this2.computedPagination.page;
            _this2.updatePagination({ page: page + 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_right')]);
    },
    genSelect: function genSelect() {
      var _this3 = this;

      return this.$createElement('div', {
        'class': 'datatable__actions__select'
      }, [this.rowsPerPageText, this.$createElement('v-select', {
        props: {
          items: this.rowsPerPageItems,
          value: this.computedPagination.rowsPerPage,
          hideDetails: true,
          auto: true,
          minWidth: '75px'
        },
        on: {
          input: function input(val) {
            _this3.updatePagination({
              page: 1,
              rowsPerPage: val
            });
          }
        }
      })]);
    },
    genPagination: function genPagination() {
      var pagination = '–';

      if (this.itemsLength) {
        var stop = this.itemsLength < this.pageStop || this.pageStop < 0 ? this.itemsLength : this.pageStop;

        pagination = this.$scopedSlots.pageText ? this.$scopedSlots.pageText({
          pageStart: this.pageStart + 1,
          pageStop: stop,
          itemsLength: this.itemsLength
        }) : this.pageStart + 1 + '-' + stop + ' of ' + this.itemsLength;
      }

      return this.$createElement('div', {
        'class': 'datatable__actions__pagination'
      }, [pagination]);
    },
    genActions: function genActions() {
      return [this.$createElement('div', {
        'class': 'datatable__actions'
      }, [this.genSelect(), this.genPagination(), this.genPrevIcon(), this.genNextIcon()])];
    },
    genTFoot: function genTFoot() {
      var children = [];

      if (this.$slots.footer) {
        var footer = this.$slots.footer;
        var row = this.needsTR(footer) ? this.genTR(footer) : footer;

        children.push(row);
      }

      if (!this.hideActions) {
        children.push(this.genTR([this.$createElement('td', {
          attrs: { colspan: '100%' }
        }, this.genActions())]));
      }

      if (!children.length) return null;
      return this.$createElement('tfoot', children);
    }
  }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      color: ''
    };
  },


  watch: {
    loading: function loading(val) {
      if (val) this.color = val;
    }
  },

  methods: {
    genTProgress: function genTProgress() {
      var loader = this.$createElement('v-progress-linear', {
        props: {
          primary: this.color === 'primary',
          secondary: this.color === 'secondary',
          success: this.color === 'success',
          info: this.color === 'info',
          warning: this.color === 'warning',
          error: this.color === 'error',
          indeterminate: true,
          height: 3,
          active: !!this.loading
        }
      });

      var col = this.$createElement('th', {
        class: 'column',
        attrs: {
          colspan: '100%'
        }
      }, [loader]);

      return this.$createElement('thead', {
        class: 'datatable__progress'
      }, [this.genTR([col])]);
    }
  }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-edit-dialog',

  data: function data() {
    return {
      isActive: false,
      isSaving: false
    };
  },


  props: {
    cancelText: {
      default: 'Cancel'
    },
    large: Boolean,
    lazy: Boolean,
    saveText: {
      default: 'Save'
    },
    transition: {
      type: String,
      default: 'slide-x-reverse-transition'
    }
  },

  watch: {
    isActive: function isActive(val) {
      val && this.$emit('open') && setTimeout(this.focus, 50); // Give DOM time to paint

      if (!val) {
        !this.isSaving && this.$emit('cancel');
        this.isSaving && this.$emit('close');
        this.isSaving = false;
      }
    }
  },

  methods: {
    cancel: function cancel() {
      this.isActive = false;
    },
    focus: function focus() {
      var input = this.$refs.content.querySelector('input');
      input && input.focus();
    },
    save: function save() {
      this.isSaving = true;
      this.isActive = false;
      this.$emit('save');
    },
    genButton: function genButton(fn, text) {
      return this.$createElement('v-btn', {
        props: {
          flat: true,
          primary: true,
          light: true
        },
        on: { click: fn }
      }, text);
    },
    genActions: function genActions() {
      return this.$createElement('div', {
        'class': 'small-dialog__actions',
        directives: [{
          name: 'show',
          value: this.large
        }]
      }, [this.genButton(this.cancel, this.cancelText), this.genButton(this.save, this.saveText)]);
    },
    genContent: function genContent() {
      var _this = this;

      return this.$createElement('div', {
        'class': 'small-dialog__content',
        on: {
          keydown: function keydown(e) {
            e.keyCode === 27 && _this.cancel();
            e.keyCode === 13 && _this.save();
          }
        },
        ref: 'content'
      }, [this.$slots.input]);
    }
  },

  render: function render(h) {
    var _this2 = this;

    return h('v-menu', {
      'class': 'small-dialog',
      props: {
        transition: this.transition,
        origin: 'top right',
        right: true,
        value: this.isActive,
        closeOnContentClick: false,
        lazy: this.lazy
      },
      on: {
        input: function input(val) {
          return _this2.isActive = val;
        }
      }
    }, [h('a', {
      domProps: { href: 'javascript:;' },
      slot: 'activator'
    }, this.$slots.default), this.genContent(), this.genActions()]);
  }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTabs__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VTabsItem__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VTabsContent__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VTabsBar__ = __webpack_require__(126);






var VTabsSlider = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('tabs__slider', 'li');

var VTabsItems = {
  name: 'v-tabs-items',

  render: function render(h) {
    return h('div', { 'class': { 'tabs__items': true } }, [this.$slots.default]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  VTabsItem: __WEBPACK_IMPORTED_MODULE_2__VTabsItem__["a" /* default */],
  VTabsItems: VTabsItems,
  VTabs: __WEBPACK_IMPORTED_MODULE_1__VTabs__["a" /* default */],
  VTabsContent: __WEBPACK_IMPORTED_MODULE_3__VTabsContent__["a" /* default */],
  VTabsBar: __WEBPACK_IMPORTED_MODULE_4__VTabsBar__["a" /* default */],
  VTabsSlider: VTabsSlider
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    var _this = this;

    return {
      slider: this.slider,
      tabClick: this.tabClick,
      isScrollable: function isScrollable() {
        return _this.scrollable;
      },
      isMobile: function isMobile() {
        return _this.isMobile;
      }
    };
  },
  data: function data() {
    return {
      activators: [],
      activeIndex: null,
      isMobile: false,
      reverse: false,
      target: null,
      tabsSlider: null,
      targetEl: null,
      tabsContainer: null
    };
  },


  props: {
    centered: Boolean,
    fixed: Boolean,
    grow: Boolean,
    icons: Boolean,
    mobileBreakPoint: {
      type: [Number, String],
      default: 1024
    },
    value: String,
    scrollable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'tabs': true,
        'tabs--centered': this.centered,
        'tabs--fixed': this.fixed,
        'tabs--grow': this.grow,
        'tabs--icons': this.icons,
        'tabs--mobile': this.isMobile,
        'tabs--scroll-bars': this.scrollable,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    value: function value() {
      this.tabClick(this.value);
    },
    activeIndex: function activeIndex() {
      this.updateTabs();
      this.$emit('input', this.target);
      this.isBooted = true;
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    this.$vuetify.load(function () {
      var activators = _this2.$slots.activators;

      if (!activators || !activators.length || !activators[0].componentInstance) return;

      var bar = activators[0].componentInstance.$children;
      // // This is a workaround to detect if link is active
      // // when being used as a router or nuxt link
      var i = bar.findIndex(function (t) {
        return t.$el.firstChild.classList.contains('tabs__item--active');
      });

      var tab = _this2.value || (bar[i !== -1 ? i : 0] || {}).action;

      tab && _this2.tabClick(tab) && _this2.onResize();
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resize, { passive: true });
  },


  methods: {
    onResize: function onResize() {
      this.isMobile = window.innerWidth < this.mobileBreakPoint;
      this.slider();
    },
    slider: function slider(el) {
      var _this3 = this;

      this.tabsSlider = this.tabsSlider || this.$el.querySelector('.tabs__slider');

      this.tabsContainer = this.tabsContainer || this.$el.querySelector('.tabs__container');

      if (!this.tabsSlider || !this.tabsContainer) return;

      this.targetEl = el || this.targetEl;

      if (!this.targetEl || !this.tabsContainer) return;

      // Gives DOM time to paint when
      // processing slider for
      // dynamic tabs
      this.$nextTick(function () {
        // #684 Calculate width as %
        var width = _this3.targetEl.scrollWidth / _this3.tabsContainer.clientWidth * 100;

        _this3.tabsSlider.style.width = width + '%';
        _this3.tabsSlider.style.left = _this3.targetEl.offsetLeft + 'px';
      });
    },
    tabClick: function tabClick(target) {
      var _this4 = this;

      var setActiveIndex = function setActiveIndex(index) {
        if (_this4.activeIndex === index) {
          // #762 update tabs display
          // In case tabs count got changed but activeIndex didn't
          _this4.updateTabs();
        } else {
          _this4.activeIndex = index;
        }
      };

      this.target = target;

      var content = this.$refs.content;
      if (!content) {
        setActiveIndex(target);
        return;
      }

      this.$nextTick(function () {
        var nextIndex = content.$children.findIndex(function (i) {
          return i.id === target;
        });
        _this4.reverse = nextIndex < _this4.activeIndex;
        setActiveIndex(nextIndex);
      });
    },
    updateTabs: function updateTabs() {
      var _this5 = this;

      var activators = this.$slots.activators;
      var content = this.$refs.content;

      if (!activators || !activators.length || activators.length && !activators[0].componentInstance) return;

      activators[0].componentInstance.$children.filter(function (i) {
        return i.$options._componentTag === 'v-tabs-item';
      }).forEach(function (i) {
        return i.toggle(_this5.target);
      });

      content && content.$children.forEach(function (i) {
        return i.toggle(_this5.target, _this5.reverse, _this5.isBooted);
      });
    }
  },

  render: function render(h) {
    var content = [];
    var slot = [];
    var iter = this.$slots.default || [];

    iter.forEach(function (c) {
      if (!c.componentOptions) slot.push(c);else if (c.componentOptions.tag === 'v-tabs-content') content.push(c);else slot.push(c);
    });

    var tabs = content.length ? h('v-tabs-items', {
      ref: 'content'
    }, content) : null;

    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [slot, this.$slots.activators, tabs]);
  }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-item',

  inject: ['slider', 'tabClick'],

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  data: function data() {
    return {
      isActive: false
    };
  },


  props: {
    activeClass: {
      type: String,
      default: 'tabs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = {
        'tabs__item': true,
        'tabs__item--disabled': this.disabled
      };

      classes[this.activeClass] = !this.to && this.isActive;

      return classes;
    },
    action: function action() {
      var to = this.to || this.href;

      if (!to || to === Object(to)) return this._uid;

      return to.replace('#', '');
    }
  },

  watch: {
    $route: function $route() {
      this.to && this.callSlider();
    }
  },

  mounted: function mounted() {
    this.callSlider();
  },


  methods: {
    callSlider: function callSlider() {
      var _this = this;

      setTimeout(function () {
        _this.$el.firstChild.classList.contains('tabs__item--active') && _this.slider(_this.$el);
      }, 0);
    },
    click: function click(e) {
      e.preventDefault();

      if (!this.to && !this.href) return;

      if (!this.to) {
        this.tabClick(this.action);
      }

      this.callSlider();
    },
    toggle: function toggle(action) {
      var _this2 = this;

      this.isActive = this.action === action;

      this.$nextTick(function () {
        _this2.isActive && _this2.slider(_this2.$el);
      });
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      'class': 'tabs__li'
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */]],

  data: function data() {
    return {
      isActive: false,
      reverse: false
    };
  },


  props: {
    id: {
      type: String,
      required: true
    },
    lazy: Boolean,
    transition: {
      type: String,
      default: 'v-tab-transition'
    },
    reverseTransition: {
      type: String,
      default: 'v-tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    }
  },

  methods: {
    toggle: function toggle(target, reverse, showTransition) {
      this.$el.style.transition = !showTransition ? 'none' : null;
      this.reverse = reverse;
      this.isActive = this.id === target;
    }
  },

  render: function render(h) {
    return h(this.computedTransition, {}, [h('div', {
      'class': 'tabs__content',
      domProps: { id: this.id },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, this.lazy && this.isBooted || !this.lazy ? this.$slots.default : null)]);
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-bar',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  inject: ['isScrollable', 'isMobile'],

  data: function data() {
    return {
      isOverflowing: false,
      scrollOffset: 0,
      itemOffset: 0,
      startX: 0
    };
  },


  computed: {
    classes: function classes() {
      return {
        'tabs__bar': true
      };
    },
    containerClasses: function containerClasses() {
      return {
        'tabs__container': true
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'tabs__wrapper': true,
        'tabs__wrapper--scrollable': this.isScrollable(),
        'tabs__wrapper--overflow': this.isOverflowing
      };
    },
    containerStyles: function containerStyles() {
      return {
        'transform': 'translateX(' + -this.scrollOffset + 'px)'
      };
    },
    leftIconVisible: function leftIconVisible() {
      return !this.isMobile() && this.isScrollable() && this.isOverflowing && this.scrollOffset > 0;
    },
    rightIconVisible: function rightIconVisible() {
      if (this.isMobile() || !this.isScrollable() || !this.isOverflowing) return;

      // Check one scroll ahead to know the width of right-most item
      var container = this.$refs.container;
      var item = this.newOffsetRight(this.scrollOffset, this.itemOffset);
      var itemWidth = item && container.children[item.index].clientWidth || 0;
      var scrollOffset = this.scrollOffset + container.clientWidth;

      return container.scrollWidth - scrollOffset > itemWidth * 0.30;
    }
  },

  methods: {
    genContainer: function genContainer() {
      return this.$createElement('ul', {
        'class': this.containerClasses,
        'style': this.containerStyles,
        ref: 'container'
      }, this.$slots.default);
    },
    genIcon: function genIcon(direction) {
      var capitalize = direction.charAt(0).toUpperCase() + direction.slice(1);
      return this.$createElement(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], {
        props: _defineProperty({}, '' + direction, true),
        style: { display: 'inline-flex' },
        on: {
          click: this['scroll' + capitalize]
        }
      }, 'chevron_' + direction);
    },
    genWrapper: function genWrapper() {
      return this.$createElement('div', {
        class: this.wrapperClasses,
        directives: [{
          name: 'touch',
          value: {
            start: this.start,
            move: this.move,
            end: this.end
          }
        }]
      }, [this.genContainer()]);
    },
    start: function start(e) {
      this.startX = this.scrollOffset + e.touchstartX;
      this.$refs.container.style.transition = 'none';
    },
    move: function move(e) {
      var offset = this.startX - e.touchmoveX;
      this.scrollOffset = offset;
    },
    end: function end(e) {
      this.onResize();
      var container = this.$refs.container;
      var scrollWidth = container.scrollWidth - this.$el.clientWidth / 2;
      container.style.transition = null;

      if (this.scrollOffset < 0 || !this.isOverflowing) {
        this.scrollOffset = 0;
      } else if (this.scrollOffset >= scrollWidth) {
        var lastItem = container.children[container.children.length - 1];
        this.scrollOffset = scrollWidth - lastItem.clientWidth;
      }
    },
    scrollLeft: function scrollLeft() {
      var _newOffset = this.newOffset('Left'),
          offset = _newOffset.offset,
          index = _newOffset.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    scrollRight: function scrollRight() {
      var _newOffset2 = this.newOffset('Right'),
          offset = _newOffset2.offset,
          index = _newOffset2.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    onResize: function onResize() {
      if (this._isDestroyed) return;

      var container = this.$refs.container;
      this.isOverflowing = container.clientWidth < container.scrollWidth;
    },
    newOffset: function newOffset(direction) {
      return this['newOffset' + direction](this.scrollOffset, this.itemOffset);
    },
    newOffsetLeft: function newOffsetLeft(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = 0;

      for (var index = currentIndex - 1; index >= 0; index--) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset >= container.clientWidth) {
            return { offset: currentOffset - offset, index: index + 1 };
          }
          offset = newOffset;
        }
      }

      return { offset: 0, index: 0 };
    },
    newOffsetRight: function newOffsetRight(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = currentOffset;

      for (var index = currentIndex; index < items.length; index++) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset > currentOffset + container.clientWidth) {
            return { offset: offset, index: index };
          }
          offset = newOffset;
        }
      }

      return null;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [this.genWrapper(), this.leftIconVisible ? this.genIcon('left') : null, this.rightIconVisible ? this.genIcon('right') : null]);
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VTextField__ = __webpack_require__(128);


/* harmony default export */ __webpack_exports__["a"] = ({
  VTextField: __WEBPACK_IMPORTED_MODULE_0__VTextField__["a" /* default */]
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-text-field',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  inheritAttrs: false,

  data: function data() {
    return {
      hasFocused: false,
      inputHeight: null
    };
  },


  props: {
    autofocus: Boolean,
    autoGrow: Boolean,
    counter: Boolean,
    fullWidth: Boolean,
    max: [Number, String],
    min: [Number, String],
    multiLine: Boolean,
    placeholder: String,
    prefix: String,
    rows: {
      default: 5
    },
    singleLine: Boolean,
    solo: Boolean,
    suffix: String,
    textarea: Boolean,
    type: {
      type: String,
      default: 'text'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field': true,
        'input-group--single-line': this.singleLine,
        'input-group--solo': this.solo,
        'input-group--multi-line': this.multiLine,
        'input-group--full-width': this.fullWidth,
        'input-group--prefix': this.prefix,
        'input-group--suffix': this.suffix,
        'input-group--textarea': this.textarea
      };
    },
    hasError: function hasError() {
      return this.validations.length || this.errorMessages.length > 0 || !this.counterIsValid() || !this.validateIsValid() || this.error;
    },
    count: function count() {
      var inputLength = void 0;
      if (this.inputValue) inputLength = this.inputValue.toString().length;else inputLength = 0;
      var min = inputLength;

      if (this.counterMin !== 0 && inputLength < this.counterMin) {
        min = this.counterMin;
      }

      return min + ' / ' + this.counterMax;
    },
    counterMin: function counterMin() {
      var parsedMin = parseInt(this.min, 10);
      return isNaN(parsedMin) ? 0 : parsedMin;
    },
    counterMax: function counterMax() {
      var parsedMax = parseInt(this.max, 10);
      return isNaN(parsedMax) ? 25 : parsedMax;
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        if (this.modifiers.trim) {
          val = val.trim();
        }

        if (this.modifiers.number) {
          val = Number(val);
        }

        if (!this.modifiers.lazy) {
          this.$emit('input', val);
        }

        this.lazyValue = val;
      }
    },
    isDirty: function isDirty() {
      return this.lazyValue !== null && typeof this.lazyValue !== 'undefined' && this.lazyValue.toString().length > 0 || this.placeholder;
    }
  },

  watch: {
    focused: function focused(val) {
      this.hasFocused = true;
    },
    value: function value() {
      this.lazyValue = this.value;
      this.validate();
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      _this.multiLine && _this.autoGrow && _this.calculateInputHeight();
      _this.autofocus && _this.focus();
    });
  },


  methods: {
    calculateInputHeight: function calculateInputHeight() {
      var _this2 = this;

      this.inputHeight = null;

      this.$nextTick(function () {
        var height = _this2.$refs.input.scrollHeight;
        var minHeight = _this2.rows * 24;
        var inputHeight = height < minHeight ? minHeight : height;
        _this2.inputHeight = inputHeight;
      });
    },
    onChange: function onChange(e) {
      this.lazyValue = e.target.value;
      this.$emit('change', this.lazyValue || null);
    },
    onInput: function onInput(e) {
      this.inputValue = e.target.value;
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    },
    blur: function blur(e) {
      var _this3 = this;

      this.validate();
      this.$nextTick(function () {
        return _this3.focused = false;
      });
      this.$emit('blur', e);
    },
    focus: function focus(e) {
      this.focused = true;
      this.$refs.input.focus();
      this.$emit('focus', e);
    },
    genCounter: function genCounter() {
      return this.$createElement('div', {
        'class': {
          'input-group__counter': true,
          'input-group__counter--error': !this.counterIsValid()
        }
      }, this.count);
    },
    genInput: function genInput() {
      var tag = this.multiLine || this.textarea ? 'textarea' : 'input';

      var data = {
        style: {
          'height': this.inputHeight && this.inputHeight + 'px'
        },
        domProps: {
          autofocus: this.autofocus,
          disabled: this.disabled,
          required: this.required,
          value: this.lazyValue
        },
        attrs: _extends({}, this.$attrs, {
          tabindex: this.tabindex,
          'aria-label': !this.$attrs.id && this.label // Label `for` will be set if we have an id
        }),
        on: _extends({}, this.$listeners, {
          blur: this.blur,
          input: this.onInput,
          focus: this.focus
        }),
        ref: 'input'
      };

      if (this.placeholder) data.domProps.placeholder = this.placeholder;

      if (!this.counter) {
        if (![undefined, null].includes(this.max)) data.attrs.max = this.max;
        if (![undefined, null].includes(this.min)) data.attrs.min = this.min;
      }

      if (!this.textarea && !this.multiLine) {
        data.domProps.type = this.type;
      } else {
        data.domProps.rows = this.rows;
      }

      var children = [this.$createElement(tag, data)];

      this.prefix && children.unshift(this.genFix('prefix'));
      this.suffix && children.push(this.genFix('suffix'));

      return children;
    },
    genFix: function genFix(type) {
      return this.$createElement('span', {
        'class': 'input-group--text-field__' + type
      }, this[type]);
    },

    counterIsValid: function counterIsValid() {
      var val = this.inputValue && this.inputValue.toString() || '';

      return !this.counter || val.length >= this.counterMin && val.length <= this.counterMax;
    },
    validateIsValid: function validateIsValid() {
      return !this.required || this.required && this.isDirty || !this.hasFocused || this.hasFocused && this.focused;
    }
  },

  render: function render() {
    return this.genInputGroup(this.genInput(), { attrs: { tabindex: false } });
  }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSnackbar__ = __webpack_require__(130);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSnackbar: __WEBPACK_IMPORTED_MODULE_0__VSnackbar__["a" /* default */]
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-snackbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      activeTimeout: {}
    };
  },


  props: {
    absolute: Boolean,
    bottom: Boolean,
    left: Boolean,
    multiLine: Boolean,
    right: Boolean,
    top: Boolean,
    timeout: {
      type: Number,
      default: 6000
    },
    vertical: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'snack': true,
        'snack--active': this.isActive,
        'snack--absolute': this.absolute,
        'snack--bottom': this.bottom || !this.top,
        'snack--left': this.left,
        'snack--multi-line': this.multiLine && !this.vertical,
        'snack--right': this.right,
        'snack--top': this.top,
        'snack--vertical': this.vertical,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'info': this.info,
        'warning': this.warning,
        'error': this.error
      };
    },
    computedTransition: function computedTransition() {
      return this.top ? 'v-slide-y-transition' : 'v-slide-y-reverse-transition';
    }
  },

  watch: {
    isActive: function isActive() {
      var _this = this;

      clearTimeout(this.activeTimeout);

      if (this.isActive && this.timeout) {
        this.activeTimeout = setTimeout(function () {
          _this.isActive = false;
        }, this.timeout);
      }
    }
  },

  render: function render(h) {
    var children = [];

    if (this.isActive) {
      children.push(h('div', {
        'class': 'snack__content'
      }, this.$slots.default));
    }

    return h('div', {
      'class': this.classes,
      on: this.$listeners
    }, [h(this.computedTransition, children)]);
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function load(cb) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (document.readyState === 'complete') {
    return setTimeout(cb, 0);
  }

  if (document.readyState === 'interactive' && i <= 10) {
    return setTimeout(function () {
      return load(cb, i + 1);
    }, 200);
  }

  window.addEventListener('load', cb);
}

/* harmony default export */ __webpack_exports__["a"] = (load);

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = SemVer;

// The debug function is excluded entirely from the minified version.
/* nomin */ var debug;
/* nomin */ if (typeof process === 'object' &&
    /* nomin */ process.env &&
    /* nomin */ process.env.NODE_DEBUG &&
    /* nomin */ /\bsemver\b/i.test(process.env.NODE_DEBUG))
  /* nomin */ debug = function() {
    /* nomin */ var args = Array.prototype.slice.call(arguments, 0);
    /* nomin */ args.unshift('SEMVER');
    /* nomin */ console.log.apply(console, args);
    /* nomin */ };
/* nomin */ else
  /* nomin */ debug = function() {};

// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
exports.SEMVER_SPEC_VERSION = '2.0.0';

var MAX_LENGTH = 256;
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

// The actual regexps go on exports.re
var re = exports.re = [];
var src = exports.src = [];
var R = 0;

// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.

// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.

var NUMERICIDENTIFIER = R++;
src[NUMERICIDENTIFIER] = '0|[1-9]\\d*';
var NUMERICIDENTIFIERLOOSE = R++;
src[NUMERICIDENTIFIERLOOSE] = '[0-9]+';


// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.

var NONNUMERICIDENTIFIER = R++;
src[NONNUMERICIDENTIFIER] = '\\d*[a-zA-Z-][a-zA-Z0-9-]*';


// ## Main Version
// Three dot-separated numeric identifiers.

var MAINVERSION = R++;
src[MAINVERSION] = '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')';

var MAINVERSIONLOOSE = R++;
src[MAINVERSIONLOOSE] = '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')';

// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.

var PRERELEASEIDENTIFIER = R++;
src[PRERELEASEIDENTIFIER] = '(?:' + src[NUMERICIDENTIFIER] +
                            '|' + src[NONNUMERICIDENTIFIER] + ')';

var PRERELEASEIDENTIFIERLOOSE = R++;
src[PRERELEASEIDENTIFIERLOOSE] = '(?:' + src[NUMERICIDENTIFIERLOOSE] +
                                 '|' + src[NONNUMERICIDENTIFIER] + ')';


// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.

var PRERELEASE = R++;
src[PRERELEASE] = '(?:-(' + src[PRERELEASEIDENTIFIER] +
                  '(?:\\.' + src[PRERELEASEIDENTIFIER] + ')*))';

var PRERELEASELOOSE = R++;
src[PRERELEASELOOSE] = '(?:-?(' + src[PRERELEASEIDENTIFIERLOOSE] +
                       '(?:\\.' + src[PRERELEASEIDENTIFIERLOOSE] + ')*))';

// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.

var BUILDIDENTIFIER = R++;
src[BUILDIDENTIFIER] = '[0-9A-Za-z-]+';

// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.

var BUILD = R++;
src[BUILD] = '(?:\\+(' + src[BUILDIDENTIFIER] +
             '(?:\\.' + src[BUILDIDENTIFIER] + ')*))';


// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.

// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.

var FULL = R++;
var FULLPLAIN = 'v?' + src[MAINVERSION] +
                src[PRERELEASE] + '?' +
                src[BUILD] + '?';

src[FULL] = '^' + FULLPLAIN + '$';

// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
var LOOSEPLAIN = '[v=\\s]*' + src[MAINVERSIONLOOSE] +
                 src[PRERELEASELOOSE] + '?' +
                 src[BUILD] + '?';

var LOOSE = R++;
src[LOOSE] = '^' + LOOSEPLAIN + '$';

var GTLT = R++;
src[GTLT] = '((?:<|>)?=?)';

// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
var XRANGEIDENTIFIERLOOSE = R++;
src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + '|x|X|\\*';
var XRANGEIDENTIFIER = R++;
src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + '|x|X|\\*';

var XRANGEPLAIN = R++;
src[XRANGEPLAIN] = '[v=\\s]*(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:' + src[PRERELEASE] + ')?' +
                   src[BUILD] + '?' +
                   ')?)?';

var XRANGEPLAINLOOSE = R++;
src[XRANGEPLAINLOOSE] = '[v=\\s]*(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:' + src[PRERELEASELOOSE] + ')?' +
                        src[BUILD] + '?' +
                        ')?)?';

var XRANGE = R++;
src[XRANGE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAIN] + '$';
var XRANGELOOSE = R++;
src[XRANGELOOSE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAINLOOSE] + '$';

// Tilde ranges.
// Meaning is "reasonably at or greater than"
var LONETILDE = R++;
src[LONETILDE] = '(?:~>?)';

var TILDETRIM = R++;
src[TILDETRIM] = '(\\s*)' + src[LONETILDE] + '\\s+';
re[TILDETRIM] = new RegExp(src[TILDETRIM], 'g');
var tildeTrimReplace = '$1~';

var TILDE = R++;
src[TILDE] = '^' + src[LONETILDE] + src[XRANGEPLAIN] + '$';
var TILDELOOSE = R++;
src[TILDELOOSE] = '^' + src[LONETILDE] + src[XRANGEPLAINLOOSE] + '$';

// Caret ranges.
// Meaning is "at least and backwards compatible with"
var LONECARET = R++;
src[LONECARET] = '(?:\\^)';

var CARETTRIM = R++;
src[CARETTRIM] = '(\\s*)' + src[LONECARET] + '\\s+';
re[CARETTRIM] = new RegExp(src[CARETTRIM], 'g');
var caretTrimReplace = '$1^';

var CARET = R++;
src[CARET] = '^' + src[LONECARET] + src[XRANGEPLAIN] + '$';
var CARETLOOSE = R++;
src[CARETLOOSE] = '^' + src[LONECARET] + src[XRANGEPLAINLOOSE] + '$';

// A simple gt/lt/eq thing, or just "" to indicate "any version"
var COMPARATORLOOSE = R++;
src[COMPARATORLOOSE] = '^' + src[GTLT] + '\\s*(' + LOOSEPLAIN + ')$|^$';
var COMPARATOR = R++;
src[COMPARATOR] = '^' + src[GTLT] + '\\s*(' + FULLPLAIN + ')$|^$';


// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
var COMPARATORTRIM = R++;
src[COMPARATORTRIM] = '(\\s*)' + src[GTLT] +
                      '\\s*(' + LOOSEPLAIN + '|' + src[XRANGEPLAIN] + ')';

// this one has to use the /g flag
re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], 'g');
var comparatorTrimReplace = '$1$2$3';


// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
var HYPHENRANGE = R++;
src[HYPHENRANGE] = '^\\s*(' + src[XRANGEPLAIN] + ')' +
                   '\\s+-\\s+' +
                   '(' + src[XRANGEPLAIN] + ')' +
                   '\\s*$';

var HYPHENRANGELOOSE = R++;
src[HYPHENRANGELOOSE] = '^\\s*(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s+-\\s+' +
                        '(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s*$';

// Star ranges basically just allow anything at all.
var STAR = R++;
src[STAR] = '(<|>)?=?\\s*\\*';

// Compile to actual regexp objects.
// All are flag-free, unless they were created above with a flag.
for (var i = 0; i < R; i++) {
  debug(i, src[i]);
  if (!re[i])
    re[i] = new RegExp(src[i]);
}

exports.parse = parse;
function parse(version, loose) {
  if (version instanceof SemVer)
    return version;

  if (typeof version !== 'string')
    return null;

  if (version.length > MAX_LENGTH)
    return null;

  var r = loose ? re[LOOSE] : re[FULL];
  if (!r.test(version))
    return null;

  try {
    return new SemVer(version, loose);
  } catch (er) {
    return null;
  }
}

exports.valid = valid;
function valid(version, loose) {
  var v = parse(version, loose);
  return v ? v.version : null;
}


exports.clean = clean;
function clean(version, loose) {
  var s = parse(version.trim().replace(/^[=v]+/, ''), loose);
  return s ? s.version : null;
}

exports.SemVer = SemVer;

function SemVer(version, loose) {
  if (version instanceof SemVer) {
    if (version.loose === loose)
      return version;
    else
      version = version.version;
  } else if (typeof version !== 'string') {
    throw new TypeError('Invalid Version: ' + version);
  }

  if (version.length > MAX_LENGTH)
    throw new TypeError('version is longer than ' + MAX_LENGTH + ' characters')

  if (!(this instanceof SemVer))
    return new SemVer(version, loose);

  debug('SemVer', version, loose);
  this.loose = loose;
  var m = version.trim().match(loose ? re[LOOSE] : re[FULL]);

  if (!m)
    throw new TypeError('Invalid Version: ' + version);

  this.raw = version;

  // these are actually numbers
  this.major = +m[1];
  this.minor = +m[2];
  this.patch = +m[3];

  if (this.major > MAX_SAFE_INTEGER || this.major < 0)
    throw new TypeError('Invalid major version')

  if (this.minor > MAX_SAFE_INTEGER || this.minor < 0)
    throw new TypeError('Invalid minor version')

  if (this.patch > MAX_SAFE_INTEGER || this.patch < 0)
    throw new TypeError('Invalid patch version')

  // numberify any prerelease numeric ids
  if (!m[4])
    this.prerelease = [];
  else
    this.prerelease = m[4].split('.').map(function(id) {
      if (/^[0-9]+$/.test(id)) {
        var num = +id;
        if (num >= 0 && num < MAX_SAFE_INTEGER)
          return num;
      }
      return id;
    });

  this.build = m[5] ? m[5].split('.') : [];
  this.format();
}

SemVer.prototype.format = function() {
  this.version = this.major + '.' + this.minor + '.' + this.patch;
  if (this.prerelease.length)
    this.version += '-' + this.prerelease.join('.');
  return this.version;
};

SemVer.prototype.toString = function() {
  return this.version;
};

SemVer.prototype.compare = function(other) {
  debug('SemVer.compare', this.version, this.loose, other);
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return this.compareMain(other) || this.comparePre(other);
};

SemVer.prototype.compareMain = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return compareIdentifiers(this.major, other.major) ||
         compareIdentifiers(this.minor, other.minor) ||
         compareIdentifiers(this.patch, other.patch);
};

SemVer.prototype.comparePre = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  // NOT having a prerelease is > having one
  if (this.prerelease.length && !other.prerelease.length)
    return -1;
  else if (!this.prerelease.length && other.prerelease.length)
    return 1;
  else if (!this.prerelease.length && !other.prerelease.length)
    return 0;

  var i = 0;
  do {
    var a = this.prerelease[i];
    var b = other.prerelease[i];
    debug('prerelease compare', i, a, b);
    if (a === undefined && b === undefined)
      return 0;
    else if (b === undefined)
      return 1;
    else if (a === undefined)
      return -1;
    else if (a === b)
      continue;
    else
      return compareIdentifiers(a, b);
  } while (++i);
};

// preminor will bump the version up to the next minor release, and immediately
// down to pre-release. premajor and prepatch work the same way.
SemVer.prototype.inc = function(release, identifier) {
  switch (release) {
    case 'premajor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor = 0;
      this.major++;
      this.inc('pre', identifier);
      break;
    case 'preminor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor++;
      this.inc('pre', identifier);
      break;
    case 'prepatch':
      // If this is already a prerelease, it will bump to the next version
      // drop any prereleases that might already exist, since they are not
      // relevant at this point.
      this.prerelease.length = 0;
      this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;
    // If the input is a non-prerelease version, this acts the same as
    // prepatch.
    case 'prerelease':
      if (this.prerelease.length === 0)
        this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;

    case 'major':
      // If this is a pre-major version, bump up to the same major version.
      // Otherwise increment major.
      // 1.0.0-5 bumps to 1.0.0
      // 1.1.0 bumps to 2.0.0
      if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0)
        this.major++;
      this.minor = 0;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'minor':
      // If this is a pre-minor version, bump up to the same minor version.
      // Otherwise increment minor.
      // 1.2.0-5 bumps to 1.2.0
      // 1.2.1 bumps to 1.3.0
      if (this.patch !== 0 || this.prerelease.length === 0)
        this.minor++;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'patch':
      // If this is not a pre-release version, it will increment the patch.
      // If it is a pre-release it will bump up to the same patch version.
      // 1.2.0-5 patches to 1.2.0
      // 1.2.0 patches to 1.2.1
      if (this.prerelease.length === 0)
        this.patch++;
      this.prerelease = [];
      break;
    // This probably shouldn't be used publicly.
    // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
    case 'pre':
      if (this.prerelease.length === 0)
        this.prerelease = [0];
      else {
        var i = this.prerelease.length;
        while (--i >= 0) {
          if (typeof this.prerelease[i] === 'number') {
            this.prerelease[i]++;
            i = -2;
          }
        }
        if (i === -1) // didn't increment anything
          this.prerelease.push(0);
      }
      if (identifier) {
        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
        if (this.prerelease[0] === identifier) {
          if (isNaN(this.prerelease[1]))
            this.prerelease = [identifier, 0];
        } else
          this.prerelease = [identifier, 0];
      }
      break;

    default:
      throw new Error('invalid increment argument: ' + release);
  }
  this.format();
  this.raw = this.version;
  return this;
};

exports.inc = inc;
function inc(version, release, loose, identifier) {
  if (typeof(loose) === 'string') {
    identifier = loose;
    loose = undefined;
  }

  try {
    return new SemVer(version, loose).inc(release, identifier).version;
  } catch (er) {
    return null;
  }
}

exports.diff = diff;
function diff(version1, version2) {
  if (eq(version1, version2)) {
    return null;
  } else {
    var v1 = parse(version1);
    var v2 = parse(version2);
    if (v1.prerelease.length || v2.prerelease.length) {
      for (var key in v1) {
        if (key === 'major' || key === 'minor' || key === 'patch') {
          if (v1[key] !== v2[key]) {
            return 'pre'+key;
          }
        }
      }
      return 'prerelease';
    }
    for (var key in v1) {
      if (key === 'major' || key === 'minor' || key === 'patch') {
        if (v1[key] !== v2[key]) {
          return key;
        }
      }
    }
  }
}

exports.compareIdentifiers = compareIdentifiers;

var numeric = /^[0-9]+$/;
function compareIdentifiers(a, b) {
  var anum = numeric.test(a);
  var bnum = numeric.test(b);

  if (anum && bnum) {
    a = +a;
    b = +b;
  }

  return (anum && !bnum) ? -1 :
         (bnum && !anum) ? 1 :
         a < b ? -1 :
         a > b ? 1 :
         0;
}

exports.rcompareIdentifiers = rcompareIdentifiers;
function rcompareIdentifiers(a, b) {
  return compareIdentifiers(b, a);
}

exports.major = major;
function major(a, loose) {
  return new SemVer(a, loose).major;
}

exports.minor = minor;
function minor(a, loose) {
  return new SemVer(a, loose).minor;
}

exports.patch = patch;
function patch(a, loose) {
  return new SemVer(a, loose).patch;
}

exports.compare = compare;
function compare(a, b, loose) {
  return new SemVer(a, loose).compare(b);
}

exports.compareLoose = compareLoose;
function compareLoose(a, b) {
  return compare(a, b, true);
}

exports.rcompare = rcompare;
function rcompare(a, b, loose) {
  return compare(b, a, loose);
}

exports.sort = sort;
function sort(list, loose) {
  return list.sort(function(a, b) {
    return exports.compare(a, b, loose);
  });
}

exports.rsort = rsort;
function rsort(list, loose) {
  return list.sort(function(a, b) {
    return exports.rcompare(a, b, loose);
  });
}

exports.gt = gt;
function gt(a, b, loose) {
  return compare(a, b, loose) > 0;
}

exports.lt = lt;
function lt(a, b, loose) {
  return compare(a, b, loose) < 0;
}

exports.eq = eq;
function eq(a, b, loose) {
  return compare(a, b, loose) === 0;
}

exports.neq = neq;
function neq(a, b, loose) {
  return compare(a, b, loose) !== 0;
}

exports.gte = gte;
function gte(a, b, loose) {
  return compare(a, b, loose) >= 0;
}

exports.lte = lte;
function lte(a, b, loose) {
  return compare(a, b, loose) <= 0;
}

exports.cmp = cmp;
function cmp(a, op, b, loose) {
  var ret;
  switch (op) {
    case '===':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a === b;
      break;
    case '!==':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a !== b;
      break;
    case '': case '=': case '==': ret = eq(a, b, loose); break;
    case '!=': ret = neq(a, b, loose); break;
    case '>': ret = gt(a, b, loose); break;
    case '>=': ret = gte(a, b, loose); break;
    case '<': ret = lt(a, b, loose); break;
    case '<=': ret = lte(a, b, loose); break;
    default: throw new TypeError('Invalid operator: ' + op);
  }
  return ret;
}

exports.Comparator = Comparator;
function Comparator(comp, loose) {
  if (comp instanceof Comparator) {
    if (comp.loose === loose)
      return comp;
    else
      comp = comp.value;
  }

  if (!(this instanceof Comparator))
    return new Comparator(comp, loose);

  debug('comparator', comp, loose);
  this.loose = loose;
  this.parse(comp);

  if (this.semver === ANY)
    this.value = '';
  else
    this.value = this.operator + this.semver.version;

  debug('comp', this);
}

var ANY = {};
Comparator.prototype.parse = function(comp) {
  var r = this.loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var m = comp.match(r);

  if (!m)
    throw new TypeError('Invalid comparator: ' + comp);

  this.operator = m[1];
  if (this.operator === '=')
    this.operator = '';

  // if it literally is just '>' or '' then allow anything.
  if (!m[2])
    this.semver = ANY;
  else
    this.semver = new SemVer(m[2], this.loose);
};

Comparator.prototype.toString = function() {
  return this.value;
};

Comparator.prototype.test = function(version) {
  debug('Comparator.test', version, this.loose);

  if (this.semver === ANY)
    return true;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  return cmp(version, this.operator, this.semver, this.loose);
};


exports.Range = Range;
function Range(range, loose) {
  if ((range instanceof Range) && range.loose === loose)
    return range;

  if (!(this instanceof Range))
    return new Range(range, loose);

  this.loose = loose;

  // First, split based on boolean or ||
  this.raw = range;
  this.set = range.split(/\s*\|\|\s*/).map(function(range) {
    return this.parseRange(range.trim());
  }, this).filter(function(c) {
    // throw out any that are not relevant for whatever reason
    return c.length;
  });

  if (!this.set.length) {
    throw new TypeError('Invalid SemVer Range: ' + range);
  }

  this.format();
}

Range.prototype.format = function() {
  this.range = this.set.map(function(comps) {
    return comps.join(' ').trim();
  }).join('||').trim();
  return this.range;
};

Range.prototype.toString = function() {
  return this.range;
};

Range.prototype.parseRange = function(range) {
  var loose = this.loose;
  range = range.trim();
  debug('range', range, loose);
  // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
  var hr = loose ? re[HYPHENRANGELOOSE] : re[HYPHENRANGE];
  range = range.replace(hr, hyphenReplace);
  debug('hyphen replace', range);
  // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
  range = range.replace(re[COMPARATORTRIM], comparatorTrimReplace);
  debug('comparator trim', range, re[COMPARATORTRIM]);

  // `~ 1.2.3` => `~1.2.3`
  range = range.replace(re[TILDETRIM], tildeTrimReplace);

  // `^ 1.2.3` => `^1.2.3`
  range = range.replace(re[CARETTRIM], caretTrimReplace);

  // normalize spaces
  range = range.split(/\s+/).join(' ');

  // At this point, the range is completely trimmed and
  // ready to be split into comparators.

  var compRe = loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var set = range.split(' ').map(function(comp) {
    return parseComparator(comp, loose);
  }).join(' ').split(/\s+/);
  if (this.loose) {
    // in loose mode, throw out any that are not valid comparators
    set = set.filter(function(comp) {
      return !!comp.match(compRe);
    });
  }
  set = set.map(function(comp) {
    return new Comparator(comp, loose);
  });

  return set;
};

// Mostly just for testing and legacy API reasons
exports.toComparators = toComparators;
function toComparators(range, loose) {
  return new Range(range, loose).set.map(function(comp) {
    return comp.map(function(c) {
      return c.value;
    }).join(' ').trim().split(' ');
  });
}

// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
function parseComparator(comp, loose) {
  debug('comp', comp);
  comp = replaceCarets(comp, loose);
  debug('caret', comp);
  comp = replaceTildes(comp, loose);
  debug('tildes', comp);
  comp = replaceXRanges(comp, loose);
  debug('xrange', comp);
  comp = replaceStars(comp, loose);
  debug('stars', comp);
  return comp;
}

function isX(id) {
  return !id || id.toLowerCase() === 'x' || id === '*';
}

// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
function replaceTildes(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceTilde(comp, loose);
  }).join(' ');
}

function replaceTilde(comp, loose) {
  var r = loose ? re[TILDELOOSE] : re[TILDE];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('tilde', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p))
      // ~1.2 == >=1.2.0 <1.3.0
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    else if (pr) {
      debug('replaceTilde pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      ret = '>=' + M + '.' + m + '.' + p + pr +
            ' <' + M + '.' + (+m + 1) + '.0';
    } else
      // ~1.2.3 == >=1.2.3 <1.3.0
      ret = '>=' + M + '.' + m + '.' + p +
            ' <' + M + '.' + (+m + 1) + '.0';

    debug('tilde return', ret);
    return ret;
  });
}

// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
// ^1.2.3 --> >=1.2.3 <2.0.0
// ^1.2.0 --> >=1.2.0 <2.0.0
function replaceCarets(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceCaret(comp, loose);
  }).join(' ');
}

function replaceCaret(comp, loose) {
  debug('caret', comp, loose);
  var r = loose ? re[CARETLOOSE] : re[CARET];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('caret', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p)) {
      if (M === '0')
        ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
      else
        ret = '>=' + M + '.' + m + '.0 <' + (+M + 1) + '.0.0';
    } else if (pr) {
      debug('replaceCaret pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p + pr +
              ' <' + (+M + 1) + '.0.0';
    } else {
      debug('no pr');
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p +
              ' <' + (+M + 1) + '.0.0';
    }

    debug('caret return', ret);
    return ret;
  });
}

function replaceXRanges(comp, loose) {
  debug('replaceXRanges', comp, loose);
  return comp.split(/\s+/).map(function(comp) {
    return replaceXRange(comp, loose);
  }).join(' ');
}

function replaceXRange(comp, loose) {
  comp = comp.trim();
  var r = loose ? re[XRANGELOOSE] : re[XRANGE];
  return comp.replace(r, function(ret, gtlt, M, m, p, pr) {
    debug('xRange', comp, ret, gtlt, M, m, p, pr);
    var xM = isX(M);
    var xm = xM || isX(m);
    var xp = xm || isX(p);
    var anyX = xp;

    if (gtlt === '=' && anyX)
      gtlt = '';

    if (xM) {
      if (gtlt === '>' || gtlt === '<') {
        // nothing is allowed
        ret = '<0.0.0';
      } else {
        // nothing is forbidden
        ret = '*';
      }
    } else if (gtlt && anyX) {
      // replace X with 0
      if (xm)
        m = 0;
      if (xp)
        p = 0;

      if (gtlt === '>') {
        // >1 => >=2.0.0
        // >1.2 => >=1.3.0
        // >1.2.3 => >= 1.2.4
        gtlt = '>=';
        if (xm) {
          M = +M + 1;
          m = 0;
          p = 0;
        } else if (xp) {
          m = +m + 1;
          p = 0;
        }
      } else if (gtlt === '<=') {
        // <=0.7.x is actually <0.8.0, since any 0.7.x should
        // pass.  Similarly, <=7.x is actually <8.0.0, etc.
        gtlt = '<';
        if (xm)
          M = +M + 1;
        else
          m = +m + 1;
      }

      ret = gtlt + M + '.' + m + '.' + p;
    } else if (xm) {
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    } else if (xp) {
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    }

    debug('xRange return', ret);

    return ret;
  });
}

// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
function replaceStars(comp, loose) {
  debug('replaceStars', comp, loose);
  // Looseness is ignored here.  star is always as loose as it gets!
  return comp.trim().replace(re[STAR], '');
}

// This function is passed to string.replace(re[HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0
function hyphenReplace($0,
                       from, fM, fm, fp, fpr, fb,
                       to, tM, tm, tp, tpr, tb) {

  if (isX(fM))
    from = '';
  else if (isX(fm))
    from = '>=' + fM + '.0.0';
  else if (isX(fp))
    from = '>=' + fM + '.' + fm + '.0';
  else
    from = '>=' + from;

  if (isX(tM))
    to = '';
  else if (isX(tm))
    to = '<' + (+tM + 1) + '.0.0';
  else if (isX(tp))
    to = '<' + tM + '.' + (+tm + 1) + '.0';
  else if (tpr)
    to = '<=' + tM + '.' + tm + '.' + tp + '-' + tpr;
  else
    to = '<=' + to;

  return (from + ' ' + to).trim();
}


// if ANY of the sets match ALL of its comparators, then pass
Range.prototype.test = function(version) {
  if (!version)
    return false;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  for (var i = 0; i < this.set.length; i++) {
    if (testSet(this.set[i], version))
      return true;
  }
  return false;
};

function testSet(set, version) {
  for (var i = 0; i < set.length; i++) {
    if (!set[i].test(version))
      return false;
  }

  if (version.prerelease.length) {
    // Find the set of versions that are allowed to have prereleases
    // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
    // That should allow `1.2.3-pr.2` to pass.
    // However, `1.2.4-alpha.notready` should NOT be allowed,
    // even though it's within the range set by the comparators.
    for (var i = 0; i < set.length; i++) {
      debug(set[i].semver);
      if (set[i].semver === ANY)
        continue;

      if (set[i].semver.prerelease.length > 0) {
        var allowed = set[i].semver;
        if (allowed.major === version.major &&
            allowed.minor === version.minor &&
            allowed.patch === version.patch)
          return true;
      }
    }

    // Version has a -pre, but it's not one of the ones we like.
    return false;
  }

  return true;
}

exports.satisfies = satisfies;
function satisfies(version, range, loose) {
  try {
    range = new Range(range, loose);
  } catch (er) {
    return false;
  }
  return range.test(version);
}

exports.maxSatisfying = maxSatisfying;
function maxSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return rcompare(a, b, loose);
  })[0] || null;
}

exports.minSatisfying = minSatisfying;
function minSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return compare(a, b, loose);
  })[0] || null;
}

exports.validRange = validRange;
function validRange(range, loose) {
  try {
    // Return '*' instead of '' so that truthiness works.
    // This will throw if it's invalid anyway
    return new Range(range, loose).range || '*';
  } catch (er) {
    return null;
  }
}

// Determine if version is less than all the versions possible in the range
exports.ltr = ltr;
function ltr(version, range, loose) {
  return outside(version, range, '<', loose);
}

// Determine if version is greater than all the versions possible in the range.
exports.gtr = gtr;
function gtr(version, range, loose) {
  return outside(version, range, '>', loose);
}

exports.outside = outside;
function outside(version, range, hilo, loose) {
  version = new SemVer(version, loose);
  range = new Range(range, loose);

  var gtfn, ltefn, ltfn, comp, ecomp;
  switch (hilo) {
    case '>':
      gtfn = gt;
      ltefn = lte;
      ltfn = lt;
      comp = '>';
      ecomp = '>=';
      break;
    case '<':
      gtfn = lt;
      ltefn = gte;
      ltfn = gt;
      comp = '<';
      ecomp = '<=';
      break;
    default:
      throw new TypeError('Must provide a hilo val of "<" or ">"');
  }

  // If it satisifes the range it is not outside
  if (satisfies(version, range, loose)) {
    return false;
  }

  // From now on, variable terms are as if we're in "gtr" mode.
  // but note that everything is flipped for the "ltr" function.

  for (var i = 0; i < range.set.length; ++i) {
    var comparators = range.set[i];

    var high = null;
    var low = null;

    comparators.forEach(function(comparator) {
      if (comparator.semver === ANY) {
        comparator = new Comparator('>=0.0.0')
      }
      high = high || comparator;
      low = low || comparator;
      if (gtfn(comparator.semver, high.semver, loose)) {
        high = comparator;
      } else if (ltfn(comparator.semver, low.semver, loose)) {
        low = comparator;
      }
    });

    // If the edge version comparator has a operator then our version
    // isn't outside it
    if (high.operator === comp || high.operator === ecomp) {
      return false;
    }

    // If the lowest version comparator has an operator and our version
    // is less than it then it isn't higher than the range
    if ((!low.operator || low.operator === comp) &&
        ltefn(version, low.semver)) {
      return false;
    } else if (low.operator === ecomp && ltfn(version, low.semver)) {
      return false;
    }
  }
  return true;
}

exports.prerelease = prerelease;
function prerelease(version, loose) {
  var parsed = parse(version, loose);
  return (parsed && parsed.prerelease.length) ? parsed.prerelease : null;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(133)))

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ })
/******/ ]);
});
//# sourceMappingURL=vuetify.js.map

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("VueShortkey",[],t):"object"==typeof exports?exports.VueShortkey=t():e.VueShortkey=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="../dist/",t(t.s=0)}([function(e,t,n){"use strict";(function(r){function o(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}var c;n(2),n(3);var u={},i={},a=[],l=[],s=!1,f=function(e){return e="string"==typeof e?JSON.parse(e.replace(/\'/gi,'"')):e,e instanceof Array?{"":e}:e},p=function(e,t,n,r){var o=!0===n.modifiers.push,c=!0===n.modifiers.avoid,u=!0==!n.modifiers.focus,i=!0===n.modifiers.once;c?(a=a.filter(function(e){return!e===t}),a.push(t)):v({b:e,push:o,once:i,focus:u,el:r.elm})},y=function(e,t){for(var n in e){var r=u.encodeKey(e[n]),o=i[r].el.indexOf(t);i[r].el.length>1&&o>-1?i[r].el.splice(o,1):delete i[r]}};u.install=function(e,t){l=[].concat(o(t&&t.prevent?t.prevent:[])),e.directive("shortkey",{bind:function(e,t,n){var r=f(t.value);p(r,e,t,n)},update:function(e,t,n){var r=f(t.oldValue);y(r,e);var o=f(t.value);p(o,e,t,n)},unbind:function(e,t){var n=f(t.value);y(n,e)}})},u.decodeKey=function(e){return d(e)},u.encodeKey=function(e){var t={};t.shiftKey=e.includes("shift"),t.ctrlKey=e.includes("ctrl"),t.metaKey=e.includes("meta"),t.altKey=e.includes("alt");var n=d(t);return n+=e.filter(function(e){return!["shift","ctrl","meta","alt"].includes(e)}).join("")};var d=function(e){var t="";return("Shift"===e.key||e.shiftKey)&&(t+="shift"),("Control"===e.key||e.ctrlKey)&&(t+="ctrl"),("Meta"===e.key||e.metaKey)&&(t+="meta"),("Alt"===e.key||e.altKey)&&(t+="alt"),"ArrowUp"===e.key&&(t+="arrowup"),"ArrowLeft"===e.key&&(t+="arrowleft"),"ArrowRight"===e.key&&(t+="arrowright"),"ArrowDown"===e.key&&(t+="arrowdown"),"AltGraph"===e.key&&(t+="altgraph"),"Escape"===e.key&&(t+="esc"),"Enter"===e.key&&(t+="enter"),"Tab"===e.key&&(t+="tab")," "===e.key&&(t+="space"),"PageUp"===e.key&&(t+="pageup"),"PageDown"===e.key&&(t+="pagedown"),"Home"===e.key&&(t+="home"),"End"===e.key&&(t+="end"),"Delete"===e.key&&(t+="del"),"Backspace"===e.key&&(t+="backspace"),"Insert"===e.key&&(t+="insert"),"NumLock"===e.key&&(t+="numlock"),"CapsLock"===e.key&&(t+="capslock"),"Pause"===e.key&&(t+="pause"),"ContextMenu"===e.key&&(t+="contextmenu"),"ScrollLock"===e.key&&(t+="scrolllock"),"BrowserHome"===e.key&&(t+="browserhome"),"MediaSelect"===e.key&&(t+="mediaselect"),(e.key&&" "!==e.key&&1===e.key.length||/F\d{1,2}|\//g.test(e.key))&&(t+=e.key.toLowerCase()),t},h=function(e){var t=new CustomEvent("shortkey",{bubbles:!1});i[e].key&&(t.srcKey=i[e].key);var n=i[e].el;n[n.length-1].dispatchEvent(t)};u.keyDown=function(e){(!i[e].once&&!i[e].push||i[e].push&&!s)&&h(e)},r&&Object({NODE_ENV:"production"})&&function(){document.addEventListener("keydown",function(e){var t=u.decodeKey(e);if(m(t))if(e.preventDefault(),e.stopPropagation(),i[t].focus)u.keyDown(t),s=!0;else if(!s){var n=i[t].el;n[n.length-1].focus(),s=!0}},!0),document.addEventListener("keyup",function(e){var t=u.decodeKey(e);m(t)&&(e.preventDefault(),e.stopPropagation(),(i[t].once||i[t].push)&&h(t)),s=!1},!0)}();var v=function(e){var t=e.b,n=e.push,r=e.once,o=e.focus,c=e.el;for(var a in t){var l=u.encodeKey(t[a]),s=i[l]&&i[l].el?i[l].el:[];s.push(c),i[l]={push:n,once:r,focus:o,key:a,el:s}}},m=function(e){var t=!!a.find(function(e){return e===document.activeElement}),n=!!l.find(function(e){return document.activeElement&&document.activeElement.matches(e)});return!!i[e]&&!(t||n)};void 0!==e&&e.exports?e.exports=u:void 0!==(c=function(){return u}.call(t,n,t,e))&&(e.exports=c)}).call(t,n(1))},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function o(e){if(s===setTimeout)return setTimeout(e,0);if((s===n||!s)&&setTimeout)return s=setTimeout,setTimeout(e,0);try{return s(e,0)}catch(t){try{return s.call(null,e,0)}catch(t){return s.call(this,e,0)}}}function c(e){if(f===clearTimeout)return clearTimeout(e);if((f===r||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(e);try{return f(e)}catch(t){try{return f.call(null,e)}catch(t){return f.call(this,e)}}}function u(){h&&y&&(h=!1,y.length?d=y.concat(d):v=-1,d.length&&i())}function i(){if(!h){var e=o(u);h=!0;for(var t=d.length;t;){for(y=d,d=[];++v<t;)y&&y[v].run();v=-1,t=d.length}y=null,h=!1,c(e)}}function a(e,t){this.fun=e,this.array=t}function l(){}var s,f,p=e.exports={};!function(){try{s="function"==typeof setTimeout?setTimeout:n}catch(e){s=n}try{f="function"==typeof clearTimeout?clearTimeout:r}catch(e){f=r}}();var y,d=[],h=!1,v=-1;p.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];d.push(new a(e,t)),1!==d.length||h||o(i)},a.prototype.run=function(){this.fun.apply(null,this.array)},p.title="browser",p.browser=!0,p.env={},p.argv=[],p.version="",p.versions={},p.on=l,p.addListener=l,p.once=l,p.off=l,p.removeListener=l,p.removeAllListeners=l,p.emit=l,p.prependListener=l,p.prependOnceListener=l,p.listeners=function(e){return[]},p.binding=function(e){throw new Error("process.binding is not supported")},p.cwd=function(){return"/"},p.chdir=function(e){throw new Error("process.chdir is not supported")},p.umask=function(){return 0}},function(e,t){Element.prototype.matches||(Element.prototype.matches=Element.prototype.matchesSelector||Element.prototype.msMatchesSelector||Element.prototype.webkitMatchesSelector)},function(e,t){!function(){if("undefined"!=typeof window)try{var e=new window.CustomEvent("test",{cancelable:!0});if(e.preventDefault(),!0!==e.defaultPrevented)throw new Error("Could not prevent default")}catch(e){var t=function(e,t){var n,r;return t=t||{},t.bubbles=!!t.bubbles,t.cancelable=!!t.cancelable,n=document.createEvent("CustomEvent"),n.initCustomEvent(e,t.bubbles,t.cancelable,t.detail),r=n.preventDefault,n.preventDefault=function(){r.call(this);try{Object.defineProperty(this,"defaultPrevented",{get:function(){return!0}})}catch(e){this.defaultPrevented=!0}},n};t.prototype=window.Event.prototype,window.CustomEvent=t}}()}])});
//# sourceMappingURL=index.js.map

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(__webpack_require__(70)) :
  typeof define === 'function' && define.amd ? define(['hammerjs'], factory) :
  (factory(global.Hammer));
}(this, (function (Hammer) { 'use strict';

Hammer = 'default' in Hammer ? Hammer['default'] : Hammer;

function assign(target) {
  var sources = [], len = arguments.length - 1;
  while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];
  for (var i = 0; i < sources.length; i++) {
    var source = sources[i];
    var keys = Object.keys(source);
    for (var i$1 = 0; i$1 < keys.length; i$1++) {
      var key = keys[i$1];
      target[key] = source[key];
    }
  }
  return target
}
function createProp() {
  return {
    type: Object,
    default: function() { return {} }
  }
}
function capitalize (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
var directions = ['up', 'down', 'left', 'right', 'horizontal', 'vertical', 'all'];
function guardDirections (options) {
  var dir = options.direction;
  if (typeof dir === 'string') {
    var hammerDirection = 'DIRECTION_' + dir.toUpperCase();
    if (directions.indexOf(dir) > -1 && Hammer.hasOwnProperty(hammerDirection)) {
      options.direction = Hammer[hammerDirection];
    } else {
      console.warn('[vue-touch] invalid direction: ' + dir);
    }
  }
  return options
}
var config = {
};
var customEvents = {
};
var gestures = [
  'pan','panstart','panmove','panend','pancancel','panleft','panright','panup','pandown',
  'pinch','pinchstart','pinchmove','pinchend','pinchcancel','pinchin','pinchout',
  'press','pressup',
  'rotate','rotatestart','rotatemove','rotateend','rotatecancel',
  'swipe','swipeleft','swiperight','swipeup','swipedown',
  'tap'
];
var gestureMap = {
  pan: 'pan',
  panstart: 'pan',
  panmove: 'pan',
  panend: 'pan',
  pancancel: 'pan',
  panleft: 'pan',
  panright: 'pan',
  panup: 'pan',
  pandown: 'pan',
  pinch: 'pinch',
  pinchstart: 'pinch',
  pinchmove: 'pinch',
  pinchend: 'pinch',
  pinchcancel: 'pinch',
  pinchin: 'pinch',
  pinchout: 'pinch',
  press: 'press',
  pressup: 'press',
  rotate: 'rotate',
  rotatestart: 'rotate',
  rotatemove: 'rotate',
  rotateend: 'rotate',
  rotatecancel: 'rotate',
  swipe: 'swipe',
  swipeleft: 'swipe',
  swiperight: 'swipe',
  swipeup: 'swipe',
  swipedown: 'swipe',
  tap: 'tap'
};

var Component = {
  props: {
    options: createProp(),
    tapOptions: createProp(),
    panOptions: createProp(),
    pinchOptions: createProp(),
    pressOptions: createProp(),
    rotateOptions: createProp(),
    swipeOptions: createProp(),
    tag: { type: String, default: 'div' },
    enabled: {
      default: true,
      type: [Boolean, Object],
    }
  },
  mounted: function mounted() {
    if (!this.$isServer) {
      this.hammer = new Hammer.Manager(this.$el, this.options);
      this.recognizers = {};
      this.setupBuiltinRecognizers();
      this.setupCustomRecognizers();
      this.updateEnabled(this.enabled);
    }
  },
  destroyed: function destroyed() {
    if (!this.$isServer) {
      this.hammer.destroy();
    }
  },
  watch: {
    enabled: {
      deep: true,
      handler: function handler() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];
        (ref = this).updateEnabled.apply(ref, args);
        var ref;
      }
    }
  },
  methods: {
    setupBuiltinRecognizers: function setupBuiltinRecognizers()  {
      var this$1 = this;
      for (var i = 0; i < gestures.length; i++) {
        var gesture = gestures[i];
        if (this$1._events[gesture]) {
          var mainGesture = gestureMap[gesture];
          var options = assign({}, (config[mainGesture] || {}), this$1[(mainGesture + "Options")]);
          this$1.addRecognizer(mainGesture, options);
          this$1.addEvent(gesture);
        }
      }
    },
    setupCustomRecognizers: function setupCustomRecognizers() {
      var this$1 = this;
      var gestures$$1 = Object.keys(customEvents);
      for (var i = 0; i < gestures$$1.length; i++) {
        var gesture = gestures$$1[i];
        if (this$1._events[gesture]) {
          var opts = customEvents[gesture];
          var localCustomOpts = this$1[(gesture + "Options")] || {};
          var options = assign({}, opts, localCustomOpts);
          this$1.addRecognizer(gesture, options, {mainGesture: options.type});
          this$1.addEvent(gesture);
        }
      }
    },
    addRecognizer: function addRecognizer(gesture, options, ref) {
      if ( ref === void 0 ) ref = {};
      var mainGesture = ref.mainGesture;
      if (!this.recognizers[gesture]) {
        var recognizer = new Hammer[capitalize(mainGesture || gesture)](guardDirections(options));
        this.recognizers[gesture] = recognizer;
        this.hammer.add(recognizer);
        recognizer.recognizeWith(this.hammer.recognizers);
      }
    },
    addEvent: function addEvent(gesture) {
      var this$1 = this;
      this.hammer.on(gesture, function (e) { return this$1.$emit(gesture, e); });
    },
    updateEnabled: function updateEnabled(newVal, oldVal) {
      var this$1 = this;
      if (newVal === true) {
        this.enableAll();
      } else if (newVal === false) {
        this.disableAll();
      } else if (typeof newVal === 'object') {
        var keys = Object.keys(newVal);
        for (var i = 0; i < keys.length; i++) {
          var event = keys[i];
          if (this$1.recognizers[event]) {
            newVal[event]
              ? this$1.enable(event)
              : this$1.disable(event);
          }
        }
      }
    },
    enable: function enable(r) {
      var recognizer = this.recognizers[r];
      if (!recognizer.options.enable) {
        recognizer.set({ enable: true });
      }
    },
    disable: function disable(r) {
      var recognizer = this.recognizers[r];
      if (recognizer.options.enable) {
        recognizer.set({ enable: false });
      }
    },
    toggle: function toggle(r) {
      var recognizer = this.recognizers[r];
      if (recognizer) {
        recognizer.options.enable
          ? this.disable(r)
          : this.enable(r);
      }
    },
    enableAll: function enableAll(r) {
      this.toggleAll({ enable: true });
    },
    disableAll: function disableAll(r) {
      this.toggleAll({ enable: false });
    },
    toggleAll: function toggleAll(ref) {
      var this$1 = this;
      var enable = ref.enable;
      var keys = Object.keys(this.recognizers);
      for (var i = 0; i < keys.length; i++) {
        var r = this$1.recognizers[keys[i]];
        if (r.options.enable !== enable) {
          r.set({ enable: enable });
        }
      }
    },
    isEnabled: function isEnabled(r) {
      return this.recognizers[r] && this.recognizers[r].options.enable
    }
  },
  render: function render(h) {
    return h(this.tag, {}, this.$slots.default)
  }
};

var installed = false;
var vueTouch = { config: config, customEvents: customEvents };
vueTouch.install = function install(Vue, opts) {
  if ( opts === void 0 ) opts = {};
  var name = opts.name || 'v-touch';
  Vue.component(name, assign(Component, { name: name }));
  installed = true;
}.bind(vueTouch);
vueTouch.registerCustomEvent = function registerCustomEvent(event, options) {
  if ( options === void 0 ) options = {};
  if (installed) {
    console.warn(("\n      [vue-touch]: Custom Event '" + event + "' couldn't be added to vue-touch.\n      Custom Events have to be registered before installing the plugin.\n      "));
    return
  }
  options.event = event;
  customEvents[event] = options;
  Component.props[(event + "Options")] = {
    type: Object,
    default: function default$1() { return {} }
  };
}.bind(vueTouch);
vueTouch.component = Component;
if (true) {
  module.exports = vueTouch;
} else if (typeof define == "function" && define.amd) {
  define([], function(){ return vueTouch });
} else if (typeof window !== 'undefined' && window.Vue) {
  window.VueTouch = vueTouch;
  Vue.use(vueTouch);
}

})));
//# sourceMappingURL=vue-touch.js.map


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return Hammer;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof module != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Url */
/* unused harmony export Http */
/* unused harmony export Resource */
/*!
 * vue-resource v1.5.1
 * https://github.com/pagekit/vue-resource
 * Released under the MIT License.
 */

/**
 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
 */

var RESOLVED = 0;
var REJECTED = 1;
var PENDING = 2;

function Promise$1(executor) {

    this.state = PENDING;
    this.value = undefined;
    this.deferred = [];

    var promise = this;

    try {
        executor(function (x) {
            promise.resolve(x);
        }, function (r) {
            promise.reject(r);
        });
    } catch (e) {
        promise.reject(e);
    }
}

Promise$1.reject = function (r) {
    return new Promise$1(function (resolve, reject) {
        reject(r);
    });
};

Promise$1.resolve = function (x) {
    return new Promise$1(function (resolve, reject) {
        resolve(x);
    });
};

Promise$1.all = function all(iterable) {
    return new Promise$1(function (resolve, reject) {
        var count = 0, result = [];

        if (iterable.length === 0) {
            resolve(result);
        }

        function resolver(i) {
            return function (x) {
                result[i] = x;
                count += 1;

                if (count === iterable.length) {
                    resolve(result);
                }
            };
        }

        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolver(i), reject);
        }
    });
};

Promise$1.race = function race(iterable) {
    return new Promise$1(function (resolve, reject) {
        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolve, reject);
        }
    });
};

var p = Promise$1.prototype;

p.resolve = function resolve(x) {
    var promise = this;

    if (promise.state === PENDING) {
        if (x === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        var called = false;

        try {
            var then = x && x['then'];

            if (x !== null && typeof x === 'object' && typeof then === 'function') {
                then.call(x, function (x) {
                    if (!called) {
                        promise.resolve(x);
                    }
                    called = true;

                }, function (r) {
                    if (!called) {
                        promise.reject(r);
                    }
                    called = true;
                });
                return;
            }
        } catch (e) {
            if (!called) {
                promise.reject(e);
            }
            return;
        }

        promise.state = RESOLVED;
        promise.value = x;
        promise.notify();
    }
};

p.reject = function reject(reason) {
    var promise = this;

    if (promise.state === PENDING) {
        if (reason === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        promise.state = REJECTED;
        promise.value = reason;
        promise.notify();
    }
};

p.notify = function notify() {
    var promise = this;

    nextTick(function () {
        if (promise.state !== PENDING) {
            while (promise.deferred.length) {
                var deferred = promise.deferred.shift(),
                    onResolved = deferred[0],
                    onRejected = deferred[1],
                    resolve = deferred[2],
                    reject = deferred[3];

                try {
                    if (promise.state === RESOLVED) {
                        if (typeof onResolved === 'function') {
                            resolve(onResolved.call(undefined, promise.value));
                        } else {
                            resolve(promise.value);
                        }
                    } else if (promise.state === REJECTED) {
                        if (typeof onRejected === 'function') {
                            resolve(onRejected.call(undefined, promise.value));
                        } else {
                            reject(promise.value);
                        }
                    }
                } catch (e) {
                    reject(e);
                }
            }
        }
    });
};

p.then = function then(onResolved, onRejected) {
    var promise = this;

    return new Promise$1(function (resolve, reject) {
        promise.deferred.push([onResolved, onRejected, resolve, reject]);
        promise.notify();
    });
};

p.catch = function (onRejected) {
    return this.then(undefined, onRejected);
};

/**
 * Promise adapter.
 */

if (typeof Promise === 'undefined') {
    window.Promise = Promise$1;
}

function PromiseObj(executor, context) {

    if (executor instanceof Promise) {
        this.promise = executor;
    } else {
        this.promise = new Promise(executor.bind(context));
    }

    this.context = context;
}

PromiseObj.all = function (iterable, context) {
    return new PromiseObj(Promise.all(iterable), context);
};

PromiseObj.resolve = function (value, context) {
    return new PromiseObj(Promise.resolve(value), context);
};

PromiseObj.reject = function (reason, context) {
    return new PromiseObj(Promise.reject(reason), context);
};

PromiseObj.race = function (iterable, context) {
    return new PromiseObj(Promise.race(iterable), context);
};

var p$1 = PromiseObj.prototype;

p$1.bind = function (context) {
    this.context = context;
    return this;
};

p$1.then = function (fulfilled, rejected) {

    if (fulfilled && fulfilled.bind && this.context) {
        fulfilled = fulfilled.bind(this.context);
    }

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
};

p$1.catch = function (rejected) {

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.catch(rejected), this.context);
};

p$1.finally = function (callback) {

    return this.then(function (value) {
        callback.call(this);
        return value;
    }, function (reason) {
        callback.call(this);
        return Promise.reject(reason);
    }
    );
};

/**
 * Utility functions.
 */

var ref = {};
var hasOwnProperty = ref.hasOwnProperty;
var ref$1 = [];
var slice = ref$1.slice;
var debug = false, ntick;

var inBrowser = typeof window !== 'undefined';

function Util (ref) {
    var config = ref.config;
    var nextTick = ref.nextTick;

    ntick = nextTick;
    debug = config.debug || !config.silent;
}

function warn(msg) {
    if (typeof console !== 'undefined' && debug) {
        console.warn('[VueResource warn]: ' + msg);
    }
}

function error(msg) {
    if (typeof console !== 'undefined') {
        console.error(msg);
    }
}

function nextTick(cb, ctx) {
    return ntick(cb, ctx);
}

function trim(str) {
    return str ? str.replace(/^\s*|\s*$/g, '') : '';
}

function trimEnd(str, chars) {

    if (str && chars === undefined) {
        return str.replace(/\s+$/, '');
    }

    if (!str || !chars) {
        return str;
    }

    return str.replace(new RegExp(("[" + chars + "]+$")), '');
}

function toLower(str) {
    return str ? str.toLowerCase() : '';
}

function toUpper(str) {
    return str ? str.toUpperCase() : '';
}

var isArray = Array.isArray;

function isString(val) {
    return typeof val === 'string';
}

function isFunction(val) {
    return typeof val === 'function';
}

function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}

function isPlainObject(obj) {
    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
}

function isBlob(obj) {
    return typeof Blob !== 'undefined' && obj instanceof Blob;
}

function isFormData(obj) {
    return typeof FormData !== 'undefined' && obj instanceof FormData;
}

function when(value, fulfilled, rejected) {

    var promise = PromiseObj.resolve(value);

    if (arguments.length < 2) {
        return promise;
    }

    return promise.then(fulfilled, rejected);
}

function options(fn, obj, opts) {

    opts = opts || {};

    if (isFunction(opts)) {
        opts = opts.call(obj);
    }

    return merge(fn.bind({$vm: obj, $options: opts}), fn, {$options: opts});
}

function each(obj, iterator) {

    var i, key;

    if (isArray(obj)) {
        for (i = 0; i < obj.length; i++) {
            iterator.call(obj[i], obj[i], i);
        }
    } else if (isObject(obj)) {
        for (key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                iterator.call(obj[key], obj[key], key);
            }
        }
    }

    return obj;
}

var assign = Object.assign || _assign;

function merge(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source, true);
    });

    return target;
}

function defaults(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {

        for (var key in source) {
            if (target[key] === undefined) {
                target[key] = source[key];
            }
        }

    });

    return target;
}

function _assign(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source);
    });

    return target;
}

function _merge(target, source, deep) {
    for (var key in source) {
        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
                target[key] = {};
            }
            if (isArray(source[key]) && !isArray(target[key])) {
                target[key] = [];
            }
            _merge(target[key], source[key], deep);
        } else if (source[key] !== undefined) {
            target[key] = source[key];
        }
    }
}

/**
 * Root Prefix Transform.
 */

function root (options$$1, next) {

    var url = next(options$$1);

    if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
        url = trimEnd(options$$1.root, '/') + '/' + url;
    }

    return url;
}

/**
 * Query Parameter Transform.
 */

function query (options$$1, next) {

    var urlParams = Object.keys(Url.options.params), query = {}, url = next(options$$1);

    each(options$$1.params, function (value, key) {
        if (urlParams.indexOf(key) === -1) {
            query[key] = value;
        }
    });

    query = Url.params(query);

    if (query) {
        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
    }

    return url;
}

/**
 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
 */

function expand(url, params, variables) {

    var tmpl = parse(url), expanded = tmpl.expand(params);

    if (variables) {
        variables.push.apply(variables, tmpl.vars);
    }

    return expanded;
}

function parse(template) {

    var operators = ['+', '#', '.', '/', ';', '?', '&'], variables = [];

    return {
        vars: variables,
        expand: function expand(context) {
            return template.replace(/\{([^{}]+)\}|([^{}]+)/g, function (_, expression, literal) {
                if (expression) {

                    var operator = null, values = [];

                    if (operators.indexOf(expression.charAt(0)) !== -1) {
                        operator = expression.charAt(0);
                        expression = expression.substr(1);
                    }

                    expression.split(/,/g).forEach(function (variable) {
                        var tmp = /([^:*]*)(?::(\d+)|(\*))?/.exec(variable);
                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
                        variables.push(tmp[1]);
                    });

                    if (operator && operator !== '+') {

                        var separator = ',';

                        if (operator === '?') {
                            separator = '&';
                        } else if (operator !== '#') {
                            separator = operator;
                        }

                        return (values.length !== 0 ? operator : '') + values.join(separator);
                    } else {
                        return values.join(',');
                    }

                } else {
                    return encodeReserved(literal);
                }
            });
        }
    };
}

function getValues(context, operator, key, modifier) {

    var value = context[key], result = [];

    if (isDefined(value) && value !== '') {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            value = value.toString();

            if (modifier && modifier !== '*') {
                value = value.substring(0, parseInt(modifier, 10));
            }

            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
        } else {
            if (modifier === '*') {
                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            result.push(encodeValue(operator, value[k], k));
                        }
                    });
                }
            } else {
                var tmp = [];

                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        tmp.push(encodeValue(operator, value));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            tmp.push(encodeURIComponent(k));
                            tmp.push(encodeValue(operator, value[k].toString()));
                        }
                    });
                }

                if (isKeyOperator(operator)) {
                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
                } else if (tmp.length !== 0) {
                    result.push(tmp.join(','));
                }
            }
        }
    } else {
        if (operator === ';') {
            result.push(encodeURIComponent(key));
        } else if (value === '' && (operator === '&' || operator === '?')) {
            result.push(encodeURIComponent(key) + '=');
        } else if (value === '') {
            result.push('');
        }
    }

    return result;
}

function isDefined(value) {
    return value !== undefined && value !== null;
}

function isKeyOperator(operator) {
    return operator === ';' || operator === '&' || operator === '?';
}

function encodeValue(operator, value, key) {

    value = (operator === '+' || operator === '#') ? encodeReserved(value) : encodeURIComponent(value);

    if (key) {
        return encodeURIComponent(key) + '=' + value;
    } else {
        return value;
    }
}

function encodeReserved(str) {
    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
        if (!/%[0-9A-Fa-f]/.test(part)) {
            part = encodeURI(part);
        }
        return part;
    }).join('');
}

/**
 * URL Template (RFC 6570) Transform.
 */

function template (options) {

    var variables = [], url = expand(options.url, options.params, variables);

    variables.forEach(function (key) {
        delete options.params[key];
    });

    return url;
}

/**
 * Service for URL templating.
 */

function Url(url, params) {

    var self = this || {}, options$$1 = url, transform;

    if (isString(url)) {
        options$$1 = {url: url, params: params};
    }

    options$$1 = merge({}, Url.options, self.$options, options$$1);

    Url.transforms.forEach(function (handler) {

        if (isString(handler)) {
            handler = Url.transform[handler];
        }

        if (isFunction(handler)) {
            transform = factory(handler, transform, self.$vm);
        }

    });

    return transform(options$$1);
}

/**
 * Url options.
 */

Url.options = {
    url: '',
    root: null,
    params: {}
};

/**
 * Url transforms.
 */

Url.transform = {template: template, query: query, root: root};
Url.transforms = ['template', 'query', 'root'];

/**
 * Encodes a Url parameter string.
 *
 * @param {Object} obj
 */

Url.params = function (obj) {

    var params = [], escape = encodeURIComponent;

    params.add = function (key, value) {

        if (isFunction(value)) {
            value = value();
        }

        if (value === null) {
            value = '';
        }

        this.push(escape(key) + '=' + escape(value));
    };

    serialize(params, obj);

    return params.join('&').replace(/%20/g, '+');
};

/**
 * Parse a URL and return its components.
 *
 * @param {String} url
 */

Url.parse = function (url) {

    var el = document.createElement('a');

    if (document.documentMode) {
        el.href = url;
        url = el.href;
    }

    el.href = url;

    return {
        href: el.href,
        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
        port: el.port,
        host: el.host,
        hostname: el.hostname,
        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
        search: el.search ? el.search.replace(/^\?/, '') : '',
        hash: el.hash ? el.hash.replace(/^#/, '') : ''
    };
};

function factory(handler, next, vm) {
    return function (options$$1) {
        return handler.call(vm, options$$1, next);
    };
}

function serialize(params, obj, scope) {

    var array = isArray(obj), plain = isPlainObject(obj), hash;

    each(obj, function (value, key) {

        hash = isObject(value) || isArray(value);

        if (scope) {
            key = scope + '[' + (plain || hash ? key : '') + ']';
        }

        if (!scope && array) {
            params.add(value.name, value.value);
        } else if (hash) {
            serialize(params, value, key);
        } else {
            params.add(key, value);
        }
    });
}

/**
 * XDomain client (Internet Explorer).
 */

function xdrClient (request) {
    return new PromiseObj(function (resolve) {

        var xdr = new XDomainRequest(), handler = function (ref) {
                var type = ref.type;


                var status = 0;

                if (type === 'load') {
                    status = 200;
                } else if (type === 'error') {
                    status = 500;
                }

                resolve(request.respondWith(xdr.responseText, {status: status}));
            };

        request.abort = function () { return xdr.abort(); };

        xdr.open(request.method, request.getUrl());

        if (request.timeout) {
            xdr.timeout = request.timeout;
        }

        xdr.onload = handler;
        xdr.onabort = handler;
        xdr.onerror = handler;
        xdr.ontimeout = handler;
        xdr.onprogress = function () {};
        xdr.send(request.getBody());
    });
}

/**
 * CORS Interceptor.
 */

var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();

function cors (request) {

    if (inBrowser) {

        var orgUrl = Url.parse(location.href);
        var reqUrl = Url.parse(request.getUrl());

        if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {

            request.crossOrigin = true;
            request.emulateHTTP = false;

            if (!SUPPORTS_CORS) {
                request.client = xdrClient;
            }
        }
    }

}

/**
 * Form data Interceptor.
 */

function form (request) {

    if (isFormData(request.body)) {
        request.headers.delete('Content-Type');
    } else if (isObject(request.body) && request.emulateJSON) {
        request.body = Url.params(request.body);
        request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    }

}

/**
 * JSON Interceptor.
 */

function json (request) {

    var type = request.headers.get('Content-Type') || '';

    if (isObject(request.body) && type.indexOf('application/json') === 0) {
        request.body = JSON.stringify(request.body);
    }

    return function (response) {

        return response.bodyText ? when(response.text(), function (text) {

            var type = response.headers.get('Content-Type') || '';

            if (type.indexOf('application/json') === 0 || isJson(text)) {

                try {
                    response.body = JSON.parse(text);
                } catch (e) {
                    response.body = null;
                }

            } else {
                response.body = text;
            }

            return response;

        }) : response;

    };
}

function isJson(str) {

    var start = str.match(/^\s*(\[|\{)/);
    var end = {'[': /]\s*$/, '{': /}\s*$/};

    return start && end[start[1]].test(str);
}

/**
 * JSONP client (Browser).
 */

function jsonpClient (request) {
    return new PromiseObj(function (resolve) {

        var name = request.jsonp || 'callback', callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2), body = null, handler, script;

        handler = function (ref) {
            var type = ref.type;


            var status = 0;

            if (type === 'load' && body !== null) {
                status = 200;
            } else if (type === 'error') {
                status = 500;
            }

            if (status && window[callback]) {
                delete window[callback];
                document.body.removeChild(script);
            }

            resolve(request.respondWith(body, {status: status}));
        };

        window[callback] = function (result) {
            body = JSON.stringify(result);
        };

        request.abort = function () {
            handler({type: 'abort'});
        };

        request.params[name] = callback;

        if (request.timeout) {
            setTimeout(request.abort, request.timeout);
        }

        script = document.createElement('script');
        script.src = request.getUrl();
        script.type = 'text/javascript';
        script.async = true;
        script.onload = handler;
        script.onerror = handler;

        document.body.appendChild(script);
    });
}

/**
 * JSONP Interceptor.
 */

function jsonp (request) {

    if (request.method == 'JSONP') {
        request.client = jsonpClient;
    }

}

/**
 * Before Interceptor.
 */

function before (request) {

    if (isFunction(request.before)) {
        request.before.call(this, request);
    }

}

/**
 * HTTP method override Interceptor.
 */

function method (request) {

    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
        request.headers.set('X-HTTP-Method-Override', request.method);
        request.method = 'POST';
    }

}

/**
 * Header Interceptor.
 */

function header (request) {

    var headers = assign({}, Http.headers.common,
        !request.crossOrigin ? Http.headers.custom : {},
        Http.headers[toLower(request.method)]
    );

    each(headers, function (value, name) {
        if (!request.headers.has(name)) {
            request.headers.set(name, value);
        }
    });

}

/**
 * XMLHttp client (Browser).
 */

function xhrClient (request) {
    return new PromiseObj(function (resolve) {

        var xhr = new XMLHttpRequest(), handler = function (event) {

                var response = request.respondWith(
                'response' in xhr ? xhr.response : xhr.responseText, {
                    status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
                    statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
                });

                each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
                    response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
                });

                resolve(response);
            };

        request.abort = function () { return xhr.abort(); };

        xhr.open(request.method, request.getUrl(), true);

        if (request.timeout) {
            xhr.timeout = request.timeout;
        }

        if (request.responseType && 'responseType' in xhr) {
            xhr.responseType = request.responseType;
        }

        if (request.withCredentials || request.credentials) {
            xhr.withCredentials = true;
        }

        if (!request.crossOrigin) {
            request.headers.set('X-Requested-With', 'XMLHttpRequest');
        }

        // deprecated use downloadProgress
        if (isFunction(request.progress) && request.method === 'GET') {
            xhr.addEventListener('progress', request.progress);
        }

        if (isFunction(request.downloadProgress)) {
            xhr.addEventListener('progress', request.downloadProgress);
        }

        // deprecated use uploadProgress
        if (isFunction(request.progress) && /^(POST|PUT)$/i.test(request.method)) {
            xhr.upload.addEventListener('progress', request.progress);
        }

        if (isFunction(request.uploadProgress) && xhr.upload) {
            xhr.upload.addEventListener('progress', request.uploadProgress);
        }

        request.headers.forEach(function (value, name) {
            xhr.setRequestHeader(name, value);
        });

        xhr.onload = handler;
        xhr.onabort = handler;
        xhr.onerror = handler;
        xhr.ontimeout = handler;
        xhr.send(request.getBody());
    });
}

/**
 * Http client (Node).
 */

function nodeClient (request) {

    var client = __webpack_require__(72);

    return new PromiseObj(function (resolve) {

        var url = request.getUrl();
        var body = request.getBody();
        var method = request.method;
        var headers = {}, handler;

        request.headers.forEach(function (value, name) {
            headers[name] = value;
        });

        client(url, {body: body, method: method, headers: headers}).then(handler = function (resp) {

            var response = request.respondWith(resp.body, {
                status: resp.statusCode,
                statusText: trim(resp.statusMessage)
            });

            each(resp.headers, function (value, name) {
                response.headers.set(name, value);
            });

            resolve(response);

        }, function (error$$1) { return handler(error$$1.response); });
    });
}

/**
 * Base client.
 */

function Client (context) {

    var reqHandlers = [sendRequest], resHandlers = [];

    if (!isObject(context)) {
        context = null;
    }

    function Client(request) {
        while (reqHandlers.length) {

            var handler = reqHandlers.pop();

            if (isFunction(handler)) {

                var response = (void 0), next = (void 0);

                response = handler.call(context, request, function (val) { return next = val; }) || next;

                if (isObject(response)) {
                    return new PromiseObj(function (resolve, reject) {

                        resHandlers.forEach(function (handler) {
                            response = when(response, function (response) {
                                return handler.call(context, response) || response;
                            }, reject);
                        });

                        when(response, resolve, reject);

                    }, context);
                }

                if (isFunction(response)) {
                    resHandlers.unshift(response);
                }

            } else {
                warn(("Invalid interceptor of type " + (typeof handler) + ", must be a function"));
            }
        }
    }

    Client.use = function (handler) {
        reqHandlers.push(handler);
    };

    return Client;
}

function sendRequest(request) {

    var client = request.client || (inBrowser ? xhrClient : nodeClient);

    return client(request);
}

/**
 * HTTP Headers.
 */

var Headers = function Headers(headers) {
    var this$1 = this;


    this.map = {};

    each(headers, function (value, name) { return this$1.append(name, value); });
};

Headers.prototype.has = function has (name) {
    return getName(this.map, name) !== null;
};

Headers.prototype.get = function get (name) {

    var list = this.map[getName(this.map, name)];

    return list ? list.join() : null;
};

Headers.prototype.getAll = function getAll (name) {
    return this.map[getName(this.map, name)] || [];
};

Headers.prototype.set = function set (name, value) {
    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
};

Headers.prototype.append = function append (name, value) {

    var list = this.map[getName(this.map, name)];

    if (list) {
        list.push(trim(value));
    } else {
        this.set(name, value);
    }
};

Headers.prototype.delete = function delete$1 (name) {
    delete this.map[getName(this.map, name)];
};

Headers.prototype.deleteAll = function deleteAll () {
    this.map = {};
};

Headers.prototype.forEach = function forEach (callback, thisArg) {
        var this$1 = this;

    each(this.map, function (list, name) {
        each(list, function (value) { return callback.call(thisArg, value, name, this$1); });
    });
};

function getName(map, name) {
    return Object.keys(map).reduce(function (prev, curr) {
        return toLower(name) === toLower(curr) ? curr : prev;
    }, null);
}

function normalizeName(name) {

    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
        throw new TypeError('Invalid character in header field name');
    }

    return trim(name);
}

/**
 * HTTP Response.
 */

var Response = function Response(body, ref) {
    var url = ref.url;
    var headers = ref.headers;
    var status = ref.status;
    var statusText = ref.statusText;


    this.url = url;
    this.ok = status >= 200 && status < 300;
    this.status = status || 0;
    this.statusText = statusText || '';
    this.headers = new Headers(headers);
    this.body = body;

    if (isString(body)) {

        this.bodyText = body;

    } else if (isBlob(body)) {

        this.bodyBlob = body;

        if (isBlobText(body)) {
            this.bodyText = blobText(body);
        }
    }
};

Response.prototype.blob = function blob () {
    return when(this.bodyBlob);
};

Response.prototype.text = function text () {
    return when(this.bodyText);
};

Response.prototype.json = function json () {
    return when(this.text(), function (text) { return JSON.parse(text); });
};

Object.defineProperty(Response.prototype, 'data', {

    get: function get() {
        return this.body;
    },

    set: function set(body) {
        this.body = body;
    }

});

function blobText(body) {
    return new PromiseObj(function (resolve) {

        var reader = new FileReader();

        reader.readAsText(body);
        reader.onload = function () {
            resolve(reader.result);
        };

    });
}

function isBlobText(body) {
    return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
}

/**
 * HTTP Request.
 */

var Request = function Request(options$$1) {

    this.body = null;
    this.params = {};

    assign(this, options$$1, {
        method: toUpper(options$$1.method || 'GET')
    });

    if (!(this.headers instanceof Headers)) {
        this.headers = new Headers(this.headers);
    }
};

Request.prototype.getUrl = function getUrl () {
    return Url(this);
};

Request.prototype.getBody = function getBody () {
    return this.body;
};

Request.prototype.respondWith = function respondWith (body, options$$1) {
    return new Response(body, assign(options$$1 || {}, {url: this.getUrl()}));
};

/**
 * Service for sending network requests.
 */

var COMMON_HEADERS = {'Accept': 'application/json, text/plain, */*'};
var JSON_CONTENT_TYPE = {'Content-Type': 'application/json;charset=utf-8'};

function Http(options$$1) {

    var self = this || {}, client = Client(self.$vm);

    defaults(options$$1 || {}, self.$options, Http.options);

    Http.interceptors.forEach(function (handler) {

        if (isString(handler)) {
            handler = Http.interceptor[handler];
        }

        if (isFunction(handler)) {
            client.use(handler);
        }

    });

    return client(new Request(options$$1)).then(function (response) {

        return response.ok ? response : PromiseObj.reject(response);

    }, function (response) {

        if (response instanceof Error) {
            error(response);
        }

        return PromiseObj.reject(response);
    });
}

Http.options = {};

Http.headers = {
    put: JSON_CONTENT_TYPE,
    post: JSON_CONTENT_TYPE,
    patch: JSON_CONTENT_TYPE,
    delete: JSON_CONTENT_TYPE,
    common: COMMON_HEADERS,
    custom: {}
};

Http.interceptor = {before: before, method: method, jsonp: jsonp, json: json, form: form, header: header, cors: cors};
Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];

['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {

    Http[method$$1] = function (url, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1}));
    };

});

['post', 'put', 'patch'].forEach(function (method$$1) {

    Http[method$$1] = function (url, body, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1, body: body}));
    };

});

/**
 * Service for interacting with RESTful services.
 */

function Resource(url, params, actions, options$$1) {

    var self = this || {}, resource = {};

    actions = assign({},
        Resource.actions,
        actions
    );

    each(actions, function (action, name) {

        action = merge({url: url, params: assign({}, params)}, options$$1, action);

        resource[name] = function () {
            return (self.$http || Http)(opts(action, arguments));
        };
    });

    return resource;
}

function opts(action, args) {

    var options$$1 = assign({}, action), params = {}, body;

    switch (args.length) {

        case 2:

            params = args[0];
            body = args[1];

            break;

        case 1:

            if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
                body = args[0];
            } else {
                params = args[0];
            }

            break;

        case 0:

            break;

        default:

            throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
    }

    options$$1.body = body;
    options$$1.params = assign({}, options$$1.params, params);

    return options$$1;
}

Resource.actions = {

    get: {method: 'GET'},
    save: {method: 'POST'},
    query: {method: 'GET'},
    update: {method: 'PUT'},
    remove: {method: 'DELETE'},
    delete: {method: 'DELETE'}

};

/**
 * Install plugin.
 */

function plugin(Vue) {

    if (plugin.installed) {
        return;
    }

    Util(Vue);

    Vue.url = Url;
    Vue.http = Http;
    Vue.resource = Resource;
    Vue.Promise = PromiseObj;

    Object.defineProperties(Vue.prototype, {

        $url: {
            get: function get() {
                return options(Vue.url, this, this.$options.url);
            }
        },

        $http: {
            get: function get() {
                return options(Vue.http, this, this.$options.http);
            }
        },

        $resource: {
            get: function get() {
                return Vue.resource.bind(this);
            }
        },

        $promise: {
            get: function get() {
                var this$1 = this;

                return function (executor) { return new Vue.Promise(executor, this$1); };
            }
        }

    });
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);



/***/ }),
/* 72 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){if(true)module.exports=n();else if("function"==typeof define&&define.amd)define([],n);else{var t=n();for(var r in t)("object"==typeof exports?exports:e)[r]=t[r]}}("undefined"!=typeof self?self:this,(function(){return function(e){var n={};function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{enumerable:!0,get:r})},t.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},t.t=function(e,n){if(1&n&&(e=t(e)),8&n)return e;if(4&n&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(t.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&n&&"string"!=typeof e)for(var o in e)t.d(r,o,function(n){return e[n]}.bind(null,o));return r},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,n){return Object.prototype.hasOwnProperty.call(e,n)},t.p="",t(t.s=0)}([function(e,n,t){"use strict";function r(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function o(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?r(t,!0).forEach((function(n){i(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):r(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}function i(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}t.r(n);var c={$vue:null,id:null,router:null,fields:{},customIdFields:{},ignoreRoutes:[],linkers:[],commands:{},disabled:!1,customResourceURL:null,set:[],require:[],ecommerce:{enabled:!1,options:null,enhanced:!1},autoTracking:{screenview:!1,shouldRouterUpdate:null,skipSamePath:!1,exception:!1,exceptionLogs:!0,page:!0,transformQueryString:!0,pageviewOnLoad:!0,pageviewTemplate:null,untracked:!0,prependBase:!0},debug:{enabled:!1,trace:!1,sendHitTask:!0},batch:{enabled:!1,delay:500,amount:2},checkDuplicatedScript:!1,disableScriptLoader:!1,beforeFirstHit:s,ready:s,untracked:[]},a=o({},c);function u(e){!function e(n,t){return Object.keys(t).forEach((function(r){var o=n[r]&&Object.prototype.toString.call(n[r]);"[object Object]"!==o&&"[object Array]"!==o?n[r]=t[r]:e(n[r],t[r])})),n}(a,e)}function f(){return a.id?[].concat(a.id):[]}var l=a;function s(){}var p=function(e){console.warn("[vue-analytics] ".concat(e))};function d(e,n){return new Promise((function(t,r){var o=document.head||document.getElementsByTagName("head")[0],i=document.createElement("script");if(i.async=!0,i.src=e,i.charset="utf-8",n){var c=document.createElement("link");c.href=n,c.rel="preconnect",o.appendChild(c)}o.appendChild(i),i.onload=t,i.onerror=r}))}function y(e){return e.name||e.replace(/-/gi,"")}function b(e,n){if(f().length>1){var t=y(n);return"".concat(t,".").concat(e)}return e}var m,v=function(e){if(e.then)return e;if("function"==typeof e){var n=e();return n.then?n:Promise.resolve(n)}return Promise.resolve(e)};function g(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var h=[];function w(e){for(var n=arguments.length,t=new Array(n>1?n-1:0),r=1;r<n;r++)t[r-1]=arguments[r];"undefined"!=typeof window&&f().forEach((function(n){var r,o={m:b(e,n),a:t};window.ga?l.batch.enabled?(h.push(o),m||(m=setInterval((function(){h.length?h.splice(0,l.batch.amount).forEach((function(e){var n;(n=window).ga.apply(n,[e.m].concat(g(e.a)))})):(clearInterval(m),m=null)}),l.batch.delay))):(r=window).ga.apply(r,[b(e,n)].concat(t)):l.untracked.push(o)}))}function O(e){return(O="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function j(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];"object"!==O(n[0])||n[0].constructor!==Object?w("set",n[0],n[1]):w("set",n[0])}function P(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function S(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function k(){if(window.ga||!l.debug.enabled){if(window.ga){var e=f();l.debug.enabled&&(window.ga_debug={trace:l.debug.trace}),e.forEach((function(n){var t=y(n),r=l.customIdFields[n]||{},o=e.length>1?function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?P(t,!0).forEach((function(n){S(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):P(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},l.fields,{},r,{name:t}):l.fields;window.ga("create",n.id||n,"auto",o)})),l.beforeFirstHit();var n=l.ecommerce;if(n.enabled){var t=n.enhanced?"ec":"ecommerce";n.options?w("require",t,n.options):w("require",t)}l.linkers.length>0&&(w("require","linker"),w("linker:autoLink",l.linkers)),l.debug.sendHitTask||j("sendHitTask",null)}}else p("Google Analytics has probably been blocked.")}var E=function(){2!=arguments.length?w("require",arguments.length<=0?void 0:arguments[0]):w("require",arguments.length<=0?void 0:arguments[0],arguments.length<=1?void 0:arguments[1])};function A(e){return(A="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var x=function(){var e;l.set.forEach((function(e){var n=e.field,t=e.value;if(void 0===n||void 0===t)throw new Error('[vue-analytics] Wrong configuration in the plugin options.\nThe "set" array requires each item to have a "field" and a "value" property.');j(n,t)})),e=["ec","ecommerce"],l.require.forEach((function(n){if(-1!==e.indexOf(n)||-1!==e.indexOf(n.name))throw new Error("[vue-analytics] The ecommerce features are built-in in the plugin. \nFollow the ecommerce instructions available in the documentation.");if("string"!=typeof n&&"object"!==A(n))throw new Error('[vue-analytics] Wrong configuration in the plugin options. \nThe "require" array requires each item to be a string or to have a "name" and an "options" property.');var t=n.name||n;n.options?E(t,n.options):E(t)}))};function T(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r=n[0];if(1===n.length&&"string"==typeof r)return w("send","screenview",{screenName:r});w.apply(void 0,["send","screenview"].concat(n))}function D(e){return(D="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function q(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r;n.length&&!n[0]||(n.length&&n[0].currentRoute&&(r=n[0].currentRoute),n.length&&function(e){return e.query&&e.params}(n[0])&&(r=n[0]),r?R(r):(j("page","object"===D(n[0])?n[0].page:n[0]),w.apply(void 0,["send","pageview"].concat(n))))}function R(e){if(![(n=e).name,n.path].filter(Boolean).find((function(e){return-1!==l.ignoreRoutes.indexOf(e)}))){var n,t=l.autoTracking,r=e.meta.analytics,o=(void 0===r?{}:r).pageviewTemplate||t.pageviewTemplate;if(t.screenview&&!e.name)throw new Error("[vue-analytics] Route name is mandatory when using screenview.");if(t.screenview)T(e.name);else if(o)q(o(e));else{var i=l.router,c=l.autoTracking,a=c.transformQueryString,u=c.prependBase,f=function(e){var n=Object.keys(e).reduce((function(n,t,r,o){var i=r===o.length-1,c=e[t];return null==c?n:n+="".concat(t,"=").concat(c).concat(i?"":"&")}),"");return""!==n?"?".concat(n):""}(e.query),s=i&&i.options.base,p=u&&s,d=e.path+(a?f:"");q(d=p?function(e,n){var t=n.split("/"),r=e.split("/");return""===t[0]&&"/"===e[e.length-1]&&t.shift(),r.join("/")+t.join("/")}(s,d):d)}}}function I(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var L=function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];"undefined"!=typeof window&&f().forEach((function(n){window["ga-disable-".concat(n)]=e}))},_=function(){if("undefined"!=typeof document&&"undefined"!=typeof window){if(l.id){var e,n,t=[v(l.id),v(l.disabled)];if(e=l.checkDuplicatedScript,n=l.disableScriptLoader,[Boolean(window&&window.ga),e&&!(Array.prototype.slice.call(document.getElementsByTagName("script")).filter((function(e){return-1!==e.src.indexOf("analytics")||-1!==e.src.indexOf("gtag")})).length>0),!n].some(Boolean)){var r="https://www.google-analytics.com",o=l.debug.enabled?"analytics_debug":"analytics",i=l.customResourceURL?d(l.customResourceURL):d("".concat(r,"/").concat(o,".js"),r);t.push(i.catch((function(){p("An error occured! Please check your connection or disable your AD blocker")})))}return Promise.all(t).then((function(e){var n,t,r;u({id:e[0],disabled:e[1]}),L(l.disabled),k(),x(),l.untracked.forEach((function(e){w.apply(void 0,[e.m].concat(I(e.a)))})),n=l.router,t=l.autoTracking,r=l.$vue,t.page&&n&&n.onReady((function(){t.pageviewOnLoad&&n.history.ready&&R(n.currentRoute),n.afterEach((function(e,o){var i=t.skipSamePath,c=t.shouldRouterUpdate;i&&e.path===o.path||("function"!=typeof c||c(e,o))&&r.nextTick().then((function(){R(n.currentRoute)}))}))})),l.ready()})).catch((function(e){l.debug.enabled&&p(e.message)}))}p('Missing the "id" parameter. Add at least one tracking domain ID')}};var B=function(e){var n=arguments.length>1&&void 0!==arguments[1]&&arguments[1];w("send","exception",{exDescription:e,exFatal:n})},H=function(e){if(l.autoTracking.exception){window.addEventListener("error",(function(e){B(e.message)}));var n=e.config.errorHandler;e.config.errorHandler=function(e,t,r){B(e.message),l.autoTracking.exceptionLogs&&console.error(e),"function"==typeof n&&n.call(void 0,e,t,r)}}},F=B;function M(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function U(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}var $=function(e){return"".concat(l.ecommerce.enhanced?"ec":"ecommerce",":").concat(e)},C=["addItem","addTransaction","addProduct","addImpression","setAction","addPromo","send"].reduce((function(e,n){return function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?M(t,!0).forEach((function(n){U(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):M(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},e,U({},n,(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];w.apply(void 0,[$(n)].concat(t))})))}),{}),N={event:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","event"].concat(n))},exception:F,page:q,query:w,require:E,set:j,social:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","social"].concat(n))},time:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","timing"].concat(n))},screenview:T,ecommerce:C,disable:function(){return L(!0)},enable:function(){return L(!1)},commands:l.commands},Q={inserted:function(e,n,t){var r=Object.keys(n.modifiers);0===r.length&&r.push("click"),r.forEach((function(r){e.addEventListener(r,(function(){var e="string"==typeof n.value?l.commands[n.value]:n.value;if(!e)throw new Error("[vue-analytics] The value passed to v-ga is not defined in the commands list.");e.apply(t.context)}))}))}};function W(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function G(e,n){return function(e){if(Array.isArray(e))return e}(e)||function(e,n){if(!(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e)))return;var t=[],r=!0,o=!1,i=void 0;try{for(var c,a=e[Symbol.iterator]();!(r=(c=a.next()).done)&&(t.push(c.value),!n||t.length!==n);r=!0);}catch(e){o=!0,i=e}finally{try{r||null==a.return||a.return()}finally{if(o)throw i}}return t}(e,n)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function z(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function J(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function K(e){u(function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?z(t,!0).forEach((function(n){J(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):z(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},{$vue:e})),e.directive("ga",Q),e.prototype.$ga=e.$ga=N,H(e),_()}t.d(n,"default",(function(){return K})),t.d(n,"analyticsMiddleware",(function(){return V})),t.d(n,"onAnalyticsReady",(function(){return X})),t.d(n,"event",(function(){return Y})),t.d(n,"ecommerce",(function(){return Z})),t.d(n,"set",(function(){return ee})),t.d(n,"page",(function(){return ne})),t.d(n,"query",(function(){return te})),t.d(n,"screenview",(function(){return re})),t.d(n,"time",(function(){return oe})),t.d(n,"require",(function(){return ie})),t.d(n,"exception",(function(){return ce})),t.d(n,"social",(function(){return ae}));var V=function(e){e.subscribe((function(e){var n=e.payload;if(n&&n.meta&&n.meta.analytics){var t=n.meta.analytics;if(!Array.isArray(t))throw new Error('The "analytics" property needs to be an array');t.forEach((function(e){var n,t,r=e.shift(),o=e;if(r.includes(":")){var i=G(r.split(":"),2);r=i[0],n=i[1]}if(!(r in N))throw new Error('[vue-analytics:vuex] The type "'.concat(r,"\" doesn't exist."));if(n&&!(n in N[r]))throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" has not method "').concat(n,'".'));if("ecommerce"===r&&!n)throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" needs to call a method. Check documentation.'));n?(t=N[r])[n].apply(t,W(o)):N[r].apply(N,W(o))}))}}))},X=function(){return new Promise((function(e,n){var t=setInterval((function(){"undefined"!=typeof window&&window.ga&&(e(),clearInterval(t))}),10)}))},Y=N.event,Z=N.ecommerce,ee=N.set,ne=N.page,te=N.query,re=N.screenview,oe=N.time,ie=N.require,ce=N.exception,ae=N.social}])}));

/***/ })
],[16]);


// WEBPACK FOOTER //
// js/app.35c027edc04272cd5cad.js